// Auto-generado por @xone-web/staticweb.
// Concatenación de los JS includes del proyecto (orden importa).
// @ts-nocheck — el contenido es JS XOne sin anotaciones de tipo.

// ===== Sandbox web XOne: APIs DOM/timers vetadas → no-ops =====
const __xoneDomNoop = new Proxy(function () {}, {
    get: (_t, p) => (typeof p === "symbol" ? undefined : __xoneDomNoop),
    apply: () => __xoneDomNoop,
    construct: () => __xoneDomNoop,
    set: () => true,
});
const document = new Proxy({}, {
    get: (_t, p) => {
        if (p === "querySelectorAll" || p === "getElementsByClassName" || p === "getElementsByTagName" || p === "getElementsByName") return () => [];
        if (p === "querySelector" || p === "getElementById" || p === "closest") return () => null;
        return __xoneDomNoop;
    },
});
const setInterval = () => 0;
const clearInterval = () => {};

let self = undefined;
export function __xoneSetSelf(v) { self = v; }
export function __xoneGetSelf() { return self; }

// ===== actividades_functions.js =====
// ===== comun_functions.js =====
// ===== deudas_functions.js =====
// ===== documentos_functions.js =====
// ===== functions.js =====
// ===== mensajes_functions.js =====
// ===== movimientos_functions.js =====
// ===== online_functions.js =====
// ===== ringover_functions.js =====
// ===== vbscriptsupport.js =====
// Funciones de las actividades del cliente


async function filtrarActividadCliente(objself) {
    await actualizarDatosPaginadoLeads(objself,"ActividadesCliente","ActividadesClienteContador","MAP_PAG_INI_ACT","MAP_PAG_LEN_ACT","MAP_TOTAL_REGISTROS_ACT","MAP_T1_ACT");
    limpiarCampos(objself,"filtrarActividadCliente");
    objself.MAP_FILTRAR_ACTIVIDAD = 0;
}

async function crearActividadClienteGuardar(objself){
    var collDoc = appData.getCollection("DocumentoScript");
    
    
    if(objself.MAP_PROCESANDO == 1) {
        return;
    }
    objself.MAP_PROCESANDO = 1;
    
    // Realizamos las comprobaciones en función del tipo de actividad
    if(safeToInt(objself.MAP_ACTIVIDADES_COMBO) === 0){
        await ui.msgBox("Debe indicar un tipo de actividad.","Falta tipo",0);
        objself.MAP_PROCESANDO = 0;
        return;
    }
    // llamada bienvenida, devolución de saldo, solicitud de baja, solicitud de baja pre14, conversación con el cliente, reserva de cita enviada
    if(objself.MAP_ACTIVIDADES_COMBO==1 || objself.MAP_ACTIVIDADES_COMBO==6 || objself.MAP_ACTIVIDADES_COMBO==7 || objself.MAP_ACTIVIDADES_COMBO==8 || objself.MAP_ACTIVIDADES_COMBO==10 || objself.MAP_ACTIVIDADES_COMBO==13){
        if(isNullOrEmpty(objself.MAP_OBSERVACION_ACTIVIDAD)){
            await ui.msgBox("Debe indicar una observación para la actividad.","Falta observación",0);
            objself.MAP_PROCESANDO = 0;
            return;
        }
    }
    
    // Addendum
    if(objself.MAP_ACTIVIDADES_COMBO == 2){
        let deudasSinComprobante = [];
        
        // Comprobamos que todas las deudas tengan comprobante subido
        let cntDeuda = await objself.getContents("DeudaClientePrograma");
        for(var i = 0; i < cntDeuda.count(); i++){
            let itemDeuda = cntDeuda.getItem(i);
            if(safeToInt(itemDeuda.BAJA) !== 1){
                if(itemDeuda.MAP_DOCUMENTO_COMPROBANTE == ''){
                    deudasSinComprobante.push(itemDeuda.MAP_IDENTIFICADOR);
                }
            }
        }
        if(deudasSinComprobante.length > 0) {
            await ui.msgBox("No se puede crear la actividad porque existen deudas sin comprobante asociado: [" + deudasSinComprobante.join(", ") + "]. Súbalos desde la deuda.", "Falta comprobante", 0);
            objself.MAP_PROCESANDO = 0;
            return;
        }
    }
    
    // Resolución de contrato por incumplimiento
    if(objself.MAP_ACTIVIDADES_COMBO==4){
        if(isNullOrEmpty(objself.MAP_DESCRIPCION_PLANTILLA)){
            await ui.msgBox("Debe introducir el texto con el motivo para incluirlo en el documento.","Falta motivo",0);
            objself.MAP_PROCESANDO = 0;
            return;
        }
    }
    // Addendum y conversación con el cliente
    if(objself.MAP_ACTIVIDADES_COMBO==2 || objself.MAP_ACTIVIDADES_COMBO==10){
        if(safeToInt(objself.MAP_ACTIVIDADES_SUBTIPO_COMBO) === 0){
            await ui.msgBox("Debe indicar el subtipo para la actividad.","Falta subtipo",0);
            objself.MAP_PROCESANDO = 0;
            return;
        }
    }
    // Devolución de saldo
    if(objself.MAP_ACTIVIDADES_COMBO==6){
        if(safeToFloat(objself.MAP_IMPORTE_ACTIVIDAD) === 0){
            await ui.msgBox("Debe indicar el importe.","Falta importe",0);
            objself.MAP_PROCESANDO = 0;
            return;
        }
    }
    // Devolución de saldo, solicitud baja pre14
    if(objself.MAP_ACTIVIDADES_COMBO==6 || objself.MAP_ACTIVIDADES_COMBO==8){
        if(isNullOrEmpty(objself.MAP_IBAN_ACTIVIDAD)){
            await ui.msgBox("Debe indicar el IBAN.","Falta IBAN",0);
            objself.MAP_PROCESANDO = 0;
            return;
        }
    }
    // comisión mensual
    if(objself.MAP_ACTIVIDADES_COMBO==11){
        if(objself.MAP_MESES_PROGRAMA>25){
            await ui.msgBox("El cliente lleva más de 25 meses en el programa. No se le aplicará ninguna comisión mensual más pasado este tiempo","Comisión mensual",0);
            objself.MAP_PROCESANDO = 0;
            return;
        }
        // comprobamos si tiene alguna comisión mensual pendiente de cobrar en el mes actual
        let collMov = appData.getCollection("MovimientosScript");
        await filtrarCollMacroObject(collMov,"m.IDLEAD="+objself.ID+" AND m.IDTIPO_MOVIMIENTO=2 AND m.IDESTADO in(5,7) AND m.FECHA_SOLICITUD >= DATE_FORMAT(CURDATE(), '%Y-%m-01') AND m.FECHA_SOLICITUD < DATE_ADD(LAST_DAY(CURDATE()), INTERVAL 1 DAY)");
        
        if(collMov.count() > 0){
            await ui.msgBox("El cliente ya tiene una comisión mensual pendiente de cobrar/cobrada este mes. Revise el apartado de movimientos.","Comisión mensual",0);
            objself.MAP_PROCESANDO = 0;
            return;
        }
    }
    // Pausa manual cliente
    if(objself.MAP_ACTIVIDADES_COMBO == 14){
        if(safeToFloat(objself.IDESTADO_CLIENTE) === 7){
            await ui.msgBox("El cliente ya se encuentra en estado de pausa.","Pausa cliente",0);
            objself.MAP_PROCESANDO = 0;
            return;
        }
    }
    // Pausa manual cliente
    if(objself.MAP_ACTIVIDADES_COMBO == 15){
        if(safeToFloat(objself.IDESTADO_CLIENTE) != 7){
            await ui.msgBox("El cliente no se encuentra en estado de pausa.","Reanudar cliente",0);
            objself.MAP_PROCESANDO = 0;
            return;
        }
    }
    
    // Devolución de intereses
    if(objself.MAP_ACTIVIDADES_COMBO == 19){
        let error = 0;
        let cadenaError = "Debe indicar los siguientes valores: ";
        if(safeToFloat(objself.MAP_CUENTA_DEVOLUCION_COMBO) === 0){
            error +=1;
            cadenaError = cadenaError + "A qué cuenta realizar la devolución. ";
        }
        if(safeToFloat(objself.MAP_TIPO_DEVOLUCION_COMBO) === 0){
            error +=1;
            cadenaError = cadenaError + "Tipo de devolución. ";
        }
        if(safeToFloat(objself.MAP_IMPORTE_RECIBIR) === 0){
            error +=1;
            cadenaError = cadenaError + "Introducir la cantidad a recibir. ";
        }
        if(safeToFloat(objself.MAP_DIAS_RECIBIR) === 0){
            error +=1;
            cadenaError = cadenaError + "Introducir los dias para recibir el dinero. ";
        }
        if (error > 0) {
            await ui.msgBox(cadenaError,"Faltan datos",0);
            objself.MAP_PROCESANDO = 0;
            return;
        }
    }
    
    // Compensación acuerdo acreedores
    if(objself.MAP_ACTIVIDADES_COMBO == 24){
        let error = 0;
        let cadenaError = "Debe indicar los siguientes valores: ";
        if(safeToFloat(objself.MAP_IMPORTE_RECIBIR24) === 0){
            error +=1;
            cadenaError = cadenaError + "Introducir la cantidad a recibir. ";
        }
        if(safeToFloat(objself.MAP_DIAS_RECIBIR24) === 0){
            error +=1;
            cadenaError = cadenaError + "Introducir los dias para recibir el dinero. ";
        }
        if (error > 0) {
            await ui.msgBox(cadenaError,"Faltan datos",0);
            objself.MAP_PROCESANDO = 0;
            return;
        }
    }
   
    
    // cartas de representación, abstención de llamadas y oferta negociación extrajudicial
    if(objself.MAP_ACTIVIDADES_COMBO == 3 || objself.MAP_ACTIVIDADES_COMBO == 16 || objself.MAP_ACTIVIDADES_COMBO == 21){
        // comprobamos si se ha seleccionado alguna entidad
        let cntEntidad= await objself.getContents("EntidadesDeudaClienteActividades");
        let total=0;
        for(var i=0; i<cntEntidad.count();i++){
            let item = cntEntidad.getItem(i);
            if(item.MAP_SELECCIONAR==1){
                total=total+1;
                 
                if(objself.MAP_ACTIVIDADES_COMBO == 21) {
                    if(safeToInt(item.MAP_PLAZO_FRACC) === 0 || safeToInt(item.MAP_PLAZO_REFI) === 0) {
                        await ui.msgBox("Debe indicar los plazos en las entidades seleccionadas.","Faltan Plazos",0);
                        objself.MAP_PROCESANDO = 0;
                        return;
                    }
                }
            }
        }
        if(total === 0){
            await ui.msgBox("Debe seleccionar la(s) entidad(es) para la(s) cual(es) desea generar el documento.","Falta entidad",0);
            objself.MAP_PROCESANDO = 0;
            return;
        }
    }
    
    // devolución de intereses, generar acción judicial, monitorio recibido, Compensación acuerdo acreedores
    if(objself.MAP_ACTIVIDADES_COMBO == 19 || objself.MAP_ACTIVIDADES_COMBO == 20 || objself.MAP_ACTIVIDADES_COMBO == 22 || objself.MAP_ACTIVIDADES_COMBO == 24){
        
        // comprobamos si se ha seleccionado alguna entidad
        let cntEntidad= await objself.getContents("EntidadesDeudaClienteJudicialActividades");
        let total = 0;
        let entidades = [];
        
        for(var i=0; i<cntEntidad.count(); i++){
            let item = cntEntidad.getItem(i);
            
            if(item.MAP_SELECCIONAR == 1){
                total = total + 1;
                 
                // en acciones judiciales(20) tenemos en cuenta solo la entidad de la deuda, aunque seleccione varias deudas. Debe ser misma entidad para la acción judicial
                if(objself.MAP_ACTIVIDADES_COMBO == 20){
                    
                    if(!entidades.includes(item.MAP_IDENTIDAD)) {
                        entidades.push(item.MAP_IDENTIDAD);
                    }
                    
                    let collDeudaClienteDemanda = appData.getCollection("DeudaClienteDemandaScript");
                    // comprobamos si se ha generado previamente un identificador para ese tipo de acción
                    if(objself.MAP_IDACCION_COMBO == 1){
                        await filtrarCollMacroObject(collDeudaClienteDemanda,"cd.IDDEUDACLIENTE="+item.ID+" AND cd.IDENTIFICADOR like 'OPO%' ");
                    } else if(objself.MAP_IDACCION_COMBO == 2) {
                        await filtrarCollMacroObject(collDeudaClienteDemanda,"cd.IDDEUDACLIENTE="+item.ID+" AND cd.IDENTIFICADOR like 'DEM%'");
                    } else if(objself.MAP_IDACCION_COMBO == 3) {
                        await filtrarCollMacroObject(collDeudaClienteDemanda,"cd.IDDEUDACLIENTE="+item.ID+" AND cd.IDENTIFICADOR like 'DIL%'");
                    }
                    
                    // si ya existe un identificador para el mismo tipo de acción y deuda, preguntamos si desea generar otra acción igualmente
                    if(collDeudaClienteDemanda.count() > 0){
                        let pregunta = await ui.msgBox("La deuda " + item.MAP_IDENTIFICADOR + " ya cuenta con una acción del mismo tipo seleccionado, ¿desea generar una nueva acción igualmente?","Acción judicial repetida",1);
                        if(pregunta == 2) {
                            objself.MAP_PROCESANDO = 0;
                            return;
                        }
                    }
                }
            }
        }
        
        
        // devolución de intereses, compensación acuerdo acreedores
        if(objself.MAP_ACTIVIDADES_COMBO == 19 || objself.MAP_ACTIVIDADES_COMBO == 24) {
            
            if(total == 0){
                await ui.msgBox("Debe seleccionar la entidad para la cual desea generar la devolución de intereses.","Falta entidad",0);
                return;
            }
            else if(total > 1){
                await ui.msgBox("Debe seleccionar sólo una única entidad para la cual desea generar la devolución de intereses.","Varias entidades seleccionadas",0);
                objself.MAP_PROCESANDO = 0;
                return;
            }
        }
        
        // comprobaciones para acción judicial
        if(objself.MAP_ACTIVIDADES_COMBO == 20) {
            if(safeToInt(objself.MAP_IDACCION_COMBO) === 0){
                await ui.msgBox("Debe seleccionar el tipo de acción judicial a ejercer acción judicial",0);
                objself.MAP_PROCESANDO = 0;
                return;
            }
            
            if(entidades.length > 1){
                await ui.msgBox("Ha seleccionado varias deudas con entidades diferentes. Seleccione solo deudas con una misma entidad para generar la acción judicial.","Varias entidades",0);
                objself.MAP_PROCESANDO = 0;
                return;
            }
            
            if(total == 0){
                await ui.msgBox("Debe seleccionar la(s) entidad(es) para la(s) cual(es) desea generar la acción judicial.","Falta entidad",0);
                objself.MAP_PROCESANDO = 0;
                return;
            }
        }
        // comprobaciones para monitorio recibido
        else if(objself.MAP_ACTIVIDADES_COMBO == 22) {
            
            if(isNullOrEmpty(objself.MAP_ANEXO4) || objself.MAP_ANNADIR_ANEXO == 0) {
                // debe añadir un documento obligatoriamente
                await ui.msgBox("Debe adjuntar el documento monitorio que quiere subir","Falta documento monitorio",0);
                objself.MAP_PROCESANDO = 0;
                return;
            }
            
            if(total == 0){
                await ui.msgBox("Debe seleccionar la entidad para la cual desea generar el monitorio.","Falta entidad",0);
                objself.MAP_PROCESANDO = 0;
                return;
            }
            else if(total > 1){
                await ui.msgBox("Debe seleccionar sólo una única entidad para la cual desea generar el monitorio.","Varias entidades seleccionadas",0);
                objself.MAP_PROCESANDO = 0;
                return;
            }
        }
    }
    
    
    // comprobamos si el nombre del archivo está duplicado
    // Llamada bienvenida, conversaciones con el cliente, reserva de cita enviada, monitorio recibido
    if(objself.MAP_ACTIVIDADES_COMBO == 1 || objself.MAP_ACTIVIDADES_COMBO == 10 || objself.MAP_ACTIVIDADES_COMBO == 13 || objself.MAP_ACTIVIDADES_COMBO == 22){
        // comprobamos si adjunta anexo
        if(isNullOrEmpty(objself.MAP_ANEXO4) == false && objself.MAP_ANNADIR_ANEXO == 1){
            let file = objself.getOwnerCollection().getVariables("File");
            let fileName="";

            if(isNothing(file)){
                await ui.msgBox("Debe adjuntar el anexo que quiere subir","Falta anexo",0);
                objself.MAP_PROCESANDO = 0;
                return;
            }
            fileName = objself.MAP_ANEXO4;
            
            //  Comprobamos si para este lead existe un documento con el mismo nombre
            await filtrarCollMacroObject(collDoc,"d.BAJA=0 AND d.DOCUMENTO='"+fileName+"' AND d.ROWID_LEAD='"+objself.ROWID+"'");

            if(collDoc.count()>0){
                await ui.msgBox("Ya existe un documento con el nombre indicado. Especifique otro distinto.","Archivo duplicado",0);
                objself.MAP_PROCESANDO = 0;
                return;
            }
        }
    }
    
    
    // creamos la actividad
    let cnt = await objself.getContents("ActividadesCliente");
    let obj = await cnt.createObject();
    var fecha = ObtenerFechaHoraActual();
    
    obj.IDTIPO_ACTIVIDAD = objself.MAP_ACTIVIDADES_COMBO;
    
    if(objself.MAP_ACTIVIDADES_SUBTIPO_COMBO > 0){
        obj.IDSUBTIPO_ACTIVIDAD = objself.MAP_ACTIVIDADES_SUBTIPO_COMBO;
    }
    
    obj.IDLEAD = objself.ID;
    obj.IDUSUARIO = user.ID;
    obj.FECHA = fecha;
    obj.OBSERVACIONES = objself.MAP_OBSERVACION_ACTIVIDAD;
    obj.IMPORTE = objself.MAP_IMPORTE_ACTIVIDAD;
    obj.IBAN = objself.MAP_IBAN_ACTIVIDAD;
    obj.ESTADO = 0;
    
    await obj.save();
    // asignamos el id de la actividad que acabamos de crear para poder generar algunas plantillas
    objself.MAP_IDACTIVIDAD = obj.ID;
    
    
    // en conversación con el cliente, guardamos el comentario también en el content de observaciones
    if(objself.MAP_ACTIVIDADES_COMBO == 10) {
        let collObs = appData.getCollection("ClienteObservacionesScript");
        let objObs = await collObs.createObject();
        
        objObs.IDUSUARIO = user.ID;
        objObs.IDLEAD = objself.ID;
        objObs.IDACTIVIDAD = obj.ID;
        objObs.FECHA = fecha;
        objObs.OBSERVACION = objself.MAP_OBSERVACION_ACTIVIDAD;
        await objObs.save();
        
        await actualizarDatosContent(self,"ClienteObservaciones");
        ui.showToast("Actividad generada también en 'Observaciones/comentarios'");
    }
    
    // en monitorio recibido creamos la actividad de monitorio correspondiente
    if(objself.MAP_ACTIVIDADES_COMBO == 22) {
        await crearActividadClienteMonitorio(objself, obj.ID);
    }
    
    
    // creamos los documentos correspondientes
    
    // Cartas de representación, abstención de llamadas y oferta negociación extrajudicial
    if(objself.MAP_ACTIVIDADES_COMBO == 3 || objself.MAP_ACTIVIDADES_COMBO == 16 || objself.MAP_ACTIVIDADES_COMBO == 21){
        // aquí puesto que podemos seleccionar varias entidades, debemos generar una carta por cada una de ellas
        let cntEntidades = await objself.getContents("EntidadesDeudaClienteActividades");
        for(var i = 0; i < cntEntidades.count(); i++){
            let itemEntidad= cntEntidades.getItem(i);
            
            if(itemEntidad.MAP_SELECCIONAR == 1){
                objself.MAP_IDDEUDA_ACTIVIDAD=itemEntidad.ID;
                if(isNullOrEmpty(itemEntidad.MAP_NOMBRE_COMPLETO) == false){
                    objself.MAP_NOMCOTITULAR_ENTIDAD_ACTIVIDAD="D./Dna. "+itemEntidad.MAP_NOMBRE_COMPLETO+", ";
                }
                if(isNullOrEmpty(itemEntidad.MAP_NIF) == false){
                    objself.MAP_DNICOTITULAR_ENTIDAD_ACTIVIDAD="con NIF "+itemEntidad.MAP_NIF;
                }
                if(isNullOrEmpty(itemEntidad.MAP_DIRECCION) == false){
                    objself.MAP_DIRECCIONCOTITULAR_ENTIDAD_ACTIVIDAD=" y domicilio en  "+itemEntidad.MAP_DIRECCION+" (el Cotitular de la Deuda)";
                }
                
                // generamos la plantilla correspondiente con la actividad carta/abstención/autorización
                if(objself.MAP_ACTIVIDADES_COMBO == 3){
                    
                    await GenerarPlantilla(objself,3,itemEntidad,12, objself.ROWID);
                    
                } else if(objself.MAP_ACTIVIDADES_COMBO == 16){
                    
                    await GenerarPlantilla(objself,11,itemEntidad,29, objself.ROWID);
                    
                } else if(objself.MAP_ACTIVIDADES_COMBO == 21){
                    
                    await GenerarPlantilla(objself,14,itemEntidad,32, objself.ROWID);
                }
                
                objself.MAP_IDDEUDA_ACTIVIDAD = 0;
                objself.MAP_NOMCOTITULAR_ENTIDAD_ACTIVIDAD = "";
                objself.MAP_DNICOTITULAR_ENTIDAD_ACTIVIDAD = "";
                objself.MAP_DIRECCIONCOTITULAR_ENTIDAD_ACTIVIDAD = "";
            }
        }
    }
    // Resolución de contrato por incumplimiento
    else if(objself.MAP_ACTIVIDADES_COMBO == 4){
        await GenerarPlantilla(objself,8,'',16, objself.ROWID);
    }
    // Certificado fin programa
    else if(objself.MAP_ACTIVIDADES_COMBO == 5){
        await GenerarPlantilla(objself,10,'',19, objself.ROWID);
    }
    // Solicitud de pausa baja
    else if(objself.MAP_ACTIVIDADES_COMBO == 7){
        await crearActividadSolicitudBaja(objself, obj.ID);
        await GenerarPlantilla(objself,6,'',16, objself.ROWID);
    }
    // Solicitud de baja pre14
    else if(objself.MAP_ACTIVIDADES_COMBO == 8){
        await GenerarPlantilla(objself,5,'',15, objself.ROWID);
    }
    // Solicitud de pausa
    else if(objself.MAP_ACTIVIDADES_COMBO == 9){
        await GenerarPlantilla(objself,7,'',14, objself.ROWID);
    }
    // Modificación cláusulas contractuales
    else if(objself.MAP_ACTIVIDADES_COMBO == 17){
        await GenerarPlantilla(objself,12,'',24, objself.ROWID);
    }
    
    // Autorización ingreso cuenta bancaria - documento genérico sin entidad
    else if(objself.MAP_ACTIVIDADES_COMBO == 18){
        await GenerarPlantilla(objself,13,'',31, objself.ROWID);
    }
    
    // devolución de intereses
    else if(objself.MAP_ACTIVIDADES_COMBO == 19) {
        // generamos el registro de la devolución de intereses asociado a la actividad
        await crearActividadClienteDevolucionIntereses(objself, obj.ID);
    }
    //Compensación acuerdo acreedores
    else if(objself.MAP_ACTIVIDADES_COMBO == 24) {
        await crearActividadClienteCompensacionAcuerdoAcreedores(objself, obj.ID);
    }
    // generar acción judicial
    else if(objself.MAP_ACTIVIDADES_COMBO == 20){
        
        try {
            
            // generamos el registro de la acción judicial asociado a la actividad
            await crearActividadClienteAccionJudicial(objself, obj.ID);
            
            
            // aquí puesto que podemos seleccionar varias deudas, debemos generar un identificador por cada una de ellas
            let cntDeudaEntidades = await objself.getContents("EntidadesDeudaClienteJudicialActividades");
            let collDeudaClienteDemanda = appData.getCollection("DeudaClienteDemandaScript");
            // let seleccionados = 0;
            // let descartados = 0;
    
            // según el combo seleccionado en la actividad, generamos un identificador de acción judicial para las deudas. Es el mismo para todas
            let valores = await generarIdentificadorActividadDemandaMonitorio(objself.MAP_IDACCION_COMBO);
            let identificador = valores.identificador;
            let contador = valores.contador;
            
            for(var j = 0; j < cntDeudaEntidades.count(); j++){
                
                let itemDeuda = cntDeudaEntidades.getItem(j);
                
                if(itemDeuda.MAP_SELECCIONAR == 1){
                    
                    // seleccionados += 1;
                    
                    // DE MOMENTO SE PERMITE REPETIR DEUDA 10_2_26
                    // comprobamos si se ha generado previamente un identificador para ese tipo de acción para descartarlos
                    // if(objself.MAP_IDACCION_COMBO == 1){
                    //     await filtrarCollMacroObject(collDeudaClienteDemanda,"cd.IDDEUDACLIENTE="+itemDeuda.ID+" AND cd.IDENTIFICADOR like 'OPO%' ");
                    // } else if(objself.MAP_IDACCION_COMBO == 2) {
                    //     await filtrarCollMacroObject(collDeudaClienteDemanda,"cd.IDDEUDACLIENTE="+itemDeuda.ID+" AND cd.IDENTIFICADOR like 'DEM%'");
                    // } else if(objself.MAP_IDACCION_COMBO == 3) {
                    //     await filtrarCollMacroObject(collDeudaClienteDemanda,"cd.IDDEUDACLIENTE="+itemDeuda.ID+" AND cd.IDENTIFICADOR like 'DIL%'");
                    // }
                    
                    // // si ya existe un identificador para el mismo tipo de acción y deuda, lo descartamos y pasamos al siguiente
                    // if(collDeudaClienteDemanda.count() > 0){
                    //     itemDeuda.MAP_SELECCIONAR = 0;
                    //     descartados += 1;
                    //     continue;
                    // }
                    
                    
                    // guardamos un registro por cada entidad/deuda seleccionada a la que vamos a generar el identificador
                    let objDeudaClienteDemanda = await collDeudaClienteDemanda.createObject();
                    
                    
                    objDeudaClienteDemanda.IDDEUDACLIENTE = itemDeuda.ID;
                    objDeudaClienteDemanda.IDLEAD = objself.ID;
                    objDeudaClienteDemanda.IDACTIVIDADCLIENTE = obj.ID;
                    objDeudaClienteDemanda.IDENTIFICADOR = identificador;
                    
                    if(objself.MAP_IDACCION_COMBO == 1){
                        objDeudaClienteDemanda.NUMERO_OPOSICION = contador;
                    }else if(objself.MAP_IDACCION_COMBO == 2){
                        objDeudaClienteDemanda.NUMERO_DEMANDA = contador;
                    }else if (objself.MAP_IDACCION_COMBO == 3){
                        objDeudaClienteDemanda.NUMERO_DILIGENCIA = contador;
                    }
                    
                    await objDeudaClienteDemanda.save();
                }
            }
            
            // generamos la prmera actualización para la acción judicial
            await generarActualizacionAccionJudicial(objself, obj.ID, "inicial");
            
        } catch(e) {
            ui.showToast("error generando las acciones judiciales");
            obj.ESTADO = 2;
            await obj.save();
        }
        
        // si ya se había generado el identificador para todas las deudas seleccionadas, marcamos como fallida la actividad al no hacer nada
        // if(descartados == seleccionados) {
        //     obj.ESTADO = 2;
        // }
        // await obj.save();
    }
    
    
    // Llamada bienvenida, conversaciones con el cliente, reserva de cita enviada y monitorio recibido
    if(objself.MAP_ACTIVIDADES_COMBO == 1 || objself.MAP_ACTIVIDADES_COMBO == 10 || objself.MAP_ACTIVIDADES_COMBO == 13 || objself.MAP_ACTIVIDADES_COMBO == 22){
        // comprobamos si adjunta anexo
        if(isNullOrEmpty(objself.MAP_ANEXO4) == false && objself.MAP_ANNADIR_ANEXO == 1){
            let file = objself.getOwnerCollection().getVariables("File");
            let fileName = "";
            let tipoDoc = 0;

            if(isNothing(file)){
                await ui.msgBox("Debe adjuntar el anexo que quiere subir","Falta anexo",0);
                objself.MAP_PROCESANDO = 0;
                return;
            }
            fileName=objself.MAP_ANEXO4;
            
            if(objself.MAP_ACTIVIDADES_COMBO == 22) {
                tipoDoc = 33; // monitorio
            }else {
                tipoDoc = 21; // anexo actividad
            }
            
            // subimos el archivo
            await uploadFiles(objself, file, fileName, tipoDoc, objself.CORREO, user.CORREO, user.LOGIN,"anexoActividad",objself.ROWID,0,0,0,0,obj.ID);
        }
    }
    
    // si es una llamada de bienvenida, pasamos de etapa al cliente
    if(objself.MAP_ACTIVIDADES_COMBO==1 && objself.IDESTADO_CLIENTE==1){
        var collEstado= appData.getCollection("EstadosCliente");
        await filtrarCollMacroObject(collEstado,"CODIGO=2");

        let Estado = collEstado.getItem(0);
        if(Estado){
            objself.IDESTADO_CLIENTE=2;
            objself.MAP_ETAPA=Estado.NOMBRE;
            await guardarHistoricoCambioEstadoCliente(objself,1,2);
        }else{
            ui.showToast("error al pasar a la etapa 'en proceso'");
        }
    }
    
    // actualizamos la fecha de última actividad del cliente
    objself.FECHA_ULT_ACTIVIDAD = fecha;
    await objself.save();
    
    objself.MAP_CREAR_ACTIVIDAD=0;
    objself.MAP_IDACTIVIDAD=0;
    objself.MAP_PROCESANDO = 0;
    limpiarCampos(objself,"crearActividadCliente");
    await actualizarDatosPaginadoLeads(objself,"ActividadesCliente","ActividadesClienteContador","MAP_PAG_INI_ACT","MAP_PAG_LEN_ACT","MAP_TOTAL_REGISTROS_ACT","MAP_T1_ACT");
}


async function crearActividadSolicitudBaja(objself, idactividadcliente) {
    
    // creamos la actividad de solicitud de baja a partir de la actividad principal
    let collSolicitudBaja = appData.getCollection("ActividadesClienteHijoSolicitudBajaScript");
    let objSolicitudBaja = await collSolicitudBaja.createObject();

    objSolicitudBaja.IDACTIVIDADCLIENTE = idactividadcliente;  
    objSolicitudBaja.IMPORTE = objself.MAP_IMPORTE_ACTIVIDAD;
    objSolicitudBaja.IBAN = objself.MAP_IBAN_ACTIVIDAD;
    objSolicitudBaja.OBSERVACIONES = objself.MAP_OBSERVACION_ACTIVIDAD;
    
    await objSolicitudBaja.save();
}

async function crearActividadClienteDevolucionIntereses(objself, idactividadcliente) {
    
    let fecha = ObtenerFechaHoraActual();
    let fechaInicio = new Date(fecha);    
    let fecha_limite = sumarDiasLaborables(fechaInicio, objself.MAP_DIAS_RECIBIR, {agostoLaborable: true,navidadLaborable: true});
    
    // obtenemos datos de IBAN y beneficiario desde InformacionGeneralScript
    let objInfo = await obtenerPrimerObjetoColl("InformacionGeneralScript", "1=1");
    
    // creamos la actividad de acción judicial a partir de la actividad principal
    let collDevolucionIntereses = appData.getCollection("ActividadesClienteAccionesDevolucionInteresesScript");
    let objDevolucionIntereses = await collDevolucionIntereses.createObject();
    
    
    objDevolucionIntereses.IDACTIVIDADCLIENTE = idactividadcliente;  
    objDevolucionIntereses.IDESTADO = 1;
    objDevolucionIntereses.ID_RECEPTOR_DEVOLUCION = objself.MAP_CUENTA_DEVOLUCION_COMBO;
    objDevolucionIntereses.ID_TIPO_DEVOLUCION = objself.MAP_TIPO_DEVOLUCION_COMBO;
    
    objDevolucionIntereses.FECHA_ACUERDO = fechaInicio;
    objDevolucionIntereses.FECHA_LIMITE = fecha_limite;
    objDevolucionIntereses.IBAN = objInfo.IBAN; 
    objDevolucionIntereses.BENEFICIARIO = objInfo.BENEFICIARIO; 
    objDevolucionIntereses.IBAN_CLIENTE = objself.IBAN; 
    objDevolucionIntereses.BENEFICIARIO_CLIENTE = objself.NOMBRE + " " + objself.APELLIDOS; 
    objDevolucionIntereses.DIAS_RECIBIR_DINERO = objself.MAP_DIAS_RECIBIR; 
    objDevolucionIntereses.IMPORTE_RECIBIR = objself.MAP_IMPORTE_RECIBIR;
    objDevolucionIntereses.IMPORTE_COBRAR = objself.MAP_IMPORTE_RECIBIR * 0.15;
    objDevolucionIntereses.IMPORTE_DEVOLVER = objself.MAP_IMPORTE_RECIBIR - objDevolucionIntereses.IMPORTE_COBRAR;
    
    // comprobamos si se ha seleccionado alguna entidad
    let cntEntidad = await objself.getContents("EntidadesDeudaClienteJudicialActividades");
    for(var i=0; i<cntEntidad.count(); i++){
        let item = cntEntidad.getItem(i);
        
        if(item.MAP_SELECCIONAR == 1){
            objDevolucionIntereses.IDDEUDACLIENTE = item.ID;
            break;
        }
    }
    
    await objDevolucionIntereses.save();
    // generamos el identificador del objeto creado
    await generarIdentificadorDevolucionIntereses(objDevolucionIntereses);
    
    // generamos la primera actualización para el cliente asociado a la deuda
    await generarActualizacionDevolucionIntereses(objDevolucionIntereses, objself.ID);
    
    // guardamos en el histórico de estados
    await guardarHistoricoDevolucionIntereses(objDevolucionIntereses,0,1);
}

async function guardarHistoricoDevolucionIntereses(objDevolucion,idestadoOrigen,idestadoDestino){
    // para llevar un histórico de los cambios de estado en devoluciones de intereses
    let fecha=ObtenerFechaHoraActual();
    let collHistorico = appData.getCollection("DevolucionInteresesClienteHistoricoEstadosScript");
    let objEstado = await collHistorico.createObject();
    
    objEstado.IDACTIVIDADCLIENTE_DEVOLUCION_INTERESES = objDevolucion.ID;
    objEstado.IDESTADO_ORIGEN = idestadoOrigen;
    objEstado.IDESTADO_DESTINO = idestadoDestino;
    objEstado.FECHA = fecha;
    await objEstado.save();
}

function asignarValoresPlazoIntereses(fechaLimiteprt) {

    if (esFechaMayor(fechaLimiteprt)) {
        return {texto: "En plazo", colorFondo: "#c6dcff"};
    } else {
        return {texto: "Fuera de plazo", colorFondo: "#bd0a0a"};
    }
}

async function generarActualizacionDevolucionIntereses (objself, idlead) {
    // Actualizaciones que se generan para visualizarse en la zona de usuario de manera automática con la actividad devolución de intereses
    // objself aquí será el objeto de gen_cliente_actividad_erp_devolucion_intereses
    let fecha = ObtenerFechaHoraActual();
    let collAct = appData.getCollection("ClienteActualizacionesScript");
    let objAct = await collAct.createObject();
    
    objAct.IDDEUDA = objself.IDDEUDACLIENTE;
    objAct.IDLEAD = idlead;
    objAct.IDUSUARIO = user.ID;
    objAct.FECHA = fecha;
    
    // devoluciones a cliente
    if(objself.ID_RECEPTOR_DEVOLUCION == 1) {
        switch (objself.IDESTADO) {
            // Pendiente devolución directa a cuenta cliente
            case 1:
                objAct.IDCONCEPTO = 29;
                objAct.OBSERVACIONES_ZONA_USUARIO = "La entidad ha indicado que realizará la devolución de ["+objself.IMPORTE_RECIBIR+"€] directamente a tu cuenta bancaria. Avísanos cuando recibas el importe para poder registrarlo en tu expediente.";
                break;
            // Devolución recibida en cuenta de cliente
            case 2:
                objAct.IDCONCEPTO = 30;
                objAct.OBSERVACIONES_ZONA_USUARIO = "Has recibido correctamente los ["+objself.IMPORTE_RECIBIR+"€] en tu cuenta bancaria. Procedemos a actualizar tu expediente.";
                break;
            // Pendiente cobro de comisión Alivia por la gestión
            case 3:
                objAct.IDCONCEPTO = 25;
                objAct.OBSERVACIONES_ZONA_USUARIO = "Está pendiente el cobro de la comisión de gestión de ["+objself.IMPORTE_COBRAR+"€] correspondiente a este procedimiento.";
                break;
            // Comisión Alivia cobrada
            case 4:
                objAct.IDCONCEPTO = 26;
                objAct.OBSERVACIONES_ZONA_USUARIO = "La comisión de gestión de ["+objself.IMPORTE_COBRAR+"€] ha sido cobrada correctamente.";
                break;

                
            default:
                return; // No hacemos nada si el estado no está contemplado
            }
    }
    // devoluciones a Alivia
    else if(objself.ID_RECEPTOR_DEVOLUCION == 2) {
        switch (objself.IDESTADO) {
            // Pendiente devolución a cuenta Alivia
            case 1:
                objAct.IDCONCEPTO = 23;
                objAct.OBSERVACIONES_ZONA_USUARIO = "Estamos a la espera de recibir la devolución de ["+objself.IMPORTE_RECIBIR+"€] en la cuenta de Alivia por parte de la entidad.";
                break;
            // Devolución recibida en cuenta Alivia
            case 2:
                objAct.IDCONCEPTO = 24;
                objAct.OBSERVACIONES_ZONA_USUARIO = "Hemos recibido correctamente los ["+objself.IMPORTE_RECIBIR+"€] en la cuenta de Alivia. Estamos gestionando los siguientes pasos.";
                break;
            // Pendiente cobro de comisión Alivia por la gestión
            case 3:
                objAct.IDCONCEPTO = 25;
                objAct.OBSERVACIONES_ZONA_USUARIO = "Está pendiente el cobro de la comisión de gestión de ["+objself.IMPORTE_COBRAR+"€] correspondiente a este procedimiento.";
                break;
            // Comisión Alivia cobrada
            case 4:
                objAct.IDCONCEPTO = 26;
                objAct.OBSERVACIONES_ZONA_USUARIO = "La comisión de gestión de ["+objself.IMPORTE_COBRAR+"€] ha sido cobrada correctamente.";
                break;
            // Pendiente devolución a la cuenta del cliente
            case 5:
                objAct.IDCONCEPTO = 27;
                objAct.OBSERVACIONES_ZONA_USUARIO = "Estamos preparando la transferencia de ["+objself.IMPORTE_DEVOLVER+"€] a tu cuenta bancaria.";
                break;
            // Devolución realizada a la cuenta del cliente
            case 6:
                objAct.IDCONCEPTO = 28;
                objAct.OBSERVACIONES_ZONA_USUARIO = "Hemos realizado la transferencia de ["+objself.IMPORTE_DEVOLVER+"€] a tu cuenta bancaria. El ingreso puede tardar entre 24 y 72 horas en reflejarse.";
                break;
           
            default:
                return; // No hacemos nada si el estado no está contemplado
            }
    }
    
    await objAct.save();
}

async function crearActividadClienteCompensacionAcuerdoAcreedores(objself, idactividadcliente) {
    
    let fecha = ObtenerFechaHoraActual();
    let fechaInicio = new Date(fecha);    
    let fecha_limite = sumarDiasLaborables(fechaInicio, objself.MAP_DIAS_RECIBIR24, {agostoLaborable: true,navidadLaborable: true});
    
    // obtenemos datos de IBAN y beneficiario desde InformacionGeneralScript
    let objInfo = await obtenerPrimerObjetoColl("InformacionGeneralScript", "1=1");
    
    
    // creamos la actividad de acción judicial a partir de la actividad principal
    let collAcuerdoAcreedores = appData.getCollection("ActividadesClienteHijoCompensacionAcuerdoAcreedoresScript");
    let objAcuerdoAcreedores = await collAcuerdoAcreedores.createObject();
    
    
    objAcuerdoAcreedores.IDACTIVIDADCLIENTE = idactividadcliente;  
    objAcuerdoAcreedores.IDESTADO = 1;
    objAcuerdoAcreedores.FECHA_ACUERDO = fechaInicio;
    objAcuerdoAcreedores.FECHA_LIMITE = fecha_limite;
    objAcuerdoAcreedores.DIAS_RECIBIR_DINERO = objself.MAP_DIAS_RECIBIR24; 
    objAcuerdoAcreedores.IMPORTE_RECIBIR = objself.MAP_IMPORTE_RECIBIR24;
    objAcuerdoAcreedores.IMPORTE_COBRAR = objself.MAP_IMPORTE_RECIBIR24;
    objAcuerdoAcreedores.IBAN = objInfo.IBAN;
    objAcuerdoAcreedores.BENEFICIARIO = objInfo.BENEFICIARIO;

    // comprobamos si se ha seleccionado alguna entidad
    let cntEntidad = await objself.getContents("EntidadesDeudaClienteJudicialActividades");
    for(var i=0; i<cntEntidad.count(); i++){
        let item = cntEntidad.getItem(i);
        
        if(item.MAP_SELECCIONAR == 1){
            objAcuerdoAcreedores.IDDEUDACLIENTE = item.ID;
            break;
        }
    }
    
    await objAcuerdoAcreedores.save();
    // generamos el identificador del objeto creado
    await generarIdentificadorGenerico(objAcuerdoAcreedores, "ActividadesClienteHijoCompensacionAcuerdoAcreedoresContador", "CGEAC", "NUMERO_IDENTIFICADOR", "IDENTIFICADOR");    
    
    // // generamos la primera actualización para el cliente asociado a la deuda
    // await generarActualizacionDevolucionIntereses(objAcuerdoAcreedores, objself.ID);
    
    // // guardamos en el histórico de estados
    // await guardarHistoricoDevolucionIntereses(objAcuerdoAcreedores,0,1);
}

function comprobarEtapaCompensacionAcuerdoAcreedores(objself, propImagenEtapa, numeroEtapas) {
    
    // iteramos las etapas de la acción judicial. Según el estado, vamos asignando a los props las imágenes correspondientes
    for(var i = 1; i <= numeroEtapas; i++) {
        
        if(i < objself.IDESTADO) {
            objself[propImagenEtapa + safeToString(i)] = "deudaVerde.png";
        }
        else if(i == objself.IDESTADO) {
            objself[propImagenEtapa + safeToString(i)] = "deudaAmarillo.png";
        }else if(i > objself.IDESTADO) {
            objself[propImagenEtapa + safeToString(i)] = "deudaGris.png";
        }
    }
}

async function solicitarDevolucionCompensacionAcuerdoAcreedores(objself, idactividad) {
    let padre = objself.getParent();
    var fecha = ObtenerFechaHoraActual();
    let error = 0;

    var collMov = appData.getCollection("MovimientosScript");

    // comprobaciones
    if(safeToInt(objself.MAP_IDDEUDACLIENTE) === 0){
        ui.showToast("Debe indicar la deuda asociada");
        error++;
    }
    if(safeToFloat(objself.IMPORTE_RECIBIR) === 0){
        ui.showToast("Debe indicar el importe");
        error++;
    }
    if(isNullOrEmpty(objself.MAP_IBAN)){
        ui.showToast("Debe indicar el IBAN");
        error++;
    }
    if(isNullOrEmpty(objself.MAP_BENEFICIARIO)){
        ui.showToast("Debe indicar el beneficiario");
        error++;
    }
    if(error > 0) return;

    // comprobamos si ya existe un movimiento pendiente
    await filtrarCollMacroObject(collMov, "m.IDACTIVIDAD="+idactividad+" AND m.IDLEAD="+objself.MAP_IDLEAD+" AND m.IDTIPO_MOVIMIENTO=13 AND m.IDESTADO IN(5,1)");

    if(collMov.count() > 0){
        ui.showToast("Ya existe un movimiento de compensación pendiente asociado a la actividad. Revise el apartado de movimientos");
        return;
    }

    let pregunta = await ui.msgBox("¿Está seguro que desea solicitar la compensación acuerdo acreedores?","Compensación acuerdo acreedores", 1);

    if(pregunta == 1){
        let MovCrear = appData.getCollection("MovimientosScript");
        let objMov = await MovCrear.createObject();

        objMov.IDACTIVIDAD = idactividad;
        objMov.IDLEAD = objself.MAP_IDLEAD;
        objMov.IDTIPO_MOVIMIENTO = 13;
        objMov.FECHA_SOLICITUD = fecha;
        objMov.IDESTADO = 5;
        objMov.IMPORTE = objself.IMPORTE_RECIBIR;
        objMov.IBAN = objself.MAP_IBAN;
        objMov.BENEFICIARIO = objself.MAP_BENEFICIARIO;
        objMov.IDDEUDA = objself.MAP_IDDEUDACLIENTE;
        await objMov.save();

        // generamos el identificador del movimiento
        let nuevoIdentificador = await generarIdentificadorMovimiento(13, objMov.ID, true);
        let concepto = nuevoIdentificador + " - Compensación acuerdo acreedores " + objself.MAP_DEUDA_ASOCIADA;

        objMov.CONCEPTO = concepto;
        
        await objMov.save();

        objself.CONCEPTO = concepto;
        objself.MAP_CONCEPTO = concepto;
        objself.MAP_IDENTIFICADOR_MOVIMIENTO = nuevoIdentificador;
        await objself.save();

        await actualizarDatosPaginadoLeads(padre,"ActividadesCliente","ActividadesClienteContador","MAP_PAG_INI_ACT","MAP_PAG_LEN_ACT","MAP_TOTAL_REGISTROS_ACT","MAP_T1_ACT");

        ui.showToast("Movimiento de compensación acuerdo acreedores creado. Por favor, revise el apartado de movimientos");
    } else {
        return;
    }
}

// funcion que arranca al pulsar boton CobroCE
async function solicitarCobroCECompensacionAcuerdoAcreedores(objself) {
    let collMov = appData.getCollection("MovimientosScript");
    let fecha = ObtenerFechaHoraActual();
    
    // comprobamos que no exista ya un movimiento de CE tipo 14 para esta actividad
    await filtrarCollMacroObject(collMov, "m.IDTIPO_MOVIMIENTO = 14 AND m.IDACTIVIDAD=" + objself.IDACTIVIDADCLIENTE + " and m.IDESTADO IN(5,7)");
    
    if(collMov.count() > 0) {
        ui.showToast("Ya existe un cobro de CE asociado a la actividad. Revise el apartado de movimientos");
        return;
    }
    
    let pregunta = await ui.msgBox("¿Está seguro que desea solicitar el cobro?", "Cobro comisión", 1);
    if(pregunta == 2) {
        return;
    }
    
    let objMov = await collMov.createObject();
    
    objMov.IDACTIVIDAD = objself.IDACTIVIDADCLIENTE;
    objMov.IDLEAD = objself.MAP_IDLEAD;
    objMov.IDDEUDA = objself.MAP_IDDEUDACLIENTE;
    objMov.IDTIPO_MOVIMIENTO = 14;  // CE compensación acuerdo acreedores
    objMov.FECHA_SOLICITUD = fecha;
    objMov.IDESTADO = 5;
    objMov.BASE_IMPONIBLE = round(objself.IMPORTE_COBRAR / 1.21, 2);
    objMov.IVA = round(objself.IMPORTE_COBRAR - (objself.IMPORTE_COBRAR / 1.21), 2);
    objMov.IMPORTE = objself.IMPORTE_COBRAR;
    await objMov.save();
    
    // pasamos la actividad hija a estado 3 (Pendiente Cobro CE)
    objself.IDESTADO = 3;
    await objself.save();
    
    let objEstado = await obtenerPrimerObjetoColl("EstadosCompensacionAcuerdoAcreedores","ID=3");
    
    if(objEstado) {
        objself.MAP_ESTADO_DEVOLUCION = objEstado.NOMBRE;
    }
    comprobarEtapaCompensacionAcuerdoAcreedores(objself, "MAP_IMG_PROGRESO", 4);
    
    let padre = objself.getParent();
    await actualizarDatosPaginadoLeads(padre, "ActividadesCliente", "ActividadesClienteContador", "MAP_PAG_INI_ACT", "MAP_PAG_LEN_ACT", "MAP_TOTAL_REGISTROS_ACT", "MAP_T1_ACT");
    
    ui.showToast("Movimiento de cobro de comisión creado. Por favor, revise el apartado de movimientos");
}


async function crearActividadClienteAccionJudicial(objself, idactividadcliente) {
    
    // creamos la actividad de acción judicial a partir de la actividad principal
    let collAccionJudicial = appData.getCollection("ActividadesClienteAccionesJudicialesScript");
    let objAccionJudicial = await collAccionJudicial.createObject();
    
    objAccionJudicial.IDACTIVIDADCLIENTE = idactividadcliente;
    await objAccionJudicial.save();
}

async function generarActualizacionAccionJudicial(objself, idactividadcliente, tipo) {
    // Actualizaciones que se generan para visualizarse en la zona de usuario de manera automática con la actividad acciones judiciales
    // coll para la acción judicial y deudas asociadas a la acción judicial y misma actividad principal
    let collAccionJudicial= appData.getCollection("ActividadesClienteAccionesJudicialesScript");
    let collDeudaDemanda= appData.getCollection("DeudaClienteDemandaScript");
    
    let collAct = appData.getCollection("ClienteActualizacionesScript");
    let fecha = ObtenerFechaHoraActual();
    
    // buscamos la acción judicial y deudas asociadas a la misma actividad principal
    await filtrarCollMacroObject(collAccionJudicial,"acc.IDACTIVIDADCLIENTE=" + idactividadcliente);
    if(collAccionJudicial.count() == 0){
        ui.showToast("No es posible generar la actualización. Acción judicial no encontrada.");
        return;
    }
    let objAccionJudicial = collAccionJudicial.getItem(0);
    
    
    // Buscamos todas las deudas asociadas para generar la actualización en ellas
    // En función del tipo, generaremos una actualización u otra
    await filtrarCollMacroObject(collDeudaDemanda,"cd.IDACTIVIDADCLIENTE=" + idactividadcliente);
    if(collDeudaDemanda.count() > 0){
        
        for(var i = 0; i<collDeudaDemanda.count(); i++) {
            let objDeudaDemanda = collDeudaDemanda.getItem(i);
            
            let objAct = await collAct.createObject();
            
            objAct.IDDEUDA = objDeudaDemanda.IDDEUDACLIENTE;
            objAct.IDLEAD = objDeudaDemanda.IDLEAD;
            objAct.IDUSUARIO = user.ID;
            objAct.FECHA = fecha;
            objAct.IDACTIVIDADCLIENTE = idactividadcliente;
            
            
            // estado apud acción judicial (ID_ESTADO_APUD_ACCION_JUDICIAL)
            if(tipo == "apud") {
                switch (objAccionJudicial.ID_ESTADO_APUD_ACCION_JUDICIAL) {
                    // Solicitada
                    case 1:
                        objAct.IDCONCEPTO = 32;
                        objAct.OBSERVACIONES_ZONA_USUARIO = "Necesitamos tu firma del apud acta para poder representarte legalmente en el procedimiento.";
                        break;
                    // Firmada
                    case 3:
                        objAct.IDCONCEPTO = 33;
                        objAct.OBSERVACIONES_ZONA_USUARIO = "El apud acta ya está firmado. Ya podemos representarte legalmente.";
                        break;
                    // En carpeta
                    case 4:
                        objAct.IDCONCEPTO = 34;
                        objAct.OBSERVACIONES_ZONA_USUARIO = "El apud acta ya está en manos del procurador. El procurador se encargará de presentarlo en el juzgado para formalizar la representación";
                        break;
                        
                    default:
                        return; // No hacemos nada si el estado no está contemplado
                    }
            }
           
            // estado acción judicial (ID_ESTADO_ACCION_JUDICIAL)
            else if(tipo == "accion") {
                switch (objAccionJudicial.ID_ESTADO_ACCION_JUDICIAL) {
                    // A presentar
                    case 5:
                        objAct.IDCONCEPTO = 35;
                        objAct.OBSERVACIONES_ZONA_USUARIO = "La demanda está preparada. Estamos pendientes de presentarla ante el juzgado.";
                        break;
                    // Presentado
                    case 6:
                        objAct.IDCONCEPTO = 36;
                        objAct.OBSERVACIONES_ZONA_USUARIO = "La demanda ya se ha presentado ante el juzgado.";
                        break;
                        
                    default:
                        return; // No hacemos nada si el estado no está contemplado
                    }
            }
            
            // Actualización que guardamos sólo al crear la acción judicial
            else if(tipo == "inicial") {
                    // Cuando creamos la actividad
                    objAct.IDCONCEPTO = 31;
                    objAct.OBSERVACIONES_ZONA_USUARIO = "Tu caso está siendo revisado por el equipo legal para evaluar si procede iniciar una acción judicial.";

            }
            // Estados propios (1-10) de la acción judicial cliente_actividad_erp_acciones_judiciales
            else if(tipo == "estadoPendiente") {
                switch (objAccionJudicial.IDESTADO) {
                    // estado = 1 pendiente
                    case 1:
                        objAct.IDCONCEPTO = 37;
                        objAct.OBSERVACIONES_ZONA_USUARIO = "Estámos pendientes de obterner el justificado de presentación oficial (LEXNET).";
                        break;
                    // estado = 2 pendiente
                    case 2:
                        objAct.IDCONCEPTO = 39;
                        objAct.OBSERVACIONES_ZONA_USUARIO = "El juzgado está revisando la demanda para decidir si la admite a trámite.";
                        break;
                    // estado = 3 pendiente
                    case 3:
                        objAct.IDCONCEPTO = 41;
                        objAct.OBSERVACIONES_ZONA_USUARIO = "Estamos a la espera de que el juzgado señale la fecha de audiencia o juicio.";
                        break;
                    // estado = 6 pendiente
                    case 6:
                        objAct.IDCONCEPTO = 48;
                        objAct.OBSERVACIONES_ZONA_USUARIO = "Estamos preparando el escrito de oposición al recurso presentado.";
                        break;
                    // estado = 8 pendiente
                    case 8:
                        objAct.IDCONCEPTO = 53;
                        objAct.OBSERVACIONES_ZONA_USUARIO = "Estamos esperando a que la sentencia sea firme (sin posibilidad de recurso).";
                        break;
                   
                    default:
                        return; // No hacemos nada si el estado no está contemplado
                    }
            }
            // Estados propios (1-10) de la acción judicial cliente_actividad_erp_acciones_judiciales
            else if(tipo == "estadoRealizado") {
                switch (objAccionJudicial.IDESTADO) {
                    // estado = 1 realizado
                    case 1:
                        objAct.IDCONCEPTO = 38;
                        objAct.OBSERVACIONES_ZONA_USUARIO = "El justificante LEXNET ya está disponible.";
                        objAct.IDDOCUMENTO = objAccionJudicial.MAP_IDDOCUMENTO34;
                        break;
                    // estado = 2 realizado
                    case 2:
                        objAct.IDCONCEPTO = 40;
                        objAct.OBSERVACIONES_ZONA_USUARIO = "El juzgado ha admitido la demanda a trámite. El procedimiento continúa.";
                        objAct.IDDOCUMENTO = objAccionJudicial.MAP_IDDOCUMENTO35;
                        break;
                    // estado = 3 realizado
                    case 3:
                        objAct.IDCONCEPTO = 42;
                        objAct.OBSERVACIONES_ZONA_USUARIO = "El juzgado ha fijado la fecha de audiencia/juicio para el " + fechaFormateada(objself.MAP_FECHA_JUICIO) + ".";
                        break;
                    // estado = 6 realizado
                    case 6:
                        objAct.IDCONCEPTO = 49;
                        objAct.OBSERVACIONES_ZONA_USUARIO = "Hemos presentado la oposición al recurso ante el tribunal.";
                        objAct.IDDOCUMENTO = objAccionJudicial.MAP_IDDOCUMENTO37;
                        break;
                    // estado = 8 realizado
                    case 8:
                        objAct.IDCONCEPTO = 54;
                        objAct.OBSERVACIONES_ZONA_USUARIO = "La sentencia ya es firme. Pasamos a gestionar la ejecución y cobros/devoluciones.";
                        objAct.IDDOCUMENTO = objAccionJudicial.MAP_IDDOCUMENTO38;
                        break;
                   
                    default:
                        return; // No hacemos nada si el estado no está contemplado
                    }
            }
            // En función del resultado del juicio
            else if(tipo == "resultadoJuicio") {
                switch (objAccionJudicial.ID_RESULTADO_JUICIO) {
                    // resultado = 1. Estimación total
                    case 1:
                        objAct.IDCONCEPTO = 45;
                        objAct.OBSERVACIONES_ZONA_USUARIO = "Hemos obtenido una sentencia favorable.";
                        objAct.IDDOCUMENTO = objAccionJudicial.MAP_IDDOCUMENTO36;
                        break;
                    // resultado = 2. Estimación parcial
                    case 2:
                        objAct.IDCONCEPTO = 44;
                        objAct.OBSERVACIONES_ZONA_USUARIO = "La sentencia es favorable en parte. Te explicaremos el resultado y el impacto exacto.";
                        objAct.IDDOCUMENTO = objAccionJudicial.MAP_IDDOCUMENTO36;
                        break;
                    // resultado = 3. Desestimación
                    case 3:
                        objAct.IDCONCEPTO = 43;
                        objAct.OBSERVACIONES_ZONA_USUARIO = "La sentencia no ha sido favorable. Revisaremos contigo las opciones y próximos pasos.";
                        objAct.IDDOCUMENTO = objAccionJudicial.MAP_IDDOCUMENTO36;
                        break;
                    
                    default:
                        return; // No hacemos nada si el estado no está contemplado
                    }
            }
            // En función de si presenta recurso
            else if(tipo == "presentaRecurso") {
                switch (objAccionJudicial.ID_PRESENTA_RECURSO) {
                    // resultado = 1. Síp resenta
                    case 1:
                        objAct.IDCONCEPTO = 46;
                        objAct.OBSERVACIONES_ZONA_USUARIO = "La parte contraria ha presentado recurso. Nuestro equipo ya está gestionando la respuesta.";
                        break;
                    // resultado = 2. No presenta
                    case 2:
                        objAct.IDCONCEPTO = 47;
                        objAct.OBSERVACIONES_ZONA_USUARIO = "La parte contraria no ha presentado recurso dentro del plazo legal.";
                        break;
                    
                    default:
                        return; // No hacemos nada si el estado no está contemplado
                    }
            }
            // En función del resultado del juicio del recurso
            else if(tipo == "resultadoJuicioRecurso") {
                switch (objAccionJudicial.ID_RESULTADO_JUICIO_RECURSO) {
                    // resultado = 1. Estimación total
                    case 1:
                        objAct.IDCONCEPTO = 52;
                        objAct.OBSERVACIONES_ZONA_USUARIO = "La resolución del recurso ha sido favorable.";
                        break;
                    // resultado = 2. Estimación parcial
                    case 2:
                        objAct.IDCONCEPTO = 51;
                        objAct.OBSERVACIONES_ZONA_USUARIO = "La resolución del recurso es favorable en parte. Te explicaremos el resultado.";
                        break;
                    // resultado = 3. Desestimación
                    case 3:
                        objAct.IDCONCEPTO = 50;
                        objAct.OBSERVACIONES_ZONA_USUARIO = "La resolución del recurso no ha sido favorable. Revisaremos alternativas contigo.";
                        break;
                    
                    default:
                        return; // No hacemos nada si el estado no está contemplado
                    }
            }
            
            await objAct.save();
        }
    }
}

async function cambiarEtapaAccionJudicial(objself, tipoDoc) {
    // en ocasiones al subir documentos de las acciones judiciales, cambia la etapa
    
    var etapaPorTipoDocumento = {
        34: 2,
        35: 3,
        37: 7,
        38: 9
    };
    
    var nuevaEtapa = etapaPorTipoDocumento[tipoDoc];

    if (nuevaEtapa !== undefined) {
        // generamos la actualización correspondiente antes de pasar de etapa (realizado)
        await generarActualizacionAccionJudicial(objself, objself.IDACTIVIDADCLIENTE, "estadoRealizado");
        
        objself.IDESTADO = nuevaEtapa;
        await objself.save();
        
        // generamos la actualización correspondiente en la nueva etapa (pendiente)
        await generarActualizacionAccionJudicial(objself, objself.IDACTIVIDADCLIENTE, "estadoPendiente");
    }
}

function comprobarEtapaAccionJudicial(objself, propImagenEtapa, numeroEtapas) {
    
    // iteramos las etapas de la acción judicial. Según el estado, vamos asignando a los props las imágenes correspondientes
    for(var i = 1; i <= numeroEtapas; i++) {
        
        if(i < objself.IDESTADO) {
            objself[propImagenEtapa + safeToString(i)] = "deudaVerde.png";
        }
        else if(i == objself.IDESTADO) {
            objself[propImagenEtapa + safeToString(i)] = "deudaAmarillo.png";
        }else if(i > objself.IDESTADO) {
            objself[propImagenEtapa + safeToString(i)] = "deudaGris.png";
        }
        
        // si está marcado el check final de cobrado, la última etapa está realizada
        if(i == numeroEtapas && objself.COBRADO_CHECK == 1){
            objself[propImagenEtapa + i] = "deudaVerde.png";
        }
    }
}

async function accionJudicialHistoricoEstadoApudGuardar(idactividad_acc_judicial, estadoOrigen, estadoDestino) {
    // para cuando cambia el campo ID_ESTADO_APUD_ACCION_JUDICIAL de una acción judicial
    let collEstadoApud = appData.getCollection("DeudaClienteDemandaHistoricoEstadosApudScript");
    let fecha = ObtenerFechaHoraActual();
    
    let objEstadoApud = await collEstadoApud.createObject();
    objEstadoApud.IDACTIVIDADCLIENTE_ACCION_JUDICIAL = idactividad_acc_judicial;
    objEstadoApud.IDESTADO_ORIGEN = estadoOrigen;
    objEstadoApud.IDESTADO_DESTINO = estadoDestino;
    objEstadoApud.FECHA = fecha;
    await objEstadoApud.save();
}

async function accionJudicialHistoricoEstadoAccionGuardar(idactividad_acc_judicial, estadoOrigen, estadoDestino) {
    // para cuando cambia el campo ID_ESTADO_ACCION_JUDICIAL de una acción judicial
    let collEstadoAccion = appData.getCollection("DeudaClienteDemandaHistoricoEstadosAccionScript");
    let fecha = ObtenerFechaHoraActual();
    
    let objEstadoAccion = await collEstadoAccion.createObject();
    objEstadoAccion.IDACTIVIDADCLIENTE_ACCION_JUDICIAL = idactividad_acc_judicial;
    objEstadoAccion.IDESTADO_ORIGEN = estadoOrigen;
    objEstadoAccion.IDESTADO_DESTINO = estadoDestino;
    objEstadoAccion.FECHA = fecha;
    await objEstadoAccion.save();
}


async function accionJudicialGuardar(objself, idactividadCliente) {
    // Para actualizar estados de una acción judicial desde el listado general
    
    let cambioApud = false;
    let cambioAccion = false;
    
    // buscamos la actividad hija de acción judicial asociada
    let collActividad = appData.getCollection("ActividadesClienteAccionesJudicialesScript");
    await filtrarCollMacroObject(collActividad,"acc.IDACTIVIDADCLIENTE =" + idactividadCliente);
    
    if (collActividad.count() > 0) {
        let objActividad = collActividad.getItem(0);
        
        // comprobamos si ha cambiado alguno de los estados y lo guardamos en el/los históricos
        if(objself.MAP_ID_ESTADO_ACCION_JUDICIAL != objActividad.ID_ESTADO_ACCION_JUDICIAL) {
            await accionJudicialHistoricoEstadoAccionGuardar(objActividad.ID, objActividad.ID_ESTADO_ACCION_JUDICIAL, objself.MAP_ID_ESTADO_ACCION_JUDICIAL);
            objActividad.ID_ESTADO_ACCION_JUDICIAL = objself.MAP_ID_ESTADO_ACCION_JUDICIAL;
            cambioAccion = true;
        }
        
        if(objself.MAP_ID_ESTADO_APUD_ACCION_JUDICIAL != objActividad.ID_ESTADO_APUD_ACCION_JUDICIAL) {
            await accionJudicialHistoricoEstadoApudGuardar(objActividad.ID, objActividad.ID_ESTADO_APUD_ACCION_JUDICIAL, objself.MAP_ID_ESTADO_APUD_ACCION_JUDICIAL);
            objActividad.ID_ESTADO_APUD_ACCION_JUDICIAL = objself.MAP_ID_ESTADO_APUD_ACCION_JUDICIAL;
            cambioApud = true;
        }
        
        if(objself.MAP_ID_VIABILIDAD_ESTUDIO != objself.ID_VIABILIDAD_ESTUDIO) {
            objActividad.ID_VIABILIDAD_ESTUDIO = objself.MAP_ID_VIABILIDAD_ESTUDIO;
        }
        
        
        objActividad.OBSERVACIONES = objself.MAP_OBSERVACIONES;
        objActividad.URL_ACCION_JUDICIAL = objself.MAP_URL;
        
        await objActividad.save();
        
        // generamos actualizaciones si procede
        if(cambioApud) {
            await generarActualizacionAccionJudicial(objself, idactividadCliente, "apud");
        }
        if(cambioAccion) {
            await generarActualizacionAccionJudicial(objself, idactividadCliente, "accion");
        }
        
        
        ui.showToast("Registro actualizado");
        
        await actualizarDatosPaginadoLeads(objself,"DeudaClienteAccionesJudiciales","DeudaClienteAccionesJudicialesContador","MAP_PAG_INI","MAP_PAG_LEN","MAP_TOTAL_REGISTROS","MAP_T1");
        limpiarCampos(objself,"editarActividadDeudaAccionJudicial");
        objself.MAP_VER_DETALLE_ACTIVIDAD = 0;
    }else {
        ui.showToast("No se ha encontrado la actividad asociada a la acción judicial");
        return;
    }
}

async function crearActividadClienteMonitorio(objself, idactividadcliente) {
    
    // Fecha actual y crear una nueva fecha sumando 20 días laborables para la fecha límite
    let fecha = ObtenerFechaHoraActual();
    
    let fechaInicio = new Date(fecha);
    let fechaMas20Dias = sumarDiasLaborables(fechaInicio, 20, {agostoLaborable: true,navidadLaborable: true});
    
    
    // deuda seleccionada para obtener el id
    let cntEntidad= await objself.getContents("EntidadesDeudaClienteJudicialActividades");
    let idDeudaCliente = "";
    
    for(var i=0; i < cntEntidad.count(); i++){
        let item = cntEntidad.getItem(i);
        if(item.MAP_SELECCIONAR == 1){
            idDeudaCliente = item.ID;
        }
    }
    
    // usuario responsable por defecto y obtenemos su id
    let usuarioResponsable = 'laura.lopez@aliviafinance.com';

    let collUsu = appData.getCollection("UsuariosScript");
    await filtrarCollMacroObject(collUsu,"u.LOGIN='" + usuarioResponsable + "'");
    
    if(collUsu.count() === 0) {
        await ui.msgBox("no se ha encontrado el usuario responsable para este correo: " + usuarioResponsable,"Usuario no encontrado",0);
        return;
    }
    let objUsu = collUsu.getItem(0);
    
    // identificador del monitorio
    let valores = await generarIdentificadorActividadDemandaMonitorio(0, 1);
    let identificador = valores.identificador;
    let contador = valores.contador;
    
    // creamos la actividad de monitorio recibido a partir de la actividad principal
    let collMonitorio = appData.getCollection("ActividadesClienteMonitorioScript");
    let objMonitorio = await collMonitorio.createObject();
    
    objMonitorio.IDACTIVIDADCLIENTE = idactividadcliente;
    objMonitorio.IDDEUDACLIENTE = idDeudaCliente;
    objMonitorio.IDENTIFICADOR = valores.identificador;
    objMonitorio.NUMERO_IDENTIFICADOR = valores.contador;
    objMonitorio.FECHA_RECEPCION = fecha;
    objMonitorio.FECHA_LIMITE = fechaMas20Dias;
    objMonitorio.IDUSUARIO_RESPONSABLE = objUsu.ID;
    objMonitorio.IDESTADO_MONITORIO = 1;
    
    await objMonitorio.save();
}

async function generarIdentificadorActividadDemandaMonitorio(tipoAccion, monitorio){
    // Generamos el identificador para actividades de demanda y monitorio
    // Obtenemos el  número de identificador buscando el último existente y le sumamos 1 para generar uno nuevo
    
    var identificador,campoContador,cadenaIdentificador,numero,Contador = 1,coll;
    var guardado = 0;
    var fecha = new Date();
	var yy = safeToString(fecha.getFullYear()).substring(2,4);
    
    if(monitorio == 1) {
        // para monitorio
        coll = appData.getCollection("ActividadesClienteMonitorioContadorIdentificador");
        campoContador = "NUMERO_IDENTIFICADOR";
        cadenaIdentificador = "M";
        
    } else {
        // para demanda
        // Oposición
        if(tipoAccion == 1){
            coll = appData.getCollection("DeudaClienteDemandaContadorOposicion");
            campoContador = "NUMERO_OPOSICION";
            cadenaIdentificador = "OPO";
        }
        //  Demanda
        else if(tipoAccion == 2){
            coll = appData.getCollection("DeudaClienteDemandaContadorDemanda");
            campoContador = "NUMERO_DEMANDA";
            cadenaIdentificador = "DEM";
        }
    	// Diligencia
        else if(tipoAccion == 3){
            coll = appData.getCollection("DeudaClienteDemandaContadorDiligencia");
            campoContador = "NUMERO_DILIGENCIA";
            cadenaIdentificador = "DIL";
        }
    }

    await coll.loadAll();
    if(coll.getItem(0)!==undefined && coll.getItem(0)!==null){
        if(safeToInt(coll.getItem(0)[campoContador]) === 0){
            Contador = 1;
        }else{
            Contador = coll.getItem(0)[campoContador] + 1;
        }
    }
    
	
    if(safeToInt(Contador)>0 && safeToInt(Contador) <= 9){
        // identificador entre el 1 y el 9
        numero = '0000'+Contador;
    }else if(safeToInt(Contador)>=10 && safeToInt(Contador) <= 99){
        // identificador entre el 10 y el 99
        numero = '000'+Contador;
    }else if(safeToInt(Contador)>=100 && safeToInt(Contador) <= 999){
        // identificador entre el 100 y el 999
        numero = '00'+Contador;
    }else if(safeToInt(Contador)>=1000 && safeToInt(Contador) <= 9999){
        // identificador entre el 1000 y el 9999
        numero = '0'+Contador;
    }else{
        // identificador por encima del 10000
        numero = Contador;
    }
    coll.clear();
    
    identificador = cadenaIdentificador + yy + numero;
    
    return {
        identificador: identificador,
        contador: Contador
    };
}

function asignarValoresPlazoMonitorio(plazo) {
    // En función de los días transcurridos, asignamos unos valores en el monitorio
    switch (true) {
        case (plazo >= 0 && plazo <= 7):
            return {texto: "En plazo", colorFondo: "#adf0c7"};
        case (plazo >= 8 && plazo <= 12):
            return {texto: "Peligro", colorFondo: "#fe9f4d"};
        case (plazo >= 13 && plazo <= 19):
            return {texto: "Solucionar YA", colorFondo: "#ff6464"};
        case (plazo >= 20):
            return {texto: "Fuera de plazo", colorFondo: "#bd0a0a"};
        default:
            return {texto: "-", colorFondo: "#F2F2F2"};
    }
}

async function vincularOposicionMonitorio(objself) {
    if(safeToInt(objself.MAP_IDDEUDACLIENTE_DEMANDA) > 0){
	    ui.showToast("Ya existe una oposición vinculada al monitorio");
	}
	
    // buscamos la oposición para la deuda del monitorio
    let collDeudaDemanda = appData.getCollection("DeudaClienteDemandaScript");
    await filtrarCollMacroObject(collDeudaDemanda,"cd.IDDEUDACLIENTE = " + objself.MAP_IDDEUDA + " AND cd.IDENTIFICADOR like 'OPO%'");
    
    if(collDeudaDemanda.count() > 0) {
        let objDeudaDemanda = collDeudaDemanda.getItem(0);
        
        let collMonitorio = appData.getCollection("ActividadesClienteMonitorioScript");
        await filtrarCollMacroObject(collMonitorio,"ca.ID=" + objself.MAP_IDMONITORIO);
        
        // guardamos en el monitorio la oposición de la deuda asociada
        if(collMonitorio.count() > 0) {
            let objMonitorio = collMonitorio.getItem(0);
                
            objMonitorio.IDDEUDACLIENTE_DEMANDA = objDeudaDemanda.ID;
            await objMonitorio.save();
            objself.MAP_OPOSICION_VINCULADA = objDeudaDemanda.IDENTIFICADOR;

            objself.MAP_ESTADO_OPOSICION_APUD = objDeudaDemanda.MAP_ESTADO_APUD;
            objself.MAP_ESTADO_ACCION_DEMANDA = objDeudaDemanda.MAP_ESTADO_ACCION;
            objself.MAP_IDDEUDACLIENTE_DEMANDA = objDeudaDemanda.ID;
        }
        
    } else {
        ui.showToast("No existe una oposición para la deuda");
    }
}

async function agregarDocumentoActividadGuardar(objself,documento,tipo,tipoDoc,idactividad, correoCliente, rowidlead, idDocumentoBorrar){
    // función para subir los documentos del cliente para las actividades de la pestaña actividades
    let fileName = "";
    let file = objself.getOwnerCollection().getVariables("File");
    var coll = appData.getCollection("DocumentoScript");
    
    // en el caso de un monitorio, como podemos reemplazar el documento, borramos el que existe previamente
    if(tipo == 33) {
        let sufijo = await obtenerVersionDocumento(objself,tipo,rowidlead);
        documento = file.name.split('.')[0] + sufijo + "." + file.name.split('.')[1];
        await borrarDocumento(objself,idDocumentoBorrar,'Documento', true);
    }
    
    
    if(isNothing(file)){
        await ui.msgBox("Debe adjuntar el documento que quiere subir","Falta documento",0);
        return;
    }
    if(isNullOrEmpty(documento)){
        await ui.msgBox("Debe adjuntar el documento que quiere subir","Falta documento",0);
        return;
    }
    
    if(isNullOrEmpty(documento)===false){
        fileName =documento;
    }
    
    //  Comprobamos si para este cliente existe un documento con el mismo nombre
    if(fileName !== ""){
        await filtrarCollMacroObject(coll,"d.BAJA=0 AND d.DOCUMENTO='"+fileName+"' AND d.ROWID_LEAD='"+rowidlead+"'");
    }else{
        await filtrarCollMacroObject(coll,"d.BAJA=0 AND d.DOCUMENTO='"+file.name+"' AND d.ROWID_LEAD='"+rowidlead+"'");
    }
    
    if(coll.count() > 0){
        await ui.msgBox("Ya existe un documento con el nombre indicado. Especifique otro distinto.","Archivo duplicado",0);
        return;
    }
    
    // subimos el archivo
    await uploadFiles(objself, file, fileName, tipo, correoCliente, user.CORREO, user.LOGIN, tipoDoc, rowidlead, 0,0,0,0,idactividad);
}

async function solicitarDevolucion(objself,idactividad,tipoActividad){
    // Hacemos referencia a la coll clienteEdicion la cual contiene este content
    let padre = objself.getParent();
    let fecha=ObtenerFechaHoraActual();
    let PrimeraAportacion;
    
    // Solicitamos la devolución al cliente de la primera aportaión que ha hecho
    // Comprobamos si ya ha generado la devolución y está pendiente
    var collMov = appData.getCollection("MovimientosScript");
    await filtrarCollMacroObject(collMov,"m.IDACTIVIDAD="+idactividad+" and m.IDLEAD="+padre.ID+" and m.IDTIPO_MOVIMIENTO=5 AND m.IDESTADO IN(3,4)");
    
    if(collMov.count()>0){
        ui.showToast("Ya existe una devolución pendiente asociada a la actividad. Revise el apartado de movimientos");
        return;
    }
    
    let pregunta= await ui.msgBox("¿Está seguro que desea solicitar la devolución?","Devolución baja pre14",1);
    if(pregunta==1){

        // generamos el movimiento para la devolución
        let MovCrear = appData.getCollection("Movimientos");
        let objMov = await MovCrear.createObject();
        objMov.IDACTIVIDAD=idactividad;
        objMov.IDLEAD=padre.ID;
        objMov.IDTIPO_MOVIMIENTO=5;
        objMov.FECHA_SOLICITUD= fecha;
        objMov.IDESTADO=3;
        objMov.IBAN= objself.IBAN;
        
        // Devolución de saldo y Solicitud de baja devolvemos el valor del importe indicado en la actividad
        if(tipoActividad==6 || tipoActividad==7){
            objMov.BASE_IMPONIBLE = round(objself.IMPORTE/1.21,2);
            objMov.IVA = round(objself.IMPORTE - (objself.IMPORTE/1.21),2);
            objMov.IMPORTE= objself.IMPORTE;
        }
        // BajaPre14 devolvemos el valor de la primera aportación
        if(tipoActividad==8){
            var collMovDev = appData.getCollection("MovimientoContadorPrimeraAportacion");
            await filtrarCollMacroObject(collMovDev,"IDLEAD="+padre.ID+" and IDTIPO_MOVIMIENTO=4 AND IDESTADO=1");
            if(collMovDev.count()>0){
                PrimeraAportacion=collMovDev.getItem(0);
                
                objMov.BASE_IMPONIBLE = round(PrimeraAportacion.IMPORTE/1.21,2);
                objMov.IVA = round(PrimeraAportacion.IMPORTE - (PrimeraAportacion.IMPORTE/1.21),2);
                objMov.IMPORTE= PrimeraAportacion.IMPORTE;
            }
        }

        await objMov.save();
        
        // Generamos y guardamos el identificador del movimiento (devolución)
        await generarIdentificadorMovimiento(5,objMov.ID);
        await actualizarDatosPaginadoLeads(padre,"ActividadesCliente","ActividadesClienteContador","MAP_PAG_INI_ACT","MAP_PAG_LEN_ACT","MAP_TOTAL_REGISTROS_ACT","MAP_T1_ACT");
        
        // actualizamos el content de actividad hijo según el tipo
        if(tipoActividad == 6) {
            await actualizarDatosContent(padre,"ActividadesClienteHijoSolicitudDevolucion");
        }
        else if(tipoActividad == 7) {
            await actualizarDatosContent(padre,"ActividadesClienteHijoSolicitudBaja");
        }
        else if(tipoActividad == 8) {
            await actualizarDatosContent(padre,"ActividadesClienteHijoSolicitudBajaPre14");
        }
        
        ui.showToast("Movimiento de devolución creado. Por favor, revise el apartado de movimientos");
    }else{
        return;
    }
}

async function solicitarComisionMensual(objself,idactividad,tipoActividad){
    // hacemos referencia a la coll clienteEdicion la cual contiene este content
    let padre = self.getParent();
    var fecha = ObtenerFechaHoraActual();
    let duracionMeses = 0;
    
    if(objself.MAP_IMPORTE_COMISION <= 0 || objself.MAP_IMPORTE_COMISION == null){
        await ui.msgBox("Debe indicar un importe","Falta importe",0);
        return;
    }
    // Solicitamos el cobro de la comisión mensual
    // Comprobamos si ya ha generado el cobro y está pendiente
    var collMov = appData.getCollection("MovimientosScript");
    await filtrarCollMacroObject(collMov,"m.IDACTIVIDAD="+idactividad+" and m.IDLEAD="+padre.ID+" and m.IDTIPO_MOVIMIENTO=2 AND m.IDESTADO IN(5,7)");
    
    if(collMov.count()>0){
        ui.showToast("Ya existe una comisión mensual pendiente asociada a la actividad. Revise el apartado de movimientos");
        return;
    }
    
    let pregunta= await ui.msgBox("¿Está seguro que desea solicitar la comisión mensual?","Comisión mensual",1);
    if(pregunta==1){
        // generamos el movimiento para la devolución
        let MovCrear = appData.getCollection("Movimientos");
        let objMov = await MovCrear.createObject();
        objMov.IDACTIVIDAD = idactividad;
        objMov.IDLEAD = padre.ID;
        objMov.IDTIPO_MOVIMIENTO = 2;
        objMov.FECHA_SOLICITUD = fecha;
        objMov.IDESTADO = 5;
        
        // bucamos las comisiones mensuales según el mes en el programa y aplicamos el porcentaje sobre la deuda total
        let collComisiones = appData.getCollection("ComisionesScript");
        collComisiones.setFilter("GRUPO_PAQUETE_COMISION="+padre.GRUPO_PAQUETE_COMISION);
        collComisiones.clear();
        await collComisiones.loadAll();

        
        for(var i = 0; i < collComisiones.count(); i++){
            let item = collComisiones.getItem(i);
            duracionMeses = duracionMeses + item.DURACION_MES;
            if(padre.MAP_MESES_PROGRAMA <= duracionMeses){
                
                // calcular deuda_inicial * porcentaje correspondiente. Depende de los meses que lleve en el programa
                // si marcamos el importe a mano, cogemos ese valor, si no, por defecto según el mes
                if(objself.MAP_IMPORTE_COMISION > 0){
                    objMov.IMPORTE= objself.MAP_IMPORTE_COMISION;
                    objMov.BASE_IMPONIBLE = round(objMov.IMPORTE/1.21,2);
                    objMov.IVA = round(objMov.IMPORTE - (objMov.IMPORTE/1.21),2);
                }else{
                    
                    objMov.IMPORTE= round(objself.MAP_DEUDA_INICIAL_CLIENTE*(item.PORCENTAJE/100),2);
                    objMov.BASE_IMPONIBLE = round(objMov.IMPORTE/1.21,2);
                    objMov.IVA = round(objMov.IMPORTE - (objMov.IMPORTE/1.21),2);
                }
                
                // comprobamos si el cliente tiene saldo suficiente para pagar la cuota. Si no tiene, cancelamos la generación del movimiento
                if(padre.MAP_SALDO < objMov.IMPORTE){
                    await ui.msgBox("El cliente no cuenta con saldo suficiente. Dispone de un saldo de "+padre.MAP_SALDO+"€ para una comisión de "+objMov.IMPORTE+"€","Saldo insuficiente",0);
                    return;
                }
                
                break;
            }
        }
        // guardamos el importe en la actividad para que persista
        objself.IMPORTE = objself.MAP_IMPORTE_COMISION;
        await objself.save();
        await objMov.save();
        
        // Generamos y guardamos el identificador del movimiento (devolución)
        await generarIdentificadorMovimiento(2,objMov.ID);
        await actualizarDatosPaginadoLeads(padre,"ActividadesCliente","ActividadesClienteContador","MAP_PAG_INI_ACT","MAP_PAG_LEN_ACT","MAP_TOTAL_REGISTROS_ACT","MAP_T1_ACT");
        await actualizarDatosContent(padre,"ActividadesClienteHijoComisionMensual");
        
        ui.showToast("Movimiento de comisión mensual creado. Por favor, revise el apartado de movimientos");
    }else{
        return;
    }
}

async function marcarBajaCliente(objself){
    // Hacemos referencia a la coll clienteEdicion la cual contiene este content
    let padre = objself.getParent();
    var fecha = ObtenerFechaHoraActual();
    
    if(padre.IDESTADO_CLIENTE == 9) {
        ui.showToast("El cliente ya está de baja");
        return;
    }
    
    let pregunta = await ui.msgBox("¿Está seguro que desea marcar el cliente como baja? Se cancelará también la suscripción que tenga activa","Baja cliente",1);
    if(pregunta==1){
        var collEstado = appData.getCollection("EstadosCliente");
        await filtrarCollMacroObject(collEstado,"CODIGO=9");
    
        let Estado = collEstado.getItem(0);
        if(Estado){
            await guardarHistoricoCambioEstadoCliente(padre,padre.IDESTADO_CLIENTE,Estado.CODIGO);
            padre.IDESTADO_CLIENTE = Estado.CODIGO;
            padre.BAJA = 1;
            padre.MAP_BAJA = 1;
            padre.FECHA_BAJA = fecha;
            padre.MAP_COLOR_ETAPA_BG = Estado.COLOR;
            padre.MAP_ETAPA = Estado.NOMBRE;
            padre.FECHA_PAGO_TRANSFERENCIA = null;
            await padre.save();
            
            objself.ESTADO = 1;
            await objself.save();
            
        }else{  // cierre if(Estado)
            ui.showToast("error al pasar a la etapa 'baja'");
        }
        
        // buscamos si tiene alguna suscripción activa
        var collSub = appData.getCollection("PagosSuscripcion");
        await filtrarCollMacroObject(collSub,"IDCLIENTE="+padre.ID);
        
        if(collSub.count()>0){
            borrarSuscripcion(padre,padre.CORREO,function() {ui.showToast("Suscripción borrada");},function() {ui.showToast("No ha sido posible borrar la suscripción");});
        }
        
        await actualizarDatosPaginadoLeads(padre,"ActividadesCliente","ActividadesClienteContador","MAP_PAG_INI_ACT","MAP_PAG_LEN_ACT","MAP_TOTAL_REGISTROS_ACT","MAP_T1_ACT");
        await actualizarDatosContent(padre,"ActividadesClienteHijoBajaCliente");
    }
}
  
async function marcarPausaCliente(objself){
    // Hacemos referencia a la coll clienteEdicion la cual contiene este content
    let padre = objself.getParent();
    var fecha = ObtenerFechaHoraActual();
    
    if(padre.IDESTADO_CLIENTE == 7) {
        ui.showToast("El cliente ya está en pausa");
        return;
    }
    
    let pregunta = await ui.msgBox("¿Está seguro que desea marcar el cliente como pausa? Se cancelará también la suscripción que tenga activa","Pausa cliente",1);
    if(pregunta == 1){
        var collEstado = appData.getCollection("EstadosCliente");
        await filtrarCollMacroObject(collEstado,"CODIGO=7");
    
        let Estado = collEstado.getItem(0);
        if(Estado){
            await guardarHistoricoCambioEstadoCliente(padre,padre.IDESTADO_CLIENTE,Estado.CODIGO);
            await guardarEstadoClientePausa(objself,padre);
            
            padre.IDESTADO_CLIENTE = Estado.CODIGO;
            padre.MAP_ETAPA = Estado.NOMBRE;
            padre.MAP_COLOR_ETAPA_BG = Estado.COLOR;
            await padre.save();
            
            objself.ESTADO = 1;
            await objself.save();
        }else{
            ui.showToast("error al pasar a la etapa 'pausa'");
        }
        
        // buscamos si tiene alguna suscripción activa
        var collSub = appData.getCollection("PagosSuscripcion");
        await filtrarCollMacroObject(collSub,"IDCLIENTE="+padre.ID);
        
        if(collSub.count()>0){
            borrarSuscripcion(padre,padre.CORREO,function() {ui.showToast("Suscripción borrada");},function() {ui.showToast("No ha sido posible borrar la suscripción");});
        }
        
        await actualizarDatosPaginadoLeads(padre,"ActividadesCliente","ActividadesClienteContador","MAP_PAG_INI_ACT","MAP_PAG_LEN_ACT","MAP_TOTAL_REGISTROS_ACT","MAP_T1_ACT");
        await actualizarDatosContent(objself,"ActividadesClienteHijoPausaManualCliente");
    }
}

async function marcarReactivacionCliente(objself){
    // Hacemos referencia a la coll clienteEdicion la cual contiene este content
    let padre = objself.getParent();
    var fecha = ObtenerFechaHoraActual();
    
    let pregunta= await ui.msgBox("¿Está seguro que desea reactivar el cliente? Se le asignará la etapa 'en proceso'","Reactivar cliente",1);
    if(pregunta==1){
        var collEstado= appData.getCollection("EstadosCliente");
        await filtrarCollMacroObject(collEstado,"CODIGO=2");
    
        let Estado = collEstado.getItem(0);
        if(Estado){
            await guardarHistoricoCambioEstadoCliente(padre,padre.IDESTADO_CLIENTE,Estado.CODIGO);
            await guardarEstadoClienteReanudar(padre);
            
            padre.IDESTADO_CLIENTE = Estado.CODIGO;
            padre.MAP_ETAPA = Estado.NOMBRE;
            padre.MAP_COLOR_ETAPA_BG = Estado.COLOR;
            await padre.save();
            
            objself.ESTADO = 1;
            await objself.save();
        }else{
            ui.showToast("error al pasar a la etapa 'en proceso'");
        }
        await actualizarDatosPaginadoLeads(padre,"ActividadesCliente","ActividadesClienteContador","MAP_PAG_INI_ACT","MAP_PAG_LEN_ACT","MAP_TOTAL_REGISTROS_ACT","MAP_T1_ACT");
        await actualizarDatosContent(padre,"ActividadesClienteHijoReactivarCliente");
    }
}


async function obtenerImporteDeudadAddendum(objself,IDLEAD){
    let total=0;
    var coll = appData.getCollection("DeudaClienteAddendumScript");
    await filtrarCollMacroObject(coll,"d.IDLEAD="+IDLEAD+" AND ifnull(d.BAJA,0)=0 AND ifnull(d.ADDENDUM_REALIZADO,0)=0 AND d.APLICA_PL=1");
    for(let i=0;i<coll.count();i++){
        total=total + coll.getItem(i).IMPORTE_ACTUAL; 
    }
    objself.MAP_DEUDA_TOTAL=round(total,2)+" €";
}

// function annadirDeudadAddendum(objself){
//     // en este caso la coll padre es clienteEdicion
//     let padre = self.getParent();
    
    
//     var collD = appData.getCollection("DeudaClienteScript");
//     var collAd = appData.getCollection("DeudaClienteAddendumScript");
//     var collDoc = appData.getCollection("DocumentoScript");
    
//     // Buscamos las deudas del cliente que no se hayan añadido al addendum
//     filtrarCollMacroObject(collD,"d.IDLEAD="+padre.ID+" AND ifnull(d.ANNADIDO_ADDENDUM,0)=0 AND ifnull(d.LIQUIDADA,0)=0 AND ifnull(d.BAJA,0)=0");
//     if(collD.count()>0){
//         ui.showToast("añadiendo deudas al addendum...");
//         // si tenemos deudas para añadir al addendum, las añadimos
//         for(var i=0; i<collD.count();i++){
//             let objD = collD.getItem(i);
//             if(objD){
//                 let objAd = collAd.createObject();
//                 objAd.IDDEUDACLIENTE = objD.ID;
//                 objAd.IDLEAD = objD.IDLEAD;
//                 objAd.BAJA = 0;
//                 objAd.IDENTIDAD = objD.IDENTIDAD;
//                 objAd.IMPORTE_ACTUAL = objD.IMPORTE_ACTUAL;
//                 objAd.IDPRODUCTO_FINANCIERO = objD.IDPRODUCTO_FINANCIERO;
//                 if(objD.IDPRODUCTO_FINANCIERO==1){
//                     objAd.MES_OTORGAMIENTO = 0;
//                 }else{
//                     objAd.MES_OTORGAMIENTO = objD.MES_SOLUCION;
//                 }
//                 objAd.APLICA_PL = 1;
//                 objAd.COMPROBANTE = objD.COMPROBANTE;
//                 objAd.IDTIPO_PRODUCTO = objD.IDTIPO_PRODUCTO;
//                 objAd.FECHA_ACTUALIZACION = objD.FECHA_ACTUALIZACION;
//                 objAd.FECHA_ULT_PAGO = objD.FECHA_ULT_PAGO;
//                 objAd.SITUACION_DEUDA = objD.SITUACION_DEUDA;
//                 objAd.ADDENDUM_REALIZADO = 0;
                
//                 // Buscamos si la deuda original tiene un comprobante asociado
//                 filtrarCollMacroObject(collDoc,"d.BAJA=0 AND d.ROWID_LEAD='"+padre.ROWID+"' AND d.IDTIPO=5 AND d.IDDEUDACLIENTE="+objD.ID);
//                 if(collDoc.count() > 0){
//                     let objDoc = collDoc.getItem(0);
//                     objAd.IDDOCUMENTO = objDoc.ID;
//                 }
                
//                 objAd.save();
                
//                 // Marcamos la deuda como añadida
//                 objD.ANNADIDO_ADDENDUM = 1;
//                 objD.save();
//             }
//         }
//     }
    
    
//     // padre.MAP_MOSTRAR_CALCULO = 1;
//     actualizarDatosContent(padre,"DeudaClienteAddendum");
//     obtenerImporteDeudadAddendum(padre,padre.ID);
//     // padre.MAP_MOSTRAR_CALCULO = 0;
    
//     // asignamos al padre (clienteEdicion) el valor del id de la actividad del addendum
//     padre.MAP_IDACTIVIDAD = objself.ID;
//     padre.MAP_CREAR_ADDENDUM = 1;
// }

async function annadirDeudadAddendum(objself){
    // Evitar ejecuciones concurrentes (Doble clic)
    if (safeToInt(objself.MAP_PROCESANDO) == 1) {
        return;
    }
    objself.MAP_PROCESANDO = 1;

    let padre = self.getParent();
    
    var collD = appData.getCollection("DeudaClienteScript");
    var collAd = appData.getCollection("DeudaClienteAddendumScript");
    var collDoc = appData.getCollection("DocumentoScript");
    
    // Colección auxiliar para verificar si ya fue añadida
    var collCheck = appData.getCollection("DeudaClienteAddendumScript");
    
    await filtrarCollMacroObject(collD,"d.IDLEAD="+padre.ID+" AND ifnull(d.ANNADIDO_ADDENDUM,0)=0 AND ifnull(d.LIQUIDADA,0)=0 AND ifnull(d.BAJA,0)=0");
    if(collD.count()>0){
        ui.showToast("añadiendo deudas al addendum...");
        
        for(var i=0; i<collD.count();i++){
            let objD = collD.getItem(i);
            if(objD){
                // Comprobamos si ya existe la deuda en el addendum (evita duplicados si falló el guardado del flag)
                await filtrarCollMacroObject(collCheck, "d.IDDEUDACLIENTE=" + objD.ID + " AND ifnull(d.BAJA,0)=0 AND ifnull(d.ADDENDUM_REALIZADO,0)=0");
                if (collCheck.count() > 0) {
                    // Si ya existe en el addendum, solo nos aseguramos de marcar el flag en la deuda original
                    objD.ANNADIDO_ADDENDUM = 1;
                    await objD.save();
                    continue;
                }

                let objAd = await collAd.createObject();
                objAd.IDDEUDACLIENTE = objD.ID;
                objAd.IDLEAD = objD.IDLEAD;
                objAd.BAJA = 0;
                objAd.IDENTIDAD = objD.IDENTIDAD;
                objAd.IMPORTE_ACTUAL = objD.IMPORTE_ACTUAL;
                objAd.IDPRODUCTO_FINANCIERO = objD.IDPRODUCTO_FINANCIERO;
                if(objD.IDPRODUCTO_FINANCIERO==1){
                    objAd.MES_OTORGAMIENTO = 0;
                }else{
                    objAd.MES_OTORGAMIENTO = objD.MES_SOLUCION;
                }
                objAd.APLICA_PL = 1;
                objAd.COMPROBANTE = objD.COMPROBANTE;
                objAd.IDTIPO_PRODUCTO = objD.IDTIPO_PRODUCTO;
                objAd.FECHA_ACTUALIZACION = objD.FECHA_ACTUALIZACION;
                objAd.FECHA_ULT_PAGO = objD.FECHA_ULT_PAGO;
                objAd.SITUACION_DEUDA = objD.SITUACION_DEUDA;
                objAd.ADDENDUM_REALIZADO = 0;
                
                await filtrarCollMacroObject(collDoc,"d.BAJA=0 AND d.ROWID_LEAD='"+padre.ROWID+"' AND d.IDTIPO=5 AND d.IDDEUDACLIENTE="+objD.ID);
                if(collDoc.count() > 0){
                    let objDoc = collDoc.getItem(0);
                    objAd.IDDOCUMENTO = objDoc.ID;
                }
                
                await objAd.save();
                
                objD.ANNADIDO_ADDENDUM = 1;
                await objD.save();
            }
        }
    }
    
    await actualizarDatosContent(padre,"DeudaClienteAddendum");
    await obtenerImporteDeudadAddendum(padre,padre.ID);
    
    padre.MAP_IDACTIVIDAD = objself.ID;
    padre.MAP_CREAR_ADDENDUM = 1;
    
    objself.MAP_PROCESANDO = 0;
}

async function asignarIdDocumentoDeudaAddendum(objself,file,fileName,rowid_lead,iddeuda){
    // asignamos el id del documento subido al mes correspondiente del plan de pagos de una deuda con producto fraccionado

    var objDeuda,objDoc,objself;
    var collDoc = appData.getCollection("DocumentoScript");
    
    var collDeuda = appData.getCollection("DeudaClienteAddendumScript");
    await filtrarCollMacroObject(collDeuda,"d.ID="+iddeuda);
    
    if(collDeuda.count()>0){
        objDeuda = collDeuda.getItem(0);
        
        if(fileName!==""){
            await filtrarCollMacroObject(collDoc,"d.BAJA=0 AND d.DOCUMENTO='"+fileName+"' AND d.ROWID_LEAD='"+rowid_lead+"'");
        }else{
            await filtrarCollMacroObject(collDoc,"d.BAJA=0 AND d.DOCUMENTO='"+file.name+"' AND d.ROWID_LEAD='"+rowid_lead+"'");
        }
        if(collDoc.count()>0){

            objDoc = collDoc.getItem(0);
            
            objDeuda.IDDOCUMENTO=objDoc.ID;
            objDeuda.COMPROBANTE=objDoc.DOCUMENTO;
            await objDeuda.save();

            await actualizarDatosContent(objself,"DeudaClienteAddendum");
        }
    }
}

function comprobarDeudaAnnadidaAddendum(objself){
    // Si al editar una deuda del addendum viene incorporada del programa, bloqueamos su edición
    if(objself.IDDEUDACLIENTE > 0){
        objself.setFieldPropertyValue("MAP_ENTIDAD_ED","bgcolor","#D2D2D2");
        objself.setFieldPropertyValue("MAP_TIPO_PROD_ED","bgcolor","#D2D2D2");
        objself.setFieldPropertyValue("IMPORTE_ACTUAL","bgcolor","#D2D2D2");
        objself.setFieldPropertyValue("FECHA_ACTUALIZACION","bgcolor","#D2D2D2");
        objself.setFieldPropertyValue("FECHA_ULT_PAGO","bgcolor","#D2D2D2");
        objself.setFieldPropertyValue("MAP_SITUACION_ED","bgcolor","#D2D2D2");
        objself.setFieldPropertyValue("MAP_PROD_ED","bgcolor","#D2D2D2");
    }
}

async function confirmarAddendum(objself, correo, rowidlead){
    
    var idDocumento=0;
    
    let pregunta= await ui.msgBox("¿Está seguro que desea confirmar el addendum realizado?","Confirmar addendum",1);
    if(pregunta==1){
        
        // buscamos el id del documento del addendum aceptado
        var collDoc = appData.getCollection("DocumentoScript");
        await filtrarCollMacroObject(collDoc,"d.BAJA=0 AND d.ROWID_LEAD='"+rowidlead+"' AND d.IDACTIVIDADCLIENTE="+objself.ID+" AND d.IDTIPO=24 AND d.ACEPTADO=1 AND d.DOCUMENTO_FIRMADO=1");

        if(collDoc.count() > 0){
            let item = collDoc.getItem(0);
            idDocumento = item.ID;
            
            // una vez tenemos el documento, llamamos para confirmar los cambios en la adenda
            try{
                callApiPost(objself,"accept_addendum","",{
                    EMAIL: correo,
                    IDDOCUMENTO: idDocumento
                },user.MAP_TOKEN,
                function(objself,data){
                    // Marcamos la actividad como completa
                    objself.ESTADO = 1;
                    objself.save();
                    
                    let padre = objself.getParent();
                    // let abuelo = padre.getParent();
                    actualizarDatosPaginadoLeads(padre,"ActividadesCliente","ActividadesClienteContador","MAP_PAG_INI_ACT","MAP_PAG_LEN_ACT","MAP_TOTAL_REGISTROS_ACT","MAP_T1_ACT");
                    // marcarEstadoActividad(objself,1);
                    
                    ui.msgBox("El addendum se ha realizado correctamente","Confirmar addendum",0);
                },function(objself,data){
                    ui.showToast("Error al confirmar el addendum");
                });
            } catch(e){
                ui.showToast("Ha ocurrido un error. Por favor, compruebe su conexión a internet e inténtelo nuevamente.");
            }
        }else{
            ui.showToast("No se encuentra el documento firmado asociado a la adenda");
        }
    }
}

async function eliminarAddendum(objself, idlead, rowidlead) {
    
    let pregunta = await ui.msgBox("¿Está seguro que desea borrar el addendum en curso? Este proceso no se podrá deshacer","Eliminar addendum",1);

    if(pregunta == 2) {
        return;
    }
    ui.showToast("Rechazando addendum...");
    
    // buscamos los documentos asociados, contrato y plan. Los rechazamos y damos de baja
    let collDoc = appData.getCollection("DocumentoScript");
    await filtrarCollMacroObject(collDoc,"d.BAJA=0 AND d.ROWID_LEAD='"+rowidlead+"' AND d.IDACTIVIDADCLIENTE="+objself.ID+" AND d.IDTIPO in(23,24)");

    if(collDoc.count() > 0){
        for( var i=0; i < collDoc.count(); i++) {
            let item = collDoc.getItem(i);
            item.DOCUMENTO_VISIBLE = 0;
            item.ACEPTADO = 2;
            item.BAJA = 1;
            await item.save();
        }
    }
    
    // buscamos las deudas añadidas al addendum y las marcamos como realizadas
    let collDeudaAddendum = appData.getCollection("DeudaClienteAddendumScript");
    await filtrarCollMacroObject(collDeudaAddendum,"ifnull(d.BAJA,0)=0 AND d.IDLEAD=" + idlead + " AND ifnull(d.ADDENDUM_REALIZADO,0)=0");

    if(collDeudaAddendum.count() > 0){
        for( var j=0; j < collDeudaAddendum.count(); j++) {
            let deudaAd = collDeudaAddendum.getItem(j);
            deudaAd.ADDENDUM_REALIZADO = 1;
            deudaAd.BAJA = 1;
            await deudaAd.save();
        }
    }
    
    // buscamos las deudas del cliente y las desmarcamos como añadidas al addendum
    let collDeuda = appData.getCollection("DeudaClienteScript");
    await filtrarCollMacroObject(collDeuda,"ifnull(d.BAJA,0)=0 AND d.IDLEAD=" + idlead + " AND ifnull(d.ANNADIDO_ADDENDUM,0)=1");

    if(collDeuda.count() > 0){
        for( var k=0; k < collDeuda.count(); k++) {
            let deuda = collDeuda.getItem(k);
            deuda.ANNADIDO_ADDENDUM = 0;
            await deuda.save();
        }
    }
    
    // marcamos la actividad como rechazada
    objself.ESTADO = 2;
    await objself.save();
    
    let padre = objself.getParent();
    await Promise.all([
        actualizarDatosPaginadoLeads(padre,"Documento","DocumentoContador","MAP_PAG_INI_DOC","MAP_PAG_LEN_DOC","MAP_TOTAL_REGISTROS_DOC","MAP_T1_DOC"),
        actualizarDatosPaginadoLeads(padre,"ActividadesCliente","ActividadesClienteContador","MAP_PAG_INI_ACT","MAP_PAG_LEN_ACT","MAP_TOTAL_REGISTROS_ACT","MAP_T1_ACT"),
    ]);
    await actualizarDatosContent(padre,"ActividadesClienteHijoAddendum");
}

async function generarIdentificadorDevolucionIntereses(objDevolucion){
    var numero,Contador,coll;
    var guardado = 0;
    var fecha = new Date();
	var yy = safeToString(fecha.getFullYear()).substring(2,4);
	
	do{
        try{
        	coll = appData.getCollection("ActividadesClienteHijoDevolucionInteresesContador");
            await coll.loadAll();
            if(coll.getItem(0)!==undefined && coll.getItem(0)!==null){
                if(safeToInt(coll.getItem(0).NUMERO_IDENTIFICADOR)==0){
                    Contador=1;
                }else{
                    Contador=coll.getItem(0).NUMERO_IDENTIFICADOR+1;
                }
            }
            
            if(safeToInt(Contador)>0 && safeToInt(Contador)<=9){
                // identificador entre el 1 y el 9
                numero = '0000'+Contador;
            }else if(safeToInt(Contador)>=10 && safeToInt(Contador)<=99){
                // identificador entre el 10 y el 99
                numero = '000'+Contador;
            }else if(safeToInt(Contador)>=100 && safeToInt(Contador)<=999){
                // identificador entre el 100 y el 999
                numero = '00'+Contador;
            }else if(safeToInt(Contador)>=1000 && safeToInt(Contador)<=9999){
                // identificador entre el 1000 y el 9999
                numero = '0'+Contador;
            }else{
                // identificador por encima del 10000
                numero = Contador;
            }
            coll.clear();
            
            
            // Guardamos el número de identificador y el número (campos únicos)
            objDevolucion.NUMERO_IDENTIFICADOR = Contador;
            objDevolucion.IDENTIFICADOR = "DEVAC"+yy+numero;
            await objDevolucion.save();
            guardado = 1;
                
        }catch(e){
            // si existe un nº de identificador duplicado, da error y seguimos iterando
            objDevolucion.IDENTIFICADOR = "";
            guardado = 0;
        }
    }while(guardado === 0);
}            


async function solicitarDevolucionIntereses(objself,idactividad,tipoMovimiento){
    // Hacemos referencia a la coll clienteEdicion la cual contiene este content
    let padre = objself.getParent();
    var fecha=ObtenerFechaHoraActual();
    let error = 0;
    let tipoMovimiento10 = tipoMovimiento === 10;
    
    
    // Solicitamos la devolución
    var collMov = appData.getCollection("MovimientosScript");
    
    var estados = {
        10 : " AND m.IDESTADO IN(5,1)",
        11 : " AND m.IDESTADO IN(5,4)"
    };
    
    // si generamos el movimiento tipo 11, de cliente comprobamos que se haya cobrado primero el 10, la de acreedor. Debe existir cobrado
    if(tipoMovimiento == 11){
        await filtrarCollMacroObject(collMov,"m.IDACTIVIDAD="+idactividad+" and m.IDLEAD="+padre.ID+" and m.IDTIPO_MOVIMIENTO=10 AND m.IDESTADO=1");
        
        
        if(collMov.count() === 0){
            ui.showToast("Debe generar/confirmar el pago de la devolución de intereses de acreedores. Genere el movimiento o revise el apartado de movimientos");
            return;
        }
    }
    
      // RESCATAR DEUDA ASOCIADA (ID) DEUDA_CLIENTE*
    if(safeToInt(objself.MAP_IDDEUDACLIENTE) === 0){
         ui.showToast("Debe indicar la deuda asociada");
        error ++;
     }
    
    // importe a recibir
    if(safeToInt(tipoMovimiento10 ? objself.IMPORTE_RECIBIR : objself.IMPORTE_DEVOLVER) === 0){
        ui.showToast("Debe indicar el importe");
        error ++;
    }
    
    if(isNullOrEmpty(tipoMovimiento10 ? objself.MAP_IBAN : objself.MAP_IBAN_CLIENTE)){
        ui.showToast("Debe indicar el iban");
        error ++;
    }

    // if(isNullOrEmpty(tipoMovimiento10 ? objself.MAP_CONCEPTO : objself.MAP_CONCEPTO_CLIENTE)){
    //     ui.showToast("Debe indicar el concepto");
    //     error ++;
    // }
    
     if(isNullOrEmpty(tipoMovimiento10 ? objself.MAP_BENEFICIARIO : objself.MAP_BENEFICIARIO_CLIENTE)){
        ui.showToast("Debe indicar el beneficiario");
        error ++;
    }

    // Comprobaciones de importe a devolver editable
    if(!isNullOrEmpty(objself.MAP_IMPORTE_DEVOLVER_EDITABLE)){
        if(!isNumber(objself.MAP_IMPORTE_DEVOLVER_EDITABLE)){
            ui.showToast("El importe a devolver debe ser un número válido");
            error++;
        } else if(parseFloat(objself.MAP_IMPORTE_DEVOLVER_EDITABLE) < 0){
            ui.showToast("El importe a devolver no puede ser negativo");
            error++;
        }
    }
    
    if(error > 0) return;
    
    
    // buscamos si se ha generado el movimiento correspondiente*
    await filtrarCollMacroObject(collMov,"m.IDACTIVIDAD="+idactividad+" and m.IDLEAD="+objself.MAP_IDLEAD+" and m.IDTIPO_MOVIMIENTO="+tipoMovimiento + estados[tipoMovimiento]);
    
    if(collMov.count() > 0){
        ui.showToast("Ya existe una devolución de intereses pendiente asociada a la actividad. Revise el apartado de movimientos");
        return;
    }
    
    // Pregunta de devolución de intereses que cubre ambos casos. Si se hace desde el campo editable o desde el campo ya calculado
    let pregunta;
    if(!isNullOrEmpty(objself.MAP_IMPORTE_DEVOLVER_EDITABLE)){
        pregunta = await ui.msgBox("¿Está seguro que desea solicitar la devolución de intereses por importe de " + objself.MAP_IMPORTE_DEVOLVER_EDITABLE + " €?","Devolución de intereses",1);
    } else {
        pregunta = await ui.msgBox("¿Está seguro que desea solicitar la devolución de intereses?","Devolución de intereses",1);
    }
    
    if(pregunta == 1){
        
        // en el caso de una devolución a cliente (DIC), pueden meter un importe manual
        let importeDevolverCliente = !isNullOrEmpty(objself.MAP_IMPORTE_DEVOLVER_EDITABLE) ? safeToFloat(objself.MAP_IMPORTE_DEVOLVER_EDITABLE) : safeToFloat(objself.MAP_IMPORTE_DEVOLVER.split(" ")[0]);
        
        // generamos el movimiento para la devolución*
        let MovCrear = appData.getCollection("MovimientosScript");
        let objMov = await MovCrear.createObject();
        
        objMov.IDACTIVIDAD = idactividad;
        objMov.IDLEAD = objself.MAP_IDLEAD;
        objMov.IDTIPO_MOVIMIENTO = tipoMovimiento;
        objMov.FECHA_SOLICITUD = fecha;
        objMov.IDESTADO = 5;
        
        // Comprobacion si el campo devolución editable esta relleno
        objMov.IMPORTE = tipoMovimiento10 ? objself.MAP_IMPORTE_RECIBIR : importeDevolverCliente;
       
        objMov.IBAN = tipoMovimiento10 ? objself.MAP_IBAN : objself.MAP_IBAN_CLIENTE;
        objMov.BENEFICIARIO = tipoMovimiento10 ? objself.MAP_BENEFICIARIO : objself.MAP_BENEFICIARIO_CLIENTE;
        objMov.IDDEUDA = objself.MAP_IDDEUDACLIENTE;
        // objMov.BASE_IMPONIBLE = round(objMov.IMPORTE/1.21,2);
        // objMov.IVA = round(objMov.IMPORTE - (objMov.IMPORTE/1.21),2);
  
        await objMov.save();
        
        // Generamos y guardamos el identificador del movimiento (devolución)
        let nuevoIdentificador = await generarIdentificadorMovimiento(tipoMovimiento,objMov.ID, true);
        
        let conceptoBase = tipoMovimiento10 ? "" : objself.MAP_BENEFICIARIO_CLIENTE;
        let concepto = nuevoIdentificador + " - Devolución intereses abusivos " + conceptoBase;
        
        objMov.CONCEPTO = concepto;
        await objMov.save();
        
        if(tipoMovimiento == 10) {
            objself.CONCEPTO = concepto;
            objself.MAP_CONCEPTO = concepto;
            objself.MAP_IDENTIFICADOR_MOVIMIENTO_DIA = nuevoIdentificador;
        }
        else if(tipoMovimiento == 11) {
            objself.CONCEPTO_CLIENTE = concepto;
            objself.IBAN_CLIENTE = objself.MAP_IBAN_CLIENTE;
            objself.BENEFICIARIO_CLIENTE = objself.MAP_BENEFICIARIO_CLIENTE;
            
            // si se ha generado el movimiento con un importe a devolver manual, guardamos el valor
            // if(!isNullOrEmpty(objself.MAP_IMPORTE_DEVOLVER_EDITABLE)){
                objself.IMPORTE_DEVOLVER_MANUAL = objself.MAP_IMPORTE_DEVOLVER_EDITABLE;
            // }
            
            objself.MAP_CONCEPTO_CLIENTE = concepto;
            objself.MAP_IDENTIFICADOR_MOVIMIENTO_DIC = nuevoIdentificador;

            // generamos la actualización de estado=5 para el cliente asociado a la deuda
            await generarActualizacionDevolucionIntereses(objself, objself.MAP_IDLEAD);
        }
        await objself.save();
        

        await actualizarDatosPaginadoLeads(padre,"ActividadesCliente","ActividadesClienteContador","MAP_PAG_INI_ACT","MAP_PAG_LEN_ACT","MAP_TOTAL_REGISTROS_ACT","MAP_T1_ACT");
        // await actualizarDatosContent(padre,"ActividadesClienteHijoDevolucionIntereses");
        
        ui.showToast("Movimiento de devolución de intereses creado. Por favor, revise el apartado de movimientos");
    }else{
        return;
    }
}




async function cambiarEstadoActividad(objself,idactividadcliente,estado) {
    let collActividadCliente = appData.getCollection("ActividadesClienteScript");
    await filtrarCollMacroObject(collActividadCliente,"ca.ID = " + idactividadcliente);
    
    if(collActividadCliente.count() > 0) {
        let objActividad = collActividadCliente.getItem(0);
        objActividad.ESTADO = estado;
        await objActividad.save();
    }
}


function comprobarEtapaDevolucionIntereses(objself, propImagenEtapa, numeroEtapas) {
    
    // iteramos las etapas de la acción judicial. Según el estado, vamos asignando a los props las imágenes correspondientes
    for(var i = 1; i <= numeroEtapas; i++) {
        
        if(i < objself.IDESTADO) {
            objself[propImagenEtapa + safeToString(i)] = "deudaVerde.png";
        }
        else if(i == objself.IDESTADO) {
            objself[propImagenEtapa + safeToString(i)] = "deudaAmarillo.png";
        }else if(i > objself.IDESTADO) {
            objself[propImagenEtapa + safeToString(i)] = "deudaGris.png";
        }
        
        // si está marcado el check de no solicitar devolución a cliente, la última etapa está realizada
        if(objself.NO_SOLICITA_DEVOLUCION_CHECK == 1){
            objself[propImagenEtapa + 5] = "deudaVerde.png";
        }
    }
}

async function solicitarCobroCEDevolucionIntereses(objself) {
    // generamos el movimiento para la comisión de éxito
    let collMov = appData.getCollection("MovimientosScript");
    let fecha = ObtenerFechaHoraActual();
    
    // en el caso de devoluciones a cliente, debe haber subido el documento asociado a la devolución de acreedores
    if( objself.ID_RECEPTOR_DEVOLUCION == 1 && !objself.MAP_DOCUMENTO_DEV) {
        ui.showToast("Adjunte el documento asociado a la devolución de acreedores");
        return;
    }
    
    await filtrarCollMacroObject(collMov,"m.IDTIPO_MOVIMIENTO = 3 AND m.IDACTIVIDAD="+objself.IDACTIVIDADCLIENTE+" and m.IDESTADO IN(5,7,10)");
            
    if(collMov.count()>0){
        ui.showToast("Ya existe un cobro de CE asociado a la actividad. Revise el apartado de movimientos");
        return;
    }
    
    let pregunta= await ui.msgBox("¿Está seguro que desea solicitar el cobro?","Cobro comisión",1);
    if(pregunta == 2) {
        return;
    }
    
    let importe = safeToFloat(objself.MAP_IMPORTE_COBRAR.split(' ')[0]);
    let objMov = await collMov.createObject();
                
    objMov.IDACTIVIDAD = objself.IDACTIVIDADCLIENTE;
    objMov.IDLEAD = objself.MAP_IDLEAD;
    objMov.IDDEUDA = objself.MAP_IDDEUDACLIENTE;
    objMov.IDTIPO_MOVIMIENTO = 3;
    objMov.FECHA_SOLICITUD = fecha;
    objMov.IDESTADO = 5;
    objMov.BASE_IMPONIBLE = round(importe/1.21,2);
    objMov.IVA = round(importe - (importe/1.21),2);
    objMov.IMPORTE = importe;
    await objMov.save();
    
    ui.showToast("Movimiento de cobro de comisión creado. Por favor, revise el apartado de movimientos");
    
}

async function hola() {
    await ui.msgBox("hola","",0);
}

function sumarDiasNaturales(fechaInicio, diasNaturales) {
    // función para obtener una fecha teniendo en cuenta solo días naturales
    let fecha = new Date(fechaInicio);

    fecha.setDate(fecha.getDate() + diasNaturales);
    return fecha;
}


function esDiaLaborable(fecha, opciones = {}) {
    
    // contamos días laborables. por defecto agosto y navidad cuentan como festivo (no laborable)
    const {
        agostoLaborable = false,
        navidadLaborable = false
    } = opciones;

    const diaSemana = fecha.getDay();
    const mes = fecha.getMonth();
    const dia = fecha.getDate();

    // Fin de semana
    if (diaSemana === 0 || diaSemana === 6) {
        return false;
    }

    // Agosto completo
    if (!agostoLaborable && mes === 7) {
        return false;
    }

    // Del 24/12 al 31/12
    if (!navidadLaborable && mes === 11 && dia >= 24) {
        return false;
    }

    // Del 01/01 al 07/01
    if (!navidadLaborable && mes === 0 && dia <= 7) {
        return false;
    }

    return true;
}

function sumarDiasLaborables(fechaInicio, diasLaborables, periodosLaborables = {}) {
    // función para obtener una fecha teniendo en cuenta solo días laborables
    let fecha = new Date(fechaInicio);
    let diasSumados = 0;

    while (diasSumados < diasLaborables) {
        // avanzar un día
        fecha.setDate(fecha.getDate() + 1);

        if (esDiaLaborable(fecha,periodosLaborables)) {
            diasSumados++;
        }
    }

    return fecha;
}


function diasLaborablesTranscurridos(fechaInicio, fechaFin, periodosLaborables = {}) {
    let inicio = new Date(fechaInicio);
    let fin = new Date(fechaFin);

    // Normalizar horas
    inicio.setHours(0, 0, 0, 0);
    fin.setHours(0, 0, 0, 0);

    if (inicio > fin) return 0;

    let dias = 0;
    let fecha = new Date(inicio);

    while (fecha < fin) {
        fecha.setDate(fecha.getDate() + 1);

        if (esDiaLaborable(fecha, periodosLaborables)) {
            dias++;
        }
    }

    return dias;
}


function ObtenerFechaHoraActual(formato){
// 	let fechaHora =ObtenerFechaActual(formato)+" "+ObtenerHoraActual();
	return ObtenerFechaActual(formato)+" "+ObtenerHoraActual();
}

function ObtenerFechaActual(formato){
	var today = new Date();
	var dd = today.getDate();
	var mm = today.getMonth()+1; //January is 0!
	var yyyy = today.getFullYear();
 
	if(dd<10) {
	    dd='0'+dd;
	} 
 
	if(mm<10) {
	    mm='0'+mm;
	} 
 	if (formato=="dmy") today = dd+'-'+mm+'-'+yyyy;
 	else today = yyyy+'-'+mm+'-'+dd;
	return today;
}

function ObtenerFechaMesAnterior(formato){
	var date = new Date();
  /* Javascript recalculará la fecha si el mes es menor de 0 (enero) 
    o mayor de 11 (diciembre) */
  date.setMonth(date.getMonth() - 1);
  /* Obtenemos la fecha en formato YYYY-mm-dd */
  return date.toISOString().substring(0, 10);
}

function obtenerFechaActualConcatenada() {
    const ahora = new Date();

    const dd = String(ahora.getDate()).padStart(2, '0');
    const mm = String(ahora.getMonth() + 1).padStart(2, '0'); // Los meses van de 0 a 11
    const yyyy = ahora.getFullYear();

    const HH = String(ahora.getHours()).padStart(2, '0');
    const Min = String(ahora.getMinutes()).padStart(2, '0');
    const SS = String(ahora.getSeconds()).padStart(2, '0');
    const ms = String(ahora.getMilliseconds()).padStart(3, '0');

    return dd+mm+yyyy+HH+Min+SS+ms;
}

function esAnteriorAHoy(fecha) {
  const hoy = new Date();
  hoy.setHours(0, 0, 0, 0);     // normalizamos
  
  const f = new Date(fecha);
  f.setHours(0, 0, 0, 0);       // normalizamos
  
  return f < hoy;
}

function sumarMeses(fechaBase, cantidadMeses) {
    var nuevaFecha = new Date(fechaBase);
    nuevaFecha.setMonth(nuevaFecha.getMonth() + cantidadMeses);
    
    var dd = nuevaFecha.getDate();
    var mm = nuevaFecha.getMonth()+1; //January is 0!
    var yyyy = nuevaFecha.getFullYear();
    
    if(dd<10) {
	    dd='0'+dd;
	} 
 
	if(mm<10) {
	    mm='0'+mm;
	}
    
    nuevaFecha = yyyy+'-'+mm+'-'+dd;
  
    return nuevaFecha+" "+ObtenerHoraActual();
}

function ObtenerFechaModificada(mes,formato){
    // añadimos los meses que pasemos por parámetro
	var today = new Date();
	var dd = today.getDate();
    // 	sumamos los meses a la fecha actual
	today.setMonth(today.getMonth() + 1 + mes); //January is 0!
	var mm= today.getMonth();
	var yyyy = today.getFullYear();
 
	if(dd<10) {
	    dd='0'+dd;
	} 
 
	if(mm<10) {
	    mm='0'+mm;
	} 
 	if (formato=="dmy") today = dd+'-'+mm+'-'+yyyy;
 	else today = yyyy+'-'+mm+'-'+dd;
	return today;
}

function ObtenerHoraActual(){
	var ahora = new Date();
	var hh = ahora.getHours();
	var mm = ahora.getMinutes();
	var ss = ahora.getSeconds();
 
	if(hh<10) {
	    hh='0'+hh;
	} 
 
	if(mm<10) {
	    mm='0'+mm;
	} 
	if(ss<10) {
	    ss='0'+ss;
	}
 
	ahora = hh+':'+mm+':'+ss;
	return ahora;
}

function fechaFormateada(fechaCompleta){
    // Separar fecha de hora
    var fecha = safeToString(fechaCompleta).split(' ')[0];  // "ejemplo 2025-05-14"
 
    var anio = fecha.split('-')[0];
    var mes = fecha.split('-')[1];
    var dia = fecha.split('-')[2];

    return dia+"-"+mes+"-"+anio;
}

function diferenciaEnDias(fecha) {
    // diferencia en días entre una fecha dada y la actual
    const hoy = new Date();
    const fechaDada = new Date(fecha);

    // Eliminar horas para evitar errores por zona horaria
    hoy.setHours(0, 0, 0, 0);
    fechaDada.setHours(0, 0, 0, 0);

    const diferenciaMs = hoy - fechaDada;
    const dias = Math.floor(diferenciaMs / (1000 * 60 * 60 * 24));

    return dias;
}
function diferenciaEnDiasDosFechas(fechaInicio, fechaFin) {
    // diferencia en días entre dos fechas
    let inicio = new Date(fechaInicio);
    let fin = new Date(fechaFin);

    // Normalizar horas
    inicio.setHours(0, 0, 0, 0);
    fin.setHours(0, 0, 0, 0);

    const diferenciaMs = fin - inicio;
    const dias = Math.floor(diferenciaMs / (1000 * 60 * 60 * 24));

    return dias;
}

/**
 * Calcula los años de diferencia entre una fecha y hoy
 */
function calcularDiferenciaAnnios(fecha) {
    if (!fecha) return 0;
    
    let hoy = new Date();
    let f = new Date(fecha);
    let diff = hoy.getFullYear() - f.getFullYear();
    let m = hoy.getMonth() - f.getMonth();
    
    if (m < 0 || (m === 0 && hoy.getDate() < f.getDate())) {
        diff--;
    }
    return diff;
}

function esFechaMayor(fecha) {
    // para comparar si una fecha dada es mayor que la actual
    //  OJO!!! función para formatos DD-MM-YYYY
    
    // fechaStr = "DD/MM/YYYY"
    const hoy = new Date();
    hoy.setHours(0,0,0,0);        // ignorar horas
    fecha.setHours(0,0,0,0);      // ignorar horas

    return fecha > hoy;
}


function mismoDia(fecha1, fecha2) {
    // para comparar que dd-mm-yyyy sea igual en dos fechas
    const f1 = new Date(fecha1);
    const f2 = new Date(fecha2);

    // Normalizamos horas
    f1.setHours(0, 0, 0, 0);
    f2.setHours(0, 0, 0, 0);

    return f1.getTime() === f2.getTime();
}


function isNullOrEmpty(text) {
    if (text === null || text === undefined) return true;
    return text.trim() == '';
}

function onBack(){
    appData.failWithMessage(-11888, "##EXIT##");
}

function cambiarColorProp(objself,prop,color){
    objself.setFieldPropertyValue(prop,"bgcolor",color);
    ui.refresh(prop);
}

function round(value, decimals) {
  return Number(Math.round(value+'e'+decimals)+'e-'+decimals);
}

async function obtenerobjeto(coll,filtro,Posicionobj){
    var coll = appData.getCollection(coll);
    // coll.setFilter(filtro);
    // await coll.loadAll();
    let obj= coll.get(Posicionobj);
    return obj;
}

async function obtenerPrimerobjetoCnt(coll,campo,valor){
    var coll = await self.getParent().getContents(coll);
    let obj= coll.getObject(campo,valor);
    return obj;
}

// funciones de para las deudas de los clientes

async function verComprobanteDeuda(objself,iddeuda){
    // Buscamos si la deuda seleccionada del cliente tiene comprobante para verlo/descargarlo
    var collDeuda = appData.getCollection("DeudaClienteScript");
    
    await filtrarCollMacroObject(collDeuda,"d.ID="+iddeuda);

    if(collDeuda.count()>0){
        // Buscamos si tiene un documento asociado (comprobante)
        var collDoc = appData.getCollection("DocumentoScript");
        await filtrarCollMacroObject(collDoc,"d.IDDEUDACLIENTE="+iddeuda+" AND d.IDTIPO=5 AND ifnull(d.BAJA,0)=0");

        if(collDoc.count()>0){
            let objDoc = collDoc.getItem(0);

            // descargamos/vemos el documento
            downloadDocumentAsyncPDF(objself,objself.ROWID,objDoc.DOCUMENTO,objself.CORREO,
                function(data){
                    if(objDoc.DOCUMENTO.includes(".pdf")==true){
                        ui.openUrl(data);
                    }else{
                        var link = document.createElement("a");
                        link.download = objDoc.DOCUMENTO;
                        link.href = data;
                        link.click();
                    }
                });
        }else{
            ui.showToast("No se encuentra el comprobante asociado a la deuda seleccionada");
        }
    }else{
        ui.showToast("No se encuentra la deuda seleccionada");
    }
}


async function omitirCobroComision(objself, iddeuda) {
    
    let pregunta = await ui.msgBox("¿Está seguro que desea pasar a la etapa 'Pago financiera' sin realizar ningún cobro de comisión?","Omitir cobro comisión",1);
    
    if(pregunta == 1) {
        let collDeuda = appData.getCollection("DeudaClienteScript");
        await filtrarCollMacroObject(collDeuda,"d.ID="+iddeuda+" AND ifnull(d.BAJA,0)=0");
        
        if(collDeuda.count()>0){
            let objDeuda = collDeuda.getItem(0);
            objDeuda.IDESTADO = 8;
            await objDeuda.save();
            objself.MAP_IDESTADO_DEUDA = 8;
            
            await actualizarDatosContent(objself,"DeudaClientePrograma");
            
            let producto = objDeuda.IDPRODUCTO_FINANCIERO_ACTUAL > 0 ? objDeuda.IDPRODUCTO_FINANCIERO_ACTUAL : objDeuda.IDPRODUCTO_FINANCIERO;
            await comprobarEstadoDeuda(objDeuda.IDESTADO,producto,iddeuda);
        }
    }
}

async function guardarActualizacion(idActualizacion,iddeuda){
    // función para guardar las actualizaciones de las deudas de clienteEdicion
    let error = 0;
    let fecha = ObtenerFechaHoraActual();
    var Producto, objDeuda;
    var coll = appData.getCollection("DocumentoScript");
    
    
    // comprobaciones
    if(safeToInt(idActualizacion)==0){
        ui.showToast("Debe seleccionar un tipo de actualización");
        error++;
    }
    // Localización de la deuda
    else if(safeToInt(idActualizacion)==1){
        if(safeToInt(self.MAP_IDENTIDAD_COMBO)==0){
            ui.showToast("Debe indicar una entidad");
            error++;
        }
        if(safeToFloat(self.MAP_IMPORTE_ACTUAL2)==0){
            ui.showToast("Debe indicar el importe actual");
            error++;
        }
    }
    // Obtención de descuento
    else if(safeToInt(idActualizacion)==2){
        if(safeToFloat(self.MAP_IMPORTE_LIQUIDAR2)==0){
            ui.showToast("Debe indicar el importe a liquidar");
            error++;
        }
    }
    // Obtención de descuento
    else if(safeToInt(idActualizacion)==3){
        if(isNullOrEmpty(self.MAP_OBSERVACION_CLIENTE) || self.MAP_OBSERVACION_CLIENTE==""){
            ui.showToast("Debe indicar una observación para el cliente");
            error++;
        }
    }
    // Obtención de reestructura
    else if(safeToInt(idActualizacion)==5){
        if(safeToFloat(self.MAP_CUOTA1)==0){
            ui.showToast("Debe indicar la cuota");
            error++;
        }
        if(safeToInt(self.MAP_PLAZO_PAGAR)==0){
            ui.showToast("Debe indicar el plazo para pagar");
            error++;
        }
        if(safeToInt(self.MAP_CUOTA_INICIAL2)==0){
            ui.showToast("Debe indicar la cuota inicial");
            error++;
        }
        if(isNullOrEmpty(safeToString(self.MAP_CUOTA_INICIAL_FECHA))){
            ui.showToast("Debe indicar la fecha para la primera cuota");
            error++;
        }
        // if(safeToFloat(self.MAP_TASA_INTERES)==0){
        //     ui.showToast("Debe indicar la tasa de interés");
        //     error++;
        // }
    }
    // Obtención de descneto y fraccionamiento
    else if(safeToInt(idActualizacion)==9){
        if(safeToFloat(self.MAP_IMPORTE_LIQUIDAR2)==0){
            ui.showToast("Debe indicar el importe a liquidar");
            error++;
        }
        if(safeToInt(self.MAP_PLAZO_PAGAR)<=0){
            ui.showToast("Debe indicar el plazo para pagar");
            error++;
        }
        // if(safeToInt(self.MAP_IMPORTE_REMANENTE)<=0){
        //     ui.showToast("Debe indicar el importe remanente");
        //     error++;
        // }
        // if(safeToInt(self.MAP_IMPORTE_INICIAL_FRACCIONADO2)<=0){
        //     ui.showToast("Debe indicar el importe inicial fraccionado");
        //     error++;
        // }
        if(safeToInt(self.MAP_PLAZO_COMISION)<=0){
            ui.showToast("Debe indicar el plazo para la comisión de éxito");
            error++;
        }
        if(safeToInt(self.MAP_DIA_PAGO1)<=0 || safeToInt(self.MAP_DIA_PAGO1)>31){
            ui.showToast("Debe indicar el día de pago (1-31)");
            error++;
        }
    }
    // Estudio de viabilidad
    else if(safeToInt(idActualizacion)==16){
        if(safeToInt(self.MAP_IDENTIDAD_COMBO)==0){
            ui.showToast("Debe indicar la entidad");
            error++;
        }
        if(safeToInt(self.MAP_VIABILIDAD_COMBO)==0){
            ui.showToast("Debe indicar la viabilidad");
            error++;
        }
        if(safeToInt(self.MAP_TIPO_DEMANDA_COMBO)==0){
            ui.showToast("Debe indicar el tipo de demanda");
            error++;
        }
    }
    // Acuerdo de solución
    else if(safeToInt(idActualizacion)==21){
        if(isNullOrEmpty(self.MAP_ANEXO3)==true && self.MAP_ANNADIR_ANEXO==0){
            ui.showToast("Debe adjuntar el documento para la actualización");
            error++;
        }
    }
    
    // Comprobamos si hay documentos con nombres duplicados en caso de adjuntar uno
    if(isNullOrEmpty(self.MAP_ANEXO3) == false && self.MAP_ANNADIR_ANEXO == 1){
        let file=self.getOwnerCollection().getVariables("File");
        let fileName="";

        if(isNothing(file)){
            await ui.msgBox("Debe adjuntar el anexo que quiere subir","Falta anexo",0);
            return;
        }
        
        fileName = self.MAP_ANEXO3;
        
        //  Comprobamos si para este lead existe un documento con el mismo nombre
        await filtrarCollMacroObject(coll,"d.BAJA=0 AND d.DOCUMENTO='"+fileName+"' AND d.ROWID_LEAD='"+self.ROWID+"'");
        
        if(coll.count() > 0){
            await ui.msgBox("Ya existe un documento con el nombre indicado. Especifique otro distinto.","Archivo duplicado",0);
            return;
        }
    }
    
    if(error == 0){
        let cntAct = await self.getContents("ClienteActualizaciones");
        let objAct = await cntAct.createObject();
        
        objAct.IDDEUDA=iddeuda;
        objAct.IDLEAD=self.ID;
        objAct.IDUSUARIO=user.ID;
        objAct.IDCONCEPTO=self.MAP_CONCEPTOS_COMBO;
        objAct.IDENTIDAD=self.MAP_IDENTIDAD_COMBO;
        objAct.FECHA=fecha;
        objAct.IMPORTE_ACTUAL=self.MAP_IMPORTE_ACTUAL2;
        objAct.IMPORTE_LIQUIDAR=self.MAP_IMPORTE_LIQUIDAR2;
        objAct.OBSERVACIONES=self.MAP_OBSERVACION;
        objAct.OBSERVACIONES_CLIENTE=self.MAP_OBSERVACION_CLIENTE;
        objAct.PLAZO_PAGAR=self.MAP_PLAZO_PAGAR;
        objAct.TASA_INTERES=self.MAP_TASA_INTERES;
        objAct.IMPORTE_REMANENTE=self.MAP_IMPORTE_REMANENTE;
        objAct.IMPORTE_INICIAL_FRACCIONADO = self.MAP_IMPORTE_INICIAL_FRACCIONADO2;
        objAct.CUOTA=self.MAP_CUOTA1;
        objAct.PLAZO_COMISION=self.MAP_PLAZO_COMISION;
        objAct.DIA_PAGO=self.MAP_DIA_PAGO1;
        objAct.CUOTA_INICIAL=self.MAP_CUOTA_INICIAL2;
        objAct.FECHA_CUOTA_INICIAL=self.MAP_CUOTA_INICIAL_FECHA;
        objAct.INTERPOSICION_DEMANDA=self.MAP_VIABILIDAD_COMBO;
        objAct.TIPO_DEMANDA=self.MAP_TIPO_DEMANDA_COMBO;

        // guardamos las observaciones para la zona de usuario
        // 1=Localización de la deuda. 2=Obtención de descuento. 5=Obtención de la reestructura. 9=obtención de descuento y fraccionamiento
        // 16=estudio de viabilidad. 22=acuerdo de solución. 55=Pago diferido de comisión
        if(idActualizacion == 1){
            objAct.OBSERVACIONES_ZONA_USUARIO="Deuda localizada en la entidad ["+self.MAP_ENTIDAD_ACT+"]";
        }else if(idActualizacion == 2){
            objAct.OBSERVACIONES_ZONA_USUARIO="Importe de ["+self.MAP_IMPORTE_LIQUIDAR2+"€] para cancelar la deuda completa";
        }else if(idActualizacion == 5){
            objAct.OBSERVACIONES_ZONA_USUARIO="Condiciones para reestructura - ["+self.MAP_PLAZO_PAGAR+" cuotas] de ["+self.MAP_CUOTA1+"€]";
        }else if(idActualizacion == 9){
            objAct.OBSERVACIONES_ZONA_USUARIO="Importe de ["+self.MAP_IMPORTE_LIQUIDAR2+"€] a realizar en ["+self.MAP_PLAZO_PAGAR+"] pagos mensuales para cancelar la deuda";
        }else if(idActualizacion == 16){
            let entidad = self.MAP_IDENTIDAD_ACTUAL === 0 ? self.MAP_ENTIDAD_INICIAL : self.MAP_ENTIDAD_ACTUAL1;
            if(self.MAP_VIABILIDAD_COMBO == 3){
                objAct.OBSERVACIONES_ZONA_USUARIO="Tras análisis de la documentación recibida, se determina que [es viable] interponer una reclamación extrajudicial a la financiera ["+ entidad +"] - Se continua por la vía de la reclamación";
            }else if(self.MAP_VIABILIDAD_COMBO == 4){
                objAct.OBSERVACIONES_ZONA_USUARIO="Tras análisis de la documentación recibida, se determina que [no es viable] interponer una reclamación extrajudicial a la financiera ["+ entidad +"] - Se continua por la vía de la negociación amistosa";
            }
        }else if(idActualizacion == 21){
            objAct.OBSERVACIONES_ZONA_USUARIO="Acuerdo de solución pendiente de firma por el cliente";
        }else if(idActualizacion == 55){
            objAct.OBSERVACIONES_ZONA_USUARIO="El cliente reconoce la comisión acordada y se compromete a abonarla en los plazos diferidos establecidos, lo que le ha permitido destinar sus recursos a formalizar el acuerdo de pago con el acreedor.";
        }
        
        await objAct.save();
        
        
        // Buscamos la deuda asociada a la actualización
        var collDeuda = appData.getCollection("DeudaClienteScript");
        await filtrarCollMacroObject(collDeuda,"d.ID="+iddeuda+" AND ifnull(d.BAJA,0)=0");
        
        if(collDeuda.count()>0){
            objDeuda= collDeuda.getItem(0);
            
            // buscamos el producto asociado a la deuda por si se hubiera actualizado
            var collProd=appData.getCollection("ProductoScript");

            if(safeToInt(objDeuda.IDPRODUCTO_FINANCIERO_ACTUAL)>0){
                await filtrarCollMacroObject(collProd,"ID="+objDeuda.IDPRODUCTO_FINANCIERO_ACTUAL);
            }else{
                await filtrarCollMacroObject(collProd,"ID="+objDeuda.IDPRODUCTO_FINANCIERO);
            }
            
            if(collProd.count()>0){
                Producto = collProd.getItem(0);
            }else{
                ui.showToast("No se ha encontrado el producto financiero asociado a la deuda");
                return;
            }
            
            
            // localización de deuda
            if(safeToInt(idActualizacion)==1){
                objDeuda.IDENTIDAD_NUEVO=self.MAP_IDENTIDAD_COMBO;
                objDeuda.IMPORTE_NUEVO=self.MAP_IMPORTE_ACTUAL2;
                objDeuda.POTENCIAL=round(objDeuda.IMPORTE_NUEVO/self.CUOTA_ALIVIA,0);
                self.MAP_POTENCIAL_DEUDA=objDeuda.POTENCIAL;
            }
            // Obtención de descuento
            else if(safeToInt(idActualizacion)==2){
                objDeuda.IMPORTE_LIQUIDAR=self.MAP_IMPORTE_LIQUIDAR2;
                objDeuda.DESCUENTO_SOBRE_INICIAL=round((1-self.MAP_IMPORTE_LIQUIDAR2/objDeuda.IMPORTE_ACTUAL)*100,2);
                objDeuda.COMISION_EXITO = round((Producto.CE/100)*(((1-self.MAP_IMPORTE_LIQUIDAR2/objDeuda.IMPORTE_ACTUAL)*100)*objDeuda.IMPORTE_ACTUAL/100),2);
                // no permitimos valor negativo
                if(objDeuda.COMISION_EXITO < 0){
                    objDeuda.COMISION_EXITO = 1;
                }
                objDeuda.TOTAL_PAGAR=objDeuda.IMPORTE_LIQUIDAR+objDeuda.COMISION_EXITO;
            }
            // reestructuración
            if(safeToInt(idActualizacion)==5){
                // el importe actual aquí no es obligatorio, sólo guardamos si indican valor
                if(safeToFloat(self.MAP_IMPORTE_ACTUAL2)>0){
                    objDeuda.IMPORTE_NUEVO=self.MAP_IMPORTE_ACTUAL2;
                    objDeuda.CHECK_IMPORTE_NUEVO=0;
                    objDeuda.POTENCIAL=round(objDeuda.IMPORTE_NUEVO/self.CUOTA_ALIVIA,0);
                    self.MAP_POTENCIAL_DEUDA=objDeuda.POTENCIAL;
                    self.MAP_DEUDA_NEG="";
                    self.MAP_IMPORTE_NUEVO_CHECK=0;
                }
                objDeuda.CUOTA_INICIAL=self.MAP_CUOTA_INICIAL2;
                objDeuda.FECHA_CUOTA_INICIAL=self.MAP_CUOTA_INICIAL_FECHA;
                objDeuda.CUOTA=self.MAP_CUOTA1;
                objDeuda.CHECK_CUOTA=0;
                objDeuda.PLAZO_PAGAR=self.MAP_PLAZO_PAGAR;
                objDeuda.CHECK_PLAZO_PAGAR=0;
                objDeuda.TASA_INTERES=self.MAP_TASA_INTERES;
                objDeuda.COMISION_EXITO=round(0.05*objDeuda.IMPORTE_NUEVO,2);
                // objDeuda.COMISION_EXITO=round((Producto.CE/100)*objDeuda.IMPORTE_ACTUAL,2);
                objDeuda.TOTAL_PAGAR=round((self.MAP_CUOTA1*self.MAP_PLAZO_PAGAR)+objDeuda.COMISION_EXITO,2);
            }
            // descuento y fraccionamiento
            else if(safeToInt(idActualizacion)==9){
                objDeuda.IMPORTE_LIQUIDAR=self.MAP_IMPORTE_LIQUIDAR2;
                objDeuda.DESCUENTO_SOBRE_INICIAL=round((1-self.MAP_IMPORTE_LIQUIDAR2/objDeuda.IMPORTE_ACTUAL)*100,2);
                objDeuda.COMISION_EXITO = round((Producto.CE/100)*(((1-self.MAP_IMPORTE_LIQUIDAR2/objDeuda.IMPORTE_ACTUAL)*100)*objDeuda.IMPORTE_ACTUAL/100),2);
                // no permitimos valor negativo
                if(objDeuda.COMISION_EXITO < 0){
                    objDeuda.COMISION_EXITO = 1;
                }
                // !!!
                objDeuda.TOTAL_PAGAR=objDeuda.IMPORTE_LIQUIDAR+objDeuda.COMISION_EXITO;
                objDeuda.IMPORTE_REMANENTE = safeToInt(self.MAP_IMPORTE_REMANENTE);
                objDeuda.IMPORTE_INICIAL_FRACCIONADO = safeToInt(self.MAP_IMPORTE_INICIAL_FRACCIONADO2);
                objDeuda.PLAZO_PAGAR=self.MAP_PLAZO_PAGAR;
                objDeuda.PLAZO_COMISION=self.MAP_PLAZO_COMISION;
                objDeuda.DIA_PAGO=self.MAP_DIA_PAGO1;
                objDeuda.PAB_MENSUAL=0;
                objDeuda.CE_MENSUAL=0;
            }
            // estudio de viabilidad interposición de demanda
            else if(safeToInt(idActualizacion)==16){
                objDeuda.IDENTIDAD_NUEVO=self.MAP_IDENTIDAD_COMBO;
                objDeuda.INTERPOSICION_DEMANDA=self.MAP_VIABILIDAD_COMBO;
                objDeuda.TIPO_DEMANDA=self.MAP_TIPO_DEMANDA_COMBO;
            }

            objDeuda.FECHA_ACTUALIZACION = fecha;
            await objDeuda.save();
            
            
            // actualizamos los valores en pantalla
            actualizarValoresDeuda(idActualizacion,objDeuda,Producto);
            
            // comprobamos si adjunta anexo
            if(isNullOrEmpty(self.MAP_ANEXO3)==false && self.MAP_ANNADIR_ANEXO==1){
                let file=self.getOwnerCollection().getVariables("File");
                let fileName="";

                if(isNothing(file)){
                    await ui.msgBox("Debe adjuntar el anexo que quiere subir","Falta anexo",0);
                    return;
                }
                fileName=self.MAP_ANEXO3;
                
                // subimos el archivo
                await uploadFiles(self, file, fileName, 9, self.CORREO, user.CORREO, user.LOGIN,"anexo",self.ROWID,0,iddeuda,objAct.ID);
            }
            
            self.MAP_ANNADIR_ACTUALIZACION = 0;
            limpiarCampos(self,"annadirActualizacion");
            await actualizarDatosPaginadoLeads(self,"ClienteActualizaciones","ClienteActualizacionesContador","MAP_PAG_INI_ACTUALIZACIONES","MAP_PAG_LEN_ACTUALIZACIONES","MAP_TOTAL_REGISTROS_ACTUALIZACIONES","MAP_T1_ACTUALIZACIONES");
            await actualizarDatosContent(self,"DeudaClientePrograma");
            
            // menos en cobranza y demanda
            // if(safeToInt(idActualizacion)!==3 && safeToInt(idActualizacion)!==4){
                // enviamos mensaje al cliente al generar la actualización
                // EnviarMensajeAivo(self,"actualizacion_deuda_v1",self.MOVIL);
            // }
            
        }else{
            ui.showToast("No se ha encontrado la deuda actual");
        }
    }else{
        return;
    }
}


async function generarActualizacion(objself,iddeuda,idestadoDeuda,producto,mes, callback) {

    var productos = [1,2,3]; // 1=descuento, 2=refinanciación, 3=fraccionamiento
    var objDeuda;
    var collDeuda = appData.getCollection("DeudaClienteScript");
    
    await filtrarCollMacroObject(collDeuda,"d.ID="+iddeuda+" AND ifnull(d.BAJA,0)=0");
    
    if(collDeuda.count()>0){
        objDeuda = collDeuda.getItem(0);
        
        // Actualizaciones que se generan para visualizarse en la zona de usuario de manera automática
        let fecha=ObtenerFechaHoraActual();
        let collAct = appData.getCollection("ClienteActualizacionesScript");
        let objAct = await collAct.createObject();
        
        objAct.IDDEUDA = iddeuda;
        objAct.IDLEAD = objDeuda.IDLEAD;
        objAct.IDUSUARIO = user.ID;
        objAct.FECHA = fecha;
        
        
        // para productos de descuento, refinanciación y fraccionado (1,2,3)
        if(productos.includes(producto)){
            switch (idestadoDeuda) {
            // si pasamos a aprobación cliente
            case 5:
                objAct.IDCONCEPTO = 10;
                objAct.OBSERVACIONES_ZONA_USUARIO = "Pendiente aprobación del cliente";
                break;
            // si estamos en el plan de pagos
            case 6:
                const collPlanPago = appData.getCollection("PlanDePagosScript");
                await filtrarCollMacroObject(collPlanPago, "p.IDDEUDA=" + iddeuda + " AND IFNULL(p.PAB_MENSUAL,0)>0 AND p.BAJA=0");
                objAct.IDCONCEPTO = 6;
                objAct.OBSERVACIONES_ZONA_USUARIO = "Seguimiento de los pagos realizados a la financiera - Mes ["+mes+"]/["+collPlanPago.count()+"]";
                break;
            // si lo solicitamos desde Pago financiera
            case 8:
                objAct.IDCONCEPTO = 12;
                objAct.OBSERVACIONES_ZONA_USUARIO = "Pendiente realización del pago a la financiera";
                break;
            // si subimos el justificante de transferencia
            case 9:
                objAct.IDCONCEPTO = 13;
                objAct.OBSERVACIONES_ZONA_USUARIO = "Justificante de transferencia a financiera/devolución adjuntado";
                break;
            // si subimos el certificado de la financiera
            case 10:
                objAct.IDCONCEPTO = 14;
                objAct.OBSERVACIONES_ZONA_USUARIO = objDeuda.IDPRODUCTO_FINANCIERO_ACTUAL !== 2
                    ? "Certificado de liquidación de la financiera adjuntado"
                    : "Certificado de reestructura de la financiera adjuntado";
                break;
            default:
                return; // No hacemos nada si el estado no está contemplado
            }
            
        // Para interposición de demanda
        }else if(producto == 4){
            switch (idestadoDeuda) {
            case 1:
                objAct.IDCONCEPTO = 15;
                objAct.OBSERVACIONES_ZONA_USUARIO = "Documentación obtenida correctamente";
                break;
            case 2:
                objAct.IDCONCEPTO = 16;
                objAct.OBSERVACIONES_ZONA_USUARIO = "Pendiente estudio documentación para determinar viabilidad";
                break;
            case 3:
                objAct.IDCONCEPTO = 17;
                objAct.OBSERVACIONES_ZONA_USUARIO = "Pendiente elaboración reclamación extrajudicial - [Falta de transparencia]";
                break;
            default:
                return; // No hacemos nada si el estado no está contemplado
            }
        }
        
        await objAct.save();
        // enviamos mensaje al cliente al generar la actualización
        // EnviarMensajeAivo(objself,"actualizacion_deuda_v1",objself.MAP_MOVIL_CABECERA);
        
        // Se define algún callback porque no hay cojones a cascar el await en la función al publicar la web
        // Para poder rescatar el objeto guardado y acceder a sus campos 
        if (typeof callback === "function") {
            callback(objAct);
        }
        
        return objAct;
    }
}


async function asignarIdDocumentoActualizacionDeuda(objself,idAct,file,fileName,rowid_lead){
    // asignamos el id del documento subido a la actualización que hemos creado
    var objAct,objDoc;
    
    
    var cntAct = await objself.getContents("ClienteActualizaciones");
    await filtrarContentMacroObject(cntAct,"c.ID="+idAct);
    
    if(cntAct.count()>0){
        objAct = cntAct.getItem(0);
        
        var collDoc = appData.getCollection("DocumentoScript");
        
        if(fileName!==""){
            await filtrarCollMacroObject(collDoc,"d.BAJA=0 AND d.DOCUMENTO='"+fileName+"' AND d.ROWID_LEAD='"+rowid_lead+"'");
        }else{
            await filtrarCollMacroObject(collDoc,"d.BAJA=0 AND d.DOCUMENTO='"+file.name+"' AND d.ROWID_LEAD='"+rowid_lead+"'");
        }
        
        if(collDoc.count()>0){
            objDoc = collDoc.getItem(0);
            
            objAct.IDDOCUMENTO = objDoc.ID;
            objAct.ANEXO = objDoc.DOCUMENTO;
            await objAct.save();
            await actualizarDatosPaginadoLeads(self,"ClienteActualizaciones","ClienteActualizacionesContador","MAP_PAG_INI_ACTUALIZACIONES","MAP_PAG_LEN_ACTUALIZACIONES","MAP_TOTAL_REGISTROS_ACTUALIZACIONES","MAP_T1_ACTUALIZACIONES");
        }
    }
}

async function asignarIdDocumentoPlanPagoDeuda(objself,idDeuda,file,fileName,rowid_lead,mes){
    // asignamos el id del documento subido al mes correspondiente del plan de pagos de una deuda con producto fraccionado
    var objPlanPago,objDoc,objself;
    var collDoc = appData.getCollection("DocumentoScript");
    
    var collPlanPago = appData.getCollection("PlanDePagosScript");
    await filtrarCollMacroObject(collPlanPago,"p.IDDEUDA="+idDeuda+ " AND p.MES="+mes);
    
    if(collPlanPago.count()>0){
        objPlanPago = collPlanPago.getItem(0);
        
        if(fileName!==""){
            await filtrarCollMacroObject(collDoc,"d.BAJA=0 AND d.DOCUMENTO='"+fileName+"' AND d.ROWID_LEAD='"+rowid_lead+"'");
        }else{
            await filtrarCollMacroObject(collDoc,"d.BAJA=0 AND d.DOCUMENTO='"+file.name+"' AND d.ROWID_LEAD='"+rowid_lead+"'");
        }
        if(collDoc.count()>0){
            objDoc = collDoc.getItem(0);
            
            objPlanPago.IDDOCUMENTO=objDoc.ID;
            await objPlanPago.save();
        }
    }
}

async function crearPlanDePago(objself,iddeuda){
    // función para crear en una deuda fraccionada el plan de pagos en la etapa 'plan de pagos' de clienteEdicion
    // comprobamos si existe un plan activo, si no, lo creamos
    var objDeuda;
    var collPlanPago= appData.getCollection("PlanDePagosScript");
    await filtrarCollMacroObject(collPlanPago,"p.IDDEUDA="+iddeuda+" and p.BAJA=0");
    
    if(collPlanPago.count()>0){
        ui.showToast("Ya existe un plan de pagos activo asociado a la deuda");
        return;
    }else{
        let mesesTotal,NuevoPlanPago;
        var collDeuda = appData.getCollection("DeudaClienteScript");
        await filtrarCollMacroObject(collDeuda,"d.ID="+iddeuda+" AND ifnull(d.BAJA,0)=0");
        
        if(collDeuda.count()>0){
            objDeuda = collDeuda.getItem(0);
            
            // al asignar por meses diferentes tanto el pago como las comisiones, comprobamos cuál es mayor para hacer el bucle
            if(objDeuda.PLAZO_PAGAR > objDeuda.PLAZO_COMISION){
                mesesTotal=objDeuda.PLAZO_PAGAR;
            }else{
                mesesTotal=objDeuda.PLAZO_COMISION;
            }
            ui.showToast("Creando plan...");
            // creamos el plan de pagos en función de los meses establecidos. Empezamos asignando por el mes(i) 1 y no por el 0
            for(var i=1;i<=mesesTotal;i++){
                NuevoPlanPago = await collPlanPago.createObject();
                NuevoPlanPago.IDLEAD = objself.ID;
                NuevoPlanPago.IDDEUDA = iddeuda;
                NuevoPlanPago.BAJA = 0;
                NuevoPlanPago.MES = i;
                
                // como los meses de pago a banco y comisiones pueden no coincidir, comprobamos y asignamos en función del nº de los mismos
                if(i <= objDeuda.PLAZO_PAGAR){
                    // Primer mes, importe inicial, último mes importe remanente, no el mensual

                    if(i == 1 && objDeuda.IMPORTE_INICIAL_FRACCIONADO > 0){
                        NuevoPlanPago.PAB_MENSUAL = objself.MAP_IMPORTE_INICIAL_FRACCIONADO;
                    }else if(i == objDeuda.PLAZO_PAGAR && objDeuda.IMPORTE_REMANENTE > 0){
                        NuevoPlanPago.PAB_MENSUAL = objself.MAP_PAB_REMANENTE;
                    }else{
                        NuevoPlanPago.PAB_MENSUAL = objself.MAP_PAB_MENSUAL;
                    }
                }else{
                    NuevoPlanPago.PAB_MENSUAL = 0;
                }
                
                if(i<=objDeuda.PLAZO_COMISION){
                    NuevoPlanPago.CE_MENSUAL = objself.MAP_CE_MENSUAL;
                }else{
                    NuevoPlanPago.CE_MENSUAL = 0;
                }
                await NuevoPlanPago.save();
            }
            
            // pasamos de etapa a 'aprobacion cliente' una vez generado el plan de pagos
            self.MAP_IDESTADO_DEUDA = 5;
            objDeuda.IDESTADO = 5;
            await objDeuda.save();
            
            await actualizarDatosContent(objself,"PlanDePagos");
        } else {
            ui.showToast("No se ha poddido crear el plan para la deuda");
        }
    }
}

function actualizarValoresDeuda(idActualizacion,objDeuda,Producto){
    // Actualizamos los valores en pantalla tras crear la actualización
    // localización de la deuda
    if(idActualizacion==1){
        self.MAP_ENTIDAD_ACTUAL=self.MAP_ENTIDAD_ACT;
        self.MAP_IMPORTE_NUEVO=self.MAP_IMPORTE_ACTUAL2+" €";
    }
    // Obtención de descuento
    if(idActualizacion==2){
        self.MAP_IMPORTE_LIQUIDAR=self.MAP_IMPORTE_LIQUIDAR2+" €";
        self.MAP_DESCUENTO=round((1-self.MAP_IMPORTE_LIQUIDAR2/objDeuda.IMPORTE_ACTUAL)*100,2)+"%";
        self.MAP_COMISION_EXITO = round((Producto.CE/100)*(((1-self.MAP_IMPORTE_LIQUIDAR2/objDeuda.IMPORTE_ACTUAL)*100)*objDeuda.IMPORTE_ACTUAL/100),2)+" €";
        // no permitimos valor negativo
        if(round((Producto.CE/100)*(((1-self.MAP_IMPORTE_LIQUIDAR2/objDeuda.IMPORTE_ACTUAL)*100)*objDeuda.IMPORTE_ACTUAL/100),2) < 0){
            self.MAP_COMISION_EXITO = "1 €";
        }
        self.MAP_TOTAL_PAGAR=objDeuda.IMPORTE_LIQUIDAR+objDeuda.COMISION_EXITO+" €";
    }
    // Obtención de reestructura
    if(idActualizacion==5){
        if(safeToFloat(self.MAP_IMPORTE_ACTUAL2)>0){
            self.MAP_IMPORTE_NUEVO=self.MAP_IMPORTE_ACTUAL2+" €";
        }
        self.MAP_CUOTA_INICIAL=self.MAP_CUOTA_INICIAL2+" €";
        self.MAP_FECHA_CUOTA_INI=fechaFormateada(self.MAP_CUOTA_INICIAL_FECHA);
        self.MAP_CUOTA=self.MAP_CUOTA1+" €";
        self.MAP_MESES3=self.MAP_PLAZO_PAGAR;
        self.MAP_INTERES=self.MAP_TASA_INTERES+"%";
        self.MAP_COMISION_EXITO=round((Producto.CE/100)*objDeuda.IMPORTE_ACTUAL,2)+" €";
        // no permitimos valor negativo
        if(round((Producto.CE/100)*objDeuda.IMPORTE_ACTUAL,2) < 0){
            self.MAP_COMISION_EXITO = "1 €";
        }
        self.MAP_TOTAL_PAGAR=(objDeuda.CUOTA*objDeuda.PLAZO_PAGAR)+objDeuda.COMISION_EXITO+" €";

        // vaciamos los campos del lado derecho y los checks ya que habremos desmarcado alguno que estuviera marcado previamente
        self.MAP_CUOTA_CHECK=0;
        self.MAP_MESES_CHECK=0;
        self.MAP_CUOTA_INICIAL_CHECK=0;
        self.MAP_FECHA_CUOTA_INI_CHECK=0;
        self.MAP_CUOTA_NEG="";
        self.MAP_MESES_NEG="";
        self.MAP_CUOTA_INI_NEG="";
        self.MAP_FECHA_CUOTA_INI_NEG="";
    }
    // Obtención de descuento y fraccionamiento
    if(idActualizacion==9){
        self.MAP_IMPORTE_LIQUIDAR=self.MAP_IMPORTE_LIQUIDAR2+" €";
        self.MAP_DESCUENTO=round((1-self.MAP_IMPORTE_LIQUIDAR2/objDeuda.IMPORTE_ACTUAL)*100,2)+"%";
        self.MAP_COMISION_EXITO=round((Producto.CE/100)*(((1-self.MAP_IMPORTE_LIQUIDAR2/objDeuda.IMPORTE_ACTUAL)*100)*objDeuda.IMPORTE_ACTUAL/100),2)+" €";
        // no permitimos valor negativo
        if(round((Producto.CE/100)*(((1-self.MAP_IMPORTE_LIQUIDAR2/objDeuda.IMPORTE_ACTUAL)*100)*objDeuda.IMPORTE_ACTUAL/100),2) < 0){
            self.MAP_COMISION_EXITO = "1 €";
        }
        self.MAP_TOTAL_PAGAR=objDeuda.IMPORTE_LIQUIDAR+objDeuda.COMISION_EXITO+" €";
        self.MAP_MESES1=self.MAP_PLAZO_PAGAR;
        self.MAP_MESES2=self.MAP_PLAZO_COMISION;
        self.MAP_DIA_PAGO=self.MAP_DIA_PAGO1;
        self.MAP_PAB_REMANENTE=objDeuda.IMPORTE_REMANENTE+" €";
        self.MAP_IMPORTE_INICIAL_FRACCIONADO=objDeuda.IMPORTE_INICIAL_FRACCIONADO+" €";
        self.MAP_PAB_MENSUAL="";
        self.MAP_CE_MENSUAL="";
    }
    // Estudio de viabilidad
    if(idActualizacion==16){
        self.MAP_ENTIDAD_ACTUAL_DEM = self.MAP_ENTIDAD_ACT;
        self.MAP_ESTUDIO_VIABILIDAD_DEM = self.MAP_VIABILIDAD_ACT;
        self.MAP_TIPO_DEMANDA_DEM = self.MAP_TIPO_DEMANDA_ACT;
    }
}

async function comprobarCambioEtapaDeuda(iddeuda,idestadoDeuda){
    // verificaciones para el cambio de etapa en una deuda
    var productos = [1,2,3]; // 1=descuento, 2=refinanciación, 3=fraccionamiento
    var producto, objDeuda;
    var collDeuda= appData.getCollection("DeudaClienteScript");
    
    await filtrarCollMacroObject(collDeuda,"d.ID="+iddeuda+" AND ifnull(d.BAJA,0)=0");
    
    if(collDeuda.count()>0){
        objDeuda = collDeuda.getItem(0);
        
        if(objDeuda.IDPRODUCTO_FINANCIERO_ACTUAL>0){
            producto=objDeuda.IDPRODUCTO_FINANCIERO_ACTUAL;
        }else{
            producto=objDeuda.IDPRODUCTO_FINANCIERO;
        }
        
        // para productos de descuento, refinanciación y fraccionado (1,2,3)
        if(productos.includes(producto)){
            
            // búsqueda
            if(idestadoDeuda==2){
                if(self.MAP_ENTIDAD_CHECK==1){
                    let pregunta= await ui.msgBox("¿Está seguro que desea confirmar la entidad "+self.MAP_ENTIDAD_ACTUAL+" y cambiar a la etapa 'Negociación'?","Búsqueda",1);
                    if(pregunta==1){
                        objDeuda.CHECK_IDENTIDAD_NUEVO=1;
                        objDeuda.IDESTADO=3;
                        await objDeuda.save();
                        self.MAP_BUSQUEDA=self.MAP_ENTIDAD_ACTUAL;
                        self.MAP_IDESTADO_DEUDA=3;
                    }else{
                        self.MAP_ENTIDAD_CHECK=0;
                        return;
                    }
                }
            }
            // negociación
            if(idestadoDeuda==3){
                // comprobaciones para producto descuento
                if(producto==1){
                    if(self.MAP_CHECK_IMPORTE_LIQUIDAR==1){
                        let pregunta= await ui.msgBox("¿Está seguro que desea confirmar el importe a liquidar "+self.MAP_IMPORTE_LIQUIDAR+" y cambiar a la etapa 'Aprobación cliente'?","Negociación",1);
                        if(pregunta==1){
                            objDeuda.CHECK_IMPORTE_LIQUIDAR=1;
                            objDeuda.IDESTADO=5;
                            await objDeuda.save();
                            self.MAP_NEGOCIACION=objDeuda.IMPORTE_LIQUIDAR+" € / "+objDeuda.COMISION_EXITO+" €";
                            self.MAP_IDESTADO_DEUDA=5;
                        }else{
                            self.MAP_CHECK_IMPORTE_LIQUIDAR=0;
                            return;
                        }
                    }
                }
                // comprobaciones para reestructura
                if(producto==2){
                    if(self.MAP_IMPORTE_NUEVO_CHECK==1 && isNullOrEmpty(self.MAP_DEUDA_NEG)){
                        let pregunta= await ui.msgBox("¿Está seguro que desea confirmar el importe actual "+self.MAP_IMPORTE_NUEVO+"?","Negociación",1);
                        if(pregunta==1){
                            objDeuda.CHECK_IMPORTE_NUEVO=1;
                            await objDeuda.save();
                            self.MAP_DEUDA_NEG=objDeuda.IMPORTE_NUEVO+" €";
                        }else{
                            self.MAP_IMPORTE_NUEVO_CHECK=0;
                            return;
                        }
                    }
                    if(self.MAP_CUOTA_CHECK==1 && isNullOrEmpty(self.MAP_CUOTA_NEG)){
                        let pregunta= await ui.msgBox("¿Está seguro que desea confirmar la cuota "+self.MAP_CUOTA+"?","Negociación",1);
                        if(pregunta==1){
                            objDeuda.CHECK_CUOTA=1;
                            await objDeuda.save();
                            self.MAP_CUOTA_NEG=objDeuda.CUOTA+" €";
                        }else{
                            self.MAP_CUOTA_CHECK=0;
                            return;
                        }
                    }
                    if(self.MAP_MESES_CHECK==1 && isNullOrEmpty(safeToString(self.MAP_MESES_NEG))){
                        let pregunta= await ui.msgBox("¿Está seguro que desea confirmar el plazo de "+self.MAP_MESES3+" meses?","Negociación",1);
                        if(pregunta==1){
                            objDeuda.CHECK_PLAZO_PAGAR=1;
                            await objDeuda.save();
                            self.MAP_MESES_NEG=objDeuda.PLAZO_PAGAR;
                        }else{
                            self.MAP_MESES_CHECK=0;
                            return;
                        }
                    }
                    if(self.MAP_CUOTA_INICIAL_CHECK==1 && isNullOrEmpty(safeToString(self.MAP_CUOTA_INI_NEG))){
                        let pregunta= await ui.msgBox("¿Está seguro que desea confirmar la cuota inicial de "+self.MAP_CUOTA_INICIAL+"?","Negociación",1);
                        if(pregunta==1){
                            objDeuda.CHECK_CUOTA_INICIAL=1;
                            await objDeuda.save();
                            self.MAP_CUOTA_INI_NEG=objDeuda.CUOTA_INICIAL+" €";
                            self.MAP_IMPORTE_REF = objDeuda.CUOTA_INICIAL;
                        }else{
                            self.MAP_CUOTA_INICIAL_CHECK=0;
                            self.MAP_IMPORTE_REF = "";
                            return;
                        }
                    }
                    if(self.MAP_FECHA_CUOTA_INI_CHECK==1 && isNullOrEmpty(safeToString(self.MAP_FECHA_CUOTA_INI_NEG))){
                        let pregunta= await ui.msgBox("¿Está seguro que desea confirmar la siguiente fecha para la cuota inicial "+self.MAP_FECHA_CUOTA_INI+"?","Negociación",1);
                        if(pregunta==1){
                            objDeuda.CHECK_FECHA_CUOTA_INICIAL=1;
                            await objDeuda.save();
                            self.MAP_FECHA_CUOTA_INI_NEG=fechaFormateada(objDeuda.FECHA_CUOTA_INICIAL);
                        }else{
                            self.MAP_FECHA_CUOTA_INI_CHECK=0;
                            return;
                        }
                    }
    
                    // comprobamos si los 3 checks están marcados para cambiar de etapa
                    if(objDeuda.CHECK_IMPORTE_NUEVO==1 && objDeuda.CHECK_CUOTA==1 && objDeuda.CHECK_PLAZO_PAGAR==1 && objDeuda.CHECK_CUOTA_INICIAL==1 && objDeuda.CHECK_FECHA_CUOTA_INICIAL==1){
                        let pregunta= await ui.msgBox("¿Está seguro que desea cambiar a la etapa 'Aprobación cliente'? Si no lo hace se desmarcarán de nuevo los checks","Negociación",1);
                        if(pregunta==1){
                            objDeuda.IDESTADO=5;
                            self.MAP_IDESTADO_DEUDA=5;
                            await objDeuda.save();
                        }else{
                            objDeuda.CHECK_IMPORTE_NUEVO=0;
                            objDeuda.CHECK_CUOTA=0;
                            objDeuda.CHECK_PLAZO_PAGAR=0;
                            objDeuda.CHECK_CUOTA_INICIAL=0;
                            objDeuda.CHECK_FECHA_CUOTA_INICIAL=0;
                            await objDeuda.save();
                            self.MAP_IMPORTE_NUEVO_CHECK=0;
                            self.MAP_CUOTA_CHECK=0;
                            self.MAP_MESES_CHECK=0;
                            self.MAP_CUOTA_INICIAL_CHECK=0;
                            self.MAP_FECHA_CUOTA_INI_CHECK=0;
                            self.MAP_DEUDA_NEG="";
                            self.MAP_CUOTA_NEG="";
                            self.MAP_MESES_NEG="";
                            self.MAP_CUOTA_INI_NEG="";
                            self.MAP_FECHA_CUOTA_INI_NEG="";
                            self.MAP_IMPORTE_REF = "";
                        }
                    }
                }
                // Comprobaciones para descuento y fraccionamiento
                if(producto==3){
                    if(self.MAP_CHECK_IMPORTE_LIQUIDAR==1 && objDeuda.CHECK_IMPORTE_LIQUIDAR==0){
                        // comprobaciones
                        if(objDeuda.PAB_MENSUAL <= 0){
                            ui.showToast("Debe indicar el fraccionamiento del importe a liquidar. Falta el Pab mensual");
                            self.MAP_CHECK_IMPORTE_LIQUIDAR=0;
                            return;
                        }
                        if(objDeuda.CE_MENSUAL <= 0){
                            ui.showToast("Debe indicar el fraccionamiento de la comisión de éxito. Falta la CE mensual");
                            self.MAP_CHECK_IMPORTE_LIQUIDAR=0;
                            return;
                        }
                        let pregunta= await ui.msgBox("¿Está seguro que desea confirmar el importe a liquidar "+self.MAP_IMPORTE_LIQUIDAR+"?","Negociación",1);
                        if(pregunta==1){
                            objDeuda.CHECK_IMPORTE_LIQUIDAR=1;
                            await objDeuda.save();
                        }else{
                            self.MAP_CHECK_IMPORTE_LIQUIDAR=0;
                            return;
                        }
                    }
                    if(self.MAP_CHECK_DIA_PAGO==1 && objDeuda.CHECK_DIA_PAGO==0){
                        if(safeToInt(self.MAP_DIA_PAGO)==0){
                            ui.showToast("Debe indicar el día de pago. Falta día de pago");
                            self.MAP_CHECK_DIA_PAGO=0;
                            return;
                        }
                        let pregunta= await ui.msgBox("¿Está seguro que desea confirmar el día de pago "+self.MAP_DIA_PAGO+"?","Negociación",1);
                        if(pregunta==1){
                            objDeuda.CHECK_DIA_PAGO=1;
                            await objDeuda.save();
                        }else{
                            self.MAP_CHECK_DIA_PAGO=0;
                            return;
                        }
                    }
                    if(objDeuda.CHECK_IMPORTE_LIQUIDAR==1 && objDeuda.CHECK_DIA_PAGO==1){
                        let pregunta= await ui.msgBox("¿Está seguro que desea confirmar el importe a liquidar "+self.MAP_IMPORTE_LIQUIDAR+", los pagos mensuales en "+self.MAP_MESES1+" meses, la comisión de éxito en "+self.MAP_MESES2+" meses, el "+self.MAP_DIA_PAGO+" como día de pago y cambiar a la etapa 'Plan de pagos'?","Negociación",1);
                        if(pregunta==1){
                            objDeuda.IDESTADO=4;
                            await objDeuda.save();
                            self.MAP_NEGOCIACION=objDeuda.IMPORTE_LIQUIDAR+" € / "+objDeuda.PAB_MENSUAL+" € / "+objDeuda.IMPORTE_REMANENTE+" € / "+objDeuda.CE_MENSUAL+" €";
                            self.MAP_IDESTADO_DEUDA=4;
                        }else{
                            self.MAP_CHECK_IMPORTE_LIQUIDAR=0;
                            self.MAP_CHECK_DIA_PAGO=0;
                            objDeuda.CHECK_IMPORTE_LIQUIDAR=0;
                            objDeuda.CHECK_DIA_PAGO=0;
                            await objDeuda.save();
                            return;
                        }
                    }
                }
            }
            
        // para las etapas de interposición de demanda
        }else if(producto == 4){
            
            // recopilación de documentación
            if(idestadoDeuda==1){
                if(self.MAP_CHECK_RECOPILACION==1){
                    let pregunta= await ui.msgBox("¿Está seguro que desea dar por concluida la recopilación de documentación y cambiar a la etapa 'Estudio de viabilidad'?","Recopilación documentación",1);
                    if(pregunta==1){
                        // !!!
                        // concepto 15. recopilación de la documentación
                        await generarActualizacion(self,objDeuda.ID,objDeuda.IDESTADO,producto);
                        
                        objDeuda.CHECK_RECOPILACION_DEMANDA=1;
                        objDeuda.IDESTADO=2;
                        await objDeuda.save();
                        
                        self.MAP_IDESTADO_DEUDA=2;
                        // concepto 16. estudio de viabilidad, pendiente
                        await generarActualizacion(self,objDeuda.ID,objDeuda.IDESTADO,producto);
                    }else{
                        self.MAP_CHECK_RECOPILACION=0;
                        return;
                    }
                }
            }
            // !!!
            // estudio viabilidad
            if(idestadoDeuda==2){
                if(self.MAP_ENTIDAD_CHECK_DEM==1 && isNullOrEmpty(safeToString(self.MAP_CUOTA_INI_NEG))){
                    let pregunta= await ui.msgBox("¿Está seguro que desea confirmar la entidad "+self.MAP_ENTIDAD_ACTUAL_DEM+"?","Estudio viabilidad",1);
                    if(pregunta==1){
                        objDeuda.CHECK_IDENTIDAD_NUEVO_DEMANDA=1;
                        await objDeuda.save();
                    }else{
                        self.MAP_ENTIDAD_CHECK_DEM=0;
                        return;
                    }
                }
            }
        }
    }

    await comprobarEstadoDeuda(objDeuda.IDESTADO,producto,iddeuda);
    await actualizarDatosContent(self,"DeudaClientePrograma");
}

async function cambioProductoDeuda(objself){
    // Función para el cambio de producto en las deudas del programa
    var productos = [1,2,3]; // 1=descuento, 2=refinanciación, 3=fraccionamiento
    var cnt = await objself.getContents("DeudaClientePrograma");
    await filtrarContentMacroObject(cnt,"d.ID="+objself.MAP_IDDEUDA+" AND ifnull(d.BAJA,0)=0");
    
    if(cnt.count()>0){
        let objDeuda = cnt.getItem(0);
        
        // !!!
        // si decide cambiar el producto, reseteamos etapas
        let pregunta = await ui.msgBox("Va a cambiar de producto, esto supondrá el reseteo de etapas y pérdida de los datos asociadas a las mismas. ¿Desea continuar?","Atención cambio de producto",1);
        
        if(pregunta == 1){
            
            // borramos datos en función de la etapa y el producto previo
            
            // Si los productos son (descuento, refinanciación o fraccionado) y está en la etapa búsqueda = limpiamos o si cambia a interposición demanda, limpiamos
            if((productos.includes(objself.MAP_IDPRODUCTO) && objself.MAP_IDESTADO_DEUDA==2) || objself.MAP_IDPRODUCTO_COMBO == 4){
                
                objself.MAP_ENTIDAD_CHECK = 0;
                objself.MAP_ENTIDAD_ACTUAL = "";
                objself.MAP_IMPORTE_NUEVO = "";
                
                objDeuda.CHECK_IDENTIDAD_NUEVO = 0;
                objDeuda.IDENTIDAD_NUEVO = 0;
                objDeuda.IMPORTE_NUEVO = 0;
            }
            
            // Si los productos son (descuento, refinanciación o fraccionado) y está en la etapa negociación = limpiamos o si cambia a interposición demanda, limpiamos
            if((productos.includes(objself.MAP_IDPRODUCTO) && objself.MAP_IDESTADO_DEUDA==3) || objself.MAP_IDPRODUCTO_COMBO == 4){
                // vaciamos los campos que participan en la etapa negociación
                objself.MAP_CUOTA="";
                objself.MAP_CUOTA_CHECK=0;
                objself.MAP_MESES3=0;
                objself.MAP_MESES_CHECK=0;
                objself.MAP_INTERES="";
                objself.MAP_IMPORTE_LIQUIDAR="";
                objself.MAP_CHECK_IMPORTE_LIQUIDAR=0;
                objself.MAP_DESCUENTO="";
                objself.MAP_MESES1=0;
                objself.MAP_PAB_MENSUAL="";
                objself.MAP_IMPORTE_INICIAL_FRACCIONADO="";
                objself.MAP_PAB_REMANENTE="";
                objself.MAP_COMISION_EXITO="";
                objself.MAP_TOTAL_PAGAR="";
                objself.MAP_MESES2=0;
                objself.MAP_CE_MENSUAL="";
                objself.MAP_DIA_PAGO=0;
                objself.MAP_CHECK_DIA_PAGO=0;
                objself.MAP_CUOTA_INICIAL_CHECK=0;
                objself.MAP_FECHA_CUOTA_INI_CHECK=0;
                objself.MAP_CUOTA_INICIAL=0;
                objself.MAP_FECHA_CUOTA_INI="";
                // vaciamos la parte derecha de las deudas, en negociación
                objself.MAP_NEGOCIACION="";
                objself.MAP_DEUDA_NEG="";
                objself.MAP_CUOTA_NEG="";
                objself.MAP_MESES_NEG="";
                objself.MAP_CUOTA_INI_NEG="";
                objself.MAP_FECHA_CUOTA_INI_NEG="";
                objself.MAP_IMPORTE_REF=0;
                
                objDeuda.CUOTA=0;
                objDeuda.CHECK_CUOTA=0;
                objDeuda.PLAZO_PAGAR=0;
                objDeuda.CHECK_PLAZO_PAGAR=0;
                objDeuda.TASA_INTERES=0;
                objDeuda.IMPORTE_LIQUIDAR=0;
                objDeuda.CHECK_IMPORTE_LIQUIDAR=0;
                objDeuda.DESCUENTO_SOBRE_INICIAL=0;
                objDeuda.PAB_MENSUAL=0;
                objDeuda.IMPORTE_INICIAL_FRACCIONADO=0;
                objDeuda.PAB_REMANENTE=0;
                objDeuda.COMISION_EXITO=0;
                objDeuda.TOTAL_PAGAR=0;
                objDeuda.PLAZO_COMISION=0;
                objDeuda.CE_MENSUAL=0;
                objDeuda.DIA_PAGO=0;
                objDeuda.CHECK_DIA_PAGO=0;
                objDeuda.CHECK_CUOTA_INICIAL=0;
                objDeuda.CHECK_FECHA_CUOTA_INICIAL=0;
                objDeuda.CUOTA_INICIAL=0;
                objDeuda.FECHA_CUOTA_INICIAL="";
            }
            
            // Si cambia de interposición demanda a los productos (descuento, refinanciación o fraccionado) limpiamos
            if(objself.MAP_IDPRODUCTO == 4 && productos.includes(objself.MAP_IDPRODUCTO_COMBO)){
                objself.MAP_CHECK_RECOPILACION = 0;
                objDeuda.CHECK_RECOPILACION_DEMANDA = 0;
            }
            
            
            // si cambiamos de algún producto (1,2,3) a interposición demanda (4), volvemos a la etapa 1. Si es al revés, volvemos a etapa 2
            if(productos.includes(objself.MAP_IDPRODUCTO) && objself.MAP_IDPRODUCTO_COMBO == 4){
                objDeuda.IDESTADO = 1;
                objself.MAP_IDESTADO_DEUDA = 1;
                
            } else if(objself.MAP_IDPRODUCTO == 4 && productos.includes(objself.MAP_IDPRODUCTO_COMBO)){
                objDeuda.IDESTADO = 2;
                objself.MAP_IDESTADO_DEUDA = 2;
                
            }
            
            // asignamos el nuevo producto
            objself.MAP_IDPRODUCTO = objself.MAP_IDPRODUCTO_COMBO;
            objDeuda.IDPRODUCTO_FINANCIERO_ACTUAL = objself.MAP_IDPRODUCTO_COMBO;
            
            await objDeuda.save();
        }else{
            // dejamos el combo con el producto actual de la deuda
            objself.MAP_IDPRODUCTO_COMBO = objself.MAP_IDPRODUCTO;
        }
    }
    await actualizarDatosContent(objself,"DeudaClientePrograma");
}

async function volverEtapaDeuda(objself,iddeuda,etapaDeuda,producto){
    var objDeuda, objDoc, objDocCertificado;
    var collDoc = appData.getCollection("DocumentoScript");
    
    let collDeuda = appData.getCollection("DeudaClienteScript");
    await filtrarCollMacroObject(collDeuda,"d.ID="+iddeuda+" AND ifnull(d.BAJA,0)=0");
    
    if(collDeuda.count()>0){
        objDeuda = collDeuda.getItem(0);
        
        // Comprobamos en qué etapa estamos para volver a la anterior y borrar datos en pantalla y en la deuda
        // Negociación
        if(etapaDeuda==3){
            let pregunta = await ui.msgBox("¿Desea volver a la etapa 'Búsqueda'? Se borrarán los datos de la etapa actual","Cambio a etapa búsqueda",1);
            if(pregunta==1){
                objself.MAP_CUOTA="";
                objself.MAP_CUOTA_CHECK=0;
                objself.MAP_MESES3=0;
                objself.MAP_MESES_CHECK=0;
                objself.MAP_INTERES="";
                objself.MAP_IMPORTE_LIQUIDAR="";
                objself.MAP_CHECK_IMPORTE_LIQUIDAR=0;
                objself.MAP_DESCUENTO="";
                objself.MAP_MESES1=0;
                objself.MAP_PAB_MENSUAL="";
                objself.MAP_COMISION_EXITO="";
                objself.MAP_TOTAL_PAGAR="";
                objself.MAP_MESES2=0;
                objself.MAP_CE_MENSUAL="";
                objself.MAP_DIA_PAGO=0;
                objself.MAP_CHECK_DIA_PAGO=0;
                objself.MAP_CUOTA_INICIAL="";
                objself.MAP_CUOTA_INICIAL_CHECK=0;
                objself.MAP_FECHA_CUOTA_INI="";
                objself.MAP_FECHA_CUOTA_INI_CHECK=0;
                
                // vaciamos la parte derecha de las deudas, en negociación
                objself.MAP_NEGOCIACION="";
                objself.MAP_DEUDA_NEG="";
                objself.MAP_CUOTA_NEG="";
                objself.MAP_MESES_NEG="";
                objself.MAP_CUOTA_INI_NEG="";
                objself.MAP_FECHA_CUOTA_INI_NEG="";
                objself.MAP_ENTIDAD_CHECK=0;
                objself.MAP_IDESTADO_DEUDA=2;
                
                objDeuda.CUOTA=0;
                objDeuda.CHECK_CUOTA=0;
                objDeuda.PLAZO_PAGAR=0;
                objDeuda.CHECK_PLAZO_PAGAR=0;
                objDeuda.TASA_INTERES=0;
                objDeuda.IMPORTE_LIQUIDAR=0;
                objDeuda.CHECK_IMPORTE_LIQUIDAR=0;
                objDeuda.DESCUENTO_SOBRE_INICIAL=0;
                objDeuda.PAB_MENSUAL=0;
                objDeuda.COMISION_EXITO=0;
                objDeuda.TOTAL_PAGAR=0;
                objDeuda.PLAZO_COMISION=0;
                objDeuda.CE_MENSUAL=0;
                objDeuda.DIA_PAGO=0;
                objDeuda.CHECK_DIA_PAGO=0;
                objDeuda.CHECK_IDENTIDAD_NUEVO=0;
                objDeuda.CUOTA_INICIAL=0;
                objDeuda.CHECK_CUOTA_INICIAL=0;
                objDeuda.FECHA_CUOTA_INICIAL="";
                objDeuda.CHECK_FECHA_CUOTA_INICIAL=0;
                objDeuda.IDESTADO=2;
                await objDeuda.save();
            }else{
                return;
            }
        }
        // plan de pagos
        if(etapaDeuda==4){
            let pregunta = await ui.msgBox("¿Desea volver a la etapa 'Negociación'?","Cambio a etapa negociación",1);
            if(pregunta==1){
                objself.MAP_CHECK_DIA_PAGO=0;
                objself.MAP_CHECK_IMPORTE_LIQUIDAR=0;
                objself.MAP_NEGOCIACION="";
                objself.MAP_IDESTADO_DEUDA=3;
                
                objDeuda.CHECK_DIA_PAGO=0;
                objDeuda.CHECK_IMPORTE_LIQUIDAR=0;
                objDeuda.IDESTADO=3;
                await objDeuda.save();
            }else{
                return;
            }
        }
        // aprobación cliente
        if(etapaDeuda==5){
            if(producto==1 || producto==2){
                let pregunta = await ui.msgBox("¿Desea volver a la etapa 'Negociación'?","Cambio a etapa negociación",1);
                if(pregunta==1){
                    objself.MAP_CHECK_IMPORTE_LIQUIDAR=0;
                    objself.MAP_IMPORTE_NUEVO_CHECK=0;
                    objself.MAP_CUOTA_CHECK=0;
                    objself.MAP_MESES_CHECK=0;
                    objself.MAP_CUOTA_INICIAL_CHECK=0;
                    objself.MAP_FECHA_CUOTA_INI_CHECK=0;
                    objself.MAP_IDESTADO_DEUDA=3;
                    objself.MAP_IMPORTE_REF = 0;
                    
                    objself.MAP_NEGOCIACION="";
                    objself.MAP_DEUDA_NEG="";
                    objself.MAP_CUOTA_NEG="";
                    objself.MAP_MESES_NEG="";
                    objself.MAP_CUOTA_INI_NEG="";
                    objself.MAP_FECHA_CUOTA_INI_NEG="";
                    
                    objDeuda.CHECK_IMPORTE_LIQUIDAR=0;
                    objDeuda.CHECK_IMPORTE_NUEVO=0;
                    objDeuda.CHECK_CUOTA=0;
                    objDeuda.CHECK_PLAZO_PAGAR=0;
                    objDeuda.IDESTADO=3;
                    objDeuda.CHECK_CUOTA_INICIAL=0;
                    objDeuda.CHECK_CUOTA_INICIAL=0;

                    await objDeuda.save();
                }else{
                    return;
                }
            }
            // producto fraccionamiento
            else if(producto==3){
                let pregunta = await ui.msgBox("¿Desea volver a la etapa 'Plan de pagos'? El plan generado actualmente perderá validez","Cambio a etapa negociación",1);
                if(pregunta==1){
                    // buscamos el plan de pagos actual y lo damos de baja. Lo recorremos para marcar todos los mee s
                    var collPlanPago = appData.getCollection("PlanDePagosScript");
                    await filtrarCollMacroObject(collPlanPago,"p.IDDEUDA="+iddeuda+" and p.BAJA=0");
                    
                    ui.showToast("Borrando plan...");
                    for(var i=0;i<collPlanPago.count();i++){
                        let objPlanPago=collPlanPago.getItem(i);
                        objPlanPago.BAJA=1;
                        await objPlanPago.save();
                    }
                    await actualizarDatosContent(objself,"PlanDePagos");
                    
                    objself.MAP_IDESTADO_DEUDA=4;
                    
                    objDeuda.IDESTADO=4;
                    await objDeuda.save();
                }else{
                    return;
                }
            }
        }
        // seguimiento pagos
        if(etapaDeuda==6){
            // fraccionamiento
            let pregunta = await ui.msgBox("¿Desea volver a la etapa 'Aprobación cliente'? Aviso: los documentos adjuntos en dicha etapa perderán validez","Cambio a etapa aprobación cliente",1);
            if(pregunta==1){
                objself.MAP_IDESTADO_DEUDA=5;

                objDeuda.IDESTADO=5;
                await objDeuda.save();
                
                // Buscamos el documento de aprobación cliente, lo marcamos como rechazado y lo dejamos visible en la zona de ususario
                await filtrarCollMacroObject(collDoc,"d.IDDEUDACLIENTE="+iddeuda+" AND d.IDTIPO=10 AND d.ACEPTADO IN(0,1)");
                
                if(collDoc.count()>0){
                    objDoc = collDoc.getItem(0);
                    
                    objDoc.ACEPTADO=2;
                    objDoc.DOCUMENTO_VISIBLE=1;
                    await objDoc.save();
                    objself.MAP_DOCUMENTO_APROBACION="";
                    await actualizarDatosPaginadoLeads(objself,"Documento","DocumentoContador","MAP_PAG_INI_DOC","MAP_PAG_LEN_DOC","MAP_TOTAL_REGISTROS_DOC","MAP_T1_DOC");
                }
            }else{
                return;
            }
        }
        // cobro comisión
        if(etapaDeuda==7){
            // Buscamos si se ha generado un movimiento y está aceptado o pendiente
            var collMov = appData.getCollection("MovimientosScript");
            
            // buscamos si se ha realizado una rectificación previa para permitir volver en la etapa
            var comisionRectificada = await comprobarRectificativa(iddeuda,objself.ID);
            
            if(comisionRectificada === 0){
                await filtrarCollMacroObject(collMov,"m.IDDEUDA="+objself.MAP_IDDEUDA+" and m.IDLEAD="+objself.ID+" and m.IDTIPO_MOVIMIENTO=3 AND m.IDESTADO IN(5,6,7,10)");

                if(collMov.count()>0){
                    ui.showToast("Existe un cobro pendiente/cobrado asociado a la deuda. No se puede volver a la etapa anterior");
                    return;
                }
            }
            
            
            
            if(producto==1 || producto==2){
                // descuento y refinanciación
                let pregunta = await ui.msgBox("¿Desea volver a la etapa 'Aprobación cliente'? Aviso: los documentos adjuntos en dicha etapa perderán validez","Cambio a etapa aprobación cliente",1);
                if(pregunta==1){
                    objself.MAP_IDESTADO_DEUDA=5;
    
                    objDeuda.IDESTADO=5;
                    await objDeuda.save();
                    
                    // Buscamos el documento de aprobación cliente, lo marcamos como rechazado y lo dejamos visible en la zona de usuario
                    await filtrarCollMacroObject(collDoc,"d.IDDEUDACLIENTE="+iddeuda+" AND d.IDTIPO=10 AND d.ACEPTADO IN(0,1)");
                    
                    if(collDoc.count()>0){
                        objDoc = collDoc.getItem(0);
                        
                        objDoc.ACEPTADO=2;
                        objDoc.DOCUMENTO_VISIBLE=1;
                        await objDoc.save();
                        objself.MAP_DOCUMENTO_APROBACION="";
                        await actualizarDatosPaginadoLeads(objself,"Documento","DocumentoContador","MAP_PAG_INI_DOC","MAP_PAG_LEN_DOC","MAP_TOTAL_REGISTROS_DOC","MAP_T1_DOC");
                    }
                }else{
                    return;
                }
            }else{
                // para fraccionamiento
                let pregunta = await ui.msgBox("¿Desea volver a la etapa 'Seguimiento pagos'?","Cambio a etapa seguimiento pagos",1);
                if(pregunta==1){
                    objself.MAP_IDESTADO_DEUDA=6;
    
                    objDeuda.IDESTADO=6;
                    await objDeuda.save();
                }else{
                    return;
                }
            }
        }
        // pago financiera
        if(etapaDeuda==8){
            let pregunta = await ui.msgBox("¿Desea volver a la etapa 'Cobro comisión'?","Cambio a etapa cobro comisión",1);
            if(pregunta==1){
                objself.MAP_IDESTADO_DEUDA=7;

                objDeuda.IDESTADO=7;
                await objDeuda.save();
            }else{
                return;
            }
        }
        // justificante de transferencia
        if(etapaDeuda==9){
            if(producto==1 || producto==2){
                let pregunta = await ui.msgBox("¿Desea volver a la etapa 'Pago financiera'?","Cambio a etapa pago financiera",1);
                if(pregunta==1){
                    objself.MAP_IDESTADO_DEUDA=8;
                    
                    objDeuda.IDESTADO=8;
                    await objDeuda.save();
                }else{
                    return;
                }
            }
        }
        // certificado financiera
        if(etapaDeuda==10){
            if(producto==1 || producto==2){
                let pregunta = await ui.msgBox("¿Desea volver a la etapa 'Justificante de transferencia'? Aviso: los documentos adjuntos en dicha etapa perderán validez","Cambio a etapa justificante de transferencia",1);
                if(pregunta==1){
                    // todo: Desmarcar deuda liquidada si fuera necesario
                    objDeuda.LIQUIDADA=0;
                    objDeuda.IDESTADO=9;
                    await objDeuda.save();
                    
                    objself.MAP_IDESTADO_DEUDA=9;
                    objself.MAP_DEUDA_LIQUIDADA=0;
                    
                    // Buscamos el documento de certificado financiera y lo marcamos como rechazado
                    await filtrarCollMacroObject(collDoc,"d.IDDEUDACLIENTE="+iddeuda+" AND d.IDTIPO=18 AND d.ACEPTADO IN(0,1)");
                    
                    if(collDoc.count()>0){
                        objDocCertificado = collDoc.getItem(0);
                        
                        objDocCertificado.ACEPTADO=2;
                        await objDocCertificado.save();
                        objself.MAP_DOCUMENTO_CERTIFICADO="";
                    }
                    
                    // Buscamos el documento de justificante de transferencia y lo marcamos como rechazado
                    await filtrarCollMacroObject(collDoc,"d.IDDEUDACLIENTE="+iddeuda+" AND d.IDTIPO=17 AND d.ACEPTADO IN(0,1)");
                    
                    if(collDoc.count()>0){
                        objDoc = collDoc.getItem(0);
                        
                        objDoc.ACEPTADO=2;
                        await objDoc.save();
                        objself.MAP_DOCUMENTO_JUSTIFICANTE="";
                    }
                    
                    await actualizarDatosPaginadoLeads(objself,"Documento","DocumentoContador","MAP_PAG_INI_DOC","MAP_PAG_LEN_DOC","MAP_TOTAL_REGISTROS_DOC","MAP_T1_DOC");
                    
                    // Si el producto es refinanciación, sumamos el valor a le deuda neta al no estar liquidada
                    // if(producto==2){
                    //     objself.DEUDA_NETA_CLIENTE= objself.DEUDA_NETA_CLIENTE + objDeuda.IMPORTE_ACTUAL;
                    //     objself.MAP_DEUDA_TOTAL_NETA= objself.DEUDA_NETA_CLIENTE+" €";
                    //     await objself.save();
                    // }
                    
                    // comprobamos el nº de deudas saldadas para el cliente
                    let total=0;
                    let deudasSolucionadas=0;
                    for(var i=0;i<collDeuda.count();i++){
                        let item = collDeuda.getItem(i);
                        if(item.LIQUIDADA==1){
                            deudasSolucionadas=deudasSolucionadas+1;
                        }
                        total=total+1;
                    }
                    objself.MAP_DEUDAS_SOLUCIONADAS=deudasSolucionadas+"/"+total;
                }else{
                    return;
                }
            }
        }
        await actualizarDatosContent(objself,"DeudaClientePrograma");
    }else{
        ui.showToast("No se ha encontrado la deuda seleccionada");
    }
}

async function comprobarEstadoDeuda(idestadoDeuda, producto, iddeuda){
    var collMov = appData.getCollection("MovimientosScript");
    
    // Para una deuda seleccionada comprobamos el color de cada etapa cuando ésta cambia

    // para productos DC, RT y DF
    if(idestadoDeuda==1){
        self.MAP_IMG_PROGRESO_DEUDA1="deudaAmarillo.png";
        self.MAP_IMG_PROGRESO_DEUDA2="deudaGris.png";
        self.MAP_IMG_PROGRESO_DEUDA3="deudaGris.png";
        self.MAP_IMG_PROGRESO_DEUDA4="deudaGris.png";
        self.MAP_IMG_PROGRESO_DEUDA5="deudaGris.png";
        self.MAP_IMG_PROGRESO_DEUDA6="deudaGris.png";
        self.MAP_IMG_PROGRESO_DEUDA7="deudaGris.png";
        self.MAP_IMG_PROGRESO_DEUDA8="deudaGris.png";
        self.MAP_IMG_PROGRESO_DEUDA9="deudaGris.png";
        self.MAP_IMG_PROGRESO_DEUDA10="deudaGris.png";
        
        self.setFieldPropertyValue("MAP_PLAN_PAGO","bgcolor","#878787");
        self.setFieldPropertyValue("MAP_APROBACION_CLIENTE","bgcolor","#878787");
        self.setFieldPropertyValue("MAP_ADJ_APROBACION_CLIENTE","bgcolor","#878787");
        self.setFieldPropertyValue("MAP_SALTAR_COBRO_COMISION","bgcolor","#878787");
        self.setFieldPropertyValue("MAP_COBRO_COMISION","bgcolor","#878787");
        self.setFieldPropertyValue("MAP_PAGO_FINANCIERA","bgcolor","#878787");
        self.setFieldPropertyValue("MAP_JUSTIFICANTE_TRANSFERENCIA","bgcolor","#878787");
        self.setFieldPropertyValue("MAP_CERTIFICADO_FINANCIERA","bgcolor","#878787");
    }else if(idestadoDeuda==2){
        self.MAP_IMG_PROGRESO_DEUDA1="deudaVerde.png";
        self.MAP_IMG_PROGRESO_DEUDA2="deudaAmarillo.png";
        self.MAP_IMG_PROGRESO_DEUDA3="deudaGris.png";
        self.MAP_IMG_PROGRESO_DEUDA4="deudaGris.png";
        self.MAP_IMG_PROGRESO_DEUDA5="deudaGris.png";
        self.MAP_IMG_PROGRESO_DEUDA6="deudaGris.png";
        self.MAP_IMG_PROGRESO_DEUDA7="deudaGris.png";
        self.MAP_IMG_PROGRESO_DEUDA8="deudaGris.png";
        self.MAP_IMG_PROGRESO_DEUDA9="deudaGris.png";
        self.MAP_IMG_PROGRESO_DEUDA10="deudaGris.png";
        
        self.setFieldPropertyValue("MAP_PLAN_PAGO","bgcolor","#878787");
        self.setFieldPropertyValue("MAP_APROBACION_CLIENTE","bgcolor","#878787");
        self.setFieldPropertyValue("MAP_ADJ_APROBACION_CLIENTE","bgcolor","#878787");
        self.setFieldPropertyValue("MAP_SALTAR_COBRO_COMISION","bgcolor","#878787");
        self.setFieldPropertyValue("MAP_COBRO_COMISION","bgcolor","#878787");
        self.setFieldPropertyValue("MAP_PAGO_FINANCIERA","bgcolor","#878787");
        self.setFieldPropertyValue("MAP_JUSTIFICANTE_TRANSFERENCIA","bgcolor","#878787");
        self.setFieldPropertyValue("MAP_CERTIFICADO_FINANCIERA","bgcolor","#878787");
    }else if(idestadoDeuda==3){
        self.MAP_IMG_PROGRESO_DEUDA1="deudaVerde.png";
        self.MAP_IMG_PROGRESO_DEUDA2="deudaVerde.png";
        self.MAP_IMG_PROGRESO_DEUDA3="deudaAmarillo.png";
        self.MAP_IMG_PROGRESO_DEUDA4="deudaGris.png";
        self.MAP_IMG_PROGRESO_DEUDA5="deudaGris.png";
        self.MAP_IMG_PROGRESO_DEUDA6="deudaGris.png";
        self.MAP_IMG_PROGRESO_DEUDA7="deudaGris.png";
        self.MAP_IMG_PROGRESO_DEUDA8="deudaGris.png";
        self.MAP_IMG_PROGRESO_DEUDA9="deudaGris.png";
        self.MAP_IMG_PROGRESO_DEUDA10="deudaGris.png";
        
        self.setFieldPropertyValue("MAP_PLAN_PAGO","bgcolor","#878787");
        self.setFieldPropertyValue("MAP_APROBACION_CLIENTE","bgcolor","#878787");
        self.setFieldPropertyValue("MAP_ADJ_APROBACION_CLIENTE","bgcolor","#878787");
        self.setFieldPropertyValue("MAP_SALTAR_COBRO_COMISION","bgcolor","#878787");
        self.setFieldPropertyValue("MAP_COBRO_COMISION","bgcolor","#878787");
        self.setFieldPropertyValue("MAP_PAGO_FINANCIERA","bgcolor","#878787");
        self.setFieldPropertyValue("MAP_JUSTIFICANTE_TRANSFERENCIA","bgcolor","#878787");
        self.setFieldPropertyValue("MAP_CERTIFICADO_FINANCIERA","bgcolor","#878787");
    }else if(idestadoDeuda==4){
        self.MAP_IMG_PROGRESO_DEUDA1="deudaVerde.png";
        self.MAP_IMG_PROGRESO_DEUDA2="deudaVerde.png";
        self.MAP_IMG_PROGRESO_DEUDA3="deudaVerde.png";
        self.MAP_IMG_PROGRESO_DEUDA4="deudaAmarillo.png";
        self.MAP_IMG_PROGRESO_DEUDA5="deudaGris.png";
        self.MAP_IMG_PROGRESO_DEUDA6="deudaGris.png";
        self.MAP_IMG_PROGRESO_DEUDA7="deudaGris.png";
        self.MAP_IMG_PROGRESO_DEUDA8="deudaGris.png";
        self.MAP_IMG_PROGRESO_DEUDA9="deudaGris.png";
        self.MAP_IMG_PROGRESO_DEUDA10="deudaGris.png";
        
        self.setFieldPropertyValue("MAP_PLAN_PAGO","bgcolor","#3E2554");
        self.setFieldPropertyValue("MAP_APROBACION_CLIENTE","bgcolor","#878787");
        self.setFieldPropertyValue("MAP_ADJ_APROBACION_CLIENTE","bgcolor","#878787");
        self.setFieldPropertyValue("MAP_SALTAR_COBRO_COMISION","bgcolor","#878787");
        self.setFieldPropertyValue("MAP_COBRO_COMISION","bgcolor","#878787");
        self.setFieldPropertyValue("MAP_PAGO_FINANCIERA","bgcolor","#878787");
        self.setFieldPropertyValue("MAP_JUSTIFICANTE_TRANSFERENCIA","bgcolor","#878787");
        self.setFieldPropertyValue("MAP_CERTIFICADO_FINANCIERA","bgcolor","#878787");
    }else if(idestadoDeuda==5){
        self.MAP_IMG_PROGRESO_DEUDA1="deudaVerde.png";
        self.MAP_IMG_PROGRESO_DEUDA2="deudaVerde.png";
        self.MAP_IMG_PROGRESO_DEUDA3="deudaVerde.png";
        self.MAP_IMG_PROGRESO_DEUDA4="deudaVerde.png";
        self.MAP_IMG_PROGRESO_DEUDA5="deudaAmarillo.png";
        self.MAP_IMG_PROGRESO_DEUDA6="deudaGris.png";
        self.MAP_IMG_PROGRESO_DEUDA7="deudaGris.png";
        self.MAP_IMG_PROGRESO_DEUDA8="deudaGris.png";
        self.MAP_IMG_PROGRESO_DEUDA9="deudaGris.png";
        self.MAP_IMG_PROGRESO_DEUDA10="deudaGris.png";
        
        self.setFieldPropertyValue("MAP_PLAN_PAGO","bgcolor","#878787");
        self.setFieldPropertyValue("MAP_APROBACION_CLIENTE","bgcolor","#3E2554");
        self.setFieldPropertyValue("MAP_ADJ_APROBACION_CLIENTE","bgcolor","#3E2554");
        self.setFieldPropertyValue("MAP_SALTAR_COBRO_COMISION","bgcolor","#878787");
        self.setFieldPropertyValue("MAP_COBRO_COMISION","bgcolor","#878787");
        self.setFieldPropertyValue("MAP_PAGO_FINANCIERA","bgcolor","#878787");
        self.setFieldPropertyValue("MAP_JUSTIFICANTE_TRANSFERENCIA","bgcolor","#878787");
        self.setFieldPropertyValue("MAP_CERTIFICADO_FINANCIERA","bgcolor","#878787");
    }else if(idestadoDeuda==6){
        self.MAP_IMG_PROGRESO_DEUDA1="deudaVerde.png";
        self.MAP_IMG_PROGRESO_DEUDA2="deudaVerde.png";
        self.MAP_IMG_PROGRESO_DEUDA3="deudaVerde.png";
        self.MAP_IMG_PROGRESO_DEUDA4="deudaVerde.png";
        self.MAP_IMG_PROGRESO_DEUDA5="deudaVerde.png";
        self.MAP_IMG_PROGRESO_DEUDA6="deudaAmarillo.png";
        self.MAP_IMG_PROGRESO_DEUDA7="deudaGris.png";
        self.MAP_IMG_PROGRESO_DEUDA8="deudaGris.png";
        self.MAP_IMG_PROGRESO_DEUDA9="deudaGris.png";
        self.MAP_IMG_PROGRESO_DEUDA10="deudaGris.png";
        
        self.setFieldPropertyValue("MAP_PLAN_PAGO","bgcolor","#878787");
        self.setFieldPropertyValue("MAP_APROBACION_CLIENTE","bgcolor","#878787");
        self.setFieldPropertyValue("MAP_ADJ_APROBACION_CLIENTE","bgcolor","#878787");
        self.setFieldPropertyValue("MAP_SALTAR_COBRO_COMISION","bgcolor","#878787");
        self.setFieldPropertyValue("MAP_COBRO_COMISION","bgcolor","#878787");
        self.setFieldPropertyValue("MAP_PAGO_FINANCIERA","bgcolor","#878787");
        self.setFieldPropertyValue("MAP_JUSTIFICANTE_TRANSFERENCIA","bgcolor","#878787");
        self.setFieldPropertyValue("MAP_CERTIFICADO_FINANCIERA","bgcolor","#878787");
    }else if(idestadoDeuda==7){
        self.MAP_IMG_PROGRESO_DEUDA1="deudaVerde.png";
        self.MAP_IMG_PROGRESO_DEUDA2="deudaVerde.png";
        self.MAP_IMG_PROGRESO_DEUDA3="deudaVerde.png";
        self.MAP_IMG_PROGRESO_DEUDA4="deudaVerde.png";
        self.MAP_IMG_PROGRESO_DEUDA5="deudaVerde.png";
        self.MAP_IMG_PROGRESO_DEUDA6="deudaVerde.png";
        self.MAP_IMG_PROGRESO_DEUDA7="deudaAmarillo.png";
        self.MAP_IMG_PROGRESO_DEUDA8="deudaGris.png";
        self.MAP_IMG_PROGRESO_DEUDA9="deudaGris.png";
        self.MAP_IMG_PROGRESO_DEUDA10="deudaGris.png";
        
        self.setFieldPropertyValue("MAP_PLAN_PAGO","bgcolor","#878787");
        self.setFieldPropertyValue("MAP_APROBACION_CLIENTE","bgcolor","#878787");
        self.setFieldPropertyValue("MAP_ADJ_APROBACION_CLIENTE","bgcolor","#878787");
        self.setFieldPropertyValue("MAP_SALTAR_COBRO_COMISION","bgcolor","#3E2554");
        self.setFieldPropertyValue("MAP_COBRO_COMISION","bgcolor","#3E2554");
        self.setFieldPropertyValue("MAP_PAGO_FINANCIERA","bgcolor","#878787");
        self.setFieldPropertyValue("MAP_JUSTIFICANTE_TRANSFERENCIA","bgcolor","#878787");
        self.setFieldPropertyValue("MAP_CERTIFICADO_FINANCIERA","bgcolor","#878787");
    }else if(idestadoDeuda==8){
        self.MAP_IMG_PROGRESO_DEUDA1="deudaVerde.png";
        self.MAP_IMG_PROGRESO_DEUDA2="deudaVerde.png";
        self.MAP_IMG_PROGRESO_DEUDA3="deudaVerde.png";
        self.MAP_IMG_PROGRESO_DEUDA4="deudaVerde.png";
        self.MAP_IMG_PROGRESO_DEUDA5="deudaVerde.png";
        self.MAP_IMG_PROGRESO_DEUDA6="deudaVerde.png";
        
        // Comprobamos si hay algún cobro de comisión en diferido para avisar al comercial
        
        await filtrarCollMacroObject(collMov,"m.IDDEUDA="+iddeuda+" AND m.IDTIPO_MOVIMIENTO=3 AND m.IDESTADO IN(5,10)");
        if(collMov.count() > 0){
            self.MAP_IMG_PROGRESO_DEUDA7="deudaAmarillo.png";
        }else{
            self.MAP_IMG_PROGRESO_DEUDA7="deudaVerde.png";
        }
        
        self.MAP_IMG_PROGRESO_DEUDA8="deudaAmarillo.png";
        self.MAP_IMG_PROGRESO_DEUDA9="deudaGris.png";
        self.MAP_IMG_PROGRESO_DEUDA10="deudaGris.png";
        
        self.setFieldPropertyValue("MAP_PLAN_PAGO","bgcolor","#878787");
        self.setFieldPropertyValue("MAP_APROBACION_CLIENTE","bgcolor","#878787");
        self.setFieldPropertyValue("MAP_ADJ_APROBACION_CLIENTE","bgcolor","#878787");
        self.setFieldPropertyValue("MAP_SALTAR_COBRO_COMISION","bgcolor","#878787");
        self.setFieldPropertyValue("MAP_COBRO_COMISION","bgcolor","#878787");
        self.setFieldPropertyValue("MAP_PAGO_FINANCIERA","bgcolor","#3E2554");
        self.setFieldPropertyValue("MAP_JUSTIFICANTE_TRANSFERENCIA","bgcolor","#878787");
        self.setFieldPropertyValue("MAP_CERTIFICADO_FINANCIERA","bgcolor","#878787");
    }else if(idestadoDeuda==9){
        self.MAP_IMG_PROGRESO_DEUDA1="deudaVerde.png";
        self.MAP_IMG_PROGRESO_DEUDA2="deudaVerde.png";
        self.MAP_IMG_PROGRESO_DEUDA3="deudaVerde.png";
        self.MAP_IMG_PROGRESO_DEUDA4="deudaVerde.png";
        self.MAP_IMG_PROGRESO_DEUDA5="deudaVerde.png";
        self.MAP_IMG_PROGRESO_DEUDA6="deudaVerde.png";
        self.MAP_IMG_PROGRESO_DEUDA7="deudaVerde.png";
        self.MAP_IMG_PROGRESO_DEUDA8="deudaVerde.png";
        self.MAP_IMG_PROGRESO_DEUDA9="deudaAmarillo.png";
        self.MAP_IMG_PROGRESO_DEUDA10="deudaGris.png";
        
        self.setFieldPropertyValue("MAP_PLAN_PAGO","bgcolor","#878787");
        self.setFieldPropertyValue("MAP_APROBACION_CLIENTE","bgcolor","#878787");
        self.setFieldPropertyValue("MAP_ADJ_APROBACION_CLIENTE","bgcolor","#878787");
        self.setFieldPropertyValue("MAP_SALTAR_COBRO_COMISION","bgcolor","#878787");
        self.setFieldPropertyValue("MAP_COBRO_COMISION","bgcolor","#878787");
        self.setFieldPropertyValue("MAP_PAGO_FINANCIERA","bgcolor","#878787");
        self.setFieldPropertyValue("MAP_JUSTIFICANTE_TRANSFERENCIA","bgcolor","#3E2554");
        self.setFieldPropertyValue("MAP_CERTIFICADO_FINANCIERA","bgcolor","#878787");
    }else if(idestadoDeuda==10 && self.MAP_DOCUMENTO_CERTIFICADO==""){
        self.MAP_IMG_PROGRESO_DEUDA1="deudaVerde.png";
        self.MAP_IMG_PROGRESO_DEUDA2="deudaVerde.png";
        self.MAP_IMG_PROGRESO_DEUDA3="deudaVerde.png";
        self.MAP_IMG_PROGRESO_DEUDA4="deudaVerde.png";
        self.MAP_IMG_PROGRESO_DEUDA5="deudaVerde.png";
        self.MAP_IMG_PROGRESO_DEUDA6="deudaVerde.png";
        self.MAP_IMG_PROGRESO_DEUDA7="deudaVerde.png";
        self.MAP_IMG_PROGRESO_DEUDA8="deudaVerde.png";
        self.MAP_IMG_PROGRESO_DEUDA9="deudaVerde.png";
        self.MAP_IMG_PROGRESO_DEUDA10="deudaAmarillo.png";
        
        // si la deuda está liquidada aunque no se haya subido el certificado
        if(safeToInt(self.MAP_DEUDA_LIQUIDADA)==1){
            // buscamos el movimiento de la comisión de éxito una vez liquidada la deuda
            await filtrarCollMacroObject(collMov,"m.IDDEUDA="+iddeuda+" and m.IDLEAD="+self.ID+" and m.IDTIPO_MOVIMIENTO=3 AND m.IDESTADO!=8 AND ifnull(m.CE_DEUDA_LIQUIDADA,0)=1");
    
            if(collMov.count()>0){
                let item = collMov.getItem(0);
                if(item.IDESTADO == 5 || item.IDESTADO == 6){
                    self.MAP_IMG_PROGRESO_DEUDA11="deudaAmarillo.png";
                    self.MAP_MOV_CE_CREADO=1;
                }else if(item.IDESTADO == 7){
                    self.MAP_IMG_PROGRESO_DEUDA11="deudaVerde.png";
                    self.MAP_MOV_CE_CREADO=1;
                }else{
                    self.MAP_IMG_PROGRESO_DEUDA11="deudaGris.png";
                    self.MAP_MOV_CE_CREADO=0;
                }
            }else{
                self.MAP_IMG_PROGRESO_DEUDA11="deudaGris.png";
                self.MAP_MOV_CE_CREADO=0;
            }
        }
        
        self.setFieldPropertyValue("MAP_PLAN_PAGO","bgcolor","#878787");
        self.setFieldPropertyValue("MAP_APROBACION_CLIENTE","bgcolor","#878787");
        self.setFieldPropertyValue("MAP_ADJ_APROBACION_CLIENTE","bgcolor","#878787");
        self.setFieldPropertyValue("MAP_SALTAR_COBRO_COMISION","bgcolor","#878787");
        self.setFieldPropertyValue("MAP_COBRO_COMISION","bgcolor","#878787");
        self.setFieldPropertyValue("MAP_PAGO_FINANCIERA","bgcolor","#878787");
        self.setFieldPropertyValue("MAP_JUSTIFICANTE_TRANSFERENCIA","bgcolor","#878787");
        self.setFieldPropertyValue("MAP_CERTIFICADO_FINANCIERA","bgcolor","#3E2554");
    }else if(safeToInt(self.MAP_DEUDA_LIQUIDADA)==1){
        // si la deuda está liquidada
        self.MAP_IMG_PROGRESO_DEUDA1="deudaVerde.png";
        self.MAP_IMG_PROGRESO_DEUDA2="deudaVerde.png";
        self.MAP_IMG_PROGRESO_DEUDA3="deudaVerde.png";
        self.MAP_IMG_PROGRESO_DEUDA4="deudaVerde.png";
        self.MAP_IMG_PROGRESO_DEUDA5="deudaVerde.png";
        self.MAP_IMG_PROGRESO_DEUDA6="deudaVerde.png";
        self.MAP_IMG_PROGRESO_DEUDA7="deudaVerde.png";
        self.MAP_IMG_PROGRESO_DEUDA8="deudaVerde.png";
        self.MAP_IMG_PROGRESO_DEUDA9="deudaVerde.png";
        self.MAP_IMG_PROGRESO_DEUDA10="deudaVerde.png";
        
        // buscamos el movimiento de la comisión de éxito una vez liquidada la deuda
        await filtrarCollMacroObject(collMov,"m.IDDEUDA="+iddeuda+" and m.IDLEAD="+self.ID+" and m.IDTIPO_MOVIMIENTO=3 AND m.IDESTADO!=8 AND ifnull(m.CE_DEUDA_LIQUIDADA,0)=1");

        if(collMov.count()>0){
            let item = collMov.getItem(0);
            if(item.IDESTADO == 5 || item.IDESTADO == 6){
                self.MAP_IMG_PROGRESO_DEUDA11="deudaAmarillo.png";
                self.MAP_MOV_CE_CREADO=1;
            }else if(item.IDESTADO == 7){
                self.MAP_IMG_PROGRESO_DEUDA11="deudaVerde.png";
                self.MAP_MOV_CE_CREADO=1;
            }else{
                self.MAP_IMG_PROGRESO_DEUDA11="deudaGris.png";
                self.MAP_MOV_CE_CREADO=0;
            }
        }else{
            self.MAP_IMG_PROGRESO_DEUDA11="deudaGris.png";
            self.MAP_MOV_CE_CREADO=0;
        }
        
        self.setFieldPropertyValue("MAP_PLAN_PAGO","bgcolor","#878787");
        self.setFieldPropertyValue("MAP_APROBACION_CLIENTE","bgcolor","#878787");
        self.setFieldPropertyValue("MAP_ADJ_APROBACION_CLIENTE","bgcolor","#878787");
        self.setFieldPropertyValue("MAP_SALTAR_COBRO_COMISION","bgcolor","#878787");
        self.setFieldPropertyValue("MAP_COBRO_COMISION","bgcolor","#878787");
        self.setFieldPropertyValue("MAP_PAGO_FINANCIERA","bgcolor","#878787");
        self.setFieldPropertyValue("MAP_JUSTIFICANTE_TRANSFERENCIA","bgcolor","#878787");
        self.setFieldPropertyValue("MAP_CERTIFICADO_FINANCIERA","bgcolor","#878787");
    }
}

async function comprobacionExisteDocumento(objself,iddeuda,tipoDoc,plantilla){
    // Generación del documento de aprobación de cliente(4), reclamación extrajudicial para las deudas de la pestaña programas
    var objDoc, objEntidad; 
    var collDoc = appData.getCollection("DocumentoScript");
    
    // para el caso del documento de aprobación deuda cliente (plantilla 4, tipoDoc 10), buscamos el objeto entidad para generar el nombre personalizado en la plantilla
    if(tipoDoc == 10){
        
        // buscamos la entidad para la deuda seleccionada
        let idEntidadDeuda = objself.MAP_IDENTIDAD_ACTUAL > 0 ? objself.MAP_IDENTIDAD_ACTUAL : objself.MAP_IDENTIDAD_INICIAL;
            
        let collEntidad = appData.getCollection("EntidadesScript");
        await filtrarCollMacroObject(collEntidad,"ID="+idEntidadDeuda);
        
        if(collEntidad.count() > 0){
            objEntidad = collEntidad.getItem(0);
            
            // pasamos el nombre así porque lo necesitaremos a la hora de generar la plantilla
            objEntidad.MAP_ENTIDAD = objEntidad.NOMBRE;
        }
    }
    
    // buscamos si existe el documento de aprobación asocado a la deuda. Si no existe, lo generamos
    await filtrarCollMacroObject(collDoc,"d.IDDEUDACLIENTE="+iddeuda+" AND d.IDTIPO="+tipoDoc);
    
    if(collDoc.count()>0){
        objDoc = collDoc.getItem(0);
        
        if(objDoc.DOCUMENTO_FIRMADO == 1 && objDoc.ACEPTADO == 1){
            ui.showToast("ya existe un documento firmado por el cliente");
            return;
        }
        if(objDoc.ACEPTADO == 0){
            ui.showToast("ya existe un documento pendiente de firmar/rechazar por el cliente");
            return;
        }
        if(objDoc.ACEPTADO == 2){
            // generamos el documento al haberse rechazado el anterior
            await GenerarPlantilla(objself,plantilla,objEntidad,tipoDoc, objself.ROWID);
        }
    }else{
        // generamos el documento al no existir
        await GenerarPlantilla(objself,plantilla,objEntidad,tipoDoc, objself.ROWID);
    }
}

async function rechazarContratoManual(objself,iddeuda){
    // Si en la deuda del cliente en clienteEdicion estamos en la etapa 'aprobación cliente' y el técnico quiere rechazar el contrato adjunto manualmente
    let pregunta = await ui.msgBox("¿Desea marcar el documento actual como rechazado? No podrá deshacer este cambio","Rechazar documento aprobación cliente",1);
    if(pregunta==1){
        // Buscamos el documento de aprobación cliente, lo marcamos como rechazado y lo dejamos visible en la zona de usuario
        var collDoc = appData.getCollection("DocumentoScript");
        await filtrarCollMacroObject(collDoc,"d.IDDEUDACLIENTE="+iddeuda+" AND d.IDTIPO=10 AND d.ACEPTADO IN(0,1)");
        
        if(collDoc.count()>0){
            let objDoc = collDoc.getItem(0);
            
            objDoc.ACEPTADO=2;
            objDoc.DOCUMENTO_VISIBLE=1;
            await objDoc.save();
            objself.MAP_DOCUMENTO_APROBACION="";
            await actualizarDatosPaginadoLeads(objself,"Documento","DocumentoContador","MAP_PAG_INI_DOC","MAP_PAG_LEN_DOC","MAP_TOTAL_REGISTROS_DOC","MAP_T1_DOC");
        }
    }else{
        return;
    }
}

async function agregarDocumentoDeudaGuardar(objself,documento,tipo,tipoDoc,mes,desdeMovimiento){
    // función para subir los documentos del cliente para las deudas de la pestaña programas (aprobación,justificante,certificado...)
    let fileName="";
    let file = objself.getOwnerCollection().getVariables("File");
    var coll = appData.getCollection("DocumentoScript");
    
    var rowidlead = !isNullOrEmpty(objself.MAP_ROWID_LEAD) ? objself.MAP_ROWID_LEAD : objself.ROWID;
    
    if(isNothing(file)){
        await ui.msgBox("Debe adjuntar el documento que quiere subir","Falta documento",0);
        return;
    }
    if(isNullOrEmpty(documento)){
        await ui.msgBox("Debe adjuntar el documento que quiere subir","Falta documento",0);
        return;
    }
    
    if(isNullOrEmpty(documento) === false){
        fileName = documento;
    }
    
    //  Comprobamos si para este cliente existe un documento con el mismo nombre
    if(fileName !== ""){
        await filtrarCollMacroObject(coll,"d.BAJA=0 AND d.DOCUMENTO='"+fileName+"' AND d.ROWID_LEAD='"+rowidlead+"'");
    }else{
        await filtrarCollMacroObject(coll,"d.BAJA=0 AND d.DOCUMENTO='"+file.name+"' AND d.ROWID_LEAD='"+rowidlead+"'");
    }
    
    if(coll.count() > 0){
        await ui.msgBox("Ya existe un documento con el nombre indicado. Especifique otro distinto.","Archivo duplicado",0);
        return;
    }else{
        if(desdeMovimiento == 0){
            // subimos el archivo
            await uploadFiles(objself, file, fileName, tipo, objself.CORREO, user.CORREO, user.LOGIN, tipoDoc, rowidlead, 0, objself.MAP_IDDEUDA, 0, mes);
        }else{
            // archivo subido desde el listado de movimientos. El mapeo de los campos es distinto que el if (revisar cuando se pueda para unificar)
            // tipo = 5 devoluciones (lleva idactividad). tipo= 6,7 y 8 transferencias, pagos a financieras
            await uploadFiles(objself, file, fileName, tipo, objself.MAP_CLIENTE, user.CORREO, user.LOGIN, tipoDoc, rowidlead, 0, objself.MAP_IDDEUDA, 0, mes, objself.IDACTIVIDAD);
        }
    }
}

async function liquidarDeuda(objself,iddeuda,producto){
    let total=0;
    let fecha = ObtenerFechaHoraActual();
    let deudasSolucionadas=0;
    var collDeuda = appData.getCollection("DeudaClienteScript");
    await filtrarCollMacroObject(collDeuda,"d.ID="+iddeuda+" AND ifnull(d.BAJA,0)=0");
    
    if(collDeuda.count()>0){
        let pregunta= await ui.msgBox("¿Desea marcar la deuda "+objself.MAP_IDENTIFICADOR+" como liquidada?","Liquidar deuda",1);
        if(pregunta==1){
            let objDeuda = collDeuda.getItem(0);
            
            objDeuda.LIQUIDADA = 1;
            objDeuda.IDESTADO = 10;
            objDeuda.FECHA_LIQUIDADA = fecha;

            // cambiar mes final si se liquida antes de lo previsto
            if(objself.MAP_MESES_PROGRAMA < objDeuda.MES_SOLUCION){
                objDeuda.MES_FINAL = objself.MAP_MESES_PROGRAMA;
            }
            
            await objDeuda.save();
            
            objself.MAP_IDESTADO_DEUDA=10;
            objself.MAP_DEUDA_LIQUIDADA=1;
            
            
            // Si el producto es refinanciación, restamos el valor a le deuda neta
            // if(producto==2){
            //     objself.DEUDA_NETA_CLIENTE= objself.DEUDA_NETA_CLIENTE - objDeuda.IMPORTE_ACTUAL;
            //     objself.MAP_DEUDA_TOTAL_NETA= objself.DEUDA_NETA_CLIENTE+" €";
            //     await objself.save();
            // }
            
            // comprobamos el nº de deudas saldadas para el cliente
            await filtrarCollMacroObject(collDeuda,"d.IDLEAD="+objself.ID+" AND ifnull(d.BAJA,0)=0");
            
            for(var i=0;i<collDeuda.count();i++){
                let item = collDeuda.getItem(i);
                if(item.LIQUIDADA==1){
                    deudasSolucionadas=deudasSolucionadas+1;
                }
                total=total+1;
            }
            objself.MAP_DEUDAS_SOLUCIONADAS=deudasSolucionadas+"/"+total;
            
            // si se han liquidado todas las deudas, marcamos el estado del cliente como graduado
            if(deudasSolucionadas == total){
                // buscamos el estado actualizado del lead por si hubiera cambiado de etapa en la zona de usuario
                var collEstado= appData.getCollection("EstadosCliente");
                await filtrarCollMacroObject(collEstado,"CODIGO=12");
                if(collEstado.count()>0){
                    let Estado = collEstado.getItem(0);
                    let fecha = ObtenerFechaHoraActual();
                    
                    await guardarHistoricoCambioEstadoCliente(objself,objself.IDESTADO_CLIENTE,Estado.CODIGO);
                    
                    objself.MAP_ETAPA = Estado.NOMBRE;
                    objself.MAP_COLOR_ETAPA_BG = Estado.COLOR;
                    objself.IDESTADO_CLIENTE = Estado.CODIGO;
                    objself.FECHA_GRADUADO = fecha;
                    
                    await objself.save();
                    
                    // desactivamos la suscripción del cliente si la tiene
                    var collSub = appData.getCollection("PagosSuscripcion");
                    await filtrarCollMacroObject(collSub,"IDCLIENTE="+objself.ID);
                    
                    if(collSub.count()>0){
                        borrarSuscripcion(objself,objself.CORREO,function() {ui.showToast("Suscripción borrada");},function() {ui.showToast("No ha sido posible borrar la suscripción");});
                    }
                }

                // generamos la plantilla para el certificado de fin del programa
                await GenerarPlantilla(objself,10,'',19, objself.ROWID);
            }
            
            await actualizarDatosContent(objself,"DeudaClientePrograma");
            ui.showToast("Deuda liquidada");
            
        }else{
            return;
        }
    }
}

async function eliminarDeuda(objself, idDeuda) {
    // función para dar de baja deudas del programa
    
    let objDeuda = await obtenerPrimerObjetoColl("DeudaClienteScript","d.ID=" + idDeuda);
    
    if(objDeuda) {
        let eliminar = await ui.msgBox("Desea dar de baja la deuda " + objDeuda.IDENTIFICADOR + " y eliminarla del programa? Está acción no será reversible","Dar de baja deuda",1);
        
        if(eliminar == 2) {
            return;
        }
        objDeuda.BAJA = 1;
        await objDeuda.save();
        
        // ajustamos la deuda del cliente y valores en pantalla
        if(safeToFloat(objself.DEUDA_NETA_CLIENTE) > 0) {
            objself.DEUDA_NETA_CLIENTE -= objDeuda.IMPORTE_ACTUAL;
            objself.MAP_DEUDA_TOTAL_NETA = objself.DEUDA_NETA_CLIENTE + ' €';
        }
        objself.DEUDA_INICIAL_CLIENTE -= objDeuda.IMPORTE_ACTUAL;
        await objself.save();
        
        objself.MAP_DEUDA_INICIAL = objself.DEUDA_INICIAL_CLIENTE + ' €';
        objself.MAP_DEUDA_INICIAL_AND_POST = objself.DEUDA_INICIAL_CLIENTE + ' € / ' + safeToFloat(objself.DEUDA_NETA_CLIENTE) + ' €';
        
        objself.MAP_VER_DEUDA = 0;
        objself.MAP_IDDEUDA = 0;
        await actualizarDatosContent(objself,"DeudaClientePrograma");
        ui.showToast("Deuda eliminada");
    }
}

async function ResetearDeuda(objself) {
    // Comprobar si existe la deuda
    var idDeuda = objself.MAP_IDDEUDA;
    if (!idDeuda || idDeuda == 0 || idDeuda == null) {
        await ui.msgBox("No hay ninguna deuda seleccionada.", "Aviso", 0);
        return;
    }
    
    // Preguntar confirmación
    var pregunta = await ui.msgBox("¿Está seguro que desea resetear la deuda: " + objself.MAP_IDENTIFICADOR + "? Esta acción no se puede deshacer.", "Resetear Deuda", 1);
    if (pregunta != 1) {
        return;
    }
    
    // Obtener colección
    var collDeuda = appData.getCollection("DeudaClienteScript");
    await filtrarCollMacroObject(collDeuda, "d.ID=" + idDeuda);

    if (collDeuda.count() > 0) {
        var objDeuda = collDeuda.getItem(0);
        // Reset campos
        objDeuda.IDESTADO = 2;
        objDeuda.IDDOCUMENTO = null;
        objDeuda.IDENTIDAD_NUEVO = null;
        objDeuda.IMPORTE_NUEVO = null;
        objDeuda.IDPRODUCTO_FINANCIERO_ACTUAL = null;
        objDeuda.LIQUIDADA = null;
        objDeuda.IMPORTE_LIQUIDAR = null;
        objDeuda.CHECK_IMPORTE_LIQUIDAR = null;
        objDeuda.CHECK_IDENTIDAD_NUEVO = null;
        objDeuda.DESCUENTO_SOBRE_INICIAL = null;
        objDeuda.COMISION_EXITO = null;
        objDeuda.TOTAL_PAGAR = null;
        objDeuda.IDDOCUMENTO_APROBACION = null; 
        objDeuda.CUOTA = null;
        objDeuda.PLAZO_PAGAR = null;
        objDeuda.TASA_INTERES = null;
        objDeuda.CHECK_IMPORTE_NUEVO = null;
        objDeuda.CHECK_CUOTA = null;
        objDeuda.CHECK_PLAZO_PAGAR = null;
        objDeuda.PAB_MENSUAL = null;
        objDeuda.CE_MENSUAL = null;
        objDeuda.DIA_PAGO = null;
        objDeuda.PLAZO_COMISION = null;
        objDeuda.CHECK_DIA_PAGO = null;
        objDeuda.ANNADIDO_ADDENDUM = null;
        objDeuda.IMPORTE_REMANENTE = null;
        objDeuda.COMISION_EXITO_LIQUIDADA = null;
        objDeuda.CUOTA_INICIAL = null;
        objDeuda.FECHA_CUOTA_INICIAL = null;
        objDeuda.CHECK_FECHA_CUOTA_INICIAL = null;
        
        // Comprobación reseteo campos
        // await ui.msgBox(
        //     "VERIFICACIÓN DE RESETEO - Deuda: " + objDeuda.IDENTIFICADOR + "\n\n" +
        //     "IDESTADO: " + objDeuda.IDESTADO + "\n" +
        //     "IDDOCUMENTO: " + objDeuda.IDDOCUMENTO + "\n" +
        //     "IDENTIDAD_NUEVO: " + objDeuda.IDENTIDAD_NUEVO + "\n" +
        //     "IMPORTE_NUEVO: " + objDeuda.IMPORTE_NUEVO + "\n" +
        //     "IDPRODUCTO_FINANCIERO_ACTUAL: " + objDeuda.IDPRODUCTO_FINANCIERO_ACTUAL + "\n" +
        //     "LIQUIDADA: " + objDeuda.LIQUIDADA + "\n" +
        //     "IMPORTE_LIQUIDAR: " + objDeuda.IMPORTE_LIQUIDAR + "\n" +
        //     "CHECK_IMPORTE_LIQUIDAR: " + objDeuda.CHECK_IMPORTE_LIQUIDAR + "\n" +
        //     "CHECK_IDENTIDAD_NUEVO: " + objDeuda.CHECK_IDENTIDAD_NUEVO + "\n" +
        //     "DESCUENTO_SOBRE_INICIAL: " + objDeuda.DESCUENTO_SOBRE_INICIAL + "\n" +
        //     "COMISION_EXITO: " + objDeuda.COMISION_EXITO + "\n" +
        //     "TOTAL_PAGAR: " + objDeuda.TOTAL_PAGAR + "\n" +
        //     "IDDOCUMENTO_APROBACION: " + objDeuda.IDDOCUMENTO_APROBACION + "\n" +
        //     "CUOTA: " + objDeuda.CUOTA + "\n" +
        //     "PLAZO_PAGAR: " + objDeuda.PLAZO_PAGAR + "\n" +
        //     "TASA_INTERES: " + objDeuda.TASA_INTERES + "\n" +
        //     "CHECK_IMPORTE_NUEVO: " + objDeuda.CHECK_IMPORTE_NUEVO + "\n" +
        //     "CHECK_CUOTA: " + objDeuda.CHECK_CUOTA + "\n" +
        //     "CHECK_PLAZO_PAGAR: " + objDeuda.CHECK_PLAZO_PAGAR + "\n" +
        //     "PAB_MENSUAL: " + objDeuda.PAB_MENSUAL + "\n" +
        //     "CE_MENSUAL: " + objDeuda.CE_MENSUAL + "\n" +
        //     "DIA_PAGO: " + objDeuda.DIA_PAGO + "\n" +
        //     "PLAZO_COMISION: " + objDeuda.PLAZO_COMISION + "\n" +
        //     "CHECK_DIA_PAGO: " + objDeuda.CHECK_DIA_PAGO + "\n" +
        //     "ANNADIDO_ADDENDUM: " + objDeuda.ANNADIDO_ADDENDUM + "\n" +
        //     "IMPORTE_REMANENTE: " + objDeuda.IMPORTE_REMANENTE + "\n" +
        //     "COMISION_EXITO_LIQUIDADA: " + objDeuda.COMISION_EXITO_LIQUIDADA + "\n" +
        //     "CUOTA_INICIAL: " + objDeuda.CUOTA_INICIAL + "\n" +
        //     "FECHA_CUOTA_INICIAL: " + objDeuda.FECHA_CUOTA_INICIAL + "\n" +
        //     "CHECK_FECHA_CUOTA_INICIAL: " + objDeuda.CHECK_FECHA_CUOTA_INICIAL,
        //     "Verificación Reseteo",
        //     0
        // );
        
        // Guardar datos reseteados
        await objDeuda.save();
        

        //refrescar UI
        await actualizarDatosContent(objself,"DeudaClientePrograma");

        // Reset selección en pantalla
        objself.MAP_VER_DEUDA = 0;
        objself.MAP_IDDEUDA = 0;
        ui.showToast("Deuda reseteada correctamente");
    } else {
        ui.showToast("Deuda no encontrada");
    }
}

// funciones para subir documentos y helpers

// *** helpers para subirArchivo ***
function leerRespuesta(response) {
    // respuesta al subir un documento
    return response.data[0];
}

async function limpiarDatosTrasSubida(objself, refrescarPadre) {
    objself.getOwnerCollection().setVariables("File", null);
    ui.showToast("Actualizando listado de documentos...");
    await actualizarDatosPaginadoLeads(
        objself,
        "Documento", "DocumentoContador",
        "MAP_PAG_INI_DOC", "MAP_PAG_LEN_DOC",
        "MAP_TOTAL_REGISTROS_DOC", "MAP_T1_DOC",
        refrescarPadre
    );
}

async function guardarSubtipoComprobante(idtipoComprobante,iddocumento) {
    let coll = appData.getCollection("DocumentoComprobanteScript");
    let obj = await coll.createObject();
    
    obj.IDDOCUMENTO = iddocumento;
    obj.IDTIPO_COMPROBANTE = idtipoComprobante;
    await obj.save();
}

// para documentos de datos extra del cliente en clienteEdicion
async function recargarDocumentoDatosCliente(objself) {
    objself.getOwnerCollection().setVariables("File", null);
    objself.MAP_DOC_DATOS_CLIENTE = "";
    objself.MAP_TIPO_DOC_DATOS_CLIENTE = "";
    objself.MAP_IDTIPO_DOC_CLIENTE = 0;
    await refrescarContent(objself,"DocumentoDatosCliente");
}

function limpiarDatosCliente(objself) {
    // Tras subir con adjuntarArchivoDatosCliente un único archivo
    objself.getOwnerCollection().setVariables("File", null);
    objself.MAP_TIPO_DOC_DATOS_CLIENTE = "";
    objself.MAP_IDTIPO_DOC_CLIENTE = 0;
    objself.MAP_ANEXO = "";
}

function limpiarDatosComprobantes(objself) {
    // Tras subir comprobantes de deudas
    objself.getOwnerCollection().setVariables("File", null);
    objself.MAP_DOC_DATOS_CLIENTE = "";
    objself.MAP_TIPO_DOC_DATOS_CLIENTE = "";
    objself.MAP_IDSUBTIPO_COMPROBANTE = 0;
}


// *** funciones descarga de ficheros cliente y proceso LSO ***

function verDocumentoCliente(objself, rowidlead, nombreDocumento, correo) {
   
    downloadDocumentAsyncPDF(objself,rowidlead,nombreDocumento,correo,
    function(data)
    {
        if(nombreDocumento.includes(".pdf")==true){
            ui.openUrl(data);
        }else{
            var link = document.createElement("a");
            link.download = nombreDocumento;
            link.href = data;
            link.click();
        }
    },
    function(){
        ui.showToast("Error descargando el fichero");
    });
}

function verDocumentoProcesoLSO(objself, idProcesoLso, nombreDocumento) {
   
    DescargarArchivoLSO(objself,nombreDocumento,idProcesoLso,
    function(data)
    {
        if(nombreDocumento.includes(".pdf")==true){
            ui.openUrl(data);
        }else{
            var link = document.createElement("a");
            link.download = nombreDocumento;
            link.href = data;
            link.click();
        }
    },
    function(){
        ui.showToast("Error descargando el fichero");
    });
}



// *** funciones con parámetros para las subidas de archivos y callbacks ***
function adjuntarArchivoDatosCliente(objself, tipoDocumento, tipoCallback, rowidlead, correo_lead) {
    // para subir varios documentos en los listados de datos del cliente que tienen varios documentos
    // información base volcada desde verDocumentacionDatosCliente()  para cada caso
    
    // if(safeToInt(objself.MAP_IDTIPO_DOC_CLIENTE) === 0) {
    if(safeToInt(tipoDocumento) === 0) {
        ui.showToast("indique el tipo de documento");
        return;
    }
    
    // En comprobantes de deuda tenemos que tener el subtipo seleccionado
    if(safeToInt(tipoDocumento) === 5 && safeToInt(objself.MAP_IDSUBTIPO_COMPROBANTE) === 0) {
        ui.showToast("Indique el tipo de comprobante");
        return;
    }
    
    // comprobamos si adjunta documento
    let file = objself.getOwnerCollection().getVariables("File");
    let docValido = true;
    
    if(file){
        docValido = comprobarDocumento(objself, file.name, rowidlead);
        if(!docValido) {
            return;
        }
    } else {
        ui.showToast("Indique el documento que desea subir");
        return;
    }
    
    // ** parámetros base comunes a todos los casos (procesoLSO || cliente) **
    const parametrosBase = {
        tipoDoc: tipoDocumento,
        correo_lead: correo_lead,
        rowid_lead: rowidlead,
        fileName: file.name,
    };

    // parámetros específicos según el caso de subida y callback
    const parametrosPorTipo = {
        
        // comprobantes de deudas lead en edición de deuda
        comprobanteDeuda: {
            iddeuda: objself.ID,
            onSuccess: function(response) {
                ui.showToast("Comprobante subido correctamente");
                
                // Guardamos el subtipo de comprobante aquí
                let documento = leerRespuesta(response);
                guardarSubtipoComprobante(objself.MAP_IDSUBTIPO_COMPROBANTE,documento.ID);
                
                filtrarContentFilterObject(objself,"DocumentoDatosCliente","doc.ROWID_LEAD ='" + objself.MAP_ROWID +"' AND ifnull(doc.BAJA,0)=0 AND doc.IDTIPO=5 AND doc.IDDEUDA=" + objself.ID);
                limpiarDatosTrasSubida(objself.getParent(),true);
                limpiarDatosComprobantes(objself);
                
                if (objself.getParent().IDESTADO === 10) {
                    asignarIdDocumentoDeudaAddendum(objself.getParent(),file,file.name,rowidlead,objself.ID);
                }
            }
        },
        // comprobantes de deudas leadedición
        comprobanteDeudaLeadEdicion: {
            iddeuda: objself.MAP_ID_DATOS_CLIENTE,
            onSuccess: function(response) {
                ui.showToast("Comprobante subido correctamente");

                // Guardamos el subtipo de comprobante aquí
                let documento = leerRespuesta(response);
                guardarSubtipoComprobante(objself.MAP_IDSUBTIPO_COMPROBANTE,documento.ID);
                
                refrescarContent(objself,"DocumentoDatosCliente");
                limpiarDatosTrasSubida(objself,true);
                limpiarDatosComprobantes(objself);
                
                if (objself.IDESTADO === 10) {
                    asignarIdDocumentoDeudaAddendum(objself,file,file.name,rowidlead,objself.ID);
                }
            }
        },
        // comprobantes de deudas cliente en edición de deuda
        comprobanteDeudaCliente: {
            iddeudacliente: objself.ID,
            onSuccess: function(response) {
                ui.showToast("Comprobante subido correctamente");
                let documento = leerRespuesta(response);
                guardarSubtipoComprobante(objself.MAP_IDSUBTIPO_COMPROBANTE,documento.ID);
                
                filtrarContentFilterObject(objself,"DocumentoDatosCliente","doc.ROWID_LEAD ='" + objself.MAP_ROWID +"' AND ifnull(doc.BAJA,0)=0 AND doc.IDTIPO=5 AND doc.IDDEUDACLIente=" + objself.ID);
                refrescarContent(objself,"DocumentoDatosCliente");
                limpiarDatosTrasSubida(objself.getParent(),true);
                limpiarDatosComprobantes(objself);
                
                // si la deuda está en idestado=1, pasamos al subir el primer comprobante
                if(objself.IDESTADO == 1) {
                    objself.IDESTADO = 2;
                    objself.save();
                    
                    actualizarDatosContent(objself.getParent(),"DeudaClientePrograma",true);
                }
            }
        },
        // comprobantes de deudas clienteEdición
        comprobanteDeudaClienteEdicion: {
            iddeudacliente: objself.MAP_ID_DATOS_CLIENTE,
            onSuccess: function(response) {
                ui.showToast("Comprobante subido correctamente");

                // Guardamos el subtipo de comprobante aquí
                let documento = leerRespuesta(response);
                guardarSubtipoComprobante(objself.MAP_IDSUBTIPO_COMPROBANTE,documento.ID);
                
                refrescarContent(objself,"DocumentoDatosCliente");
                limpiarDatosTrasSubida(objself,true);
                limpiarDatosComprobantes(objself);
                
                // si la deuda está en idestado=1, pasamos al subir el primer comprobante
                if(objself.MAP_IDESTADO_DEUDA == 1) {
                    objself.MAP_IDESTADO_DEUDA = 2;
                    comprobarEstadoDeuda(objself.MAP_IDESTADO_DEUDA, objself.MAP_IDPRODUCTO, objself.MAP_IDDEUDA);
                    // guardamos el estado de la deuda fuera por los await...
                    comprobanteClienteEdicionOk(objself);
                }
            }
        },
        poseeSociedad: {
            idposeesociedad: objself.MAP_ID_DATOS_CLIENTE,
            onSuccess: function(response) {
                ui.showToast("Documento de posesión de sociedades subido correctamente");
                recargarDocumentoDatosCliente(objself);

            },
        },
        sancionesHacienda: {
            idsancioneshacienda: objself.MAP_ID_DATOS_CLIENTE,
            onSuccess: function(response) {
                ui.showToast("Documento de sanciones subido correctamente");
                recargarDocumentoDatosCliente(objself);

            },
        },
        ventaDonacionBien: {
            idventadonacionbien: objself.MAP_ID_DATOS_CLIENTE,
            onSuccess: function() {
                ui.showToast("Documento de venta/donación subido correctamente");
                recargarDocumentoDatosCliente(objself);
            },
        },
        herencia: {
            idherencia: objself.MAP_ID_DATOS_CLIENTE,
            onSuccess: function() {
                ui.showToast("Documento de herencia subido correctamente");
                recargarDocumentoDatosCliente(objself);
            },
        },
        otrosActivos: {
            idotrosactivos: objself.MAP_ID_DATOS_CLIENTE,
            onSuccess: function() {
                ui.showToast("Documento de otros activos subido correctamente");
                recargarDocumentoDatosCliente(objself);
            },
        },
        bienesInmuebles: {
            idinmuebles: objself.MAP_ID_DATOS_CLIENTE,
            onSuccess: function() {
                ui.showToast("Documento de bienes inmuebles subido correctamente");
                recargarDocumentoDatosCliente(objself);
            },
        },
        vehiculos: {
            idvehiculos: objself.MAP_ID_DATOS_CLIENTE,
            onSuccess: function() {
                ui.showToast("Documento de vehículos subido correctamente");
                recargarDocumentoDatosCliente(objself);
            },
        },
        familiares: {
            idfamiliares: objself.MAP_ID_DATOS_CLIENTE,
            onSuccess: function() {
                ui.showToast("Documento de familiares a cargo subido correctamente");
                recargarDocumentoDatosCliente(objself);
            },
        },
        familiaresCargoLibroFamilia: {
            onSuccess: function(response) {
                ui.showToast("Documento de libro de familia subido correctamente");
                limpiarDatosCliente(objself);
                let documento = leerRespuesta(response);
                objself.MAP_DOCUMENTO_LIBRO_FAMILIA = documento.DOCUMENTO;
                objself.MAP_ID_DOCUMENTO_LIBRO_FAMILIA = documento.ID;
            },
        },
        procesoLSODocumentacionPreviaCliente: {
            onSuccess: function(response) {
                ui.showToast("Documento de documentación previa subido correctamente");
                limpiarDatosCliente(objself);
                let documento = response.data[0];
                let padre = objself.getParent();
                
                limpiarDatosTrasSubida(padre, true);
                
                objself.MAP_DOCUMENTO = documento.DOCUMENTO;
                objself.MAP_IDDOCUMENTO = documento.ID;
                objself.MAP_FECHA_USUARIO_SUBIDA = ObtenerFechaActual('dmy') + ' ' + documento.USUARIO_SUBIDA;
                
                actualizarDatosContent(padre, objself.getOwnerCollection().getName(), true, true);
            }
        },
        partidaNacimiento: {
            onSuccess: function(response) {
                ui.showToast("Documento de partida de nacimiento subido correctamente");
                limpiarDatosCliente(objself);
                let documento = leerRespuesta(response);
                objself.MAP_DOCUMENTO_PARTIDA_NACIMIENTO = documento.DOCUMENTO;
                objself.MAP_ID_DOCUMENTO_PARTIDA_NACIMIENTO = documento.ID;
            },
        },
        certificadoCatastral: {
            onSuccess: function(response) {
                ui.showToast("Documento de certificado catastral subido correctamente");
                limpiarDatosCliente(objself);
                let documento = leerRespuesta(response);
                objself.MAP_DOCUMENTO_CERTIFICADO_CATASTRAL = documento.DOCUMENTO;
                objself.MAP_ID_DOCUMENTO_CERTIFICADO_CATASTRAL = documento.ID;
            },
        },
        lsoPrevia: {
            onSuccess: function(response) {
                ui.showToast("Documento de LSO previa subido correctamente");
                limpiarDatosCliente(objself);
                let documento = leerRespuesta(response);
                objself.MAP_DOCUMENTO_LSO_PREVIA = documento.DOCUMENTO;
                objself.MAP_ID_DOCUMENTO_LSO_PREVIA = documento.ID;
            },
        },
        acreditaResidencia: {
            onSuccess: function(response) {
                ui.sleep(0);
                ui.showToast("Documento de acredita residencia subido correctamente");
                limpiarDatosCliente(objself);
                let documento = leerRespuesta(response);
                
                let idCliente = objself.MAP_ID_CLIENTE_SELECCIONADO || objself.ID;
                acreditaResidenciaOk(objself, documento, idCliente);
            },
        },
        certificadoAntecedentesPenales: {
            onSuccess: function(response) {
                ui.showToast("Documento de certificado de antecedentes penales subido correctamente");
                limpiarDatosCliente(objself);
                let documento = leerRespuesta(response);
                objself.MAP_DOCUMENTO_CERTIFICADO_ANTECEDENTES_PENALES = documento.DOCUMENTO;
                objself.MAP_ID_DOCUMENTO_CERTIFICADO_ANTECEDENTES_PENALES = documento.ID;
            },
        },
        certificadoVidaLaboral: {
            onSuccess: function(response) {
                ui.showToast("Documento de certificado laboral subido correctamente");
                limpiarDatosCliente(objself);
                let documento = leerRespuesta(response);
                objself.MAP_DOCUMENTO_CERTIFICADO_VIDA_LABORAL = documento.DOCUMENTO;
                objself.MAP_ID_DOCUMENTO_CERTIFICADO_VIDA_LABORAL = documento.ID;
            },
        },
        ClienteSancionesHaciendaSSDeudaCero: {
            onSuccess: function() {
                ui.showToast("Documento de sanciones deuda cero subido correctamente");
                recargarDocumentoDatosCliente(objself);
            },
        },
        ClienteEstadoCivil: {
            onSuccess: function() {
                ui.showToast("Documento subido correctamente");
                recargarDocumentoDatosCliente(objself);
            },
        },
        ClienteDiscapacidad: {
            onSuccess: function() {
                ui.showToast("Documento subido correctamente");
                recargarDocumentoDatosCliente(objself);
            },
        },
        autorizacionOposicionMonitorio: {
            idactividadcliente: objself.ID,
            onSuccess: function(response) {
                ui.showToast("Documento de autorización oposición subido correctamente");
                let padre = objself.getParent();
                limpiarDatosTrasSubida(padre, true);
                
                let documento = leerRespuesta(response);
                objself.MAP_DOCUMENTO_AUTORIZACION_OPOSICION = documento.DOCUMENTO;
                objself.MAP_IDDOCUMENTO_AUTORIZACION_OPOSICION = documento.ID;
            },
        },
        autorizacionIngreso: {
            idactividadcliente: objself.ID,
            onSuccess: function(response) {
                ui.showToast("Documento subido correctamente");
                let documento = leerRespuesta(response);
                objself.MAP_DOCUMENTO = documento.DOCUMENTO;
                objself.MAP_ID_DOCUMENTO = documento.ID;
            },
        }
    };

    const parametrosEspecificos = parametrosPorTipo[tipoCallback] || {};
    const parametros = Object.assign({}, parametrosBase, parametrosEspecificos);
    
    
    // si es válido, lo subimos
    subirArchivo(objself, parametros);
}

async function comprobanteClienteEdicionOk(objself) {
    let contentsName = "";
    
    if(objself.getOwnerCollection().getName() == "ProcesoLSOEdicion") {
        contentsName = "ProcesoLSODeudaCliente";
    } else if(objself.getOwnerCollection().getName() == "ClienteEdicion") {
        contentsName = "DeudaClientePrograma";
    }
    
    let objDeuda = await obtenerPrimerObjetoColl("DeudaClienteScript","d.ID=" + objself.MAP_IDDEUDA);
    
    if(objDeuda) {
        objDeuda.IDESTADO=2;
        await objDeuda.save();
    }
    
    await actualizarDatosContent(objself,contentsName,true);
}



// función para el ok tras subir documento. (lo pongo fuera porque dentro del callback no me aplica await y falla)
async function acreditaResidenciaOk(objself, documento, idCliente) {
    let objResidencia;
    
    let collResidencia = appData.getCollection("ClienteDatosAcreditaResidenciaScript");
    await filtrarCollMacroObject(collResidencia,"IDLEAD=" + idCliente);
    
    if(collResidencia.count() > 0) {
        objResidencia = collResidencia.getItem(0);
        objResidencia.ID_DOCUMENTO = documento.ID;
        await objResidencia.save();
        
    } else {
        objResidencia = await collResidencia.createObject();
        objResidencia.IDLEAD = objself.ID;
        objResidencia.ID_DOCUMENTO = documento.ID;
    }
    await objResidencia.save();
    
    // asignamos el nombre y el id en memoria del documento recién subido
    objself["MAP_ID_DOCUMENTO_ACREDITA_RESIDENCIA"] = documento.ID;
    objself["MAP_DOCUMENTO_ACREDITA_RESIDENCIA"] = documento.DOCUMENTO;
}


// funcién genérica para subida de archivos de LSO (por proceso, no por cliente)
async function adjuntarArchivoProcesoLSO(objself, tipoCallback, tipoDoc) {
    if(safeToInt(tipoDoc) === 0) {
        ui.showToast("indique el tipo de documento");
        return;
    }
    
    // Detectar si objself es un registro de un content (doc previa) y usamos el padre, o si es del propio proceso
    let isProcesoEdicion = (objself.getOwnerCollection().getName() === "ProcesoLSOEdicion");
    let recordProceso = isProcesoEdicion ? objself : objself.getParent();
    let processId = recordProceso.ID;
    let processRowid = recordProceso.ROWID;
    
    // comprobamos si adjunta documento
    let file = objself.getOwnerCollection().getVariables("File");
    let docValido = true;
    
    if(file){
        docValido = await comprobarDocumentoLSO(objself, file.name, processRowid);
        if(!docValido) {
            return;
        }
    }
    
    // parámetros base comunes a todos los casos (cliente || procesoLSO)
    const parametrosBase = {
        tipoDoc: tipoDoc,
        idproceso_lso: processId,
        fileName: file.name,
    };

    // parámetros específicos según el caso de subida y callback
    const parametrosPorTipo = {
        
        procesoLSODocumentacionPrevia: {
            onSuccess: function(response) {
                ui.showToast("Documento del proceso subido correctamente");
                let documento = response.data[0];
                let padre = objself.getParent();
                padre.getOwnerCollection().setVariables("File", null);

                objself.MAP_DOCUMENTO = documento.DOCUMENTO;
                objself.MAP_IDDOCUMENTO = documento.ID;
                objself.MAP_FECHA_USUARIO_SUBIDA = ObtenerFechaActual('dmy') + ' ' + documento.USUARIO_SUBIDA;
                objself.MAP_FECHA_SUBIDA = ObtenerFechaActual('dmy');
                objself.MAP_USUARIO_SUBIDA = documento.USUARIO_SUBIDA;
                
                let index = objself.getObjectIndex();
                ui.refreshContentRow('ProcesoLSODocumentacionPrevia', index);
                // actualizarDatosContent(padre, "ProcesoLSODocumentacionPrevia", true, true);
            }
        },
        procesoLSO: {
            onSuccess: function(response) {
                ui.showToast("Documento del proceso subido correctamente");
                let documento = response.data[0];
                objself["MAP_DOCUMENTO" + safeToString(documento.IDTIPO)] = documento.DOCUMENTO;
                objself["MAP_IDDOCUMENTO" + safeToString(documento.IDTIPO)] = documento.ID;
            },
        }
    };

    const parametrosEspecificos = parametrosPorTipo[tipoCallback] || {};
    const parametros = Object.assign({}, parametrosBase, parametrosEspecificos);
    
    // si es válido, lo subimos
    await subirArchivoLSO(objself, parametros);
}

// QA publish pipeline test — comentario de prueba (2026-07-05T01:06:47.526Z)

// para almacenar el objeto anterior del menú padre
var ObjMenuPadre = "";

var _objClienteEdicionChat = null;


var textoColor="Opacidad: 2 dígitos. Valores entre 01-99. Sin valor (0) es opaco totalmente. " +
                "Color: 6 dígitos. Valores válidos [0-9,a-f,A-F] ";

var camposMatriz = ['C','D','E','F','G','H','I','J','K','L','M','N','O','P','Q','R','S','T','U','V','W','X','Y','Z',
'AA','AB','AC','AD','AE','AF','AG','AH','AI','AJ','AK','AL','AM','AN','AO','AP','AQ','AR','AS','AT','AU','AV','AW','AX','AY','AZ',
'BA','BB','BC','BD','BE','BF','BG','BH','BI','BJ','BK','BL','BM','BN','BO','BP','BQ','BR','BS','BT','BU','BV','BW','BX','BY','BZ',
'CA','CB','CC','CD','CE','CF','CG','CH','CI','CJ','CK','CL','CM','CN','CO','CP','CQ','CR','CS','CT','CU','CV','CW','CX','CY','CZ',
'DA','DB','DC','DD','DE','DF','DG','DH','DI','DJ','DK','DL','DM','DN','DO','DP','DQ','DR','DS','DT','DU','DV','DW','DX','DY','DZ',
'EA','EB','EC','ED','EE','EF','EG','EH','EI','EJ','EK','EL','EM','EN','EO','EP','EQ','ER','ES','ET','EU'];


function sendPush() {
    ui.sendPush("d-W1zpMeTzC0fgXeQ-wHfm:APA91bHNgS995tVEBdX-DTzwGiLeDV7sdVa20ETQ-0VhrSFynBPcrYY1OYAELMcjeVPnnWB_lIuZz8cPeYIaIB8b1n7FPIcyeJm6kmX2XqPMdBhMtfSB2AY", "Notif", "Hola");
    ui.showToast("push enviado");
}

function tituloPestanyaNavegador(objself) {
    try {
        let coleccion = objself.getOwnerCollection().getName();
        let titulo = "";
        
        if(coleccion == "ClienteEdicion") {
            titulo = safeToString(objself.MAP_NOMBRE_COMPLETO);
        } else if(coleccion == "LeadEdicion") {
            titulo = safeToString(objself.MAP_NOMBRE_COMPLETO);
        }
        
        document.title = (titulo != "" ? titulo + " - " : "") + "Alivia Finance";
    } catch(e) {
        document.title = "Alivia Finance";
    }
}

// ── Chatbot nappai: MIGRADO al atributo declarativo `web-widget` ──────────────
// El montaje del widget <nappai-chat-widget> ya NO se hace por DOM directo. Las
// antiguas DevolverIframeAgente()/loadTargetDiv() usaban document.querySelector +
// setInterval + document.createElement (vetados en el sandbox web XOne; el
// generador los neutralizaba a no-ops, por eso el chat salía vacío). Ahora el
// widget se declara en el <prop MAP_CHAT> del frame frmChatBot (EntradaApp.xne)
// con web-widget / web-widget-attr-*; los valores llegan por macros globales
// (comprobarEntorno = config de entorno, before-edit = sesión).

// function DevolverIframeAgente(objself){
    
//     var jsonAgente = {
//         "userName": user.NOMBRE,
//         "apiKey": apiKey,
//         "flowId": flowID,
//         "hostUrl": hostUrl,
//         "activeTheme": "dark",
//         "viewMode": "fullscreen",
//         "tweaks": "{\"userEmail\": {\"input_value\": \"" + user.LOGIN + "\"},\"token\": {\"input_value\": \"Bearer " + user.MAP_TOKEN + "\"}}",
//         "backgroundImage": bgImage,
//         "useHistory": "true",
//         "allowUpdateFiles": "getfalse",
//         "customTheme": {
//             "primary-accent": "#3E2554",
//             "light-text-primary": "#000000",
//             "light-bg-sidebar": "#e6e6fa",
//             "bubble-user-bg": "#3E2554",
//             "button-primary-bg": "#df1111",
//             "input-border-focus": "#df1111",
//             "icon-color-active": "#df1111",
//             "hover-bg": "#ccccdd"
//         }
//     };

    
//     const jsonString = JSON.stringify(jsonAgente);
//     const urlBase64 = btoa(unescape(encodeURIComponent(jsonString)));
    
//     //Concatenamos el iframe
//   	return '<iframe id="chatbot" type="text/html" src="'+dominioUrlAgente+'/chat.html?q=' + urlBase64 + '" width="100%" height="700p" frameborder="0" ></iframe>';
// //   	return '<nappai-chat-widget view-mode="fullscreen" use-history="true" session-id="[user-name]" host-url="https://localhost:7151" api-key=""	flow-id="f0c9a7cf-88f0-49b9-80dc-89c43b9704a8" background-image="http://localhost:3000/default_chat_logo.svg"></nappai-chat-widget>';
// }

// var interval = "";
// function DevolverIframeAgente(objself){
    
//     interval = setInterval(loadTargetDiv, 500);
// }

// function loadTargetDiv() {
//     const targetDiv = document.querySelector('div[xone-name="frmChatBot"]');
    
//     if (targetDiv) {
//         clearInterval(interval);
        
//         const script = document.createElement("script");
//         script.src = dominioUrlAgente+"/js/bundle.min.js";
//         const widget = document.createElement("nappai-chat-widget");
        
//         script.onload = function() {
//             //Once the script is loaded, create the widget element
     
//             widget.setAttribute("view-mode", "floating");
//             widget.setAttribute("use-history", "true");
//             widget.setAttribute("session-id", user.LOGIN);
//             widget.setAttribute("host-url", hostUrl);
//             widget.setAttribute("api-key", apiKey);
//             widget.setAttribute("tweaks", "{\"userEmail\": {\"input_value\": \"" + user.LOGIN + "\"},\"token\": {\"input_value\": \"Bearer " + user.MAP_TOKEN + "\"}}");
//             widget.setAttribute("flow-id", flowID);
//             widget.setAttribute("background-image", bgImage);
//             widget.setAttribute("style", "height: 92%");
            
//             // Espera a que el widget termine de renderizar
//             setTimeout( function() {
//                 const shadow = widget.shadowRoot;
//                 if (shadow) {
//                     const chatWidget = shadow.querySelector('main.chat-widget');
//                     if (chatWidget) {
//                         // chatWidget.style.left = "72%";
//                         // chatWidget.style.top = "200px";
                        
//                     }
                    
//                     // const toggleButton = shadow.querySelector('button.toggle-conversation-button');
//                     // if (toggleButton) {
//                     //     // toggleButton.style.width = "40p";
//                     //     // toggleButton.style.height = "40p";
//                     //     // toggleButton.style.setProperty('width', '40p', 'important');
//                     //     // toggleButton.style.setProperty('height', '40p', 'important');
//                     //     toggleButton.style.left = "0%";
//                     //     toggleButton.style.top = "0%";
//                     //     toggleButton.addEventListener('click', function () {
//                     //         self.MAP_VERBOT = 0;
//                     //     });
                        
                    
//                     // } else {
//                     //     console.warn('No se encontró el botón dentro del shadow DOM');
//                     // }
                    
//                     // tamaño del botón
//                     const toggleHost = shadow.querySelector('nappai-toggle-conversation-button');
//                     if (toggleHost) {
//                         const style = document.createElement('style');
//                         style.textContent = `
//                             button.toggle-conversation-button {
//                             width: 40px !important;
//                             height: 40px !important;
//                           }
//                         `;
//                         toggleHost.appendChild(style);
                        
//                     }
//                 }
//             }, 1500);
//         };
     
//         document.body.appendChild(script);
        
//         targetDiv.appendChild(widget);
        
//     } else {
//         console.error('Target div with xone-name="chat-area" not found.');
//     }
// }


async function refrescarContent(objself,contentsName){
    objself.MAP_BANDERA=1;
    let cnt = await objself.getContents(contentsName);
    cnt.unlock();
    cnt.clear();
    await cnt.loadAll();
    cnt.lock();
    ui.refresh(contentsName);
    objself.MAP_BANDERA=0;
}
async function refrescarContentMacro(objself,contentsName,macro){
    objself.MAP_BANDERA=1;
    let cnt = await objself.getContents(contentsName);
    cnt.unlock();
    cnt.setMacro("##MACRO##",macro);
    cnt.clear();
    await cnt.loadAll();
    cnt.lock();
    ui.refresh(contentsName);
    objself.MAP_BANDERA=0;
}
async function refrescarContentPadre(objself,contentsName){
    let padre = objself.getParent();
    padre.MAP_BANDERA=1;
    let cnt = await padre.getContents(contentsName);
    cnt.unlock();
    cnt.clear();
    await cnt.loadAll();
    cnt.lock();
    ui.getView(padre).refresh(contentsName);
    padre.MAP_BANDERA=0;
}
async function filtrarCollObject(coll,filter){
    let collFiltrar = appData.getCollection(coll);
    collFiltrar.setFilter(filter);
    collFiltrar.clear();
    await collFiltrar.loadAll();
    collFiltrar.lock();
}

async function crearObjetoContent(objself, contentsName, valoresIniciales) {
    let cnt = await objself.getContents(contentsName);
    let nuevoObjeto = await cnt.createObject();
    
    if (valoresIniciales) {
        for (let key in valoresIniciales) {
            nuevoObjeto[key] = valoresIniciales[key];
        }
    }
    
    appData.pushValue(nuevoObjeto);
}


async function onEditorAction(objself,param){
    if(param=="login"){
        await objself.executeNode('login');
    }
    if(param=="LeadList_Filtro"){
        objself.MAP_BUSQUEDA_AVANZADA=0;
        await actualizarDatosPaginadoLeads(objself,'Lead','LeadContador','MAP_PAG_INI','MAP_PAG_LEN','MAP_TOTAL_REGISTROS','MAP_T1');
    }
    if(param=="ClienteList_Filtro"){
        objself.MAP_BUSQUEDA_AVANZADA=0;
        await actualizarDatosPaginadoLeads(objself,'Cliente','ClienteContador','MAP_PAG_INI','MAP_PAG_LEN','MAP_TOTAL_REGISTROS','MAP_T1');
    }
    if(param=="ProcesoLSOList_Filtro"){
        objself.MAP_BUSQUEDA_AVANZADA=0;
        await actualizarDatosPaginadoLeads(objself,'ProcesoLSO','ProcesoLSOContador','MAP_PAG_INI','MAP_PAG_LEN','MAP_TOTAL_REGISTROS','MAP_T1');
    }
    if(param=="DeudasList_Filtro"){
        objself.MAP_BUSQUEDA_AVANZADA=0;
        await actualizarDatosPaginadoLeads(objself,'DeudaCliente','DeudaClienteContador','MAP_PAG_INI','MAP_PAG_LEN','MAP_TOTAL_REGISTROS','MAP_T1');
    }
    if(param=="DeudasMicroprestamosList_Filtro"){
        objself.MAP_BUSQUEDA_AVANZADA=0;
        await actualizarDatosPaginadoLeads(objself,'DeudaMicroprestamoCliente','DeudaMicroprestamoClienteContador','MAP_PAG_INI','MAP_PAG_LEN','MAP_TOTAL_REGISTROS','MAP_T1');
    }
    if(param=="DocumentoGlobalList_Filtro"){
        objself.MAP_BUSQUEDA_AVANZADA=0;
        await actualizarDatosPaginadoLeads(objself,'DocumentoGlobal','DocumentoGlobalContador','MAP_PAG_INI','MAP_PAG_LEN','MAP_TOTAL_REGISTROS','MAP_T1');
    }
    if(param=="DeudaClienteAccionesJudicialesList_Filtro"){
        objself.MAP_BUSQUEDA_AVANZADA=0;
        await actualizarDatosPaginadoLeads(objself,'DeudaClienteAccionesJudiciales','DeudaClienteAccionesJudicialesContador','MAP_PAG_INI','MAP_PAG_LEN','MAP_TOTAL_REGISTROS','MAP_T1');
    }
    if(param=="DevolucionInteresesClienteList_Filtro"){
        objself.MAP_BUSQUEDA_AVANZADA=0;
        await actualizarDatosPaginadoLeads(objself,'DevolucionInteresesCliente','DeudaClienteAccionesJudicialesContador','MAP_PAG_INI','MAP_PAG_LEN','MAP_TOTAL_REGISTROS','MAP_T1');
    }
    if(param=="ActividadesClienteMonitoriosList_Filtro"){
        objself.MAP_BUSQUEDA_AVANZADA=0;
        await actualizarDatosPaginadoLeads(objself,'ActividadesClienteMonitorios','ActividadesClienteMonitoriosContador','MAP_PAG_INI','MAP_PAG_LEN','MAP_TOTAL_REGISTROS','MAP_T1');
    }
    if(param=="EntidadesList_Filtro"){
        await actualizarDatosPaginadoLeads(objself,'Entidades','EntidadesContador','MAP_PAG_INI','MAP_PAG_LEN','MAP_TOTAL_REGISTROS','MAP_T1');
    }
    if(param=="MovimientosList_Filtro"){
        await objself.executeNode("filtrarContent("+objself.MAP_PESTANYA+")");
    }
    if(param=="MovimientosPlanDePagosList_Filtro"){
    await actualizarDatosPaginadoLeads(self,"MovimientosPlanDePagos","MovimientosPlanDePagosContador","MAP_PAG_INI","MAP_PAG_LEN","MAP_TOTAL_REGISTROS","MAP_T1");
    }
    if(param=="MensajeriaList_Filtro"){
        await actualizarDatosPaginadoLeads(objself,"MensajeriaChatListado","MensajeriaChatListadoContador","MAP_PAG_INI","MAP_PAG_LEN","MAP_TOTAL_REGISTROS","MAP_T1");
    }
    if(param=="ClienteNoCobrarComisionList_Filtro"){
        objself.MAP_BUSQUEDA_AVANZADA=0;
        await actualizarDatosPaginadoLeads(objself,"ClienteNoCobrarComision","ClienteNoCobrarComisionContador","MAP_PAG_INI","MAP_PAG_LEN","MAP_TOTAL_REGISTROS","MAP_T1");
    }
}


async function bloquearContentsBeforeEdit(objself) {
    
    switch (objself.getOwnerCollection().getName()){
        case "LeadEdicion":

            break;
        case "ClienteEdicion":
            await objself.getContents("ClienteObservaciones").lock();
            await objself.getContents("DeudaClientePrograma").lock();
            await objself.getContents("ClienteActualizaciones").lock();
            await objself.getContents("MovimientosCliente").lock();
            await objself.getContents("MovimientosClienteMes").lock();
            await objself.getContents("Documento").lock();
            await objself.getContents("ActividadesCliente").lock();
            await objself.getContents("DocumentoPersonal").lock();
            await objself.getContents("PlanDePagos").lock();
            await objself.getContents("DeudaClienteAddendum").lock();
            await objself.getContents("EntidadesDeudaClienteActividades").lock();
            await objself.getContents("EntidadesDeudaClienteJudicialActividades").lock();
            await objself.getContents("ActividadesClienteHijoLlamadaBienvenida").lock();
            await objself.getContents("ActividadesClienteHijoAddendum").lock();
            await objself.getContents("ActividadesClienteHijoCartaRepresentacion").lock();
            await objself.getContents("ActividadesClienteHijoResolucionPorIncumplimiento").lock();
            await objself.getContents("ActividadesClienteHijoCertificadoFinPrograma").lock();
            await objself.getContents("ActividadesClienteHijoSolicitudDevolucion").lock();
            await objself.getContents("ActividadesClienteHijoSolicitudBaja").lock();
            await objself.getContents("ActividadesClienteHijoSolicitudBajaPre14").lock();
            await objself.getContents("ActividadesClienteHijoSolicitudPausa").lock();
            await objself.getContents("ActividadesClienteHijoConversacionCliente").lock();
            await objself.getContents("ActividadesClienteHijoComisionMensual").lock();
            await objself.getContents("ActividadesClienteHijoBajaCliente").lock();
            await objself.getContents("ActividadesClienteHijoCitaEntidad").lock();
            await objself.getContents("ActividadesClienteHijoPausaManualCliente").lock();
            await objself.getContents("ActividadesClienteHijoReactivarCliente").lock();
            await objself.getContents("ActividadesClienteHijoAbstencionLlamadas").lock();
            await objself.getContents("ActividadesClienteHijoModificacionClausulasContractuales").lock();
            await objself.getContents("ActividadesClienteHijoAutorizacionIngresoCartaBancaria").lock();
            await objself.getContents("ActividadesClienteHijoDevolucionIntereses").lock();
            await objself.getContents("ActividadesClienteHijoAccionJudicial").lock();
            await objself.getContents("ActividadesClienteHijoNegociacionExtrajudicial").lock();
            await objself.getContents("ActividadesClienteHijoMonitorioRecibido").lock();
            await objself.getContents("ActividadesClienteHijoAportacionExtra").lock();
            await objself.getContents("ClienteDatosFamiliaresCargo").lock();
            await objself.getContents("ClienteDatosGastosMensuales").lock();
            await objself.getContents("ClienteDatosEmbargosActivos").lock();
            await objself.getContents("ClienteDatosSancionesHaciendaSS").lock();
            await objself.getContents("ClienteDatosVentaDonacionBien").lock();
            await objself.getContents("ClienteDatosHerencia").lock();
            await objself.getContents("ClienteDatosOtrosActivos").lock();
            await objself.getContents("ClienteDatosInmuebles").lock();
            await objself.getContents("ClienteDatosVehiculos").lock();
            await objself.getContents("ClienteVinculo").lock();
            await objself.getContents("ClienteContactoCorreos").lock();
            await objself.getContents("ClienteContactoTelefonos").lock();
            await objself.getContents("ClienteDatosPoseeAlgunaSociedad").lock();
            break;
        case "ProcesoLSOEdicion":
            await objself.getContents("ProcesoLSOObservaciones").lock();
            await objself.getContents("ProcesoLSOHistoricoEstados").lock();
            await objself.getContents("ClienteDatosFamiliaresCargo").lock();
            await objself.getContents("ClienteDatosGastosMensuales").lock();
            await objself.getContents("ClienteDatosEmbargosActivos").lock();
            await objself.getContents("ClienteDatosSancionesHaciendaSS").lock();
            await objself.getContents("ClienteDatosVentaDonacionBien").lock();
            await objself.getContents("ClienteDatosHerencia").lock();
            await objself.getContents("ClienteDatosOtrosActivos").lock();
            await objself.getContents("ClienteDatosInmuebles").lock();
            await objself.getContents("ClienteDatosVehiculos").lock();
            await objself.getContents("ClienteVinculo").lock();
            await objself.getContents("ClienteContactoCorreos").lock();
            await objself.getContents("ClienteContactoTelefonos").lock();
            await objself.getContents("ClienteDatosPoseeAlgunaSociedad").lock();
            
            break;
        default:
            // si hay otros casos, decides qué hacer o dejar false
    }
}

// function cargarContentVacio(contentName){
//     var coll = objself.getContents("contentName");
//     coll.unlock();
//     coll.loadAll();
//     coll.lock();
// }


async function goToColl(collName) {
    var obj = await appData.getCollection(collName).createObject();
    appData.pushValueAndExit(obj);
}

async function irColl(collname){
    var coll = appData.getCollection(collname);
    var obj = await coll.createObject();
    await coll.addItem(obj);
    appData.pushValue(obj);
}

async function irColl2(objself,collname){
    var coll = await objself.getContents(collname);
    var obj = await coll.createObject();
    await coll.addItem(obj);
    appData.pushValue(obj);
}


async function logoutExpirado() {

    await ui.msgBox("La sesión ha caducado. Debe iniciar sesión nuevamente","Sesión caducada",0);

    ObjMenuPadre = "";
    cerrarRingover();
    appData.logout();
}

function logout() {
    ObjMenuPadre = "";
    cerrarRingover();
    appData.logout();
}


async function selectedItemPadre(destino){
    // pasamos por parámetro el objeto del menú al que vamos a ir (destino)
    
    // guardamos la referencia del objeto para desmarcarlo cuando seleccionemos otro
    if(ObjMenuPadre==""){
        ObjMenuPadre=destino;
    }
    // Single-select DETERMINISTA: limpiamos el resaltado de TODOS los items del
    // menu (no solo el ObjMenuPadre previo; en el MPA no persiste fiable y dejaba
    // 2 items resaltados). Menu single-select.
    let collMenuSel = destino.getOwnerCollection();
    for(let i=0, n=collMenuSel.getCount(); i<n; i++){ collMenuSel.getItem(i).MAP_COLOR=0; }
    
    if (destino.MAP_NOMBRE){
        let padre=destino.getParent();
        if(destino.MAP_COLL=="LeadList"){
            if(padre.MAP_MENU==1){
                destino.MAP_COLOR=1;
            }else{
                padre.MAP_MENU=1;
                destino.MAP_COLOR=1;
            }
        }
        else if(destino.MAP_NOMBRE=="Clientes"){
            if(padre.MAP_MENU==2){
                padre.MAP_MENU=0;
            }else{
                padre.MAP_MENU=2;
                destino.MAP_COLOR=1;
            }
        }
        else if(destino.MAP_NOMBRE=="Deudas"){
            if(padre.MAP_MENU==3){
                padre.MAP_MENU=0;
            }else{
                padre.MAP_MENU=3;
                destino.MAP_COLOR=1;
            }
        }

        else if(destino.MAP_COLL=="ProcesoLSOList"){
            if(padre.MAP_MENU==4){
                destino.MAP_COLOR=1;
            }else{
                padre.MAP_MENU=4;
                destino.MAP_COLOR=1;
            }
        }
        else if(destino.MAP_COLL=="CarterasList"){
            if(padre.MAP_MENU==5){
                destino.MAP_COLOR=1;
            }else{
                padre.MAP_MENU=5;
                destino.MAP_COLOR=1;
            }
        }
        else if(destino.MAP_NOMBRE=="Movimientos"){
            if(padre.MAP_MENU==6){
                padre.MAP_MENU=0;
            }else{
                padre.MAP_MENU=6;
                destino.MAP_COLOR=1;
            }
        }
        else if(destino.MAP_COLL=="MensajeriaList"){
            if(padre.MAP_MENU==7){
                destino.MAP_COLOR=1;
            }else{
                padre.MAP_MENU=7;
                destino.MAP_COLOR=1;
            }
        }
        else if(destino.MAP_NOMBRE=="Calculadora"){
            if(padre.MAP_MENU==8){
                padre.MAP_MENU=0;
            }else{
                padre.MAP_MENU=8;
                destino.MAP_COLOR=1;
            }
            // cargamos el submenú
            // loadMenuHijo();
        }
        else if(destino.MAP_NOMBRE=="Configuración"){
            if(padre.MAP_MENU==9){
                padre.MAP_MENU=0;
            }else{
                padre.MAP_MENU=9;
                destino.MAP_COLOR=1;
            }
            // cargamos el submenú
            // loadMenuHijo();
        }
        // gurdamos la referencia del objeto para desmarcarlo cuando seleccionemos otro
        ObjMenuPadre=destino;
        
        // En el caso de leads, procesoLSO, carteras, y chat accedemos a la coll directamente
        if(padre.MAP_MENU==1 || padre.MAP_MENU==4 || padre.MAP_MENU==5 || padre.MAP_MENU==7){
            // comprobamos la conexión de signalR para cerrar la conexión si está activa de HubConnection
            // comprobarConexionWhatsapp();
            
            // para prod bloqueamos temporalmente algunos menús
            // if(appData.getCurrentEnterprise().getVariables("DESARROLLO") === 0 && (padre.MAP_MENU == 4  || padre.MAP_MENU == 7)){
            //     return;
            // }
            
            tituloPestanyaNavegador(destino);
            await goToColl(destino.MAP_COLL);
        }
    }
}

async function selectedItemHijo(){
    if(self.MAP_COLL){
        let padre=self.getParent();
        padre.MAP_MENU=0;
        // Con ObjMenuPadre deseleccionamos (repintamos) el botón de la coll MenuPadre
        // ObjMenuPadre.setFieldPropertyValue("MAP_NOMBRE","bgcolor","#FFFFFF");
        // ui.getView(padre).refresh("MAP_MENU,FRMMENU1,FRMMENU2");
        
        
        // comprobamos la conexión de signalR para cerrar la conexión si está activa de HubConnection
        // comprobarConexionWhatsapp();
        
        // para prod bloqueamos temporalmente algunos menús
        if(appData.getCurrentEnterprise().getVariables("DESARROLLO") === 0 && self.MAP_COLL=="MovimientosPlanDePagosList"){
            return;
        }
        
        // en el caso de los parámetros, editamos el objeto directamente
        if(self.MAP_COLL=="ParametrosCalculadora"){
            let coll =appData.getCollection("ParametrosCalculadora");
            let obj = await coll.findObject("ID=1");
            if(obj){
                tituloPestanyaNavegador(obj);
                appData.pushValue(obj);
            }
        }else{
            tituloPestanyaNavegador(self);
            await goToColl(self.MAP_COLL);
        }
    }
}

async function marcarMenuPadre(destino){
    // obtenemos la referencia al objeto de EntradaApp
    let layout = user.getVariables("layout");
    
    // obtenemos la referencia al objeto del content MenuPadre al que queremos ir
    let coll = await layout.getContents("WebMenuPadre");
    // let coll = await layout.getContents("MenuPadre");
    let objdestino = coll.getItem(destino);
    
    await selectedItemPadre(objdestino);
}

function marcarPadreInicio(destino){
    // Es la única forma por ahora para marcar el apartado de Leads del WebMenuPadre.
    // Si lo hago al cargar el content en EntradaApp no se desmarca el subrayado al ir a otra opción del menú
    
    // obtenemos la referencia al objeto de EntradaApp
    let layout = user.getVariables("layout");
    
    // obtenemos la referencia al objeto del content MenuPadre al que queremos ir
    let coll = getContents("WebMenuPadre");
    let objdestino = coll.getItem(destino);
    // Single-select DETERMINISTA (ver selectedItemPadre): limpiamos el resaltado
    // de TODOS los items antes de marcar el activo. Corrige el menu-multi-highlight.
    for(let i=0, n=coll.getCount(); i<n; i++){ coll.getItem(i).MAP_COLOR=0; }
    
    // guardamos la referencia del objeto para desmarcarlo cuando seleccionemos otro
    if(ObjMenuPadre==""){
        ObjMenuPadre=objdestino;
    }
    
    if (objdestino.MAP_NOMBRE){
        let padre=objdestino.getParent();
        if(objdestino.MAP_COLL=="LeadList"){
            if(padre.MAP_MENU==1){
                objdestino.MAP_COLOR=1;
            }else{
                padre.MAP_MENU=1;
                objdestino.MAP_COLOR=1;
            }
        }
    }
}


async function cargarChatMensajeria(objself) {
    // Resetear búsqueda al cambiar de chat
    cerrarBuscadorMensajes(objself);

    var idLead = prepararContextoChatMensajeria(objself);

    if (idLead <= 0) {
        return;
    }

    let view = ui.getView(objself);
    if (view) {
        let control = view.getControl("Mensajeria");
        if (control && control.element) {
            let scrollableDiv = control.element.querySelector('.xone-contents.xone-reverse-column');
            if (scrollableDiv) {
                if (scrollableDiv._scrollHandler) {
                    scrollableDiv.removeEventListener('scroll', scrollableDiv._scrollHandler);
                    scrollableDiv._scrollHandler = null;
                }
                scrollableDiv._scrollListenerAdded = false;
            }
        }
    }

    var cnt = await objself.getContents("Mensajeria");
    if (cnt) {
        cnt.unlock();
        var filtro = getFilter(objself, "Mensajeria");
        cnt.setMacro("##MACRO##", filtro);
        cnt.clear();
        cnt.lock();
    }

    ui.refresh("Mensajeria");

    if (typeof cargarBusquedaEnMemoria === "function") {
        cargarBusquedaEnMemoria(objself);
    }
    objself._ultimoChatCargado = objself.MAP_IDLEAD_SEL || objself.ID;

    ui.executeActionAfterDelay("scrollAlFondoConReintento", 3);
    ui.executeActionAfterDelay("buscarGridDOM", 1.5);
    ui.executeActionAfterDelay("precargarBusqueda", 2);

    comprobarMensajesNuevos(objself);

    // await marcarChatComoLeido(objself, idLead);

    objself.getOwnerCollection().setVariables("UltimoIdMensajeChat", 0);
}

function prepararContextoChatMensajeria(objself) {
    var idLead = objself.MAP_IDLEAD_SEL > 0 ? objself.MAP_IDLEAD_SEL : objself.ID;

    if (!idLead || idLead <= 0) {
        return 0;
    }

    objself.MAP_IDLEAD_SEL = idLead;

    return idLead;
}

// Cargar mensajes ficha individual cliente
async function cargarMensajesFicha(objself) {
    _objClienteEdicionChat = objself;
    cerrarBuscadorMensajesFicha(objself);

    objself.MAP_IDLEAD_SEL = objself.ID;
    objself.MAP_CORREO = objself.CORREO;


    // Limpiar listener de scroll anterior
    var view = ui.getView(objself);
    if (view) {
        var control = view.getControl("Mensajeria");
        if (control && control.element) {
            var scrollableDiv = control.element.querySelector('.xone-contents.xone-reverse-column');
            if (scrollableDiv) {
                if (scrollableDiv._scrollHandler) {
                    scrollableDiv.removeEventListener('scroll', scrollableDiv._scrollHandler);
                    scrollableDiv._scrollHandler = null;
                }
                scrollableDiv._scrollListenerAdded = false;
            }
        }
    }

    // Cargar content Mensajeria con el filtro del cliente
    var cnt = await objself.getContents("Mensajeria");
    if (cnt) {
        cnt.unlock();
        cnt.setMacro("##MACRO##", "m.IDLEAD=" + objself.ID);
        cnt.clear();
        cnt.lock();
    }

    // Preparar MensajeriaUltimoScript con el mismo filtro
    await prepararMensajeriaUltimoScript(objself);

    ui.refresh("Mensajeria");
    

    ui.executeActionAfterDelay("scrollAlFondoConReintento", 1);
    ui.executeActionAfterDelay("buscarGridDOM", 1.5);
    ui.executeActionAfterDelay("precargarBusquedaFicha", 2);

    comprobarMensajesNuevos(objself);
    await marcarChatComoLeido(objself, objself.ID);
    objself.getOwnerCollection().setVariables("UltimoIdMensajeChat", 0);
}

async function prepararMensajeriaUltimoScript(objself) {
    var cntUltimo = await objself.getContents("MensajeriaUltimoScript");

    if (!cntUltimo) {
        return;
    }

    var filtro = getFilter(objself, "Mensajeria");

    cntUltimo.unlock();
    cntUltimo.setMacro("##MACRO##", filtro);
    cntUltimo.clear();
    cntUltimo.lock();
}
 
// Establece la macro del filtro del content Mensajeria SIN cargar datos.
// Es la pieza clave: reutiliza tu getFilter() pero NO llama a loadAll(),
// para no cortocircuitar la paginacion inversa del framework.


async function MostrarGrupoDispositivo(grupo,coll){
	self.MAP_PESTANYA=grupo;
	
	if(coll=="Movimientos"){
    	if(grupo == 1){
            self.setFieldPropertyValue("MAP_BT1","forecolor","#FF795A");
            self.setFieldPropertyValue("MAP_BT2","forecolor","#000000");
            self.setFieldPropertyValue("MAP_BT3","forecolor","#000000");
            self.setFieldPropertyValue("MAP_BT4","forecolor","#000000");
            self.setFieldPropertyValue("MAP_BT5","forecolor","#000000");
            self.setFieldPropertyValue("MAP_BT6","forecolor","#000000");
            self.setFieldPropertyValue("MAP_BT7","forecolor","#000000");
    	}
    	else if(grupo == 2){
            self.setFieldPropertyValue("MAP_BT1","forecolor","#000000");
            self.setFieldPropertyValue("MAP_BT2","forecolor","#FF795A");
            self.setFieldPropertyValue("MAP_BT3","forecolor","#000000");
            self.setFieldPropertyValue("MAP_BT4","forecolor","#000000");
            self.setFieldPropertyValue("MAP_BT5","forecolor","#000000");
            self.setFieldPropertyValue("MAP_BT6","forecolor","#000000");
            self.setFieldPropertyValue("MAP_BT7","forecolor","#000000");
    	}
    	else if(grupo == 3){
            self.setFieldPropertyValue("MAP_BT1","forecolor","#000000");
            self.setFieldPropertyValue("MAP_BT2","forecolor","#000000");
            self.setFieldPropertyValue("MAP_BT3","forecolor","#FF795A");
            self.setFieldPropertyValue("MAP_BT4","forecolor","#000000");
            self.setFieldPropertyValue("MAP_BT5","forecolor","#000000");
            self.setFieldPropertyValue("MAP_BT6","forecolor","#000000");
            self.setFieldPropertyValue("MAP_BT7","forecolor","#000000");
    	}
    	else if(grupo == 4){
            self.setFieldPropertyValue("MAP_BT1","forecolor","#000000");
            self.setFieldPropertyValue("MAP_BT2","forecolor","#000000");
            self.setFieldPropertyValue("MAP_BT3","forecolor","#000000");
            self.setFieldPropertyValue("MAP_BT4","forecolor","#FF795A");
            self.setFieldPropertyValue("MAP_BT5","forecolor","#000000");
            self.setFieldPropertyValue("MAP_BT6","forecolor","#000000");
            self.setFieldPropertyValue("MAP_BT7","forecolor","#000000");
    	}
    	else if(grupo == 5){
            self.setFieldPropertyValue("MAP_BT1","forecolor","#000000");
            self.setFieldPropertyValue("MAP_BT2","forecolor","#000000");
            self.setFieldPropertyValue("MAP_BT3","forecolor","#000000");
            self.setFieldPropertyValue("MAP_BT4","forecolor","#000000");
            self.setFieldPropertyValue("MAP_BT5","forecolor","#FF795A");
            self.setFieldPropertyValue("MAP_BT6","forecolor","#000000");
            self.setFieldPropertyValue("MAP_BT7","forecolor","#000000");
    	}
    	else if(grupo == 6){
            self.setFieldPropertyValue("MAP_BT1","forecolor","#000000");
            self.setFieldPropertyValue("MAP_BT2","forecolor","#000000");
            self.setFieldPropertyValue("MAP_BT3","forecolor","#000000");
            self.setFieldPropertyValue("MAP_BT4","forecolor","#000000");
            self.setFieldPropertyValue("MAP_BT5","forecolor","#000000");
            self.setFieldPropertyValue("MAP_BT6","forecolor","#FF795A");
            self.setFieldPropertyValue("MAP_BT7","forecolor","#000000");
    	}
    	else if(grupo == 7){
            self.setFieldPropertyValue("MAP_BT1","forecolor","#000000");
            self.setFieldPropertyValue("MAP_BT2","forecolor","#000000");
            self.setFieldPropertyValue("MAP_BT3","forecolor","#000000");
            self.setFieldPropertyValue("MAP_BT4","forecolor","#000000");
            self.setFieldPropertyValue("MAP_BT5","forecolor","#000000");
            self.setFieldPropertyValue("MAP_BT6","forecolor","#000000");
            self.setFieldPropertyValue("MAP_BT7","forecolor","#FF795A");
    	}
	}
	else if(coll=="MovimientosPlanDePagos"){
    	if(grupo==1){
            self.setFieldPropertyValue("MAP_BT1","forecolor","#FF795A");
            self.setFieldPropertyValue("MAP_BT2","forecolor","#000000");
            self.setFieldPropertyValue("MAP_BT3","forecolor","#000000");
    	}
    	else if(grupo==2){
            self.setFieldPropertyValue("MAP_BT1","forecolor","#000000");
            self.setFieldPropertyValue("MAP_BT2","forecolor","#FF795A");
            self.setFieldPropertyValue("MAP_BT3","forecolor","#000000");
    	}
    	else if(grupo==3){
            self.setFieldPropertyValue("MAP_BT1","forecolor","#000000");
            self.setFieldPropertyValue("MAP_BT2","forecolor","#000000");
            self.setFieldPropertyValue("MAP_BT3","forecolor","#FF795A");
    	}
    	await actualizarDatosPaginadoLeads(self,"MovimientosPlanDePagos","MovimientosPlanDePagosContador","MAP_PAG_INI","MAP_PAG_LEN","MAP_TOTAL_REGISTROS","MAP_T1");
	}
	
	else if(coll=="ClienteEdicion"){
    	if(grupo==1){
            self.setFieldPropertyValue("MAP_BT1","forecolor","#FF795A");
            self.setFieldPropertyValue("MAP_BT2","forecolor","#000000");
            self.setFieldPropertyValue("MAP_BT3","forecolor","#000000");
            self.setFieldPropertyValue("MAP_BT4","forecolor","#000000");
            self.setFieldPropertyValue("MAP_BT5","forecolor","#000000");
            self.setFieldPropertyValue("MAP_CHAT","forecolor","#000000");
    	}
    	else if(grupo==2){
            self.setFieldPropertyValue("MAP_BT1","forecolor","#000000");
            self.setFieldPropertyValue("MAP_BT2","forecolor","#FF795A");
            self.setFieldPropertyValue("MAP_BT3","forecolor","#000000");
            self.setFieldPropertyValue("MAP_BT4","forecolor","#000000");
            self.setFieldPropertyValue("MAP_BT5","forecolor","#000000");
            self.setFieldPropertyValue("MAP_CHAT","forecolor","#000000");
    	}
    	else if(grupo==3){
            self.setFieldPropertyValue("MAP_BT1","forecolor","#000000");
            self.setFieldPropertyValue("MAP_BT2","forecolor","#000000");
            self.setFieldPropertyValue("MAP_BT3","forecolor","#FF795A");
            self.setFieldPropertyValue("MAP_BT4","forecolor","#000000");
            self.setFieldPropertyValue("MAP_BT5","forecolor","#000000");
            self.setFieldPropertyValue("MAP_CHAT","forecolor","#000000");
    	}
    	else if(grupo==4){
            self.setFieldPropertyValue("MAP_BT1","forecolor","#000000");
            self.setFieldPropertyValue("MAP_BT2","forecolor","#000000");
            self.setFieldPropertyValue("MAP_BT3","forecolor","#000000");
            self.setFieldPropertyValue("MAP_BT4","forecolor","#FF795A");
            self.setFieldPropertyValue("MAP_BT5","forecolor","#000000");
            self.setFieldPropertyValue("MAP_CHAT","forecolor","#000000");
    	}
    	else if(grupo==5){
            self.setFieldPropertyValue("MAP_BT1","forecolor","#000000");
            self.setFieldPropertyValue("MAP_BT2","forecolor","#000000");
            self.setFieldPropertyValue("MAP_BT3","forecolor","#000000");
            self.setFieldPropertyValue("MAP_BT4","forecolor","#000000");
    	    self.setFieldPropertyValue("MAP_BT5","forecolor","#FF795A");
            self.setFieldPropertyValue("MAP_CHAT","forecolor","#000000");
    	}
    	else if(grupo==6){
            self.setFieldPropertyValue("MAP_BT1","forecolor","#000000");
            self.setFieldPropertyValue("MAP_BT2","forecolor","#000000");
            self.setFieldPropertyValue("MAP_BT3","forecolor","#000000");
            self.setFieldPropertyValue("MAP_BT4","forecolor","#000000");
    	    self.setFieldPropertyValue("MAP_BT5","forecolor","#000000");
    	    self.setFieldPropertyValue("MAP_CHAT","forecolor","#FF795A");
    	    
    	    // recargamos el chat y descargamos las imágenes
            // await cargarChatMensajeria(self);
    	}
	} else {
	    if(grupo==1){
            self.setFieldPropertyValue("MAP_DATOS","forecolor","#FF795A");
            self.setFieldPropertyValue("MAP_DEUDAS","forecolor","#000000");
            self.setFieldPropertyValue("MAP_DATOSAD","forecolor","#000000");
            self.setFieldPropertyValue("MAP_DOCUMENTOS","forecolor","#000000");
            self.setFieldPropertyValue("MAP_ACTIVIDADES","forecolor","#000000");
            self.setFieldPropertyValue("MAP_CHAT","forecolor","#000000");
    	}
    	else if(grupo==2){
            self.setFieldPropertyValue("MAP_DATOS","forecolor","#000000");
            self.setFieldPropertyValue("MAP_DEUDAS","forecolor","#FF795A");
            self.setFieldPropertyValue("MAP_DATOSAD","forecolor","#000000");
            self.setFieldPropertyValue("MAP_DOCUMENTOS","forecolor","#000000");
            self.setFieldPropertyValue("MAP_ACTIVIDADES","forecolor","#000000");
            self.setFieldPropertyValue("MAP_CHAT","forecolor","#000000");
    	}
    	else if(grupo==3){
            self.setFieldPropertyValue("MAP_DATOS","forecolor","#000000");
            self.setFieldPropertyValue("MAP_DEUDAS","forecolor","#000000");
            self.setFieldPropertyValue("MAP_DATOSAD","forecolor","#FF795A");
            self.setFieldPropertyValue("MAP_DOCUMENTOS","forecolor","#000000");
            self.setFieldPropertyValue("MAP_ACTIVIDADES","forecolor","#000000");
            self.setFieldPropertyValue("MAP_CHAT","forecolor","#000000");
    	}
    	else if(grupo==4){
            self.setFieldPropertyValue("MAP_DATOS","forecolor","#000000");
            self.setFieldPropertyValue("MAP_DEUDAS","forecolor","#000000");
            self.setFieldPropertyValue("MAP_DATOSAD","forecolor","#000000");
            self.setFieldPropertyValue("MAP_DOCUMENTOS","forecolor","#FF795A");
            self.setFieldPropertyValue("MAP_ACTIVIDADES","forecolor","#000000");
            self.setFieldPropertyValue("MAP_CHAT","forecolor","#000000");
    	}
    	else if(grupo==5){
            self.setFieldPropertyValue("MAP_DATOS","forecolor","#000000");
            self.setFieldPropertyValue("MAP_DEUDAS","forecolor","#000000");
            self.setFieldPropertyValue("MAP_DATOSAD","forecolor","#000000");
            self.setFieldPropertyValue("MAP_DOCUMENTOS","forecolor","#000000");
            self.setFieldPropertyValue("MAP_ACTIVIDADES","forecolor","#FF795A");
            self.setFieldPropertyValue("MAP_CHAT","forecolor","#000000");

    	}
    	else if(grupo==6){
            self.setFieldPropertyValue("MAP_DATOS","forecolor","#000000");
            self.setFieldPropertyValue("MAP_DEUDAS","forecolor","#000000");
            self.setFieldPropertyValue("MAP_DATOSAD","forecolor","#000000");
            self.setFieldPropertyValue("MAP_DOCUMENTOS","forecolor","#000000");
            self.setFieldPropertyValue("MAP_ACTIVIDADES","forecolor","#000000");
            self.setFieldPropertyValue("MAP_CHAT","forecolor","#FF795A");
            
            // recargamos el chat y descargamos las imágenes
            // await cargarChatMensajeria(self);
    	}
	}
}


async function MostrarGrupoDispositivoNuevo(grupo,coll){
	
	self.MAP_PESTANYA = grupo;
	
	if(coll=="Movimientos"){
    	if(grupo == 1){
            self.setFieldPropertyValue("MAP_BT1","forecolor","#FF795A");
            self.setFieldPropertyValue("MAP_BT2","forecolor","#000000");
            self.setFieldPropertyValue("MAP_BT3","forecolor","#000000");
            self.setFieldPropertyValue("MAP_BT4","forecolor","#000000");
            self.setFieldPropertyValue("MAP_BT5","forecolor","#000000");
            self.setFieldPropertyValue("MAP_BT6","forecolor","#000000");
            self.setFieldPropertyValue("MAP_BT7","forecolor","#000000");
    	}
    	else if(grupo == 2){
            self.setFieldPropertyValue("MAP_BT1","forecolor","#000000");
            self.setFieldPropertyValue("MAP_BT2","forecolor","#FF795A");
            self.setFieldPropertyValue("MAP_BT3","forecolor","#000000");
            self.setFieldPropertyValue("MAP_BT4","forecolor","#000000");
            self.setFieldPropertyValue("MAP_BT5","forecolor","#000000");
            self.setFieldPropertyValue("MAP_BT6","forecolor","#000000");
            self.setFieldPropertyValue("MAP_BT7","forecolor","#000000");
    	}
    	else if(grupo == 3){
            self.setFieldPropertyValue("MAP_BT1","forecolor","#000000");
            self.setFieldPropertyValue("MAP_BT2","forecolor","#000000");
            self.setFieldPropertyValue("MAP_BT3","forecolor","#FF795A");
            self.setFieldPropertyValue("MAP_BT4","forecolor","#000000");
            self.setFieldPropertyValue("MAP_BT5","forecolor","#000000");
            self.setFieldPropertyValue("MAP_BT6","forecolor","#000000");
            self.setFieldPropertyValue("MAP_BT7","forecolor","#000000");
    	}
    	else if(grupo == 4){
            self.setFieldPropertyValue("MAP_BT1","forecolor","#000000");
            self.setFieldPropertyValue("MAP_BT2","forecolor","#000000");
            self.setFieldPropertyValue("MAP_BT3","forecolor","#000000");
            self.setFieldPropertyValue("MAP_BT4","forecolor","#FF795A");
            self.setFieldPropertyValue("MAP_BT5","forecolor","#000000");
            self.setFieldPropertyValue("MAP_BT6","forecolor","#000000");
            self.setFieldPropertyValue("MAP_BT7","forecolor","#000000");
    	}
    	else if(grupo == 5){
            self.setFieldPropertyValue("MAP_BT1","forecolor","#000000");
            self.setFieldPropertyValue("MAP_BT2","forecolor","#000000");
            self.setFieldPropertyValue("MAP_BT3","forecolor","#000000");
            self.setFieldPropertyValue("MAP_BT4","forecolor","#000000");
            self.setFieldPropertyValue("MAP_BT5","forecolor","#FF795A");
            self.setFieldPropertyValue("MAP_BT6","forecolor","#000000");
            self.setFieldPropertyValue("MAP_BT7","forecolor","#000000");
    	}
    	else if(grupo == 6){
            self.setFieldPropertyValue("MAP_BT1","forecolor","#000000");
            self.setFieldPropertyValue("MAP_BT2","forecolor","#000000");
            self.setFieldPropertyValue("MAP_BT3","forecolor","#000000");
            self.setFieldPropertyValue("MAP_BT4","forecolor","#000000");
            self.setFieldPropertyValue("MAP_BT5","forecolor","#000000");
            self.setFieldPropertyValue("MAP_BT6","forecolor","#FF795A");
            self.setFieldPropertyValue("MAP_BT7","forecolor","#000000");
    	}
    	else if(grupo == 7){
            self.setFieldPropertyValue("MAP_BT1","forecolor","#000000");
            self.setFieldPropertyValue("MAP_BT2","forecolor","#000000");
            self.setFieldPropertyValue("MAP_BT3","forecolor","#000000");
            self.setFieldPropertyValue("MAP_BT4","forecolor","#000000");
            self.setFieldPropertyValue("MAP_BT5","forecolor","#000000");
            self.setFieldPropertyValue("MAP_BT6","forecolor","#000000");
            self.setFieldPropertyValue("MAP_BT7","forecolor","#FF795A");
    	}
	}
	else if(coll=="LeadEdicion"){
	    
	   // Cuando tenga tiempo hacer esto para las pantallas con pestañas de manera genérica
	    
        var gruposCollLeadEdicion = {
            1: "MAP_DATOS",
            2: "MAP_DEUDAS",
            3: "MAP_DATOSAD",
            4: "MAP_DOCUMENTOS",
            5: "MAP_ACTIVIDADES",
            6: "MAP_CHAT"
        };  
        
        // convertimos el objeto en un array clave-valor con entries y recorremos buscando el grupo seleccionado
        Object.entries(gruposCollLeadEdicion).forEach(function(grupos) {
        
            var numeroPestanya = grupos[0];
            var nombrePestanya = grupos[1];
            
            // comprobamos si la pestaña coincide con el grupo seleccionado
            if (Number(numeroPestanya) === safeToInt(grupo)) {
                // color activo
                self.setFieldPropertyValue(nombrePestanya,"forecolor","#FF795A");
            } else {
                // color inactivo
                self.setFieldPropertyValue(nombrePestanya,"forecolor","#000000");
            }
        });
	}
	else if(coll=="ClienteEdicion"){
	    
	   // Cuando tenga tiempo hacer esto para las pantallas con pestañas de manera genérica
	    
        var gruposCollEdicion = {
            1: "MAP_BT_GENERAL",
            2: "MAP_BT_PROGRAMA",
            3: "MAP_BT_DEUDAS",
            4: "MAP_BT_MOVIMIENTOS",
            5: "MAP_BT_DOCUMENTOS",
            6: "MAP_BT_ACTIVIDADES",
            7: "MAP_CHAT"
        };  
        
        // convertimos el objeto en un array clave-valor con entries y recorremos buscando el grupo seleccionado
        Object.entries(gruposCollEdicion).forEach(function(grupos) {
        
            var numeroPestanya = grupos[0];
            var nombrePestanya = grupos[1];
            
            // comprobamos si la pestaña coincide con el grupo seleccionado
            if (Number(numeroPestanya) === safeToInt(grupo)) {
                // color activo
                self.setFieldPropertyValue(nombrePestanya,"forecolor","#FF795A");
            } else {
                // color inactivo
                self.setFieldPropertyValue(nombrePestanya,"forecolor","#000000");
            }
        });
	}
	else if(coll=="ProcesoLSOEdicion"){
	    
	   // Cuando tenga tiempo hacer esto para las pantallas con pestañas de manera genérica
	    
        var gruposCollProcesoLSOEdicion = {
            1: "MAP_BT_PROCESO",
            2: "MAP_BT_PROGRAMA",
            3: "MAP_BT_GENERAL",
            4: "MAP_BT_DEUDAS",
            5: "MAP_BT_MOVIMIENTOS",
            6: "MAP_BT_DOCUMENTOS",
            7: "MAP_BT_ACTIVIDADES"
        };  
        
        // convertimos el objeto en un array clave-valor con entries y recorremos buscando el grupo seleccionado
        Object.entries(gruposCollProcesoLSOEdicion).forEach(function(grupos) {
        
            var numeroPestanya = grupos[0];
            var nombrePestanya = grupos[1];
            
            // comprobamos si la pestaña coincide con el grupo seleccionado
            if (Number(numeroPestanya) === safeToInt(grupo)) {
                // color activo
                self.setFieldPropertyValue(nombrePestanya,"forecolor","#FF795A");
            } else {
                // color inactivo
                self.setFieldPropertyValue(nombrePestanya,"forecolor","#000000");
            }
        });
	}
	 else {
	    if(grupo==1){
            self.setFieldPropertyValue("MAP_DATOS","forecolor","#FF795A");
            self.setFieldPropertyValue("MAP_DEUDAS","forecolor","#000000");
            self.setFieldPropertyValue("MAP_DATOSAD","forecolor","#000000");
            self.setFieldPropertyValue("MAP_DOCUMENTOS","forecolor","#000000");
            self.setFieldPropertyValue("MAP_CHAT","forecolor","#000000");
    	}
    	else if(grupo==2){
            self.setFieldPropertyValue("MAP_DATOS","forecolor","#000000");
            self.setFieldPropertyValue("MAP_DEUDAS","forecolor","#FF795A");
            self.setFieldPropertyValue("MAP_DATOSAD","forecolor","#000000");
            self.setFieldPropertyValue("MAP_DOCUMENTOS","forecolor","#000000");
            self.setFieldPropertyValue("MAP_CHAT","forecolor","#000000");
    	}
    	else if(grupo==3){
            self.setFieldPropertyValue("MAP_DATOS","forecolor","#000000");
            self.setFieldPropertyValue("MAP_DEUDAS","forecolor","#000000");
            self.setFieldPropertyValue("MAP_DATOSAD","forecolor","#FF795A");
            self.setFieldPropertyValue("MAP_DOCUMENTOS","forecolor","#000000");
            self.setFieldPropertyValue("MAP_CHAT","forecolor","#000000");
    	}
    	else if(grupo==4){
            self.setFieldPropertyValue("MAP_DATOS","forecolor","#000000");
            self.setFieldPropertyValue("MAP_DEUDAS","forecolor","#000000");
            self.setFieldPropertyValue("MAP_DATOSAD","forecolor","#000000");
            self.setFieldPropertyValue("MAP_DOCUMENTOS","forecolor","#FF795A");
            self.setFieldPropertyValue("MAP_CHAT","forecolor","#000000");
    	}
    	else if(grupo==5){
            self.setFieldPropertyValue("MAP_DATOS","forecolor","#000000");
            self.setFieldPropertyValue("MAP_DEUDAS","forecolor","#000000");
            self.setFieldPropertyValue("MAP_DATOSAD","forecolor","#000000");
            self.setFieldPropertyValue("MAP_DOCUMENTOS","forecolor","#000000");
            self.setFieldPropertyValue("MAP_CHAT","forecolor","#FF795A");
            
            // recargamos el chat y descargamos las imágenes
            // await cargarChatMensajeria(self);
    	}
	}
}


async function annadirOrigenLeadFiltro(objself){
    // Montamos la cadena de orígenes separados por comas para el filtro "idorigen in (2,3,4)"..
    let cnt = await objself.getContents("OrigenLeadContentFiltro");
    for(let i=0; i < cnt.count(); i++){
        let obj = cnt.getItem(i);
        if(obj.MAP_SELECCIONAR == 1){
            if(objself.MAP_ORIGEN == ""){
                objself.MAP_ORIGEN = obj.CODIGO;
            }else{
                objself.MAP_ORIGEN = objself.MAP_ORIGEN+","+obj.CODIGO;
            }
        }
    }
}


function getFilter(objself,contentsName){
    var filterQuery = "(";
    
    if (contentsName==='WebMenuPadre') {
        filterQuery = filterQuery + "NIVEL=0 AND WEB=1 AND find_in_set((SELECT USERTYPE FROM gen_usuarios WHERE LOGIN='"+user.LOGIN+"' AND ROWID='"+user.ROWID+"'),PERMISOS)";
    }
    else if (contentsName==='WebMenuHijo') {
        filterQuery = filterQuery + "NIVEL=1 AND find_in_set((SELECT USERTYPE FROM gen_usuarios WHERE LOGIN='"+user.LOGIN+"' AND ROWID='"+user.ROWID+"'),PERMISOS) AND IDPADRE="+self.ID;
    }
    else if (contentsName==='Lead' || contentsName==="LeadContador") {
        // if(objself.MAP_BAJA=="Alta"){
        //     filterQuery = filterQuery + "c.BAJA=0";
        // } else {
        //     filterQuery = filterQuery + "c.BAJA=1";
        // }
        
        if(objself.MAP_VERTODO == 0){
            if(user.USERTYPE==1){
                filterQuery=filterQuery + "c.IDASESOR="+user.ID;
            }
            // pitcher
            else if(user.USERTYPE==2){
                filterQuery=filterQuery + "c.IDPITCHER="+user.ID;
            }
            // líder
            else if(user.USERTYPE==3){
                filterQuery=filterQuery + "c.IDLIDER="+user.ID;
            }
            // gerente, director
            else{
                filterQuery=filterQuery + "1=1";
            }
        }else{
            filterQuery=filterQuery + "1=1";
        }
        
        if(objself.MAP_OCULTAR_CLIENTES == 1){
            filterQuery=filterQuery + " AND c.IDESTADO != 10";
        }
        if(!isNullOrEmpty(objself.MAP_NOMBRE)){
            filterQuery = filterQuery + " AND c.NOMBRE like '%"+ objself.MAP_NOMBRE +"%'";
        }
        if(!isNullOrEmpty(objself.MAP_APELLIDOS)){
            filterQuery = filterQuery + " AND c.APELLIDOS like '%"+ objself.MAP_APELLIDOS +"%'";
        }
        if(!isNullOrEmpty(objself.MAP_MOVIL)){
            filterQuery = filterQuery + " AND (c.MOVIL like REPLACE('%"+ objself.MAP_MOVIL +"%',' ','') OR c.MOVIL2 like REPLACE('%"+ objself.MAP_MOVIL +"%',' ','') OR c.MOVIL3 like REPLACE('%"+ objself.MAP_MOVIL +"%',' ',''))";
        }
        if(!isNullOrEmpty(objself.MAP_CORREO)){
            filterQuery = filterQuery + " AND c.CORREO like '%"+ objself.MAP_CORREO +"%'";
        }
        if(objself.MAP_IDASESOR!==0){
            if(objself.MAP_IDASESOR>0){
                filterQuery = filterQuery + " AND c.IDASESOR="+ objself.MAP_IDASESOR;
            }
            if(objself.MAP_IDASESOR==-2){
                // si no está asignado
                filterQuery = filterQuery + " AND ifnull(c.IDASESOR,0)=0";
            }
        }
        if(objself.MAP_IDLIDER!==0){
            if(objself.MAP_IDLIDER>0){
                filterQuery = filterQuery + " AND c.IDLIDER="+ objself.MAP_IDLIDER;
            }
            if(objself.MAP_IDLIDER==-2){
                // si no está asignado
                filterQuery = filterQuery + " AND ifnull(c.IDLIDER,0)=0";
            }
        }
        if(objself.MAP_CODIGO_ESTADO>0){
            if(objself.MAP_CODIGO_ESTADO==3){
                if(objself.MAP_CODIGO_SUBESTADO!==0){
                    filterQuery = filterQuery + " AND c.IDESTADO="+objself.MAP_CODIGO_SUBESTADO;
                }else{
                    filterQuery = filterQuery + " AND c.IDESTADO="+objself.MAP_CODIGO_ESTADO;
                }
            }else{
                filterQuery = filterQuery + " AND c.IDESTADO="+objself.MAP_CODIGO_ESTADO;
            }
        }
        // if(objself.MAP_CANTIDAD_ORIGEN>0){
        //     filterQuery = filterQuery + " AND c.IDORIGEN IN("+objself.MAP_ORIGEN+")";
        // }
        if(objself.MAP_IDORIGEN>0){
            filterQuery = filterQuery + " AND c.IDORIGEN ="+objself.MAP_IDORIGEN;
        }
        if(objself.MAP_IDNOCONTESTA==1){
            filterQuery = filterQuery + " AND ifnull(c.NO_CONTESTA,0)=0";
        }
        if(objself.MAP_IDNOCONTESTA==2){
            filterQuery = filterQuery + " AND ifnull(c.NO_CONTESTA,0)=1";
        }
        if(!isNullOrEmpty(objself.MAP_AV_DNI)){
            filterQuery = filterQuery + " AND c.DNI like '%"+ objself.MAP_AV_DNI +"%'";
        }
        if(!isNullOrEmpty(objself.MAP_AV_EXTERNALID)){
            filterQuery = filterQuery + " AND c.IDSTRIPE like '%"+ objself.MAP_AV_EXTERNALID +"%'";
        }
        if(objself.MAP_AV_NUM_REGISTROS>0){
            filterQuery = filterQuery + " AND (SELECT COUNT(h.ID) FROM gen_cliente_historico_registro h WHERE h.IDLEAD=c.ID)="+objself.MAP_AV_NUM_REGISTROS;
        }
        if(objself.MAP_AV_DEUDA_MIN>0){
            filterQuery = filterQuery + " AND c.DEUDA_TOTAL_CALCULO>="+ objself.MAP_AV_DEUDA_MIN;
        }
        if(objself.MAP_AV_DEUDA_MAX>0){
            filterQuery = filterQuery + " AND c.DEUDA_TOTAL_CALCULO<="+ objself.MAP_AV_DEUDA_MAX;
        }
        if(objself.MAP_IDLSO==1){
            filterQuery = filterQuery + " AND ifnull(c.LSO,0)=0";
        }
        if(objself.MAP_IDLSO==2){
            filterQuery = filterQuery + " AND ifnull(c.LSO,0)=1";
        }
        if(objself.MAP_IDLSO==3){
            filterQuery = filterQuery + " AND ifnull(c.LSO,0)=2";
        }
        if(!isNullOrEmpty(safeToString(objself.MAP_AV_FECHA_REGISTRO_DESDE)) && isNullOrEmpty(safeToString(objself.MAP_AV_FECHA_REGISTRO_HASTA))){ 
            filterQuery = filterQuery + " AND DATE_FORMAT(c.FECHA_REGISTRO, '%y-%m-%d') >= DATE_FORMAT('" + safeToDate(objself.MAP_AV_FECHA_REGISTRO_DESDE) + "', '%y-%m-%d')";
        } else if (isNullOrEmpty(safeToString(objself.MAP_AV_FECHA_REGISTRO_DESDE)) && !isNullOrEmpty(safeToString(objself.MAP_AV_FECHA_REGISTRO_HASTA))){ 
            filterQuery = filterQuery + " AND DATE_FORMAT(c.FECHA_REGISTRO, '%y-%m-%d') <= DATE_FORMAT('" + safeToDate(objself.MAP_AV_FECHA_REGISTRO_HASTA) + "', '%y-%m-%d')";
        } else if (!isNullOrEmpty(safeToString(objself.MAP_AV_FECHA_REGISTRO_DESDE)) && !isNullOrEmpty(safeToString(objself.MAP_AV_FECHA_REGISTRO_HASTA))){ 
            filterQuery = filterQuery + " AND DATE_FORMAT(c.FECHA_REGISTRO, '%y-%m-%d') BETWEEN DATE_FORMAT('" + safeToDate(objself.MAP_AV_FECHA_REGISTRO_DESDE) + "', '%y-%m-%d') AND DATE_FORMAT('" + safeToDate(objself.MAP_AV_FECHA_REGISTRO_HASTA) + "', '%y-%m-%d')";
        }
        if(!isNullOrEmpty(safeToString(objself.MAP_AV_FECHA_ACTIVIDAD_DESDE)) && isNullOrEmpty(safeToString(objself.MAP_AV_FECHA_ACTIVIDAD_HASTA))){ 
            filterQuery = filterQuery + " AND DATE_FORMAT(c.FECHA_ULT_ACTIVIDAD, '%y-%m-%d') >= DATE_FORMAT('" + safeToDate(objself.MAP_AV_FECHA_ACTIVIDAD_DESDE) + "', '%y-%m-%d')";
        } else if (isNullOrEmpty(safeToString(objself.MAP_AV_FECHA_ACTIVIDAD_DESDE)) && !isNullOrEmpty(safeToString(objself.MAP_AV_FECHA_ACTIVIDAD_HASTA))){ 
            filterQuery = filterQuery + " AND DATE_FORMAT(c.FECHA_ULT_ACTIVIDAD, '%y-%m-%d') <= DATE_FORMAT('" + safeToDate(objself.MAP_AV_FECHA_ACTIVIDAD_HASTA) + "', '%y-%m-%d')";
        } else if (!isNullOrEmpty(safeToString(objself.MAP_AV_FECHA_ACTIVIDAD_DESDE)) && !isNullOrEmpty(safeToString(objself.MAP_AV_FECHA_ACTIVIDAD_HASTA))){ 
            filterQuery = filterQuery + " AND DATE_FORMAT(c.FECHA_ULT_ACTIVIDAD, '%y-%m-%d') BETWEEN DATE_FORMAT('" + safeToDate(objself.MAP_AV_FECHA_ACTIVIDAD_DESDE) + "', '%y-%m-%d') AND DATE_FORMAT('" + safeToDate(objself.MAP_AV_FECHA_ACTIVIDAD_HASTA) + "', '%y-%m-%d')";
        }
    }
    else if (contentsName==='ClienteHistoricoLlamada') {
        filterQuery = filterQuery + "ch.IDLEAD="+objself.ID;
    }
    else if (contentsName==='ActividadesLead') {
        filterQuery=filterQuery + "ca.IDLEAD="+objself.ID;
    }
    else if (contentsName==='Deuda') {
        filterQuery=filterQuery + "d.IDLEAD="+objself.ID+" and ifnull(d.BAJA,0)=0";
    }
    else if (contentsName==='DocumentoPersonal') {
        filterQuery=filterQuery + "d.BAJA=0 AND d.ROWID_LEAD='"+objself.ROWID+"' AND d.IDTIPO in (1,2,3,4,25,30)";
    }
    // else if (contentsName==='DocumentoGlobal' || contentsName==='DocumentoGlobalContador') {
    //     filterQuery=filterQuery + "d.BAJA=0 AND d.IDTIPO not in (1,2,3,4,25,30)";
    // }
    else if (contentsName==='Documento' || contentsName==="DocumentoContador" || contentsName==='DocumentoGlobal' || contentsName==='DocumentoGlobalContador') {
        filterQuery=filterQuery + "ifnull(d.BAJA,0)=0 AND d.IDTIPO not in (1,2,3,4,25,30)";
        
        if(contentsName==='Documento' || contentsName==="DocumentoContador"){
            filterQuery = filterQuery + " AND d.ROWID_LEAD='"+objself.ROWID+"'";
        }
        if(!isNullOrEmpty(objself.MAP_NOMBRE_FILTRAR)){
            filterQuery = filterQuery + " AND d.DOCUMENTO like '%"+ objself.MAP_NOMBRE_FILTRAR +"%'";
        }
        if(safeToInt(objself.MAP_IDTIPO_DOC1)!==0){
            filterQuery = filterQuery + " AND d.IDTIPO="+ objself.MAP_IDTIPO_DOC1;
        }
        if(safeToInt(objself.MAP_VALORES_ENVIAR_FIRMAR)==1){
            filterQuery = filterQuery + " AND d.ENVIAR_FIRMAR=1";
        } else if(safeToInt(objself.MAP_VALORES_ENVIAR_FIRMAR)==2){
            filterQuery = filterQuery + " AND ifnull(d.ENVIAR_FIRMAR,0)=0";
        }
        if(safeToInt(objself.MAP_VALORES_DOCUMENTO_VISIBLE)==1){
            filterQuery = filterQuery + " AND d.DOCUMENTO_VISIBLE=1";
        } else if(safeToInt(objself.MAP_VALORES_DOCUMENTO_VISIBLE)==2){
            filterQuery = filterQuery + " AND ifnull(d.DOCUMENTO_VISIBLE,0)=0";
        }
        if(safeToInt(objself.MAP_VALORES_FIRMADO)==1){
            filterQuery = filterQuery + " AND d.DOCUMENTO_FIRMADO=1";
        } else if(safeToInt(objself.MAP_VALORES_FIRMADO)==2){
            filterQuery = filterQuery + " AND ifnull(d.DOCUMENTO_FIRMADO,0)=0";
        }
        if(!isNullOrEmpty(safeToString(objself.MAP_FECHA_INICIO)) && isNullOrEmpty(safeToString(objself.MAP_FECHA_FIN))){ 
            filterQuery = filterQuery + " AND DATE_FORMAT(d.FECHA, '%y-%m-%d') >= DATE_FORMAT('" + safeToDate(objself.MAP_FECHA_INICIO) + "', '%y-%m-%d')";
        } else if (isNullOrEmpty(safeToString(objself.MAP_FECHA_INICIO)) && !isNullOrEmpty(safeToString(objself.MAP_FECHA_FIN))){ 
            filterQuery = filterQuery + " AND DATE_FORMAT(d.FECHA, '%y-%m-%d') <= DATE_FORMAT('" + safeToDate(objself.MAP_FECHA_FIN) + "', '%y-%m-%d')";
        } else if (!isNullOrEmpty(safeToString(objself.MAP_FECHA_INICIO)) && !isNullOrEmpty(safeToString(objself.MAP_FECHA_FIN))){ 
            filterQuery = filterQuery + " AND DATE_FORMAT(d.FECHA, '%y-%m-%d') BETWEEN DATE_FORMAT('" + safeToDate(objself.MAP_FECHA_INICIO) + "', '%y-%m-%d') AND DATE_FORMAT('" + safeToDate(objself.MAP_FECHA_FIN) + "', '%y-%m-%d')";
        }
        if(safeToInt(objself.MAP_IDENT_INI)!==0){
            filterQuery = filterQuery + " AND dc.IDENTIDAD="+ objself.MAP_IDENT_INI;
        }
        if(safeToInt(objself.MAP_IDENT_ACT)!==0){
            filterQuery = filterQuery + " AND dc.IDENTIDAD_NUEVO="+ objself.MAP_IDENT_ACT;
        }
        if(!isNullOrEmpty(objself.MAP_IDENTIFICADOR_DEUDA)){
            filterQuery = filterQuery + " AND dc.IDENTIFICADOR like '%"+ objself.MAP_IDENTIFICADOR_DEUDA +"%'";
        }
   
    }
    else if (contentsName==='PlanesLiquidacion') {
        filterQuery=filterQuery + "pl.IDLEAD="+objself.ID;
    }
    else if (contentsName==='Cliente' || contentsName==="ClienteContador") {
        // if(objself.MAP_BAJA=="Alta"){
        //     filterQuery = filterQuery + "c.BAJA=0";
        // } else {
        //     filterQuery = filterQuery + "c.BAJA=1";
        // }
        
        filterQuery=filterQuery + "IFNULL(c.IDESTADO,0)=10";
        
        // para ver cada técnico lo que tiene asignado por defecto
        if(objself.MAP_VERTODO == 0){
            // ESC
            if(user.USERTYPE==6){
                filterQuery=filterQuery + " AND c.IDESC="+user.ID;
            }
            // NT
            else if(user.USERTYPE==7){
                filterQuery=filterQuery + " AND c.IDNT="+user.ID;
            }
            // NR
            else if(user.USERTYPE==8){
                filterQuery=filterQuery + " AND c.IDNR="+user.ID;
            // líder operaciones
            }else if (user.USERTYPE==9){
                filterQuery=filterQuery + " AND (c.IDESC="+user.ID+" OR c.IDNT="+user.ID+" OR c.IDNR="+user.ID+")";
            }
        }
        
        if(!isNullOrEmpty(objself.MAP_NOMBRE)){
            filterQuery = filterQuery + " AND c.NOMBRE like '%"+ objself.MAP_NOMBRE +"%'";
        }
        if(!isNullOrEmpty(objself.MAP_APELLIDOS)){
            filterQuery = filterQuery + " AND c.APELLIDOS like '%"+ objself.MAP_APELLIDOS +"%'";
        }
        if(!isNullOrEmpty(objself.MAP_MOVIL)){
            filterQuery = filterQuery + " AND (c.MOVIL like REPLACE('%"+ objself.MAP_MOVIL +"%',' ','') OR c.MOVIL like REPLACE('%"+ objself.MAP_MOVIL2 +"%',' ','') OR c.MOVIL like REPLACE('%"+ objself.MAP_MOVIL3 +"%',' ',''))";
        }
        
        if(!isNullOrEmpty(objself.MAP_DNI)){
            filterQuery = filterQuery + " AND c.DNI like '%"+ objself.MAP_DNI +"%'";
        }
        if(!isNullOrEmpty(objself.MAP_CORREO)){
            filterQuery = filterQuery + " AND c.CORREO like '%"+ objself.MAP_CORREO +"%'";
        }
        if(objself.MAP_IDNT2>0){
            filterQuery = filterQuery + " AND c.IDNT="+objself.MAP_IDNT2;
        }
        if(objself.MAP_CODIGO_ESTADO>0){
            filterQuery = filterQuery + " AND c.IDESTADO_CLIENTE="+objself.MAP_CODIGO_ESTADO;
        }
        // if(!isNullOrEmpty(safeToString(objself.MAP_AV_FECHA_REG))){
        //     filterQuery = filterQuery + " AND DATE_FORMAT(c.FECHA, '%y-%m-%d') = DATE_FORMAT('" + safeToDate(objself.MAP_AV_FECHA_REG) + "', '%y-%m-%d')";
        // }
        if(!isNullOrEmpty(safeToString(objself.MAP_AV_FECHA_REGISTRO_DESDE)) && isNullOrEmpty(safeToString(objself.MAP_AV_FECHA_REGISTRO_HASTA))){ 
            filterQuery = filterQuery + " AND DATE_FORMAT(c.FECHA_INICIO_CLIENTE, '%y-%m-%d') >= DATE_FORMAT('" + safeToDate(objself.MAP_AV_FECHA_REGISTRO_DESDE) + "', '%y-%m-%d')";
        } else if (isNullOrEmpty(safeToString(objself.MAP_AV_FECHA_REGISTRO_DESDE)) && !isNullOrEmpty(safeToString(objself.MAP_AV_FECHA_REGISTRO_HASTA))){ 
            filterQuery = filterQuery + " AND DATE_FORMAT(c.FECHA_INICIO_CLIENTE, '%y-%m-%d') <= DATE_FORMAT('" + safeToDate(objself.MAP_AV_FECHA_REGISTRO_HASTA) + "', '%y-%m-%d')";
        } else if (!isNullOrEmpty(safeToString(objself.MAP_AV_FECHA_REGISTRO_DESDE)) && !isNullOrEmpty(safeToString(objself.MAP_AV_FECHA_REGISTRO_HASTA))){ 
            filterQuery = filterQuery + " AND DATE_FORMAT(c.FECHA_INICIO_CLIENTE, '%y-%m-%d') BETWEEN DATE_FORMAT('" + safeToDate(objself.MAP_AV_FECHA_REGISTRO_DESDE) + "', '%y-%m-%d') AND DATE_FORMAT('" + safeToDate(objself.MAP_AV_FECHA_REGISTRO_HASTA) + "', '%y-%m-%d')";
        }
        if(!isNullOrEmpty(safeToString(objself.MAP_AV_FECHA_ACTIVIDAD_DESDE)) && isNullOrEmpty(safeToString(objself.MAP_AV_FECHA_ACTIVIDAD_HASTA))){ 
            filterQuery = filterQuery + " AND DATE_FORMAT(c.FECHA_ULT_ACTIVIDAD, '%y-%m-%d') >= DATE_FORMAT('" + safeToDate(objself.MAP_AV_FECHA_ACTIVIDAD_DESDE) + "', '%y-%m-%d')";
        } else if (isNullOrEmpty(safeToString(objself.MAP_AV_FECHA_ACTIVIDAD_DESDE)) && !isNullOrEmpty(safeToString(objself.MAP_AV_FECHA_ACTIVIDAD_HASTA))){ 
            filterQuery = filterQuery + " AND DATE_FORMAT(c.FECHA_ULT_ACTIVIDAD, '%y-%m-%d') <= DATE_FORMAT('" + safeToDate(objself.MAP_AV_FECHA_ACTIVIDAD_HASTA) + "', '%y-%m-%d')";
        } else if (!isNullOrEmpty(safeToString(objself.MAP_AV_FECHA_ACTIVIDAD_DESDE)) && !isNullOrEmpty(safeToString(objself.MAP_AV_FECHA_ACTIVIDAD_HASTA))){ 
            filterQuery = filterQuery + " AND DATE_FORMAT(c.FECHA_ULT_ACTIVIDAD, '%y-%m-%d') BETWEEN DATE_FORMAT('" + safeToDate(objself.MAP_AV_FECHA_ACTIVIDAD_DESDE) + "', '%y-%m-%d') AND DATE_FORMAT('" + safeToDate(objself.MAP_AV_FECHA_ACTIVIDAD_HASTA) + "', '%y-%m-%d')";
        }
        if(objself.MAP_IDNR2>0){
            filterQuery = filterQuery + " AND c.IDNR="+objself.MAP_IDNR2;
        }
        if(objself.MAP_IDESC2>0){
            filterQuery = filterQuery + " AND c.IDESC="+objself.MAP_IDESC2;
        }
        // if(objself.MAP_AV_DEUDA>0){
        //     filterQuery = filterQuery + " AND (SELECT SUM(IMPORTE_ACTUAL) FROM gen_deuda_cliente WHERE IDLEAD=c.ID )="+objself.MAP_AV_DEUDA;
            // filterQuery = filterQuery + " AND (SELECT SUM(CASE WHEN IFNULL(d.IMPORTE_NUEVO,0)=0 THEN d.IMPORTE_ACTUAL ELSE d.IMPORTE_NUEVO END) FROM gen_deuda_cliente d HAVING d.IDLEAD)="+objself.MAP_AV_DEUDA;
        // }
        if(!isNullOrEmpty(objself.MAP_AV_EXTERNALID)){
            filterQuery = filterQuery + " AND c.IDSTRIPE like '%"+ objself.MAP_AV_EXTERNALID +"%'";
        }
        if(objself.MAP_AV_DEUDA_MIN>0){
            filterQuery = filterQuery + " AND (SELECT SUM(IMPORTE_ACTUAL) FROM gen_deuda_cliente WHERE IDLEAD=c.ID )>="+objself.MAP_AV_DEUDA_MIN;
        }
        if(objself.MAP_AV_DEUDA_MAX>0){
            filterQuery = filterQuery + " AND (SELECT SUM(IMPORTE_ACTUAL) FROM gen_deuda_cliente WHERE IDLEAD=c.ID )<="+objself.MAP_AV_DEUDA_MAX;
        }
        if(objself.MAP_AV_POTENCIAL_MIN>0){
            filterQuery = filterQuery + " AND (SELECT ROUND(AVG(POTENCIAL),0) FROM gen_deuda_cliente WHERE IDLEAD=c.ID)>="+objself.MAP_AV_POTENCIAL_MIN;
        }
        if(objself.MAP_AV_POTENCIAL_MAX>0){
            filterQuery = filterQuery + " AND (SELECT ROUND(AVG(POTENCIAL),0) FROM gen_deuda_cliente WHERE IDLEAD=c.ID)<="+objself.MAP_AV_POTENCIAL_MAX;
        }
        if(objself.MAP_PROGRAMA>0){
            filterQuery = filterQuery + " AND c.PROGRAMA=" + objself.MAP_PROGRAMA;
        }
        if(objself.MAP_AV_RATING_MIN>0){
            
            filterQuery = filterQuery + " AND CASE"+
            	" WHEN TIMESTAMPDIFF(MONTH,DATE(c.FECHA_INICIO_CLIENTE - INTERVAL DAYOFMONTH(c.FECHA_INICIO_CLIENTE) - 1 DAY), DATE(NOW() - INTERVAL DAYOFMONTH(NOW()) - 1 DAY))+1 = 1 THEN"+
            		" ROUND((SELECT SUM(m.IMPORTE) FROM gen_movimientos m WHERE m.IDTIPO_MOVIMIENTO=4 AND m.IDESTADO=1 AND m.IDLEAD=c.ID)/ c.CUOTA_ALIVIA*100,0)>="+objself.MAP_AV_RATING_MIN+
                " WHEN TIMESTAMPDIFF(MONTH,DATE(c.FECHA_INICIO_CLIENTE - INTERVAL DAYOFMONTH(c.FECHA_INICIO_CLIENTE) - 1 DAY), DATE(NOW() - INTERVAL DAYOFMONTH(NOW()) - 1 DAY))+1 > 1 AND DATE(NOW()) >= CONCAT(YEAR(NOW()),'-',MONTH(NOW()),'-',c.DIA_PAGO) THEN"+
            		" ROUND((SELECT SUM(m.IMPORTE) FROM gen_movimientos m WHERE m.IDTIPO_MOVIMIENTO=4 AND m.IDESTADO=1 AND m.IDLEAD=c.ID)/ (c.CUOTA_ALIVIA * (TIMESTAMPDIFF(MONTH,DATE(c.FECHA_INICIO_CLIENTE - INTERVAL DAYOFMONTH(c.FECHA_INICIO_CLIENTE) - 1 DAY), DATE(NOW() - INTERVAL DAYOFMONTH(NOW()) - 1 DAY))+1))*100,0)>="+objself.MAP_AV_RATING_MIN+
            	" ELSE"+ 
            		" ROUND((SELECT SUM(m.IMPORTE) FROM gen_movimientos m WHERE m.IDTIPO_MOVIMIENTO=4 AND m.IDESTADO=1 AND m.IDLEAD=c.ID)/ (c.CUOTA_ALIVIA * (TIMESTAMPDIFF(MONTH,DATE(c.FECHA_INICIO_CLIENTE - INTERVAL DAYOFMONTH(c.FECHA_INICIO_CLIENTE) - 1 DAY), DATE(NOW() - INTERVAL DAYOFMONTH(NOW()) - 1 DAY))))*100,0)>="+objself.MAP_AV_RATING_MIN+
                " END";
            
            
            // filterQuery = filterQuery + " AND ROUND((SELECT SUM(m.IMPORTE) FROM gen_movimientos m WHERE m.IDTIPO_MOVIMIENTO=4 AND m.IDESTADO=1 AND m.IDLEAD=c.ID)/ (c.CUOTA_ALIVIA * TIMESTAMPDIFF(MONTH,DATE(c.FECHA_INICIO_CLIENTE - INTERVAL DAYOFMONTH(c.FECHA_INICIO_CLIENTE) - 1 DAY), DATE(NOW() - INTERVAL DAYOFMONTH(NOW()) - 1 DAY)))*100,0)>="+objself.MAP_AV_RATING_MIN;
        }
        if(objself.MAP_AV_RATING_MAX>0){
            
            filterQuery = filterQuery + " AND CASE"+
            	" WHEN TIMESTAMPDIFF(MONTH,DATE(c.FECHA_INICIO_CLIENTE - INTERVAL DAYOFMONTH(c.FECHA_INICIO_CLIENTE) - 1 DAY), DATE(NOW() - INTERVAL DAYOFMONTH(NOW()) - 1 DAY))+1 = 1 THEN"+
            		" ROUND((SELECT SUM(m.IMPORTE) FROM gen_movimientos m WHERE m.IDTIPO_MOVIMIENTO=4 AND m.IDESTADO=1 AND m.IDLEAD=c.ID)/ c.CUOTA_ALIVIA*100,0)<="+objself.MAP_AV_RATING_MAX+
                " WHEN TIMESTAMPDIFF(MONTH,DATE(c.FECHA_INICIO_CLIENTE - INTERVAL DAYOFMONTH(c.FECHA_INICIO_CLIENTE) - 1 DAY), DATE(NOW() - INTERVAL DAYOFMONTH(NOW()) - 1 DAY))+1 > 1 AND DATE(NOW()) >= CONCAT(YEAR(NOW()),'-',MONTH(NOW()),'-',c.DIA_PAGO) THEN"+
            		" ROUND((SELECT SUM(m.IMPORTE) FROM gen_movimientos m WHERE m.IDTIPO_MOVIMIENTO=4 AND m.IDESTADO=1 AND m.IDLEAD=c.ID)/ (c.CUOTA_ALIVIA * (TIMESTAMPDIFF(MONTH,DATE(c.FECHA_INICIO_CLIENTE - INTERVAL DAYOFMONTH(c.FECHA_INICIO_CLIENTE) - 1 DAY), DATE(NOW() - INTERVAL DAYOFMONTH(NOW()) - 1 DAY))+1))*100,0)<="+objself.MAP_AV_RATING_MAX+
            	" ELSE"+ 
            		" ROUND((SELECT SUM(m.IMPORTE) FROM gen_movimientos m WHERE m.IDTIPO_MOVIMIENTO=4 AND m.IDESTADO=1 AND m.IDLEAD=c.ID)/ (c.CUOTA_ALIVIA * (TIMESTAMPDIFF(MONTH,DATE(c.FECHA_INICIO_CLIENTE - INTERVAL DAYOFMONTH(c.FECHA_INICIO_CLIENTE) - 1 DAY), DATE(NOW() - INTERVAL DAYOFMONTH(NOW()) - 1 DAY))))*100,0)<="+objself.MAP_AV_RATING_MAX+
                " END";
            
            // filterQuery = filterQuery + " AND ROUND((SELECT SUM(m.IMPORTE) FROM gen_movimientos m WHERE m.IDTIPO_MOVIMIENTO=4 AND m.IDESTADO=1 AND m.IDLEAD=c.ID)/ (c.CUOTA_ALIVIA * TIMESTAMPDIFF(MONTH,DATE(c.FECHA_INICIO_CLIENTE - INTERVAL DAYOFMONTH(c.FECHA_INICIO_CLIENTE) - 1 DAY), DATE(NOW() - INTERVAL DAYOFMONTH(NOW()) - 1 DAY)))*100,0)<="+objself.MAP_AV_RATING_MAX;
        }
        if(objself.MAP_AV_MESES_MIN>0){
            filterQuery = filterQuery + " AND TIMESTAMPDIFF(MONTH,DATE(c.FECHA_INICIO_CLIENTE - INTERVAL DAYOFMONTH(c.FECHA_INICIO_CLIENTE) - 1 DAY), DATE(NOW() - INTERVAL DAYOFMONTH(NOW()) - 1 DAY))>="+objself.MAP_AV_MESES_MIN;
        }
        if(objself.MAP_AV_MESES_MAX>0){
            filterQuery = filterQuery + " AND TIMESTAMPDIFF(MONTH,DATE(c.FECHA_INICIO_CLIENTE - INTERVAL DAYOFMONTH(c.FECHA_INICIO_CLIENTE) - 1 DAY), DATE(NOW() - INTERVAL DAYOFMONTH(NOW()) - 1 DAY))<="+objself.MAP_AV_MESES_MAX;
        }
        if(objself.MAP_IDTARJETA == 1){
            filterQuery = filterQuery + " AND EXISTS (SELECT 1 FROM gen_mediospago mp WHERE mp.IDLEAD = c.id AND IFNULL(mp.BAJA,0) = 0)";
        }else if(objself.MAP_IDTARJETA == 2){
            filterQuery = filterQuery + " AND NOT EXISTS (SELECT 1 FROM gen_mediospago mp WHERE mp.IDLEAD = c.id AND IFNULL(mp.BAJA,0) = 0)";
        }
        if(objself.MAP_IDSUSCRIPCION == 1){
            filterQuery = filterQuery + " AND EXISTS (SELECT 1 FROM gen_subscription s WHERE s.IDCLIENTE = c.id)";
        }else if(objself.MAP_IDSUSCRIPCION == 2){
            filterQuery = filterQuery + " AND NOT EXISTS (SELECT 1 FROM gen_subscription s WHERE s.IDCLIENTE = c.id)";
        }
        if(objself.MAP_IDTRANSFERENCIA == 1){
            filterQuery = filterQuery + " AND IFNULL(c.FECHA_PAGO_TRANSFERENCIA,'')!='' ";
        }else if(objself.MAP_IDTRANSFERENCIA == 2){
            filterQuery = filterQuery + " AND IFNULL(c.FECHA_PAGO_TRANSFERENCIA,'')='' ";
        }
        if(objself.MAP_IDPROCESO == 1){
            filterQuery = filterQuery + " AND EXISTS (SELECT 1 FROM gen_cliente_actividad_erp ca WHERE ca.IDLEAD = c.ID AND IFNULL(c.BAJA,0)=0 AND ca.IDTIPO_ACTIVIDAD = 7 AND ca.ESTADO = 0)";
        }else if(objself.MAP_IDPROCESO == 2){
            filterQuery = filterQuery + " AND NOT EXISTS (SELECT 1 FROM gen_cliente_actividad_erp ca WHERE ca.IDLEAD = c.ID AND IFNULL(c.BAJA,0)=0 AND ca.IDTIPO_ACTIVIDAD = 7 AND ca.ESTADO = 0)";
        }
        if(objself.MAP_ID_NO_COBRAR_CM == 1){
            filterQuery = filterQuery + " AND IFNULL(c.NO_COBRAR_CM_CHECK,0)=0 ";
        }else if(objself.MAP_ID_NO_COBRAR_CM == 2){
            filterQuery = filterQuery + " AND IFNULL(c.NO_COBRAR_CM_CHECK,0)=1 ";
        }
    }
    else if (contentsName==='ClienteObservaciones') {
        filterQuery=filterQuery + "c.ID="+objself.ID;
    }
    else if (contentsName==='DeudaClientePrograma') {
        filterQuery=filterQuery + "d.IDLEAD="+objself.ID+ " AND ((d.IDNT="+user.ID+" OR d.IDNR="+user.ID+" OR d.IDESC="+user.ID+") OR "+user.USERTYPE+" in(11,50,51))";
    
        // IDENTIFICADOR
        if(!isNullOrEmpty(objself.MAP_IDENTIFICADOR_FILTRAR_DEUDA)){
            filterQuery = filterQuery + " AND d.IDENTIFICADOR LIKE '%" + objself.MAP_IDENTIFICADOR_FILTRAR_DEUDA + "%'";
        }
        
       // ENTIDAD
        if(safeToInt(objself.MAP_IDENTIDAD_DEUDA) > 0){
            filterQuery = filterQuery + " AND (d.IDENTIDAD = " + objself.MAP_IDENTIDAD_DEUDA + " OR d.IDENTIDAD_NUEVO = " + objself.MAP_IDENTIDAD_DEUDA + ")";
        } 
        
        // DEUDA ACTUAL 
        if(safeToFloat(objself.MAP_DEUDA_ACTUAL_MIN) > 0){
            filterQuery = filterQuery + " AND d.IMPORTE_NUEVO >= " + objself.MAP_DEUDA_ACTUAL_MIN;
        }
        if(safeToFloat(objself.MAP_DEUDA_ACTUAL_MAX) > 0){
            filterQuery = filterQuery + " AND d.IMPORTE_NUEVO <= " + objself.MAP_DEUDA_ACTUAL_MAX;
        }
        
        // PAGO ENTIDAD 
        if(safeToFloat(objself.MAP_PAGO_ENTIDAD_MIN) > 0){
            filterQuery = filterQuery + " AND d.IMPORTE_ACTUAL >= " + objself.MAP_PAGO_ENTIDAD_MIN;
        }
        if(safeToFloat(objself.MAP_PAGO_ENTIDAD_MAX) > 0){
            filterQuery = filterQuery + " AND d.IMPORTE_ACTUAL <= " + objself.MAP_PAGO_ENTIDAD_MAX;
        }
        
        // POTENCIAL
        if(safeToFloat(objself.MAP_POTENCIAL_MIN_DEUDA) > 0){
            filterQuery = filterQuery + " AND d.POTENCIAL >= " + objself.MAP_POTENCIAL_MIN_DEUDA;
        }
        if(safeToFloat(objself.MAP_POTENCIAL_MAX_DEUDA) > 0){
            filterQuery = filterQuery + " AND d.POTENCIAL <= " + objself.MAP_POTENCIAL_MAX_DEUDA;
        }
        
        // MES SOLUCION
        if(safeToInt(objself.MAP_MES_SOL_MIN) > 0){
            filterQuery = filterQuery + " AND d.MES_FINAL >= " + objself.MAP_MES_SOL_MIN;
        }
        if(safeToInt(objself.MAP_MES_SOL_MAX) > 0){
            filterQuery = filterQuery + " AND d.MES_FINAL <= " + objself.MAP_MES_SOL_MAX;
        }
        
        // ESTADO
        if(safeToInt(objself.MAP_IDESTADO_DEUDA_FILTRAR) > 0){
            filterQuery = filterQuery + " AND d.IDESTADO = " + objself.MAP_IDESTADO_DEUDA_FILTRAR;
        }
        
        // TIPO PRODUCTO
        if(safeToInt(objself.MAP_IDTIPO_PRODUCTO_DEUDA) > 0){
            filterQuery = filterQuery + " AND d.IDTIPO_PRODUCTO = " + objself.MAP_IDTIPO_PRODUCTO_DEUDA;
        }
        
        // SITUACION 
        if(safeToInt(objself.MAP_IDSITUACION_DEUDA_FILTRAR) > 0){
            filterQuery = filterQuery + " AND d.SITUACION_DEUDA = " + objself.MAP_IDSITUACION_DEUDA_FILTRAR;
        }
        
        // LIQUIDADA 
        if(safeToInt(objself.MAP_VALORES_LIQUIDADA_DEUDA) == 1){
            filterQuery = filterQuery + " AND d.LIQUIDADA = 1";
        } else if(safeToInt(objself.MAP_VALORES_LIQUIDADA_DEUDA) == 2){
            filterQuery = filterQuery + " AND IFNULL(d.LIQUIDADA,0) = 0";
        }
        
        // BAJA 
        if(safeToInt(objself.MAP_VALORES_BAJA_DEUDA) == 1){
            filterQuery = filterQuery + " AND d.BAJA = 1";
        } else if(safeToInt(objself.MAP_VALORES_BAJA_DEUDA) == 2){
            filterQuery = filterQuery + " AND IFNULL(d.BAJA,0) = 0";
        }
        
        // FAVORITO 
        if(safeToInt(objself.MAP_VALORES_FAVORITO_DEUDA) == 1){
            filterQuery = filterQuery + " AND d.FAVORITO = 1";
        } else if(safeToInt(objself.MAP_VALORES_FAVORITO_DEUDA) == 2){
            filterQuery = filterQuery + " AND IFNULL(d.FAVORITO,0) = 0";
        }
    }
    else if (contentsName==='DeudaClienteAddendum') {
        filterQuery=filterQuery + "d.IDLEAD="+objself.ID+" AND IFNULL(d.ADDENDUM_REALIZADO,0)=0 AND IFNULL(d.BAJA,0)=0";
    }
    else if (contentsName==='ClienteActualizaciones' || contentsName==='ClienteActualizacionesContador') {
        filterQuery=filterQuery + "ifnull(c.BAJA,0)=0 AND c.IDDEUDA="+objself.MAP_IDDEUDA+" AND ta.IDESTADO_DEUDA!=0 ";
    }
    else if (contentsName==='PlanDePagos') {
        // filterQuery=filterQuery + "1=1";
        if(objself.MAP_IDDEUDA){
            filterQuery=filterQuery + "p.IDDEUDA="+objself.MAP_IDDEUDA+" AND p.BAJA=0 ";
        }else{
            return "1=2";
        }
    }
    else if (contentsName==='DeudaCliente' || contentsName==="DeudaClienteContador") {
        filterQuery=filterQuery + "ifnull(d.BAJA,0)=0";
        if(!isNullOrEmpty(objself.MAP_DNI)){
            filterQuery = filterQuery + " AND c.DNI like '%"+ objself.MAP_DNI +"%'";
        }
        if(!isNullOrEmpty(objself.MAP_IDENTIFICADOR)){
            filterQuery = filterQuery + " AND d.IDENTIFICADOR like '%"+ objself.MAP_IDENTIFICADOR +"%'";
        }
        if(objself.MAP_IDTIPO_ENT>0){
            filterQuery = filterQuery + " AND te.CODIGO="+objself.MAP_IDTIPO_ENT;
        }
        if(objself.MAP_IDENT_INI>0){
            filterQuery = filterQuery + " AND d.IDENTIDAD="+objself.MAP_IDENT_INI;
        }
        if(objself.MAP_IDENT_ACT>0){
            filterQuery = filterQuery + " AND d.IDENTIDAD_NUEVO="+objself.MAP_IDENT_ACT;
        }
        if(objself.MAP_IDPRODUCTO>0){
            filterQuery = filterQuery + " AND d.IDPRODUCTO_FINANCIERO="+objself.MAP_IDPRODUCTO;
        }
        if(objself.MAP_POTENCIAL>0){
            filterQuery = filterQuery + " AND d.POTENCIAL="+ objself.MAP_POTENCIAL;
        }
        if(objself.MAP_IDESTADODEUDA>0){
            filterQuery = filterQuery + " AND d.IDESTADO="+ objself.MAP_IDESTADODEUDA;
        }
        if(!isNullOrEmpty(objself.MAP_CLIENTE)){
            filterQuery = filterQuery + " AND c.CORREO like '%"+ objself.MAP_CLIENTE +"%'";
        }
        if(objself.MAP_IDNT2>0){
            filterQuery = filterQuery + " AND d.IDNT="+ objself.MAP_IDNT2;
        }
        if (!isNullOrEmpty(safeToString(objself.MAP_AV_FECHA_REG))){
            filterQuery = filterQuery + "  AND DATE_FORMAT(d.FECHA_REGISTRO, '%d-%m-%y') = DATE_FORMAT(CONVERT('"+objself.MAP_AV_FECHA_REG+"', DATE), '%d-%m-%y')";
        }
        if (!isNullOrEmpty(safeToString(objself.MAP_AV_FECHA_ULT_ACT))){
            filterQuery = filterQuery + "  AND DATE_FORMAT(d.FECHA_ACTUALIZACION, '%d-%m-%y') = DATE_FORMAT(CONVERT('"+objself.MAP_AV_FECHA_ULT_ACT+"', DATE), '%d-%m-%y')";
        }
        if(objself.MAP_AV_DEUDA_INI_MIN > 0 && objself.MAP_AV_DEUDA_INI_MAX === 0){ 
            filterQuery = filterQuery + " AND d.IMPORTE_ACTUAL >= " + objself.MAP_AV_DEUDA_INI_MIN;
        } else if (objself.MAP_AV_DEUDA_INI_MIN === 0 && objself.MAP_AV_DEUDA_INI_MAX > 0){ 
            filterQuery = filterQuery + " AND d.IMPORTE_ACTUAL <= " + objself.MAP_AV_DEUDA_INI_MAX;
        } else if (objself.MAP_AV_DEUDA_INI_MIN > 0 && objself.MAP_AV_DEUDA_INI_MAX > 0){ 
            filterQuery = filterQuery + " AND d.IMPORTE_ACTUAL BETWEEN " + objself.MAP_AV_DEUDA_INI_MIN + " AND " + objself.MAP_AV_DEUDA_INI_MAX;
        }
        if(objself.MAP_IDPRODUCTO_ACT>0){
            filterQuery = filterQuery + " AND d.IDPRODUCTO_FINANCIERO_ACTUAL="+objself.MAP_IDPRODUCTO_ACT;
        }
        if(objself.MAP_IDNR2>0){
            filterQuery = filterQuery + " AND d.IDNR="+ objself.MAP_IDNR2;
        }
        if(objself.MAP_IDESC>0){
            filterQuery = filterQuery + " AND d.IDESC="+ objself.MAP_IDESC;
        }
        if(objself.MAP_ID_TIPO_PRODUCTO>0){
            filterQuery = filterQuery + " AND d.IDTIPO_PRODUCTO="+ objself.MAP_ID_TIPO_PRODUCTO;
        }
        if(objself.MAP_LIQUIDADA == 1){
            filterQuery = filterQuery + " AND d.LIQUIDADA=1";
        }
        if(objself.MAP_FAVORITO == 1){
            filterQuery = filterQuery + " AND d.FAVORITO=1";
        }
        if(objself.MAP_IDACCION_COMBO > 0){
            if(objself.MAP_IDACCION_COMBO == 1){
                filterQuery = filterQuery + " AND dd_demanda.MAP_DEUDA_ACCION_JUDICIAL LIKE '%OPO%'";
                // AND MAP_DEUDA_ACCION_JUDICIAL LIKE '%OPO%'";
            }
            else if(objself.MAP_IDACCION_COMBO == 2){
                filterQuery = filterQuery + " AND dd_demanda.MAP_DEUDA_ACCION_JUDICIAL LIKE '%DEM%'";
            }
            else if(objself.MAP_IDACCION_COMBO == 3){
                filterQuery = filterQuery + " AND dd_demanda.MAP_DEUDA_ACCION_JUDICIAL LIKE '%DIL%'";
            }
        }
        if(!isNullOrEmpty(objself.MAP_ACCION)){
            filterQuery = filterQuery + " AND dd_demanda.MAP_DEUDA_ACCION_JUDICIAL LIKE '%"+objself.MAP_ACCION+"%'";
        }
    }
    else if (contentsName==='DeudaMicroprestamoCliente' || contentsName==="DeudaMicroprestamoClienteContador") {
        filterQuery=filterQuery + "ifnull(d.BAJA,0)=0 AND tp.USURA = 1";
        if(!isNullOrEmpty(objself.MAP_DNI)){
            filterQuery = filterQuery + " AND c.DNI like '%"+ objself.MAP_DNI +"%'";
        }
        if(!isNullOrEmpty(objself.MAP_IDENTIFICADOR)){
            filterQuery = filterQuery + " AND d.IDENTIFICADOR like '%"+ objself.MAP_IDENTIFICADOR +"%'";
        }
        if(objself.MAP_IDTIPO_ENT>0){
            filterQuery = filterQuery + " AND te.CODIGO="+objself.MAP_IDTIPO_ENT;
        }
        if(objself.MAP_IDENT_INI>0){
            filterQuery = filterQuery + " AND d.IDENTIDAD="+objself.MAP_IDENT_INI;
        }
        if(objself.MAP_IDENT_ACT>0){
            filterQuery = filterQuery + " AND d.IDENTIDAD_NUEVO="+objself.MAP_IDENT_ACT;
        }
        if(objself.MAP_IDPRODUCTO>0){
            filterQuery = filterQuery + " AND d.IDPRODUCTO_FINANCIERO="+objself.MAP_IDPRODUCTO;
        }
        if(objself.MAP_IDESTADODEUDA>0){
            filterQuery = filterQuery + " AND d.IDESTADO="+ objself.MAP_IDESTADODEUDA;
        }
        if(objself.MAP_IDNT2>0){
            filterQuery = filterQuery + " AND d.IDNT="+ objself.MAP_IDNT2;
        }
        if(!isNullOrEmpty(safeToString(objself.MAP_AV_FECHA_REG_DESDE)) && isNullOrEmpty(safeToString(objself.MAP_AV_FECHA_REG_HASTA))){ 
            filterQuery = filterQuery + " AND DATE_FORMAT(d.FECHA_REGISTRO, '%y-%m-%d') >= DATE_FORMAT('" + safeToDate(objself.MAP_AV_FECHA_REG_DESDE) + "', '%y-%m-%d')";
        } else if (isNullOrEmpty(safeToString(objself.MAP_AV_FECHA_REG_DESDE)) && !isNullOrEmpty(safeToString(objself.MAP_AV_FECHA_REG_HASTA))){ 
            filterQuery = filterQuery + " AND DATE_FORMAT(d.FECHA_REGISTRO, '%y-%m-%d') <= DATE_FORMAT('" + safeToDate(objself.MAP_AV_FECHA_REG_HASTA) + "', '%y-%m-%d')";
        } else if (!isNullOrEmpty(safeToString(objself.MAP_AV_FECHA_REG_DESDE)) && !isNullOrEmpty(safeToString(objself.MAP_AV_FECHA_REG_HASTA))){ 
            filterQuery = filterQuery + " AND DATE_FORMAT(d.FECHA_REGISTRO, '%y-%m-%d') BETWEEN DATE_FORMAT('" + safeToDate(objself.MAP_AV_FECHA_REG_DESDE) + "', '%y-%m-%d') AND DATE_FORMAT('" + safeToDate(objself.MAP_AV_FECHA_REG_HASTA) + "', '%y-%m-%d')";
        }
        if(!isNullOrEmpty(safeToString(objself.MAP_AV_FECHA_ULT_ACT_DESDE)) && isNullOrEmpty(safeToString(objself.MAP_AV_FECHA_ULT_ACT_HASTA))){ 
            filterQuery = filterQuery + " AND DATE_FORMAT(d.FECHA_ACTUALIZACION, '%y-%m-%d') >= DATE_FORMAT('" + safeToDate(objself.MAP_AV_FECHA_ULT_ACT_DESDE) + "', '%y-%m-%d')";
        } else if (isNullOrEmpty(safeToString(objself.MAP_AV_FECHA_ULT_ACT_DESDE)) && !isNullOrEmpty(safeToString(objself.MAP_AV_FECHA_ULT_ACT_HASTA))){ 
            filterQuery = filterQuery + " AND DATE_FORMAT(d.FECHA_ACTUALIZACION, '%y-%m-%d') <= DATE_FORMAT('" + safeToDate(objself.MAP_AV_FECHA_ULT_ACT_HASTA) + "', '%y-%m-%d')";
        } else if (!isNullOrEmpty(safeToString(objself.MAP_AV_FECHA_ULT_ACT_DESDE)) && !isNullOrEmpty(safeToString(objself.MAP_AV_FECHA_ULT_ACT_HASTA))){ 
            filterQuery = filterQuery + " AND DATE_FORMAT(d.FECHA_ACTUALIZACION, '%y-%m-%d') BETWEEN DATE_FORMAT('" + safeToDate(objself.MAP_AV_FECHA_ULT_ACT_DESDE) + "', '%y-%m-%d') AND DATE_FORMAT('" + safeToDate(objself.MAP_AV_FECHA_ULT_ACT_HASTA) + "', '%y-%m-%d')";
        }
        if(objself.MAP_AV_DEUDA_INI_MIN > 0 && objself.MAP_AV_DEUDA_INI_MAX === 0){ 
            filterQuery = filterQuery + " AND d.IMPORTE_ACTUAL >= " + objself.MAP_AV_DEUDA_INI_MIN;
        } else if (objself.MAP_AV_DEUDA_INI_MIN === 0 && objself.MAP_AV_DEUDA_INI_MAX > 0){ 
            filterQuery = filterQuery + " AND d.IMPORTE_ACTUAL <= " + objself.MAP_AV_DEUDA_INI_MAX;
        } else if (objself.MAP_AV_DEUDA_INI_MIN > 0 && objself.MAP_AV_DEUDA_INI_MAX > 0){ 
            filterQuery = filterQuery + " AND d.IMPORTE_ACTUAL BETWEEN " + objself.MAP_AV_DEUDA_INI_MIN + " AND " + objself.MAP_AV_DEUDA_INI_MAX;
        }
        if(objself.MAP_AV_DEUDA_ACT_MIN > 0 && objself.MAP_AV_DEUDA_ACT_MAX === 0){ 
            filterQuery = filterQuery + " AND d.IMPORTE_NUEVO >= " + objself.MAP_AV_DEUDA_ACT_MIN;
        } else if (objself.MAP_AV_DEUDA_ACT_MIN === 0 && objself.MAP_AV_DEUDA_ACT_MAX > 0){ 
            filterQuery = filterQuery + " AND d.IMPORTE_NUEVO <= " + objself.MAP_AV_DEUDA_ACT_MAX;
        } else if (objself.MAP_AV_DEUDA_ACT_MIN > 0 && objself.MAP_AV_DEUDA_ACT_MAX > 0){ 
            filterQuery = filterQuery + " AND d.IMPORTE_NUEVO BETWEEN " + objself.MAP_AV_DEUDA_ACT_MIN + " AND " + objself.MAP_AV_DEUDA_ACT_MAX;
        }
        if(objself.MAP_IDPRODUCTO_ACT > 0){
            filterQuery = filterQuery + " AND d.IDPRODUCTO_FINANCIERO_ACTUAL="+objself.MAP_IDPRODUCTO_ACT;
        }
        if(objself.MAP_POTENCIAL > 0){
            filterQuery = filterQuery + " AND d.POTENCIAL="+ objself.MAP_POTENCIAL;
        }
        if(objself.MAP_IDACCION_COMBO > 0){
            if(objself.MAP_IDACCION_COMBO == 1){
                filterQuery = filterQuery + " AND dd_demanda.MAP_DEUDA_ACCION_JUDICIAL LIKE '%OPO%'";
                // AND MAP_DEUDA_ACCION_JUDICIAL LIKE '%OPO%'";
            }
            else if(objself.MAP_IDACCION_COMBO == 2){
                filterQuery = filterQuery + " AND dd_demanda.MAP_DEUDA_ACCION_JUDICIAL LIKE '%DEM%'";
            }
            else if(objself.MAP_IDACCION_COMBO == 3){
                filterQuery = filterQuery + " AND dd_demanda.MAP_DEUDA_ACCION_JUDICIAL LIKE '%DIL%'";
            }
        }
        if(!isNullOrEmpty(objself.MAP_ACCION)){
            filterQuery = filterQuery + " AND dd_demanda.MAP_DEUDA_ACCION_JUDICIAL LIKE '%"+objself.MAP_ACCION+"%'";
        }
        if(!isNullOrEmpty(objself.MAP_CLIENTE)){
            filterQuery = filterQuery + " AND c.CORREO like '%"+ objself.MAP_CLIENTE +"%'";
        }
        if(objself.MAP_IDNR2 > 0){
            filterQuery = filterQuery + " AND d.IDNR="+ objself.MAP_IDNR2;
        }
        if(objself.MAP_IDESC > 0){
            filterQuery = filterQuery + " AND d.IDESC="+ objself.MAP_IDESC;
        }
        if(objself.MAP_SALDO_SUFICIENTE == 1){
            filterQuery = filterQuery + " AND IFNULL(d.LIQUIDADA,0) = 0 AND d.IDESTADO != 6 AND datos_deuda.MAP_PAF > 0 AND c.SALDO > datos_deuda.MAP_PAF + datos_deuda.MAP_CE";
        }
        if(objself.MAP_LIQUIDADA == 1){
            filterQuery = filterQuery + " AND d.LIQUIDADA=1";
        }
        if(objself.MAP_FAVORITO == 1){
            filterQuery = filterQuery + " AND d.FAVORITO=1";
        }
    }
    else if (contentsName==='DeudaClienteAccionesJudiciales' || contentsName==="DeudaClienteAccionesJudicialesContador") {
        filterQuery=filterQuery + "ca.IDTIPO_ACTIVIDAD = 20 AND ifnull(d.BAJA,0)=0 AND ca.ESTADO != 2";
        
        if(!isNullOrEmpty(objself.MAP_CORREO)){
            filterQuery = filterQuery + " AND c.CORREO like '%" + objself.MAP_CORREO +"%'";
        }
        if(!isNullOrEmpty(objself.MAP_IDENTIFICADOR_DEUDA)){
            filterQuery = filterQuery + " AND d.IDENTIFICADOR like '%" + objself.MAP_IDENTIFICADOR_DEUDA +"%'";
        }
        if(objself.MAP_IDENTIDAD > 0){
            filterQuery = filterQuery + " AND COALESCE(d.IDENTIDAD_NUEVO,d.IDENTIDAD) = " + objself.MAP_IDENTIDAD;
        }
        if(!isNullOrEmpty(objself.MAP_IDENTIFICADOR_DEMANDA)){
            filterQuery = filterQuery + " AND dd.IDENTIFICADOR like '%" + objself.MAP_IDENTIFICADOR_DEMANDA +"%'";
        }
        if(objself.MAP_IDTIPO_ACCION > 0){
            if(objself.MAP_IDTIPO_ACCION == 1){
                filterQuery = filterQuery + " AND dd.NUMERO_OPOSICION > 0";
            }
            else if(objself.MAP_IDTIPO_ACCION == 2) {
                filterQuery = filterQuery + " AND dd.NUMERO_DEMANDA > 0";
            }
            else if(objself.MAP_IDTIPO_ACCION == 3) {
                filterQuery = filterQuery + " AND dd.NUMERO_DILIGENCIA > 0";
            }
        }
        if(objself.MAP_IDESTADO_APUD_ACTA > 0){
            filterQuery = filterQuery + " AND acc.ID_ESTADO_APUD_ACCION_JUDICIAL = " + objself.MAP_IDESTADO_APUD_ACTA;
        }
        if(objself.MAP_IDESTADO_DEMANDA > 0){
            filterQuery = filterQuery + " AND acc.ID_ESTADO_ACCION_JUDICIAL = " + objself.MAP_IDESTADO_DEMANDA;
        }
        if(objself.MAP_IDVIABILIDAD_ESTUDIO > 0){
            filterQuery = filterQuery + " AND acc.ID_VIABILIDAD_ESTUDIO = " + objself.MAP_IDVIABILIDAD_ESTUDIO;
        }
        if(objself.MAP_IDESTADO_ACCION_JUDICIAL > 0){
            filterQuery = filterQuery + " AND acc.IDESTADO = " + objself.MAP_IDESTADO_ACCION_JUDICIAL;
        }
        if(objself.MAP_IDRESULTADO_JUICIO > 0){
            filterQuery = filterQuery + " AND acc.ID_RESULTADO_JUICIO = " + objself.MAP_IDRESULTADO_JUICIO;
        }
        if(!isNullOrEmpty(safeToString(objself.MAP_AV_FECHA_AUDIENCIA_DESDE)) && isNullOrEmpty(safeToString(objself.MAP_AV_FECHA_AUDIENCIA_HASTA))){ 
            filterQuery = filterQuery + " AND DATE_FORMAT(acc.FECHA_JUICIO, '%y-%m-%d') >= DATE_FORMAT('" + safeToDate(objself.MAP_AV_FECHA_AUDIENCIA_DESDE) + "', '%y-%m-%d')";
        } else if (isNullOrEmpty(safeToString(objself.MAP_AV_FECHA_AUDIENCIA_DESDE)) && !isNullOrEmpty(safeToString(objself.MAP_AV_FECHA_AUDIENCIA_HASTA))){ 
            filterQuery = filterQuery + " AND DATE_FORMAT(acc.FECHA_JUICIO, '%y-%m-%d') <= DATE_FORMAT('" + safeToDate(objself.MAP_AV_FECHA_AUDIENCIA_HASTA) + "', '%y-%m-%d')";
        } else if (!isNullOrEmpty(safeToString(objself.MAP_AV_FECHA_AUDIENCIA_DESDE)) && !isNullOrEmpty(safeToString(objself.MAP_AV_FECHA_AUDIENCIA_HASTA))){ 
            filterQuery = filterQuery + " AND DATE_FORMAT(acc.FECHA_JUICIO, '%y-%m-%d') BETWEEN DATE_FORMAT('" + safeToDate(objself.MAP_AV_FECHA_AUDIENCIA_DESDE) + "', '%y-%m-%d') AND DATE_FORMAT('" + safeToDate(objself.MAP_AV_FECHA_AUDIENCIA_HASTA) + "', '%y-%m-%d')";
        }
        if(!isNullOrEmpty(safeToString(objself.MAP_AV_FECHA_SENTENCIA_DESDE)) && isNullOrEmpty(safeToString(objself.MAP_AV_FECHA_SENTENCIA_HASTA))){ 
            filterQuery = filterQuery + " AND DATE_FORMAT(acc.FECHA_SENTENCIA, '%y-%m-%d') >= DATE_FORMAT('" + safeToDate(objself.MAP_AV_FECHA_SENTENCIA_DESDE) + "', '%y-%m-%d')";
        } else if (isNullOrEmpty(safeToString(objself.MAP_AV_FECHA_SENTENCIA_DESDE)) && !isNullOrEmpty(safeToString(objself.MAP_AV_FECHA_SENTENCIA_HASTA))){ 
            filterQuery = filterQuery + " AND DATE_FORMAT(acc.FECHA_SENTENCIA, '%y-%m-%d') <= DATE_FORMAT('" + safeToDate(objself.MAP_AV_FECHA_SENTENCIA_HASTA) + "', '%y-%m-%d')";
        } else if (!isNullOrEmpty(safeToString(objself.MAP_AV_FECHA_SENTENCIA_DESDE)) && !isNullOrEmpty(safeToString(objself.MAP_AV_FECHA_SENTENCIA_HASTA))){ 
            filterQuery = filterQuery + " AND DATE_FORMAT(acc.FECHA_SENTENCIA, '%y-%m-%d') BETWEEN DATE_FORMAT('" + safeToDate(objself.MAP_AV_FECHA_SENTENCIA_DESDE) + "', '%y-%m-%d') AND DATE_FORMAT('" + safeToDate(objself.MAP_AV_FECHA_SENTENCIA_HASTA) + "', '%y-%m-%d')";
        }
        if(objself.MAP_AV_DIAS_DESDE > 0 && objself.MAP_AV_DIAS_HASTA === 0){ 
            filterQuery = filterQuery + " AND IFNULL(acc.DIAS_TRANSCURRIDOS,0)  >= " + objself.MAP_AV_DIAS_DESDE;
        } else if (objself.MAP_AV_DIAS_DESDE === 0 && objself.MAP_AV_DIAS_HASTA > 0){ 
            filterQuery = filterQuery + " AND IFNULL(acc.DIAS_TRANSCURRIDOS,0)  <= " + objself.MAP_AV_DIAS_HASTA;
        } else if (objself.MAP_AV_DIAS_DESDE > 0 && objself.MAP_AV_DIAS_HASTA > 0){ 
            filterQuery = filterQuery + " AND IFNULL(acc.DIAS_TRANSCURRIDOS,0)  BETWEEN " + objself.MAP_AV_DIAS_DESDE + " AND " + objself.MAP_AV_DIAS_HASTA;
        }
        if(!isNullOrEmpty(objself.MAP_AV_NOMBRE_APELLIDOS)){
            filterQuery = filterQuery + " AND CONCAT(c.NOMBRE,' ',COALESCE(c.APELLIDOS,'')) like '%" + objself.MAP_AV_NOMBRE_APELLIDOS + "%'";
        }
        if(!isNullOrEmpty(objself.MAP_AV_OBSERVACIONES)){
            filterQuery = filterQuery + " AND acc.OBSERVACIONES like '%" + objself.MAP_AV_OBSERVACIONES + "%'";
        }
    }
    else if (contentsName==='DevolucionInteresesCliente' || contentsName==="DevolucionInteresesClienteContador") {
        filterQuery=filterQuery + "ca.ESTADO != 2";
        
        if(!isNullOrEmpty(objself.MAP_IDENTIFICADOR_ACTIVIDAD)){
            filterQuery = filterQuery + " AND dei.IDENTIFICADOR like '%" + objself.MAP_IDENTIFICADOR_ACTIVIDAD +"%'";
        }
        if(!isNullOrEmpty(objself.MAP_CORREO)){
            filterQuery = filterQuery + " AND c.CORREO like '%" + objself.MAP_CORREO +"%'";
        }
        if(objself.MAP_IDENTIDAD > 0){
            filterQuery = filterQuery + " AND COALESCE(d.IDENTIDAD_NUEVO,d.IDENTIDAD) = " + objself.MAP_IDENTIDAD;
        }
        if(!isNullOrEmpty(objself.MAP_IDENTIFICADOR_DEUDA)){
            filterQuery = filterQuery + " AND d.IDENTIFICADOR like '%" + objself.MAP_IDENTIFICADOR_DEUDA +"%'";
        }
        if(objself.MAP_IDESTADO_DEUDA > 0){
            filterQuery = filterQuery + " AND d.IDESTADO = " + objself.MAP_IDESTADO_DEUDA;
        }
        if(objself.MAP_IDTIPO_DEVOLUCION > 0){
            filterQuery = filterQuery + " AND dei.ID_TIPO_DEVOLUCION = " + objself.MAP_IDTIPO_DEVOLUCION;
        }
        if(objself.MAP_IDTRANSFERENCIA_A > 0){
            filterQuery = filterQuery + " AND dei.ID_RECEPTOR_DEVOLUCION = " + objself.MAP_IDTRANSFERENCIA_A;
        }
        if(!isNullOrEmpty(safeToString(objself.MAP_AV_FECHA_ACUERDO_DESDE)) && isNullOrEmpty(safeToString(objself.MAP_AV_FECHA_ACUERDO_HASTA))){ 
            filterQuery = filterQuery + " AND DATE_FORMAT(dei.FECHA_ACUERDO, '%y-%m-%d') >= DATE_FORMAT('" + safeToDate(objself.MAP_AV_FECHA_ACUERDO_DESDE) + "', '%y-%m-%d')";
        } else if (isNullOrEmpty(safeToString(objself.MAP_AV_FECHA_ACUERDO_DESDE)) && !isNullOrEmpty(safeToString(objself.MAP_AV_FECHA_ACUERDO_HASTA))){ 
            filterQuery = filterQuery + " AND DATE_FORMAT(dei.FECHA_ACUERDO, '%y-%m-%d') <= DATE_FORMAT('" + safeToDate(objself.MAP_AV_FECHA_ACUERDO_HASTA) + "', '%y-%m-%d')";
        } else if (!isNullOrEmpty(safeToString(objself.MAP_AV_FECHA_ACUERDO_DESDE)) && !isNullOrEmpty(safeToString(objself.MAP_AV_FECHA_ACUERDO_HASTA))){ 
            filterQuery = filterQuery + " AND DATE_FORMAT(dei.FECHA_ACUERDO, '%y-%m-%d') BETWEEN DATE_FORMAT('" + safeToDate(objself.MAP_AV_FECHA_ACUERDO_DESDE) + "', '%y-%m-%d') AND DATE_FORMAT('" + safeToDate(objself.MAP_AV_FECHA_ACUERDO_HASTA) + "', '%y-%m-%d')";
        }
        if(objself.MAP_AV_DIAS_TRANSCURRIDOS_DESDE > 0 && objself.MAP_AV_DIAS_TRANSCURRIDOS_HASTA === 0){ 
            filterQuery = filterQuery + " AND DATEDIFF(CURDATE(), dei.FECHA_ACUERDO)  >= " + objself.MAP_AV_DIAS_TRANSCURRIDOS_DESDE;
        } else if (objself.MAP_AV_DIAS_TRANSCURRIDOS_DESDE === 0 && objself.MAP_AV_DIAS_TRANSCURRIDOS_HASTA > 0){ 
            filterQuery = filterQuery + " AND DATEDIFF(CURDATE(), dei.FECHA_ACUERDO)  <= " + objself.MAP_AV_DIAS_TRANSCURRIDOS_HASTA;
        } else if (objself.MAP_AV_DIAS_TRANSCURRIDOS_DESDE > 0 && objself.MAP_AV_DIAS_TRANSCURRIDOS_HASTA > 0){ 
            filterQuery = filterQuery + " AND DATEDIFF(CURDATE(), dei.FECHA_ACUERDO)  BETWEEN " + objself.MAP_AV_DIAS_TRANSCURRIDOS_DESDE + " AND " + objself.MAP_AV_DIAS_TRANSCURRIDOS_HASTA;
        }
        if(objself.MAP_AV_IDSITUACION > 0){
            // En plazo
            if(objself.MAP_AV_IDSITUACION == 1){ 
            filterQuery = filterQuery + " AND dei.FECHA_LIMITE >= CURDATE()";
            // Fuera de plazo
        } else if (objself.MAP_AV_IDSITUACION == 2){ 
            filterQuery = filterQuery + " AND dei.FECHA_LIMITE <= CURDATE()";
        } else if (objself.MAP_AV_IDSITUACION == 3){ 
            filterQuery = filterQuery + " AND mov10.IDENTIFICADOR_MOVIMIENTO IS NOT NULL ";
        }
        }
        if(!isNullOrEmpty(safeToString(objself.MAP_AV_FECHA_LIMITE_DESDE)) && isNullOrEmpty(safeToString(objself.MAP_AV_FECHA_LIMITE_HASTA))){ 
            filterQuery = filterQuery + " AND DATE_FORMAT(dei.FECHA_LIMITE, '%y-%m-%d') >= DATE_FORMAT('" + safeToDate(objself.MAP_AV_FECHA_LIMITE_DESDE) + "', '%y-%m-%d')";
        } else if (isNullOrEmpty(safeToString(objself.MAP_AV_FECHA_LIMITE_DESDE)) && !isNullOrEmpty(safeToString(objself.MAP_AV_FECHA_LIMITE_HASTA))){ 
            filterQuery = filterQuery + " AND DATE_FORMAT(dei.FECHA_LIMITE, '%y-%m-%d') <= DATE_FORMAT('" + safeToDate(objself.MAP_AV_FECHA_LIMITE_HASTA) + "', '%y-%m-%d')";
        } else if (!isNullOrEmpty(safeToString(objself.MAP_AV_FECHA_LIMITE_DESDE)) && !isNullOrEmpty(safeToString(objself.MAP_AV_FECHA_LIMITE_HASTA))){ 
            filterQuery = filterQuery + " AND DATE_FORMAT(dei.FECHA_LIMITE, '%y-%m-%d') BETWEEN DATE_FORMAT('" + safeToDate(objself.MAP_AV_FECHA_LIMITE_DESDE) + "', '%y-%m-%d') AND DATE_FORMAT('" + safeToDate(objself.MAP_AV_FECHA_LIMITE_HASTA) + "', '%y-%m-%d')";
        }
        if(objself.MAP_AV_IMPORTE_RECIBIR_DESDE > 0 && objself.MAP_AV_IMPORTE_RECIBIR_HASTA === 0){ 
            filterQuery = filterQuery + " AND IFNULL(dei.IMPORTE_RECIBIR,0)  >= " + objself.MAP_AV_IMPORTE_RECIBIR_DESDE;
        } else if (objself.MAP_AV_IMPORTE_RECIBIR_DESDE === 0 && objself.MAP_AV_IMPORTE_RECIBIR_HASTA > 0){ 
            filterQuery = filterQuery + " AND IFNULL(dei.IMPORTE_RECIBIR,0)  <= " + objself.MAP_AV_IMPORTE_RECIBIR_HASTA;
        } else if (objself.MAP_AV_IMPORTE_RECIBIR_DESDE > 0 && objself.MAP_AV_IMPORTE_RECIBIR_HASTA > 0){ 
            filterQuery = filterQuery + " AND IFNULL(dei.IMPORTE_RECIBIR,0)  BETWEEN " + objself.MAP_AV_IMPORTE_RECIBIR_DESDE + " AND " + objself.MAP_AV_IMPORTE_RECIBIR_HASTA;
        }
        if(objself.MAP_AV_IDESTADO > 0){
            filterQuery = filterQuery + " AND dei.IDESTADO = " + objself.MAP_AV_IDESTADO;
        }
        if(!isNullOrEmpty(objself.MAP_AV_MOV_DIA)){
            filterQuery = filterQuery + " AND mov10.IDENTIFICADOR like '%" + objself.MAP_AV_MOV_DIA +"%'";
        }
        if(!isNullOrEmpty(objself.MAP_AV_MOV_DIC)){
            filterQuery = filterQuery + " AND mov11.IDENTIFICADOR like '%" + objself.MAP_AV_MOV_DIC +"%'";
        }
    }
    else if (contentsName==='ActividadesClienteMonitorios' || contentsName==="ActividadesClienteMonitoriosContador") {
        filterQuery=filterQuery + "ca.IDTIPO_ACTIVIDAD = 22 AND ifnull(d.BAJA,0)=0";
        
        if(!isNullOrEmpty(objself.MAP_CORREO)){
            filterQuery = filterQuery + " AND c.CORREO like '%" + objself.MAP_CORREO +"%'";
        }
        if(!isNullOrEmpty(objself.MAP_IDENTIFICADOR_DEUDA)){
            filterQuery = filterQuery + " AND d.IDENTIFICADOR like '%" + objself.MAP_IDENTIFICADOR_DEUDA +"%'";
        }
        if(objself.MAP_IDENTIDAD > 0){
            filterQuery = filterQuery + " AND COALESCE(d.IDENTIDAD_NUEVO,d.IDENTIDAD) = " + objself.MAP_IDENTIDAD;
        }
        if(!isNullOrEmpty(objself.MAP_IDENTIFICADOR_MONITORIO)){
            filterQuery = filterQuery + " AND mon.IDENTIFICADOR like '%" + objself.MAP_IDENTIFICADOR_MONITORIO +"%'";
        }
        if(objself.MAP_IDESTADO_RESULTADO_ESTUDIO_FILTRO > 0){
            filterQuery = filterQuery + " AND mon.IDESTADO_RESULTADO_ESTUDIO =" + objself.MAP_IDESTADO_RESULTADO_ESTUDIO_FILTRO;
        }
        if(!isNullOrEmpty(objself.MAP_OPOSICION_VINCULADA_FILTRO)){
            filterQuery = filterQuery + " AND dcd.IDENTIFICADOR like '%" + objself.MAP_OPOSICION_VINCULADA_FILTRO +"%'";
        }
        if(objself.MAP_IDRESPONSABLE > 0){
            filterQuery = filterQuery + " AND mon.IDUSUARIO_RESPONSABLE = " + objself.MAP_IDRESPONSABLE;
        }
        if(objself.MAP_ID_TIENE_OPOSICION > 0){
            if(objself.MAP_ID_TIENE_OPOSICION == 1){
                filterQuery = filterQuery + "  AND IFNULL(dcd.IDENTIFICADOR,'') != '' ";
            }
            else if(objself.MAP_ID_TIENE_OPOSICION == 2) {
                filterQuery = filterQuery + " AND IFNULL(dcd.IDENTIFICADOR,'') = '' ";
            }
        }
        if(objself.MAP_IDESTADO_OPOSICION > 0){
            filterQuery = filterQuery + "  AND ca_demanda.ID_ESTADO_ACCION_JUDICIAL = " + objself.MAP_IDESTADO_OPOSICION;
        }
        if(objself.MAP_AV_IDESTADO_MONITORIO > 0){
            if(objself.MAP_AV_IDESTADO_MONITORIO == 1){
                filterQuery = filterQuery + "  AND dias.MAP_DIAS_TRANSCURRIDOS BETWEEN 0 AND 7 ";
            }
            else if(objself.MAP_AV_IDESTADO_MONITORIO == 2) {
                filterQuery = filterQuery + " AND dias.MAP_DIAS_TRANSCURRIDOS BETWEEN 8 AND 12 ";
            }
            else if(objself.MAP_AV_IDESTADO_MONITORIO == 3) {
                filterQuery = filterQuery + " AND dias.MAP_DIAS_TRANSCURRIDOS BETWEEN 13 AND 19 ";
            }
            else if(objself.MAP_AV_IDESTADO_MONITORIO == 4) {
                filterQuery = filterQuery + " AND dias.MAP_DIAS_TRANSCURRIDOS >= 20 ";
            }
        }
    }
    else if (contentsName==='ActividadesCliente' || contentsName==='ActividadesClienteContador') {
        // para lead filtramos solo cartas de representación
        let coleccion = objself.getOwnerCollection().getName();
        
        if(coleccion == "LeadEdicion") {
            filterQuery=filterQuery + "ca.IDLEAD=" + objself.ID + " AND ca.IDTIPO_ACTIVIDAD = 3";
        } else {
            filterQuery=filterQuery + "ca.IDLEAD=" + objself.ID;
        }
        
        if(objself.MAP_FILTRAR_ID_ACTIVIDAD_SELECCIONADA > 0){
            filterQuery = filterQuery + " AND ca.ID="+objself.MAP_FILTRAR_ID_ACTIVIDAD_SELECCIONADA;
        }
        if(objself.MAP_FILTRAR_TIPO_ACTIVIDADES_COMBO > 0){
            filterQuery = filterQuery + " AND ca.IDTIPO_ACTIVIDAD="+objself.MAP_FILTRAR_TIPO_ACTIVIDADES_COMBO;
        }
    }
    else if (contentsName==='ActividadesClienteHijo') {
        filterQuery=filterQuery + "ca.ID="+objself.ID;
    }
    else if (contentsName==='Movimientos' || contentsName==="MovimientosContador") {
        filterQuery=filterQuery + "1=1";
        if(objself.MAP_IDTIPO_MOV>0){
            filterQuery = filterQuery + " AND m.IDTIPO_MOVIMIENTO="+objself.MAP_IDTIPO_MOV;
        }
        if(!isNullOrEmpty(objself.MAP_IDENTIFICADOR)){
            filterQuery = filterQuery + " AND m.IDENTIFICADOR like '%"+ objself.MAP_IDENTIFICADOR +"%'";
        }
        if(!isNullOrEmpty(safeToString(objself.MAP_FECHA_DESDE)) && isNullOrEmpty(safeToString(objself.MAP_FECHA_HASTA))){ 
            filterQuery = filterQuery + " AND DATE_FORMAT(m.FECHA_SOLICITUD, '%y-%m-%d') >= DATE_FORMAT('" + safeToDate(objself.MAP_FECHA_DESDE) + "', '%y-%m-%d')";
        } else if (isNullOrEmpty(safeToString(objself.MAP_FECHA_DESDE)) && !isNullOrEmpty(safeToString(objself.MAP_FECHA_HASTA))){ 
            filterQuery = filterQuery + " AND DATE_FORMAT(m.FECHA_SOLICITUD, '%y-%m-%d') <= DATE_FORMAT('" + safeToDate(objself.MAP_FECHA_HASTA) + "', '%y-%m-%d')";
        } else if (!isNullOrEmpty(safeToString(objself.MAP_FECHA_DESDE)) && !isNullOrEmpty(safeToString(objself.MAP_FECHA_HASTA))){ 
            filterQuery = filterQuery + " AND DATE_FORMAT(m.FECHA_SOLICITUD, '%y-%m-%d') BETWEEN DATE_FORMAT('" + safeToDate(objself.MAP_FECHA_DESDE) + "', '%y-%m-%d') AND DATE_FORMAT('" + safeToDate(objself.MAP_FECHA_HASTA) + "', '%y-%m-%d')";
        }
        if(objself.MAP_IMPORTE_MOV>0){
            filterQuery = filterQuery + " AND m.IMPORTE="+objself.MAP_IMPORTE_MOV;
        }
        if(!isNullOrEmpty(objself.MAP_CLIENTE_MOV)){
            filterQuery = filterQuery + " AND c.CORREO like '%"+ objself.MAP_CLIENTE_MOV +"%'";
        }
        if(!isNullOrEmpty(objself.MAP_IDENTIFICADOR_DEUDA_MOV)){
            filterQuery = filterQuery + " AND d.IDENTIFICADOR like '%"+ objself.MAP_IDENTIFICADOR_DEUDA_MOV +"%'";
        }
        if(objself.MAP_IDESTADO_MOV>0){
            filterQuery = filterQuery + " AND m.IDESTADO="+objself.MAP_IDESTADO_MOV;
        }
    }
    else if (contentsName==='MovimientosAportaciones' || contentsName==="MovimientosAportacionesContador") {
        if(objself.MAP_IDTIPO_MOV>0){
            filterQuery = filterQuery + "m.IDTIPO_MOVIMIENTO="+objself.MAP_IDTIPO_MOV;
        }else{
            filterQuery=filterQuery + "m.IDTIPO_MOVIMIENTO in (4,5,10,11,13)";
        }
        if(!isNullOrEmpty(objself.MAP_IDENTIFICADOR)){
            filterQuery = filterQuery + " AND m.IDENTIFICADOR like '%"+ objself.MAP_IDENTIFICADOR +"%'";
        }
        if(!isNullOrEmpty(safeToString(objself.MAP_FECHA_DESDE)) && isNullOrEmpty(safeToString(objself.MAP_FECHA_HASTA))){ 
            filterQuery = filterQuery + " AND DATE_FORMAT(m.FECHA_SOLICITUD, '%y-%m-%d') >= DATE_FORMAT('" + safeToDate(objself.MAP_FECHA_DESDE) + "', '%y-%m-%d')";
        } else if (isNullOrEmpty(safeToString(objself.MAP_FECHA_DESDE)) && !isNullOrEmpty(safeToString(objself.MAP_FECHA_HASTA))){ 
            filterQuery = filterQuery + " AND DATE_FORMAT(m.FECHA_SOLICITUD, '%y-%m-%d') <= DATE_FORMAT('" + safeToDate(objself.MAP_FECHA_HASTA) + "', '%y-%m-%d')";
        } else if (!isNullOrEmpty(safeToString(objself.MAP_FECHA_DESDE)) && !isNullOrEmpty(safeToString(objself.MAP_FECHA_HASTA))){ 
            filterQuery = filterQuery + " AND DATE_FORMAT(m.FECHA_SOLICITUD, '%y-%m-%d') BETWEEN DATE_FORMAT('" + safeToDate(objself.MAP_FECHA_DESDE) + "', '%y-%m-%d') AND DATE_FORMAT('" + safeToDate(objself.MAP_FECHA_HASTA) + "', '%y-%m-%d')";
        }
        if(objself.MAP_IMPORTE_MOV>0){
            filterQuery = filterQuery + " AND m.IMPORTE="+objself.MAP_IMPORTE_MOV;
        }
        if(!isNullOrEmpty(objself.MAP_CLIENTE_MOV)){
            filterQuery = filterQuery + " AND c.CORREO like '%"+ objself.MAP_CLIENTE_MOV +"%'";
        }
        if(!isNullOrEmpty(objself.MAP_IDENTIFICADOR_DEUDA_MOV)){
            filterQuery = filterQuery + " AND d.IDENTIFICADOR like '%"+ objself.MAP_IDENTIFICADOR_DEUDA_MOV +"%'";
        }
        if(objself.MAP_IDESTADO_MOV>0){
            filterQuery = filterQuery + " AND m.IDESTADO="+objself.MAP_IDESTADO_MOV;
        }
    }
    else if (contentsName==='MovimientosFinancieras' || contentsName==="MovimientosFinancierasContador") {
        if(objself.MAP_IDTIPO_MOV>0){
            filterQuery = filterQuery + "m.IDTIPO_MOVIMIENTO="+objself.MAP_IDTIPO_MOV;
        }else{
            filterQuery=filterQuery + "m.IDTIPO_MOVIMIENTO in (6,7,8)";
        }
        if(!isNullOrEmpty(objself.MAP_IDENTIFICADOR)){
            filterQuery = filterQuery + " AND m.IDENTIFICADOR like '%"+ objself.MAP_IDENTIFICADOR +"%'";
        }
        if(!isNullOrEmpty(safeToString(objself.MAP_FECHA_DESDE)) && isNullOrEmpty(safeToString(objself.MAP_FECHA_HASTA))){ 
            filterQuery = filterQuery + " AND DATE_FORMAT(m.FECHA_SOLICITUD, '%y-%m-%d') >= DATE_FORMAT('" + safeToDate(objself.MAP_FECHA_DESDE) + "', '%y-%m-%d')";
        } else if (isNullOrEmpty(safeToString(objself.MAP_FECHA_DESDE)) && !isNullOrEmpty(safeToString(objself.MAP_FECHA_HASTA))){ 
            filterQuery = filterQuery + " AND DATE_FORMAT(m.FECHA_SOLICITUD, '%y-%m-%d') <= DATE_FORMAT('" + safeToDate(objself.MAP_FECHA_HASTA) + "', '%y-%m-%d')";
        } else if (!isNullOrEmpty(safeToString(objself.MAP_FECHA_DESDE)) && !isNullOrEmpty(safeToString(objself.MAP_FECHA_HASTA))){ 
            filterQuery = filterQuery + " AND DATE_FORMAT(m.FECHA_SOLICITUD, '%y-%m-%d') BETWEEN DATE_FORMAT('" + safeToDate(objself.MAP_FECHA_DESDE) + "', '%y-%m-%d') AND DATE_FORMAT('" + safeToDate(objself.MAP_FECHA_HASTA) + "', '%y-%m-%d')";
        }
        if(objself.MAP_IMPORTE_MOV>0){
            filterQuery = filterQuery + " AND m.IMPORTE="+objself.MAP_IMPORTE_MOV;
        }
        if(!isNullOrEmpty(objself.MAP_CLIENTE_MOV)){
            filterQuery = filterQuery + " AND c.CORREO like '%"+ objself.MAP_CLIENTE_MOV +"%'";
        }
        if(!isNullOrEmpty(objself.MAP_IDENTIFICADOR_DEUDA_MOV)){
            filterQuery = filterQuery + " AND d.IDENTIFICADOR like '%"+ objself.MAP_IDENTIFICADOR_DEUDA_MOV +"%'";
        }
        if(objself.MAP_IDESTADO_MOV>0){
            filterQuery = filterQuery + " AND m.IDESTADO="+objself.MAP_IDESTADO_MOV;
        }
    }
    else if (contentsName==='MovimientosComision' || contentsName==="MovimientosComisionContador") {
        if(objself.MAP_IDTIPO_MOV>0){
            filterQuery = filterQuery + "m.IDTIPO_MOVIMIENTO="+objself.MAP_IDTIPO_MOV;
        }else{
            filterQuery=filterQuery + "m.IDTIPO_MOVIMIENTO in (1,2,3,9,14)";
        }
        if(!isNullOrEmpty(objself.MAP_IDENTIFICADOR)){
            filterQuery = filterQuery + " AND m.IDENTIFICADOR like '%"+ objself.MAP_IDENTIFICADOR +"%'";
        }
        if(!isNullOrEmpty(safeToString(objself.MAP_FECHA_DESDE)) && isNullOrEmpty(safeToString(objself.MAP_FECHA_HASTA))){ 
            filterQuery = filterQuery + " AND DATE_FORMAT(m.FECHA_SOLICITUD, '%y-%m-%d') >= DATE_FORMAT('" + safeToDate(objself.MAP_FECHA_DESDE) + "', '%y-%m-%d')";
        } else if (isNullOrEmpty(safeToString(objself.MAP_FECHA_DESDE)) && !isNullOrEmpty(safeToString(objself.MAP_FECHA_HASTA))){ 
            filterQuery = filterQuery + " AND DATE_FORMAT(m.FECHA_SOLICITUD, '%y-%m-%d') <= DATE_FORMAT('" + safeToDate(objself.MAP_FECHA_HASTA) + "', '%y-%m-%d')";
        } else if (!isNullOrEmpty(safeToString(objself.MAP_FECHA_DESDE)) && !isNullOrEmpty(safeToString(objself.MAP_FECHA_HASTA))){ 
            filterQuery = filterQuery + " AND DATE_FORMAT(m.FECHA_SOLICITUD, '%y-%m-%d') BETWEEN DATE_FORMAT('" + safeToDate(objself.MAP_FECHA_DESDE) + "', '%y-%m-%d') AND DATE_FORMAT('" + safeToDate(objself.MAP_FECHA_HASTA) + "', '%y-%m-%d')";
        }
        if(objself.MAP_IMPORTE_MOV>0){
            filterQuery = filterQuery + " AND m.IMPORTE="+objself.MAP_IMPORTE_MOV;
        }
        if(!isNullOrEmpty(objself.MAP_CLIENTE_MOV)){
            filterQuery = filterQuery + " AND c.CORREO like '%"+ objself.MAP_CLIENTE_MOV +"%'";
        }
        if(!isNullOrEmpty(objself.MAP_IDENTIFICADOR_DEUDA_MOV)){
            filterQuery = filterQuery + " AND d.IDENTIFICADOR like '%"+ objself.MAP_IDENTIFICADOR_DEUDA_MOV +"%'";
        }
        if(objself.MAP_IDESTADO_MOV>0){
            filterQuery = filterQuery + " AND m.IDESTADO="+objself.MAP_IDESTADO_MOV;
        }
        if(objself.MAP_SALDO_SUFICIENTE == 1){
            filterQuery = filterQuery + " AND m.IDESTADO IN (3,5,10) AND c.SALDO >= m.IMPORTE";
        }
        if(objself.MAP_UNICO == 1){
            filterQuery = filterQuery + " AND m.FECHA_SOLICITUD = (SELECT MIN(m2.FECHA_SOLICITUD) FROM gen_movimientos m2 LEFT JOIN gen_cliente c2 ON m2.IDLEAD = c2.ID WHERE m2.IDDEUDA = m.IDDEUDA AND m2.IDTIPO_MOVIMIENTO IN (1,2,3,9) AND m2.IDESTADO IN (3,5,10) AND c2.SALDO >= m2.IMPORTE)";
        }
    }
    else if (contentsName==='MovimientosCostas' || contentsName==="MovimientosCostasContador") {
        if(objself.MAP_IDTIPO_MOV>0){
            filterQuery = filterQuery + "m.IDTIPO_MOVIMIENTO="+objself.MAP_IDTIPO_MOV;
        }else{
            filterQuery=filterQuery + "m.IDTIPO_MOVIMIENTO in (12)";
        }
        if(!isNullOrEmpty(objself.MAP_IDENTIFICADOR)){
            filterQuery = filterQuery + " AND m.IDENTIFICADOR like '%"+ objself.MAP_IDENTIFICADOR +"%'";
        }
        if(!isNullOrEmpty(safeToString(objself.MAP_FECHA_DESDE)) && isNullOrEmpty(safeToString(objself.MAP_FECHA_HASTA))){ 
            filterQuery = filterQuery + " AND DATE_FORMAT(m.FECHA_SOLICITUD, '%y-%m-%d') >= DATE_FORMAT('" + safeToDate(objself.MAP_FECHA_DESDE) + "', '%y-%m-%d')";
        } else if (isNullOrEmpty(safeToString(objself.MAP_FECHA_DESDE)) && !isNullOrEmpty(safeToString(objself.MAP_FECHA_HASTA))){ 
            filterQuery = filterQuery + " AND DATE_FORMAT(m.FECHA_SOLICITUD, '%y-%m-%d') <= DATE_FORMAT('" + safeToDate(objself.MAP_FECHA_HASTA) + "', '%y-%m-%d')";
        } else if (!isNullOrEmpty(safeToString(objself.MAP_FECHA_DESDE)) && !isNullOrEmpty(safeToString(objself.MAP_FECHA_HASTA))){ 
            filterQuery = filterQuery + " AND DATE_FORMAT(m.FECHA_SOLICITUD, '%y-%m-%d') BETWEEN DATE_FORMAT('" + safeToDate(objself.MAP_FECHA_DESDE) + "', '%y-%m-%d') AND DATE_FORMAT('" + safeToDate(objself.MAP_FECHA_HASTA) + "', '%y-%m-%d')";
        }
        if(objself.MAP_IMPORTE_MOV>0){
            filterQuery = filterQuery + " AND m.IMPORTE="+objself.MAP_IMPORTE_MOV;
        }
        if(!isNullOrEmpty(objself.MAP_CLIENTE_MOV)){
            filterQuery = filterQuery + " AND c.CORREO like '%"+ objself.MAP_CLIENTE_MOV +"%'";
        }
        if(!isNullOrEmpty(objself.MAP_IDENTIFICADOR_DEUDA_MOV)){
            filterQuery = filterQuery + " AND d.IDENTIFICADOR like '%"+ objself.MAP_IDENTIFICADOR_DEUDA_MOV +"%'";
        }
        if(objself.MAP_IDESTADO_MOV>0){
            filterQuery = filterQuery + " AND m.IDESTADO="+objself.MAP_IDESTADO_MOV;
        }
        if(objself.MAP_SALDO_SUFICIENTE == 1){
            filterQuery = filterQuery + " AND m.IDESTADO IN (3,5,10) AND c.SALDO >= m.IMPORTE";
        }
        if(objself.MAP_UNICO == 1){
            filterQuery = filterQuery + " AND m.FECHA_SOLICITUD = (SELECT MIN(m2.FECHA_SOLICITUD) FROM gen_movimientos m2 LEFT JOIN gen_cliente c2 ON m2.IDLEAD = c2.ID WHERE m2.IDDEUDA = m.IDDEUDA AND m2.IDTIPO_MOVIMIENTO IN (1,2,3,9) AND m2.IDESTADO IN (3,5,10) AND c2.SALDO >= m2.IMPORTE)";
        }
    }
    else if (contentsName==='MovimientosFacturacion' || contentsName==="MovimientosFacturacionContador") {
        if(objself.MAP_IDTIPO_MOV>0){
            filterQuery = filterQuery + "m.IDTIPO_MOVIMIENTO=" + objself.MAP_IDTIPO_MOV + " AND m.IDESTADO = 7";
        }else{
            filterQuery=filterQuery + "m.IDTIPO_MOVIMIENTO in (1,2,3,9) AND m.IDESTADO = 7";
        }
        if(!isNullOrEmpty(objself.MAP_IDENTIFICADOR)){
            filterQuery = filterQuery + " AND m.IDENTIFICADOR like '%"+ objself.MAP_IDENTIFICADOR +"%'";
        }
        if(!isNullOrEmpty(safeToString(objself.MAP_FECHA_DESDE)) && isNullOrEmpty(safeToString(objself.MAP_FECHA_HASTA))){ 
            filterQuery = filterQuery + " AND DATE_FORMAT(m.FECHA_SOLICITUD, '%y-%m-%d') >= DATE_FORMAT('" + safeToDate(objself.MAP_FECHA_DESDE) + "', '%y-%m-%d')";
        } else if (isNullOrEmpty(safeToString(objself.MAP_FECHA_DESDE)) && !isNullOrEmpty(safeToString(objself.MAP_FECHA_HASTA))){ 
            filterQuery = filterQuery + " AND DATE_FORMAT(m.FECHA_SOLICITUD, '%y-%m-%d') <= DATE_FORMAT('" + safeToDate(objself.MAP_FECHA_HASTA) + "', '%y-%m-%d')";
        } else if (!isNullOrEmpty(safeToString(objself.MAP_FECHA_DESDE)) && !isNullOrEmpty(safeToString(objself.MAP_FECHA_HASTA))){ 
            filterQuery = filterQuery + " AND DATE_FORMAT(m.FECHA_SOLICITUD, '%y-%m-%d') BETWEEN DATE_FORMAT('" + safeToDate(objself.MAP_FECHA_DESDE) + "', '%y-%m-%d') AND DATE_FORMAT('" + safeToDate(objself.MAP_FECHA_HASTA) + "', '%y-%m-%d')";
        }
        if(objself.MAP_IMPORTE_MOV>0){
            filterQuery = filterQuery + " AND m.IMPORTE="+objself.MAP_IMPORTE_MOV;
        }
        if(!isNullOrEmpty(objself.MAP_CLIENTE_MOV)){
            filterQuery = filterQuery + " AND c.CORREO like '%"+ objself.MAP_CLIENTE_MOV +"%'";
        }
        if(!isNullOrEmpty(objself.MAP_IDENTIFICADOR_DEUDA_MOV)){
            filterQuery = filterQuery + " AND d.IDENTIFICADOR like '%"+ objself.MAP_IDENTIFICADOR_DEUDA_MOV +"%'";
        }
        if(objself.MAP_PDTE_FACTURAR == 1){
            filterQuery = filterQuery + " AND ifnull(m.FACTURADO,0) = 0";
        }
    }
    else if (contentsName==='FacturasContent' || contentsName==="FacturasContentContador") {
        filterQuery=filterQuery + "1=1";
        if(!isNullOrEmpty(objself.MAP_CLIENTE_MOV)){
            filterQuery = filterQuery + " AND c.CORREO like '%"+ objself.MAP_CLIENTE_MOV +"%'";
        }
    }
    else if (contentsName==='MovimientosCliente' || contentsName==="MovimientosClienteContador") {
        filterQuery=filterQuery + "m.IDLEAD="+objself.ID+" and m.IDESTADO IN (1,4,6,7,9)";
    }
    else if (contentsName==='MovimientosClienteMes') {
        filterQuery=filterQuery + "m.IDLEAD="+objself.ID+" and m.IDESTADO IN (1,4,6,7)";
    }
    else if (contentsName === 'MovimientosPlanDePagos' || contentsName === 'MovimientosPlanDePagosContador') {
        filterQuery = filterQuery + "IFNULL(p.BAJA,0)=0";
        if (!isNullOrEmpty(objself.MAP_CLIENTE_MOV)) {
            filterQuery = filterQuery + " AND c.CORREO like '%" + objself.MAP_CLIENTE_MOV + "%'";
        }
        if (!isNullOrEmpty(objself.MAP_IDENTIFICADOR_DEUDA_MOV)) {
            filterQuery = filterQuery + " AND d.IDENTIFICADOR like '%" + objself.MAP_IDENTIFICADOR_DEUDA_MOV + "%'";
        }
        if (!isNullOrEmpty(safeToString(objself.MAP_FECHA_DESDE)) && isNullOrEmpty(safeToString(objself.MAP_FECHA_HASTA))) {
            filterQuery = filterQuery + " AND DATE_FORMAT(p.FECHA_PREVISTA_PAGO, '%y-%m-%d') >= DATE_FORMAT('" + safeToDate(objself.MAP_FECHA_DESDE) + "', '%y-%m-%d')";
        } else if (isNullOrEmpty(safeToString(objself.MAP_FECHA_DESDE)) && !isNullOrEmpty(safeToString(objself.MAP_FECHA_HASTA))) {
            filterQuery = filterQuery + " AND DATE_FORMAT(p.FECHA_PREVISTA_PAGO, '%y-%m-%d') <= DATE_FORMAT('" + safeToDate(objself.MAP_FECHA_HASTA) + "', '%y-%m-%d')";
        } else if (!isNullOrEmpty(safeToString(objself.MAP_FECHA_DESDE)) && !isNullOrEmpty(safeToString(objself.MAP_FECHA_HASTA))) {
            filterQuery = filterQuery + " AND DATE_FORMAT(p.FECHA_PREVISTA_PAGO, '%y-%m-%d') BETWEEN DATE_FORMAT('" + safeToDate(objself.MAP_FECHA_DESDE) + "', '%y-%m-%d') AND DATE_FORMAT('" + safeToDate(objself.MAP_FECHA_HASTA) + "', '%y-%m-%d')";
        }
        if (safeToInt(objself.MAP_IDESTADO_PAB) > 0) {
            filterQuery = filterQuery + " AND mp.IDESTADO=" + objself.MAP_IDESTADO_PAB;
        }
        if (safeToInt(objself.MAP_IDESTADO_CE) > 0) {
            filterQuery = filterQuery + " AND mc.IDESTADO=" + objself.MAP_IDESTADO_CE;
        }
        if (safeToInt(objself.MAP_PESTANYA) == 2) {
            filterQuery = filterQuery + " AND IFNULL(mp.IDESTADO,0) NOT IN (4)";
        } else if (safeToInt(objself.MAP_PESTANYA) == 3) {
            filterQuery = filterQuery + " AND mp.IDESTADO=4 AND mc.IDESTADO=7";
        }
    }
    else if (contentsName==='Carteras'){  
        filterQuery=filterQuery + "u.USERTYPE IN (6,7,8)";
        if(objself.MAP_IDCOLABORADOR>0){
            filterQuery = filterQuery + " AND u.ID="+objself.MAP_IDCOLABORADOR;
        }
        // if(!isNullOrEmpty(objself.MAP_DPTO)){
        //     filterQuery = filterQuery + " AND u.NOMBRE like '%"+objself.MAP_DPTO+"%'";
        // }
        if(objself.MAP_CLIENTE>0){
            filterQuery = filterQuery + " AND COUNT(c.ID)="+objself.MAP_CLIENTE;
        }
        if(objself.MAP_DEUDA>0){
            filterQuery = filterQuery + " AND COUNT(dc.ID)="+objself.MAP_DEUDA;
        }
        // if(objself.MAP_DEUDA_TOTAL>0){
        //     filterQuery = filterQuery + " AND COUNT(dc.ID)="+objself.MAP_DEUDA_TOTAL;
        // }
        // if(objself.MAP_CLIENTE3>0){
        //     filterQuery = filterQuery + " AND COUNT(dc.ID)="+objself.MAP_CLIENTE3;
        // }
        // if(objself.MAP_CLIENTE36>0){
        //     filterQuery = filterQuery + " AND COUNT(dc.ID)="+objself.MAP_CLIENTE36;
        // }
        // if(objself.MAP_CLIENTE6>0){
        //     filterQuery = filterQuery + " AND COUNT(dc.ID)="+objself.MAP_CLIENTE6;
        // }
        // if(objself.MAP_POTENCIAL>0){
        //     filterQuery = filterQuery + " AND COUNT(dc.ID)="+objself.MAP_POTENCIAL;
        // }
    }
    else if (contentsName==='UsuariosContent') {
        if(user.USERTYPE==5 || user.USERTYPE==50){
            filterQuery=filterQuery + "ifnull(u.BAJA,0)=0 AND u.USERTYPE IN (1,2,3,4,5)";
        }else{
            filterQuery=filterQuery + "ifnull(u.BAJA,0)=0 AND u.USERTYPE IN (1,2)";
        }
        // if(objself.MAP_BAJA=="Alta"){
        //     filterQuery = filterQuery + "u.BAJA=0";
        // } else {
        //     filterQuery = filterQuery + "u.BAJA=1";
        // }
        if(!isNullOrEmpty(objself.MAP_NOMBRE)){
            filterQuery = filterQuery + " AND u.NOMBRE like '%"+objself.MAP_NOMBRE+"%'";
        }
        if(!isNullOrEmpty(objself.MAP_APELLIDO)){
            filterQuery = filterQuery + " AND u.APELLIDOS like '%"+objself.MAP_APELLIDO+"%'";
        }
        if(!isNullOrEmpty(objself.MAP_USUARIO)){
            filterQuery = filterQuery + " AND u.USUARIO like '%"+objself.MAP_USUARIO+"%'";
        }
        if(!isNullOrEmpty(objself.MAP_CORREO)){
            filterQuery = filterQuery + " AND u.CORREO like '%"+objself.MAP_CORREO+"%'";
        }
        if(!isNullOrEmpty(objself.MAP_LIDER)){
            filterQuery = filterQuery + " AND ul.CORREO like '%"+objself.MAP_LIDER+"%'";
        }
        if(objself.MAP_IDTIPO>0){
            filterQuery = filterQuery + " AND u.USERTYPE="+objself.MAP_IDTIPO;
        }
    }
    else if (contentsName==='UsuariosIntegracionesContent') {
        filterQuery=filterQuery + "u.USERTYPE=98";
        
        // if(objself.MAP_BAJA=="Alta"){
        //     filterQuery = filterQuery + "u.BAJA=0";
        // } else {
        //     filterQuery = filterQuery + "u.BAJA=1";
        // }
        if(!isNullOrEmpty(objself.MAP_USUARIO)){
            filterQuery = filterQuery + " AND u.USUARIO like '%"+objself.MAP_USUARIO+"%'";
        }
        if(!isNullOrEmpty(objself.MAP_CORREO)){
            filterQuery = filterQuery + " AND u.CORREO like '%"+objself.MAP_CORREO+"%'";
        }
    }
    else if (contentsName==='DespachosContent') {
        filterQuery=filterQuery + "d.LSO=1";
        if(!isNullOrEmpty(objself.MAP_NOMBRE)){
            filterQuery = filterQuery + " AND d.NOMBRE like '%"+objself.MAP_NOMBRE+"%'";
        }
    }
    else if (contentsName==='DespachosContentLSO') {
        filterQuery=filterQuery + "d.LSO=2";
        if(!isNullOrEmpty(objself.MAP_NOMBRE)){
            filterQuery = filterQuery + " AND d.NOMBRE like '%"+objself.MAP_NOMBRE+"%'";
        }
    }
    else if (contentsName==='UsuariosClienteContent'){  
        filterQuery=filterQuery + "ifnull(u.BAJA,0)=0 AND u.USERTYPE IN (6,7,8,9,10,11,12)";
        // if(objself.MAP_BAJA=="Alta"){
        //     filterQuery = filterQuery + "u.BAJA=0";
        // } else {
        //     filterQuery = filterQuery + "u.BAJA=1";
        // }
        if(!isNullOrEmpty(objself.MAP_COLABORADOR)){
            filterQuery = filterQuery + " AND u.CORREO like '%"+objself.MAP_COLABORADOR+"%'";
        }
   //      if(!isNullOrEmpty(objself.MAP_DEPARTAMENTO)){
   //          filterQuery = filterQuery + " AND u.CORREO like '%"+objself.MAP_DEPARTAMENTO+"%'";
   //      }
        if(!isNullOrEmpty(objself.MAP_LIDER_BUSCAR)){
            filterQuery = filterQuery + " AND ul.CORREO like '%"+objself.MAP_LIDER_BUSCAR+"%'";
        }
        // if(objself.MAP_MAXCLIENTES>0){
        //     filterQuery = filterQuery + " AND u.MAXCLIENTES="+objself.MAP_MAXCLIENTES;
        // }
        // if(objself.MAP_MAXDEUDAS>0){
        //     filterQuery = filterQuery + " AND u.MAXDEUDAS="+objself.MAP_MAXDEUDAS;
        // }
        // if(objself.MAP_MAXDEUDATOTAL>0){
        //     filterQuery = filterQuery + " AND u.MAXDEUDATOTAL="+objself.MAP_MAXDEUDATOTAL;
        // }
        // if(objself.MAP_MAXCLIENTES3>0){
        //     filterQuery = filterQuery + " AND u.MAXCLIENTES3="+objself.MAP_MAXCLIENTES3;
        // }
        // if(objself.MAP_MAXCLIENTES36>0){
        //     filterQuery = filterQuery + " AND u.MAXCLIENTES36="+objself.MAP_MAXCLIENTES36;
        // }
        // if(objself.MAP_MAXCLIENTES6>0){
        //     filterQuery = filterQuery + " AND u.MAXCLIENTES6="+objself.MAP_MAXCLIENTES6;
        // }
        if(!isNullOrEmpty(objself.MAP_ESTADO_BUSCAR)){
            filterQuery = filterQuery + " AND ue.DESCRIPCION like '%"+objself.MAP_ESTADO_BUSCAR+"%'";
        }
        if(objself.MAP_IDTIPO>0){
            filterQuery = filterQuery + " AND u.USERTYPE="+objself.MAP_IDTIPO;
        }
    }
    else if (contentsName==='TipoUsuarios') {
        if(objself.MAP_BAJA=="Alta"){
            filterQuery = filterQuery + "BAJA=0";
        } else {
            filterQuery = filterQuery + "BAJA=1";
        }
        if(objself.MAP_IDTIPO>0){
            filterQuery = filterQuery + " AND DESCRIPCION='"+objself.MAP_TIPO+"'";
        }
    }
    else if (contentsName==='Estados') {
        if(objself.MAP_BAJA=="Alta"){
            filterQuery = filterQuery + "BAJA=0";
        } else {
            filterQuery = filterQuery + "BAJA=1";
        }
        if(objself.MAP_CODIGO>0){
            filterQuery = filterQuery + " AND CODIGO="+objself.MAP_CODIGO;
        }
        if(!isNullOrEmpty(objself.MAP_NOMBRE)){
            filterQuery = filterQuery + " AND NOMBRE like '%"+objself.MAP_NOMBRE+"%'";
        }
        if(objself.MAP_IDTIPO>0){
            filterQuery = filterQuery + " AND TIPO="+objself.MAP_IDTIPO;
        }
    }
    else if (contentsName==='EstadosCliente') {
        if(objself.MAP_BAJA=="Alta"){
            filterQuery = filterQuery + "BAJA=0";
        } else {
            filterQuery = filterQuery + "BAJA=1";
        }
        if(objself.MAP_CODIGO>0){
            filterQuery = filterQuery + " AND CODIGO="+objself.MAP_CODIGO;
        }
        if(!isNullOrEmpty(objself.MAP_NOMBRE)){
            filterQuery = filterQuery + " AND NOMBRE like '%"+objself.MAP_NOMBRE+"%'";
        }
        // if(objself.MAP_IDTIPO>0){
        //     filterQuery = filterQuery + " AND TIPO="+objself.MAP_IDTIPO;
        // }
    }
    else if (contentsName==='TipoEntidades') {
        if(objself.MAP_BAJA=="Alta"){
            filterQuery = filterQuery + "BAJA=0";
        } else {
            filterQuery = filterQuery + "BAJA=1";
        }
        if(objself.MAP_CODIGO>0){
            filterQuery = filterQuery + " AND CODIGO="+objself.MAP_CODIGO;
        }
        if(!isNullOrEmpty(objself.MAP_NOMBRE)){
            filterQuery = filterQuery + " AND NOMBRE like '%"+objself.MAP_NOMBRE+"%'";
        }
        if(objself.MAP_IDRIESGO!==0){
            filterQuery = filterQuery + " AND RIESGO_DEMANDA='"+objself.MAP_RIESGO+"'";
        }
    }
    else if (contentsName === 'Entidades' || contentsName === 'EntidadesContador') {
        if(objself.MAP_BAJA !== "Alta"){
            filterQuery = filterQuery + "e.BAJA=1";
        } else {
            filterQuery = filterQuery + "e.BAJA=0";
        }
        if(!isNullOrEmpty(objself.MAP_MOVIL)){
            filterQuery = filterQuery + " AND (e.MOVIL like '%"+objself.MAP_MOVIL+"%' OR e.MOVIL2 like '%"+objself.MAP_MOVIL+"%' OR e.MOVIL3 like '%"+objself.MAP_MOVIL+"%' OR e.MOVIL4 like '%"+objself.MAP_MOVIL+"%' OR e.MOVIL5 like '%"+objself.MAP_MOVIL+"%')";
        }
        if(objself.MAP_TIPOENTIDAD_COD>0){
            filterQuery = filterQuery + " AND t.CODIGO="+objself.MAP_TIPOENTIDAD_COD;
        }
        if(!isNullOrEmpty(objself.MAP_NOMBRE)){
            filterQuery = filterQuery + " AND e.NOMBRE like '%"+objself.MAP_NOMBRE+"%'";
        }
        if(!isNullOrEmpty(objself.MAP_IBAN)){
            filterQuery = filterQuery + " AND e.IBAN like '%"+objself.MAP_IBAN+"%'";
        }
    }
    else if (contentsName==='EntidadesCorreos') {
        filterQuery = filterQuery + "ec.IDENTIDAD = " + objself.ID;
    }
    else if (contentsName==='Producto') {
        if(objself.MAP_BAJA=="Alta"){
            filterQuery = filterQuery + "BAJA=0";
        } else {
            filterQuery = filterQuery + "BAJA=1";
        }
        if(!isNullOrEmpty(objself.MAP_NOMBRE)){
            filterQuery = filterQuery + " AND NOMBRE like '%"+objself.MAP_NOMBRE+"%'";
        }
        if(!isNullOrEmpty(objself.MAP_ABREVIATURA)){
            filterQuery = filterQuery + " AND ABREVIATURA like '%"+objself.MAP_ABREVIATURA+"%'";
        }
    }
    else if (contentsName==='RangosCuota') {
        if(objself.MAP_BAJA=="Alta"){
            filterQuery = filterQuery + "BAJA=0";
        } else {
            filterQuery = filterQuery + "BAJA=1";
        }
        if(!isNullOrEmpty(objself.MAP_VALOR)){
            filterQuery = filterQuery + " AND VALOR like '%"+objself.MAP_VALOR+"%'";
        }
    }
    else if (contentsName==='Comisiones') {
        if(objself.MAP_BAJA=="Alta"){
            filterQuery = filterQuery + "c.BAJA=0";
        } else {
            filterQuery = filterQuery + "c.BAJA=1";
        }
        if(!isNullOrEmpty(objself.MAP_NOMBRE)){
            filterQuery = filterQuery + " AND c.CONCEPTO like '%"+objself.MAP_NOMBRE+"%'";
        }
        if(objself.MAP_PORCENTAJE>0){
            filterQuery = filterQuery + " AND c.PORCENTAJE like '%"+objself.MAP_PORCENTAJE+"%'";
        }
        if(objself.MAP_DURACION>0){
            filterQuery = filterQuery + " AND c.DURACION like '%"+objself.MAP_DURACION+"%'";
        }
        if(objself.MAP_GRUPO_PAQUETE_COMISION>0){
            filterQuery = filterQuery + " AND c.GRUPO_PAQUETE_COMISION ="+objself.MAP_GRUPO_PAQUETE_COMISION;
        }
        if(objself.MAP_TIPO>0){
            filterQuery = filterQuery + " AND c.TIPO ="+objself.MAP_TIPO;
        }
    }
    else if (contentsName==='OrigenLeadContent') {
        // if(objself.MAP_BAJA=="Alta"){
        //     filterQuery = filterQuery + "BAJA=0";
        // } else {
        //     filterQuery = filterQuery + "BAJA=1";
        // }
        filterQuery = filterQuery + "1=1";
        if(objself.MAP_CODIGO>0){
            filterQuery = filterQuery + " AND CODIGO="+objself.MAP_CODIGO;
        }
        if(!isNullOrEmpty(objself.MAP_NOMBRE)){
            filterQuery = filterQuery + " AND ORIGEN like '%"+objself.MAP_NOMBRE+"%'";
        }
    }
    else if (contentsName==='MatrizDescuentoSimple') {
        filterQuery = filterQuery + "1=1";
        if(objself.MAP_TIPOENTIDAD_COD>0){
            filterQuery = filterQuery + " AND m.TIPOENTIDAD_COD="+objself.MAP_TIPOENTIDAD_COD;
        }
        if(objself.MAP_MES>0){
            filterQuery = filterQuery + " AND m.MES="+objself.MAP_MES;
        }
        if(objself.MAP_VALOR>0){
            filterQuery = filterQuery + " AND m.VALOR LIKE "+objself.MAP_VALOR;
        }
    }
    else if (contentsName==='MatrizIntereses') {
        filterQuery = filterQuery + "1=1";
        if(objself.MAP_TIPOENTIDAD_COD>0){
            filterQuery = filterQuery + " AND m.TIPOENTIDAD_COD="+objself.MAP_TIPOENTIDAD_COD;
        }
        if(objself.MAP_MES>0){
            filterQuery = filterQuery + " AND m.MES="+objself.MAP_MES;
        }
        if(objself.MAP_VALOR>0){
            filterQuery = filterQuery + " AND m.VALOR LIKE "+objself.MAP_VALOR;
        }
    }
    else if (contentsName==='MatrizDescuentoAumentado') {
        filterQuery = filterQuery + "1=1";
        if(objself.MAP_TIPOENTIDAD_COD>0){
            filterQuery = filterQuery + " AND m.TIPOENTIDAD_COD="+objself.MAP_TIPOENTIDAD_COD;
        }
        if(objself.MAP_MES>0){
            filterQuery = filterQuery + " AND m.MES="+objself.MAP_MES;
        }
        if(objself.MAP_VALOR>0){
            filterQuery = filterQuery + " AND m.VALOR LIKE "+objself.MAP_VALOR;
        }
    }
   else if (contentsName === 'MensajeriaChatListadoNotificacion') {
        filterQuery = filterQuery + "c.IDESTADO=10";
        
        if(user.USERTYPE==1){
            filterQuery=filterQuery + " AND c.IDASESOR="+user.ID;
        }
        // pitcher
        else if(user.USERTYPE==2){
            filterQuery=filterQuery + " AND c.IDPITCHER="+user.ID;
        }
        // líder
        else if(user.USERTYPE==3){
            filterQuery=filterQuery + " AND c.IDLIDER="+user.ID;
        }
        // ESC
        else if(user.USERTYPE==6){
            filterQuery=filterQuery + " AND c.IDESC="+user.ID;
        }
        // NT
        else if(user.USERTYPE==7){
            filterQuery=filterQuery + " AND c.IDNT="+user.ID;
        }
        // NR
        else if(user.USERTYPE==8){
            filterQuery=filterQuery + " AND c.IDNR="+user.ID;
        // líder operaciones
        }else if (user.USERTYPE==9){
            filterQuery=filterQuery + " AND (c.IDESC="+user.ID+" OR c.IDNT="+user.ID+" OR c.IDNR="+user.ID+")";
        }
        
    }
    else if (contentsName==='MensajeriaChatListado' || contentsName==="MensajeriaChatListadoContador") {
        
        filterQuery = filterQuery + "c.IDESTADO=10";
        
        if(user.USERTYPE==1){
            filterQuery=filterQuery + " AND c.IDASESOR="+user.ID;
        }
        // pitcher
        else if(user.USERTYPE==2){
            filterQuery=filterQuery + " AND c.IDPITCHER="+user.ID;
        }
        // líder
        else if(user.USERTYPE==3){
            filterQuery=filterQuery + " AND c.IDLIDER="+user.ID;
        }
        // ESC
        else if(user.USERTYPE==6){
            filterQuery=filterQuery + " AND c.IDESC="+user.ID;
        }
        // NT
        else if(user.USERTYPE==7){
            filterQuery=filterQuery + " AND c.IDNT="+user.ID;
        }
        // NR
        else if(user.USERTYPE==8){
            filterQuery=filterQuery + " AND c.IDNR="+user.ID;
        // líder operaciones
        }else if (user.USERTYPE==9){
            filterQuery=filterQuery + " AND (c.IDESC="+user.ID+" OR c.IDNT="+user.ID+" OR c.IDNR="+user.ID+")";
        }
        // gerente, director
        // else{
        //     filterQuery=filterQuery + "1=1";
        // }
        if(!isNullOrEmpty(objself.MAP_NOMBRE)){
            filterQuery = filterQuery + " AND c.NOMBRE like '%"+ objself.MAP_NOMBRE +"%'";
        }
        if(!isNullOrEmpty(objself.MAP_APELLIDOS)){
            filterQuery = filterQuery + " AND c.APELLIDOS like '%"+ objself.MAP_APELLIDOS +"%'";
        }
        if(!isNullOrEmpty(objself.MAP_MOVIL)){
            filterQuery = filterQuery + " AND (c.MOVIL like REPLACE('%"+ objself.MAP_MOVIL +"%',' ','') OR c.MOVIL2 like REPLACE('%"+ objself.MAP_MOVIL +"%',' ','') OR c.MOVIL3 like REPLACE('%"+ objself.MAP_MOVIL +"%',' ',''))";
        }
        if(!isNullOrEmpty(objself.MAP_CORREO_FILTRO)){
            filterQuery = filterQuery + " AND c.CORREO like '%"+ objself.MAP_CORREO_FILTRO +"%'";
        }
        
        // Último mensaje es del asesor desde CRM
        if (objself.MAP_ID_FILTRO_TIPO_CONV == 1) {
            filterQuery = filterQuery + " AND (SELECT ORIGIN FROM gen_mensajes WHERE IDLEAD = c.ID ORDER BY FECHA DESC LIMIT 1) = 'humano'" +
                " AND (SELECT ENVIADO_ALIVIA FROM gen_mensajes WHERE IDLEAD = c.ID ORDER BY FECHA DESC LIMIT 1) = 1" +
                " AND (SELECT IFNULL(IDSUPERVISOR,0) FROM gen_mensajes WHERE IDLEAD = c.ID ORDER BY FECHA DESC LIMIT 1) = 0";
        }
        // Último mensaje es del bot real
        if (objself.MAP_ID_FILTRO_TIPO_CONV == 2) {
            filterQuery = filterQuery + " AND (SELECT ORIGIN FROM gen_mensajes WHERE IDLEAD = c.ID ORDER BY FECHA DESC LIMIT 1) = 'bot' AND (SELECT IFNULL(IDSUPERVISOR,0) FROM gen_mensajes WHERE IDLEAD = c.ID ORDER BY FECHA DESC LIMIT 1) != 0";
        }
        if (objself.MAP_ID_FILTRO_NOTIF == 1) {
            filterQuery = filterQuery + " AND EXISTS (SELECT 1 FROM gen_mensajes mn WHERE mn.IDLEAD = c.ID AND mn.ENVIADO_ALIVIA = 0 AND mn.ORIGIN = 'humano' AND (mn.SESSIONID IS NULL OR mn.SESSIONID = '') AND ifnull(mn.NOTIFICADO,0) = 0)";
        }
        if (objself.MAP_ID_FILTRO_NOTIF == 2) {
            filterQuery = filterQuery + " AND NOT EXISTS (SELECT 1 FROM gen_mensajes mn WHERE mn.IDLEAD = c.ID AND mn.ENVIADO_ALIVIA = 0 AND mn.ORIGIN = 'humano' AND (mn.SESSIONID IS NULL OR mn.SESSIONID = '') AND ifnull(mn.NOTIFICADO,0) = 0)";
        }
        if (objself.MAP_ID_FILTRO_ASESOR > 0) {
            filterQuery = filterQuery + " AND c.IDASESOR=" + objself.MAP_ID_FILTRO_ASESOR;
        }
        if (objself.MAP_ID_FILTRO_NT > 0) {
            filterQuery = filterQuery + " AND c.IDNT=" + objself.MAP_ID_FILTRO_NT;
        }
        if (objself.MAP_ID_FILTRO_NR > 0) {
            filterQuery = filterQuery + " AND c.IDNR=" + objself.MAP_ID_FILTRO_NR;
        }
        
    }
    else if (contentsName==='MensajeriaChatFecha' || contentsName==="MensajeriaChatFechaContador") {
        
        filterQuery = filterQuery + "c.IDESTADO=10";
        
        if(user.USERTYPE==1){
            filterQuery=filterQuery + " AND c.IDASESOR="+user.ID;
        }
        // pitcher
        else if(user.USERTYPE==2){
            filterQuery=filterQuery + " AND c.IDPITCHER="+user.ID;
        }
        // líder
        else if(user.USERTYPE==3){
            filterQuery=filterQuery + " AND c.IDLIDER="+user.ID;
        }
        // ESC
        else if(user.USERTYPE==6){
            filterQuery=filterQuery + " AND c.IDESC="+user.ID;
        }
        // NT
        else if(user.USERTYPE==7){
            filterQuery=filterQuery + " AND c.IDNT="+user.ID;
        }
        // NR
        else if(user.USERTYPE==8){
            filterQuery=filterQuery + " AND c.IDNR="+user.ID;
        // líder operaciones
        }else if (user.USERTYPE==9){
            filterQuery=filterQuery + " AND (c.IDESC="+user.ID+" OR c.IDNT="+user.ID+" OR c.IDNR="+user.ID+")";
        }
        // gerente, director
        // else{
        //     filterQuery=filterQuery + "1=1";
        // }
        if(!isNullOrEmpty(objself.MAP_NOMBRE)){
            filterQuery = filterQuery + " AND c.NOMBRE like '%"+ objself.MAP_NOMBRE +"%'";
        }
        if(!isNullOrEmpty(objself.MAP_APELLIDOS)){
            filterQuery = filterQuery + " AND c.APELLIDOS like '%"+ objself.MAP_APELLIDOS +"%'";
        }
        if(!isNullOrEmpty(objself.MAP_MOVIL)){
            filterQuery = filterQuery + " AND (c.MOVIL like REPLACE('%"+ objself.MAP_MOVIL +"%',' ','') OR c.MOVIL2 like REPLACE('%"+ objself.MAP_MOVIL +"%',' ','') OR c.MOVIL3 like REPLACE('%"+ objself.MAP_MOVIL +"%',' ',''))";
        }
        if(!isNullOrEmpty(objself.MAP_CORREO_FILTRO)){
            filterQuery = filterQuery + " AND c.CORREO like '%"+ objself.MAP_CORREO_FILTRO +"%'";
        }
    }
    // else if (contentsName==='Mensajeria') {
    //     if(objself.ID > 0){
    //         filterQuery = filterQuery + "IDLEAD="+objself.ID;
    //     }
    //     else if(objself.MAP_IDLEAD_SEL > 0){
    //         filterQuery = filterQuery + "IDLEAD="+objself.MAP_IDLEAD_SEL;
    //     }
    // }
    else if (contentsName==='Mensajeria') {
        if(objself.MAP_IDLEAD_SEL > 0){
            filterQuery = filterQuery + "IDLEAD="+objself.MAP_IDLEAD_SEL;
        }
        else if(objself.ID > 0){
            filterQuery = filterQuery + "IDLEAD="+objself.ID;
        }
    }
    else if (contentsName==='ActividadesClienteDocumentos') {
        filterQuery = filterQuery + "doc.IDACTIVIDADCLIENTE=" + objself.ID + " AND doc.BAJA=0";
    }
    else if (contentsName==='ActividadesClienteHijoLlamadaBienvenida') {
        if(objself.MAP_IDACTIVIDADCLIENTE_SEL > 0){
            filterQuery = filterQuery + "ca.ID="+objself.MAP_IDACTIVIDADCLIENTE_SEL;
        }
    }
    else if (contentsName==='ActividadesClienteHijoAddendum') {
        if(objself.MAP_IDACTIVIDADCLIENTE_SEL > 0){
            filterQuery = filterQuery + "ca.ID="+objself.MAP_IDACTIVIDADCLIENTE_SEL;
        }
    }
    else if (contentsName==='ActividadesClienteHijoCartaRepresentacion') {
        if(objself.MAP_IDACTIVIDADCLIENTE_SEL > 0){
            filterQuery = filterQuery + "ca.ID="+objself.MAP_IDACTIVIDADCLIENTE_SEL;
        }
    }
    else if (contentsName==='ActividadesClienteHijoResolucionPorIncumplimiento') {
        if(objself.MAP_IDACTIVIDADCLIENTE_SEL > 0){
            filterQuery = filterQuery + "ca.ID="+objself.MAP_IDACTIVIDADCLIENTE_SEL;
        }
    }
    else if (contentsName==='ActividadesClienteHijoCertificadoFinPrograma') {
        if(objself.MAP_IDACTIVIDADCLIENTE_SEL > 0){
            filterQuery = filterQuery + "ca.ID="+objself.MAP_IDACTIVIDADCLIENTE_SEL;
        }
    }
    else if (contentsName==='ActividadesClienteHijoSolicitudDevolucion') {
        if(objself.MAP_IDACTIVIDADCLIENTE_SEL > 0){
            filterQuery = filterQuery + "ca.ID="+objself.MAP_IDACTIVIDADCLIENTE_SEL;
        }
    }
    else if (contentsName==='ActividadesClienteHijoSolicitudBaja') {
        if(objself.MAP_IDACTIVIDADCLIENTE_SEL > 0){
            filterQuery = filterQuery + "ca.ID="+objself.MAP_IDACTIVIDADCLIENTE_SEL;
        }
    }
    else if (contentsName==='ActividadesClienteHijoSolicitudBajaPre14') {
        if(objself.MAP_IDACTIVIDADCLIENTE_SEL > 0){
            filterQuery = filterQuery + "ca.ID="+objself.MAP_IDACTIVIDADCLIENTE_SEL;
        }
    }
    else if (contentsName==='ActividadesClienteHijoSolicitudPausa') {
        if(objself.MAP_IDACTIVIDADCLIENTE_SEL > 0){
            filterQuery = filterQuery + "ca.ID="+objself.MAP_IDACTIVIDADCLIENTE_SEL;
        }
    }
    else if (contentsName==='ActividadesClienteHijoConversacionCliente') {
        if(objself.MAP_IDACTIVIDADCLIENTE_SEL > 0){
            filterQuery = filterQuery + "ca.ID="+objself.MAP_IDACTIVIDADCLIENTE_SEL;
        }
    }
    else if (contentsName==='ActividadesClienteHijoComisionMensual') {
        if(objself.MAP_IDACTIVIDADCLIENTE_SEL > 0){
            filterQuery = filterQuery + "ca.ID="+objself.MAP_IDACTIVIDADCLIENTE_SEL;
        }
    }
    else if (contentsName==='ActividadesClienteHijoBajaCliente') {
        if(objself.MAP_IDACTIVIDADCLIENTE_SEL > 0){
            filterQuery = filterQuery + "ca.ID="+objself.MAP_IDACTIVIDADCLIENTE_SEL;
        }
    }
    else if (contentsName==='ActividadesClienteHijoCitaEntidad') {
        if(objself.MAP_IDACTIVIDADCLIENTE_SEL > 0){
            filterQuery = filterQuery + "ca.ID="+objself.MAP_IDACTIVIDADCLIENTE_SEL;
        }
    }
    else if (contentsName==='ActividadesClienteHijoPausaManualCliente') {
        if(objself.MAP_IDACTIVIDADCLIENTE_SEL > 0){
            filterQuery = filterQuery + "ca.ID="+objself.MAP_IDACTIVIDADCLIENTE_SEL;
        }
    }
    else if (contentsName==='ActividadesClienteHijoReactivarCliente') {
        if(objself.MAP_IDACTIVIDADCLIENTE_SEL > 0){
            filterQuery = filterQuery + "ca.ID="+objself.MAP_IDACTIVIDADCLIENTE_SEL;
        }
    }
    else if (contentsName==='ActividadesClienteHijoAbstencionLlamadas') {
        if(objself.MAP_IDACTIVIDADCLIENTE_SEL > 0){
            filterQuery = filterQuery + "ca.ID="+objself.MAP_IDACTIVIDADCLIENTE_SEL;
        }
    }
    else if (contentsName==='ActividadesClienteHijoModificacionClausulasContractuales') {
        if(objself.MAP_IDACTIVIDADCLIENTE_SEL > 0){
            filterQuery = filterQuery + "ca.ID="+objself.MAP_IDACTIVIDADCLIENTE_SEL;
        }
    }
    else if (contentsName==='ActividadesClienteHijoAutorizacionIngresoCartaBancaria') {
        if(objself.MAP_IDACTIVIDADCLIENTE_SEL > 0){
            filterQuery = filterQuery + "ca.ID="+objself.MAP_IDACTIVIDADCLIENTE_SEL;
        }
    }
    else if (contentsName==='ActividadesClienteHijoDevolucionIntereses') {
        if(objself.MAP_IDACTIVIDADCLIENTE_SEL > 0){
            filterQuery = filterQuery + "ca.ID="+objself.MAP_IDACTIVIDADCLIENTE_SEL;
        }
    }
    else if (contentsName==='ActividadesClienteHijoAccionJudicial') {
        if(objself.MAP_IDACTIVIDADCLIENTE_SEL > 0){
            filterQuery = filterQuery + "ca.ID="+objself.MAP_IDACTIVIDADCLIENTE_SEL;
        }
    }
    else if (contentsName==='ActividadesClienteHijoNegociacionExtrajudicial') {
        if(objself.MAP_IDACTIVIDADCLIENTE_SEL > 0){
            filterQuery = filterQuery + "ca.ID="+objself.MAP_IDACTIVIDADCLIENTE_SEL;
        }
    }
    else if (contentsName==='ActividadesClienteHijoMonitorioRecibido') {
        if(objself.MAP_IDACTIVIDADCLIENTE_SEL > 0){
            filterQuery = filterQuery + "ca.ID="+objself.MAP_IDACTIVIDADCLIENTE_SEL;
        } else {
            filterQuery = filterQuery + "1=2";
        }
    }
    
    else if (contentsName==='ActividadesClienteHijoCompensacionAcuerdoAcreedores') {
        if(objself.MAP_IDACTIVIDADCLIENTE_SEL > 0){
            filterQuery = filterQuery + "caa.IDACTIVIDADCLIENTE="+objself.MAP_IDACTIVIDADCLIENTE_SEL;
        }
    }
    else if (contentsName==='ActividadesClienteHijoAportacionExtra') {
        if(objself.MAP_IDACTIVIDADCLIENTE_SEL > 0){
            filterQuery = filterQuery + "ca.ID="+objself.MAP_IDACTIVIDADCLIENTE_SEL;
        } else {
            filterQuery = filterQuery + "1=2";
        }
    }
  
    else if (contentsName==='Juzgados' || contentsName==='JuzgadosContador') {
        filterQuery = filterQuery + "1=1";
        
        if(!isNullOrEmpty(objself.MAP_ORGANO)){
            filterQuery = filterQuery + " AND j.ORGANO like '%" + objself.MAP_ORGANO + "%'"; 
        }
        if(!isNullOrEmpty(objself.MAP_TIPO_ORGANO)){
            filterQuery = filterQuery + " AND j.TIPO_ORGANO like '%" + objself.MAP_TIPO_ORGANO + "%'"; 
        }
        if(!isNullOrEmpty(objself.MAP_CODIGO_UNIDAD_FUNCIONAL)){
            filterQuery = filterQuery + " AND j.CODIGO_UNIDAD_FUNCIONAL like '%" + objself.MAP_CODIGO_UNIDAD_FUNCIONAL + "%'"; 
        }
        if(!isNullOrEmpty(objself.MAP_CCAA)){
            filterQuery = filterQuery + " AND j.CCAA like '%" + objself.MAP_CCAA + "%'"; 
        }
        if(!isNullOrEmpty(objself.MAP_PROVINCIA)){
            filterQuery = filterQuery + " AND j.PROVINCIA like '%" + objself.MAP_PROVINCIA + "%'"; 
        }
        if(!isNullOrEmpty(objself.MAP_MUNICIPIO)){
            filterQuery = filterQuery + " AND j.MUNICIPIO like '%" + objself.MAP_MUNICIPIO + "%'"; 
        }
        if(!isNullOrEmpty(objself.MAP_CODIGO_CTEAJE)){
            filterQuery = filterQuery + " AND j.CODIGO_CTEAJE like '%" + objself.MAP_CODIGO_CTEAJE + "%'"; 
        }
   
    }
    else if (contentsName==='ClienteNoCobrarComision' || contentsName==='ClienteNoCobrarComisionContador') {
        filterQuery = filterQuery + "1=1";
    
        if(!isNullOrEmpty(objself.MAP_NOMBRE)){
            filterQuery = filterQuery + " AND c.NOMBRE like '%" + objself.MAP_NOMBRE + "%'"; 
        }
        if(!isNullOrEmpty(objself.MAP_APELLIDOS)){
            filterQuery = filterQuery + " AND c.APELLIDOS like '%" + objself.MAP_APELLIDOS + "%'"; 
        }
        if(!isNullOrEmpty(objself.MAP_MOVIL)){
            filterQuery = filterQuery + " AND c.MOVIL like '%" + objself.MAP_MOVIL + "%'"; 
        }
        if(!isNullOrEmpty(objself.MAP_CORREO)){
            filterQuery = filterQuery + " AND c.CORREO like '%" + objself.MAP_CORREO + "%'"; 
        }
        // Filtro por rango de fechas Fecha Inicio NC
        if(!isNullOrEmpty(safeToString(objself.MAP_AV_FECHA_INICIO_NC_DESDE)) && isNullOrEmpty(safeToString(objself.MAP_AV_FECHA_FIN_NC_HASTA))){ 
            filterQuery = filterQuery + " AND DATE_FORMAT(nc.FECHA_INICIO, '%y-%m-%d') >= DATE_FORMAT('" + safeToDate(objself.MAP_AV_FECHA_INICIO_NC_DESDE) + "', '%y-%m-%d')";
        } else if (isNullOrEmpty(safeToString(objself.MAP_AV_FECHA_INICIO_NC_DESDE)) && !isNullOrEmpty(safeToString(objself.MAP_AV_FECHA_FIN_NC_HASTA))){ 
            filterQuery = filterQuery + " AND DATE_FORMAT(nc.FECHA_FIN, '%y-%m-%d') <= DATE_FORMAT('" + safeToDate(objself.MAP_AV_FECHA_FIN_NC_HASTA) + "', '%y-%m-%d')";
        } else if (!isNullOrEmpty(safeToString(objself.MAP_AV_FECHA_INICIO_NC_DESDE)) && !isNullOrEmpty(safeToString(objself.MAP_AV_FECHA_FIN_NC_HASTA))){ 
            filterQuery = filterQuery + " AND DATE_FORMAT(nc.FECHA_INICIO, '%y-%m-%d') >= DATE_FORMAT('" + safeToDate(objself.MAP_AV_FECHA_INICIO_NC_DESDE) + "', '%y-%m-%d') AND DATE_FORMAT(nc.FECHA_FIN, '%y-%m-%d') <= DATE_FORMAT('" + safeToDate(objself.MAP_AV_FECHA_FIN_NC_HASTA) + "', '%y-%m-%d')";
        }
    }
    // !!!
    else if (contentsName==='ProcesoLSO' || contentsName==="ProcesoLSOContador") {
        // que el titular tenga el proceso lso y la pareja también, si existe
        filterQuery=filterQuery + "IFNULL(lso.BAJA,0)=0 AND ifnull(titular.PROGRAMA,0)=2 AND (pareja.ID IS NULL OR IFNULL(pareja.PROGRAMA,0)=2)";
        // filterQuery=filterQuery + "IFNULL(lso.BAJA,0)=0 AND ifnull(c.PROGRAMA,0)=2";
    }
    else if (contentsName==='ProcesoLSOObservaciones') {
        filterQuery=filterQuery + "ob.ID_PROCESO_LSO="+objself.ID;
    }
    else if (contentsName==='ProcesoLSOObservacionesGlobal') {
        filterQuery=filterQuery + "c.ID_PROCESO_LSO="+objself.ID;
    }
    else if (contentsName==='ProcesoLSOHistoricoEstados') {
        filterQuery=filterQuery + "c.ID_PROCESO_LSO="+objself.ID;
    }
    else if (contentsName==='ProcesoLSODocumentacionPrevia') {
        // **** lleva además una macro extra en la coll para la privacidad de los tipos de documentos ****
        filterQuery=filterQuery + "p.ID=" + objself.ID;
    }
    else if (contentsName==='ProcesoLSODocumentacionPreviaCliente1') {
        filterQuery=filterQuery + "c.ID=" + objself.MAP_IDLEAD_TITULAR;
    }
    else if (contentsName==='ProcesoLSODocumentacionPreviaCliente2') {
        filterQuery=filterQuery + "c.ID=" + objself.MAP_IDLEAD_PAREJA;
    }
    else if (contentsName==='ProcesoLSODeudaCliente') {
        if(safeToInt(objself.MAP_ID_CLIENTE_DEUDA_SELECCIONADO) == 0) {
            // Conjunta: Titular + Pareja
            filterQuery = filterQuery + "d.IDLEAD IN (" + objself.MAP_IDLEAD_TITULAR + "," + objself.MAP_IDLEAD_PAREJA + ")";
        } else {
            // Titular o Pareja individual
            filterQuery = filterQuery + "d.IDLEAD = " + objself.MAP_ID_CLIENTE_DEUDA_SELECCIONADO;
        }
        filterQuery = filterQuery + " AND ((d.IDNT="+user.ID+" OR d.IDNR="+user.ID+" OR d.IDESC="+user.ID+") OR "+user.USERTYPE+" in(11,50,51))";
    }
    else if (contentsName==='ProcesoLSODocumento' || contentsName==="ProcesoLSODocumentoContador") {
        if(objself.MAP_ROWID_CLIENTE_DOCUMENTOS_SELECCIONADO == objself.ROWID) {
            // Conjunta: Titular + Pareja
            filterQuery = filterQuery + "d.ROWID_PROCESO_LSO ='" + objself.ROWID + "'";
        } else {
            // Titular o Pareja individual
            filterQuery = filterQuery + "d.ROWID_LEAD = '" + objself.MAP_ROWID_CLIENTE_DOCUMENTOS_SELECCIONADO + "'";
        }
        filterQuery=filterQuery + " AND ifnull(d.BAJA,0)=0 AND d.IDTIPO not in (1,2,3,4,25,30)";
    }
    else if (contentsName==='ProcesoDocumentoPersonal') {
        if(objself.MAP_ROWID_CLIENTE_DOCUMENTOS_SELECCIONADO == objself.ROWID) {
            // Conjunta: Titular + Pareja
            filterQuery=filterQuery + "ifnull(d.BAJA,0)=0 AND d.ROWID_PROCESO_LSO='"+objself.ROWID+"' AND d.IDTIPO in (1,2,3,4,25,30)";
        } else {
            // Titular o Pareja individual
            filterQuery=filterQuery + "ifnull(d.BAJA,0)=0 AND d.ROWID_LEAD='"+objself.MAP_ROWID_CLIENTE_DOCUMENTOS_SELECCIONADO+"' AND d.IDTIPO in (1,2,3,4,25,30)";
        }
        
    }
    else if (contentsName === 'ClienteDatosFamiliaresCargo') {
        let clientID = (safeToInt(objself.MAP_ID_CLIENTE_SELECCIONADO) > 0) ? objself.MAP_ID_CLIENTE_SELECCIONADO : objself.ID;
        filterQuery = filterQuery + "ifnull(f.BAJA,0)=0 AND f.IDLEAD=" + clientID;
    }
    else if (contentsName === 'ClienteDatosGastosMensuales') {
        let clientID = (safeToInt(objself.MAP_ID_CLIENTE_SELECCIONADO) > 0) ? objself.MAP_ID_CLIENTE_SELECCIONADO : objself.ID;
        filterQuery = filterQuery + "ifnull(g.BAJA,0)=0 AND g.IDLEAD=" + clientID;
    }
    else if (contentsName === 'ClienteDatosPoseeAlgunaSociedad') {
        let clientID = (safeToInt(objself.MAP_ID_CLIENTE_SELECCIONADO) > 0) ? objself.MAP_ID_CLIENTE_SELECCIONADO : objself.ID;
        filterQuery = filterQuery + "ifnull(s.BAJA,0)=0 AND s.IDLEAD=" + clientID;
    }
    else if (contentsName === 'ClienteDatosEmbargosActivos') {
        let clientID = (safeToInt(objself.MAP_ID_CLIENTE_SELECCIONADO) > 0) ? objself.MAP_ID_CLIENTE_SELECCIONADO : objself.ID;
        filterQuery = filterQuery + "ifnull(e.BAJA,0)=0 AND e.IDLEAD=" + clientID;
    }
    else if (contentsName === 'ClienteDatosSancionesHaciendaSS') {
        let clientID = (safeToInt(objself.MAP_ID_CLIENTE_SELECCIONADO) > 0) ? objself.MAP_ID_CLIENTE_SELECCIONADO : objself.ID;
        filterQuery = filterQuery + "ifnull(s.BAJA,0)=0 AND s.IDLEAD=" + clientID;
    }
    else if (contentsName === 'ClienteDatosVentaDonacionBien' || contentsName === 'ClienteDatosVehiculos') {
        let clientID = (safeToInt(objself.MAP_ID_CLIENTE_SELECCIONADO) > 0) ? objself.MAP_ID_CLIENTE_SELECCIONADO : objself.ID;
        filterQuery = filterQuery + "ifnull(v.BAJA,0)=0 AND v.IDLEAD=" + clientID;
    }
    else if (contentsName === 'ClienteDatosHerencia') {
        let clientID = (safeToInt(objself.MAP_ID_CLIENTE_SELECCIONADO) > 0) ? objself.MAP_ID_CLIENTE_SELECCIONADO : objself.ID;
        filterQuery = filterQuery + "ifnull(h.BAJA,0)=0 AND h.IDLEAD=" + clientID;
    }
    else if (contentsName === 'ClienteDatosOtrosActivos') {
        let clientID = (safeToInt(objself.MAP_ID_CLIENTE_SELECCIONADO) > 0) ? objself.MAP_ID_CLIENTE_SELECCIONADO : objself.ID;
        filterQuery = filterQuery + "ifnull(a.BAJA,0)=0 AND a.IDLEAD=" + clientID;
    }
    else if (contentsName === 'ClienteDatosInmuebles') {
        let clientID = (safeToInt(objself.MAP_ID_CLIENTE_SELECCIONADO) > 0) ? objself.MAP_ID_CLIENTE_SELECCIONADO : objself.ID;
        filterQuery = filterQuery + "ifnull(i.BAJA,0)=0 AND i.IDLEAD=" + clientID;
    }
    else if (contentsName === 'ClienteDatosVehiculos') {
        let clientID = (safeToInt(objself.MAP_ID_CLIENTE_SELECCIONADO) > 0) ? objself.MAP_ID_CLIENTE_SELECCIONADO : objself.ID;
        filterQuery = filterQuery + "ifnull(v.BAJA,0)=0 AND v.IDLEAD=" + clientID;
    }
    else if (contentsName === 'ClienteVinculo') {
        let clientID = (safeToInt(objself.MAP_ID_CLIENTE_SELECCIONADO) > 0) ? objself.MAP_ID_CLIENTE_SELECCIONADO : objself.ID;
        filterQuery = filterQuery + "ifnull(cv.BAJA,0)=0 AND " + clientID + " IN (cv.IDLEAD_A,cv.IDLEAD_B)";
    }
    else if (contentsName === 'ClienteContactoCorreos') {
        let clientID = (safeToInt(objself.MAP_ID_CLIENTE_SELECCIONADO) > 0) ? objself.MAP_ID_CLIENTE_SELECCIONADO : objself.ID;
        filterQuery = filterQuery + "ifnull(c.BAJA,0)=0 AND c.IDLEAD=" + clientID;
    }
    else if (contentsName === 'ClienteContactoTelefonos') {
        let clientID = (safeToInt(objself.MAP_ID_CLIENTE_SELECCIONADO) > 0) ? objself.MAP_ID_CLIENTE_SELECCIONADO : objself.ID;
        filterQuery = filterQuery + "ifnull(c.BAJA,0)=0 AND c.IDLEAD=" + clientID;
    }
    filterQuery=filterQuery +")";
    return filterQuery;
}

// function getFilter2(objself,contentsName){
//     var filterQuery = "(";
    
//     if (contentsName==='ProcesoLSODocumentacionPrevia') {
//         filterQuery=filterQuery + "td.PRIVADO=" + objself.MAP_TIPO_DOCUMENTO_PRIVADO;
//     }
    
//     filterQuery=filterQuery +")";
//     return filterQuery;
// }

 
function getFilter2(objself,contentsName){
    var filterQuery = "(";
    
    if (contentsName==='ProcesoLSODocumentacionPrevia' || contentsName==='ProcesoLSODocumentacionPreviaCliente1' || contentsName==='ProcesoLSODocumentacionPreviaCliente2') {
        // indicamos si mostramos los documentos privados (1) o públicos (0)
        filterQuery = filterQuery + "td.PRIVADO=" + objself.MAP_TIPO_DOCUMENTO_PRIVADO;
    }
    else if (contentsName === 'ClienteVinculo') {
        let clientID = (safeToInt(objself.MAP_ID_CLIENTE_SELECCIONADO) > 0) ? objself.MAP_ID_CLIENTE_SELECCIONADO : objself.ID;
        filterQuery = filterQuery + clientID;
    }
    
    filterQuery=filterQuery +")";
    return filterQuery;
}


function limpiarFiltro(coll){
    if(coll=="LeadList"){
        self.MAP_NOMBRE="";
        self.MAP_APELLIDOS="";
        self.MAP_MOVIL="";
        self.MAP_CORREO="";
        self.MAP_CODIGO_ESTADO=0;
        self.MAP_CODIGO_SUBESTADO=0;
        self.MAP_IDASESOR=0;
        self.MAP_IDLIDER=0;
        self.MAP_AV_ORIGEN="";
        self.MAP_AV_DNI="";
        self.MAP_AV_NO_CONTESTA="";
        self.MAP_AV_NUM_REGISTROS=0;
        self.MAP_AV_DEUDA_MIN=0;
        self.MAP_AV_DEUDA_MAX=0;
        self.MAP_IDORIGEN=0;
        self.MAP_IDNOCONTESTA="";
        self.MAP_AV_LSO="";
        self.MAP_IDLSO="";
        self.MAP_AV_FECHA_REGISTRO_DESDE="";
        self.MAP_AV_FECHA_REGISTRO_HASTA="";
        self.MAP_AV_FECHA_ACTIVIDAD_DESDE="";
        self.MAP_AV_FECHA_ACTIVIDAD_HASTA="";
        self.MAP_AV_EXTERNALID="";
    }
    if(coll=="ClienteList"){
        self.MAP_NOMBRE="";
        self.MAP_APELLIDOS="";
        self.MAP_MOVIL="";
        self.MAP_CORREO="";
        self.MAP_DNI="";
        self.MAP_NT="";
        self.MAP_IDNT2=0;
        self.MAP_AV_NR="";
        self.MAP_IDNR2=0;
        self.MAP_AV_ESC="";
        self.MAP_IDESC2=0;
        self.MAP_CODIGO_ESTADO=0;
        // self.MAP_CODIGO_SUBESTADO=0;
        
        self.MAP_PROGRAMA=0;
        self.MAP_AV_DEUDA_MIN=0;
        self.MAP_AV_DEUDA_MAX=0;
        self.MAP_AV_MESES_MIN=0;
        self.MAP_AV_MESES_MAX=0;
        self.MAP_AV_POTENCIAL_MIN=0;
        self.MAP_AV_POTENCIAL_MAX=0;
        self.MAP_AV_RATING_MIN=0;
        self.MAP_AV_RATING_MAX=0;
        self.MAP_AV_APORTACION=0;
        self.MAP_IDTARJETA=0;
        self.MAP_IDSUSCRIPCION=0;
        self.MAP_IDTRANSFERENCIA=0;
        self.MAP_ID_NO_COBRAR_CM=0;
        self.MAP_IDPROCESO=0;
        self.MAP_AV_FECHA_REGISTRO_DESDE="";
        self.MAP_AV_FECHA_REGISTRO_HASTA="";
        self.MAP_AV_FECHA_ACTIVIDAD_DESDE="";
        self.MAP_AV_FECHA_ACTIVIDAD_HASTA="";
        self.MAP_AV_EXTERNALID="";
        self.MAP_AV_TARJETA="";
        self.MAP_AV_SUSCRIPCION="";
    }
    if(coll=="CarterasList"){
        self.MAP_IDCOLABORADOR=0;
        self.MAP_DPTO="";
        self.MAP_CLIENTE=0;
        self.MAP_DEUDA=0;
        self.MAP_DEUDA_TOTAL=0;
        self.MAP_CLIENTE3=0;
        self.MAP_CLIENTE36=0;
        self.MAP_CLIENTE6=0;
        self.MAP_POTENCIAL=0;
    }
    if(coll=="MovimientosList"){
        self.MAP_TIPO_MOV="";
        self.MAP_IDTIPO_MOV=0;
        self.MAP_IDENTIFICADOR="";
        self.MAP_FECHA_DESDE="";
        self.MAP_FECHA_HASTA="";
        self.MAP_IMPORTE_MOV=0;
        self.MAP_CLIENTE_MOV="";
        self.MAP_IDENTIFICADOR_DEUDA_MOV="";
        self.MAP_ESTADO_MOV="";
        self.MAP_IDESTADO_MOV=0;
        self.MAP_SALDO_SUFICIENTE = 0;
        self.MAP_PDTE_FACTURAR = 0;
    }
    if(coll=="DeudasList"){
        self.MAP_DNI="";
        self.MAP_IDENTIFICADOR="";
        self.MAP_IDTIPO_ENT=0;
        self.MAP_IDENT_INI=0;
        self.MAP_IDPRODUCTO=0;
        self.MAP_POTENCIAL=0;
        self.MAP_IDESTADODEUDA=0;
        self.MAP_CLIENTE="";
        self.MAP_IDNT2=0;
        self.MAP_AV_FECHA_REG="";
        self.MAP_AV_FECHA_ULT_ACT="";
        self.MAP_IDENT_ACT=0;
        self.MAP_IDPRODUCTO_ACT=0;
        self.MAP_AV_DEUDA_INI_MIN = 0;
        self.MAP_AV_DEUDA_INI_MAX = 0;
        self.MAP_AV_DEUDA_ACT_MIN = 0;
        self.MAP_AV_DEUDA_ACT_MAX = 0;
        self.MAP_IDNR2=0;
        self.MAP_IDESC=0;
        self.MAP_ID_TIPO_PRODUCTO=0;
        self.MAP_LIQUIDADA = 0;
        self.MAP_FAVORITO = 0;
        self.MAP_TIPO_ACCION = "";
        self.MAP_IDACCION_COMBO = 0;
        self.MAP_ACCION = "";
    }   
    if(coll=="DeudasMicroprestamosList"){
        self.MAP_DNI = "";
        self.MAP_IDENTIFICADOR = "";
        self.MAP_TIPO_ENTIDAD = "";
        self.MAP_ENT_INI = "";
        self.MAP_AV_ENT_ACT = "";
        self.MAP_PROD_INI = "";
        self.MAP_SUBESTADO = "";
        self.MAP_NT = "";
        self.MAP_IDTIPO_ENT = 0;
        self.MAP_IDENT_INI = 0;
        self.MAP_IDENT_ACT = 0;
        self.MAP_IDPRODUCTO = 0;
        self.MAP_IDESTADODEUDA = 0;
        self.MAP_IDNT2 = 0;
        self.MAP_AV_FECHA_REG_DESDE = "";
        self.MAP_AV_FECHA_REG_HASTA = "";
        self.MAP_AV_FECHA_ULT_ACT_DESDE = "";
        self.MAP_AV_FECHA_ULT_ACT_HASTA = "";
        self.MAP_AV_DEUDA_INI_MIN = 0;
        self.MAP_AV_DEUDA_INI_MAX = 0;
        self.MAP_AV_DEUDA_ACT_MIN = 0;
        self.MAP_AV_DEUDA_ACT_MAX = 0;
        self.MAP_AV_PROD_ACT = "";
        self.MAP_POTENCIAL = 0;
        self.MAP_TIPO_ACCION = "";
        self.MAP_ACCION = "";
        self.MAP_IDACCION_COMBO = 0;
        self.MAP_CLIENTE = "";
        self.MAP_AV_NR = "";
        self.MAP_AV_SC = "";
        self.MAP_SALDO_SUFICIENTE = 0;
        self.MAP_LIQUIDADA = 0;
        self.MAP_FAVORITO = 0;
        self.MAP_IDPRODUCTO_ACT = 0;
        self.MAP_IDNR2 = 0;
        self.MAP_IDESC = 0;
    }   
    if(coll=="DeudaClienteAccionesJudicialesList"){
        self.MAP_CORREO = "";
        self.MAP_IDENTIFICADOR_DEUDA = "";
        self.MAP_ENTIDAD = "";
        self.MAP_IDENTIFICADOR_DEMANDA = "";
        self.MAP_ACCION_JUDICIAL = "";
        self.MAP_ESTADO_APUD_ACTA = "";
        self.MAP_ESTADO_DEMANDA = "";
        self.MAP_IDENTIDAD = 0;
        self.MAP_IDTIPO_ACCION = 0;
        self.MAP_IDESTADO_APUD_ACTA = 0;
        self.MAP_IDESTADO_DEMANDA = 0;
        self.MAP_ESTADO_ACCION_JUDICIAL = "";
        self.MAP_AV_FECHA_AUDIENCIA_DESDE = "";
        self.MAP_AV_FECHA_AUDIENCIA_HASTA = "";
        self.MAP_AV_RESULTADO_JUICIO = "";
        self.MAP_IDESTADO_ACCION_JUDICIAL = 0;
        self.MAP_IDRESULTADO_JUICIO = 0;
        self.MAP_AV_FECHA_SENTENCIA_DESDE = "";
        self.MAP_AV_FECHA_SENTENCIA_HASTA = "";
        self.MAP_AV_DIAS_DESDE = 0;
        self.MAP_AV_DIAS_HASTA = 0;
        self.MAP_AV_VIABILIDAD_ESTUDIO = "";
        self.MAP_IDVIABILIDAD_ESTUDIO = 0;
        self.MAP_AV_NOMBRE_APELLIDOS = "";
        self.MAP_AV_OBSERVACIONES = "";
    }   
    if(coll=="DevolucionInteresesClienteList"){
        self.MAP_IDENTIFICADOR_ACTIVIDAD = "";
        self.MAP_CORREO = "";
        self.MAP_ENTIDAD = "";
        self.MAP_IDENTIFICADOR_DEUDA = "";
        self.MAP_IDENTIFICADOR_DEMANDA = "";
        self.MAP_ESTADO_DEUDA = "";
        self.MAP_TIPO_DEVOLUCION = "";
        self.MAP_TRANSFERENCIA_A = "";
        self.MAP_IDENTIDAD = 0;
        self.MAP_IDESTADO_DEUDA = 0;
        self.MAP_IDTIPO_DEVOLUCION = 0;
        self.MAP_IDTRANSFERENCIA_A = 0;
        self.MAP_AV_FECHA_ACUERDO_DESDE = "";
        self.MAP_AV_FECHA_ACUERDO_HASTA = "";
        self.MAP_AV_DIAS_TRANSCURRIDOS_DESDE = 0;
        self.MAP_AV_DIAS_TRANSCURRIDOS_HASTA = 0;
        self.MAP_AV_SITUACION = "";
        self.MAP_AV_IDSITUACION = 0;
        self.MAP_AV_FECHA_LIMITE_DESDE = "";
        self.MAP_AV_FECHA_LIMITE_HASTA = "";
        self.MAP_AV_IMPORTE_RECIBIR_DESDE = 0;
        self.MAP_AV_IMPORTE_RECIBIR_HASTA = 0;
        self.MAP_AV_ESTADO = "";
        self.MAP_AV_MOV_DIA = "";
        self.MAP_AV_MOV_DIC = "";
        self.MAP_AV_IDESTADO = 0;
    }   
    if(coll=="ActividadesClienteMonitoriosList"){
        self.MAP_CORREO = "";
        self.MAP_IDENTIFICADOR_DEUDA = "";
        self.MAP_ENTIDAD = "";
        self.MAP_IDENTIFICADOR_MONITORIO = "";
        self.MAP_PLAZO_MONITORIO = "";
        self.MAP_RESULTADO = "";
        self.MAP_OPOSICION_VINCULADA_FILTRO = "";
        self.MAP_RESPONSABLE = "";
        self.MAP_IDENTIDAD = 0;
        self.MAP_IDPLAZO_MONITORIO = 0;
        self.MAP_IDESTADO_RESULTADO_ESTUDIO_FILTRO = 0;
        self.MAP_IDRESPONSABLE = 0;
        self.MAP_ID_TIENE_OPOSICION = 0;
        self.MAP_IDESTADO_OPOSICION = 0;
        self.MAP_AV_IDESTADO_MONITORIO = 0;
    }   
    if(coll=="TipoEntidadesList"){
        self.MAP_CODIGO=0;
        self.MAP_NOMBRE="";
        self.MAP_MOVIL="";
        self.MAP_IDRIESGO=0;
        self.MAP_IDBAJA=0;
    }
    if(coll=="EntidadesList"){
        self.MAP_NOMBRE="";
        self.MAP_IBAN="";
        self.MAP_MOVIL="";
        self.MAP_TIPOENTIDAD_COD=0;
        self.MAP_IDBAJA=0;
    }
    if(coll=="ProductoList"){
        self.MAP_NOMBRE="";
        self.MAP_ABREVIATURA="";
        self.MAP_IDBAJA=0;
    }
    if(coll=="RangosCuotaList"){
        self.MAP_VALOR="";
        self.MAP_IDBAJA=0;
    }
    if(coll=="ComisionesList"){
        self.MAP_NOMBRE="";
        self.MAP_PORCENTAJE=0;
        self.MAP_DURACION=0;
        self.MAP_IDBAJA=0;
        self.MAP_GRUPO_PAQUETE_COMISION=0;
    }
    if(coll=="MatrizList"){
        self.MAP_NOMBRE="";
        self.MAP_MES=0;
        self.MAP_VALOR=0;
        self.MAP_TIPOENTIDAD_COD=0;
        self.MAP_MATRIZ_COMBO=0;
    }
    if(coll=="UsuariosList"){
        self.MAP_NOMBRE="";
        self.MAP_CORREO="";
        self.MAP_IDTIPO=0;
        // self.MAP_IDBAJA=0;
    }
    if(coll=="UsuariosEquiposList"){
        self.MAP_NOMBRE="";
        self.MAP_APELLIDO="";
        self.MAP_USUARIO="";
        self.MAP_CORREO="";
        self.MAP_IDTIPO=0;
        self.MAP_IDLIDER=0;
    }
    if(coll=="UsuariosEquiposClienteList"){
        self.MAP_LIDER_BUSCAR="";
        self.MAP_ROL_BUSCAR="";
        self.MAP_ESTADO_BUSCAR="";
        self.MAP_IDLIDER2=0;
        self.MAP_IDTIPO=0;
        self.MAP_IDESTADO=0;
        self.MAP_COLABORADOR="";
        self.MAP_DEPARTAMENTO="";
        self.MAP_IDLIDER=0;
        self.MAP_ID_USERTYPE=0;
        self.MAP_ID_USERTYPE=0;
        
        // self.MAP_IDBAJA=0;
       // self.MAP_IDBAJA=0;
    }
    if(coll=="TipoUsuariosList"){
        self.MAP_IDTIPO=0;
        self.MAP_IDBAJA=0;
    }
    if(coll=="EstadosList"){
        self.MAP_NOMBRE="";
        self.MAP_CODIGO=0;
        self.MAP_IDTIPO=0;
        self.MAP_IDBAJA=0;
    }
    if(coll=="EstadosClienteList"){
        self.MAP_NOMBRE="";
        self.MAP_CODIGO=0;
        // self.MAP_IDTIPO=0;
        self.MAP_IDBAJA=0;
    }
    if(coll=="OrigenLeadList"){
        self.MAP_NOMBRE="";
        self.MAP_CODIGO=0;
        self.MAP_IDORIGEN=0;
        self.MAP_IDBAJA=0;
    }
    if(coll=="UsuariosIntegracionesList"){
        self.MAP_USUARIO="";
        self.MAP_CORREO="";
    }
    if(coll=="UsuariosDespachosList"){
        self.MAP_NOMBRE="";
        self.MAP_IDLSO=0;
        self.MAP_LSO="";
    }
   if(coll=="MensajeriaList"){
        self.MAP_NOMBRE="";
        self.MAP_APELLIDOS="";
        self.MAP_MOVIL="";
        self.MAP_CORREO_FILTRO="";
        self.MAP_FILTRO_TIPO_CONV="";
        self.MAP_FILTRO_NOTIF="";
        self.MAP_ID_FILTRO_TIPO_CONV=0;
        self.MAP_ID_FILTRO_NOTIF=0;
        self.MAP_FILTRO_ASESOR="";
        self.MAP_FILTRO_NT="";
        self.MAP_FILTRO_NR="";
        self.MAP_ID_FILTRO_ASESOR=0;
        self.MAP_ID_FILTRO_NT=0;
        self.MAP_ID_FILTRO_NR=0;
    }
    if(coll=="JuzgadosList"){
        self.MAP_CCAA="";
        self.MAP_PROVINCIA="";
        self.MAP_MUNICIPIO="";
        self.MAP_ORGANO="";
        self.MAP_TIPO_ORGANO="";
        self.MAP_CODIGO_UNIDAD_FUNCIONAL="";
        self.MAP_CODIGO_CTEAJE="";
    }
    if(coll=="ClienteNoCobrarComisionList"){
        self.MAP_NOMBRE="";
        self.MAP_APELLIDOS="";
        self.MAP_MOVIL="";
        self.MAP_CORREO="";
        self.MAP_AV_FECHA_INICIO_NC_DESDE="";        
        self.MAP_AV_FECHA_FIN_NC_HASTA="";
    }
    if(coll=="MovimientosPlanDePagosList"){
        self.MAP_CLIENTE_MOV="";
        self.MAP_IDENTIFICADOR_DEUDA_MOV="";
        self.MAP_FECHA_DESDE="";
        self.MAP_FECHA_HASTA="";
        self.MAP_ESTADO_PAB="";
        self.MAP_IDESTADO_PAB=0;
        self.MAP_ESTADO_CE="";
        self.MAP_IDESTADO_CE=0;
    }
}

function limpiarCampos(objself,campos){
    if(campos=="crearLead"){
        objself.MAP_NOMBRE_CREAR="";
        objself.MAP_APELLIDOS_CREAR="";
        objself.MAP_MOVIL_CREAR="";
        objself.MAP_CORREO_CREAR="";
    }
    else if(campos=="asignarAsesores"){
        objself.MAP_G_PITCHER="";
        objself.MAP_G_ASESOR="";
        objself.MAP_G_LIDER="";
        objself.MAP_IDPITCHER_ASIGNAR=0;
        objself.MAP_IDASESOR_ASIGNAR=0;
        objself.MAP_IDLIDER_ASIGNAR=0;
    }
    else if(campos=="crearActividad"){
        objself.MAP_DESCRIPCION_ACTIVIDAD="";
        objself.MAP_CODIGO_ETAPA_ACT=0;
        objself.MAP_CODIGO_SUBETAPA_ACT=0;
        objself.MAP_CODIGO_TIPO_ACT=0;
    }
    else if(campos=="filtrarActividadCliente"){
        objself.MAP_FILTRAR_TIPO_ACTIVIDADES = "";
        objself.MAP_FILTRAR_TIPO_ACTIVIDADES_COMBO = 0;
        objself.MAP_FILTRAR_ID_ACTIVIDAD_SELECCIONADA = 0;
    }
    else if(campos=="editarActividad"){
        objself.MAP_DESCRIPCION_ACTIVIDAD_ED="";
        objself.MAP_IDACTIVIDAD=0;
    }
    else if(campos=="ClienteObservaciones"){
        objself.MAP_NUEVA_OBSERVACION="";
    }
    else if(campos=="simulacionesWeb"){
        objself.MAP_SIMWEB_DEUDA_TOTAL="";
        objself.MAP_SIMWEB_INGRESOS_MENSUAL="";
        objself.MAP_SIMWEB_CUOTA_ACTUAL_REPAGO="";
    }
    else if(campos=="guardarPlan"){
        objself.MAP_NOMBRE_DOC_SIM="";
        objself.MAP_DOC_SIM="";
        objself.MAP_TIPO_DOC_SIM="";
        objself.MAP_IDTIPO_DOC=0;
    }
    else if(campos=="agregarDocumento"){
        objself.MAP_NOMBRE_DOC="";
        objself.MAP_DOC="";
        objself.MAP_TIPO_DOC="";
        objself.MAP_IDTIPO_DOC=0;
    }
    else if(campos=="agregarEquipo"){
        objself.MAP_NOMBRE_EQUIPO="";
        objself.MAP_CORREO_LIDER="";
        objself.MAP_TIPO_USUARIO_EQUIPO="";
        objself.MAP_IDLIDER1=0;
        // objself.MAP_ID_TIPO_USUARIO_EQUIPO=0;
    }    
    else if(campos=="FiltrarDocumento"){
        objself.MAP_FECHA_INICIO="";
        objself.MAP_FECHA_FIN="";
        objself.MAP_NOMBRE_FILTRAR="";
        objself.MAP_TIPO_DOCUMENTO="";
        objself.MAP_ENVIAR_FIRMAR="";
        objself.MAP_DOCUMENTO_VISIBLE="";
        objself.MAP_FIRMADO="";
        objself.MAP_IDTIPO_DOC1=0;
        objself.MAP_VALORES_DOCUMENTO_VISIBLE=-1;
        objself.MAP_VALORES_ENVIAR_FIRMAR=-1;
        objself.MAP_VALORES_FIRMADO=-1;
        objself.MAP_ENT_INI="";
        objself.MAP_ENT_ACT="";
        objself.MAP_IDENTIFICADOR_DEUDA="";
        objself.MAP_IDENT_INI=0;
    } 
    else if(campos=="FiltrarDeuda"){
        objself.MAP_IDENTIFICADOR_FILTRAR_DEUDA="";
        objself.MAP_ENTIDAD_DEUDA="";
        objself.MAP_IDENTIDAD_DEUDA=0;
        objself.MAP_ESTADO_DEUDA_FILTRAR="";
        objself.MAP_IDESTADO_DEUDA_FILTRAR=0;
        objself.MAP_TIPO_PRODUCTO_DEUDA="";
        objself.MAP_IDTIPO_PRODUCTO_DEUDA=0;
        objself.MAP_SITUACION_DEUDA_FILTRAR="";
        objself.MAP_IDSITUACION_DEUDA_FILTRAR=0;
        objself.MAP_DEUDA_ACTUAL_MIN=0;
        objself.MAP_DEUDA_ACTUAL_MAX=0;
        objself.MAP_PAGO_ENTIDAD_MIN=0;
        objself.MAP_PAGO_ENTIDAD_MAX=0;
        objself.MAP_POTENCIAL_MIN_DEUDA=0;
        objself.MAP_POTENCIAL_MAX_DEUDA=0;
        objself.MAP_MES_SOL_MIN=0;
        objself.MAP_MES_SOL_MAX=0;
        objself.MAP_LIQUIDADA_DEUDA_FILTRAR="";
        objself.MAP_VALORES_LIQUIDADA_DEUDA=0;
        objself.MAP_BAJA_DEUDA_FILTRAR="";
        objself.MAP_VALORES_BAJA_DEUDA=0;
        objself.MAP_FAVORITO_DEUDA_FILTRAR="";
        objself.MAP_VALORES_FAVORITO_DEUDA=0;
    }

    else if(campos=="annadirObservacion"){
        objself.MAP_NUEVA_OBSERVACION="";
    }
    else if(campos=="crearActividadCliente"){
        objself.MAP_ACTIVIDADES="";
        objself.MAP_ACTIVIDADES_SUBTIPO="";
        objself.MAP_ACTIVIDADES_COMBO=0;
        objself.MAP_ACTIVIDADES_SUBTIPO_COMBO=0;
        objself.MAP_OBSERVACION_ACTIVIDAD="";
        objself.MAP_IMPORTE_ACTIVIDAD=0;
        objself.MAP_IBAN_ACTIVIDAD="";
        objself.MAP_ANEXO4="";
        objself.MAP_IDACTIVIDAD=0;
        objself.MAP_IDDEUDA_ACTIVIDAD=0;
        objself.MAP_NOMCOTITULAR_ENTIDAD_ACTIVIDAD="";
        objself.MAP_DNICOTITULAR_ENTIDAD_ACTIVIDAD="";
        objself.MAP_DIRECCIONCOTITULAR_ENTIDAD_ACTIVIDAD="";
        objself.MAP_DESCRIPCION_PLANTILLA="";
        objself.MAP_IDACCION_COMBO=0;
        objself.MAP_ACCION = "";
        objself.MAP_CUENTA_DEVOLUCION = "";
        objself.MAP_CUENTA_DEVOLUCION_COMBO = 0;
        objself.MAP_IMPORTE_RECIBIR = 0;
        objself.MAP_TIPO_DEVOLUCION = "";
        objself.MAP_TIPO_DEVOLUCION_COMBO = 0;
        objself.MAP_DIAS_RECIBIR = 0;
    }
    else if(campos=="generarPlanAddendum"){
        objself.MAP_DEUDA_TOTAL=0;
        objself.MAP_IDGRUPO_PAQUETE_COMISION=0;
    }
    else if(campos=="generarContratoAddendum"){
        objself.MAP_CLAUSULAS="";
        objself.MAP_CHECK1=0;
        objself.MAP_CHECK2=0;
        objself.MAP_CHECK3=0;
        objself.MAP_CHECK4=0;
        objself.MAP_CHECK5=0;
        objself.MAP_CHECK6=0;
    }
    else if(campos=="annadirActualizacion"){
        objself.MAP_COMBO_CONCEPTO="";
        objself.MAP_CONCEPTOS_COMBO=0;
        objself.MAP_ENTIDAD_ACT="";
        objself.MAP_IDENTIDAD_COMBO=0;
        objself.MAP_IMPORTE_ACTUAL2="";
        objself.MAP_IMPORTE_LIQUIDAR2="";
        objself.MAP_CUOTA1=0;
        objself.MAP_PLAZO_PAGAR=0;
        objself.MAP_TASA_INTERES=0;
        objself.MAP_PLAZO_COMISION=0;
        objself.MAP_DIA_PAGO1=0;
        objself.MAP_ANEXO3="";
        objself.MAP_OBSERVACION="";
        objself.MAP_OBSERVACION_CLIENTE="";
        objself.MAP_CUOTA_INICIAL2=0;
        objself.MAP_CUOTA_INICIAL_FECHA="";
        objself.MAP_VIABILIDAD_COMBO = 0;
        objself.MAP_TIPO_DEMANDA_COMBO = 0;
        objself.MAP_IMPORTE_REMANENTE = 0;
        objself.MAP_IMPORTE_INICIAL_FRACCIONADO2 = 0;
    }
    else if(campos=="verActualizacion"){
        objself.MAP_COLABORADOR3="";
        objself.MAP_CONCEPTO3="";
        objself.MAP_FECHA5="";
        objself.MAP_ENTIDAD="";
        objself.MAP_IMPORTE_ACTUAL_1="";
        objself.MAP_IMPORTE_LIQUIDAR1="";
        objself.MAP_PLAZO_PAGAR1="";
        objself.MAP_ANEXO5="";
        objself.MAP_TASA_INTERES1="";
        objself.MAP_CUOTA2="";
        objself.MAP_OBSERVACION3="";
        objself.MAP_OBSERVACION_CLIENTE1="";
    }
    else if(campos=="agregarUsuario"){
        objself.getOwnerCollection().setVariables("File",null);
        objself.MAP_NOMBRE_FOTO="";
        objself.MAP_NOMBRE_USUARIO="";
        objself.MAP_APELLIDO_USUARIO="";
        objself.MAP_CORREO_USUARIO="";
        objself.MAP_PWD="";
        objself.MAP_PWD1="";
        objself.MAP_TIPO_USUARIO="";
        objself.MAP_EQUIPO1="";
        objself.MAP_LIDER1="";
        objself.MAP_ASIGNACION="";
        objself.MAP_REASIGNACION="";
        objself.MAP_DEUDA_TOTAL="";
        objself.MAP_TIPO_ENTIDAD="";
        objself.MAP_ESTATUS_AGENTE="";
        objself.MAP_LEADS="";
        objself.MAP_USUARIO1="";
        objself.MAP_IDUSUARIO=0;
        objself.MAP_IDESTATUS=0;
        objself.MAP_IDTIPOENTIDAD=0;
        objself.MAP_IDEQUIPO1=0;
        objself.MAP_IDTIPO_USUARIO=0;
        objself.MAP_IDDEUDATOTAL=0;
        objself.MAP_BAJA=0;
    }
    else if(campos=="agregarUsuarioOperaciones"){
        objself.getOwnerCollection().setVariables("File",null);
        objself.MAP_NOMBRE_FOTO="";
        objself.MAP_NOMBRE_USUARIO="";
        objself.MAP_APELLIDO_USUARIO="";
        objself.MAP_CORREO_USUARIO="";
        objself.MAP_PWD="";
        objself.MAP_PWD1="";
        objself.MAP_USUARIO1="";
        objself.MAP_DEPARTAMENTO_CREAR="";
        objself.MAP_EQUIPO1="";
        objself.MAP_LIDER1="";
        objself.MAP_IDEQUIPO1=0;
        objself.MAP_IDLIDER_EQUIPO=0;
        objself.MAP_LIDER_EQUIPO="";
        objself.MAP_MAXCLIENTES_CREAR=0;
        objself.MAP_MAXDEUDAS_CREAR=0;
        objself.MAP_MAXDEUDATOTAL_CREAR=0;
        objself.MAP_MAXCLIENTES3_CREAR=0;
        objself.MAP_MAXCLIENTES36_CREAR=0;
        objself.MAP_MAXCLIENTES6_CREAR=0;
        objself.MAP_TIPO_USUARIO="";
        objself.MAP_IDTIPO_USUARIO=0;
        objself.MAP_ESTATUS_AGENTE="";
        objself.MAP_IDESTATUS=0;
        objself.MAP_LEADS="";
        objself.MAP_RECIBIRLEADS="";
        objself.MAP_RECIBIRLEADS_NUM=0;
        objself.MAP_CALENDARIO_URL="";
        objself.MAP_BAJA=0;
    }
    else if(campos=="asignarEquipoDeuda"){
        objself.MAP_G_NT="";
        objself.MAP_G_NR="";
        objself.MAP_IDNT=0;
        objself.MAP_IDNR=0;
    }
    else if(campos=="asignarGestores"){
        objself.MAP_G_NEG_TRAD="";
        objself.MAP_G_ESC="";
        objself.MAP_G_NEG_RES="";
        objself.MAP_IDNT=0;
        objself.MAP_IDNR=0;
        objself.MAP_IDESC=0;
    }    
    else if(campos=="cambiarEstadoMovimiento"){
        objself.MAP_ESTADO="";
        objself.MAP_IDESTADO_COMBO=0;
    }    
    else if(campos=="agregarUsuarioIntegraciones"){
        objself.MAP_CORREO_USUARIO="";
        objself.MAP_USUARIO1="";
        objself.MAP_PWD="";
        objself.MAP_PWD1="";
        objself.MAP_ESTATUS_AGENTE="";
        objself.MAP_IDESTATUS=0;
        objself.MAP_IDUSUARIO=0;
    }    
    else if(campos=="agregarDespacho"){
        objself.MAP_NOMBRE_DESPACHO="";
        objself.MAP_LSO_CREAR="";
        objself.MAP_IDLSO_CREAR=0;
        objself.MAP_BAJA_CREAR=0;
        objself.MAP_IDDESPACHO=0;
    }    
    else if(campos=="pagoTransferencia"){
        objself.MAP_IMPORTE_TRANSFERENCIA=0;
    }    
    else if(campos=="pagoFinanciera"){
        objself.MAP_BENEFICIARIO_PAGO = "";
        objself.MAP_CONCEPTO_PAGO = "";
        objself.MAP_IBAN_ENTIDAD_PAGO = "";
    }    
    else if(campos=="fraccionarCobroComision"){
        objself.MAP_FRACCION_COMISION = 1;
    }    
    else if(campos=="facturarMovimiento"){
        objself.MAP_ID_TIPO_FACTURA = "";
        objself.MAP_ID_CALIFICACION_OPERACION_FACTURA = "";
        objself.MAP_ID_OPERACION_EXENTA_FACTURA = "";
        objself.MAP_ID_CLAVE_REGIMEN_FACTURA = "";
        objself.MAP_ID_IMPUESTO_FACTURA = "";
        objself.MAP_NC_EXENTO = 0;
        objself.MAP_NC_NO_EXENTO = 0;
        
        objself.MAP_FACTURA_ORIGINAL = "";
        objself.MAP_FACTURA_ORIGINAL_FECHA = "";
        objself.MAP_MOVIMIENTO_ORIGINAL = "";
        objself.MAP_FACTURA_ORIGINAL_IMPORTE = "";
        objself.MAP_FACTURA_ORIGINAL_TIPO_FACTURA = "";
        objself.MAP_FACTURA_ORIGINAL_CALIFICACION = "";
        objself.MAP_FACTURA_ORIGINAL_EXENTA = "";
        objself.MAP_FACTURA_ORIGINAL_REGIMEN = "";
        objself.MAP_FACTURA_ORIGINAL_IMPUESTO = "";
    }    
    else if(campos=="DeudaClientePrograma"){
        objself.MAP_IDDEUDA= 0;
        objself.MAP_IDESTADO_DEUDA= 0;
        objself.MAP_DEUDA_LIQUIDADA= 0;
        objself.MAP_IDENTIFICADOR= "";
        objself.MAP_ENTIDAD_INICIAL= "";
        objself.MAP_ENTIDAD_ACTUAL1= "";
        objself.MAP_IMPORTE_INICIAL= "";
        objself.MAP_PRODUCTO_INICIAL= "";
        objself.MAP_TIPO_PRODUCTO= "";
        objself.MAP_IDPRODUCTO= 0;
        objself.MAP_IDPRODUCTO_COMBO= 0;
        objself.MAP_POTENCIAL_DEUDA= 0;
        objself.MAP_ENTIDAD_ACTUAL= "";
        objself.MAP_IMPORTE_NUEVO= "";
        objself.MAP_CUOTA_INICIAL= "";
        objself.MAP_FECHA_CUOTA_INI= "";
        objself.MAP_ENTIDAD_CHECK= 0;
        objself.MAP_IMPORTE_LIQUIDAR= "";
        objself.MAP_CHECK_IMPORTE_LIQUIDAR= 0;
        objself.MAP_DESCUENTO= "";
        objself.MAP_COMISION_EXITO= "";
        objself.MAP_TOTAL_PAGAR= "";
        objself.MAP_MES_INICIAL= 0;
        objself.MAP_DOCUMENTO_COMPROBANTE= "";
        objself.MAP_DOCUMENTO_APROBACION= "";
        objself.MAP_DOCUMENTO_JUSTIFICANTE= "";
        objself.MAP_DOCUMENTO_CERTIFICADO= "";
        objself.MAP_CUOTA= "";
        objself.MAP_MESES1= 0;
        objself.MAP_MESES2= 0;
        objself.MAP_MESES3= 0;
        objself.MAP_INTERES= "";
        objself.MAP_IMPORTE_NUEVO_CHECK= 0;
        objself.MAP_CUOTA_CHECK= 0;
        objself.MAP_MESES_CHECK= 0;
        objself.MAP_DEUDA_NEG= "";
        objself.MAP_CUOTA_INI_NEG= "";
        objself.MAP_FECHA_CUOTA_INI_NEG= "";
        objself.MAP_CUOTA_NEG= 0;
        objself.MAP_MESES_NEG= 0;
        objself.MAP_PAB_MENSUAL= "";
        objself.MAP_PAB_REMANENTE= "";
        objself.MAP_CE_MENSUAL= "";
        objself.MAP_DIA_PAGO= 0;
        objself.MAP_CHECK_DIA_PAGO= 0;
        objself.MAP_SEGUMIENTO_PAGOS= 0;
        objself.MAP_IDSITUACION= 0;
        objself.MAP_SITUACION= "";
        objself.MAP_IMPORTE_REF= 0;
        objself.MAP_IDENTIDAD_INICIAL = 0;
        objself.MAP_IDENTIDAD_ACTUAL = 0;
        objself.MAP_IDENTIDAD_INICIAL_TLF = 0;
        objself.MAP_IDENTIDAD_ACTUAL_TLF = 0;
        objself.MAP_CUOTA_INICIAL_CHECK = 0;
        objself.MAP_FECHA_CUOTA_INI_CHECK = 0;
        objself.MAP_IBAN_ENTIDAD = "";
        objself.MAP_VIABILIDAD = "";
        objself.MAP_TIPO_DEMANDA_VIABILIDAD= 0;
        objself.MAP_IDTIPO_DEMANDA = 0;
        objself.MAP_ENTIDAD_CHECK_DEM = 0;
        objself.MAP_ESTUDIO_VIABILIDAD_CHECK_DEM = 0;
        objself.MAP_TIPO_DEMANDA_CHECK_DEM = 0;
        objself.MAP_IMPORTE_CE_LIQUIDADA= "";
        objself.MAP_BUSQUEDA = "";
        objself.MAP_NEGOCIACION = "";
        objself.MAP_CHECK_RECOPILACION = 0;
        objself.MAP_LIQUIDAR_PLANPAGO = 0;
    }
    else if(campos=="editarActividadDeudaAccionJudicial"){
        objself.MAP_ID_ACTIVIDADCLIENTE = 0;
        objself.MAP_ACCION_JUDICIAL_SELECCIONADA = "";
        objself.MAP_OBSERVACIONES = "";
        objself.MAP_ESTADO_APUD = "";
        objself.MAP_ESTADO_ACCION = "";
        objself.MAP_URL = "";
        objself.MAP_ID_ESTADO_APUD_ACCION_JUDICIAL = 0;
        objself.MAP_ID_ESTADO_ACCION_JUDICIAL = 0;
        objself.MAP_VIABILIDAD_ESTUDIO = "";
        objself.MAP_ID_VIABILIDAD_ESTUDIO = 0;
    }
    else if(campos=="editarMonitorio"){
        objself.MAP_IDMONITORIO = 0;
        objself.MAP_MONITORIO_SELECCIONADO = "";
        objself.MAP_IDESTADO_MONITORIO = 0;
        objself.MAP_IDESTADO_RESULTADO_ESTUDIO = 0;
        objself.MAP_OBSERVACIONES = "";
    }
    else if(campos=="ProcesoLSOObservaciones"){
        objself.MAP_NUEVA_OBSERVACION = "";
    }
    else if(campos == "annadirFamiliar"){
        objself.MAP_FAMILIAR_RELACION = "";
        objself.MAP_FAMILIAR_EDAD = 0;
        objself.MAP_FAMILIAR_DISCAPACIDAD = "";
        objself.MAP_FAMILIAR_IDRELACION = 0;
        objself.MAP_FAMILIAR_IDDISCAPACIDAD = 0;
        objself.MAP_FAMILIAR_OBSERVACIONES = "";
    }
    else if(campos == "annadirGastoMensual"){
        objself.MAP_GASTO_MENSUAL_TIPO = "";
        objself.MAP_GASTO_MENSUAL_OBSERVACIONES = "";
        objself.MAP_GASTO_MENSUAL_IMPORTE = 0;
        objself.MAP_GASTO_MENSUAL_IDTIPO = 0;
        objself.MAP_GASTO_MENSUAL_ID_TIPO_DOCUMENTO = 0;
        objself.MAP_GASTO_MENSUAL_DOCUMENTO = "";
    }
    else if(campos == "annadirBienInmueble"){
        objself.MAP_INMUEBLE_TIPO = "";
        objself.MAP_INMUEBLE_VALOR = 0;
        objself.MAP_INMUEBLE_SITUACION = "";
        objself.MAP_INMUEBLE_IDTIPO = 0;
        objself.MAP_INMUEBLE_IDSITUACION = 0;
        objself.MAP_INMUEBLE_HIPOTECA_PENDIENTE_IMPORTE = 0;
        objself.MAP_INMUEBLE_HIPOTECA_PENDIENTE = "";
        objself.MAP_INMUEBLE_HIPOTECA_MENSUAL_IMPORTE = 0;
        objself.MAP_INMUEBLE_IDHIPOTECA = 0;
        objself.MAP_INMUEBLE_CALLE = "";
        objself.MAP_INMUEBLE_NUMERO = "";
        objself.MAP_INMUEBLE_PISO = "";
        objself.MAP_INMUEBLE_LOCALIDAD = "";
        objself.MAP_INMUEBLE_CP = "";
        objself.MAP_INMUEBLE_DIRECCION_COMPLETA = "";
        objself.MAP_INMUEBLE_OBSERVACIONES = "";
    }
    else if(campos == "annadirVehiculo"){
        objself.MAP_VEHICULO_TIPO = "";
        objself.MAP_VEHICULO_OBSERVACIONES = "";
        objself.MAP_VEHICULO_VALOR_COMPRA = 0;
        objself.MAP_VEHICULO_VALOR_TASACION_ACTUAL = 0;
        objself.MAP_VEHICULO_ANYOS_ANTIGUO = 0;
        objself.MAP_VEHICULO_IDTIPO = 0;
        objself.MAP_VEHICULO_USO = "";
        objself.MAP_VEHICULO_IDUSO = 0;
        objself.MAP_VEHICULO_SITUACION = "";
        objself.MAP_VEHICULO_FINANCIACION = "";
        objself.MAP_VEHICULO_MARCA = "";
        objself.MAP_VEHICULO_MODELO = "";
        objself.MAP_VEHICULO_PAGO_MENSUAL = 0;
        objself.MAP_VEHICULO_IDSITUACION = 0;
        objself.MAP_VEHICULO_IDFINANCIACION = 0;
        objself.MAP_VEHICULO_MATRICULA = "";
        objself.MAP_VEHICULO_FECHA_MATRICULACION = "";
        objself.MAP_VEHICULO_FINANCIACION_PENDIENTE = 0;
        objself.MAP_VEHICULO_IDENTIDAD = 0;
    }
    else if(campos == "annadirEmbargoActivo"){
        objself.MAP_EMBARGO_ACTIVO_IMPORTE_TOTAL = 0;
        objself.MAP_EMBARGO_ACTIVO_IMPORTE_MENSUAL = 0;
        objself.MAP_EMBARGO_ACTIVO_ID_EMBARGO = 0;
        objself.MAP_EMBARGO_ACTIVO_ID_ENTIDAD = 0;
        objself.MAP_EMBARGO_ACTIVO_FECHA_INICIO = "";
        objself.MAP_EMBARGO_ACTIVO_FECHA_FIN = "";
        objself.MAP_EMBARGO_ACTIVO_OBSERVACIONES = "";
    }
    else if(campos == "annadirOtroActivo"){
        objself.MAP_OTROS_ACTIVOS_MAP_OTROS_ACTIVOS_OBSERVACIONES = "";
        objself.MAP_OTROS_ACTIVOS_TIPO = "";
        objself.MAP_OTROS_ACTIVOS_SITUACION = "";
        objself.MAP_OTROS_ACTIVOS_VALOR_ACTUAL = 0;
        objself.MAP_OTROS_ACTIVOS_IDTIPO = 0;
        objself.MAP_OTROS_ACTIVOS_IDSITUACION = 0;
        objself.MAP_OTROS_ACTIVOS_NOMBRE = "";
        objself.MAP_OTROS_ACTIVOS_CUENTA_DE_VALORES = 0;
        objself.MAP_OTROS_ACTIVOS_RENTABILIDAD = 0;
        objself.MAP_OTROS_ACTIVOS_RENTABILIDAD_PORCENTAJE = 0;
        objself.MAP_OTROS_ACTIVOS_PLUSVALIA = 0;
        objself.MAP_OTROS_ACTIVOS_RENTABILIDAD_NETA = 0;
        objself.MAP_OTROS_ACTIVOS_NUMERO_POLIZA = "";
        objself.MAP_OTROS_ACTIVOS_CANTIDAD_ASEGURADA = 0;
        objself.MAP_OTROS_ACTIVOS_IBAN = "";
    }
    else if(campos == "annadirSancion"){
        objself.MAP_SANCION_FECHA = "";
        objself.MAP_SANCION_ID_ENTIDAD = 0;
        objself.MAP_SANCION_ENTIDAD = "";
        objself.MAP_SANCION_GRADO = "";
        objself.MAP_SANCION_IMPORTE = 0;
        objself.MAP_SANCION_PAGADO = 0;
        objself.MAP_SANCION_FECHA_PAGO = "";
        objself.MAP_SANCION_OBSERVACIONES = "";
    }
    else if(campos == "annadirVentaBien"){
        objself.MAP_VENTA_BIEN_ID_TIPO = 0;
        objself.MAP_VENTA_BIEN_ID_TIPO_EVENTO = 0;
        objself.MAP_VENTA_BIEN_FECHA = "";
        objself.MAP_VENTA_BIEN_IMPORTE_TOTAL = 0;
        objself.MAP_VENTA_BIEN_IMPORTE_PERCIBIDO = 0;
        objself.MAP_VENTA_BIEN_OBSERVACIONES = "";
        objself.MAP_VENTA_BIEN_TIPO_DOCUMENTO = "";
        objself.MAP_VENTA_BIEN_ID_TIPO_DOCUMENTO = 0;
        objself.MAP_VENTA_BIEN_DOCUMENTO = "";
    }
    else if(campos == "annadirHerencia"){
        objself.MAP_ID_HERENCIA_TIPO = 0;
        objself.MAP_DESCRIPCION = "";
        objself.MAP_HERENCIA_OBSERVACIONES = "";
        objself.MAP_VALOR_TOTAL = 0;
        objself.MAP_USUFRUTO_PORCENTAJE = 0;
        objself.MAP_USUFRUTO_IMPORTE = 0;
        objself.MAP_NUDA_PROPIEDAD_PORCENTAJE = 0;
        objself.MAP_NUDA_PROPIEDAD_IMPORTE = 0;
        objself.MAP_PROPIEDAD_PORCENTAJE = 0;
        objself.MAP_PROPIEDAD_IMPORTE = 0;
    }
}

function copiarPortapapeles(campo){
    clipboard.setText(campo);
    ui.showToast("Texto copiado en el portapapeles");
}

function asignarTextoColor(prop,texto){
    self.MAP_TEXTOCOLOR=textoColor;
}

function aplicarColor(){

    let color="#";
    let error=0;
    if((safeToString(self.MAP_COLOR_OPACO).length==1 && self.MAP_COLOR_OPACO!==0) || safeToString(self.MAP_COLOR_OPACO).length>2){
        ui.showToast("La opacidad debe tener 2 dígitos o ninguno (valor por defecto: 0)");
        error++;
    } 
    if(self.MAP_COLOR_HEXA.length<6){
        ui.showToast("Debe introducir un color de 6 dígitos");
        error++;
    }
    if(error==0){
        if(self.MAP_COLOR_OPACO!==0){
            color=color+self.MAP_COLOR_HEXA+self.MAP_COLOR_OPACO;
        }else{
            color=color+self.MAP_COLOR_HEXA;
        }
        if(comprobarColor(color)==true){
            cambiarColorProp(self,"MAP_COLOR_EDIT",color);
        }
    }
}

function comprobarColor(color){
    let regex = /^#[0-9a-fA-F]{6,8}$/g;
    // match devuelve el propio valor si cumple la condición del regex. Si no cumple, devuelve vacío
    let found = color.match(regex);
    if (!found){
        ui.showToast("el color introducido no es válido");
        return false;   
    }else{
        return found.length>0;
    }
}

function quitarTildes(texto){
    // quita todas la tildes que hay, no sólo las de las vocales
    return texto.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
}

async function calcularEdad(objself,fechaNacimiento){
    // calculamos los años
    let minute = 1000 * 60;
    let hour = minute * 60;
    let day = hour * 24;
    let year = day * 365.25;
    
    let fecha_actual = new Date();
    let anyos = (fecha_actual.getTime() - fechaNacimiento.getTime())/year;
    if(Math.abs(Math.trunc(anyos)) === 0){
        objself.MAP_EDAD = 1;
    }else{
        objself.MAP_EDAD = Math.abs(Math.trunc(anyos));
    }
    objself.EDAD = objself.MAP_EDAD;
    await objself.save();
}

async function guardarMatrizSimple(){
    var i=0;
    var collmatriz, obj, objAnterior;
    collmatriz = appData.getCollection("MatrizDescuentoSimpleScript");
    collmatriz.setFilter("TIPOENTIDAD_COD="+self.TIPOENTIDAD_COD);
    await collmatriz.loadAll();

    ui.showWaitDialog();

    // Micropréstamos
    if(self.TIPOENTIDAD_COD==1){
        for (i;i<=collmatriz.count();i++){
            if(self.MAP_EDITAR==1){
                obj=await obtenerobjeto("MatrizDescuentoSimpleScript","TIPOENTIDAD_COD=1",i);
            }else{
                obj = await self.getParent().getContents("MatrizDescuentoSimple").createObject();
            }
            if(i==0){
                // guardo el primer registro
                self.CAMPO=camposMatriz[i]+2;
                await self.save();
                if(self.MAP_EDITAR==0){
                    await collmatriz.addItem(self);
                }
                continue;
            }
            if(i<149){
                // segundo registro en adelante. Obtenemos una referencia al valor del registro anterior
                objAnterior= await obtenerobjeto("MatrizDescuentoSimpleScript","TIPOENTIDAD_COD=1",i-1);
                if(round(objAnterior.VALOR+1.3,2)>65){
                    obj.VALOR=65;
                }else{
                    obj.VALOR=round(objAnterior.VALOR+1.3,2);
                }
                obj.TIPOENTIDAD_COD=self.TIPOENTIDAD_COD;
                obj.MES=i+1;
                obj.CAMPO=camposMatriz[i]+2;
                await obj.save();
                if(self.MAP_EDITAR==0){
                    await collmatriz.addItem(obj);
                }
            }
        }
        await collmatriz.saveAll();
    }
    // Bancos
    if(self.TIPOENTIDAD_COD==2){
        for (i;i<=collmatriz.count();i++){
            if(self.MAP_EDITAR==1){
                obj=await obtenerobjeto("MatrizDescuentoSimpleScript","TIPOENTIDAD_COD=2",i);
            }else{
                obj = await self.getParent().getContents("MatrizDescuentoSimple").createObject();
            }
            if(i==0){
                self.CAMPO=camposMatriz[i]+3;
                await self.save();
                if(self.MAP_EDITAR==0){
                    await collmatriz.addItem(self);
                }
                continue;
            }
            if(i<149){
                // segundo registro en adelante. Obtenemos una referencia al valor del registro anterior
                objAnterior= await obtenerobjeto("MatrizDescuentoSimpleScript","TIPOENTIDAD_COD=2",i-1);
                if(round(objAnterior.VALOR+1.02,2)>25){
                    obj.VALOR=25;
                }else{
                    obj.VALOR=round(objAnterior.VALOR+1.02,2);
                }
                obj.TIPOENTIDAD_COD=self.TIPOENTIDAD_COD;
                obj.MES=i+1;
                obj.CAMPO=camposMatriz[i]+3;
                await obj.save();
                if(self.MAP_EDITAR==0){
                    await collmatriz.addItem(obj);
                }
            }
        }
    }
    // Fondos
    if(self.TIPOENTIDAD_COD==3){
        for (i;i<=collmatriz.count();i++){
            if(self.MAP_EDITAR==1){
                obj=await obtenerobjeto("MatrizDescuentoSimpleScript","TIPOENTIDAD_COD=3",i);
            }else{
                obj = await self.getParent().getContents("MatrizDescuentoSimple").createObject();
            }
            if(i==0){
                self.CAMPO=camposMatriz[i]+4;
                await self.save();
                if(self.MAP_EDITAR==0){
                    await collmatriz.addItem(self);
                }
                continue;
            }
            objAnterior= await obtenerobjeto("MatrizDescuentoSimpleScript","TIPOENTIDAD_COD=3",i-1);
            if(i<=15){
                // Obtenemos una referencia al valor del registro anterior
                if(round(objAnterior.VALOR+1.35,2)>65){
                    obj.VALOR=65;
                }else{
                    obj.VALOR=round(objAnterior.VALOR+1.35,2);
                }
                obj.TIPOENTIDAD_COD=self.TIPOENTIDAD_COD;
                obj.MES=i+1;
                obj.CAMPO=camposMatriz[i]+4;
                await obj.save();
                if(self.MAP_EDITAR==0){
                    await collmatriz.addItem(obj);
                }
            }
            if(i>15 && i<=24){
                // Obtenemos una referencia al valor del registro anterior
                if(round(objAnterior.VALOR+1.3,2)>65){
                    obj.VALOR=65;
                }else{
                    obj.VALOR=round(objAnterior.VALOR+1.35,2);
                }
                obj.TIPOENTIDAD_COD=self.TIPOENTIDAD_COD;
                obj.MES=i+1;
                obj.CAMPO=camposMatriz[i]+4;
                await obj.save();
                if(self.MAP_EDITAR==0){
                    await collmatriz.addItem(obj);
                }
            }
            if(i>24 && i<149){
                // Obtenemos una referencia al valor del registro anterior
                if(round(objAnterior.VALOR+1.2,2)>65){
                    obj.VALOR=65;
                }else{
                    obj.VALOR=round(objAnterior.VALOR+1.35,2);
                }
                obj.TIPOENTIDAD_COD=self.TIPOENTIDAD_COD;
                obj.MES=i+1;
                obj.CAMPO=camposMatriz[i]+4;
                await obj.save();
                if(self.MAP_EDITAR==0){
                    await collmatriz.addItem(obj);
                }
            }
        }
    }
    // Otros
    if(self.TIPOENTIDAD_COD==4){
        for (i;i<=collmatriz.count();i++){
            if(self.MAP_EDITAR==1){
                obj=await obtenerobjeto("MatrizDescuentoSimpleScript","TIPOENTIDAD_COD=4",i);
            }else{
                obj = await self.getParent().getContents("MatrizDescuentoSimple").createObject();
            }
            if(i==0){
                self.CAMPO=camposMatriz[i]+5;
                await self.save();
                if(self.MAP_EDITAR==0){
                    await collmatriz.addItem(self);
                }
                continue;
            }
            objAnterior= await obtenerobjeto("MatrizDescuentoSimpleScript","TIPOENTIDAD_COD=4",i-1);
            if(i<=15){
                // Obtenemos una referencia al valor del registro anterior
                if(round(objAnterior.VALOR+1.28,2)>65){
                    obj.VALOR=65;
                }else{
                    obj.VALOR=round(objAnterior.VALOR+1.28,2);
                }
                obj.TIPOENTIDAD_COD=self.TIPOENTIDAD_COD;
                obj.MES=i+1;
                obj.CAMPO=camposMatriz[i]+5;
                await obj.save();
                if(self.MAP_EDITAR==0){
                    await collmatriz.addItem(obj);
                }
            }
            if(i>15 && i<=24){
                // Obtenemos una referencia al valor del registro anterior
                if(round(objAnterior.VALOR+1.23,2)>65){
                    obj.VALOR=65;
                }else{
                    obj.VALOR=round(objAnterior.VALOR+1.28,2);
                }
                obj.TIPOENTIDAD_COD=self.TIPOENTIDAD_COD;
                obj.MES=i+1;
                obj.CAMPO=camposMatriz[i]+5;
                await obj.save();
                if(self.MAP_EDITAR==0){
                    await collmatriz.addItem(obj);
                }
            }
            if(i>24 && i<149){
                // Obtenemos una referencia al valor del registro anterior
                if(round(objAnterior.VALOR+1.2,2)>65){
                    obj.VALOR=65;
                }else{
                    obj.VALOR=round(objAnterior.VALOR+1.28,2);
                }
                obj.TIPOENTIDAD_COD=self.TIPOENTIDAD_COD;
                obj.MES=i+1;
                obj.CAMPO=camposMatriz[i]+5;
                await obj.save();
                if(self.MAP_EDITAR==0){
                    await collmatriz.addItem(obj);
                }
            }
        }
    }
    // Agencia recobro
    if(self.TIPOENTIDAD_COD==5){
        for (i;i<=collmatriz.count();i++){
            if(self.MAP_EDITAR==1){
                obj=await obtenerobjeto("MatrizDescuentoSimpleScript","TIPOENTIDAD_COD=5",i);
            }else{
                obj = await self.getParent().getContents("MatrizDescuentoSimple").createObject();
            }
            if(i==0){
                self.CAMPO=camposMatriz[i]+6;
                await self.save();
                if(self.MAP_EDITAR==0){
                    await collmatriz.addItem(self);
                }
                continue;
            }
            objAnterior= await obtenerobjeto("MatrizDescuentoSimpleScript","TIPOENTIDAD_COD=5",i-1);
            if(i<=15){
                // Obtenemos una referencia al valor del registro anterior
                if(round(objAnterior.VALOR+1.4,2)>65){
                    obj.VALOR=65;
                }else{
                    obj.VALOR=round(objAnterior.VALOR+1.4,2);
                }
                obj.TIPOENTIDAD_COD=self.TIPOENTIDAD_COD;
                obj.MES=i+1;
                obj.CAMPO=camposMatriz[i]+6;
                await obj.save();
                if(self.MAP_EDITAR==0){
                    await collmatriz.addItem(obj);
                }
            }
            if(i>15 && i<=24){
                // Obtenemos una referencia al valor del registro anterior
                if(round(objAnterior.VALOR+1.3,2)>65){
                    obj.VALOR=65;
                }else{
                    obj.VALOR=round(objAnterior.VALOR+1.4,2);
                }
                obj.TIPOENTIDAD_COD=self.TIPOENTIDAD_COD;
                obj.MES=i+1;
                obj.CAMPO=camposMatriz[i]+6;
                await obj.save();
                if(self.MAP_EDITAR==0){
                    await collmatriz.addItem(obj);
                }
            }
            if(i>24 && i<149){
                // Obtenemos una referencia al valor del registro anterior
                if(round(objAnterior.VALOR+1.2,2)>65){
                    obj.VALOR=65;
                }else{
                    obj.VALOR=round(objAnterior.VALOR+1.4,2);
                }
                obj.TIPOENTIDAD_COD=self.TIPOENTIDAD_COD;
                obj.MES=i+1;
                obj.CAMPO=camposMatriz[i]+6;
                await obj.save();
                if(self.MAP_EDITAR==0){
                    await collmatriz.addItem(obj);
                }
            }
        }
    }
    ui.hideWaitDialog();
    await guardarMatrizAumentada(self.MAP_EDITAR);
    await actualizarDatosContent(self.getParent(),"MatrizDescuentoAumentado");
}

async function guardarMatrizIntereses(){
    var i=0;
    var collmatriz, obj, objAnterior;
    collmatriz = appData.getCollection("MatrizInteresesScript");
    collmatriz.setFilter("TIPOENTIDAD_COD="+self.TIPOENTIDAD_COD);
    await collmatriz.loadAll();

    ui.showWaitDialog();

    // Micropréstamos
    if(self.TIPOENTIDAD_COD==1){
        for (i;i<=collmatriz.count();i++){
            if(self.MAP_EDITAR==1){
                obj=await obtenerobjeto("MatrizInteresesScript","TIPOENTIDAD_COD=1",i);
            }else{
                obj = await self.getParent().getContents("MatrizIntereses").createObject();
            }
            if(i==0){
                self.CAMPO=camposMatriz[i]+10;
                await self.save();
                if(self.MAP_EDITAR==0){
                    await collmatriz.addItem(self);
                }
                continue;
            }
            objAnterior= await obtenerobjeto("MatrizInteresesScript","TIPOENTIDAD_COD=1",i-1);
            if(i<149){
                // segundo registro en adelante. Obtenemos una referencia al valor del registro anterior
                if(round(objAnterior.VALOR+1.4,2)>45){
                    obj.VALOR=45;
                }else{
                    obj.VALOR=round(objAnterior.VALOR+1.4,2);
                }
                obj.TIPOENTIDAD_COD=self.TIPOENTIDAD_COD;
                obj.MES=i+1;
                obj.CAMPO=camposMatriz[i]+10;
                await obj.save();
                if(self.MAP_EDITAR==0){
                    await collmatriz.addItem(obj);
                }
            }
        }
    }
    // Bancos
    if(self.TIPOENTIDAD_COD==2){
        for (i;i<=collmatriz.count();i++){
            if(self.MAP_EDITAR==1){
                obj=await obtenerobjeto("MatrizInteresesScript","TIPOENTIDAD_COD=2",i);
            }else{
                obj = await self.getParent().getContents("MatrizIntereses").createObject();
            }
            if(i==0){
                self.CAMPO=camposMatriz[i]+11;
                await self.save();
                if(self.MAP_EDITAR==0){
                    await collmatriz.addItem(self);
                }
                continue;
            }
            objAnterior= await obtenerobjeto("MatrizInteresesScript","TIPOENTIDAD_COD=2",i-1);
            if(i<149){
                // segundo registro en adelante. Obtenemos una referencia al valor del registro anterior
                if(round(objAnterior.VALOR+1.22,2)>25){
                    obj.VALOR=25;
                }else{
                    obj.VALOR=round(objAnterior.VALOR+1.22,2);
                }
                obj.TIPOENTIDAD_COD=self.TIPOENTIDAD_COD;
                obj.MES=i+1;
                obj.CAMPO=camposMatriz[i]+11;
                await obj.save();
                if(self.MAP_EDITAR==0){
                    await collmatriz.addItem(obj);
                }
            }
        }
    }
    // Fondos
    if(self.TIPOENTIDAD_COD==3){
        for (i;i<=collmatriz.count();i++){
            if(self.MAP_EDITAR==1){
                obj=await obtenerobjeto("MatrizInteresesScript","TIPOENTIDAD_COD=3",i);
            }else{
                obj = await self.getParent().getContents("MatrizIntereses").createObject();
            }
            if(i==0){
                self.CAMPO=camposMatriz[i]+12;
                await self.save();
                if(self.MAP_EDITAR==0){
                    await collmatriz.addItem(self);
                }
                continue;
            }
            objAnterior= await obtenerobjeto("MatrizInteresesScript","TIPOENTIDAD_COD=3",i-1);
            if(i<149){
                // segundo registro en adelante. Obtenemos una referencia al valor del registro anterior
                if(round(objAnterior.VALOR+1.45,2)>45){
                    obj.VALOR=45;
                }else{
                    obj.VALOR=round(objAnterior.VALOR+1.45,2);
                }
                obj.TIPOENTIDAD_COD=self.TIPOENTIDAD_COD;
                obj.MES=i+1;
                obj.CAMPO=camposMatriz[i]+12;
                await obj.save();
                if(self.MAP_EDITAR==0){
                    await collmatriz.addItem(obj);
                }
            }
        }
    }
    // Otros
    if(self.TIPOENTIDAD_COD==4){
        for (i;i<=collmatriz.count();i++){
            if(self.MAP_EDITAR==1){
                obj=await obtenerobjeto("MatrizInteresesScript","TIPOENTIDAD_COD=4",i);
            }else{
                obj = await self.getParent().getContents("MatrizIntereses").createObject();
            }
            if(i==0){
                self.CAMPO=camposMatriz[i]+13;
                await self.save();
                if(self.MAP_EDITAR==0){
                    await collmatriz.addItem(self);
                }
                continue;
            }
            objAnterior= await obtenerobjeto("MatrizInteresesScript","TIPOENTIDAD_COD=4",i-1);
            if(i<149){
                // segundo registro en adelante. Obtenemos una referencia al valor del registro anterior
                if(round(objAnterior.VALOR+1.38,2)>45){
                    obj.VALOR=45;
                }else{
                    obj.VALOR=round(objAnterior.VALOR+1.38,2);
                }
                obj.TIPOENTIDAD_COD=self.TIPOENTIDAD_COD;
                obj.MES=i+1;
                obj.CAMPO=camposMatriz[i]+13;
                await obj.save();
                if(self.MAP_EDITAR==0){
                    await collmatriz.addItem(obj);
                }
            }
        }
    }
    // Agencia recobro
    if(self.TIPOENTIDAD_COD==5){
        for (i;i<=collmatriz.count();i++){
            if(self.MAP_EDITAR==1){
                obj=await obtenerobjeto("MatrizInteresesScript","TIPOENTIDAD_COD=5",i);
            }else{
                obj = await self.getParent().getContents("MatrizIntereses").createObject();
            }
            if(i==0){
                self.CAMPO=camposMatriz[i]+14;
                await self.save();
                if(self.MAP_EDITAR==0){
                    await collmatriz.addItem(self);
                }
                continue;
            }
            objAnterior= await obtenerobjeto("MatrizInteresesScript","TIPOENTIDAD_COD=5",i-1);
            if(i<149){
                // segundo registro en adelante. Obtenemos una referencia al valor del registro anterior
                if(round(objAnterior.VALOR+1.50,2)>45){
                    obj.VALOR=45;
                }else{
                    obj.VALOR=round(objAnterior.VALOR+1.50,2);
                }
                obj.TIPOENTIDAD_COD=self.TIPOENTIDAD_COD;
                obj.MES=i+1;
                obj.CAMPO=camposMatriz[i]+14;
                await obj.save();
                if(self.MAP_EDITAR==0){
                    await collmatriz.addItem(obj);
                }
            }
        }
    }
    ui.hideWaitDialog();
    await guardarMatrizAumentada(self.MAP_EDITAR);
    await actualizarDatosContent(self.getParent(),"MatrizDescuentoAumentado");
}

async function guardarMatrizAumentada(editar){
    var i=0;
    var obj,ObjD,ObjI;
    var collmatrizAumentada = appData.getCollection("MatrizDescuentoAumentadoScript");
    var collmatrizSimple = appData.getCollection("MatrizDescuentoSimpleScript");
    var collmatrizInteres = appData.getCollection("MatrizInteresesScript");
    
    ui.showWaitDialog();
    
    collmatrizAumentada.setFilter("TIPOENTIDAD_COD="+self.TIPOENTIDAD_COD);
    collmatrizSimple.setFilter("TIPOENTIDAD_COD="+self.TIPOENTIDAD_COD);
    collmatrizInteres.setFilter("TIPOENTIDAD_COD="+self.TIPOENTIDAD_COD);
    await collmatrizAumentada.loadAll();
    await collmatrizSimple.loadAll();
    await collmatrizInteres.loadAll();
    
    if(collmatrizSimple.count()>0 && collmatrizInteres.count()>0 && collmatrizSimple.count()==collmatrizInteres.count()){
        for(i; i<collmatrizSimple.count();i++){
            if(editar==1){
                obj = await obtenerobjeto("MatrizDescuentoAumentadoScript","TIPOENTIDAD_COD="+self.TIPOENTIDAD_COD,i);
            }else{
                obj = await self.getParent().getContents("MatrizDescuentoAumentado").createObject();
            }
            // primer elemento matrices descuento e intereses
            if(i==0){
                ObjD= await obtenerobjeto("MatrizDescuentoSimpleScript","",0);
                ObjI= await obtenerobjeto("MatrizInteresesScript","",0);

                obj.VALOR=round(ObjD.VALOR+(ObjI.VALOR/2),2);
                obj.TIPOENTIDAD_COD=self.TIPOENTIDAD_COD;
                if(self.TIPOENTIDAD_COD==1){
                    obj.CAMPO=camposMatriz[i]+18;
                }
                if(self.TIPOENTIDAD_COD==2){
                    obj.CAMPO=camposMatriz[i]+19;
                }
                if(self.TIPOENTIDAD_COD==3){
                    obj.CAMPO=camposMatriz[i]+20;
                }
                if(self.TIPOENTIDAD_COD==4){
                    obj.CAMPO=camposMatriz[i]+21;
                }
                if(self.TIPOENTIDAD_COD==5){
                    obj.CAMPO=camposMatriz[i]+22;
                }
                await obj.save();
                if(editar==0){
                    await collmatrizAumentada.addItem(obj);
                }
                continue;
            }
            // segundo elemento en adelante matrices descuento e intereses
            if(i<149){
                ObjD= await obtenerobjeto("MatrizDescuentoSimpleScript","",i);
                ObjI= await obtenerobjeto("MatrizInteresesScript","",i);
                
                obj.VALOR=round(ObjD.VALOR+(ObjI.VALOR/2),2);
                obj.TIPOENTIDAD_COD=self.TIPOENTIDAD_COD;
                obj.MES=i+1;
                if(self.TIPOENTIDAD_COD==1){
                    obj.CAMPO=camposMatriz[i]+18;
                }
                if(self.TIPOENTIDAD_COD==2){
                    obj.CAMPO=camposMatriz[i]+19;
                }
                if(self.TIPOENTIDAD_COD==3){
                    obj.CAMPO=camposMatriz[i]+20;
                }
                if(self.TIPOENTIDAD_COD==4){
                    obj.CAMPO=camposMatriz[i]+21;
                }
                if(self.TIPOENTIDAD_COD==5){
                    obj.CAMPO=camposMatriz[i]+22;
                }
                await obj.save();
                if(editar==0){
                    await collmatrizAumentada.addItem(obj);
                }
            }
        }
    }
    ui.hideWaitDialog();
}


async function obtenerPrimerElementoMatriz(matriz){
    var obj;
    if(self.TIPOENTIDAD_COD==1){
        obj = await obtenerPrimerobjetoCnt(matriz,"m.TIPOENTIDAD_COD",1);
    }
    if(self.TIPOENTIDAD_COD==2){
        obj = await obtenerPrimerobjetoCnt(matriz,"m.TIPOENTIDAD_COD",2);
    }
    if(self.TIPOENTIDAD_COD==3){
        obj = await obtenerPrimerobjetoCnt(matriz,"m.TIPOENTIDAD_COD",3);
    }
    if(self.TIPOENTIDAD_COD==4){
        obj = await obtenerPrimerobjetoCnt(matriz,"m.TIPOENTIDAD_COD",4);
    }
    if(self.TIPOENTIDAD_COD==5){
        obj = await obtenerPrimerobjetoCnt(matriz,"m.TIPOENTIDAD_COD",5);
    }
    obj.MAP_EDITAR=1;
    appData.pushValue(obj);
}


function filtrarLeadEdicionTipoUsuario(tipoUsuario, idusuario){
    // pitcher
    tipoUsuario==2 ? self.MAP_NOVER = 1 : self.MAP_NOVER = 0;
}

async function filtrarLeadEdicionTipoLead(objself,etapa){
    // Si el lead ya es cliente, no dejamos editar nada desde aquí y habilitamos ir a la ficha en cliente
    if(etapa==2){
        objself.MAP_ESCLIENTE=1;
        objself.setFieldPropertyValue("PlanesLiquidacion","edit-inrow","false");
        objself.setFieldPropertyValue("Deuda","edit-inrow","false");
        
        // bloqueamos la edición de los checks en documentos
        let cnt=await objself.getContents("Documento");
        for(var i=0;i<cnt.count();i++){
            let item= cnt.getItem(i);
            item.MAP_BLOQUEO=1;
            ui.refreshContentRow("Documento",i);
        }
        let cnt1=await objself.getContents("DocumentoPersonal");
            for(var j=0;j<cnt1.count();j++){
                let item= cnt1.getItem(j);
                item.MAP_BLOQUEO=1;
                ui.refreshContentRow("DocumentoPersonal",j);
            }
    }else{
        objself.MAP_ESCLIENTE=0;
    }
}


async function crearLeadGuardar(objself){
    var obj, objNuevo, objOrigen;
    
    if(isNullOrEmpty(objself.MAP_MOVIL_CREAR) && isNullOrEmpty(objself.MAP_CORREO_CREAR)){
        await ui.msgBox("Debe indicar un número de teléfono o correo para el lead.","Dato obligatorio",0);
        return;
    }
    if(!isNullOrEmpty(objself.MAP_MOVIL_CREAR) && !isNumber(objself.MAP_MOVIL_CREAR)){
        await ui.msgBox("El número de teléfono debe ser numérico.","Móvil",0);
        return;
    }
    // if(objself.MAP_PREFIJO_CREAR === 0){
    //     await ui.msgBox("Debe indicar un prefijo.","Prefijo",0);
    //     return;
    // }
    // if(!isNullOrEmpty(objself.MAP_MOVIL_CREAR) && objself.MAP_MOVIL_CREAR.length!=9){
    //     await ui.msgBox("El número de teléfono debe tener 9 dígitos.","Móvil",0);
    //     return;
    // }

    let regex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+.[a-zA-Z]{2,6}$/;
    let dominio = objself.MAP_CORREO_CREAR.match(regex);
    if(!dominio){
        await ui.msgBox("El dominio del correo introducido no es válido.","Dominio correo",0);
        return;
    }
    
    var collOrigen = appData.getCollection("OrigenLeadScript");
    var fecha=ObtenerFechaHoraActual();
    var coll = appData.getCollection("LeadScript");
    
    await filtrarCollMacroObject(coll,"MOVIL='"+objself.MAP_MOVIL_CREAR+"' OR CORREO='"+objself.MAP_CORREO_CREAR+"'");
    
    if(coll.count()>0){
        obj = coll.getItem(0);
        
        if(obj.MOVIL == objself.MAP_MOVIL_CREAR){
            await ui.msgBox("Ya existe un lead con el móvil indicado.","Lead ya creado",0);
        }
        if(obj.CORREO == objself.MAP_CORREO_CREAR){
            await ui.msgBox("Ya existe un lead con el correo indicado.","Lead ya creado",0);
        }
        
        await filtrarCollMacroObject(collOrigen,"CODIGO="+objself.MAP_IDORIGEN_CREAR);
        if(collOrigen.count()>0){
            objOrigen = collOrigen.getItem(0);
            
            obj.ORIGEN = objOrigen.ORIGEN;
            obj.IDORIGEN = objOrigen.CODIGO;
        }
        
        obj.FECHA_REGISTRO = fecha;
        await obj.save();
        
        await crearRegistroHistorico(obj.ID,objself.MAP_IDORIGEN_CREAR);
    }else{
        
        await filtrarCollMacroObject(collOrigen,"CODIGO="+objself.MAP_IDORIGEN_CREAR);
        
        objNuevo = await coll.createObject();

        objNuevo.NOMBRE=objself.MAP_NOMBRE_CREAR.charAt(0).toUpperCase()+objself.MAP_NOMBRE_CREAR.slice(1).toLowerCase();
        objNuevo.APELLIDOS=objself.MAP_APELLIDOS_CREAR.charAt(0).toUpperCase()+objself.MAP_APELLIDOS_CREAR.slice(1).toLowerCase();
        objNuevo.PREFIJO = objself.MAP_PREFIJO_CREAR == 0 ? 34 : objself.MAP_PREFIJO_CREAR;
        objNuevo.MOVIL=objself.MAP_MOVIL_CREAR;
        objNuevo.CORREO=objself.MAP_CORREO_CREAR;
        
        if(user.USERTYPE!=50 && user.USERTYPE!=2){
            objNuevo.IDASESOR=user.ID;
            objNuevo.IDLIDER=user.IDLIDER;
            objNuevo.FECHA_ASIGNACION=fecha;
            await guardarHistoricoCambioAsesor(objNuevo,0,objNuevo.IDASESOR);
        }
        
        objNuevo.IDESTADO=1;
        objNuevo.FECHA_REGISTRO=fecha;

        if(collOrigen.count()>0){
            objOrigen = collOrigen.getItem(0);
            
            objNuevo.ORIGEN=objOrigen.ORIGEN;
            objNuevo.IDORIGEN=objOrigen.CODIGO;
        }
        await objNuevo.save();
        
        if(objOrigen.CODIGO == 16 || objOrigen.CODIGO ==17){
            // EnviarMensajeAivo(objself,"datos_lead",objself.MAP_MOVIL_CREAR);
        }
        
        await crearRegistroHistorico(objNuevo.ID,objself.MAP_IDORIGEN_CREAR);
        await guardarHistoricoCambioEstado(objNuevo,1,1);
        enviarSms(objself,objNuevo.PREFIJO+objself.MAP_MOVIL_CREAR,"new_cliente");
        
        objself.MAP_CREAR_LEAD=0;
        objself.MAP_FECHAS=0;
        limpiarCampos(objself,"crearLead");

    }
    await actualizarDatosPaginadoLeads(objself,'Lead','LeadContador','MAP_PAG_INI','MAP_PAG_LEN','MAP_TOTAL_REGISTROS','MAP_T1');
}

async function crearRegistroHistorico(idlead,idorigen){
    var collOrigen = appData.getCollection("OrigenLeadScript");
    await filtrarCollMacroObject(collOrigen,"CODIGO="+idorigen);
    
    let coll = appData.getCollection("ClienteHistoricoRegistro");
    let objHist = await coll.createObject();
    
    objHist.IDLEAD=idlead;
    objHist.NOMBRE=self.MAP_NOMBRE_CREAR;
    objHist.APELLIDOS=self.MAP_APELLIDOS_CREAR;
    objHist.MOVIL=self.MAP_MOVIL_CREAR;
    objHist.CORREO=self.MAP_CORREO_CREAR;
    if(collOrigen.count()>0){
        let objOrigen = collOrigen.getItem(0);
        
        objHist.ORIGEN=objOrigen.ORIGEN;
        objHist.IDORIGEN=objOrigen.CODIGO;
    }
    objHist.FECHA_REGISTRO=ObtenerFechaHoraActual();
    // objHist.DEUDA_TOTAL=deudatotal;
    // objHist.CP=CP;
    objHist.BAJA=0;
    await objHist.save();
}



function textoInformacionActividad(codigo){
    var texto= "";
    if(codigo == 13 || codigo == 14){
        texto = "Ingresos mensuales: \nModo de percibir: \nHipoteca: \nRepago de préstamos: \nDeuda total: \nEntidades con las que tiene deuda: \nSituación préstamos: \nDemandado: \nEdad: \nNacionalidad: \nTiene propiedades: \nCotitular/Aval:";
    }
    if(codigo == 5){
        texto = "Situación de las deudas: Primer mes de impago / Lleva ya tiempo en impago \nNómina/pensión: Ha cambiado de banco / No ha cambiado de banco \n¿Tiene demandas?: Si/No - Caixa, BBVA... \n¿Tiene embargos ejecutados?: Si/No - 400€ \nPersonalidad: Nervioso / Tranquilo / Limitado / Inteligente \nDispositivo: Iphone/Android \nExperiencias previas: Si/No - Bravo, soluciona, etc \nOtras observaciones: ...";
    }

    return texto;
}


async function guardarHistoricoCambioEstado(objself,idestadoOrigen,idestadoDestino){
    // para llevar un histórico de los cambios de etapa de los leads 
    let fecha=ObtenerFechaHoraActual();
    let coll = appData.getCollection("ClienteHistoricoEstadosScript");
    let obj = await coll.createObject();
    
    obj.IDLEAD = objself.ID;
    obj.IDESTADO_ORIGEN = idestadoOrigen;
    obj.IDESTADO_DESTINO = idestadoDestino;
    obj.FECHA = fecha;
    await obj.save();
}

async function guardarHistoricoCambioEstadoCliente(objself,idestadoOrigen,idestadoDestino){
    // para llevar un histórico de los cambios de etapa de los leads 
    let fecha=ObtenerFechaHoraActual();
    let coll = appData.getCollection("ClienteHistoricoEstadosClienteScript");
    let obj = await coll.createObject();
    
    obj.IDLEAD = objself.ID;
    obj.IDESTADO_CLIENTE_ORIGEN = idestadoOrigen;
    obj.IDESTADO_CLIENTE_DESTINO = idestadoDestino;
    obj.FECHA = fecha;
    await obj.save();
}

async function guardarEstadoClientePausa(objself, abuelo){
    // para controlar las fechas de pausa y reanudación. Máximo 3 meses
    let fecha = ObtenerFechaHoraActual();
    var fechaTope = sumarMeses(fecha,3);

    let coll = appData.getCollection("EstadosClientePausaScript");
    let obj = await coll.createObject();
    
    obj.IDLEAD = abuelo.ID;
    obj.IDACTIVIDADCLIENTE = objself.ID;
    obj.FECHA_INICIO = fecha;
    obj.FECHA_TOPE_FIN = fechaTope;
    
    await obj.save();
}

async function guardarEstadoClienteReanudar(objself){
    // para reanudar un cliente pausado
    let fecha = ObtenerFechaHoraActual();

    let coll = appData.getCollection("EstadosClientePausaScript");
    await filtrarCollMacroObject(coll,"IDLEAD = " + objself.ID + " AND FECHA_FIN IS NULL");
    
    if(coll.count() > 0) {
        let obj = coll.getItem(0);
        
        obj.FECHA_FIN = fecha;
        await obj.save();
    }
}

async function guardarHistoricoCambioAsesor(objself,idasesorOrigen,idasesorDestino){
    // para llevar un histórico de los cambios de etapa de los leads 
    let fecha=ObtenerFechaHoraActual();
    let coll = appData.getCollection("ClienteHistoricoAsignacionScript");
    let obj = await coll.createObject();
    
    obj.IDLEAD = objself.ID;
    obj.IDASESOR_ORIGEN = idasesorOrigen;
    obj.IDASESOR_DESTINO = idasesorDestino;
    obj.FECHA = fecha;
    await obj.save();
}

async function crearActividadGuardar(objself){
    // if(isNullOrEmpty(self.MAP_DESCRIPCION_ACTIVIDAD)){
    //     await ui.msgBox("Debe indicar una descripción para la actividad.","Falta descripción",0);
    //     return;
    // }
    if(objself.MAP_BANDERA==0){
        objself.MAP_BANDERA=1;
        let cnt = await objself.getContents("ActividadesLead");
        var obj= await cnt.createObject();
        let fecha=ObtenerFechaHoraActual();
        obj.DESCRIPCION=objself.MAP_DESCRIPCION_ACTIVIDAD;
        obj.IDLEAD=objself.ID;
        obj.IDUSUARIO=user.ID;
        obj.FECHA=fecha;
        obj.IDTIPO_ACTIVIDAD=objself.MAP_CODIGO_TIPO_ACT;
        objself.FECHA_ULT_ACTIVIDAD=fecha;
        
        if(objself.MAP_CODIGO_ETAPA_ACT>0){
            if(objself.MAP_CODIGO_ETAPA_ACT==3){
                // etapa en conversación
                if(objself.MAP_CODIGO_SUBETAPA_ACT>0){
                    await guardarHistoricoCambioEstado(objself,objself.IDESTADO,objself.MAP_CODIGO_SUBETAPA_ACT);
                    obj.IDESTADO=objself.MAP_CODIGO_SUBETAPA_ACT;
                    objself.IDESTADO=objself.MAP_CODIGO_SUBETAPA_ACT;
                    objself.MAP_ESTADO=objself.MAP_SUBETAPA_CREAR;
                    
                    // si marca no interesado, buscamos planes de liquidación y contratos para rechazarlos si los tuviera
                    if(objself.MAP_CODIGO_SUBETAPA_ACT==5){
                        await rechazarDocumento(objself,7);
                        await rechazarDocumento(objself,8);
                    }
                }else{
                    await ui.msgBox("Debe seleccionar una subestapa para la etapa 'en conversación'.","Falta subestapa",0);
                    return;
                }
            }else{
                // etapa sin respuesta
                await guardarHistoricoCambioEstado(objself,objself.IDESTADO,objself.MAP_CODIGO_ETAPA_ACT);
                obj.IDESTADO=objself.MAP_CODIGO_ETAPA_ACT;
                objself.IDESTADO=objself.MAP_CODIGO_ETAPA_ACT;
                objself.MAP_ESTADO=objself.MAP_ETAPA_CREAR;
                
                // enviamos mensaje al lead
                // EnviarMensajeAivo(objself,"lead_sinrespuesta",objself.MAP_MOVIL);
            }
        }else{
            // buscamos el estado actualizado del lead por si hubiera cambiado de etapa en la zona de usuario
            let collLead = appData.getCollection("ClienteScript");
            await filtrarCollMacroObject(collLead,"c.ID="+objself.ID);
            
            if (collLead.count()>0){
                let objLead = collLead.getItem(0);
                
                if(objself.IDESTADO != objLead.IDESTADO) {
                    
                    objself.IDESTADO = objLead.IDESTADO;
                    
                    var collEstado= appData.getCollection("Estados");
                    await filtrarCollMacroObject(collEstado,"CODIGO="+objLead.IDESTADO);
                    if(collEstado.count()>0){
                        let Estado = collEstado.getItem(0);
                        objself.MAP_ESTADO = Estado.NOMBRE;
                    }
                }
            }
        }
        
        await obj.save();
        await objself.save();
        
        objself.MAP_CREAR_ACTIVIDAD=0;
        limpiarCampos(objself,"crearActividad");
        await actualizarDatosContent(objself,"ActividadesLead");
        ui.refresh("ActividadesLead");
    }
    objself.MAP_BANDERA=0;
}

async function editarActividadGuardar(objself){
    if(objself.MAP_BANDERA==0){
        objself.MAP_BANDERA=1;
        var cnt = await objself.getContents("ActividadesLead");
        await filtrarContentMacroObject(cnt,"ca.IDLEAD="+objself.ID+" AND ca.ID="+objself.MAP_IDACTIVIDAD);
        
        if(cnt.count()>0){
            let obj = cnt.getItem(0);
            let fecha=ObtenerFechaHoraActual();
            obj.DESCRIPCION=objself.MAP_DESCRIPCION_ACTIVIDAD_ED;
            obj.IDUSUARIO=user.ID;
            obj.FECHA=fecha;
            objself.FECHA_ULT_ACTIVIDAD=fecha;
            
            // buscamos el estado actualizado del lead por si hubiera cambiado de etapa en la zona de usuario
            let collLead = appData.getCollection("ClienteScript");
            await filtrarCollMacroObject(collLead,"c.ID="+objself.ID);
            
            if (collLead.count()>0){
                let objLead = collLead.getItem(0);
                
                if(objself.IDESTADO != objLead.IDESTADO) {
                    
                    objself.IDESTADO = objLead.IDESTADO;
                    
                    var collEstado= appData.getCollection("Estados");
                    await filtrarCollMacroObject(collEstado,"CODIGO="+objLead.IDESTADO);
                    if(collEstado.count()>0){
                        let Estado = collEstado.getItem(0);
                        objself.MAP_ESTADO = Estado.NOMBRE;
                    }
                }
            }
            
            await obj.save();
            await objself.save();
            
            objself.MAP_EDITAR_ACTIVIDAD=0;
            limpiarCampos(objself,"editarActividad");
            await actualizarDatosContent(objself,"ActividadesLead");
            ui.refresh("ActividadesLead");
        }
    }
    objself.MAP_BANDERA=0;
}



async function actualizarDeudaTotal(objself,idlead){
    let total=0;
    
    let contDeuda = await objself.getContents("Deuda");
    for(let i=0; i < contDeuda.count(); i++){
        let objDeuda = contDeuda.getItem(i);
        
        if(objDeuda.APLICA_PL == 1) {
            total = total + objDeuda.IMPORTE_ACTUAL; 
        }
    }
    objself.MAP_DEUDA_TOTAL = round(total,2)+" €";
}

async function guardarDatosClienteGeneral(objself) {
    let error = "", objResidencia, objDiscapacidad, objLsoPrevia, objAntecedentes, objPoseeSociedad;
    
    // comprobaciones
    if(objself.ACREDITA_RESIDENCIA_CHECK == 1 && safeToInt(objself.MAP_IDACREDITA_RESIDENCIA) === 0){
        error = "Debe indicar una opción para 'acredita residencia en España'.";
    }
    if(objself.DISCAPACIDAD_CHECK == 1 && safeToInt(objself.MAP_ID_DISCAPACIDAD) === 0){
        error = error + " Debe indicar un porcentaje de discapacidad.";
    }
    
    if(error !== "") {
        await ui.msgBox(error,"Datos cliente",0);
        return;
    }
    
    // guardamos el valor de acredita residencia
    let collResidencia = appData.getCollection("ClienteDatosAcreditaResidenciaScript");
    await filtrarCollMacroObject(collResidencia,"IDLEAD=" + objself.ID);
    if(collResidencia.count() > 0) {
        objResidencia = collResidencia.getItem(0);
    } else {
        objResidencia = await collResidencia.createObject();
    }
    
    objResidencia.IDLEAD = objself.ID;
    objResidencia.ID_ACREDITA_RESIDENCIA = objself.MAP_IDACREDITA_RESIDENCIA;
    await objResidencia.save();
    
    // guardamos los valores de discapacidad
    let collDiscapacidad = appData.getCollection("ClienteDatosDiscapacidadScript");
    await filtrarCollMacroObject(collDiscapacidad,"IDLEAD=" + objself.ID);
    if(collDiscapacidad.count() > 0) {
        objDiscapacidad = collDiscapacidad.getItem(0);
    } else {
        objDiscapacidad = await collDiscapacidad.createObject();
    }
        
    objDiscapacidad.IDLEAD = objself.ID;
    objDiscapacidad.ID_DISCAPACIDAD = objself.MAP_ID_DISCAPACIDAD;
    objDiscapacidad.OBSERVACIONES = objself.MAP_DISCAPACIDAD_OBSERVACIONES;
    await objDiscapacidad.save();
    
    // guardamos los valores de lso previa
    let collDatosLsoPrevia = appData.getCollection("ClienteDatosLsoPreviaScript");
    await filtrarCollMacroObject(collDatosLsoPrevia,"IDLEAD=" + objself.ID);
    if(collDatosLsoPrevia.count() > 0) {
        objLsoPrevia = collDatosLsoPrevia.getItem(0);
    } else {
        objLsoPrevia = await collDatosLsoPrevia.createObject();
    }
        
    objLsoPrevia.IDLEAD = objself.ID;
    objLsoPrevia.FECHA = objself.MAP_LSO_PREVIA_FECHA;
    objLsoPrevia.OBSERVACIONES = objself.MAP_LSO_PREVIA_OBSERVACIONES;
    await objLsoPrevia.save();
    
    // guardamos los valores de antecedentes penales
    let collAntecedentesPenales = appData.getCollection("ClienteDatosAntecedentesPenalesScript");
    await filtrarCollMacroObject(collAntecedentesPenales,"IDLEAD=" + objself.ID);
    if(collAntecedentesPenales.count() > 0) {
        objAntecedentes = collAntecedentesPenales.getItem(0);
    } else {
        objAntecedentes = await collAntecedentesPenales.createObject();
    }
        
    objAntecedentes.IDLEAD = objself.ID;
    objAntecedentes.FECHA = objself.MAP_ANTECEDENTES_PENALES_FECHA;
    objAntecedentes.OBSERVACIONES = objself.MAP_ANTECEDENTES_PENALES_OBSERVACIONES;
    await objAntecedentes.save();
    
    
    
    // Actualizamos los datos del usuario asociado al cliente
    try {
        await actualizarDatosUsuario(objself);
    } catch(e) {
        ui.showToast("Error actualizando datos personales (móvil y/o correo)");
    }
    
    objself.FECHA_NACIMIENTO = objself.MAP_FECHA_NACIMIENTO;
    objself.EDAD = objself.MAP_EDAD;
    await objself.save();
    objself.MAP_NOMBRE_COMPLETO = objself.NOMBRE + " " +objself.APELLIDOS;
    objself.MAP_DOMICILIO = objself.CALLE + ", " + objself.NUMCALLE + ", " + objself.NUMPISO + ", " + objself.LOCALIDAD + ", " + objself.CP ;
    objself.MAP_DNI = objself.DNI;
    objself.MAP_EDITAR_DATOS_CLIENTE = 0;
    activarEdicionDatosCliente(objself);
}

async function annadirFamiliar(objself, idcliente) {
    
    if(safeToInt(objself.MAP_FAMILIAR_IDRELACION) === 0) {
        ui.showToast("Debe indicar la relación.");
        return;
    }
    
    let collFamiliar = appData.getCollection("ClienteDatosFamiliaresCargoScript");
    
    let objFamiliar = await collFamiliar.createObject();
    objFamiliar.BAJA = 0;
    objFamiliar.IDLEAD = idcliente;
    objFamiliar.EDAD = objself.MAP_FAMILIAR_EDAD;
    objFamiliar.ID_FAMILIAR_RELACION = objself.MAP_FAMILIAR_IDRELACION;
    objFamiliar.ID_DISCAPACIDAD = objself.MAP_FAMILIAR_IDDISCAPACIDAD;
    objFamiliar.OBSERVACIONES = objself.MAP_FAMILIAR_OBSERVACIONES;
    await objFamiliar.save();
    
    await actualizarDatosContent(objself,"ClienteDatosFamiliaresCargo");
    limpiarCampos(objself,"annadirFamiliar");
    objself.MAP_VER_ANNADIR_FAMILIAR = 0;
}

async function adjuntarArchivoGastoMensual(objself, tipoCallback) {
    // para subir UN ÚNICO documento en clienteEdicion para gastos mensuales en await annadirGastoMensual()
    if(safeToInt(objself.MAP_GASTO_MENSUAL_ID_TIPO_DOCUMENTO) === 0) {
        ui.showToast("indique el tipo de documento");
        return;
    }
    
    // comprobamos si adjunta documento
    let file = objself.getOwnerCollection().getVariables("File");
    let docValido = true;
    
    if(file){
        docValido = await comprobarDocumento(objself, objself.MAP_GASTO_MENSUAL_DOCUMENTO, objself.MAP_ROWID || objself.ROWID);
        if(!docValido) {
            return;
        }
    }
    
    // Creamos una Promesa para esperar al callback
    return new Promise(function(resolve, reject) {
        const parametrosBase = {
            tipoDoc: objself.MAP_GASTO_MENSUAL_ID_TIPO_DOCUMENTO,
            correo_lead: objself.CORREO || objself.MAP_CORREO,
            fileName: objself.MAP_GASTO_MENSUAL_DOCUMENTO,
        };
        const parametrosPorTipo = {
            gastoMensual: {
                onSuccess: function(response) {
                    ui.showToast("Documento de gasto mensual subido correctamente");
                    let documento = leerRespuesta(response);
                    // Resolvemos la promesa con el ID
                    resolve(documento.ID); 
                },
                onError: function(error) {
                    ui.showToast("Error al subir el archivo");
                    reject(error);
                }
            }
        };
        const parametrosEspecificos = parametrosPorTipo[tipoCallback] || {};
        const parametros = Object.assign({}, parametrosBase, parametrosEspecificos);
        
        // Ejecutamos la subida
        subirArchivo(objself, parametros);
    });
}

async function annadirGastoMensual(objself, idcliente) {
    let error = "";
    
    if(safeToInt(objself.MAP_GASTO_MENSUAL_IDTIPO) === 0) {
        error = "Debe indicar el tipo de gasto.";
    }
    if(safeToFloat(objself.MAP_GASTO_MENSUAL_IMPORTE) <= 0) {
        error = error + " Debe indicar el importe.";
    }
    if(error !== "") {
        ui.showToast(error);
        return;
    }
    
    // comprobamos si adjunta documento
    let file = objself.getOwnerCollection().getVariables("File");
    let docValido = true;
    
    if(file){
        docValido = await comprobarDocumento(objself, objself.MAP_GASTO_MENSUAL_DOCUMENTO, objself.ROWID);
        if(!docValido) {
            return;
        }
    }
    
    let collGastoMensual = appData.getCollection("ClienteDatosGastosMensualesScript");
    
    let objGastoMensual = await collGastoMensual.createObject();
    objGastoMensual.BAJA = 0;
    objGastoMensual.IDLEAD = idcliente;
    objGastoMensual.ID_GASTO_MENSUAL = objself.MAP_GASTO_MENSUAL_IDTIPO;
    objGastoMensual.IMPORTE = objself.MAP_GASTO_MENSUAL_IMPORTE;
    objGastoMensual.OBSERVACIONES = objself.MAP_GASTO_MENSUAL_OBSERVACIONES;
    // si hay documento lo subimos y guardamos
    if(file) {
        objGastoMensual.ID_DOCUMENTO = await adjuntarArchivoGastoMensual(objself, "gastoMensual");
    }
    await objGastoMensual.save();
    
    await actualizarDatosContent(objself,"ClienteDatosGastosMensuales");
    limpiarCampos(objself,"annadirGastoMensual");
    objself.MAP_VER_ANNADIR_GASTO_MENSUAL = 0;
}

async function annadirBienInmueble(objself, idcliente) {
    let error = "";
    
    if(safeToInt(objself.MAP_INMUEBLE_IDTIPO) === 0) {
        error = "Debe indicar el tipo de vivienda.";
    }
    // if(safeToFloat(objself.MAP_GASTO_MENSUAL_IMPORTE) <= 0) {
    //     error = error + " Debe indicar el importe.";
    // }
    if(error !== "") {
        ui.showToast(error);
        return;
    }
    
    let collBienesInmuebles = appData.getCollection("ClienteDatosInmueblesScript");
    
    let objBienInmueble = await collBienesInmuebles.createObject();
    objBienInmueble.BAJA = 0;
    objBienInmueble.IDLEAD = idcliente;
    objBienInmueble.VALOR = objself.MAP_INMUEBLE_VALOR;
    objBienInmueble.ID_INMUEBLES_TIPO = objself.MAP_INMUEBLE_IDTIPO;
    objBienInmueble.ID_INMUEBLES_SITUACION = objself.MAP_INMUEBLE_IDSITUACION;
    objBienInmueble.ID_INMUEBLES_HIPOTECA = objself.MAP_INMUEBLE_IDHIPOTECA;
    objBienInmueble.HIPOTECA_PENDIENTE = objself.MAP_INMUEBLE_HIPOTECA_PENDIENTE_IMPORTE;
    objBienInmueble.HIPOTECA_MENSUAL = objself.MAP_INMUEBLE_HIPOTECA_MENSUAL_IMPORTE;
    objBienInmueble.REFERENCIA_CATASTRAL = objself.MAP_INMUEBLE_REFERENCIA_CATASTRAL;
    objBienInmueble.CALLE = objself.MAP_INMUEBLE_CALLE;
    objBienInmueble.NUMERO = objself.MAP_INMUEBLE_NUMERO;
    objBienInmueble.PISO = objself.MAP_INMUEBLE_PISO;
    objBienInmueble.LOCALIDAD = objself.MAP_INMUEBLE_LOCALIDAD;
    objBienInmueble.CP = objself.MAP_INMUEBLE_CP;
    objBienInmueble.OBSERVACIONES = objself.MAP_INMUEBLE_OBSERVACIONES;
    await objBienInmueble.save();
    
    await actualizarDatosContent(objself,"ClienteDatosInmuebles");
    limpiarCampos(objself,"annadirBienInmueble");
    objself.MAP_VER_ANNADIR_BIEN_INMUEBLE = 0;
}

async function annadirVehiculo(objself, idcliente) {
    let error = "";
    
    if(safeToInt(objself.MAP_VEHICULO_IDTIPO) === 0) {
        error = "Debe indicar el tipo de vehículo.";
    }
    // if(safeToFloat(objself.MAP_GASTO_MENSUAL_IMPORTE) <= 0) {
    //     error = error + " Debe indicar el importe.";
    // }
    if(error !== "") {
        ui.showToast(error);
        return;
    }
    
    let collVehiculos = appData.getCollection("ClienteDatosVehiculosScript");
    
    let objVehiculo = await collVehiculos.createObject();
    objVehiculo.BAJA = 0;
    objVehiculo.IDLEAD = idcliente;
    objVehiculo.ID_VEHICULOS_TIPO = objself.MAP_VEHICULO_IDTIPO;
    objVehiculo.ID_VEHICULOS_SITUACION = objself.MAP_VEHICULO_IDSITUACION;
    objVehiculo.ID_VEHICULOS_USO = objself.MAP_VEHICULO_IDUSO;
    objVehiculo.ID_VEHICULOS_FINANCIACION = objself.MAP_VEHICULO_IDFINANCIACION;
    objVehiculo.ID_ENTIDAD = objself.MAP_VEHICULO_IDENTIDAD;
    objVehiculo.VALOR_COMPRA = objself.MAP_VEHICULO_VALOR_COMPRA;
    objVehiculo.VALOR_TASACION_ACTUAL = objself.MAP_VEHICULO_VALOR_TASACION_ACTUAL;
    objVehiculo.ANYOS_ANTIGUO = objself.MAP_VEHICULO_ANYOS_ANTIGUO;
    objVehiculo.PAGO_MENSUAL = objself.MAP_VEHICULO_PAGO_MENSUAL;
    objVehiculo.VEHICULO_MARCA = objself.MAP_VEHICULO_MARCA;
    objVehiculo.VEHICULO_MODELO = objself.MAP_VEHICULO_MODELO;
    objVehiculo.VEHICULO_MATRICULA = objself.MAP_VEHICULO_MATRICULA;
    objVehiculo.VEHICULO_FECHA_MATRICULACION = objself.MAP_VEHICULO_FECHA_MATRICULACION;
    objVehiculo.VEHICULO_FINANCIACION_PENDIENTE = objself.MAP_VEHICULO_FINANCIACION_PENDIENTE;
    objVehiculo.OBSERVACIONES = objself.MAP_VEHICULO_OBSERVACIONES;
    await objVehiculo.save();
    // !!!
    await actualizarDatosContent(objself,"ClienteDatosVehiculos");
    limpiarCampos(objself,"annadirVehiculo");
    objself.MAP_VER_ANNADIR_VEHICULO = 0;
}

async function annadirEmbargoActivo(objself, idcliente) {
    let error = "";
    
    if(safeToInt(objself.MAP_EMBARGO_ACTIVO_IMPORTE_TOTAL) <= 0) {
        error = "Debe indicar un importe total.";
    }
    // if(safeToFloat(objself.MAP_GASTO_MENSUAL_IMPORTE) <= 0) {
    //     error = error + " Debe indicar el importe.";
    // }
    if(error !== "") {
        ui.showToast(error);
        return;
    }
    
    let collEmbargos = appData.getCollection("ClienteDatosEmbargosActivosScript");
    
    let objEmbargos = await collEmbargos.createObject();
    objEmbargos.BAJA = 0;
    objEmbargos.IDLEAD = idcliente;
    objEmbargos.IMPORTE = objself.MAP_EMBARGO_ACTIVO_IMPORTE_TOTAL;
    objEmbargos.IMPORTE_MENSUAL = objself.MAP_EMBARGO_ACTIVO_IMPORTE_MENSUAL;
    objEmbargos.ID_EMBARGO = objself.MAP_EMBARGO_ACTIVO_ID_EMBARGO;
    objEmbargos.ID_ENTIDAD = objself.MAP_EMBARGO_ACTIVO_ID_ENTIDAD;
    objEmbargos.FECHA_INICIO = objself.MAP_EMBARGO_ACTIVO_FECHA_INICIO;
    objEmbargos.FECHA_FIN = objself.MAP_EMBARGO_ACTIVO_FECHA_FIN;
    objEmbargos.OBSERVACIONES = objself.MAP_EMBARGO_ACTIVO_OBSERVACIONES;
    await objEmbargos.save();
    
    await actualizarDatosContent(objself,"ClienteDatosEmbargosActivos");
    limpiarCampos(objself,"annadirEmbargoActivo");
    objself.MAP_VER_ANNADIR_EMBARGOS_ACTIVOS = 0;
}

async function annadirOtroActivo(objself, idcliente) {
    let error = "";
    
    if(safeToInt(objself.MAP_OTROS_ACTIVOS_IDTIPO) <= 0) {
        error = "Debe indicar el tipo.";
    }
    // if(safeToFloat(objself.MAP_OTROS_ACTIVOS_VALOR) <= 0) {
    //     error = error + " Debe indicar el valor.";
    // }
    if(error !== "") {
        ui.showToast(error);
        return;
    }
    
    let collActivos = appData.getCollection("ClienteDatosOtrosActivosScript");
    
    let objActivos = await collActivos.createObject();
    objActivos.BAJA = 0;
    objActivos.IDLEAD = idcliente;
    objActivos.ID_ACTIVO_TIPO = objself.MAP_OTROS_ACTIVOS_IDTIPO;
    objActivos.ID_ACTIVO_SITUACION = objself.MAP_OTROS_ACTIVOS_IDSITUACION;
    objActivos.NOMBRE = objself.MAP_OTROS_ACTIVOS_NOMBRE;
    objActivos.CUENTA_DE_VALORES = objself.MAP_OTROS_ACTIVOS_CUENTA_DE_VALORES;
    objActivos.VALOR_ACTUAL = objself.MAP_OTROS_ACTIVOS_VALOR_ACTUAL;
    objActivos.RENTABILIDAD = objself.MAP_OTROS_ACTIVOS_RENTABILIDAD;
    objActivos.RENTABILIDAD_PORCENTAJE = objself.MAP_OTROS_ACTIVOS_RENTABILIDAD_PORCENTAJE;
    objActivos.PLUSVALIA = objself.MAP_OTROS_ACTIVOS_PLUSVALIA;
    objActivos.RENTABILIDAD_NETA = objself.MAP_OTROS_ACTIVOS_RENTABILIDAD_NETA;
    objActivos.NUMERO_POLIZA = objself.MAP_OTROS_ACTIVOS_NUMERO_POLIZA;
    objActivos.CANTIDAD_ASEGURADA = objself.MAP_OTROS_ACTIVOS_CANTIDAD_ASEGURADA;
    objActivos.IBAN = objself.MAP_OTROS_ACTIVOS_IBAN;
    objActivos.OBSERVACIONES = objself.MAP_OTROS_ACTIVOS_OBSERVACIONES;
    await objActivos.save();
    
    await actualizarDatosContent(objself,"ClienteDatosOtrosActivos");
    limpiarCampos(objself,"annadirOtroActivo");
    objself.MAP_VER_ANNADIR_OTROS_ACTIVOS = 0;
}

async function annadirSancion(objself, idcliente) {
    if(objself.MAP_SANCION_FECHA == "") {
        ui.showToast("Debe indicar la fecha de la sanción.");
        return;
    }
    if(safeToFloat(objself.MAP_SANCION_IMPORTE) == 0) {
        ui.showToast("Debe indicar el importe.");
        return;
    }

    let collSancion = appData.getCollection("ClienteDatosSancionesHaciendaSSScript");
    let objSancion = await collSancion.createObject();
    objSancion.BAJA = 0;
    objSancion.IDLEAD = idcliente;
    objSancion.FECHA_SANCION = objself.MAP_SANCION_FECHA;
    objSancion.ID_ENTIDAD = objself.MAP_SANCION_ID_ENTIDAD;
    objSancion.ID_GRADO = objself.MAP_SANCION_ID_GRADO;
    objSancion.IMPORTE = objself.MAP_SANCION_IMPORTE;
    objSancion.OBSERVACIONES = objself.MAP_SANCION_OBSERVACIONES;
    objSancion.PAGADO = 0;
    await objSancion.save();

    await actualizarDatosContent(objself,"ClienteDatosSancionesHaciendaSS");
    limpiarCampos(objself,"annadirSancion");
    objself.MAP_VER_ANNADIR_SANCION = 0;
}

async function annadirVentaBien(objself, idcliente) {
    // if(objself.MAP_SANCION_FECHA == "") {
    //     ui.showToast("Debe indicar la fecha de la sanción.");
    //     return;
    // }
    // if(safeToFloat(objself.MAP_SANCION_IMPORTE) == 0) {
    //     ui.showToast("Debe indicar el importe.");
    //     return;
    // }
    
    // comprobamos si adjunta documento
    // let file = objself.getOwnerCollection().getVariables("File");
    // let docValido = true;
    
    // if(file){
    //     docValido = await comprobarDocumento(objself, objself.MAP_VENTA_BIEN_DOCUMENTO, objself.ROWID);
    //     if(!docValido) {
    //         return;
    //     }
    // }

    let collVentaBien = appData.getCollection("ClienteDatosVentaDonacionBienScript");
    let objVentaBien = await collVentaBien.createObject();
    
    objVentaBien.BAJA = 0;
    objVentaBien.IDLEAD = idcliente;
    objVentaBien.ID_TIPO = objself.MAP_VENTA_BIEN_ID_TIPO;
    objVentaBien.ID_TIPO_EVENTO = objself.MAP_VENTA_BIEN_ID_TIPO_EVENTO;
    objVentaBien.FECHA_VENTA = objself.MAP_VENTA_BIEN_FECHA;
    objVentaBien.IMPORTE_VENTA_TOTAL = objself.MAP_VENTA_BIEN_IMPORTE_TOTAL;
    objVentaBien.IMPORTE_PERCIBIDO = objself.MAP_VENTA_BIEN_IMPORTE_PERCIBIDO;
    objVentaBien.OBSERVACIONES = objself.MAP_VENTA_BIEN_OBSERVACIONES;
    // !!!
    // si hay documento lo subimos y guardamos
    // if(file) {
    //     objVentaBien.ID_DOCUMENTO = adjuntarVentaDonacionBien(objself);
    // }
    await objVentaBien.save();

    await actualizarDatosContent(objself,"ClienteDatosVentaDonacionBien");
    limpiarCampos(objself,"annadirVentaBien");
    objself.MAP_VER_ANNADIR_VENTA_BIEN = 0;
}



async function annadirHerencia(objself, idcliente) {
    let collHerencia = appData.getCollection("ClienteDatosHerenciaScript");
    let objHerencia = await collHerencia.createObject();
    objHerencia.BAJA = 0;
    objHerencia.IDLEAD = idcliente;
    objHerencia.ID_HERENCIA_TIPO = objself.MAP_ID_HERENCIA_TIPO;
    objHerencia.DESCRIPCION = objself.MAP_DESCRIPCION;
    objHerencia.VALOR_TOTAL = objself.MAP_VALOR_TOTAL;
    objHerencia.USUFRUTO_PORCENTAJE = objself.MAP_USUFRUTO_PORCENTAJE;
    objHerencia.USUFRUTO_IMPORTE = objself.MAP_USUFRUTO_IMPORTE;
    objHerencia.NUDA_PROPIEDAD_PORCENTAJE = objself.MAP_NUDA_PROPIEDAD_PORCENTAJE;
    objHerencia.NUDA_PROPIEDAD_IMPORTE = objself.MAP_NUDA_PROPIEDAD_IMPORTE;
    objHerencia.PROPIEDAD_PORCENTAJE = objself.MAP_PROPIEDAD_PORCENTAJE;
    objHerencia.PROPIEDAD_IMPORTE = objself.MAP_PROPIEDAD_IMPORTE;
    objHerencia.OBSERVACIONES = objself.MAP_HERENCIA_OBSERVACIONES;
    await objHerencia.save();

    await actualizarDatosContent(objself,"ClienteDatosHerencia");
    limpiarCampos(objself,"annadirHerencia");
    objself.MAP_VER_ANNADIR_HERENCIA = 0;
}

function activarEdicionDatosCliente(objself){

    if( objself.MAP_EDITAR_DATOS_CLIENTE == 1) {
        objself.setFieldPropertyValue("NOMBRE","bgcolor","#F2F2F2");
        objself.setFieldPropertyValue("APELLIDOS","bgcolor","#F2F2F2");
        objself.setFieldPropertyValue("DNI","bgcolor","#F2F2F2");
        objself.setFieldPropertyValue("PREFIJO","bgcolor","#F2F2F2");
        objself.setFieldPropertyValue("MMP_OVIL","bgcolor","#F2F2F2");
        objself.setFieldPropertyValue("MAP_CORREO","bgcolor","#F2F2F2");
        objself.setFieldPropertyValue("MAP_FECHA_NACIMIENTO","bgcolor","#F2F2F2");
        objself.setFieldPropertyValue("SEXO","bgcolor","#F2F2F2");
        objself.setFieldPropertyValue("NACIONALIDAD","bgcolor","#F2F2F2");
        objself.setFieldPropertyValue("MAP_ESTADO_CIVIL","bgcolor","#F2F2F2");
        objself.setFieldPropertyValue("MAP_CASADO_REGIMEN_ECONOMICO","bgcolor","#F2F2F2");
        objself.setFieldPropertyValue("MAP_DIVORCIADO_MEDIDAS_REGULADORAS","bgcolor","#F2F2F2");
        objself.setFieldPropertyValue("HIJOS","bgcolor","#F2F2F2");
        objself.setFieldPropertyValue("SITUACION_VEHICULO","bgcolor","#F2F2F2");
        objself.setFieldPropertyValue("NIVEL_ACADEMICO","bgcolor","#F2F2F2");
        objself.setFieldPropertyValue("OCUPACION","bgcolor","#F2F2F2");
        objself.setFieldPropertyValue("CALLE","bgcolor","#F2F2F2");
        objself.setFieldPropertyValue("CUOTA_ACTUAL_REPAGO","bgcolor","#F2F2F2");
        objself.setFieldPropertyValue("NUMCALLE","bgcolor","#F2F2F2");
        objself.setFieldPropertyValue("NUMPISO","bgcolor","#F2F2F2");
        objself.setFieldPropertyValue("CUOTA_ACTUAL_REPAGO","bgcolor","#F2F2F2");
        objself.setFieldPropertyValue("CUOTA_ACTUAL_REPAGO","bgcolor","#F2F2F2");
        objself.setFieldPropertyValue("INGRESOS_MENSUAL","bgcolor","#F2F2F2");
        objself.setFieldPropertyValue("NUMERO_PAGAS","bgcolor","#F2F2F2");
        objself.setFieldPropertyValue("CUOTA_ACTUAL_REPAGO","bgcolor","#F2F2F2");
        objself.setFieldPropertyValue("CUOTA_ACTUAL_REPAGO","bgcolor","#F2F2F2");
        if(objself.ACREDITA_RESIDENCIA_CHECK == 1) {
            objself.setFieldPropertyValue("MAP_ACREDITA_RESIDENCIA","bgcolor","#F2F2F2");
        }
        objself.setFieldPropertyValue("MAP_DATOS_CONTRATO_TIPO","bgcolor","#F2F2F2");
        if(objself.DISCAPACIDAD_CHECK == 1) {
            objself.setFieldPropertyValue("MAP_DISCAPACIDAD","bgcolor","#F2F2F2");
            objself.setFieldPropertyValue("MAP_DISCAPACIDAD_OBSERVACIONES","bgcolor","#F2F2F2");
        }
        if(objself.LSO_PREVIA_CHECK == 1) {
            objself.setFieldPropertyValue("MAP_LSO_PREVIA_FECHA","bgcolor","#F2F2F2");
            objself.setFieldPropertyValue("MAP_LSO_PREVIA_OBSERVACIONES","bgcolor","#F2F2F2");
        }
        if(objself.ANTECEDENTES_PENALES_CHECK == 1) {
            objself.setFieldPropertyValue("MAP_ANTECEDENTES_PENALES_FECHA","bgcolor","#F2F2F2");
            objself.setFieldPropertyValue("MAP_ANTECEDENTES_PENALES_OBSERVACIONES","bgcolor","#F2F2F2");
        }
        objself.setFieldPropertyValue("MAP_VIVIENDA_SITUACION","bgcolor","#F2F2F2");
        objself.setFieldPropertyValue("VIVIENDA_IMPORTE_MENSUAL","bgcolor","#F2F2F2");
        objself.setFieldPropertyValue("VIVIENDA_OBSERVACIONES","bgcolor","#F2F2F2");
        objself.setFieldPropertyValue("MAP_DATOS_AUTONOMO_SOCIETARIO","bgcolor","#F2F2F2");
        
        if(objself.HERENCIA_CHECK == 1) {
            objself.setFieldPropertyValue("MAP_HERENCIA_TIPO","bgcolor","#F2F2F2");
            objself.setFieldPropertyValue("HERENCIA_OBSERVACIONES","bgcolor","#F2F2F2");
        }
    }else {
        objself.setFieldPropertyValue("NOMBRE","bgcolor","#D2D2D2");
        objself.setFieldPropertyValue("APELLIDOS","bgcolor","#D2D2D2");
        objself.setFieldPropertyValue("DNI","bgcolor","#D2D2D2");
        objself.setFieldPropertyValue("PREFIJO","bgcolor","#D2D2D2");
        objself.setFieldPropertyValue("MAP_MOVIL","bgcolor","#D2D2D2");
        objself.setFieldPropertyValue("MAP_CORREO","bgcolor","#D2D2D2");
        objself.setFieldPropertyValue("MAP_FECHA_NACIMIENTO","bgcolor","#D2D2D2");
        objself.setFieldPropertyValue("SEXO","bgcolor","#D2D2D2");
        objself.setFieldPropertyValue("NACIONALIDAD","bgcolor","#D2D2D2");
        objself.setFieldPropertyValue("MAP_ESTADO_CIVIL","bgcolor","#D2D2D2");
        objself.setFieldPropertyValue("MAP_CASADO_REGIMEN_ECONOMICO","bgcolor","#D2D2D2");
        objself.setFieldPropertyValue("MAP_DIVORCIADO_MEDIDAS_REGULADORAS","bgcolor","#D2D2D2");
        objself.setFieldPropertyValue("HIJOS","bgcolor","#D2D2D2");
        objself.setFieldPropertyValue("NIVEL_ACADEMICO","bgcolor","#D2D2D2");
        objself.setFieldPropertyValue("OCUPACION","bgcolor","#D2D2D2");
        objself.setFieldPropertyValue("CALLE","bgcolor","#D2D2D2");
        objself.setFieldPropertyValue("NUMCALLE","bgcolor","#D2D2D2");
        objself.setFieldPropertyValue("MAP_HERENCIA_TIPO","bgcolor","#D2D2D2");
        objself.setFieldPropertyValue("NUMPISO","bgcolor","#D2D2D2");
        objself.setFieldPropertyValue("LOCALIDAD","bgcolor","#D2D2D2");
        objself.setFieldPropertyValue("CP","bgcolor","#D2D2D2");
        objself.setFieldPropertyValue("INGRESOS_MENSUAL","bgcolor","#D2D2D2");
        objself.setFieldPropertyValue("NUMERO_PAGAS","bgcolor","#D2D2D2");
        objself.setFieldPropertyValue("CUOTA_ACTUAL_REPAGO","bgcolor","#D2D2D2");
        objself.setFieldPropertyValue("ACREDITA_RESIDENCIA_CHECK","bgcolor","#D2D2D2");
        objself.setFieldPropertyValue("MAP_ACREDITA_RESIDENCIA","bgcolor","#D2D2D2");
        objself.setFieldPropertyValue("MAP_DATOS_CONTRATO_TIPO","bgcolor","#D2D2D2");
        objself.setFieldPropertyValue("MAP_DATOS_OCUPACION","bgcolor","#D2D2D2");
        objself.setFieldPropertyValue("MAP_DISCAPACIDAD","bgcolor","#D2D2D2");
        objself.setFieldPropertyValue("MAP_DISCAPACIDAD_OBSERVACIONES","bgcolor","#D2D2D2");
        objself.setFieldPropertyValue("MAP_LSO_PREVIA_FECHA","bgcolor","#D2D2D2");
        objself.setFieldPropertyValue("MAP_LSO_PREVIA_OBSERVACIONES","bgcolor","#D2D2D2");
        objself.setFieldPropertyValue("MAP_ANTECEDENTES_PENALES_FECHA","bgcolor","#D2D2D2");
        objself.setFieldPropertyValue("MAP_ANTECEDENTES_PENALES_OBSERVACIONES","bgcolor","#D2D2D2");
        objself.setFieldPropertyValue("MAP_VIVIENDA_SITUACION","bgcolor","#D2D2D2");
        objself.setFieldPropertyValue("VIVIENDA_IMPORTE_MENSUAL","bgcolor","#D2D2D2");
        objself.setFieldPropertyValue("VIVIENDA_OBSERVACIONES","bgcolor","#D2D2D2");
        objself.setFieldPropertyValue("MAP_DATOS_AUTONOMO_SOCIETARIO","bgcolor","#D2D2D2");
        objself.setFieldPropertyValue("HERENCIA_OBSERVACIONES","bgcolor","#D2D2D2");
        objself.setFieldPropertyValue("MAP_HERENCIA_TIPO","bgcolor","#D2D2D2");
    }
}

function activarEdicionDatosContrato(objself,grupo){
    // información de LeadEdicion
    if(grupo==1){
        // datos personales y de contacto
        if(objself.MAP_EDITAR_DATOS_CONTRATO==1){
            objself.setFieldPropertyValue("MAP_NOMBRE","bgcolor","#F2F2F2");
            objself.setFieldPropertyValue("MAP_APELLIDOS","bgcolor","#F2F2F2");
            objself.setFieldPropertyValue("MAP_MOVIL","bgcolor","#F2F2F2");
            objself.setFieldPropertyValue("MAP_PREFIJO","bgcolor","#F2F2F2");
            objself.setFieldPropertyValue("MAP_MOVIL2","bgcolor","#F2F2F2");
            objself.setFieldPropertyValue("MAP_MOVIL2_NOMBRE","bgcolor","#F2F2F2");
            objself.setFieldPropertyValue("MAP_MOVIL3","bgcolor","#F2F2F2");
            objself.setFieldPropertyValue("MAP_MOVIL3_NOMBRE","bgcolor","#F2F2F2");
            objself.setFieldPropertyValue("MAP_CORREO","bgcolor","#F2F2F2");
            objself.setFieldPropertyValue("MAP_DNI","bgcolor","#F2F2F2");
        }else{
            objself.setFieldPropertyValue("MAP_NOMBRE","bgcolor","#D2D2D2");
            objself.setFieldPropertyValue("MAP_APELLIDOS","bgcolor","#D2D2D2");
            objself.setFieldPropertyValue("MAP_MOVIL","bgcolor","#D2D2D2");
            objself.setFieldPropertyValue("MAP_PREFIJO","bgcolor","#D2D2D2");
            objself.setFieldPropertyValue("MAP_MOVIL2","bgcolor","#D2D2D2");
            objself.setFieldPropertyValue("MAP_MOVIL2_NOMBRE","bgcolor","#D2D2D2");
            objself.setFieldPropertyValue("MAP_MOVIL3","bgcolor","#D2D2D2");
            objself.setFieldPropertyValue("MAP_MOVIL3_NOMBRE","bgcolor","#D2D2D2");
            objself.setFieldPropertyValue("MAP_CORREO","bgcolor","#D2D2D2");
            objself.setFieldPropertyValue("MAP_DNI","bgcolor","#D2D2D2");
            objself.MAP_GUARDAR_DATOS_CONTRATO1=0;
        }
    }
    else if(grupo==2){
        // Lugar de residencia
        if(objself.MAP_EDITAR_DATOS_CONTRATO==2){
            objself.setFieldPropertyValue("MAP_CALLE","bgcolor","#F2F2F2");
            objself.setFieldPropertyValue("MAP_NUMCALLE","bgcolor","#F2F2F2");
            objself.setFieldPropertyValue("MAP_NUMPISO","bgcolor","#F2F2F2");
            objself.setFieldPropertyValue("MAP_LOCALIDAD","bgcolor","#F2F2F2");
            objself.setFieldPropertyValue("MAP_CP","bgcolor","#F2F2F2");
        }else{
            objself.setFieldPropertyValue("MAP_CALLE","bgcolor","#D2D2D2");
            objself.setFieldPropertyValue("MAP_NUMCALLE","bgcolor","#D2D2D2");
            objself.setFieldPropertyValue("MAP_NUMPISO","bgcolor","#D2D2D2");
            objself.setFieldPropertyValue("MAP_LOCALIDAD","bgcolor","#D2D2D2");
            objself.setFieldPropertyValue("MAP_CP","bgcolor","#D2D2D2");
            objself.MAP_GUARDAR_DATOS_CONTRATO2=0;
        }
    }
    else if(grupo==3){
        // Datos demográficos
        if(objself.MAP_EDITAR_DATOS_CONTRATO==3){
            objself.setFieldPropertyValue("MAP_FECHA_NACIMIENTO","bgcolor","#F2F2F2");
            objself.setFieldPropertyValue("MAP_NACIONALIDAD","bgcolor","#F2F2F2");
            objself.setFieldPropertyValue("MAP_EDAD","bgcolor","#F2F2F2");
            objself.setFieldPropertyValue("MAP_SEXO","bgcolor","#F2F2F2");
            objself.setFieldPropertyValue("MAP_ESTADO_CIVIL","bgcolor","#F2F2F2");
            objself.setFieldPropertyValue("MAP_HIJOS","bgcolor","#F2F2F2");
            objself.setFieldPropertyValue("MAP_SITUACION_VEHICULO","bgcolor","#F2F2F2");
            // ya que no guardamos el id del tipo de coche, tenemos que hacer la comprobación por la descripción
            if(objself.MAP_SITUACION_VEHICULO=="No tiene"){
                objself.MAP_IDSITUACION_VEHICULO=1;
            }else if(objself.MAP_SITUACION_VEHICULO=="Ya pagado"){
                objself.MAP_IDSITUACION_VEHICULO=2;
            }else{
                objself.setFieldPropertyValue("MAP_COCHE_CUOTA","bgcolor","#F2F2F2");
            }
            objself.setFieldPropertyValue("MAP_NIVEL_ACADEMICO","bgcolor","#F2F2F2");
            objself.setFieldPropertyValue("MAP_OCUPACION","bgcolor","#F2F2F2");
            objself.setFieldPropertyValue("MAP_TIPO_VIVIENDA","bgcolor","#F2F2F2");
            // ya que no guardamos el id del tipo de vivienda, tenemos que hacer la comprobación por la descripción
            if(objself.MAP_TIPO_VIVIENDA=="Ya pagada"){
                objself.MAP_IDTIPO_VIVIENDA=1;
            }else if(objself.MAP_TIPO_VIVIENDA=="No paga vivienda"){
                objself.MAP_IDTIPO_VIVIENDA=4;
            }else{
                objself.setFieldPropertyValue("MAP_HIPOTECA","bgcolor","#F2F2F2");
            }
            objself.setFieldPropertyValue("MAP_COCHE_MARCA","bgcolor","#F2F2F2");
            objself.setFieldPropertyValue("MAP_COCHE_MODELO","bgcolor","#F2F2F2");
        }else{
            objself.setFieldPropertyValue("MAP_FECHA_NACIMIENTO","bgcolor","#D2D2D2");
            objself.setFieldPropertyValue("MAP_NACIONALIDAD","bgcolor","#D2D2D2");
            objself.setFieldPropertyValue("MAP_EDAD","bgcolor","#D2D2D2");
            objself.setFieldPropertyValue("MAP_SEXO","bgcolor","#D2D2D2");
            objself.setFieldPropertyValue("MAP_ESTADO_CIVIL","bgcolor","#D2D2D2");
            objself.setFieldPropertyValue("MAP_HIJOS","bgcolor","#D2D2D2");
            objself.setFieldPropertyValue("MAP_SITUACION_VEHICULO","bgcolor","#D2D2D2");
            objself.setFieldPropertyValue("MAP_COCHE_CUOTA","bgcolor","#D2D2D2");
            
            objself.setFieldPropertyValue("MAP_NIVEL_ACADEMICO","bgcolor","#D2D2D2");
            objself.setFieldPropertyValue("MAP_OCUPACION","bgcolor","#D2D2D2");
            objself.setFieldPropertyValue("MAP_TIPO_VIVIENDA","bgcolor","#D2D2D2");
            objself.setFieldPropertyValue("MAP_HIPOTECA","bgcolor","#D2D2D2");
            objself.setFieldPropertyValue("MAP_COCHE_MARCA","bgcolor","#D2D2D2");
            objself.setFieldPropertyValue("MAP_COCHE_MODELO","bgcolor","#D2D2D2");
            objself.MAP_GUARDAR_DATOS_CONTRATO3=0;
        }
        
    }
    else if(grupo==4){
        // Datos plan Alivia
        if(objself.MAP_EDITAR_DATOS_CONTRATO==4){
            objself.setFieldPropertyValue("MAP_INGRESOS_MENSUAL","bgcolor","#F2F2F2");
            objself.setFieldPropertyValue("MAP_CUOTA_ACTUAL","bgcolor","#F2F2F2");
            objself.setFieldPropertyValue("MAP_FECHA_CUOTA","bgcolor","#F2F2F2");
        }else{
            objself.setFieldPropertyValue("MAP_INGRESOS_MENSUAL","bgcolor","#D2D2D2");
            objself.setFieldPropertyValue("MAP_CUOTA_ACTUAL","bgcolor","#D2D2D2");
            objself.setFieldPropertyValue("MAP_FECHA_CUOTA","bgcolor","#D2D2D2");
            objself.MAP_GUARDAR_DATOS_CONTRATO4=0;
        }
    }
}

async function guardarDatosContrato(objself,grupo){
    let error="";
    
    // buscamos el estado actualizado del lead por si hubiera cambiado de etapa en la zona de usuario
    let collLead = appData.getCollection("ClienteScript");
    await filtrarCollMacroObject(collLead,"c.ID="+objself.ID);
    
    if (collLead.count()>0){
        let objLead = collLead.getItem(0);
        
        if(objself.IDESTADO != objLead.IDESTADO) {
            
            objself.IDESTADO = objLead.IDESTADO;
            
            var collEstado= appData.getCollection("Estados");
            await filtrarCollMacroObject(collEstado,"CODIGO="+objLead.IDESTADO);
            if(collEstado.count()>0){
                let Estado = collEstado.getItem(0);
                objself.MAP_ESTADO = Estado.NOMBRE;
            }
        }
    }
    // await objself.save();
    
    // Datos personales y de contacto
    if(grupo==1){
        
        
        // comprobamos si existe un usuario asociado al lead (se crea al mandar el plan de liquidación) y le actualizamos los datos
        try {
            await actualizarDatosUsuario(objself);
        } catch(e) {
            ui.showToast("error actualizando datos personales (móvil y/o correo)");
        }
            // Actualizamos el lead
            objself.NOMBRE=objself.MAP_NOMBRE.charAt(0).toUpperCase()+objself.MAP_NOMBRE.slice(1).toLowerCase();
            objself.APELLIDOS=objself.MAP_APELLIDOS.charAt(0).toUpperCase()+objself.MAP_APELLIDOS.slice(1).toLowerCase();
            objself.PREFIJO = objself.MAP_PREFIJO;
            objself.MOVIL2=objself.MAP_MOVIL2;
            objself.MOVIL2_NOMBRE=objself.MAP_MOVIL2_NOMBRE;
            objself.MOVIL3=objself.MAP_MOVIL3;
            objself.MOVIL3_NOMBRE=objself.MAP_MOVIL3_NOMBRE;
            objself.DNI=objself.MAP_DNI;
            await objself.save();
            ui.showToast("Datos personales y de contacto guardados");
            
            // asignamos valores guardados a otros props en pantalla
            objself.MAP_NOMBRE_COMPLETO=objself.NOMBRE+" "+objself.APELLIDOS;
    }
    // Dirección
    else if(grupo==2){
        if(!isNumber(objself.MAP_CP)){
            error= error +"El código postal debe ser numérico. ";
        }
        if(error==""){
            objself.CALLE=objself.MAP_CALLE;
            objself.NUMCALLE=objself.MAP_NUMCALLE;
            objself.NUMPISO=objself.MAP_NUMPISO;
            objself.LOCALIDAD=objself.MAP_LOCALIDAD;
            objself.CP=objself.MAP_CP;
            await objself.save();
            ui.showToast("Datos de lugar de residencia guardados");
        }else{
            await ui.msgBox(error,"Datos lugar de residencia",0);
            return;
        }
    }
    // Datos demográficos
    else if(grupo==3){
        if(objself.MAP_EDAD<0){
            error= error +"La edad debe ser mayor a cero. ";
        }
        if((objself.MAP_SITUACION_VEHICULO!=="No tiene" && objself.MAP_SITUACION_VEHICULO!=="Ya pagado" && objself.MAP_SITUACION_VEHICULO!=="") && objself.MAP_COCHE_CUOTA==0){
            error= error +"Debe indicar una cuota para el coche. ";
        }
        if((objself.MAP_TIPO_VIVIENDA!=="Ya pagada" && objself.MAP_TIPO_VIVIENDA!=="No paga vivienda" && objself.MAP_TIPO_VIVIENDA!=="") && objself.MAP_HIPOTECA==0){
            error= error +"Debe indicar una hipoteca para la vivienda. ";
        }
        if(error==""){
            objself.FECHA_NACIMIENTO=objself.MAP_FECHA_NACIMIENTO;
            objself.NACIONALIDAD=objself.MAP_NACIONALIDAD;
            objself.EDAD=objself.MAP_EDAD;
            objself.SEXO=objself.MAP_SEXO;
            // objself.ESTADO_CIVIL=objself.MAP_ESTADO_CIVIL;
            objself.HIJOS=objself.MAP_HIJOS;
            objself.COCHE_CUOTA=objself.MAP_COCHE_CUOTA;
            objself.SITUACION_VEHICULO=objself.MAP_SITUACION_VEHICULO;
            objself.NIVEL_ACADEMICO=objself.MAP_NIVEL_ACADEMICO;
            objself.OCUPACION=objself.MAP_OCUPACION;
            objself.TIPO_VIVIENDA=objself.MAP_TIPO_VIVIENDA;
            objself.HIPOTECA=objself.MAP_HIPOTECA;
            objself.COCHE_MARCA=objself.MAP_COCHE_MARCA;
            objself.COCHE_MODELO=objself.MAP_COCHE_MODELO;
            await objself.save();
            ui.showToast("Datos demográficos guardados");
        }else{
            await ui.msgBox(error,"Datos demográficos",0);
            return;
        }
    }
    // Datos plan Alivia
    else if(grupo==4){
        if(!isNumber(objself.MAP_INGRESOS_MENSUAL) && objself.MAP_INGRESOS_MENSUAL<=0){
            error= error +"El ingreso mensual debe ser numérico y mayor que cero. ";
        }
        if(error==""){
            objself.INGRESOS_MENSUAL=objself.MAP_INGRESOS_MENSUAL;
            objself.CUOTA_ACTUAL_REPAGO=objself.MAP_CUOTA_ACTUAL;
            objself.CUOTA_ALIVIA=objself.MAP_CUOTA_ALIVIA;
            objself.DEUDA_TOTAL_CALCULO=objself.MAP_DEUDA_TOTAL_CALCULO;
            objself.FECHA_CUOTA=objself.MAP_FECHA_CUOTA;
            await objself.save();
            ui.showToast("Datos plan Alivia guardados");
        }else{
            await ui.msgBox(error,"Datos plan Alivia",0);
            return;
        }
    }
    objself.MAP_EDITAR_DATOS_CONTRATO=0;
    activarEdicionDatosContrato(objself,grupo);
}

//  Para actualizar el correo del usuario en mailchimp cuando lo cambiamos en el crm
async function actualizarCorreoMailchimp(objself, objUsuario){
    callApiPost(objself,"Mailchimp/updatemail","",
    {
        oldemail: objself.CORREO,
        email: objself.MAP_CORREO
    }
    ,user.MAP_TOKEN,
    function(objself, data){
        // Tras actualizarse correctamente el correo en mailchimp, lo actualizamos en gen_usuarios
        ui.showToast("Correo actualizado en Mailchimp");
        objUsuario.LOGIN = objself.MAP_CORREO;
        objUsuario.CORREO = objself.MAP_CORREO;
        objUsuario.save();
        
        // actualizamos en el lead/cliente
        objself.CORREO = objself.MAP_CORREO;
        objself.save();
        
        objself.MAP_CORREO_CABECERA = objself.CORREO;
    },
    function(objself,data){
        ui.showToast("se ha producido un error intentando actualizar el correo en el sistema Mailchimp. No se han guardado lo cambios en la dirección de correo");
        objself.MAP_CORREO = objself.CORREO;
    });
}

async function actualizarDatosUsuario(objself) {
    // actualizamos nombre, apellidos, correo y teléfono al cambiar datos del lead/cliente en el usuario, si existe
    let objUsuario = await obtenerPrimerObjetoColl("UsuariosScript","u.CORREO ='"+objself.CORREO+"' OR u.MOVIL="+objself.MOVIL);
    
    if(objUsuario){

        objUsuario.NOMBRE = objself.MAP_NOMBRE.charAt(0).toUpperCase()+objself.MAP_NOMBRE.slice(1).toLowerCase();
        objUsuario.APELLIDOS = objself.MAP_APELLIDOS.charAt(0).toUpperCase()+objself.MAP_APELLIDOS.slice(1).toLowerCase();
        
        // Si cambia el teléfono, lo actualizamos
        if(objself.MOVIL != objself.MAP_MOVIL){
            objUsuario.MOVIL = objself.MAP_MOVIL;
            objself.MOVIL = objself.MAP_MOVIL;
            objself.MAP_MOVIL_CABECERA = objself.MOVIL;
        }
        await objUsuario.save();
        
        if(objself.CORREO != objself.MAP_CORREO){
            // Si cambia el correo, lo actualizamos en mailchimp y si da ok, en el usuario y cliente
            ui.showToast("Actualizando correo en mailchimp...");
            try {
                await actualizarCorreoMailchimp(objself, objUsuario);
                
            }catch(e){
                ui.showToast("Error al actualizar en mailchimp");
            }
        }
        
    } else {
        // si no existe el cliente, podemos actualizarle el correo y teléfono sin problemas
        objself.MOVIL = objself.MAP_MOVIL;
        objself.CORREO = objself.MAP_CORREO;
        
        objself.MAP_MOVIL_CABECERA = objself.MOVIL;
        objself.MAP_CORREO_CABECERA = objself.CORREO;
    }
}

// FUNCIÓN DE CALCULADORA
async function calcular(objself){
    var objSim, objSimDeuda;
    let duracion=0;
    var collDeuda = "";
    
    // en caso de un cliente la simulación será un addendum
    if(objself.IDESTADO==10){
        collDeuda = appData.getCollection("DeudaClienteAddendumScript");
        await filtrarCollMacroObject(collDeuda,"d.IDLEAD="+objself.ID+" AND ifnull(d.BAJA,0)=0 AND d.APLICA_PL=1 AND IFNULL(d.ADDENDUM_REALIZADO,0)=0");
        collDeuda.setSort("d.IMPORTE_ACTUAL ASC");
        // collDeuda.setFilter("d.IDLEAD="+self.ID+" AND ifnull(d.BAJA,0)=0 AND d.APLICA_PL=1 AND IFNULL(d.ADDENDUM_REALIZADO,0)=0");
    }else{
        collDeuda = appData.getCollection("DeudaScript");
        await filtrarCollMacroObject(collDeuda,"d.IDLEAD="+objself.ID+" AND ifnull(d.BAJA,0)=0 AND d.APLICA_PL=1");
        collDeuda.setSort("d.IMPORTE_ACTUAL ASC");
        // collDeuda.setFilter("d.IDLEAD="+self.ID+" AND d.BAJA=0 AND d.APLICA_PL=1");
        // await collDeuda.loadAll();
    }
    
    // comprobamos que la deuda de importe más bajo sea de tipo DC (la primera que encontremos que aplica_PL=1 ya que el content está ordenado por importe asc)
    // if(collDeuda.getItem(0).IDPRODUCTO_FINANCIERO!==1){
    //     await ui.msgBox("La deuda de importe más bajo que aplica en PL debe ser de tipo DC.","Tipo producto Alivia deuda de menor importe",0);
    //     return;
    // }
    if(safeToInt(objself.MAP_CUOTA_SEL)==0){
        await ui.msgBox("Debe seleccionar una cuota Alivia","Falta cuota",0);
        return;
    }
    
    // Creamos una simulación
    var cnt = await objself.getContents("Simulaciones");
    objSim = await cnt.createObject();
    var collOrigen = appData.getCollection("OrigenLeadScript");
    await filtrarCollMacroObject(collOrigen,"CODIGO=4");
    
    
    objSim.IDLEAD = objself.ID;
    objSim.IDUSUARIO = user.ID;
    objSim.FECHA = ObtenerFechaHoraActual();
    if(collOrigen.count()>0){
        let objOrigen = collOrigen.getItem(0);    
        
        objSim.ORIGEN = objOrigen.ORIGEN;
        objSim.IDORIGEN = objOrigen.CODIGO;
    }
    objSim.INGRESO_MENSUAL = objself.INGRESOS_MENSUAL;
    objSim.DEUDA_TOTAL = objself.MAP_DEUDA_TOTAL.substring(0,objself.MAP_DEUDA_TOTAL.length-2);
    objSim.CUOTA_ACTUAL_REPAGO = objself.MAP_CUOTA_ACTUAL;
    objSim.CUOTA_ALIVIA = objself.MAP_CUOTA_SEL;
    objSim.GRUPO_PAQUETE_COMISION = objself.MAP_IDGRUPO_PAQUETE_COMISION;
    // en caso de un cliente la simulación será un addendum
    if(objself.IDESTADO == 10){
        objSim.ADDENDUM = 1;
    }else{
        objSim.ADDENDUM = 0;
    }
    
    await objSim.save();
    
    // Asignamos la simulacion actual para filtrar el content de simulacionesdeudas
    objself.MAP_IDSIMULACION_SEL = objSim.ID;
    // objself.MAP_IDSIMULACION_SEL=20;
    
    // Creamos todas las deudas para la simulación actual y el mes más longevo
    var cnt2 = await objself.getContents("SimulacionesDeuda");
    for(var i=0;i<collDeuda.count();i++){
        let deudaSim= collDeuda.getItem(i);
        objSimDeuda = await cnt2.createObject();

        objSimDeuda.IDSIMULACION = objSim.ID;
        objSimDeuda.IDLEAD = objself.ID;
        objSimDeuda.IDDEUDA = deudaSim.ID;
        objSimDeuda.IDENTIDAD = deudaSim.IDENTIDAD;
        objSimDeuda.IDTIPO_PRODUCTO = deudaSim.IDTIPO_PRODUCTO;
        objSimDeuda.FECHA_CONTRATACION = deudaSim.FECHA_CONTRATACION;
        objSimDeuda.FECHA_ULT_PAGO = deudaSim.FECHA_ULT_PAGO;
        objSimDeuda.IMPORTE_ACTUAL = deudaSim.IMPORTE_ACTUAL;
        objSimDeuda.IDPRODUCTO_FINANCIERO = deudaSim.IDPRODUCTO_FINANCIERO;
        // para productos==1 DC mandamos el campo a nulo
        if(deudaSim.IDPRODUCTO_FINANCIERO!==1){
            objSimDeuda.MES_OTORGAMIENTO = deudaSim.MES_OTORGAMIENTO;
        }
        
        if(duracion==0){
            duracion=deudaSim.MES_OTORGAMIENTO;
        }else{
            if(deudaSim.MES_OTORGAMIENTO>duracion){
                duracion=deudaSim.MES_OTORGAMIENTO;
            }
        }
        
        // guardamos los campos nuevos de la deuda 01-06-26
        objSimDeuda.FECHA_ACTUALIZACION = deudaSim.FECHA_ACTUALIZACION;
        objSimDeuda.SITUACION_DEUDA = deudaSim.SITUACION_DEUDA;
        objSimDeuda.NUM_CONTRATO = deudaSim.NUM_CONTRATO;
        objSimDeuda.NUM_TARJETA = deudaSim.NUM_TARJETA;
        objSimDeuda.CAPITAL_PRESTADO = deudaSim.CAPITAL_PRESTADO;
        objSimDeuda.DEUDA_TOTAL_ORIGINAL = deudaSim.DEUDA_TOTAL_ORIGINAL;
        objSimDeuda.NUM_REFERENCIA = deudaSim.NUM_REFERENCIA;
        objSimDeuda.INTERESES_ORIGINALES = deudaSim.INTERESES_ORIGINALES;
        objSimDeuda.CUOTA_MENSUAL_ORIGINAL = deudaSim.CUOTA_MENSUAL_ORIGINAL;
        objSimDeuda.MESES_ORIGINAL = deudaSim.MESES_ORIGINAL;
        objSimDeuda.TIN = deudaSim.TIN;
        objSimDeuda.TAE = deudaSim.TAE;
        objSimDeuda.MESES_RESTANTES = deudaSim.MESES_RESTANTES;
        objSimDeuda.FECHA_VENCIMIENTO = deudaSim.FECHA_VENCIMIENTO;
        objSimDeuda.NUM_AUTOS = deudaSim.NUM_AUTOS;
        objSimDeuda.OBSERVACIONES_MOTIVO = deudaSim.OBSERVACIONES_MOTIVO;
        objSimDeuda.ID_TITULARES = deudaSim.ID_TITULARES;
        objSimDeuda.ID_PROCEDENCIA_DEUDA = deudaSim.ID_PROCEDENCIA_DEUDA;
        objSimDeuda.ID_CREDITO_PRIVILEGIO = deudaSim.ID_CREDITO_PRIVILEGIO;
        objSimDeuda.ID_VENCIMIENTO_CONTRATO = deudaSim.ID_VENCIMIENTO_CONTRATO;
        objSimDeuda.ID_RECLAMACION_JUDICIAL = deudaSim.ID_RECLAMACION_JUDICIAL;
        objSimDeuda.ID_JUZGADO = deudaSim.ID_JUZGADO;
        objSimDeuda.ID_PROCEDIMIENTO = deudaSim.ID_PROCEDIMIENTO;
        objSimDeuda.ID_MOTIVO_PRESTAMO = deudaSim.ID_MOTIVO_PRESTAMO;
        objSimDeuda.ID_ESTA_EN_MOROSO = deudaSim.ID_ESTA_EN_MOROSO;
        
        await objSimDeuda.save();
    }
    // guardamos la duración de la simulación
    objSim.DURACION = duracion;
    await objSim.save();
    
    // llamamos a la calculadora de la api
    calculadoraPL(objself,objSim.ID);
    // calculadoraPL(objself,20);
}

async function cargarDocumento(objself,campo){
    // función para cargar un documento que vamos a subir posteriormente
    var campo_TEMP = "";
    var jsParams = {  
        targetProperty : campo_TEMP,
        fileTypes : "pdf,docx,png,jpg,jpeg"
        };
        
    const file = await ui.pickFile(jsParams);
    if(campo) {
        objself[campo] = file.name;
    }
    objself.getOwnerCollection().setVariables("File", file);
}

function quitarDocumento(objself,campo){
    // función para quiar el documento que teníamos cargado para subirse posteriormente
    if(objself.getOwnerCollection().getVariables("File") !== null){
        objself.getOwnerCollection().setVariables("File",null);
        if(campo) {
            objself[campo] = "";
        }
    }
}
// !!!
async function comprobarDocumento(objself, nombreDocumento, rowidlead) {
    // función para comprobar que el documento está adjunto correctamente
    let fileName = "";
    let file = objself.getOwnerCollection().getVariables("File");
    var collDoc = appData.getCollection("DocumentoScript");
    
    if(isNothing(file)){
        await ui.msgBox("Debe adjuntar el documento que quiere subir","Falta documento",0);
        return false;
    }
    if(isNullOrEmpty(nombreDocumento)){
        await ui.msgBox("Debe adjuntar el documento que quiere subir","Falta documento",0);
        return false;
    }
    
    if(isNullOrEmpty(nombreDocumento) === false){
        fileName = nombreDocumento;
    }
    
    //  Comprobamos si para este cliente existe un documento con el mismo nombre
    if(fileName !== ""){
        await filtrarCollMacroObject(collDoc,"d.BAJA=0 AND d.DOCUMENTO='"+fileName+"' AND d.ROWID_LEAD='"+rowidlead+"'");
    }else{
        await filtrarCollMacroObject(collDoc,"d.BAJA=0 AND d.DOCUMENTO='"+file.name+"' AND d.ROWID_LEAD='"+rowidlead+"'");
    }
    
    if(collDoc.count() > 0){
        await ui.msgBox("Ya existe un documento con el nombre indicado. Especifique otro distinto.","Archivo duplicado",0);
        return false;
    }
    
    return true;
}

async function comprobarDocumentoLSO(objself, nombreDocumento, rowidProcesoLSO) {
    // función para comprobar que el documento está adjunto correctamente
    let fileName = "";
    let file = objself.getOwnerCollection().getVariables("File");
    var collDoc = appData.getCollection("DocumentoScript");
    
    if(isNothing(file)){
        await ui.msgBox("Debe adjuntar el documento que quiere subir","Falta documento",0);
        return false;
    }
    if(isNullOrEmpty(nombreDocumento)){
        await ui.msgBox("Debe adjuntar el documento que quiere subir","Falta documento",0);
        return false;
    }
    
    if(isNullOrEmpty(nombreDocumento) === false){
        fileName = nombreDocumento;
    }
    
    //  Comprobamos si para este cliente existe un documento con el mismo nombre
    if(fileName !== ""){
        await filtrarCollMacroObject(collDoc,"d.BAJA=0 AND d.DOCUMENTO='"+fileName+"' AND d.ROWID_PROCESO_LSO='"+rowidProcesoLSO+"'");
    }else{
        await filtrarCollMacroObject(collDoc,"d.BAJA=0 AND d.DOCUMENTO='"+file.name+"' AND d.ROWID_PROCESO_LSO='"+rowidProcesoLSO+"'");
    }
    
    if(collDoc.count() > 0){
        await ui.msgBox("Ya existe un documento con el nombre indicado. Especifique otro distinto.","Archivo duplicado",0);
        return false;
    }
    
    return true;
}


async function adjuntarDocumento(objself,tipo,campo,guardarDocDeuda,tipodoc){
    var campo_TEMP = "";
    var jsParams = {  
        targetProperty : campo_TEMP,
        fileTypes : "pdf,docx,png,jpg,jpeg"
        };
        
    const file = await ui.pickFile(jsParams);
    objself[campo]=file.name;
    objself.getOwnerCollection().setVariables("File", file);
    
    if(tipo=="compr"){
        objself.MAP_ANNADIR_COMPROBANTE=1;
    }
    else if(tipo=="anexo" || tipo=="anexoActividad"){
        objself.MAP_ANNADIR_ANEXO=1;
    }
    
      
    // si subimos directamente el documento en caso de deudas del programa clienteEdicion
    if(guardarDocDeuda == 1){
        await agregarDocumentoDeudaGuardar(objself,objself[campo],tipodoc,tipo,0,0);
    }
    // si subimos directamente el documento desde el listado de movimientos para justificantes de transferencia y devoluciones
    else if(guardarDocDeuda == 2){
        await agregarDocumentoDeudaGuardar(objself,objself[campo],tipodoc,tipo,objself.MES,1);
    }
}

function borrarDocAdjunto(objself,tipo,campo){
    if(objself.getOwnerCollection().getVariables("File") !== null){
        objself[campo]="";
        objself.getOwnerCollection().setVariables("File",null);
    
        // para casos concretos realizamos otras acciones
        if(tipo=="compr"){
            objself.MAP_ANNADIR_COMPROBANTE=0;
        }
        else if(tipo=="anexo" || tipo=="anexoActividad"){
            objself.MAP_ANNADIR_ANEXO=0;
        }
    }
}

async function agregarDocumentoGuardar(objself){
    
    // para guardar documentos en general desde el apartado documentos
    let fileName="";
    let file=objself.getOwnerCollection().getVariables("File");
    var coll = appData.getCollection("DocumentoScript");
    var objDoc;
    
    if(safeToInt(objself.MAP_IDTIPO_DOC)==0){
        await ui.msgBox("Debe seleccionar el tipo de documento","Falta tipo",0);
        return;
    }
    if(isNothing(file)){
        await ui.msgBox("Debe adjuntar el documento que quiere subir","Falta documento",0);
        return;
    }
    if(isNullOrEmpty(objself.MAP_DOC)){
        await ui.msgBox("Debe adjuntar el documento que quiere subir","Falta documento",0);
        return;
    }
    
    // Si se sube un contrato, comprobamos si ya hay uno subido que esté pendiente o aceptado
    if(safeToInt(objself.MAP_IDTIPO_DOC)==8){
        await filtrarCollMacroObject(coll,"d.BAJA=0 AND d.ROWID_LEAD='"+objself.ROWID+"' AND d.IDTIPO=8 AND d.ACEPTADO in(0,1)");
        
        if(coll.count()>0){
            objDoc=coll.getItem(0);
            
            if(objDoc.ACEPTADO==0){
                ui.showToast("Ya existe un contrato subido y pendiente de aceptación por parte del lead");
            }
            if(objDoc.ACEPTADO==1){
                ui.showToast("Ya existe un contrato subido y aceptado por el lead");
            }
            return;
        }
        if(isNullOrEmpty(objself.CONTRATO_NUMERO) || objself.CONTRATO_NUMERO==""){
            ui.showToast("Debe generar un contrato para el lead");
            return;
        }
    }
    
    
    if(isNullOrEmpty(objself.MAP_NOMBRE_DOC)==false){
        let regex = /(\.pdf)|(\.docx)|(\.png)|(\.jpg)/g;
        let extensionOriginal="";
        // let regex = /\.[a-zA-Z]+$/g;
        
        // match devuelve el propio valor si cumple la condición del regex. Si no cumple, devuelve vacío
        let extension = objself.MAP_NOMBRE_DOC.match(regex);
        if (!extension){
            // si el nuevo nombre del documento no tiene la extensión, la buscamos en el nombre original y la añadimos
            extensionOriginal = objself.MAP_DOC.match(regex);
            if(extensionOriginal){
                objself.MAP_NOMBRE_DOC=objself.MAP_NOMBRE_DOC+extensionOriginal;
            }
        }else{
            // si el nuevo nombre tiene la extensión puesta, comprobamos que coincide con la del nombre original del documento, si no, se lo ponemos
            extensionOriginal = objself.MAP_DOC.match(regex);
            if(extensionOriginal){
                if(extension[0]!==extensionOriginal[0]){
                    objself.MAP_NOMBRE_DOC=objself.MAP_NOMBRE_DOC.replace(extension,extensionOriginal);
                }    
            }
        }
        fileName=objself.MAP_NOMBRE_DOC;
    }
    
    //  Comprobamos si para este lead existe un documento con el mismo nombre
    if(fileName!==""){
        await filtrarCollMacroObject(coll,"d.BAJA=0 AND d.ROWID_LEAD='"+objself.ROWID+"' AND d.DOCUMENTO='"+fileName+"'");
    }else{
        await filtrarCollMacroObject(coll,"d.BAJA=0 AND d.ROWID_LEAD='"+objself.ROWID+"' AND d.DOCUMENTO='"+file.name+"'");
    }
    if(coll.count()>0){
        await ui.msgBox("Ya existe un documento con el nombre indicado. Especifique otro distinto.","Archivo duplicado",0);
        return;
    }
    
    // Subimos los archivos. Sólo para casos de deudas con productos de interposición de demanda (4) en su etapa 1: recopilación documentación, mandamos el iddeudacliente para asociarlo
    if(objself.MAP_IDDEUDA > 0 && objself.MAP_IDPRODUCTO == 4 && objself.MAP_IDESTADO_DEUDA == 1){
        await uploadFiles(objself, file, fileName, objself.MAP_IDTIPO_DOC, objself.CORREO, user.CORREO, user.LOGIN, "doc",objself.ROWID,0,objself.MAP_IDDEUDA);
    }else{
        await uploadFiles(objself, file, fileName, objself.MAP_IDTIPO_DOC, objself.CORREO, user.CORREO, user.LOGIN, "doc",objself.ROWID);
    }
}

function verDocumento(objself,propDocumento){
    let documento="";
    documento=objself[propDocumento];
            
    // vemos el documento subido 
    downloadDocumentAsyncPDF(objself,objself.ROWID,documento,objself.CORREO,
    function(data)
    {
        if(documento.includes(".pdf")==true){
            ui.openUrl(data);
        }else{
            var link = document.createElement("a");
            link.download = documento;
            link.href = data;
            link.click();
        }
    });
}

async function crearEquipoGuardar(objself, tipo){
    let usuarioCambio="";
    var objEq;
    var collUsu = appData.getCollection("UsuariosScript");
    var coll= appData.getCollection("EquiposScript");
    
    if(isNullOrEmpty(objself.MAP_NOMBRE_EQUIPO)){
        await ui.msgBox("Debe indicar un nombre para el equipo","Falta nombre",0);
        return;
    }
    if(safeToInt(objself.MAP_IDLIDER1)==0){
        await ui.msgBox("Debe indicar el un líder para el equipo","Falta líder",0);
        return;
    }
    if(safeToInt(objself.MAP_ID_TIPO_USUARIO_EQUIPO)<=0){
        await ui.msgBox("Debe indicar el tipo de usuarios para el equipo","Falta tipo",0);
        return;
    }
    
    await filtrarCollMacroObject(coll,"e.ID!="+objself.MAP_IDEQUIPO+" and e.Nombre='"+objself.MAP_NOMBRE_EQUIPO+"'");
    
    if(coll.count()>0){
        await ui.msgBox("Ya existe un equipo con este nombre","Nombre equipo repetido",0);
        return;
    }
    
    // comprobamos si hay usuarios con cambio de equipo
    let cntUsu=await self.getContents("UsuariosCrearEquipoContent");
    for(var i=0;i<cntUsu.count();i++){
        let obj=cntUsu.getItem(i);
        if(obj.MAP_CHECK==1 && obj.IDEQUIPO>0){
            if(usuarioCambio==""){
                usuarioCambio = obj.MAP_CORREO;
            }else{
                usuarioCambio = usuarioCambio+", "+obj.MAP_CORREO;
            }
        }
    }

    // Si hay usuarios para cambiar preguntamos. Si quiere continuar, guardamos
    if(usuarioCambio!==""){
        let pregunta = await ui.msgBox("Los siguientes usuarios tienen equipo asignado, ¿desea continuar y reemplazarlo?: "+usuarioCambio,"Reemplazo equipo",1);
        if(pregunta==2){
            return;
        }
    }
    // comprobamos si estamos editando un equipo existente
    if(self.MAP_IDEQUIPO>0){
        await filtrarCollMacroObject(coll,"e.ID="+self.MAP_IDEQUIPO);
        
        if(coll.count()>0){
            objEq = coll.getItem(0);
            
            // comprobamos si hemos cambiado el tipo de usuarios del equipo
            if(self.MAP_ID_TIPO_USUARIO_EQUIPO!==objEq.USERTYPE){
                let pregunta2 = await ui.msgBox("Va a cambiar el tipo de usuario del equipo de "+objEq.MAP_DESCRIPCION+" a "+self.MAP_TIPO_USUARIO_EQUIPO+", los usuarios de tipo "+objEq.MAP_DESCRIPCION+" quedarán sin equipo ¿desea continuar?","Cambio tipo usuario equipo "+objEq.NOMBRE,1);
                if(pregunta2==1){
                    
                    await filtrarCollMacroObject(collUsu,"u.IDEQUIPO="+objEq.ID+" AND u.ID!="+objself.MAP_IDLIDER1);
                    
                    // desmarcamos los usuarios con el tipo original menos el líder (no pueden mezclarse tipos de usuarios en un mismo equipo)
                    for(var j=0;j<collUsu.count();j++){
                        let obj=collUsu.getItem(j);
                        if(obj.IDEQUIPO==objEq.ID){
                            obj.IDEQUIPO=0;
                            obj.IDLIDER=0;
                            await obj.save();
                        }
                    }
                    
                    // asignamos los nuevos usuarios
                    for(var j=0;j<cntUsu.count();j++){
                        let obj=cntUsu.getItem(j);
                        if(obj.MAP_CHECK==1){
                            obj.IDEQUIPO=objEq.ID;
                            obj.IDLIDER=objself.MAP_IDLIDER1;
                            await obj.save();
                        }
                    }
                    // asignamos el líder al equipo
                    await filtrarCollMacroObject(collUsu,"u.ID="+objself.MAP_IDLIDER1);
                    
                    let objUsulider = collUsu.getItem(0);
                    objUsulider.IDEQUIPO=objEq.ID;
                    await objUsulider.save();
                }else{
                    return;
                }
            }else{
                // El tipo de usuario del equipo no ha cambiado
                // asignamos los nuevos usuarios
                for(var j=0;j<cntUsu.count();j++){
                    let obj=cntUsu.getItem(j);
                    if(obj.MAP_CHECK==1){
                        obj.IDEQUIPO=objEq.ID;
                        obj.IDLIDER=objself.MAP_IDLIDER1;
                        await obj.save();
                    }
                }
                // asignamos el líder al equipo
                await filtrarCollMacroObject(collUsu,"u.ID="+objself.MAP_IDLIDER1);
                
                if(collUsu.count()>0){
                    let objUsulider = collUsu.getItem(0);
                    
                    objUsulider.IDEQUIPO=objEq.ID;
                    await objUsulider.save();
                }    
            }
            
            // actualizamos los datos del equipo
            objEq.NOMBRE=objself.MAP_NOMBRE_EQUIPO;
            objEq.IDLIDER=objself.MAP_IDLIDER1;
            objEq.USERTYPE=objself.MAP_ID_TIPO_USUARIO_EQUIPO;
            objEq.BAJA=0;
            await objEq.save();
        }
    }else{
        // crear equipo y asignar usuarios
        objEq= await coll.createObject();
        objEq.NOMBRE=objself.MAP_NOMBRE_EQUIPO;
        objEq.IDLIDER=objself.MAP_IDLIDER1;
        objEq.USERTYPE=objself.MAP_ID_TIPO_USUARIO_EQUIPO;
        objEq.BAJA=0;
        await objEq.save();
        
        for(var j=0;j<cntUsu.count();j++){
            let obj=cntUsu.getItem(j);
            if(obj.MAP_CHECK==1){
                obj.IDEQUIPO=objEq.ID;
                obj.IDLIDER=objself.MAP_IDLIDER1;
                await obj.save();
            }
        }
        
        // asignamos el líder al equipo
        await filtrarCollMacroObject(collUsu,"u.ID="+objself.MAP_IDLIDER1);
        
        if(collUsu.count()>0){
            let objUsulider = collUsu.getItem(0);
            
            objUsulider.IDEQUIPO=objEq.ID;
            await objUsulider.save();
        }
    }
    
    limpiarCampos(self,"agregarEquipo");
    objself.MAP_CREAR_EQUIPO=0;
    cntUsu.unlock();
    cntUsu.clear();
    await cntUsu.loadAll();
    cntUsu.lock();
    if(tipo==1){
        await actualizarDatosContent(self,"UsuariosContent");
    }else{
        await actualizarDatosContent(self,"UsuariosClienteContent");
    }
    ui.refresh("UsuariosCrearEquipoContent");
}

async function comprobarExisteUsuarioLead(padre){
    // comprobamos si existe un usuario asociado al lead al enviar el plan de liquidación a la zona usuario de la web
    var collUsu = appData.getCollection("UsuariosScript");
    await filtrarCollMacroObject(collUsu,"u.CORREO ='"+padre.CORREO+"' OR u.MOVIL="+padre.MOVIL);
    
    if(collUsu.count()>0){
        return true;
    }else{
        // creamos el usuario (zona web) para el lead si no existe
        await crearUsuarioLead(padre);
    }
}

async function pasarLeadPropuesta(objself){
    // al crear el usuario en await crearUsuarioLead() lo pasamos a etapa propuesta
    var collEstado= appData.getCollection("Estados");
    await filtrarCollMacroObject(collEstado,"CODIGO=7");

    if(collEstado.count()>0){
        let Estado = collEstado.getItem(0);
        
        await guardarHistoricoCambioEstado(objself,objself.IDESTADO,7);
        objself.IDESTADO=7;
        objself.MAP_ESTADO=Estado.NOMBRE;
        await objself.save();
        
        // enviamos mensaje al lead
        EnviarMensajeAivo(objself,"lead_propuesta",objself.MAP_MOVIL);
    }
}

async function actualizarDatosZonaUsuario(objself){
    // Al firmar el contrato en la zona usuario, recargamos la etapa del lead para obtener contrato firmado
    var obj;
    if(objself.IDESTADO==8){
        var coll = appData.getCollection("ClienteScript");
        await filtrarCollMacroObject(coll,"c.ID="+objself.ID);
        
        if(coll.count()>0){
            obj = coll.getItem(0);
            
            objself.IDESTADO = obj.IDESTADO;
            await objself.save();
        }
        
        // asignamos el nombre de la etapa
        var collEstado= appData.getCollection("Estados");
        await filtrarCollMacroObject(collEstado,"CODIGO="+obj.IDESTADO);

        if(collEstado.count()>0){
            let Estado = collEstado.getItem(0);
            objself.MAP_ESTADO = Estado.NOMBRE;
        }
    }
    
    // comprobamos si ha seleccionado un plan de liquidación aceptado para asignarlo y bloquear su edición en pantalla
    await asignarPaquetePlanLiquidacion(objself);
}

async function comprobarCheckContrato(objself){
    let enviarContrato=0;
    
    // si el lead ya está en la etapa contrato, omitimos las comprobaciones
    let collLead = appData.getCollection("ClienteScript");
    await filtrarCollMacroObject(collLead,"c.ID="+objself.ID);
    
    if (collLead.count()>0){
        let objLead = collLead.getItem(0);
        
        if(objself.IDESTADO != objLead.IDESTADO) {
            
            objself.IDESTADO = objLead.IDESTADO;
            
            var collEstado= appData.getCollection("Estados");
            await filtrarCollMacroObject(collEstado,"CODIGO="+objLead.IDESTADO);
            if(collEstado.count()>0){
                let Estado = collEstado.getItem(0);
                objself.MAP_ESTADO = Estado.NOMBRE;
            }
            await objself.save();
        }
    }
    
    if(objself.IDESTADO == 8){
        return;
    }

    // Compobamos que están todos los comprobantes de las deudas activas en el plan elegido
    if(await comprobarCheck2(objself)==1){
        objself.MAP_CHECK_CONTRATO2=1;
        enviarContrato=enviarContrato+1;
    }else{
        objself.MAP_CHECK_CONTRATO2=0;
    }
    // Compobamos que está seleccionado un plan de liquidación
    if(await comprobarCheck3(objself)==1){
        objself.MAP_CHECK_CONTRATO3=1;
        enviarContrato=enviarContrato+1;
    }else{
        objself.MAP_CHECK_CONTRATO3=0;
    }
    // Compobamos que están todos los datos del contrato rellenos
    if(comprobarCheck4(objself)==1){
        objself.MAP_CHECK_CONTRATO4 = 1;
        enviarContrato = enviarContrato+1;
    }else{
        objself.MAP_CHECK_CONTRATO4 = 0;
    }
    // Compobamos que están todos los documentos adjuntos (dni + comprobantes)
    if(await comprobarCheck5(objself)==1 && objself.MAP_CHECK_CONTRATO2 == 1){
        objself.MAP_CHECK_CONTRATO5=1;
        enviarContrato=enviarContrato+1;
    }else{
        objself.MAP_CHECK_CONTRATO5=0;
    }
    // Si están todos los checks marcados y el cliente se encuentra por debajo de la etapa 'contrato firmado', mostramos el botón de enviar contrato
    if(enviarContrato==4 && objself.IDESTADO<=8){
        objself.MAP_ENVIAR_CONTRATO=1;
    }else{
        objself.MAP_ENVIAR_CONTRATO=0;
    }
}


function comprobarCheck1(objself){
    // Compobamos que están todos los datos generales rellenos
    let falta=0;
    // nombre,apellido,móvil,correo
    if(isNullOrEmpty(objself.NOMBRE) || isNullOrEmpty(objself.APELLIDOS) || isNullOrEmpty(safeToString(objself.MOVIL)) || isNullOrEmpty(objself.CORREO)){
        falta=falta+1;
    }
    // pitcher,comercial,líder
    if(isNullOrEmpty(objself.MAP_PITCHER) || isNullOrEmpty(objself.MAP_ARD) || isNullOrEmpty(objself.MAP_LIDER)){
        falta=falta+1;
    }
    // origen,fecha registro,fecha asignación
    if(isNullOrEmpty(objself.ORIGEN) || isNullOrEmpty(safeToString(objself.FECHA_REGISTRO)) || isNullOrEmpty(safeToString(objself.FECHA_ASIGNACION))){
        falta=falta+1;
    }
    if(falta>0){
        return 0;
    }else{
        return 1;
    }
}

async function comprobarCheck2(objself){
    // Compobamos que están todos los comprobantes de las deudas activas en el plan elegido
    let falta=0;
    let idSimulacion=0;
    var objSimDeuda, objDeuda;
    let comprobantesDeudasFaltantes = [];

    // Comprobar si hay un plan seleccionado
    await actualizarDatosContent(objself,"PlanesLiquidacion");
    let cntPLan = await objself.getContents("PlanesLiquidacion");
    for(var i=0;i<cntPLan.count();i++){
        let objPlan = cntPLan.getItem(i);
        if(objPlan.PLAN_ELEGIDO==1){
            idSimulacion=objPlan.IDSIMULACION;
            break;
        }
    }
    
    if(idSimulacion>0){
        // a través del plan elegido, buscamos las deudas asociadas a la simulación del plan
        var collDeuda = appData.getCollection("DeudaScript");
        var collDoc = appData.getCollection("DocumentoScript");
        let collSimDeuda = appData.getCollection("SimulacionesDeudaScript");
        await filtrarCollMacroObject(collSimDeuda,"sd.IDSIMULACION="+idSimulacion);
        
        // recorremos las deudas de la simulación y miramos si tienen documentos
        if(collSimDeuda.count()>0){
            for(var j=0;j<collSimDeuda.count();j++){
                objSimDeuda = collSimDeuda.getItem(j);
                if(objSimDeuda){
                    await filtrarCollMacroObject(collDeuda,"d.IDLEAD = "+objself.ID+" AND d.ID="+objSimDeuda.IDDEUDA);
                    
                    if(collDeuda.count()>0){
                        objDeuda = collDeuda.getItem(0);
                        
                        // busco documento asociado a la deuda que participa en la simulación. Si no existe, indicamos que falta
                        await filtrarCollMacroObject(collDoc,"ifnull(d.BAJA,0)=0 AND d.ROWID_LEAD = '"+objself.ROWID+"' AND d.IDDEUDA="+objDeuda.ID+" AND d.IDTIPO=5");
                        
                
                        if(collDoc.count()==0){
                            falta=falta+1;
                            comprobantesDeudasFaltantes.push(objDeuda.MAP_NOMBRE_ENTIDAD + " - " + objDeuda.IMPORTE_ACTUAL + "€");
                        }
                    }else{
                        falta=falta+1;
                    }
                }else{
                    falta=falta+1;
                }
            }
        }else{
            ui.showToast("No se encuentran las deudas asociadas al plan de liquidación seleccionado");
            falta=falta+1;
        }
    }else{
        return 0;
    }
    
    if(falta > 0){
        // mostramos el mensaje sólo si está en la etapa de propuesta
        if(objself.IDESTADO == 7) {
            await ui.msgBox("faltan comprobantes en las siguientes deudas: " + comprobantesDeudasFaltantes.join(', '),"Checks para generación de contrato",0);
        }
        return 0;
    }else{
        return 1;
    }
}
async function comprobarCheck3(objself){
    // Compobamos que está seleccionado un plan de liquidación
    var falta=0;

    let cntPlan = await objself.getContents("PlanesLiquidacion");

    if(cntPlan.count()>0){
        for(var i=0;i<cntPlan.count();i++){
            let objPlan =cntPlan.getItem(i);
            if(objPlan.PLAN_ELEGIDO==1){
                // guardamos los datos en el lead
                objself.MAP_DEUDA_TOTAL_CALCULO=objPlan.DEUDA_TOTAL.toFixed(2);
                objself.MAP_CUOTA_ALIVIA=objPlan.CUOTA_ALIVIA;
                objself.DEUDA_TOTAL_CALCULO=objPlan.DEUDA_TOTAL.toFixed(2);
                objself.CUOTA_ALIVIA=objPlan.CUOTA_ALIVIA;
                await objself.save();
                falta=0;
                break;
            }else{
                falta=falta+1;
                // borramos los datos en el lead
                objself.MAP_DEUDA_TOTAL_CALCULO=0;
                objself.MAP_CUOTA_ALIVIA=0;
                objself.DEUDA_TOTAL_CALCULO=0;
                objself.CUOTA_ALIVIA=0;
                await objself.save();
            }
        }
        // if(objPlan){
        //     // guardamos los datos en el lead
        //     objself.MAP_DEUDA_TOTAL_CALCULO=objPlan.DEUDA_TOTAL.toFixed(2);
        //     objself.MAP_CUOTA_ALIVIA=objPlan.CUOTA_ALIVIA;
        //     objself.DEUDA_TOTAL_CALCULO=objPlan.DEUDA_TOTAL.toFixed(2);
        //     objself.CUOTA_ALIVIA=objPlan.CUOTA_ALIVIA;
        //     await objself.save();
        // }else{
        //     falta=falta+1;
        //     // borramos los datos en el lead
        //     objself.MAP_DEUDA_TOTAL_CALCULO=0;
        //     objself.MAP_CUOTA_ALIVIA=0;
        //     objself.DEUDA_TOTAL_CALCULO=0;
        //     objself.CUOTA_ALIVIA=0;
        //     await objself.save();
        // }
        
        if(falta>0){
            return 0;
        }else{
            return 1;
        }
    }else{
        return 0;
    }
}
function comprobarCheck4(objself){
    // Compobamos que están todos los datos del contrato rellenos
    let falta=0;
    // nombre,apellido,móvil,correo
    if(isNullOrEmpty(objself.NOMBRE) || isNullOrEmpty(objself.APELLIDOS) || isNullOrEmpty(safeToString(objself.MOVIL)) || isNullOrEmpty(objself.CORREO)){
        falta=falta+1;
    }
    // calle,numcalle,numpiso,localidad,CP
    // || isNullOrEmpty(objself.NUMCALLE) || isNullOrEmpty(objself.NUMPISO)
    if(isNullOrEmpty(objself.CALLE) || isNullOrEmpty(objself.LOCALIDAD) || isNullOrEmpty(objself.CP)){
        falta=falta+1;
    }
    // fecha nacimiento,nacionalidad,dni,edad,sexo,estado civil,hijos
    //  || isNullOrEmpty(objself.ESTADO_CIVIL) || isNullOrEmpty(objself.HIJOS)
    if(isNullOrEmpty(safeToString(objself.FECHA_NACIMIENTO)) || isNullOrEmpty(objself.NACIONALIDAD) || isNullOrEmpty(objself.DNI) || objself.EDAD==0 || isNullOrEmpty(objself.SEXO)){
        falta=falta+1;
    }
    // nivel académico,ocupación,ingreso mensual,tipo vivienda, (quitados por ahora:hipoteca,hipoteca coche)
    // isNullOrEmpty(safeToString(objself.NIVEL_ACADEMICO)) || isNullOrEmpty(objself.OCUPACION)
    if(isNullOrEmpty(safeToString(objself.INGRESOS_MENSUAL)) || isNullOrEmpty(objself.TIPO_VIVIENDA) || isNullOrEmpty(objself.MAP_SITUACION_VEHICULO)){
        falta=falta+1;
    }
    // deuda total,cuota Alivia,fecha cuota
    if(isNullOrEmpty(safeToString(objself.DEUDA_TOTAL_CALCULO)) || isNullOrEmpty(safeToString(objself.CUOTA_ALIVIA)) || isNullOrEmpty(safeToString(objself.FECHA_CUOTA))){
        falta=falta+1;
    }
    if(falta>0){
        return 0;
    }else{
        return 1;
    }
}
async function comprobarCheck5(objself){
    // Compobamos que están todos los documentos adjuntos
    let falta=0;
    
    // buscamos el dni
    var collDoc = appData.getCollection("DocumentoScript");
    await filtrarCollMacroObject(collDoc,"d.BAJA=0 AND d.ROWID_LEAD='"+objself.ROWID+"' AND d.IDTIPO=1");
    
    if(collDoc.count()==0){
        falta=falta+1;
    }

    if(falta>0){
        return 0;
    }else{
        return 1;
    }
}

async function agregarDocumentoGuardarPlan(objself){
    // primero vamos comprobamos si se ha generado un plan para la simulación actual.
    // Si no es así, vamos a subir el documento del Plan de liquidación.
    // Una vez tengamos el documento subido, guardaremos el Plan
    // Finalmente, asignaremos el documento al plan
    
    var collDoc = appData.getCollection("DocumentoScript");
    
    let idactividad = 0;
    if(objself.IDESTADO==10){
        idactividad = objself.MAP_IDACTIVIDAD;
    }
    
    var coll = appData.getCollection("PlanesLiquidacionScript");
    await filtrarCollMacroObject(coll,"pl.IDLEAD="+objself.ID+" AND pl.IDSIMULACION="+objself.MAP_IDSIMULACION_SEL);
    
    if(coll.count()>0){
        ui.showToast("Ya ha generado un plan de liquidación para esta simulación");
        return;
    }
    
    // comprobamos que tiene todos los datos de las deudas de la simulación rellenos para poder guardar
    if(await comprobarDatosDeudasGuardarSimulacion(objself,objself.MAP_IDSIMULACION_SEL)==1){
        let pregunta = await ui.msgBox("¿Desea guardar la simulación actual?","Crear plan de liquidación",1);
        if(pregunta==1){
            let fileName="";
            let file=objself.getOwnerCollection().getVariables("File");
            if(safeToInt(objself.MAP_IDTIPO_DOC_SIM)==0){
                await ui.msgBox("Debe seleccionar el tipo de documento","Falta tipo",0);
                return;
            }
            if(isNothing(file)){
                await ui.msgBox("Debe adjuntar el documento del plan que quiere subir","Falta documento",0);
                return;
            }
            if(isNullOrEmpty(objself.MAP_DOC_SIM)){
                await ui.msgBox("Debe adjuntar el documento del plan que quiere subir","Falta documento",0);
                return;
            }
            if(isNullOrEmpty(objself.MAP_NOMBRE_DOC_SIM)==false){
                let regex = /(\.pdf)|(\.docx)|(\.png)|(\.jpg)/g;
                let extensionOriginal="";
                // let regex = /\.[a-zA-Z]+$/g;
                
                // match devuelve el propio valor si cumple la condición del regex. Si no cumple, devuelve vacío
                let extension = objself.MAP_NOMBRE_DOC_SIM.match(regex);
                if (!extension){
                    // si el nuevo nombre del documento no tiene la extensión, la buscamos en el nombre original y la añadimos
                    extensionOriginal = objself.MAP_DOC_SIM.match(regex);
                    if(extensionOriginal){
                        objself.MAP_NOMBRE_DOC_SIM=objself.MAP_NOMBRE_DOC_SIM+extensionOriginal;
                    }
                }else{
                    // si el nuevo nombre tiene la extensión puesta, comprobamos que coincide con la del nombre original del documento, si no, se lo ponemos
                    extensionOriginal = objself.MAP_DOC_SIM.match(regex);
                    if(extensionOriginal){
                        if(extension[0]!==extensionOriginal[0]){
                            objself.MAP_NOMBRE_DOC_SIM=objself.MAP_NOMBRE_DOC_SIM.replace(extension,extensionOriginal);
                        }    
                    }
                }
                fileName=objself.MAP_NOMBRE_DOC_SIM;
            }
            
            //  Comprobamos si para este lead existe un documento con el mismo nombre
            if(fileName!==""){
                await filtrarCollMacroObject(collDoc,"d.BAJA=0 AND d.ROWID_LEAD='"+objself.ROWID+"' AND d.DOCUMENTO='"+fileName+"'");
            }else{
                await filtrarCollMacroObject(collDoc,"d.BAJA=0 AND d.ROWID_LEAD='"+objself.ROWID+"' AND d.DOCUMENTO='"+file.name+"'");
            }
            
            if(collDoc.count()>0){
                await ui.msgBox("Ya existe un documento con el nombre indicado. Especifique otro distinto.","Archivo duplicado",0);
                return;
            }
            
            // subimos el archivo
            await uploadFiles(objself, file, fileName, objself.MAP_IDTIPO_DOC_SIM, objself.CORREO, user.CORREO, user.LOGIN, "plan",objself.ROWID,"","","","",idactividad);
        }
    }
}

async function guardarPlanLiquidacion(objself,idsimulacion,file,fileName,rowid_lead){

        let fecha=ObtenerFechaHoraActual();
        let cnt = await objself.getContents("PlanesLiquidacion");
        var collSim = appData.getCollection("SimulacionesScript");
        
        await filtrarCollMacroObject(collSim,"ID="+idsimulacion);
        
        if(collSim.count()>0){
            let objSim = collSim.getItem(0);
            
            let objPlan= await cnt.createObject();
            objPlan.FECHA=fecha;
            objPlan.IDLEAD=objself.ID;
            objPlan.IDUSUARIO=user.ID;
            objPlan.IDSIMULACION=idsimulacion;
            objPlan.DEUDA_TOTAL=objSim.DEUDA_TOTAL;
            objPlan.TOTAL_PAGAR=objSim.TOTAL_PAGAR;
            objPlan.DEUDA_TOTAL_INTERESES=objSim.DEUDA_TOTAL_INTERESES;
            objPlan.AHORRO=objSim.AHORRO;
            objPlan.DESCUENTO_ESTIMADO=objSim.DESCUENTO_ESTIMADO;
            objPlan.DURACION=objSim.DURACION;
            objPlan.CUOTA_ALIVIA=objSim.CUOTA_ALIVIA;
            objPlan.GRUPO_PAQUETE_COMISION=objSim.GRUPO_PAQUETE_COMISION;
            objPlan.PLAN_ELEGIDO=0;
            // en caso de un cliente la simulación serán un addendum
            if(objself.IDESTADO==10){
                objPlan.ADDENDUM=1;
            }else{
                objPlan.ADDENDUM=0;
            }
            
            await objPlan.save();
            
            // await asignarIdDocumentoPlan(objself,objPlan.ID,file,fileName,rowid_lead);
            // Buscamos el documento del plan recién subido para obtener el id y vincularlo al plan
            var coll = appData.getCollection("DocumentoScript");
            if(fileName!==""){
                await filtrarCollMacroObject(coll,"d.BAJA=0 AND d.DOCUMENTO='"+fileName+"' AND d.ROWID_LEAD='"+rowid_lead+"'");
            }else{
                await filtrarCollMacroObject(coll,"d.BAJA=0 AND d.DOCUMENTO='"+file.name+"' AND d.ROWID_LEAD='"+rowid_lead+"'");
            }
            
            if(coll.count()>0){
                var objDoc = coll.getItem(0);
                
                objPlan.IDDOCUMENTO=objDoc.ID;
                await objPlan.save();
            }else{
                ui.showToast("No ha sido posible vincular el documento al plan generado");
            }
            
            limpiarCampos(objself,"guardarPlan");
            objself.MAP_GUARDAR_SIMULACION=0;
        }else{
            ui.showToast("No se ha encontrado la simulación que desea guardar");
        }
        await actualizarDatosContent(objself,"PlanesLiquidacion");
}

// BORRAR SI YA NO SE USA. ESPERAR A PRUEBAS
async function asignarIdDocumentoPlan(objself,idPlan,file,fileName,rowid_lead){
    var objPlan, objDoc, objself;
    var collPlan = appData.getCollection("PlanesLiquidacionScript");
    var coll = appData.getCollection("DocumentoScript");
    
    if(fileName!==""){
        await filtrarCollMacroObject(coll,"d.BAJA=0 AND d.DOCUMENTO='"+fileName+"' AND d.ROWID_LEAD='"+rowid_lead+"'");
    }else{
        await filtrarCollMacroObject(coll,"d.BAJA=0 AND d.DOCUMENTO='"+file.name+"' AND d.ROWID_LEAD='"+rowid_lead+"'");
    }
    
    await filtrarCollMacroObject(collPlan,"pl.IDLEAD="+objself.ID+" AND pl.ID="+idPlan);
    
    if(collPlan.count()>0){
        objPlan=collPlan.getItem(0);
        
        if(coll.count()>0){
            objDoc = coll.getItem(0);
            
            objPlan.IDDOCUMENTO=objDoc.ID;
            await objPlan.save();
        }
    }else{
        ui.showToast("No ha sido posible vincular el documento al plan generado");
    }
}

async function comprobarDatosDeudasGuardarSimulacion(objself,idsimulacion){
    let error=0;
    let cntSimDeuda = await objself.getContents("SimulacionesDeuda");
    let cntDeuda = "";
    
    // en caso de un cliente las deudas de la simulación serán de un addendum
    if(objself.IDESTADO==10){
        cntDeuda = await objself.getContents("DeudaClienteAddendum");
    }else{
        cntDeuda = await objself.getContents("Deuda");
    }

    // Comprobamos que las deudas que intervienen en la siulación tienen todos los datos rellenos
    for(var i=0;i<cntSimDeuda.count();i++){
        let objSimDeuda = cntSimDeuda.getItem(i);
        
        for(var j=0;j<cntDeuda.count();j++){
            let objDeuda = cntDeuda.getItem(j);
            // Cogemos las deudas de esta simulación
            if(objSimDeuda.IDDEUDA==objDeuda.ID){
                if(safeToInt(objDeuda.IDENTIDAD)==0){
                    error=error+1;
                }
                if(safeToFloat(objDeuda.IMPORTE_ACTUAL)==0){
                    error=error+1;
                }
                if(safeToInt(objDeuda.IDTIPO_PRODUCTO)==0){
                    error=error+1;
                }
                if(isNothing(objDeuda.FECHA_ULT_PAGO)){
                    error=error+1;
                }
                if(safeToInt(objDeuda.SITUACION_DEUDA)==0){
                    error=error+1;
                }
                if(safeToInt(objDeuda.IDPRODUCTO_FINANCIERO)==0){
                    error=error+1;
                }
                if(safeToInt(objDeuda.IDPRODUCTO_FINANCIERO)==1 && safeToInt(objDeuda.MES_OTORGAMIENTO)>0){
                    error=error+1;
                }
                if((safeToInt(objDeuda.IDPRODUCTO_FINANCIERO)==2 || safeToInt(objDeuda.IDPRODUCTO_FINANCIERO)==3) && safeToInt(objDeuda.MES_OTORGAMIENTO)==0){
                    error=error+1;
                }
                break;
            }
        }
    }
    
    if(error>0){
        await ui.msgBox("Complete los datos que faltan en las deudas de la simulación para poder guardarla","Guardar simulación",0);
        return 0;
    }else{
        return 1;
    }
}

function PrintFrame(nameFrane){
    const element = document.querySelector(".xone-frame[xone-name="+nameFrane+"]");
        	    
    // Creamos la ventana
    const newWindow = window.open("", "", "");
    // Agregamos cabecera
    var head = newWindow.document.head; 
    for(let i=0;i< document.styleSheets.length; i++){
        let itemCss = document.styleSheets[i];
		if(itemCss.href){
            let link = newWindow.document.createElement("link");	        
            link.type = "text/css";
            link.rel = "stylesheet";
            link.href = itemCss.href;	
            head.appendChild(link);	
		}else{
			let css = document.createElement("style");
			if (css.styleSheet) {
				css.styleSheet.cssText = itemCss.ownerNode.innerText;
			}else{
				css.innerText = itemCss.ownerNode.innerText;
			}
            head.appendChild(css);
		}
    }
    
    let css2 = document.createElement("style");
	css2.innerText = '* {-webkit-print-color-adjust: exact; print-color-adjust: exact;} body {      overscroll-behavior-y: contain;    }    .xone-frame {      font-family: "Roboto", system-ui, Helvetica, Arial, sans-serif;      -webkit-font-smoothing: antialiased;      -moz-osx-font-smoothing: grayscale;      /* text-align: center; */      display: flex;      justify-content: center;      overflow: visible;    }';
    head.appendChild(css2);
    
    // Agregamos copia con los datos ...
    newWindow.document.write('<html>'+head.outerHTML+'<body></body></html>');
    newWindow.document.body.appendChild(element.cloneNode(true));
    
    // Mandamos a imprimir
    setTimeout(function(){
        newWindow.print();
    }, 500);
}

async function asignarPaquetePlanLiquidacion(objself){
    // Cuando vamos a generar la plantilla del contrato, controlamos que el paquete de comisiones del Cliente
    // coincida con el paquete de comisiones del plan elegido
    let coll = appData.getCollection("PlanesLiquidacionScript");
    coll.setFilter("pl.IDLEAD="+objself.ID+" AND pl.PLAN_ELEGIDO=1");
    coll.clear();
    await coll.loadAll();
    let obj = coll.getItem(0);
    if(obj){
        objself.MAP_IDGRUPO_PAQUETE_COMISION = obj.GRUPO_PAQUETE_COMISION;
        objself.GRUPO_PAQUETE_COMISION = obj.GRUPO_PAQUETE_COMISION;
        objself.MAP_PLAN_ELEGIDO = obj.PLAN_ELEGIDO;
        await objself.save();
    }
}

async function generarNumeroContrato(objself){
    var contrato,numero,ContadorDoc,ContadorCliente,Contador;
    var guardado=0;
    var fecha = new Date();
	var mm = fecha.getMonth()+1; //January is 0!
	var yyyy = fecha.getFullYear();
	
	if(mm<10) {
	    mm='0'+mm;
	}
	
	do{
        try{
            // Obtenemos el número de contrato buscando el último existente y le sumamos 1 para generar uno nuevo
            let collCliente = appData.getCollection("ClienteContadorContrato");
            await collCliente.loadAll();
             if(collCliente.getItem(0)!==undefined && collCliente.getItem(0)!==null){
                if(safeToInt(collCliente.getItem(0).NUMERO)==0){
                    ContadorCliente=1;
                }else{
                    ContadorCliente=collCliente.getItem(0).NUMERO+1;
                }
            }
            
            let collDoc = appData.getCollection("DocumentoContadorContrato");
            await collDoc.loadAll();
            if(collDoc.getItem(0)!==undefined && collDoc.getItem(0)!==null){
                if(safeToInt(collDoc.getItem(0).NUMERO)==0){
                    ContadorDoc=1;
                }else{
                    ContadorDoc=collDoc.getItem(0).NUMERO+1;
                }
            }
            // asignamos el valor más alto para el siguiente contrato
            if(ContadorCliente>ContadorDoc){
                Contador=ContadorCliente;
            }else if(ContadorCliente<ContadorDoc){
                Contador=ContadorDoc;
            }else{
                // si es el primer contrato da igual uno que otro
                Contador=ContadorCliente;
            }
            
                
            if(safeToInt(Contador)>0 && safeToInt(Contador)<=9){
                // contratos entre el 1 y el 9
                numero='0000'+Contador;
            }else if(safeToInt(Contador)>=10 && safeToInt(Contador)<=99){
                // contratos entre el 10 y el 99
                numero='000'+Contador;
            }else if(safeToInt(Contador)>=100 && safeToInt(Contador)<=999){
                // contratos entre el 100 y el 999
                numero='00'+Contador;
            }else if(safeToInt(Contador)>=1000 && safeToInt(Contador)<=9999){
                // contratos entre el 1000 y el 9999
                numero='0'+Contador;
            }else{
                // contratos por encima del 10000
                numero=Contador;
            }
            collDoc.clear();
            collCliente.clear();
            contrato=safeToString(mm)+safeToString(yyyy)+'-'+numero;
            
            // Guardamos el número de contrato
            objself.CONTRATO_NUMERO = contrato;
            objself.NUMERO = Contador;
            await objself.save();
            guardado=1;
        }catch(e){
            // si existe un nº de contrato duplicado, da error y seguimos iterando
            objself.CONTRATO_NUMERO="";
            objself.NUMERO="";
            contrato="";
            guardado=0;
        }
	}while(guardado==0);  
	ui.showToast("Número de contrato generado");
}

async function GenerarPlantilla(objself,numdoc,objEntidad,idTipoDoc, rowidlead){
    let parameters, nombreEntidad, entidad;
    let where = [];
    let checks = [];
    let checkstexts = [];
    let images = [];
    var nombreDocumento = "";
    var sufijo = "";
    
    // plantilla contrato lead
    if(numdoc==1){
        // comprobamos el paquete comisión del plan elegido por si se hubiera cambiado para otros planes generados
        await asignarPaquetePlanLiquidacion(objself);
        
        // generamos un número de contrato si no lo tiene para añadirlo al documento
        if(isNullOrEmpty(objself.CONTRATO_NUMERO)){
            await generarNumeroContrato(objself);
        }
        where =[objself.ID];
        
        parameters={
            name:"Contrato prestacion de servicios.docx",
            entidad: "ContratoServicios",
            lead: rowidlead,
            where: where,
            images: images,
            checks: checks,
            checkstexts: checkstexts
        };
    }
    // plantilla cartas de representación
    else if(numdoc == 3){
        
        // en el where pasamos parámetros. Para este caso pasamos además los datos del cotitular
        if(isNullOrEmpty(objself.MAP_NOMCOTITULAR_ENTIDAD_ACTIVIDAD)==true ||isNullOrEmpty(objself.MAP_DNICOTITULAR_ENTIDAD_ACTIVIDAD)==true ||isNullOrEmpty(objself.MAP_DIRECCIONCOTITULAR_ENTIDAD_ACTIVIDAD)==true){
            where =[objself.ID,objself.MAP_IDDEUDA_ACTIVIDAD,user.ID,"''","''","''"];
        }else{
            where =[objself.ID,objself.MAP_IDDEUDA_ACTIVIDAD,user.ID,"'"+objself.MAP_NOMCOTITULAR_ENTIDAD_ACTIVIDAD+"'","'"+objself.MAP_DNICOTITULAR_ENTIDAD_ACTIVIDAD+"'","'"+objself.MAP_DIRECCIONCOTITULAR_ENTIDAD_ACTIVIDAD+"'"];
        }
        
        // comprobamos el tipo de producto para seleccionar una plantilla u otra
        if(objEntidad.MAP_USURA == 1){
            nombreEntidad = "Reclamacion.docx";
            entidad = "Reclamacion";
        }else{
            nombreEntidad = "ReclamacionEJ.docx";
            entidad = "ReclamacionEJ";
        }
        
        // obtenemos las imágenes del dni
        images = await obtenerImagenDocumento(objself,images);
        
        parameters={
            name: nombreEntidad,
            entidad: entidad,
            lead: rowidlead,
            where: where,
            images: images,
            checks: checks,
            checkstexts: checkstexts
        };
    }
    // plantilla aprobación deuda cliente
    else if(numdoc==4){
        where =[objself.ID,objself.MAP_IDDEUDA];

        if(objself.MAP_IDPRODUCTO != 2){
            // en el caso de descuento o fraccionamiento
            parameters={
                name:"Aprobacion de liquidacion-reestructuracion.docx",
                entidad: "AprobacionCliente",
                lead: rowidlead,
                where: where,
                images: images,
                checks: checks,
                checkstexts: checkstexts
            };
        }else{
            // en el caso de refinanciación
            parameters={
                name:"Aprobacion_liquidacion_reestructuracion_refi.docx",
                entidad: "AprobacionClienteRefi",
                lead: rowidlead,
                where: where,
                images: images,
                checks: checks,
                checkstexts: checkstexts
            };
        }
    }
    // plantilla baja pre14 
    else if(numdoc==5){
        where =[objself.ID];
        
        parameters={
            name:"Desistimiento del consumidor.docx",
            entidad: "Bajapre14Cliente",
            lead: rowidlead,
            where: where,
            images: images,
            checks: checks,
            checkstexts: checkstexts
        };
    }
    // plantilla baja 
    else if(numdoc==6){
        where =[objself.ID,objself.MAP_IDACTIVIDAD];
        
        parameters={
            name:"Terminacion unilateral_Cliente.docx",
            entidad: "BajaCliente",
            lead: rowidlead,
            where: where,
            images: images,
            checks: checks,
            checkstexts: checkstexts
        };
    }
    // plantilla solicitud pausa (suspensión)
    else if(numdoc==7){
        where =[objself.ID];
        
        parameters={
            name:"Solicitud de suspension.docx",
            entidad: "SolicitudPausaCliente",
            lead: rowidlead,
            where: where,
            images: images,
            checks: checks,
            checkstexts: checkstexts
        };
    }
    // plantilla resolución de contrato por incumplimiento
    else if(numdoc==8){
        where =[objself.ID,user.ID, objself.MAP_DESCRIPCION_PLANTILLA];
        
        parameters={
            name:"Terminacion unilateral_Alivia.docx",
            entidad: "TerminacionAlivia",
            lead: rowidlead,
            where: where,
            images: images,
            checks: checks,
            checkstexts: checkstexts
        };
    }
    // Certificado pago financiera
    else if(numdoc==9){
        where =[objself.ID,user.ID];
        
        parameters={
            name:"Certificado fin programa.docx",
            entidad: "CertificadoFinPrograma",
            lead: rowidlead,
            where: where,
            images: images,
            checks: checks,
            checkstexts: checkstexts
        };
    }
    // Certificado fin programa
    else if(numdoc==10){
        where =[objself.ID,user.ID];
        
        parameters={
            name:"Certificado fin programa.docx",
            entidad: "CertificadoFinPrograma",
            lead: rowidlead,
            where: where,
            images: images,
            checks: checks,
            checkstexts: checkstexts
        };
    }
    // Abstención llamada cliente
    else if(numdoc==11){
        
        // en el where pasamos parámetros. Para este caso pasamos además los datos del cotitular
        if(isNullOrEmpty(objself.MAP_NOMCOTITULAR_ENTIDAD_ACTIVIDAD)==true ||isNullOrEmpty(objself.MAP_DNICOTITULAR_ENTIDAD_ACTIVIDAD)==true ||isNullOrEmpty(objself.MAP_DIRECCIONCOTITULAR_ENTIDAD_ACTIVIDAD)==true){
            where =[objself.ID,objself.MAP_IDDEUDA_ACTIVIDAD,user.ID,"''","''","''"];
        }else{
            where =[objself.ID,objself.MAP_IDDEUDA_ACTIVIDAD,user.ID,"'"+objself.MAP_NOMCOTITULAR_ENTIDAD_ACTIVIDAD+"'","'"+objself.MAP_DNICOTITULAR_ENTIDAD_ACTIVIDAD+"'","'"+objself.MAP_DIRECCIONCOTITULAR_ENTIDAD_ACTIVIDAD+"'"];
        }
        
        // obtenemos las imágenes del dni
        images = await obtenerImagenDocumento(objself,images);
        
        parameters={
            name:"Abstencion_llamadas.docx",
            entidad: "AbstencionLlamadas",
            lead: rowidlead,
            where: where,
            images: images,
            checks: checks,
            checkstexts: checkstexts
        };
    }
    // Modificación cláusulas contractuales
    else if(numdoc==12){
        where =[objself.ID];
        checks=[0,0,0,0,1,0];
        checkstexts=["Incorporacion de deudas desconocidas por Alivia a la fecha de firma del Contrato.","Incapacidad para hacer frente a las aportaciones acordadas.","Reestructuracion de deudas.","Cambio de proceso a Ley de Segundad Oportunidad - cancelacion total deuda.","Incorporacion de un nuevo Servicio en el programa del Cliente.","Otros."];
        
        parameters={
            name:"Adenda modificativa contrato*prestacion de serviciosSR.docx",
            entidad: "ModificacionClausulasContractuales",
            lead: rowidlead,
            where: where,
            images: images,
            checks: checks,
            checkstexts: checkstexts
        };
    }
    // Autorización ingreso cuenta bancaria
    else if(numdoc==13){
        
        // en el where pasamos parámetros. Para este caso pasamos además los datos del cotitular
        if(isNullOrEmpty(objself.MAP_NOMCOTITULAR_ENTIDAD_ACTIVIDAD)==true ||isNullOrEmpty(objself.MAP_DNICOTITULAR_ENTIDAD_ACTIVIDAD)==true ||isNullOrEmpty(objself.MAP_DIRECCIONCOTITULAR_ENTIDAD_ACTIVIDAD)==true){
            where =[objself.ID,user.ID,"''","''","''"];
        }else{
            where =[objself.ID,user.ID,"'"+objself.MAP_NOMCOTITULAR_ENTIDAD_ACTIVIDAD+"'","'"+objself.MAP_DNICOTITULAR_ENTIDAD_ACTIVIDAD+"'","'"+objself.MAP_DIRECCIONCOTITULAR_ENTIDAD_ACTIVIDAD+"'"];
        }
        
        // obtenemos las imágenes del dni
        images = await obtenerImagenDocumento(objself,images);
        
        parameters={
            name: "AutorizacionIngresoAlivia.docx",
            entidad: "AutorizacionIngreso",
            lead: rowidlead,
            where: where,
            images: images,
            checks: checks,
            checkstexts: checkstexts
        };
    // oferta negociación extrajudicial
    }else if(numdoc==14){
        
        // calculamos el pago de la refi para la tabla del doc (objEntidad viene de EntidadesDeudaClienteActividades)
        let cuotaRef = calcularCuotaMensualRef(objself, objEntidad.IMPORTE_ACTUAL, objEntidad.MAP_ENTIDAD_TAE, objEntidad.MAP_PLAZO_REFI);
        let totalPagarRef = (cuotaRef * objEntidad.MAP_PLAZO_REFI).toFixed(2);
        
        // en el where pasamos parámetros. Para este caso pasamos además los datos del cotitular y plazos
        if(isNullOrEmpty(objself.MAP_NOMCOTITULAR_ENTIDAD_ACTIVIDAD)==true ||isNullOrEmpty(objself.MAP_DNICOTITULAR_ENTIDAD_ACTIVIDAD)==true ||isNullOrEmpty(objself.MAP_DIRECCIONCOTITULAR_ENTIDAD_ACTIVIDAD)==true){
            where =[objself.ID,objself.MAP_IDDEUDA_ACTIVIDAD,user.ID,"''","''","''",objEntidad.MAP_PLAZO_FRACC,objEntidad.MAP_PLAZO_REFI,totalPagarRef,cuotaRef];
        }else{
            where =[objself.ID,objself.MAP_IDDEUDA_ACTIVIDAD,user.ID,"'"+objself.MAP_NOMCOTITULAR_ENTIDAD_ACTIVIDAD+"'","'"+objself.MAP_DNICOTITULAR_ENTIDAD_ACTIVIDAD+"'","'"+objself.MAP_DIRECCIONCOTITULAR_ENTIDAD_ACTIVIDAD+"'",objEntidad.MAP_PLAZO_FRACC,objEntidad.MAP_PLAZO_REFI,totalPagarRef,cuotaRef];
        }
        
        // obtenemos las imágenes del dni
        images = await obtenerImagenDocumento(objself,images);

        parameters={
            name: "NegociacionExtrajudicial.docx",
            entidad: "OfertaNegociacionExtrajudicial",
            lead: rowidlead,
            where: where,
            images: images,
            checks: checks,
            checkstexts: checkstexts
        };
    }
    // autorización oposición monitorio
    else if(numdoc == 15){
        
        nombreDocumento = objEntidad.MAP_ENTIDAD + "_" + objself.MAP_NOMBRE + "_" + objself.MAP_APELLIDOS;
        where =[objself.MAP_IDMONITORIO];
        
        parameters={
            name: "AutorizacionOposicionMonitorio.docx",
            entidad: "AutorizacionOposicionMonitorio",
            lead: objself.MAP_ROWID_CLIENTE,
            where: where,
            images: images,
            checks: checks,
            checkstexts: checkstexts
        };
    }
    
    // obtenemos la versión del documento para concatenarla al nombre del documento
    sufijo = await obtenerVersionDocumento(objself,idTipoDoc,rowidlead);
    
    // definimos el nombre del documento que generamos por defecto
    if(nombreDocumento == "") {
        nombreDocumento = (objEntidad ? objEntidad.MAP_ENTIDAD + "_" : "") + objself.NOMBRE + "_" + objself.APELLIDOS;
        
    }
    nombreDocumento = nombreDocumento + sufijo;
    
    generarDocumentoPlantilla(objself,parameters,0,objEntidad,nombreDocumento);
}

function calcularCuotaMensualRef(objself, importeDeuda, tae, plazo) {
    // calculamos la tasa anual
    let tasaAnual = (tae * 0.01)/12;
    let pagoNumerador = (importeDeuda * tasaAnual);
    let pagoDenominador = 1 - (1 + tasaAnual)**-plazo;
    
    let pago = pagoNumerador / pagoDenominador;
    
    return pago.toFixed(2);
}

async function GenerarModificacionContrato(objself,numdoc,checksValor,clausulas){
    // Para addendum
    let parameters, name;
    let where = [];
    let checks = [];
    let checkstexts = [];
    let images = [];
    var nombreDocumento = "";
    var sufijo = "";

    checks=checksValor;
    checkstexts=["Incorporacion de deudas desconocidas por Alivia a la fecha de firma del Contrato.","Incapacidad para hacer frente a las aportaciones acordadas.","Reestructuracion de deudas.","Cambio de proceso a Ley de Segundad Oportunidad - cancelacion total deuda.","Incorporacion de un nuevo Servicio en el programa del Cliente.","Otros."];
    /*
        En los checkstexts mandar las tildes codificadas:
        a:\u00e1  e:\u00e9  i:\u00ed  o:\u00f3  u:\u00fa
    */
    
    // plantilla modificación contrato
    if(numdoc==2){
        
        // si se marca el quinto check, usamos otra plantilla y sin cláusulas
        // if(checks[4] == 1){
        //     name = "Adenda modificativa contrato prestacion de serviciosSR.docx";
        //     where =[objself.ID,objself.MAP_IDACTIVIDAD,""];
        // }
        
        if(isNullOrEmpty(clausulas) || clausulas == ""){
            name = "Adenda modificativa contrato prestacion de servicios.docx";
            where =[objself.ID,objself.MAP_IDACTIVIDAD,"No hay modificaciones adicionales."];
        }else{
            name = "Adenda modificativa contrato prestacion de servicios.docx";
            clausulas = quitarTildes(clausulas);
            where =[objself.ID,objself.MAP_IDACTIVIDAD,clausulas];
        }
        
        parameters={
            name: name,
            entidad: "AdendaContratoServicios",
            lead: objself.ROWID,
            where: where,
            images: images,
            checks: checks,
            checkstexts: checkstexts
        };
    }
    
    // obtenemos la versión del documento para concatenarla al nombre del documento
    sufijo = await obtenerVersionDocumento(objself,24,objself.ROWID);
    
    // obtenemos la versión del documento para concatenarla al nombre del documento
    // sufijo = await obtenerVersionDocumento(objself,idTipoDoc);
    
    // definimos el nombre del documento que generamos por defecto
    if(nombreDocumento == "") {
        nombreDocumento = "Adenda modificativa contrato prestacion de servicios_" + objself.NOMBRE + "_" + objself.APELLIDOS;
        
    }
    nombreDocumento = nombreDocumento + sufijo;
    
    generarDocumentoPlantilla(objself,parameters,1,"", nombreDocumento);
}

async function obtenerImagenDocumento(objself, arrayImagenes){
    let collDoc = appData.getCollection("DocumentoScript");
    await filtrarCollMacroObject(collDoc,"ifnull(d.BAJA,0)=0 AND d.ROWID_LEAD = '"+objself.ROWID+"' AND d.IDTIPO = 1");
    
    // Si tenemos los documentos, los añadimos al array de imágenes
    if(collDoc.count() > 0){
        for (var i = 0; i < collDoc.count(); i++){
            let item = collDoc.getItem(i);
            arrayImagenes.push(item.DOCUMENTO);
        }
    }
    
    while (arrayImagenes.length < 4) {
        arrayImagenes.push("");
    }

    return arrayImagenes;
}

async function ircolldeuda(etapa){
    var obj = await appData.getCollection("DeudasList").createObject();
    // asignamos el valor al prop del filtro para saber qué mostramos prefiltrado
    obj.MAP_IDESTADODEUDA=etapa;
    await marcarMenuPadre(2);
    appData.pushValueAndExit(obj);
}

async function ircollcliente(etapa){
    var obj = await appData.getCollection("ClienteList").createObject();
    // asignamos el valor al prop del filtro para saber qué mostramos prefiltrado
    obj.MAP_CODIGO_ESTADO=etapa;
    await marcarMenuPadre(1);
    appData.pushValueAndExit(obj);
}

// function calcularTotalesMovimientoMes(objself){
//     // Calculamos en ClienteEdicion los totales de la pestaña movimientos en el apartado mensual
//     var totalAportacion = 0;
//     var totalCMCI = 0;
//     var totalPagoFinanciera = 0;
//     var totalCE = 0;
//     var objRec;
    
//     var coll = appData.getCollection("MovimientosScript");
//     var collRectificada = appData.getCollection("MovimientosScript").createClone();
    
//     filtrarCollMacroObject(coll,"m.IDLEAD="+objself.ID+" and m.IDESTADO IN (1,4,6,7)");

//     if(coll.count()>0){
        
//         for(var i=0; i<coll.count();i++){
            
//             let item = coll.getItem(i);
            
//             // aportaciones
//             if(item.IDTIPO_MOVIMIENTO == 4){
//                 totalAportacion = totalAportacion + item.IMPORTE;
//             }
//             // comisiones iniciales y mensuales
//             else if(item.IDTIPO_MOVIMIENTO == 1 || item.IDTIPO_MOVIMIENTO == 2){
//                 totalCMCI = totalCMCI + safeToFloat(item.IMPORTE.toFixed(2));
//                 // buscamos si hay una comisión rectificativa que anule el importe
//                 filtrarCollMacroObject(collRectificada,"m.IDFACTURA_RECTIFICADA='"+item.IDENTIFICADOR+"'");
                
//                 if(collRectificada.count()>0){
//                     objRec = collRectificada.getItem(0);
//                     totalCE = totalCE + safeToFloat(objRec.IMPORTE.toFixed(2));
//                 }
//             }
//             // pago financiera (descuento, fraccionado o reestructura)
//             else if(item.IDTIPO_MOVIMIENTO == 6 || item.IDTIPO_MOVIMIENTO == 7 || item.IDTIPO_MOVIMIENTO == 8){
//                 totalPagoFinanciera = totalPagoFinanciera + item.IMPORTE;
//             }
//             // comisiones de éxito
//             else if(item.IDTIPO_MOVIMIENTO == 3){
//                 totalCE = totalCE + item.IMPORTE;
//                 // buscamos si hay una comisión rectificativa que anule el importe
//                 filtrarCollMacroObject(collRectificada,"m.IDLEAD="+objself.ID+" and m.IDFACTURA_RECTIFICADA='"+item.IDENTIFICADOR+"'");
                
//                 if(collRectificada.count()>0){
//                     objRec = collRectificada.getItem(0);
//                     totalCE = totalCE + objRec.IMPORTE;
//                 }
//             }
//         }
//     }
    
//     objself.MAP_TOTAL_APORTACION = totalAportacion+" €";
//     objself.MAP_TOTAL_CICM = totalCMCI+" €";
//     objself.MAP_TOTAL_PAGO_FINAN = totalPagoFinanciera+" €";
//     objself.MAP_TOTAL_CE = totalCE+" €";
// }

async function calcularTotalesMovimientoMes(objself) {
    // Calculamos en ClienteEdicion los totales de la pestaña movimientos en el apartado mensual
    var totalAportacion = 0;
    var totalCMCI = 0;
    var totalPagoFinanciera = 0;
    var totalCE = 0;

    // OPTIMIZACIÓN: Cargamos todos los movimientos del lead en una única consulta inicial
    // para evitar el bucle de consultas (loaddall) posterior.
    var collAll = appData.getCollection("MovimientosScript");
    await filtrarCollMacroObject(collAll, "ifnull(m.BAJA,0)=0 and m.IDLEAD=" + objself.ID);

    var count = collAll.count();
    if (count === 0) {
        objself.MAP_TOTAL_APORTACION = "0.00 €";
        objself.MAP_TOTAL_CICM = "0.00 €";
        objself.MAP_TOTAL_PAGO_FINAN = "0.00 €";
        objself.MAP_TOTAL_CE = "0.00 €";
        return;
    }

    // 1. Mapeamos las rectificaciones para acceso instantáneo O(1)
    // Clave: IDFACTURA_RECTIFICADA, Valor: IMPORTE
    var mapRectificadas = {};
    for (var i = 0; i < count; i++) {
        var m = collAll.getItem(i);
        var idRect = m.IDFACTURA_RECTIFICADA;
        if (idRect && idRect !== "") {
            // Sumamos por si hubiera varias rectificaciones para una misma factura
            mapRectificadas[idRect] = (mapRectificadas[idRect] || 0) + m.IMPORTE;
        }
    }

    // 2. Calculamos los totales recorriendo la colección una sola vez en memoria
    var estadosValidos = [1, 4, 6, 7];
    for (var i = 0; i < count; i++) {
        var item = collAll.getItem(i);

        // Filtro original por estado
        if (estadosValidos.indexOf(item.IDESTADO) === -1) continue;

        var tipo = item.IDTIPO_MOVIMIENTO;
        var importe = item.IMPORTE;
        var identificador = item.IDENTIFICADOR;

        // Aportaciones
        if (tipo == 4) {
            totalAportacion += importe;
        }
        // Comisiones iniciales y mensuales
        else if (tipo == 1 || tipo == 2) {
            totalCMCI += safeToFloat(importe.toFixed(2));
            
            // Buscamos si hay una comisión rectificativa vinculada en el mapa
            if (mapRectificadas[identificador] !== undefined) {
                totalCE += safeToFloat(mapRectificadas[identificador].toFixed(2));
            }
        }
        // Pago financiera (descuento, fraccionado o reestructura)
        else if (tipo == 6 || tipo == 7 || tipo == 8) {
            totalPagoFinanciera += importe;
        }
        // Comisiones de éxito
        else if (tipo == 3) {
            totalCE += importe;
            
            // Buscamos si hay una comisión rectificativa vinculada en el mapa
            if (mapRectificadas[identificador] !== undefined) {
                totalCE += mapRectificadas[identificador];
            }
        }
    }

    // Volcamos los resultados formateados
    objself.MAP_TOTAL_APORTACION = totalAportacion.toFixed(2) + " €";
    objself.MAP_TOTAL_CICM = totalCMCI.toFixed(2) + " €";
    objself.MAP_TOTAL_PAGO_FINAN = totalPagoFinanciera.toFixed(2) + " €";
    objself.MAP_TOTAL_CE = totalCE.toFixed(2) + " €";
}

async function subirFotoUsuario(objself,objUsuario,correo_usuario,login){
    // subimos la foto de perfil del usuario
    let file=objself.getOwnerCollection().getVariables("File");
    
    if(isNothing(file)){
        await ui.msgBox("Debe adjuntar la foto que quiere subir","Falta documento",0);
        return;
    }
    if(isNullOrEmpty(objself.MAP_NOMBRE_FOTO)){
        await ui.msgBox("Debe adjuntar la foto que quiere subir","Falta documento",0);
        return;
    }
    
    let regex = /(\.png)|(\.jpg)/g;
    
    // match devuelve el propio valor si cumple la condición del regex. Si no cumple, devuelve vacío
    let extension = objself.MAP_NOMBRE_FOTO.match(regex);
    if(!extension){
        let fileName="FotoPerfilUsuario.png";
    }
    let fileName="FotoPerfilUsuario"+extension;
    
    await uploadUserFiles(objself,file,fileName,correo_usuario,login,objUsuario);
}

// function comprobarPagarTransferencia(objself){
    
//     var cadena = "";
//     var escliente = 0;
//     var importe = 0;
    
//     // comprobamos si el cliente tiene una suscripción activa para avisar
//     var collSub = appData.getCollection("PagosSuscripcion");
//     filtrarCollMacroObject(collSub,"IDCLIENTE="+objself.ID);
    
//     if(collSub.count()>0){
//         let seguir = ui.msgBox("El lead/cliente tiene una suscripción activa, ¿Desea continuar de todos modos con la aportación?","Cliente con suscripción",1);
//         if(seguir == 2){
//             return;
//         }
//     }
    
//     objself.MAP_IMPORTE_TRANSFERENCIA > 0 ? importe = objself.MAP_IMPORTE_TRANSFERENCIA : importe = objself.CUOTA_ALIVIA;
    
    
//     // Si es el primer pago del lead y va a pasar a cliente
//     if(objself.IDESTADO == 9){
//         cadena = "¿Desea confirmar el primer pago del lead con un importe de "+importe+" € realizado mediante transferencia y efectuar el paso a la etapa 'cliente'? Este proceso no se podrá deshacer.";
//     }
//     // Si realiza el pago siendo ya cliente
//     if(objself.IDESTADO == 10){
//         cadena = "¿Desea confirmar el pago del cliente con un importe de "+importe+" € realizado mediante transferencia? Este proceso no se podrá deshacer.";
//         escliente=1;
//     }
    
//     let pregunta = ui.msgBox(cadena,"Confirmar pago por transferencia",1);
//     if(pregunta == 1){
//         pagarTransferencia(objself,escliente, importe);
//     }
// }

async function comprobarPagarTransferencia(objself) {
    // 1. Normalizamos los datos necesarios. 
    // Si existe MAP_IDLEAD_TITULAR, asumimos que estamos en un Proceso, si no, en Cliente.
    var idLead = objself.MAP_IDLEAD_TITULAR || objself.ID;
    var idEstado = objself.MAP_IDESTADO_TITULAR || objself.IDESTADO;
    var cuotaDefault = objself.MAP_CUOTA_ALIVIA_TITULAR || objself.CUOTA_ALIVIA;
    var correo = objself.MAP_CORREO_TITULAR_CABECERA || objself.CORREO;

    var importe = objself.MAP_IMPORTE_TRANSFERENCIA > 0 ? objself.MAP_IMPORTE_TRANSFERENCIA : cuotaDefault;
    var escliente = 0;
    var cadena = "";

    // 2. Lógica de suscripción
    var collSub = appData.getCollection("PagosSuscripcion");
    await filtrarCollMacroObject(collSub, "IDCLIENTE=" + idLead);

    if (collSub.count() > 0) {
        let seguir = await ui.msgBox("El lead/cliente tiene una suscripción activa, ¿Desea continuar de todos modos con la aportación?", "Cliente con suscripción", 1);
        if (seguir == 2) return;
    }

    // 3. Lógica de mensajes según estado
    if (idEstado == 9) {
        cadena = "¿Desea confirmar el primer pago del lead con un importe de " + importe + " € realizado mediante transferencia y efectuar el paso a la etapa 'cliente'? Este proceso no se podrá deshacer.";
    } else if (idEstado == 10) {
        cadena = "¿Desea confirmar el pago del cliente con un importe de " + importe + " € realizado mediante transferencia? Este proceso no se podrá deshacer.";
        escliente = 1;
    }

    if (!cadena) return; // Por seguridad si el estado no es 9 o 10

    let pregunta = await ui.msgBox(cadena, "Confirmar pago por transferencia", 1);
    if (pregunta == 1) {
        // Importante: pasar el objself original para que pagarTransferencia 
        // sepa qué contexto de UI actualizar (flotantes, variables, etc.)
        if(objself.getOwnerCollection().getName() == "ProcesoLSOEdicion") {
            await pagarTransferenciaProceso(objself, escliente, importe);
        }else {
            await pagarTransferencia(objself, escliente, importe);
        }
    }
}



async function rechazarDocumento(objself,idTipoDoc){
    // para rechazar documentos que no supongan cambios de etapa
    var collDoc = appData.getCollection("DocumentoScript");
    
    // plan de liquidación
    if(idTipoDoc == 7){
        await filtrarCollMacroObject(collDoc,"d.BAJA=0 AND d.ROWID_LEAD='"+objself.ROWID+"' AND d.IDTIPO="+idTipoDoc+" AND d.ACEPTADO IN(0,1)");
    }
    // contrato
    else if (idTipoDoc == 8){
        await filtrarCollMacroObject(collDoc,"d.BAJA=0 AND d.ROWID_LEAD='"+objself.ROWID+"' AND d.IDTIPO="+idTipoDoc+" AND d.ACEPTADO IN(0,1)");
    }
    
    if(collDoc.count() > 0){
        var objDoc = collDoc.getItem(0);
        objDoc.DOCUMENTO="rechazado_"+objDoc.DOCUMENTO;
        objDoc.ACEPTADO=2;
        objDoc.DOCUMENTO_VISIBLE=0;
        await objDoc.save();
        
        
        // en caso de un plan de liquidación, lo desmarcamos también como plan elegido si lo estuviera
        if(idTipoDoc == 7){
            var collPlan = appData.getCollection("PlanesLiquidacionScript");
            await filtrarCollMacroObject(collPlan,"pl.IDLEAD="+objself.ID+" AND pl.IDDOCUMENTO="+objDoc.ID+" AND pl.PLAN_ELEGIDO=1");
            if(collPlan.count() > 0){
                let objPlan = collPlan.getItem(0);
                objPlan.PLAN_ELEGIDO=0;
                await objPlan.save();
                await actualizarDatosContent(objself,"PlanesLiquidacion");
            }
        }
        // en el caso de un contrato, quitamos al cliente el número de contrato
        if(idTipoDoc == 8){
            objself.CONTRATO_NUMERO="";
            objself.NUMERO="";
            await objself.save();
        }
        
        await actualizarDatosPaginadoLeads(objself,"Documento","DocumentoContador","MAP_PAG_INI_DOC","MAP_PAG_LEN_DOC","MAP_TOTAL_REGISTROS_DOC","MAP_T1_DOC");
    }
}

async function obtenerNombreDocumento(objself,idTipoDoc,nombreProp){
    // función para nombrar los planes de liquidación y en addendum
    
    let sufijo = idTipoDoc == 7 ? "_V" : "_AddendumV"; 
    
    var collDoc = appData.getCollection("DocumentoScript");
    await filtrarCollMacroObject(collDoc,"d.ROWID_LEAD='"+objself.ROWID+"' AND d.IDTIPO="+idTipoDoc);
    
    if(collDoc.count() > 0){
        objself[nombreProp] = "PL_"+objself.NOMBRE+"_"+objself.APELLIDOS+sufijo+safeToInt(collDoc.count()+1)+"-";
    }else{
        objself[nombreProp] = "PL_"+objself.MAP_NOMBRE_COMPLETO+sufijo+"1-";
    }
    
}

async function obtenerVersionDocumento(objself,idTipoDoc,rowidlead){
    // función para nombrar los documentos cambiando el sufijo para evitar repeticiones en el nombre
    
    let sufijo = "_V"; 
    
    let fechaConcatenada = obtenerFechaActualConcatenada();
    
    var collDoc = appData.getCollection("DocumentoScript");
    await filtrarCollMacroObject(collDoc,"d.ROWID_LEAD='"+rowidlead+"' AND d.IDTIPO="+idTipoDoc);
    
    if(collDoc.count() > 0){
        sufijo = sufijo + safeToInt(collDoc.count()+1) + "-" +fechaConcatenada;
    }else{
        sufijo = sufijo + "1-"+fechaConcatenada;
    }
    
    return sufijo;
}

async function generarEnlaceFirma(objself){
    // función para poder generar los enlaces de firma desde el crm
    
    var collDoc = appData.getCollection("DocumentoScript");
    var collFirma = appData.getCollection("DocumentoFirmaPendienteScript");
    var idDocumentos = [];
    var contador = 0;
    
    // buscamos los documentos que se puedan firmar
    await filtrarCollMacroObject(collDoc,"d.ROWID_LEAD='"+objself.ROWID+"' AND d.ENVIAR_FIRMAR=1 AND d.DOCUMENTO_VISIBLE=1 AND ifnull(DOCUMENTO_FIRMADO,0)=0 AND ifnull(d.BAJA,0)=0");
    
    if(collDoc.count() > 0){
        
        ui.showToast("Intentando generar enlaces de firma...");
        
        for(var i = 0; i < collDoc.count(); i++){
            let objDoc = collDoc.getItem(i);
            
            // si el documento esta rechazado o aceptado, pasamos al siguiente
            if(objDoc.ACEPTADO !== 0) {
                continue;
            }
            // buscamos si se ha generado el enlace para cada documento
            await filtrarCollMacroObject(collFirma,"ifnull(d.BAJA,0)=0 AND d.ID="+objDoc.ID+" AND d.ROWID_LEAD='"+objself.ROWID+"' and f.DOWNLOADED=0 AND f.STATUS IS NULL AND d.ENVIAR_FIRMAR=1 AND d.DOCUMENTO_VISIBLE=1");
            
            // si no existe, lo creamos
            if(collFirma.count() === 0){
                idDocumentos.push(objDoc.ID);
                contador ++;
            }
            
            // comprobamos si llevamos 15 documentos, puesto que es el máximo que permite signaturit
            if(contador == 15){
                await firmarDocumento(objself,idDocumentos);  
                
                // reseteamos el contador y el array para continuar
                contador = 0;
                idDocumentos = [];
            }
        }
        
        // mandamos firmar los documentos restantes si los hay
        idDocumentos.length > 0 ? await firmarDocumento(objself,idDocumentos): ui.showToast("No hay nuevos documentos pendientes de firmar");
    }
}

async function comprobarEnvioSms(objself) {
    // si no hay documentos pendientes de firmar, ocultamos el botón de envío sms en clienteEdicion
    var collDoc = appData.getCollection("DocumentoScript");
    var estadosNoEnviarSms = [7, 9, 12]; // pausa, baja, graduado
    
    // si el cliente está en un estado distinto a pausa, baja o graduado, comprobamos
    if(!estadosNoEnviarSms.includes(objself.IDESTADO_CLIENTE)) {
        // buscamos los documentos que se puedan firmar
        await filtrarCollMacroObject(collDoc,"d.ROWID_LEAD='"+objself.ROWID+"' AND d.ENVIAR_FIRMAR=1 AND d.DOCUMENTO_VISIBLE=1 AND ifnull(d.ACEPTADO,0)=0 AND ifnull(d.BAJA,0)=0");
        
        collDoc.count() > 0 ? objself.MAP_OCULTAR_ENVIO_SMS = 0 : objself.MAP_OCULTAR_ENVIO_SMS = 1;
    }
}



async function modificarSuscripcion(objself) {
    
    if(isNullOrEmpty(safeToString(objself.MAP_FECHA_NUEVA_SUSCRIPCION))) {
       ui.showToast("Seleccione una fecha válida");
       return;
    }
    
    if(esAnteriorAHoy(objself.MAP_FECHA_NUEVA_SUSCRIPCION)) {
       ui.showToast("Seleccione una fecha posterior o igual al día de hoy");
       return;
    }
    
    let pregunta = await ui.msgBox("¿Desea crear la nueva suscripción con fecha " + fechaFormateada(objself.MAP_FECHA_NUEVA_SUSCRIPCION) + "?","Modificar suscripción",1);
    
    if(pregunta == 1) {
        crearSuscripcion(objself,crearSuscripcionOk ,function() {ui.showToast("No ha sido posible crear la suscripción");});
        
        // buscamos si tiene alguna suscripción activa para borrarla
        // var collSub = appData.getCollection("PagosSuscripcion");
        // await filtrarCollMacroObject(collSub,"IDCLIENTE=" + objself.ID);
        
        // if(collSub.count()>0){
        //     borrarSuscripcion(objself,objself.CORREO,function() {
        //         ui.showToast("Suscripción antigua borrada");
        //         // creamos la nueva con la fecha indicada
        //         crearSuscripcion(objself,crearSuscripcionOk ,function() {ui.showToast("No ha sido posible crear la suscripción");});
                
        //     },function() {ui.showToast("No ha sido posible borrar la suscripción");});
            
        // } else {
        //     // creamos la nueva con la fecha indicada
        //     crearSuscripcion(objself,crearSuscripcionOk ,function() {ui.showToast("No ha sido posible crear la suscripción");});
        // }
    }
}

async function crearSuscripcionOk(objself) {
    // Si creamos correctamente la suscripción tras borrar la anterior
    // La declaro fuera porque si no no me pone el 'await'...
    ui.showToast("Suscripción nueva creada");
    
    var collSub = appData.getCollection("PagosSuscripcion");
    await filtrarCollMacroObject(collSub,"IDCLIENTE=" + objself.ID);
    
    if(collSub.count()>0){
        let objSubNueva = collSub.getItem(0);
        objself.MAP_SUSCRIPCION_ACTUAL = fechaFormateada(objSubNueva.FECHA_COBRO);
        objself.MAP_SUSCRIPCION = 'Sí: ' + fechaFormateada(objSubNueva.FECHA_COBRO);
    }
}

async function eliminarSuscripcion(objself) {
    
    let pregunta = await ui.msgBox("¿Desea borrar la suscripción actual?","Borrar suscripción",1);
    
    if(pregunta == 1) {
    
        borrarSuscripcion(objself,objself.CORREO,function() {
            objself.MAP_SUSCRIPCION_ACTUAL = "";
            objself.MAP_TIENE_SUSCRIPCION = 0;
            
            // ajustamos valores en pantalla
            objself.MAP_SUSCRIPCION = 'No';
            objself.MAP_FECHA_PAGO_PROGRAMA_CABECERA = fechaFormateada(objself.FECHA_PAGO_TRANSFERENCIA);
            
            ui.showToast("Suscripción borrada");
        },function() {ui.showToast("No ha sido posible borrar la suscripción");});
    }
}

// funciones procesoLSO
function comprobarEtapaProcesoLSO(objself, propImagenEtapa, numeroEtapas) {
    
    // iteramos las etapas del proceso LSO. Según el estado, vamos asignando a los props las imágenes correspondientes
    for(var i = 1; i <= numeroEtapas; i++) {
        
        if(i < objself.IDESTADO) {
            objself[propImagenEtapa + safeToString(i)] = "deudaVerde.png";
        }
        else if(i == objself.IDESTADO) {
            objself[propImagenEtapa + safeToString(i)] = "deudaAmarillo.png";
        }else if(i > objself.IDESTADO) {
            objself[propImagenEtapa + safeToString(i)] = "deudaGris.png";
        }
        
        // si está marcado el check final de sentencia firme o finalizado=1, la última etapa está realizada
        if(i == numeroEtapas && objself.FINALIZADO == 1){8                               
            objself[propImagenEtapa + i] = "deudaVerde.png";
        }
    }
}

function calcularDiasLaborablesProcesoLSO(objself) {
    // función para calcular los días laborables transcurridos en cada etapa que se contabilizan
    // debe haber una fecha rellena y el campo de días vacío
    let fecha = ObtenerFechaHoraActual();
    
    // etapa 6
    if(objself.IDESTADO >= 6 && objself.FECHA_ADMISION_TRAMITE && safeToInt(objself.DIAS_TRANSCURRIDOS_ADMISION_TRAMITE) == 0) {
        objself.MAP_DIAS_TRANSCURRIDOS_ADMISION_TRAMITE = diasLaborablesTranscurridos(objself.FECHA_ADMISION_TRAMITE,fecha);
    }
    // etapa 8
    else if(objself.IDESTADO >= 8 && objself.FECHA_OPOSICION && safeToInt(objself.DIAS_TRANSCURRIDOS_OPOSICION) == 0) {
        objself.MAP_DIAS_TRANSCURRIDOS_OPOSICION = diasLaborablesTranscurridos(objself.FECHA_OPOSICION,fecha);
    }
    // etapa 13
    else if(objself.IDESTADO >= 13 && objself.FECHA_SOLICITUD_EPI && safeToInt(objself.DIAS_TRANSCURRIDOS_SOLICITUD_EPI) == 0) {
        objself.MAP_DIAS_TRANSCURRIDOS_SOLICITUD_EPI = diasLaborablesTranscurridos(objself.FECHA_SOLICITUD_EPI,fecha);
    }
    // etapa 14
    else if(objself.IDESTADO >= 14 && objself.FECHA_OPOSICION_EPI && safeToInt(objself.DIAS_TRANSCURRIDOS_OPOSICION_EPI) == 0) {
        objself.MAP_DIAS_TRANSCURRIDOS_OPOSICION_EPI = diasLaborablesTranscurridos(objself.FECHA_OPOSICION_EPI,fecha);
    }
}

async function guardarHistoricoCambioProcesoLSO(objself,idestadoOrigen,idestadoDestino){
    // para llevar un histórico de los cambios de etapa en el proceso LSO
    let fecha=ObtenerFechaHoraActual();
    let coll = appData.getCollection("ProcesoLSOHistoricoEstadosScript");
    let obj = await coll.createObject();
    
    obj.ID_PROCESO_LSO = objself.ID;
    obj.IDESTADO_ORIGEN = idestadoOrigen;
    obj.IDESTADO_DESTINO = idestadoDestino;
    obj.IDUSUARIO = user.ID;
    obj.FECHA = fecha;
    await obj.save();
    
    // Para controlar los cambios de etapa en elhistórico, MAP_IDESTADO conservará la etapa vieja al guardar
    objself.MAP_IDESTADO = objself.IDESTADO;
    await actualizarDatosContent(objself,"ProcesoLSOHistoricoEstados", true);
}

async function comprobarDocumentacionPrevia(objself) {
    
    let collDocPrevia = appData.getCollection("ProcesoLSODocumentacionPreviaScript");
    await filtrarCollMacroObject(collDocPrevia,"c.ID=" + objself.MAP_IDLEAD);
    
    let docsTotal = collDocPrevia.count();
    let docPreviosSubidos = 0;
    
    // recorremos el content comprobando cuántos documentos están subidos
    for (var i=0; i < collDocPrevia.count(); i++) {
        let doc = collDocPrevia.getItem(i);
        
        if(doc.MAP_IDDOCUMENTO > 0) {
            docPreviosSubidos += 1;
        }
    }
    
    if(docPreviosSubidos == docsTotal) {
        objself.MAP_IMG_DOC_PREVIA = "deudaVerde.png";
    }else {
        objself.MAP_IMG_DOC_PREVIA = "deudaAmarillo.png";
    }
}




function recargarDireccionInmueble(objself) {
    objself.MAP_INMUEBLE_DIRECCION_COMPLETA = objself.MAP_INMUEBLE_CALLE + ', ' + objself.MAP_INMUEBLE_NUMERO + ' ' + objself.MAP_INMUEBLE_PISO + '. ' + objself.MAP_INMUEBLE_CP + ' ' + objself.MAP_INMUEBLE_LOCALIDAD;
}

async function verDocumentacionDatosCliente(objself, tipoCaso, contexto = objself.getParent()) {
    // función genérica para poder ver la documentación de los datos del cliente (inmuebles, vehículos, herencia...)
    
    // según se llame desde ProcesoLSOEdicion o ClienteEdicion
    let rowidActual = objself.MAP_ROWID_CLIENTE_ACTUAL || objself.MAP_ROWID;
    
    let filtroContent = "doc.ROWID_LEAD = '" + rowidActual + "' AND ifnull(doc.BAJA,0)=0";
    let filtroComboTipoDocumento = "", tituloFrame = "", tipoCallback = "";
    
    // establecemos para cada caso los filtros que vamos a aplicar
    switch (tipoCaso){
        case "LeadDeudas":
            filtroContent = filtroContent + " AND doc.IDTIPO=5 AND doc.IDDEUDA=" + objself.ID;
            filtroComboTipoDocumento = "ID=5";
            tituloFrame = "Comprobante de deuda";
            tipoCallback = "comprobanteDeudaLeadEdicion";
            break;
        case "ClienteDeudas":
            filtroContent = filtroContent + " AND doc.IDTIPO=5 AND doc.IDDEUDACLIENTE=" + objself.MAP_IDDEUDA;
            filtroComboTipoDocumento = "ID=5";
            tituloFrame = "Comprobante de deuda";
            tipoCallback = "comprobanteDeudaClienteEdicion";
            contexto.MAP_ID_DATOS_CLIENTE = objself.MAP_IDDEUDA;
            break;
        case "ClienteDatosPoseeAlgunaSociedad":
            filtroContent = filtroContent + " AND doc.ID_CLIENTE_DATOS_POSEE_ALGUNA_SOCIEDAD = " +objself.ID;
            filtroComboTipoDocumento = "ID=99 OR ID BETWEEN 148 AND 150";
            tituloFrame = "Posee alguna sociedad";
            tipoCallback = "poseeSociedad";
            break;
        case "ClienteDatosSancionesHaciendaSS":
            filtroContent = filtroContent + " AND doc.ID_CLIENTE_DATOS_SANCIONES_HACIENDA = " +objself.ID;
            filtroComboTipoDocumento = "ID BETWEEN 87 AND 94";
            tituloFrame = "Sanciones hacienda y SS";
            tipoCallback = "sancionesHacienda";
            break;
        case "ClienteDatosVentaDonacionBien":
            filtroContent = filtroContent + " AND doc.ID_CLIENTE_DATOS_VENTA_DONACION_BIEN = " +objself.ID;
            filtroComboTipoDocumento = "ID BETWEEN 79 AND 83";
            tituloFrame = "Venta o donación de algún bien";
            tipoCallback = "ventaDonacionBien";
            break;
        case "ClienteDatosHerencia":
            filtroContent = filtroContent + " AND doc.ID_CLIENTE_DATOS_HERENCIA = " +objself.ID;
            filtroComboTipoDocumento = "ID BETWEEN 111 AND 120 OR ID=134";
            tituloFrame = "Herencia";
            tipoCallback = "herencia";
            break;
        case "ClienteDatosOtrosActivos":
            filtroContent = filtroContent + " AND doc.ID_CLIENTE_DATOS_OTROS_ACTIVOS = " +objself.ID;
            filtroComboTipoDocumento = "ID BETWEEN 95 AND 110 OR ID=121 OR ID=130";
            tituloFrame = "Otros activos";
            tipoCallback = "otrosActivos";
            break;
        case "ClienteDatosInmuebles":
            filtroContent = filtroContent + " AND doc.ID_CLIENTE_DATOS_INMUEBLES = " +objself.ID;
            filtroComboTipoDocumento = "(ID BETWEEN 75 AND 78) OR (ID BETWEEN 124 AND 129)";
            tituloFrame = "Bienes inmuebles";
            tipoCallback = "bienesInmuebles";
            break;
        case "ClienteDatosVehiculos":
            filtroContent = filtroContent + " AND doc.ID_CLIENTE_DATOS_VEHICULOS = " +objself.ID;
            filtroComboTipoDocumento = "ID BETWEEN 84 AND 86 OR ID=63 OR ID=123 OR ID=144";
            tituloFrame = "Vehículos";
            tipoCallback = "vehiculos";
            break;
        case "ClienteDatosFamiliaresCargo":
            filtroContent = filtroContent + " AND doc.ID_CLIENTE_DATOS_FAMILIARES_CARGO = " +objself.ID;
            filtroComboTipoDocumento = "ID BETWEEN 131 AND 133 OR ID=56";
            tituloFrame = "Familiares a cargo";
            tipoCallback = "familiares";
            break;
            
        // casos documentos generales asociados al cliente, sin ser de contents de datos con sus ID_CLIENTE_DATOS... correspondiente
        case "ClienteSancionesHaciendaSSDeudaCero":
            filtroContent = filtroContent + " AND doc.IDTIPO in(62,65) AND ifnull(doc.ID_CLIENTE_DATOS_SANCIONES_HACIENDA,0)=0 ";
            filtroComboTipoDocumento = "ID in(62,65)";
            tituloFrame = "Sanciones hacienda y SS deuda cero";
            tipoCallback = "ClienteSancionesHaciendaSSDeudaCero";
            break;
        case "ClienteEstadoCivil":
            filtroContent = filtroContent + " AND doc.IDTIPO BETWEEN 137 AND 141 ";
            filtroComboTipoDocumento = "ID BETWEEN 137 AND 141";
            tituloFrame = "Estado civil";
            tipoCallback = "ClienteEstadoCivil";
            break;
        case "ClienteDomicilio":
            filtroContent = filtroContent + " AND doc.IDTIPO in(56,142,145) ";
            filtroComboTipoDocumento = "ID in(56,142,145)";
            tituloFrame = "Domicilio";
            tipoCallback = "ClienteEstadoCivil";
            break;
        case "ClienteDiscapacidad":
            filtroContent = filtroContent + " AND doc.IDTIPO in(132,147) ";
            filtroComboTipoDocumento = "ID in(132,147)";
            tituloFrame = "Discapacidad";
            tipoCallback = "ClienteDiscapacidad";
            break;
        default:
            // si hay otros casos, decides qué hacer o dejar false
    }
    
    // !!!
    // contexto indica si es self o self.getparent()
    contexto.MAP_VER_DOCUMENTACION_DATOS_CLIENTE = 1;
    
    // asignamos el ID por defecto si no le hemos dado otro valor previamente
    contexto.MAP_ID_DATOS_CLIENTE = safeToInt(contexto.MAP_ID_DATOS_CLIENTE) == 0 ? objself.ID : contexto.MAP_ID_DATOS_CLIENTE;
    contexto.MAP_TITULO_DOCUMENTACION_CLIENTE = tituloFrame;
    contexto.MAP_TIPO_CALLBACK_DOCUMENTACION_CLIENTE = tipoCallback;
    contexto.setFieldPropertyValue("MAP_IDTIPO_DOC_CLIENTE","filter",filtroComboTipoDocumento);
    
    let cntDocumentacion = await contexto.getContents("DocumentoDatosCliente");
    
    cntDocumentacion.unlock();
    cntDocumentacion.setFilter(filtroContent);
    cntDocumentacion.clear();
    await cntDocumentacion.loadAll();
    cntDocumentacion.lock();
    ui.refresh("DocumentoDatosCliente");
}


async function generarIdentificadorGenerico(obj, collContador, prefijo, campoNumero, campoIdentificador){
    var numero,coll;
    var Contador = 1;
    let intentos = 0;
    const maxIntentos = 10;
    var guardado = 0;
    var cantidadCerosIzquierda = 5;
    var fecha = new Date();
	var yy = safeToString(fecha.getFullYear()).substring(2,4);
	
    // 	en el caso de identificadores de deuda hay pequeñas variaciones en la construcción
    if(collContador == "DeudaClienteIdentificadorContadorScript") {
        yy = safeToString(fecha.getFullYear());
        cantidadCerosIzquierda = 7;
    }

	
    // 	requiere campos IDENTIFICADOR y NUMERO_IDENTIFICADOR
	do{
        try{
        	coll = appData.getCollection(collContador);
            await coll.loadAll();
            
            if(coll.getItem(0)) {
                let ultimo = safeToInt(coll.getItem(0)[campoNumero]);
                Contador = ultimo > 0? ultimo + 1 : 1;
            }
            
            // 2. Formateo con ceros a la izquierda (más limpio que con if-else)
            var strNumero = Contador.toString();
            while (strNumero.length < cantidadCerosIzquierda) {
                strNumero = "0" + strNumero;
            }
            
            // Guardamos el número de identificador y el número (campos únicos)
            obj[campoNumero] = Contador;
            obj[campoIdentificador] = prefijo+yy+strNumero;
            await obj.save();
            guardado = 1;
                
        }catch(e){
            // si existe un nº de identificador duplicado, da error y seguimos iterando
            obj[campoIdentificador] = "";
            guardado = 0;
            
            intentos++;
            if(intentos >= maxIntentos) {
                console.error(e);
                throw new Error(
                    "No se pudo generar identificador único"
                );
            }
        }
    }while(guardado === 0);
}


async function guardarNuevoProcesoLSO(objself) {

    if (isNullOrEmpty(objself.MAP_LSO_MODALIDAD)) { 
        ui.showToast("Seleccione el tipo de modalidad.");
        return;
    }

    const esConjunta = objself.MAP_ID_PROGRAMA_MODALIDAD == 1;

    if (esConjunta && !objself.MAP_ID_CLIENTE_PAREJA_COMBO) {
        ui.showToast("Para la modalidad conjunta debe introducir y seleccionar el correo del cliente asociado.");
        return;
    }
    
    let fecha = ObtenerFechaHoraActual();

    // creamos el proceso
    let collProgramaLSO = appData.getCollection("ProcesoLSOScript");
    let objProcesoLSO = await collProgramaLSO.createObject();
    objProcesoLSO.IDESTADO = 1;
    objProcesoLSO.FECHA_INICIO = fecha;
    // !!!
    objProcesoLSO.ID_PROGRAMA_MODALIDAD = objself.MAP_ID_PROGRAMA_MODALIDAD;
    objProcesoLSO.BAJA = 0;
    // Esta función rellena IDENTIFICADOR y hace el PRIMER .save() por eso no guardamos aquí
    await generarIdentificadorGenerico(objProcesoLSO, "ProcesoLSOIdentificadorContador", "LSO", "NUMERO_IDENTIFICADOR", "IDENTIFICADOR");
    

    objself.ID_PROCESO_LSO = objProcesoLSO.ID;

    // eterminar titular (1 = titular)
    let selfEsTitular = true;

    if (esConjunta) {
        // comprobamos si se marca la pareja como titular o no (selfEsTitular sería false en ese caso)
        selfEsTitular = objself.MAP_PAREJA_LSO_TITULAR != 1;
    }

    objself.PROCESO_LSO_CLIENTE_TITULAR = selfEsTitular ? 1 : 0;

    // i es conjunta, asignar también a la pareja
    if (esConjunta) {
        let collCliente = appData.getCollection("ClienteScript");
        await filtrarCollMacroObject(collCliente, "c.ID=" + objself.MAP_ID_CLIENTE_PAREJA_COMBO);

        if (collCliente.count() > 0) {
            let objPareja = collCliente.getItem(0);
            objPareja.PROGRAMA = 2;
            objPareja.ID_PROCESO_LSO = objProcesoLSO.ID;

            objPareja.PROCESO_LSO_CLIENTE_TITULAR = selfEsTitular ? 0 : 1;

            await objPareja.save();
        }
    }

    objself.MAP_IDPROGRAMA = 2; 
    objself.MAP_MOSTRAR_MODALIDAD_NUEVO_LSO = 0;
    await objself.save();

    ui.showToast("Proceso LSO activado");
}

function cancelarNuevoProcesoLSO(objself) {
    objself.MAP_MOSTRAR_MODALIDAD_NUEVO_LSO = 0;
    objself.PROGRAMA = objself.MAP_IDPROGRAMA;
}

function colorBotonesProcesoLSOAfterEdit(objself) {
    // Colores iniciales equipo asesores
    objself.MAP_COLOR_EQUIPO_BT_TITULAR = "#FF795A"; // Naranja (Seleccionado)
    objself.MAP_COLOR_EQUIPO_BT_PAREJA = "#3E2554";  // Morado
    
    // Colores botones memoria
    objself.MAP_COLOR_DATOS_MEMORIA_BT_CONJUNTA = "#FF795A";
    objself.MAP_COLOR_DATOS_MEMORIA_BT_TITULAR = "#3E2554";
    objself.MAP_COLOR_DATOS_MEMORIA_BT_PAREJA = "#3E2554";
    
    // color botones deuda
    objself.MAP_COLOR_DEUDA_BT_CONJUNTA = "#FF795A";
    objself.MAP_COLOR_DEUDA_BT_TITULAR = "#3E2554";
    objself.MAP_COLOR_DEUDA_BT_PAREJA = "#3E2554";
    
    // color botones documentos
    objself.MAP_COLOR_DOCUMENTOS_BT_CONJUNTA = "#FF795A";
    objself.MAP_COLOR_DOCUMENTOS_BT_TITULAR = "#3E2554";
    objself.MAP_COLOR_DOCUMENTOS_BT_PAREJA = "#3E2554";
}

// funciones para cargar el equipo asignado de los clientes en una conjunta o por defecto del titular
async function cargarAsesoresClienteProcesoLSO(objself,idcliente) {
    
    // 1. Lógica de colores (Toggle)
    if (idcliente == objself.MAP_IDLEAD_TITULAR) {
        objself.MAP_COLOR_EQUIPO_BT_TITULAR = "#FF795A"; // Naranja
        objself.MAP_COLOR_EQUIPO_BT_PAREJA = "#3E2554";  // Morado
    } else {
        objself.MAP_COLOR_EQUIPO_BT_TITULAR = "#3E2554"; // Morado
        objself.MAP_COLOR_EQUIPO_BT_PAREJA = "#FF795A";  // Naranja
    }
    
    let objCliente = await obtenerPrimerObjetoColl("ClienteScript","c.ID=" + idcliente);
    
    if(objCliente) {
        let objARD = await obtenerPrimerObjetoColl("UsuariosScript","u.ID=" + objCliente.IDASESOR);
        let objESC = await obtenerPrimerObjetoColl("UsuariosScript","u.ID=" + objCliente.IDESC);
        let objNT = await obtenerPrimerObjetoColl("UsuariosScript","u.ID=" + objCliente.IDNT);
        let objNR = await obtenerPrimerObjetoColl("UsuariosScript","u.ID=" + objCliente.IDNR);
        
        objself.MAP_ARD = objARD ? objARD.LOGIN : "";
        objself.MAP_NT = objESC ? objESC.LOGIN : "";
        objself.MAP_NR = objNT ? objNT.LOGIN : "";
        objself.MAP_ESC = objNR ? objNR.LOGIN : "";
    }
}

async function comprobarDocumentosDeudaCero(objself, rowidcliente) {
    
    let objDocumento = await obtenerPrimerObjetoColl("DocumentoScript","ifnull(d.BAJA,0)=0 AND d.ROWID_LEAD = '" + rowidcliente + "' AND d.IDTIPO in(62,65) AND ifnull(d.ID_CLIENTE_DATOS_SANCIONES_HACIENDA,0)=0");
    
    objself.MAP_IMG_DOCUMENTACION_SANCION_HACIENDA = objDocumento ? "deudaVerde.png" : "deudaGris.png";
}


// funciones para cargar datos de los clientes en una conjunta o por defecto del titular
async function cargarDatosGeneralesClienteProcesoLSO(objself,idcliente) {
    
    // Almacenamos el ID del cliente que estamos visualizando actualmente para poder guardarlo después
    objself.MAP_ID_CLIENTE_SELECCIONADO = idcliente;
    
    // 1. Lógica de colores (Toggle)
    if (idcliente == objself.MAP_IDLEAD_TITULAR) {
        objself.MAP_COLOR_DATOS_BT_TITULAR = "#FF795A"; // Naranja
        objself.MAP_COLOR_DATOS_BT_PAREJA = "#3E2554";  // Morado
        // indicamos el correo y rowid del cliente seleccionado para poder subir sus documentos
        objself.MAP_CORREO_CLIENTE_ACTUAL = objself.MAP_CORREO_TITULAR;
        objself.MAP_ROWID_CLIENTE_ACTUAL = objself.MAP_ROWID_CLIENTE_TITULAR;
    } else {
        objself.MAP_COLOR_DATOS_BT_TITULAR = "#3E2554"; // Morado
        objself.MAP_COLOR_DATOS_BT_PAREJA = "#FF795A";  // Naranja
        objself.MAP_CORREO_CLIENTE_ACTUAL = objself.MAP_CORREO_PAREJA;
        objself.MAP_ROWID_CLIENTE_ACTUAL = objself.MAP_ROWID_CLIENTE_PAREJA;
    }
    
    let objCliente = await obtenerPrimerObjetoColl("ProcesoLSOClienteDatosScript","c.ID=" + idcliente);
    
    if(objCliente) {
        
        // Datos de contacto
        objself.MAP_NOMBRE = objCliente.NOMBRE;
        objself.MAP_APELLIDOS = objCliente.APELLIDOS;
        objself.MAP_PREFIJO = objCliente.PREFIJO;
        objself.MAP_MOVIL = objCliente.MOVIL;
        objself.MAP_CORREO_CLIENTE = objCliente.CORREO;
        objself.MAP_DNI = objCliente.DNI;
        
        // Domicilio
        objself.MAP_DOMICILIO = objCliente.MAP_DOMICILIO;
        objself.MAP_CALLE = objCliente.CALLE;
        objself.MAP_NUMCALLE = objCliente.NUMCALLE;
        objself.MAP_NUMPISO = objCliente.NUMPISO;
        objself.MAP_CP = objCliente.CP;
        objself.MAP_LOCALIDAD = objCliente.LOCALIDAD;
        objself.MAP_VIVIENDA_SITUACION = objCliente.MAP_VIVIENDA_SITUACION;
        objself.MAP_VIVIENDA_ID_SITUACION = objCliente.VIVIENDA_ID_SITUACION;
        objself.MAP_VIVIENDA_IMPORTE_MENSUAL = objCliente.VIVIENDA_IMPORTE_MENSUAL;
        objself.MAP_VIVIENDA_OBSERVACIONES = objCliente.VIVIENDA_OBSERVACIONES;

        // Datos de programa
        objself.MAP_INGRESOS_MENSUAL = objCliente.INGRESOS_MENSUAL;
        objself.MAP_NUMERO_PAGAS = objCliente.NUMERO_PAGAS;
        objself.MAP_CUOTA_ACTUAL_REPAGO = objCliente.MAP_CUOTA_ACTUAL_REPAGO;
        objself.MAP_SOBREENDEUDAMIENTO = objCliente.MAP_SOBREENDEUDAMIENTO;
        objself.MAP_DATOS_CUOTA_ALIVIA = objCliente.MAP_CUOTA_ALIVIA;
        objself.MAP_SOBREENDEUDAMIENTO_ALIVIA = objCliente.MAP_SOBREENDEUDAMIENTO_ALIVIA;
        objself.MAP_DATOS_DEUDA_FINANCIERA = objCliente.MAP_DATOS_DEUDA_FINANCIERA;
        objself.MAP_DATOS_DEUDA_PUBLICA = objCliente.MAP_DATOS_DEUDA_PUBLICA;
        objself.MAP_DATOS_DEUDA_TOTAL = objCliente.MAP_DATOS_DEUDA_TOTAL;
        objself.MAP_DATOS_GRUPO_PAQUETE_COMISION = objCliente.MAP_DATOS_GRUPO_PAQUETE_COMISION;

        // Datos extra cliente
        objself.MAP_FECHA_NACIMIENTO = objCliente.FECHA_NACIMIENTO;
        objself.MAP_EDAD = objCliente.EDAD;
        objself.MAP_SEXO = objCliente.SEXO;
        objself.MAP_NACIONALIDAD = objCliente.NACIONALIDAD;
        objself.MAP_ESTADO_CIVIL = objCliente.MAP_ESTADO_CIVIL;
        objself.MAP_ID_ESTADO_CIVIL = objCliente.ID_ESTADO_CIVIL;
        objself.MAP_CASADO_REGIMEN_ECONOMICO = objCliente.MAP_CASADO_REGIMEN_ECONOMICO;
        objself.MAP_ID_CASADO_REGIMEN_ECONOMICO = objCliente.ID_CASADO_REGIMEN_ECONOMICO;
        objself.MAP_DIVORCIADO_MEDIDAS_REGULADORAS = objCliente.MAP_DIVORCIADO_MEDIDAS_REGULADORAS;
        objself.MAP_ID_DIVORCIADO_MEDIDAS_REGULADORAS_ECONOMICAS = objCliente.ID_DIVORCIADO_MEDIDAS_REGULADORAS_ECONOMICAS;
        
        objself.MAP_ACREDITA_RESIDENCIA_CHECK = objCliente.ACREDITA_RESIDENCIA_CHECK;
        objself.MAP_ACREDITA_RESIDENCIA = objCliente.MAP_ACREDITA_RESIDENCIA;
        objself.MAP_IDACREDITA_RESIDENCIA = objCliente.MAP_IDACREDITA_RESIDENCIA;
        objself.MAP_ID_DOCUMENTO_ACREDITA_RESIDENCIA = objCliente.MAP_ID_DOCUMENTO_ACREDITA_RESIDENCIA;
        objself.MAP_DOCUMENTO_ACREDITA_RESIDENCIA = objCliente.MAP_DOCUMENTO_ACREDITA_RESIDENCIA;
        objself.MAP_ID_DOCUMENTO_PARTIDA_NACIMIENTO = objCliente.MAP_ID_DOCUMENTO_PARTIDA_NACIMIENTO;
        objself.MAP_DOCUMENTO_PARTIDA_NACIMIENTO = objCliente.MAP_DOCUMENTO_PARTIDA_NACIMIENTO;
        objself.MAP_NIVEL_ACADEMICO = objCliente.NIVEL_ACADEMICO;
        objself.MAP_ID_DOCUMENTO_LSO_PREVIA = objCliente.MAP_ID_DOCUMENTO_LSO_PREVIA;
        objself.MAP_DOCUMENTO_LSO_PREVIA = objCliente.MAP_DOCUMENTO_LSO_PREVIA;
        
        objself.MAP_CONTRATO_TIPO_CHECK = objCliente.CONTRATO_TIPO_CHECK;
        objself.MAP_DATOS_CONTRATO_TIPO = objCliente.MAP_DATOS_CONTRATO_TIPO;
        objself.MAP_ID_CONTRATO_TIPO = objCliente.ID_CONTRATO_TIPO;
        objself.MAP_DATOS_OCUPACION = objCliente.MAP_DATOS_OCUPACION;
        objself.MAP_IDTIPO_OCUPACION = objCliente.IDTIPO_OCUPACION;
        objself.MAP_DATOS_AUTONOMO_SOCIETARIO = objCliente.MAP_DATOS_AUTONOMO_SOCIETARIO;
        objself.MAP_IDAUTONOMO_SOCIETARIO = objCliente.IDAUTONOMO_SOCIETARIO;

        objself.MAP_DISCAPACIDAD_CHECK = objCliente.DISCAPACIDAD_CHECK;
        objself.MAP_DISCAPACIDAD = objCliente.MAP_DISCAPACIDAD;
        objself.MAP_ID_DISCAPACIDAD = objCliente.MAP_ID_DISCAPACIDAD;
        objself.MAP_DISCAPACIDAD_OBSERVACIONES = objCliente.MAP_DISCAPACIDAD_OBSERVACIONES; 

        objself.MAP_FAMILIARES_A_CARGO_CHECK = objCliente.FAMILIARES_A_CARGO_CHECK;
        objself.MAP_MISMO_LIBRO_FAMILIA_PAREJA = objCliente.MISMO_LIBRO_FAMILIA_PAREJA;
        objself.MAP_ID_DOCUMENTO_LIBRO_FAMILIA = objCliente.MAP_ID_DOCUMENTO_LIBRO_FAMILIA;
        objself.MAP_DOCUMENTO_LIBRO_FAMILIA = objCliente.MAP_DOCUMENTO_LIBRO_FAMILIA;
        objself.MAP_ID_DOCUMENTO_CERTIFICADO_ANTECEDENTES_PENALES = objCliente.MAP_ID_DOCUMENTO_CERTIFICADO_ANTECEDENTES_PENALES;
        objself.MAP_DOCUMENTO_CERTIFICADO_ANTECEDENTES_PENALES = objCliente.MAP_DOCUMENTO_CERTIFICADO_ANTECEDENTES_PENALES;
        objself.MAP_ID_DOCUMENTO_CERTIFICADO_VIDA_LABORAL = objCliente.MAP_ID_DOCUMENTO_CERTIFICADO_VIDA_LABORAL;
        objself.MAP_DOCUMENTO_CERTIFICADO_VIDA_LABORAL = objCliente.MAP_DOCUMENTO_CERTIFICADO_VIDA_LABORAL;
        objself.MAP_GASTOS_MENSUAL_SERVICIOS_CHECK = objCliente.GASTOS_MENSUAL_SERVICIOS_CHECK;

        // Información relevante LSO
        objself.MAP_LSO_PREVIA_CHECK = objCliente.LSO_PREVIA_CHECK;
        objself.MAP_LSO_PREVIA_FECHA = objCliente.MAP_LSO_PREVIA_FECHA;
        objself.MAP_LSO_PREVIA_OBSERVACIONES = objCliente.MAP_LSO_PREVIA_OBSERVACIONES;

        objself.MAP_POSEE_ALGUNA_SOCIEDAD_CHECK = objCliente.POSEE_ALGUNA_SOCIEDAD_CHECK;

        objself.MAP_ANTECEDENTES_PENALES_CHECK = objCliente.ANTECEDENTES_PENALES_CHECK;
        objself.MAP_ANTECEDENTES_PENALES_FECHA = objCliente.MAP_ANTECEDENTES_PENALES_FECHA;
        objself.MAP_ANTECEDENTES_PENALES_OBSERVACIONES = objCliente.MAP_ANTECEDENTES_PENALES_OBSERVACIONES;

        objself.MAP_EMBARGOS_ACTIVOS_CHECK = objCliente.EMBARGOS_ACTIVOS_CHECK;
        objself.MAP_SANCIONES_HACIENDA_SS_CHECK = objCliente.SANCIONES_HACIENDA_SS_CHECK;
        objself.MAP_VENTA_DONACION_BIEN_CHECK = objCliente.VENTA_DONACION_BIEN_CHECK; 
        objself.MAP_HERENCIA_CHECK = objCliente.HERENCIA_CHECK;
        objself.MAP_HERENCIA_TIPO = objCliente.MAP_HERENCIA_TIPO;
        
        objself.MAP_ID_DOCUMENTO_CERTIFICADO_CATASTRAL = objCliente.MAP_ID_DOCUMENTO_CERTIFICADO_CATASTRAL;
        objself.MAP_DOCUMENTO_CERTIFICADO_CATASTRAL = objCliente.MAP_DOCUMENTO_CERTIFICADO_CATASTRAL;objself.MAP_HERENCIA_ID_TIPO = objCliente.MAP_HERENCIA_ID_TIPO;
        objself.MAP_HERENCIA_OBSERVACIONES_EDIT = objCliente.MAP_HERENCIA_OBSERVACIONES_EDIT;
        objself.MAP_OTROS_ACTIVOS_CHECK = objCliente.OTROS_ACTIVOS_CHECK;
        objself.MAP_BIENES_INMUEBLES_CHECK = objCliente.BIENES_INMUEBLES_CHECK;
        objself.MAP_COCHE_CHECK = objCliente.COCHE_CHECK;
        
        
        // recargamos los listados con información
        await Promise.all([
            actualizarDatosContent(objself, "ClienteDatosFamiliaresCargo"),
            actualizarDatosContent(objself, "ClienteDatosGastosMensuales"),
            actualizarDatosContent(objself, "ClienteDatosEmbargosActivos"),
            actualizarDatosContent(objself, "ClienteDatosSancionesHaciendaSS"),
            actualizarDatosContent(objself, "ClienteDatosVentaDonacionBien"),
            actualizarDatosContent(objself, "ClienteDatosHerencia"),
            actualizarDatosContent(objself, "ClienteDatosOtrosActivos"),
            actualizarDatosContent(objself, "ClienteDatosInmuebles"),
            actualizarDatosContent(objself, "ClienteDatosVehiculos"),
            actualizarDatosContent(objself, "ClienteVinculo",false,true),
            actualizarDatosContent(objself, "ClienteContactoCorreos"),
            actualizarDatosContent(objself, "ClienteContactoTelefonos"),
        ]);
        
        await comprobarDocumentosDeudaCero(objself,objself.MAP_ROWID_CLIENTE_ACTUAL);
    }
}

// funciones para cargar datos de las memorias de los clientes en una conjunta o por defecto del titular
async function cargarDatosMemoriasClienteProcesoLSO(objself,idcliente) {
    
    let objMemoria;
    
    // Almacenamos el ID del cliente que estamos visualizando actualmente para poder guardarlo después (si guardamos 0, usaremos al guardar el del procesoLSO para caso conjunta)
    objself.MAP_ID_CLIENTE_MEMORIAS_SELECCIONADO = idcliente;
    
    // 1. Lógica de colores (Toggle)
    if(idcliente === 0) {
        // id=0 lo hacemos para identificar que estamos seleccionando la conjunta. Será para el id del proceso
        objself.MAP_COLOR_DATOS_MEMORIA_BT_CONJUNTA = "#FF795A"; // Naranja
        objself.MAP_COLOR_DATOS_MEMORIA_BT_TITULAR = "#3E2554"; // Morado
        objself.MAP_COLOR_DATOS_MEMORIA_BT_PAREJA = "#3E2554";  // Morado
    }
    else if (idcliente == objself.MAP_IDLEAD_TITULAR) {
        objself.MAP_COLOR_DATOS_MEMORIA_BT_CONJUNTA = "#3E2554"; // Morado
        objself.MAP_COLOR_DATOS_MEMORIA_BT_TITULAR = "#FF795A"; // Naranja
        objself.MAP_COLOR_DATOS_MEMORIA_BT_PAREJA = "#3E2554";  // Morado
    } else {
        objself.MAP_COLOR_DATOS_MEMORIA_BT_CONJUNTA = "#3E2554"; // Morado
        objself.MAP_COLOR_DATOS_MEMORIA_BT_TITULAR = "#3E2554"; // Morado
        objself.MAP_COLOR_DATOS_MEMORIA_BT_PAREJA = "#FF795A";  // Naranja
    }
    
    if(idcliente === 0) {
        objMemoria = await obtenerPrimerObjetoColl("ProcesoLSOScript","lso.ID=" + objself.ID);
    } else {
        objMemoria = await obtenerPrimerObjetoColl("ProcesoLSOClienteDatosScript","c.ID=" + idcliente);
    }
    if(objMemoria) {
        // Memorias y resúmenes
        objself.MAP_MEMORIA_HISTORICA = objMemoria.MEMORIA_HISTORICA;
        objself.MAP_MEMORIA_HISTORICA_LSO = objMemoria.MEMORIA_HISTORICA_LSO;
        objself.MAP_RESUMEN_SOCIOECONOMICO = objMemoria.RESUMEN_SOCIOECONOMICO;
    }
}

async function guardarMemoriasProcesoLSO(objself,idcliente) {
    // idcliente=0 será para saber que tenemos que coger el self.ID del proceso y no de un cliente
    let objMemoria;
    if(idcliente === 0) {
        objMemoria = await obtenerPrimerObjetoColl("ProcesoLSOScript","lso.ID=" + objself.ID);
    } else {
        objMemoria = await obtenerPrimerObjetoColl("ProcesoLSOClienteDatosScript","c.ID=" + idcliente);
    }
    if(objMemoria) {
        // Memorias y resúmenes
        objMemoria.MEMORIA_HISTORICA = objself.MAP_MEMORIA_HISTORICA;
        objMemoria.MEMORIA_HISTORICA_LSO = objself.MAP_MEMORIA_HISTORICA_LSO;
        objMemoria.RESUMEN_SOCIOECONOMICO = objself.MAP_RESUMEN_SOCIOECONOMICO;
        await objMemoria.save();
    }
}


function activarEdicionDatosClienteProcesoLSO(objself){

    if( objself.MAP_EDITAR_DATOS_CLIENTE == 1) {
        objself.setFieldPropertyValue("MAP_NOMBRE","bgcolor","#F2F2F2");
        objself.setFieldPropertyValue("MAP_APELLIDOS","bgcolor","#F2F2F2");
        objself.setFieldPropertyValue("MAP_DNI","bgcolor","#F2F2F2");
        objself.setFieldPropertyValue("MAP_PREFIJO","bgcolor","#F2F2F2");
        objself.setFieldPropertyValue("MAP_MOVIL","bgcolor","#F2F2F2");
        objself.setFieldPropertyValue("MAP_CORREO_CLIENTE","bgcolor","#F2F2F2");
        objself.setFieldPropertyValue("MAP_FECHA_NACIMIENTO","bgcolor","#F2F2F2");
        objself.setFieldPropertyValue("MAP_SEXO","bgcolor","#F2F2F2");
        objself.setFieldPropertyValue("MAP_NACIONALIDAD","bgcolor","#F2F2F2");
        objself.setFieldPropertyValue("MAP_ESTADO_CIVIL","bgcolor","#F2F2F2");
        objself.setFieldPropertyValue("MAP_CASADO_REGIMEN_ECONOMICO","bgcolor","#F2F2F2");
        objself.setFieldPropertyValue("MAP_DIVORCIADO_MEDIDAS_REGULADORAS","bgcolor","#F2F2F2");
        objself.setFieldPropertyValue("MAP_HIJOS","bgcolor","#F2F2F2");
        objself.setFieldPropertyValue("MAP_NIVEL_ACADEMICO","bgcolor","#F2F2F2");
        objself.setFieldPropertyValue("MAP_DATOS_OCUPACION","bgcolor","#F2F2F2");
        objself.setFieldPropertyValue("MAP_CALLE","bgcolor","#F2F2F2");
        objself.setFieldPropertyValue("MAP_NUMCALLE","bgcolor","#F2F2F2");
        objself.setFieldPropertyValue("MAP_NUMPISO","bgcolor","#F2F2F2");
        objself.setFieldPropertyValue("MAP_CP","bgcolor","#F2F2F2");
        objself.setFieldPropertyValue("MAP_LOCALIDAD","bgcolor","#F2F2F2");
        objself.setFieldPropertyValue("MAP_CUOTA_ACTUAL_REPAGO","bgcolor","#F2F2F2");
        objself.setFieldPropertyValue("MAP_INGRESOS_MENSUAL","bgcolor","#F2F2F2");
        objself.setFieldPropertyValue("MAP_NUMERO_PAGAS","bgcolor","#F2F2F2");

        if(objself.MAP_ACREDITA_RESIDENCIA_CHECK == 1) {
            objself.setFieldPropertyValue("MAP_ACREDITA_RESIDENCIA","bgcolor","#F2F2F2");
        }
        objself.setFieldPropertyValue("MAP_DATOS_CONTRATO_TIPO","bgcolor","#F2F2F2");
        if(objself.MAP_DISCAPACIDAD_CHECK == 1) {
            objself.setFieldPropertyValue("MAP_DISCAPACIDAD","bgcolor","#F2F2F2");
            objself.setFieldPropertyValue("MAP_DISCAPACIDAD_OBSERVACIONES","bgcolor","#F2F2F2");
        }
        if(objself.MAP_LSO_PREVIA_CHECK == 1) {
            objself.setFieldPropertyValue("MAP_LSO_PREVIA_FECHA","bgcolor","#F2F2F2");
            objself.setFieldPropertyValue("MAP_LSO_PREVIA_OBSERVACIONES","bgcolor","#F2F2F2");
        }
        if(objself.MAP_ANTECEDENTES_PENALES_CHECK == 1) {
            objself.setFieldPropertyValue("MAP_ANTECEDENTES_PENALES_FECHA","bgcolor","#F2F2F2");
            objself.setFieldPropertyValue("MAP_ANTECEDENTES_PENALES_OBSERVACIONES","bgcolor","#F2F2F2");
        }
        if(objself.MAP_HERENCIA_CHECK == 1) {
            objself.setFieldPropertyValue("MAP_HERENCIA_TIPO","bgcolor","#F2F2F2");
            objself.setFieldPropertyValue("MAP_HERENCIA_OBSERVACIONES_EDIT","bgcolor","#F2F2F2");
        }
        objself.setFieldPropertyValue("MAP_VIVIENDA_SITUACION","bgcolor","#F2F2F2");
        objself.setFieldPropertyValue("MAP_VIVIENDA_IMPORTE_MENSUAL","bgcolor","#F2F2F2");
        objself.setFieldPropertyValue("MAP_VIVIENDA_OBSERVACIONES","bgcolor","#F2F2F2");
        objself.setFieldPropertyValue("MAP_DATOS_AUTONOMO_SOCIETARIO","bgcolor","#F2F2F2");
    }else {
        objself.setFieldPropertyValue("MAP_NOMBRE","bgcolor","#D2D2D2");
        objself.setFieldPropertyValue("MAP_APELLIDOS","bgcolor","#D2D2D2");
        objself.setFieldPropertyValue("MAP_DNI","bgcolor","#D2D2D2");
        objself.setFieldPropertyValue("MAP_PREFIJO","bgcolor","#D2D2D2");
        objself.setFieldPropertyValue("MAP_MOVIL","bgcolor","#D2D2D2");
        objself.setFieldPropertyValue("MAP_CORREO_CLIENTE","bgcolor","#D2D2D2");
        objself.setFieldPropertyValue("MAP_FECHA_NACIMIENTO","bgcolor","#D2D2D2");
        objself.setFieldPropertyValue("MAP_SEXO","bgcolor","#D2D2D2");
        objself.setFieldPropertyValue("MAP_NACIONALIDAD","bgcolor","#D2D2D2");
        objself.setFieldPropertyValue("MAP_ESTADO_CIVIL","bgcolor","#D2D2D2");
        objself.setFieldPropertyValue("MAP_CASADO_REGIMEN_ECONOMICO","bgcolor","#D2D2D2");
        objself.setFieldPropertyValue("MAP_DIVORCIADO_MEDIDAS_REGULADORAS","bgcolor","#D2D2D2");
        objself.setFieldPropertyValue("MAP_HIJOS","bgcolor","#D2D2D2");
        objself.setFieldPropertyValue("MAP_NIVEL_ACADEMICO","bgcolor","#D2D2D2");
        objself.setFieldPropertyValue("MAP_DATOS_OCUPACION","bgcolor","#D2D2D2");
        objself.setFieldPropertyValue("MAP_CALLE","bgcolor","#D2D2D2");
        objself.setFieldPropertyValue("MAP_NUMCALLE","bgcolor","#D2D2D2");
        objself.setFieldPropertyValue("MAP_NUMPISO","bgcolor","#D2D2D2");
        objself.setFieldPropertyValue("MAP_CP","bgcolor","#D2D2D2");
        objself.setFieldPropertyValue("MAP_LOCALIDAD","bgcolor","#D2D2D2");
        objself.setFieldPropertyValue("MAP_VIVIENDA_SITUACION","bgcolor","#D2D2D2");
        objself.setFieldPropertyValue("MAP_VIVIENDA_IMPORTE_MENSUAL","bgcolor","#D2D2D2");
        objself.setFieldPropertyValue("MAP_VIVIENDA_OBSERVACIONES","bgcolor","#D2D2D2");
        objself.setFieldPropertyValue("MAP_CUOTA_ACTUAL_REPAGO","bgcolor","#D2D2D2");
        objself.setFieldPropertyValue("MAP_INGRESOS_MENSUAL","bgcolor","#D2D2D2");
        objself.setFieldPropertyValue("MAP_NUMERO_PAGAS","bgcolor","#D2D2D2");
        objself.setFieldPropertyValue("MAP_ACREDITA_RESIDENCIA","bgcolor","#D2D2D2");
        objself.setFieldPropertyValue("MAP_DATOS_CONTRATO_TIPO","bgcolor","#D2D2D2");
        objself.setFieldPropertyValue("MAP_DISCAPACIDAD","bgcolor","#D2D2D2");
        objself.setFieldPropertyValue("MAP_DISCAPACIDAD_OBSERVACIONES","bgcolor","#D2D2D2");
        objself.setFieldPropertyValue("MAP_LSO_PREVIA_FECHA","bgcolor","#D2D2D2");
        objself.setFieldPropertyValue("MAP_LSO_PREVIA_OBSERVACIONES","bgcolor","#D2D2D2");
        objself.setFieldPropertyValue("MAP_ANTECEDENTES_PENALES_FECHA","bgcolor","#D2D2D2");
        objself.setFieldPropertyValue("MAP_ANTECEDENTES_PENALES_OBSERVACIONES","bgcolor","#D2D2D2");
        objself.setFieldPropertyValue("MAP_DATOS_AUTONOMO_SOCIETARIO","bgcolor","#D2D2D2");
        objself.setFieldPropertyValue("MAP_HERENCIA_TIPO","bgcolor","#D2D2D2");
        objself.setFieldPropertyValue("MAP_HERENCIA_OBSERVACIONES_EDIT","bgcolor","#D2D2D2");
    }
}

async function guardarDatosGeneralesProcesoLSO(objself) {
    let error = "", objResidencia, objDiscapacidad, objLsoPrevia, objAntecedentes, objPoseeSociedad;
    let idCliente = objself.MAP_ID_CLIENTE_SELECCIONADO;
    
    if (safeToInt(idCliente) === 0) {
        ui.showToast("No se ha identificado el cliente a guardar.");
        return;
    }

    // Comprobaciones
    if(objself.MAP_ACREDITA_RESIDENCIA_CHECK == 1 && safeToInt(objself.MAP_IDACREDITA_RESIDENCIA) === 0){
        error = "Debe indicar una opción para 'acredita residencia en España'.";
    }
    if(objself.MAP_DISCAPACIDAD_CHECK == 1 && safeToInt(objself.MAP_ID_DISCAPACIDAD) === 0){
        error = (error !== "" ? error + " " : "") + "Debe indicar un porcentaje de discapacidad.";
    }
    
    if(error !== "") {
        await ui.msgBox(error,"Datos cliente",0);
        return;
    }

    // 1. Cargamos el objeto cliente principal
    let collCliente = appData.getCollection("ClienteScript");
    await filtrarCollMacroObject(collCliente, "c.ID=" + idCliente);
    if (collCliente.count() === 0) {
        ui.showToast("No se ha encontrado el cliente en la base de datos.");
        return;
    }
    let objCliente = collCliente.getItem(0);

    // Mapeamos campos básicos
    objCliente.NOMBRE = objself.MAP_NOMBRE;
    objCliente.APELLIDOS = objself.MAP_APELLIDOS;
    objCliente.DNI = objself.MAP_DNI;
    objCliente.PREFIJO = objself.MAP_PREFIJO;
    objCliente.MOVIL = objself.MAP_MOVIL;
    objCliente.CORREO = objself.MAP_CORREO_CLIENTE;
    objCliente.FECHA_NACIMIENTO = objself.MAP_FECHA_NACIMIENTO;
    objCliente.SEXO = objself.MAP_SEXO; 
    objCliente.NACIONALIDAD = objself.MAP_NACIONALIDAD; 
    objCliente.ID_ESTADO_CIVIL = objself.MAP_ID_ESTADO_CIVIL;
    objCliente.ID_CASADO_REGIMEN_ECONOMICO = objself.MAP_ID_CASADO_REGIMEN_ECONOMICO;
    objCliente.ID_DIVORCIADO_MEDIDAS_REGULADORAS_ECONOMICAS = objself.MAP_ID_DIVORCIADO_MEDIDAS_REGULADORAS_ECONOMICAS;
    objCliente.NIVEL_ACADEMICO = objself.MAP_NIVEL_ACADEMICO;
    objCliente.ID_CONTRATO_TIPO = objself.MAP_ID_CONTRATO_TIPO;
    objCliente.IDTIPO_OCUPACION = objself.MAP_IDTIPO_OCUPACION;
    objCliente.IDAUTONOMO_SOCIETARIO = objself.MAP_IDAUTONOMO_SOCIETARIO;
    objCliente.INGRESOS_MENSUAL = objself.MAP_INGRESOS_MENSUAL;
    objCliente.NUMERO_PAGAS = objself.MAP_NUMERO_PAGAS;
    objCliente.CUOTA_ACTUAL_REPAGO = objself.MAP_CUOTA_ACTUAL_REPAGO;
    
    // Domicilio
    objCliente.CALLE = objself.MAP_CALLE;
    objCliente.NUMCALLE = objself.MAP_NUMCALLE;
    objCliente.NUMPISO = objself.MAP_NUMPISO;
    objCliente.CP = objself.MAP_CP;
    objCliente.LOCALIDAD = objself.MAP_LOCALIDAD;
    objCliente.VIVIENDA_ID_SITUACION = objself.MAP_VIVIENDA_ID_SITUACION;
    objCliente.VIVIENDA_IMPORTE_MENSUAL = objself.MAP_VIVIENDA_IMPORTE_MENSUAL;
    objCliente.VIVIENDA_OBSERVACIONES = objself.MAP_VIVIENDA_OBSERVACIONES;

    // Checks
    objCliente.ACREDITA_RESIDENCIA_CHECK = objself.MAP_ACREDITA_RESIDENCIA_CHECK;
    objCliente.CONTRATO_TIPO_CHECK = objself.MAP_CONTRATO_TIPO_CHECK;
    objCliente.DISCAPACIDAD_CHECK = objself.MAP_DISCAPACIDAD_CHECK;
    objCliente.LSO_PREVIA_CHECK = objself.MAP_LSO_PREVIA_CHECK;
    objCliente.ANTECEDENTES_PENALES_CHECK = objself.MAP_ANTECEDENTES_PENALES_CHECK;
    objCliente.POSEE_ALGUNA_SOCIEDAD_CHECK = objself.MAP_POSEE_ALGUNA_SOCIEDAD_CHECK;
    objCliente.FAMILIARES_A_CARGO_CHECK = objself.MAP_FAMILIARES_A_CARGO_CHECK;
    objCliente.MISMO_LIBRO_FAMILIA_PAREJA = objself.MAP_MISMO_LIBRO_FAMILIA_PAREJA;
    objCliente.GASTOS_MENSUAL_SERVICIOS_CHECK = objself.MAP_GASTOS_MENSUAL_SERVICIOS_CHECK;
    objCliente.HERENCIA_CHECK = objself.MAP_HERENCIA_CHECK;
    objCliente.HERENCIA_ID_TIPO = objself.MAP_HERENCIA_ID_TIPO;
    objCliente.HERENCIA_OBSERVACIONES = objself.MAP_HERENCIA_OBSERVACIONES_EDIT;
    objCliente.EMBARGOS_ACTIVOS_CHECK = objself.MAP_EMBARGOS_ACTIVOS_CHECK;
    objCliente.SANCIONES_HACIENDA_SS_CHECK = objself.MAP_SANCIONES_HACIENDA_SS_CHECK;
    objCliente.VENTA_DONACION_BIEN_CHECK = objself.MAP_VENTA_DONACION_BIEN_CHECK;
    objCliente.OTROS_ACTIVOS_CHECK = objself.MAP_OTROS_ACTIVOS_CHECK;
    objCliente.BIENES_INMUEBLES_CHECK = objself.MAP_BIENES_INMUEBLES_CHECK;
    objCliente.COCHE_CHECK = objself.MAP_COCHE_CHECK;

    await objCliente.save();

    // 2. Tablas relacionadas
    
    // Acredita residencia
    let collResidencia = appData.getCollection("ClienteDatosAcreditaResidenciaScript");
    await filtrarCollMacroObject(collResidencia, "IDLEAD=" + idCliente);
    objResidencia = collResidencia.count() > 0 ? collResidencia.getItem(0) : await collResidencia.createObject();
    objResidencia.IDLEAD = idCliente;
    objResidencia.ID_ACREDITA_RESIDENCIA = objself.MAP_IDACREDITA_RESIDENCIA;
    await objResidencia.save();
    
    // Discapacidad
    let collDiscapacidad = appData.getCollection("ClienteDatosDiscapacidadScript");
    await filtrarCollMacroObject(collDiscapacidad, "IDLEAD=" + idCliente);
    objDiscapacidad = collDiscapacidad.count() > 0 ? collDiscapacidad.getItem(0) : await collDiscapacidad.createObject();
    objDiscapacidad.IDLEAD = idCliente;
    objDiscapacidad.ID_DISCAPACIDAD = objself.MAP_ID_DISCAPACIDAD;
    objDiscapacidad.OBSERVACIONES = objself.MAP_DISCAPACIDAD_OBSERVACIONES;
    await objDiscapacidad.save();
    
    // LSO Previa
    let collDatosLsoPrevia = appData.getCollection("ClienteDatosLsoPreviaScript");
    await filtrarCollMacroObject(collDatosLsoPrevia, "IDLEAD=" + idCliente);
    objLsoPrevia = collDatosLsoPrevia.count() > 0 ? collDatosLsoPrevia.getItem(0) : await collDatosLsoPrevia.createObject();
    objLsoPrevia.IDLEAD = idCliente;
    objLsoPrevia.FECHA = objself.MAP_LSO_PREVIA_FECHA;
    objLsoPrevia.OBSERVACIONES = objself.MAP_LSO_PREVIA_OBSERVACIONES;
    await objLsoPrevia.save();
    
    // Antecedentes Penales
    let collAntecedentesPenales = appData.getCollection("ClienteDatosAntecedentesPenalesScript");
    await filtrarCollMacroObject(collAntecedentesPenales, "IDLEAD=" + idCliente);
    objAntecedentes = collAntecedentesPenales.count() > 0 ? collAntecedentesPenales.getItem(0) : await collAntecedentesPenales.createObject();
    objAntecedentes.IDLEAD = idCliente;
    objAntecedentes.FECHA = objself.MAP_ANTECEDENTES_PENALES_FECHA;
    objAntecedentes.OBSERVACIONES = objself.MAP_ANTECEDENTES_PENALES_OBSERVACIONES;
    await objAntecedentes.save();
    
    

    // Finalización
    objself.MAP_EDITAR_DATOS_CLIENTE = 0;
    activarEdicionDatosClienteProcesoLSO(objself);
    
    // Refrescamos los datos en pantalla para asegurar consistencia
    cargarDatosGeneralesCliente(objself, idCliente);
    
    ui.showToast("Datos guardados correctamente.");
}


// funciones para cargar datos de las memorias de los clientes en una conjunta o por defecto del titular
async function cargarDeudasClienteProcesoLSO(objself,idcliente) {

    // 1. Lógica de colores (Toggle)
    if(idcliente === 0) {
        // id=0 lo hacemos para identificar que estamos seleccionando la conjunta. Será para el id del proceso
        objself.MAP_COLOR_DEUDA_BT_CONJUNTA = "#FF795A"; // Naranja
        objself.MAP_COLOR_DEUDA_BT_TITULAR = "#3E2554"; // Morado
        objself.MAP_COLOR_DEUDA_BT_PAREJA = "#3E2554";  // Morado
    }
    else if (idcliente == objself.MAP_IDLEAD_TITULAR) {
        objself.MAP_COLOR_DEUDA_BT_CONJUNTA = "#3E2554"; // Morado
        objself.MAP_COLOR_DEUDA_BT_TITULAR = "#FF795A"; // Naranja
        objself.MAP_COLOR_DEUDA_BT_PAREJA = "#3E2554";  // Morado
    } else {
        objself.MAP_COLOR_DEUDA_BT_CONJUNTA = "#3E2554"; // Morado
        objself.MAP_COLOR_DEUDA_BT_TITULAR = "#3E2554"; // Morado
        objself.MAP_COLOR_DEUDA_BT_PAREJA = "#FF795A";  // Naranja
    }
    
    objself.MAP_ID_CLIENTE_DEUDA_SELECCIONADO = idcliente;
    objself.MAP_VER_DEUDA = 0;
    objself.MAP_IDDEUDA = 0;
    await actualizarDatosContent(objself,"ProcesoLSODeudaCliente");
}

async function cargarDocumentoProcesoLSO(objself,rowidcliente) {
    
    // 1. Lógica de colores (Toggle)
    if(rowidcliente === objself.ROWID) {
        // id=0 lo hacemos para identificar que estamos seleccionando la conjunta. Será para el id del proceso
        objself.MAP_COLOR_DOCUMENTOS_BT_CONJUNTA = "#FF795A"; // Naranja
        objself.MAP_COLOR_DOCUMENTOS_BT_TITULAR = "#3E2554"; // Morado
        objself.MAP_COLOR_DOCUMENTOS_BT_PAREJA = "#3E2554";  // Morado
    }
    else if (rowidcliente == objself.MAP_ROWID_CLIENTE_TITULAR) {
        objself.MAP_COLOR_DOCUMENTOS_BT_CONJUNTA = "#3E2554"; // Morado
        objself.MAP_COLOR_DOCUMENTOS_BT_TITULAR = "#FF795A"; // Naranja
        objself.MAP_COLOR_DOCUMENTOS_BT_PAREJA = "#3E2554";  // Morado
    } else {
        objself.MAP_COLOR_DOCUMENTOS_BT_CONJUNTA = "#3E2554"; // Morado
        objself.MAP_COLOR_DOCUMENTOS_BT_TITULAR = "#3E2554"; // Morado
        objself.MAP_COLOR_DOCUMENTOS_BT_PAREJA = "#FF795A";  // Naranja
    }
    
    objself.MAP_ROWID_CLIENTE_DOCUMENTOS_SELECCIONADO = rowidcliente;
    await actualizarDatosPaginadoLeads(objself,"ProcesoLSODocumento","ProcesoLSODocumentoContador","MAP_PAG_INI_DOC","MAP_PAG_LEN_DOC","MAP_TOTAL_REGISTROS_DOC","MAP_T1_DOC");
    await actualizarDatosContent(objself,"ProcesoDocumentoPersonal");
}


async function refrescarTodasDocumentacionesPrevias(objself) {
    await Promise.all([
        actualizarDatosContent(objself, "ProcesoLSODocumentacionPrevia", true, true),
        actualizarDatosContent(objself, "ProcesoLSODocumentacionPreviaCliente1", true, true),
    ]);
    if (safeToInt(objself.MAP_IDLEAD_PAREJA) > 0) {
        await actualizarDatosContent(objself, "ProcesoLSODocumentacionPreviaCliente2", true, true);
    }
}

// Funciones de las mensajes de wpp

// cargarChatMensajeria() en functions.js


// se lanza cuando se llama a cargarChatMensajeria() desde las pestañas o webhookcargarChatMensajeria
var _objMensajeriaList = null;
var _objClienteEdicionChat = null;
var _agregarMensajeProgramado = false;
var _actualizandoListado = false;




/**
 * Elimina todas las etiquetas HTML de un texto y devuelve solo el contenido
 * @param {string} html - Texto con etiquetas HTML
 * @returns {string} - Texto limpio sin HTML
 */

function comprobarMensajesNuevos(objself) {
    

    let pestanyaValida = false;

    // si estamos en otras pestañas a las indicadas, contaremos los mensajes recibidos
    switch (objself.getOwnerCollection().getName()) {
        case "LeadEdicion":
            pestanyaValida = (objself.MAP_PESTANYA != 5);
            break;
        case "ClienteEdicion":
            pestanyaValida = (objself.MAP_PESTANYA != 7);
            break;
        default:
            // si hay otros casos, decides qué hacer o dejar false
            pestanyaValida = false;
    }

    if (pestanyaValida) {
        if (objself.MAP_NUEVO_MENSAJE_TOTAL === 0) {
            objself.MAP_NUEVO_MENSAJE_TOTAL = 1;
        } else {
            objself.MAP_NUEVO_MENSAJE_TOTAL += 1;
        }
        objself.MAP_NUEVO_MENSAJE = "(" + objself.MAP_NUEVO_MENSAJE_TOTAL + ")";
    } else {
        objself.MAP_NUEVO_MENSAJE_TOTAL = 0;
        objself.MAP_NUEVO_MENSAJE = "";
    }
}



// =============================================
// SCROLL Y PAGINACIÓN
// =============================================


// Con fluid-load el framework ya carga la pagina anterior al llegar al top.
// Mantenemos un listener propio UNICAMENTE para actualizar el separador de dias.

function buscarGridScrollable(objself) {
    let view = ui.getView(objself);
    if (!view) { ("[buscarGrid] no view, reintento"); ui.executeActionAfterDelay("buscarGridDOM", 1); return; }

    let control = view.getControl("Mensajeria");
    if (!control) { ("[buscarGrid] no control, reintento"); ui.executeActionAfterDelay("buscarGridDOM", 1); return; }

    let gridElement = control.element;
    if (!gridElement) { ("[buscarGrid] no gridElement, reintento"); ui.executeActionAfterDelay("buscarGridDOM", 1); return; }

    let scrollableDiv = gridElement.querySelector('.xone-contents.xone-reverse-column');
    if (!scrollableDiv) { ("[buscarGrid] no scrollableDiv, reintento"); ui.executeActionAfterDelay("buscarGridDOM", 1); return; }

    // setContentsOnReachTop SIEMPRE, aunque el listener ya este añadido
    ui.setContentsOnReachTop("Mensajeria", "cargarMasMensajes");
    ("[buscarGrid] reachTop registrado");

    ("[buscarGrid] scrollListenerAdded:", scrollableDiv._scrollListenerAdded);
    if (scrollableDiv._scrollListenerAdded) return;
    scrollableDiv._scrollListenerAdded = true;

    let _objself = objself;

    scrollableDiv._scrollHandler = function () {
        actualizarSeparadorFlotante(_objself, scrollableDiv);

        if (scrollableDiv.scrollTop < 50) {
            let _view = ui.getView(_objself);
            let _ctrl = _view ? _view.getControl("Mensajeria") : null;
            if (_ctrl) {
                ("[scroll top] " + JSON.stringify({ rowsLength: _ctrl.rowsLength ? _ctrl.rowsLength.value : null, currentCount: _ctrl.contentsRowsInfo ? _ctrl.contentsRowsInfo.value.length : null, allRecordsLoaded: _ctrl.allRecordsLoaded, hasBeenAtBottom: _ctrl._hasBeenAtBottom, reachTopFired: _ctrl._reachTopFired, reverseScroll: _ctrl.reverseScroll, reverseAutoLoad: _ctrl.reverseAutoLoad }));
            }
        }
    };

    scrollableDiv.addEventListener('scroll', scrollableDiv._scrollHandler);
    ("[buscarGrid] listener añadido correctamente");
}

async function scrollAlFondoConReintento(objself) {
    if (objself._navegandoPorBusqueda) return;
    var view = ui.getView(objself);
    if (!view) return;
    var control = view.getControl("Mensajeria");
    if (!control) return;
    var el = control.element
        ? control.element.querySelector('.xone-contents.xone-reverse-column')
        : null;
    if (!el) return;
    setTimeout(function () {
        el.scrollTop = el.scrollHeight;
        el.dispatchEvent(new Event('scroll'));
    }, 1000);
    if (el) actualizarSeparadorFlotante(objself, el);
    // await limpiarHTMLMensajesEnContent(objself);
}


// Simplemente baja al fondo.
// Si el usuario salto a una zona antigua (fluid-load cargo paginas), basta
// con scrollToBottom; el framework ya tiene las filas necesarias.
async function scrollChat(objself) {
    if (objself.MAP_BUSCADOR_MENSAJES_VISIBLE == 1 || objself._macroModificadoPorBusqueda) {
        cerrarBuscadorMensajes(objself);
        objself._macroModificadoPorBusqueda = false;
        await cargarChatMensajeria(objself);
        return;
    }

    let control = ui.getView(objself).getControl("Mensajeria");
    if (control) control.scrollToBottom();
}


function actualizarSeparadorFlotante(objself, scrollableDiv) {
    var filas = scrollableDiv.querySelectorAll('.xone-contents-row');
    if (!filas || filas.length === 0) return;

    var gridRect = scrollableDiv.getBoundingClientRect();
    var topLimite = gridRect.top + 10;

    var filaVisible = null;
    for (var i = 0; i < filas.length; i++) {
        var rect = filas[i].getBoundingClientRect();
        if (rect.bottom > topLimite) {
            filaVisible = filas[i];
            break;
        }
    }
    if (!filaVisible) return;

    var elemFecha = filaVisible.querySelector('[xone-name="MAP_DIA_DOM"]');
    if (!elemFecha) return;
    var textoFecha = elemFecha.textContent ? elemFecha.textContent.trim() : null;
    if (!textoFecha) return;

    if (objself.MAP_SEPARADOR_TEXTO !== textoFecha) {
        objself.MAP_SEPARADOR_TEXTO = textoFecha;
    }
    if (objself.MAP_SEPARADOR_VISIBLE !== 1) {
        objself.MAP_SEPARADOR_VISIBLE = 1;
    }

    if (scrollableDiv._timerOcultarSep) {
        clearTimeout(scrollableDiv._timerOcultarSep);
    }
    scrollableDiv._timerOcultarSep = setTimeout(function () {
        objself.MAP_SEPARADOR_VISIBLE = 0;
    }, 2000);
}

function cargarMasMensajes(objself) {
    let view = ui.getView(objself);
    let control = view ? view.getControl("Mensajeria") : null;
    let el = control && control.element
        ? control.element.querySelector('.xone-contents.xone-reverse-column')
        : null;
    let oldScrollHeight = el ? el.scrollHeight : 0;

    ui.loadContentsOlderRows("Mensajeria");

    if (el) {
        setTimeout(function () {
            let newScrollHeight = el.scrollHeight;
            el.scrollTop = el.scrollTop + (newScrollHeight - oldScrollHeight);
        }, 200);
    }
}

// =============================================
// PAGINACION LISTADO IZQUIERDO
// =============================================

async function paginadoChat(objself, tipo) {
    
    if (tipo === 'ANT') {
        if (objself.MAP_PAG_INI === 0) {
            ui.showToast("Ya estás en la primera página");
            return;
        }
        objself.MAP_PAG_INI = Math.max(0, objself.MAP_PAG_INI - objself.MAP_PAG_LEN);

    } else {
        if (objself.MAP_PAG_INI + objself.MAP_PAG_LEN >= objself.MAP_TOTAL_REGISTROS) {
            ui.showToast("No hay más registros");
            return;
        }
        objself.MAP_PAG_INI = objself.MAP_PAG_INI + objself.MAP_PAG_LEN;
        if (objself.MAP_PAG_INI > objself.MAP_TOTAL_REGISTROS) {
            objself.MAP_PAG_INI = objself.MAP_TOTAL_REGISTROS;
        }
    }

    // Carga manual — sin pasar por actualizarDatosPaginadoLeads
    var cnt = await objself.getContents("MensajeriaChatListado");
    var filter = getFilter(objself, "MensajeriaChatListado");
    var page = { "start": objself.MAP_PAG_INI, "length": objself.MAP_PAG_LEN };

    cnt.unlock();
    cnt.setMacro("##MACRO##", filter);
    cnt.clear();
    await cnt.loadAll(page);
    cnt.lock();

    ui.getView(objself).refresh("MensajeriaChatListado");

    // Label correcto — nadie lo sobreescribe después
    var valorde = objself.MAP_PAG_INI;
    var valorhasta = valorde + objself.MAP_PAG_LEN;
    if (valorhasta > objself.MAP_TOTAL_REGISTROS) valorhasta = objself.MAP_TOTAL_REGISTROS;
    objself.setFieldPropertyValue("MAP_T1", "title",
        "Mostrando registros: De " + valorde + " a " + valorhasta + "/" + objself.MAP_TOTAL_REGISTROS);
}

// =============================================
// TICKS Y ESTADO DE MENSAJES
// =============================================

// para refrescar los ticks de los mensajes según su estado por webhook
async function refescarLineaContentMensaje(objself, idWhatsapp, status, idLeadDestino) {
    var icono = "";
    switch (status) {
        case "sent": icono = "tickGris.png"; break;
        case "delivered": icono = "tickGrisDoble.png"; break;
        case "read": icono = "tickAzulDoble.png"; break;
    }
    if (objself.MAP_IDLEAD_SEL == idLeadDestino) {
        await actualizarIconoEnContent(objself, "Mensajeria", "IDWHATSAPP", idWhatsapp, icono, status);
    }
    if (icono !== "" && idLeadDestino > 0) {
        let cntListado = await objself.getContents("MensajeriaChatListado");
        if (cntListado) {
            for (var j = 0; j < cntListado.count(); j++) {
                let objListado = cntListado.getItem(j);
                if (objListado.MAP_ID == idLeadDestino) {
                    if (objListado.MAP_ICONO_CHECK !== "") {
                        await actualizarIconoEnContent(objself, "MensajeriaChatListado", "MAP_ID", idLeadDestino, icono, null);
                    }
                    break;
                }
            }
        }
    }
}


async function actualizarIconoEnContent(objself, contentName, campoBusqueda, valorBusqueda, icono, status) {
    let cnt = await objself.getContents(contentName);
    if (!cnt) return;
    for (var i = 0; i < cnt.count(); i++) {
        let obj = cnt.getItem(i);
        if (obj[campoBusqueda] == valorBusqueda) {
            obj.MAP_ICONO_CHECK = icono;
            if (status) {
                obj.ESTADO = status;
            }
            await obj.save();

            if (contentName === "Mensajeria") {
                var msgId = obj.ID;
                var iconoFinal = icono;
                var intentarActualizarImagen = function (intentos) {
                    var filas = document.querySelectorAll('.xone-contents-row');
                    for (var r = 0; r < filas.length; r++) {
                        var elemId = filas[r].querySelector('[xone-name="MAP_ID_DOM"]');
                        if (elemId && elemId.textContent.trim() == msgId) {
                            var propCheck = filas[r].querySelector('[xone-name="MAP_CHECK"]');
                            if (!propCheck) {
                                if (intentos > 0) setTimeout(function () { intentarActualizarImagen(intentos - 1); }, 300);
                                return;
                            }
                            var img = propCheck.querySelector('img');
                            if (img) {
                                img.src = 'icons/' + iconoFinal;
                            } else {
                                var newImg = document.createElement('img');
                                newImg.src = 'icons/' + iconoFinal;
                                newImg.style.width = '100%';
                                newImg.style.height = '100%';
                                newImg.style.objectFit = 'contain';
                                propCheck.appendChild(newImg);
                            }
                            return;
                        }
                    }
                    if (intentos > 0) setTimeout(function () { intentarActualizarImagen(intentos - 1); }, 300);
                };
                intentarActualizarImagen(5);
            } else {
                var rows = document.querySelectorAll('[xone-name="' + contentName + '"] .xone-contents-row');
                if (rows[i]) {
                    var img = rows[i].querySelector('[xone-name="MAP_CHECK"] img');
                    if (img) {
                        img.src = 'icons/' + icono;
                        break;
                    }
                }
                ui.refreshContentRow(contentName, i);
            }
            break;
        }
    }
}
// Actualiza el estado del mensaje en BD cuando llega un webhook de delivered/read
// Busca por IDWHATSAPP y actualiza solo si el nuevo estado es superior al actual
async function actualizarEstadoMensajeWA(idWhatsapp, status) {
    let collMS = appData.getCollection("MensajeriaScript");
    let prioritarios = { 'sent': 1, 'delivered': 2, 'read': 3, 'failed': 0 };

    await filtrarCollMacroObject(collMS, "IDWHATSAPP='" + idWhatsapp + "'");

    if (collMS.count() > 0) {
        // Mensaje encontrado por IDWHATSAPP — actualizamos solo si el estado es superior al actual
        let objMsg = collMS.getItem(0);
        if (prioritarios[status] > (prioritarios[objMsg.ESTADO] || 0)) {
            objMsg.ESTADO = status;
            await objMsg.save();
        }
    }
}

// Comprueba si el delivered/read ya llegó antes que el sent (Meta no garantiza el orden)
// Se llama al final del case "sent" para recuperar el tick correcto si llegó desordenado
async function comprobarEstadoPosteriorAlSent(objself, idWhatsapp, idLeadDestino) {
    let collCheck = appData.getCollection("MensajeriaScript");
    await filtrarCollMacroObject(collCheck, "IDWHATSAPP='" + idWhatsapp + "'");

    let estadoActual = collCheck.count() > 0 ? collCheck.getItem(0).ESTADO : null;

    if (estadoActual === "delivered" || estadoActual === "read") {
        await actualizarEstadoMensajeWA(idWhatsapp, estadoActual);
        await refescarLineaContentMensaje(objself, idWhatsapp, estadoActual, idLeadDestino);
    } else {
        // No hay estado superior — al menos refrescamos con tickGris
        await refescarLineaContentMensaje(objself, idWhatsapp, "sent", idLeadDestino);
    }
}

// =============================================
// UTILIDADES
// =============================================

// formateo de hora para mostrar
// DESPUÉS:
function convertirHora(timestampSegundos) {
    const fecha = new Date(timestampSegundos * 1000);
    const dia = fecha.getDate().toString().padStart(2, '0');
    const mes = (fecha.getMonth() + 1).toString().padStart(2, '0');
    const horas = fecha.getHours().toString().padStart(2, '0');
    const minutos = fecha.getMinutes().toString().padStart(2, '0');
    return dia + "/" + mes + " " + horas + ":" + minutos;
}

function limpiarHTML(html) {
    if (!html) return "";

    // Crea un elemento temporal para parsear el HTML
    let temp = document.createElement("div");
    temp.innerHTML = html;

    // Extrae solo el texto sin etiquetas
    let textoLimpio = temp.textContent || temp.innerText || "";

    // Limpia espacios extra y saltos de línea múltiples
    textoLimpio = textoLimpio.trim().replace(/\s+/g, ' ');

    return textoLimpio;
}

/**
 * Convierte URLs en texto plano a hipervínculos HTML clicables
 */


/**
 * Limpia el HTML de todos los mensajes del bot ya guardados en BD
 * Se ejecuta una sola vez para migrar datos históricos
 */
// function filtrarCollSync(coll, filter) {
//     coll.unlock();
//     coll.setMacro("##MACRO##", filter);
//     coll.clear();
//     coll.loadAll();
//     coll.lock();
// }

// /**
//  * Limpia el HTML de todos los mensajes del bot ya guardados en BD
//  * Se ejecuta una sola vez para migrar datos históricos
//  */
// /**
//  * Limpia el HTML de todos los mensajes del bot ya guardados en BD
//  * EJECUTAR UNA SOLA VEZ desde consola del navegador
//  */
// function limpiarMensajesBotHistoricos() {
//     let totalLimpiados = 0;
//     let totalProcesados = 0;

//     ("=== INICIANDO LIMPIEZA DE MENSAJES ===");

//     // 1. Obtenemos todos los mensajes del bot tipo texto
//     let collMensajes = appData.getCollection("MensajeriaScript");
//     collMensajes.unlock();
//     collMensajes.setMacro("##MACRO##", "ORIGIN='bot' AND TIPO='text'");
//     collMensajes.clear();
//     collMensajes.loadAll();
//     collMensajes.lock();

//     ("Mensajes del bot (tipo texto): " + collMensajes.count());

//     // 2. Para cada mensaje del bot, buscamos su texto y lo limpiamos
//     for (let i = 0; i < collMensajes.count(); i++) {
//         let objMsg = collMensajes.getItem(i);
//         totalProcesados++;

//         // Obtenemos el texto de este mensaje
//         let collTexto = appData.getCollection("MensajeriaTextoScript");
//         collTexto.unlock();
//         collTexto.setMacro("##MACRO##", "IDMENSAJE=" + objMsg.ID);
//         collTexto.clear();
//         collTexto.loadAll();
//         collTexto.lock();

//         if (collTexto.count() > 0) {
//             let objTexto = collTexto.getItem(0);
//             let textoOriginal = objTexto.TEXT;

//             // Solo procesamos si contiene etiquetas HTML
//             if (textoOriginal && textoOriginal.indexOf('<') !== -1) {
//                 let textoLimpio = limpiarHTML(textoOriginal);

//                 // Actualizamos solo si el texto cambió
//                 if (textoLimpio !== textoOriginal) {
//                     objTexto.TEXT = textoLimpio;
//                     objTexto.save();
//                     totalLimpiados++;

//                     ("Mensaje ID:" + objMsg.ID + " limpiado:");
//                     ("  Antes: " + textoOriginal.substring(0, 80) + "...");
//                     ("  Después: " + textoLimpio);
//                 }
//             }
//         }

//         // Feedback cada 10 mensajes
//         if (i > 0 && i % 10 === 0) {
//             ("Progreso: " + i + "/" + collMensajes.count());
//         }
//     }

//     ui.showToast("Procesados: " + totalProcesados + " | Limpiados: " + totalLimpiados);
//     ("=== LIMPIEZA COMPLETADA ===");
//     ("Mensajes del bot procesados: " + totalProcesados);
//     ("Mensajes con HTML limpiados: " + totalLimpiados);
// }

/**
 * Recorre el content Mensajeria y limpia el HTML de los mensajes que aún lo tengan.
 * Actualiza tanto el objeto en memoria como la BD para que la próxima carga ya venga limpia.
 * Llamar después de cualquier carga/recarga del content.
 */
async function limpiarHTMLMensajesEnContent(objself) {
    var cnt = await objself.getContents("Mensajeria");
    if (!cnt) return;

    var hayCambios = false;

    for (var i = 0; i < cnt.count(); i++) {
        var objMsg = cnt.getItem(i);
        var campoMensaje = objMsg.ENVIADO_ALIVIA == 1 ? "MAP_MENSAJE_ENV" : "MAP_MENSAJE";
        var textoActual = objMsg[campoMensaje];

        // Solo procesamos si tiene HTML
        if (textoActual && textoActual.indexOf('<') !== -1) {
            var textoLimpio = limpiarHTML(textoActual);

            if (textoLimpio !== textoActual) {
                // Actualizamos en memoria para que se renderice limpio
                objMsg[campoMensaje] = textoLimpio;
                ui.refreshContentRow("Mensajeria", i);

                // Actualizamos en BD para que la próxima carga ya venga limpio
                let collTexto = appData.getCollection("MensajeriaTextoScript");
                collTexto.unlock();
                collTexto.setMacro("##MACRO##", "IDMENSAJE=" + objMsg.ID);
                collTexto.clear();
                await collTexto.loadAll();
                collTexto.lock();

                if (collTexto.count() > 0) {
                    let objTexto = collTexto.getItem(0);
                    objTexto.TEXT = textoLimpio;
                    await objTexto.save();
                }
            }
        }
    }

}

// =============================================
// ENTRADA/ENVIO MENSAJES
// =============================================

async function whatsappWebhook(objself, message) {
    // Mensaje del bot con prefijo ##AGENT##
    // Guardamos el texto en UltimoMensajeBot hasta que llegue el sent de servicio
    if (typeof message === 'string' && message.indexOf('##AGENT##') === 0) {
        var textoBot = message.replace('##AGENT##', '');
        textoBot = limpiarHTML(textoBot);
        objself.getOwnerCollection().setVariables("UltimoMensajeBot", textoBot);
        return;
    }

    // El bot emite un objeto directamente, no un JSON string como Meta
    if (typeof message === 'object') {
        await procesarMensajeBot(objself, message);
        return;
    }

    const json = JSON.parse(message);
    const value = json.entry[0].changes[0].value;
    var coll;

    switch (objself.getOwnerCollection().getName()) {
        case "LeadEdicion": coll = "LeadEdicion"; break;
        case "ClienteEdicion": coll = "ClienteEdicion"; break;
        case "MensajeriaList": coll = "MensajeriaList"; break;
    }

    // BLOQUE 1: MENSAJES RECIBIDOS DEL CLIENTE
    if (value.messages && Array.isArray(value.messages)) {
        let phoneNumber = json.entry[0].changes[0].value.contacts[0].wa_id;
        let numSinPrefijo = phoneNumber.slice(2);


        if (esMensajeDuplicado(objself, value.messages[0].id)) return;

        let idLeadDestino = await obtenerIdLeadPorMovil(numSinPrefijo);

        // let objMenu = user.getVariables("layout");

        // if (objMenu) {
        //     objMenu.MAP_NOTIFICACION = 1;
        //     objMenu.setFieldPropertyValue("MAP_BTNOTIFICACION", "img", "btNotificacionSi.png");

        //     // Si el desplegable está abierto, lo recargamos para que aparezcan varios chats.
        //     // Si está cerrado, no recargamos nada para evitar flashes.
        //     if (objMenu.MAP_VER_NOTIFICACION == 1) {
        //         await cargarDesplegableNotificaciones(objMenu);
        //     }
        // }

        if (coll == "MensajeriaList") {
            if (idLeadDestino > 0) {
                let tipo = value.messages[0].type;
                let textoPreview = tipo === "text" ? value.messages[0].text.body : tipo;

                if (textoPreview.length > 50) {
                    textoPreview = textoPreview.substring(0, 50) + '...';
                }

                let horaStr = convertirHora(value.messages[0].timestamp);

                if (idLeadDestino == objself.MAP_IDLEAD_SEL) {
                    // Chat abierto: solo añadimos el mensaje al chat.
                    // Evitamos refrescar/reordenar el listado izquierdo para reducir flashes.
                    recibirMensajeEnChat(objself);
                } else {
                    // Otro chat: sí actualizamos listado y notificación.
                    await actualizarListadoConMensaje(objself, idLeadDestino, textoPreview, horaStr);
                }
            }

        } else if (coll == "LeadEdicion" || coll == "ClienteEdicion") {
            if (idLeadDestino > 0 && idLeadDestino == objself.ID) {
                recibirMensajeEnChat(objself);
            }
        }
    }

    // BLOQUE 2: ESTADOS DE MENSAJES (sent/delivered/read)
    // Se ejecuta cuando Meta confirma el estado de un mensaje enviado
    if (value.statuses && Array.isArray(value.statuses)) {
        let status = value.statuses[0].status;
        let idWhatsapp = value.statuses[0].id;

        if (esMensajeDuplicado(objself, idWhatsapp + "_" + status)) return;

        let origin = value.statuses[0].conversation &&
            value.statuses[0].conversation.origin &&
            value.statuses[0].conversation.origin.type;

        // Webhooks de servicio (origin=service) — normalmente se ignoran
        // pero si hay texto del bot pendiente en UltimoMensajeBot, lo procesamos
        if (esWebhookServicioIgnorable(objself, origin)) {
            let idsStrCheck = objself.getOwnerCollection().getVariables("IdsWhatsappPendientes") || "";
            let idsCheck = idsStrCheck !== "" ? idsStrCheck.split(",") : [];

            if (idsCheck.indexOf(idWhatsapp) !== -1) {
                if (status === "delivered" || status === "read") {
                    if (status === "read") {
                        var idxCheck = idsCheck.indexOf(idWhatsapp);
                        idsCheck.splice(idxCheck, 1);
                        objself.getOwnerCollection().setVariables("IdsWhatsappPendientes", idsCheck.join(","));
                    }

                    let numCheck = json.entry[0].changes[0].value.statuses[0].recipient_id.slice(2);
                    await actualizarEstadoMensajeWA(idWhatsapp, status);
                    await refescarLineaContentMensaje(objself, idWhatsapp, status, await obtenerIdLeadPorMovil(numCheck));
                }

                return;
            }

            let textoBot = objself.getOwnerCollection().getVariables("UltimoMensajeBot");

            if (textoBot && textoBot !== "") {
                objself.getOwnerCollection().setVariables("UltimoMensajeBot", null);

                let numSinPrefijo = json.entry[0].changes[0].value.statuses[0].recipient_id.slice(2);
                let idLeadDestino = await obtenerIdLeadPorMovil(numSinPrefijo);
                let textoPreview = textoBot.length > 50 ? textoBot.substring(0, 50) + '...' : textoBot;
                let horaStr = convertirHora(Math.floor(Date.now() / 1000));

                await actualizarListadoConMensaje(objself, idLeadDestino, textoPreview, horaStr);

                if (idLeadDestino == objself.MAP_IDLEAD_SEL) {
                    recibirMensajeEnChat(objself);
                }
            }

            return;
        }

        let numSinPrefijo = json.entry[0].changes[0].value.statuses[0].recipient_id.slice(2);
        let idLeadDestino = await obtenerIdLeadPorMovil(numSinPrefijo);

        if (coll === "MensajeriaList") {
            switch (status) {
                case "sent": {
                    let textoGuardado = objself.getOwnerCollection().getVariables("UltimoMensajeEnviado");

                    if (textoGuardado && textoGuardado !== "" && idLeadDestino == objself.MAP_IDLEAD_SEL) {
                        objself.getOwnerCollection().setVariables("UltimoMensajeEnviado", null);

                        let idsStr = objself.getOwnerCollection().getVariables("IdsWhatsappPendientes") || "";
                        let ids = idsStr !== "" ? idsStr.split(",") : [];

                        ids.push(idWhatsapp);
                        objself.getOwnerCollection().setVariables("IdsWhatsappPendientes", ids.join(","));

                        let cntMensaje = await objself.getContents("Mensajeria");

                        for (let i = cntMensaje.count() - 1; i >= 0; i--) {
                            let obj = cntMensaje.getItem(i);

                            if (obj.ENVIADO_ALIVIA === 1 && (obj.IDWHATSAPP === "" || obj.IDWHATSAPP === null)) {
                                obj.IDWHATSAPP = idWhatsapp;
                                obj.MAP_ICONO_CHECK = "tickGris.png";
                                break;
                            }
                        }
                    }

                    await comprobarEstadoPosteriorAlSent(objself, idWhatsapp, idLeadDestino);
                    break;
                }

                case "delivered":
                case "read": {
                    if (status === "read") {
                        let idsStr2 = objself.getOwnerCollection().getVariables("IdsWhatsappPendientes") || "";
                        let ids2 = idsStr2 !== "" ? idsStr2.split(",") : [];

                        var idx2 = ids2.indexOf(idWhatsapp);

                        if (idx2 !== -1) {
                            ids2.splice(idx2, 1);
                        }

                        objself.getOwnerCollection().setVariables("IdsWhatsappPendientes", ids2.join(","));
                    }

                    await actualizarEstadoMensajeWA(idWhatsapp, status);
                    await refescarLineaContentMensaje(objself, idWhatsapp, status, idLeadDestino);
                    break;
                }
            }

        } else if (coll === "LeadEdicion" || coll === "ClienteEdicion") {
            switch (status) {
                case "sent": {
                    let textoGuardado = objself.getOwnerCollection().getVariables("UltimoMensajeEnviado");

                    var idLeadCheck = objself.MAP_IDLEAD_SEL > 0 ? objself.MAP_IDLEAD_SEL : objself.ID;
                    if (textoGuardado && textoGuardado !== "" && idLeadDestino == idLeadCheck) {
                        objself.getOwnerCollection().setVariables("UltimoMensajeEnviado", null);
                        objself.getOwnerCollection().setVariables("UltimoIdWhatsappEnviado", idWhatsapp);

                        let cntMensaje = await objself.getContents("Mensajeria");

                        for (let i = cntMensaje.count() - 1; i >= 0; i--) {
                            let obj = cntMensaje.getItem(i);

                            if (obj.ENVIADO_ALIVIA === 1 && (obj.IDWHATSAPP === "" || obj.IDWHATSAPP === null)) {
                                obj.IDWHATSAPP = idWhatsapp;
                                obj.MAP_ICONO_CHECK = "tickGris.png";
                                break;
                            }
                        }
                    }

                    await comprobarEstadoPosteriorAlSent(objself, idWhatsapp, idLeadDestino);
                    break;
                }

                case "delivered":
                case "read":
                    await actualizarEstadoMensajeWA(idWhatsapp, status);
                    await refescarLineaContentMensaje(objself, idWhatsapp, status, objself.ID);
                    objself.getOwnerCollection().setVariables("UltimoIdWhatsappEnviado", null);
                    break;
            }
        }
    }
}


// =============================================
// AUXILIARES DE whatsappWebhook
// =============================================

// --- COMPARTIDA (Bloque 1 y Bloque 2) ---

// Obtiene el ID del lead/cliente a partir de su número de móvil sin prefijo
// Devuelve -1 si no se encuentra
async function obtenerIdLeadPorMovil(numSinPrefijo) {
    let collCliente = appData.getCollection("ClienteScript");
    await filtrarCollMacroObject(collCliente, "c.MOVIL=" + numSinPrefijo);
    if (collCliente.count() > 0) {
        return collCliente.getItem(0).ID;
    }
    return -1;
}

// --- BLOQUE 1: MENSAJES RECIBIDOS DEL CLIENTE ---

// Comprueba si el mensaje ya fue procesado (Meta envía el mismo webhook 2-3 veces)
// Guarda los últimos 10 IDs procesados para detectar duplicados aunque lleguen desordenados
function esMensajeDuplicado(objself, idMsgEntrante) {
    let idsProcessados = objself.getOwnerCollection().getVariables("IdsWebhookProcesados");
    let arrIds = idsProcessados ? idsProcessados.split(",") : [];
    if (arrIds.indexOf(idMsgEntrante) !== -1) return true; // True si es duplicado
    arrIds.push(idMsgEntrante);
    if (arrIds.length > 10) arrIds.shift();
    objself.getOwnerCollection().setVariables("IdsWebhookProcesados", arrIds.join(","));
    return false; // False si es nuevo
}


// Procesa mensajes del bot — llegan como objeto JS en vez de JSON string de Meta
// Se llama desde whatsappWebhook cuando typeof message === 'object
async function procesarMensajeBot(objself, message) {
    if (!message) return;
    try {
        // Sincronizamos referencia global con el objself actual y reseteamos el flag,
        // por si quedó colgado tras salir/entrar de la pestaña Chat
        var collNameCheck = objself.getOwnerCollection() ? objself.getOwnerCollection().getName() : "";
        if (collNameCheck === "MensajeriaList") {
            _objMensajeriaList = objself;
            _agregarMensajeProgramado = false;
        }

        var idLeadDestino = -1;
        var textoPreview = "";
        var esClienteModoAsesor = false;

        if (message.idmensaje && message.text !== undefined) {
            let collMsg = appData.getCollection("MensajeriaScript");
            await filtrarCollMacroObject(collMsg, "ID=" + message.idmensaje);
            if (collMsg.count() > 0) {
                var objMsg = collMsg.getItem(0);
                idLeadDestino = objMsg.IDLEAD;
                // Es cliente modo asesor si: lo envió el cliente (ENVIADO_ALIVIA=0),
                // viene del canal app (ORIGIN='humano') y NO pertenece a sesión de bot (SESSIONID vacío)
                esClienteModoAsesor = (objMsg.ENVIADO_ALIVIA == 0 && objMsg.ORIGIN === 'humano' && (!objMsg.SESSIONID || objMsg.SESSIONID === ''));
            }
            let textoLimpio = message.text ? limpiarHTML(message.text) : "";
            textoPreview = textoLimpio ?
                (textoLimpio.length > 50 ? textoLimpio.substring(0, 50) + '...' : textoLimpio)
                : "(mensaje)";
        } else if (message.phoneNumber) {
            let numSinPrefijo = message.phoneNumber.replace(/^\+\d{2}/, '');
            idLeadDestino = await obtenerIdLeadPorMovil(numSinPrefijo);
            let textoLimpio = message.message ? limpiarHTML(message.message) : "";
            textoPreview = textoLimpio && textoLimpio.length > 50 ?
                textoLimpio.substring(0, 50) + '...' : textoLimpio;
        } else {
            return;
        }

        if (idLeadDestino <= 0) return;

        // Obtenemos el nombre de la colección activa de forma segura,
        // ya que getOwnerCollection() puede ser undefined fuera de la pestaña Chat
        var collName = objself.getOwnerCollection() ? objself.getOwnerCollection().getName() : "";

        var horaStr = convertirHora(Math.floor(Date.now() / 1000));
        var objMenu = user.getVariables("layout");

        if (collName === "MensajeriaList") {
            var chatEnDom = document.querySelector('[xone-name="MensajeriaChatListado"]') !== null;
            var esChatActivo = chatEnDom && (idLeadDestino == objself.MAP_IDLEAD_SEL);
            if (esChatActivo) {
                // Estoy viendo este chat — marco como leído, recibo mensaje y actualizo listado sin bolita
                if (esClienteModoAsesor) await marcarChatComoLeido(objself, idLeadDestino);
                recibirMensajeEnChat(objself);
                await actualizarListadoConMensaje(objself, idLeadDestino, textoPreview, horaStr, "", false);
            } else {
                // Otro chat o fuera de la pestaña — actualizo listado y campanita si es cliente app
                await actualizarListadoConMensaje(objself, idLeadDestino, textoPreview, horaStr, "", esClienteModoAsesor);
                if (esClienteModoAsesor && await debeNotificarUsuario(idLeadDestino)) {
                    if (objMenu) {
                        objMenu.MAP_NOTIFICACION = 1;
                        objMenu.setFieldPropertyValue("MAP_BTNOTIFICACION", "img", "btNotificacionSi.png");
                    }
                }
            }
        } else if (collName === "ClienteEdicion") {
            // En ficha cliente — recibir mensaje en chat si es el mismo lead
            if (idLeadDestino == objself.ID) {
                if (esClienteModoAsesor) await marcarChatComoLeido(objself, idLeadDestino);
                recibirMensajeEnChat(objself);
            }
            // Campanita siempre si es cliente app, independientemente del lead activo
            if (esClienteModoAsesor && await debeNotificarUsuario(idLeadDestino)) {
                if (objMenu) {
                    objMenu.MAP_NOTIFICACION = 1;
                    objMenu.setFieldPropertyValue("MAP_BTNOTIFICACION", "img", "btNotificacionSi.png");
                }
            }
        } else {
            // Cualquier otra pantalla (o collName vacío porque getOwnerCollection() es undefined)
            // Solo activamos la campanita si es mensaje de cliente app modo asesor
            if (esClienteModoAsesor && await debeNotificarUsuario(idLeadDestino)) {
                if (objMenu) {
                    objMenu.MAP_NOTIFICACION = 1;
                    objMenu.setFieldPropertyValue("MAP_BTNOTIFICACION", "img", "btNotificacionSi.png");
                }
            }
        }
    } catch(e) {
        _actualizandoListado = false;
    }
}





async function actualizarListadoConMensaje(objself, idLeadDestino, textoPreview, horaStr, icono, mostrarNotif) {
    if (_actualizandoListado) return;
    _actualizandoListado = true;

    icono = icono || "";
    mostrarNotif = mostrarNotif === true;

    if (idLeadDestino <= 0) { _actualizandoListado = false; return; }

    // Obtenemos el content visible del listado izquierdo y el content espejo (invisible)
    // que usamos como fuente de datos frescos desde BD para reordenar sin parpadeo
    var cntListado = await objself.getContents("MensajeriaChatListado");
    var cntScript  = await objself.getContents("MensajeriaChatListadoScript");
    if (cntListado == null || cntScript == null) { _actualizandoListado = false; return; }

    // Guardamos las notificaciones actuales en memoria antes de recargar BD,
    // para restaurarlas en los chats que no son el destino del mensaje
    var notifActual = {};
    for (var n = 0; n < cntListado.count(); n++) {
        var objN = cntListado.getItem(n);
        if (objN.MAP_ICONO_NOTIFICACION && objN.MAP_ICONO_NOTIFICACION !== '') {
            notifActual[objN.MAP_ID] = {
                icono: objN.MAP_ICONO_NOTIFICACION,
                num: objN.MAP_NUM_NOTIFICACIONES
            };
        }
    }

    // Cargamos el orden correcto desde BD en el content espejo invisible.
    // Usa el mismo filtro que el listado visible para respetar búsquedas activas.
    await filtrarContentMacroObject(cntScript, getFilter(objself, "MensajeriaChatListado"));
    if (cntScript.count() === 0) { _actualizandoListado = false; return; }

    // Buscamos la posición real del chat destino en el orden de BD
    var posicionRealEnBD = -1;
    for (var i = 0; i < cntScript.count(); i++) {
        if (cntScript.getItem(i).ID == idLeadDestino) { posicionRealEnBD = i; break; }
    }
    // Si el chat no está en los resultados (filtro activo que lo excluye), salimos
    if (posicionRealEnBD === -1) { _actualizandoListado = false; return; }

    // Comprobamos si el chat destino está en el rango de página visible actualmente.
    // Si está en otra página, no actualizamos (el usuario no lo vería)
    var pagIni = objself.MAP_PAG_INI || 0;
    var pagLen = objself.MAP_PAG_LEN || 15;
    var pagFin = pagIni + pagLen - 1;
    if (posicionRealEnBD < pagIni || posicionRealEnBD > pagFin) { _actualizandoListado = false; return; }

    // Construimos el array ordenado con los datos frescos del content espejo
    var arrOrdenado = [];
    for (var j = 0; j < cntScript.count(); j++) {
        var objS = cntScript.getItem(j);
        arrOrdenado.push({
            MAP_ID:                 objS.ID,
            MAP_NOMBRE:             objS.MAP_NOMBRE,
            MAP_CORREO:             objS.MAP_CORREO,
            MAP_ULT_MENSAJE:        limpiarHTML(objS.MAP_ULT_MENSAJE),
            MAP_ULT_MENSAJE_HORA:   objS.MAP_ULT_MENSAJE_HORA,
            MAP_ICONO_CHECK:        objS.MAP_ICONO_CHECK,
            MAP_ICONO_BOT:          objS.MAP_ICONO_BOT,
            MAP_ICONO_NOTIFICACION: objS.MAP_ICONO_NOTIFICACION,
            MAP_NUM_NOTIFICACIONES: objS.MAP_NUM_NOTIFICACIONES
        });
    }

    // Sobreescribimos el chat destino con los datos del mensaje recibido:
    // - Texto y hora del nuevo mensaje
    // - Bolita de notificación: solo si es cliente app (mostrarNotif) y no estamos en ese chat
    // - Si estamos en el chat activo, limpiamos la bolita (ya se está viendo)
    for (var k = 0; k < arrOrdenado.length; k++) {
        if (arrOrdenado[k].MAP_ID == idLeadDestino) {
            arrOrdenado[k].MAP_ULT_MENSAJE      = textoPreview;
            arrOrdenado[k].MAP_ULT_MENSAJE_HORA = horaStr;
            if (icono) arrOrdenado[k].MAP_ICONO_CHECK = icono;
            if (idLeadDestino == objself.MAP_IDLEAD_SEL) {
                arrOrdenado[k].MAP_ICONO_NOTIFICACION = '';
                arrOrdenado[k].MAP_NUM_NOTIFICACIONES = '';
            } else if (mostrarNotif) {
                arrOrdenado[k].MAP_ICONO_NOTIFICACION = 'icons/pdfRojo.png';
            }
            break;
        }
    }

    // Volcamos el array al content visible fila a fila con refreshContentRow,
    // evitando un refresh completo del listado que causaría parpadeo visible
    var total = Math.min(arrOrdenado.length, cntListado.count());
    for (var m = 0; m < total; m++) {
        var objL   = cntListado.getItem(m);
        var datosM = arrOrdenado[m];
        objL.MAP_ID               = datosM.MAP_ID;
        objL.MAP_NOMBRE           = datosM.MAP_NOMBRE;
        objL.MAP_CORREO           = datosM.MAP_CORREO;
        objL.MAP_CORREO_DISPLAY   = datosM.MAP_CORREO ? '(' + datosM.MAP_CORREO + ')' : '';
        objL.MAP_ULT_MENSAJE      = datosM.MAP_ULT_MENSAJE;
        objL.MAP_ULT_MENSAJE_HORA = datosM.MAP_ULT_MENSAJE_HORA;
        objL.MAP_ICONO_BOT        = datosM.MAP_ICONO_BOT;
        objL.MAP_ICONO_CHECK      = datosM.MAP_ICONO_CHECK;
        // Para el chat destino usamos los datos ya sobreescritos arriba.
        // Para el resto, restauramos las notificaciones que había antes de la recarga
        // para que los otros chats con bolita no la pierdan.
        if (datosM.MAP_ID == idLeadDestino) {
            objL.MAP_ICONO_NOTIFICACION = datosM.MAP_ICONO_NOTIFICACION;
            objL.MAP_NUM_NOTIFICACIONES = datosM.MAP_NUM_NOTIFICACIONES;
        } else if (notifActual[datosM.MAP_ID]) {
            objL.MAP_ICONO_NOTIFICACION = notifActual[datosM.MAP_ID].icono;
            objL.MAP_NUM_NOTIFICACIONES = notifActual[datosM.MAP_ID].num;
        } else {
            objL.MAP_ICONO_NOTIFICACION = datosM.MAP_ICONO_NOTIFICACION;
            objL.MAP_NUM_NOTIFICACIONES = datosM.MAP_NUM_NOTIFICACIONES;
        }
        ui.refreshContentRow("MensajeriaChatListado", m);
    }

    _actualizandoListado = false;
}



// --- BLOQUE 2: ESTADOS DE MENSAJES (sent/delivered/read) ---

// Comprueba si el webhook de estado debe ignorarse
// Solo se ignoran si no hay ningún mensaje del trabajador pendiente de confirmación
function esWebhookServicioIgnorable(objself, origin) {
    let textoGuardadoCheck = objself.getOwnerCollection().getVariables("UltimoMensajeEnviado");
    let idsStr = objself.getOwnerCollection().getVariables("IdsWhatsappPendientes");
    let hayMensajePendiente = (textoGuardadoCheck && textoGuardadoCheck !== "") || (idsStr && idsStr !== "");
    return origin === "service" && !hayMensajePendiente;
}

async function agregarMensajesNuevos(objself) {
    _agregarMensajeProgramado = false;
    try {
        var cntMsj = await objself.getContents("Mensajeria");
        var ultimoId = 0;
        for (var k = 0; k < cntMsj.count(); k++) {
            var item = cntMsj.getItem(k);
            if (!item) continue;
            if (item.ID && item.ID > ultimoId) ultimoId = item.ID;
        }
        var idLead = objself.MAP_IDLEAD_SEL > 0 ? objself.MAP_IDLEAD_SEL : objself.ID;
        var cntNuevos = await objself.getContents("MensajeriaUltimoScript");
        await filtrarContentMacroObject(cntNuevos, "m.IDLEAD=" + idLead + " AND m.ID > " + ultimoId);
        if (cntNuevos.count() > 0) {
            for (var i = 0; i < cntNuevos.count(); i++) {
                var src = cntNuevos.getItem(i);
                if (!src) continue;
                var obj = await cntMsj.createObject();
                obj.ID = src.ID;
                obj.IDLEAD = src.IDLEAD;
                obj.FECHA = src.FECHA;
                obj.ENVIADO_ALIVIA = src.ENVIADO_ALIVIA;
                obj.TIPO = src.TIPO;
                obj.ESTADO = src.ESTADO;
                obj.IDWHATSAPP = src.IDWHATSAPP;
                obj.NOTIFICADO = src.NOTIFICADO;
                obj.MAP_ENVIADO = src.MAP_ENVIADO;
                obj.MAP_MENSAJE = src.MAP_MENSAJE;
                obj.MAP_MENSAJE_ENV = src.MAP_MENSAJE_ENV;
                obj.MAP_FECHA_HORA = src.MAP_FECHA_HORA;
                obj.MAP_FECHA_HORA_ENV = src.MAP_FECHA_HORA_ENV;
                obj.MAP_HORA = src.MAP_HORA;
                obj.MAP_HORA_ENV = src.MAP_HORA_ENV;
                obj.MAP_TAMANIO_FRAME = src.MAP_TAMANIO_FRAME;
                obj.MAP_TAMANIO_MENSAJE = src.MAP_TAMANIO_MENSAJE;
                obj.MAP_TAMANIO_HORA = src.MAP_TAMANIO_HORA;
                obj.MAP_ICONO_CHECK = src.MAP_ICONO_CHECK;
                obj.MAP_ICONO_BOT = src.MAP_ICONO_BOT;
                obj.MAP_ID_DOM = src.MAP_ID_DOM;
                obj.MAP_TIPO_MULTIMEDIA = src.MAP_TIPO_MULTIMEDIA;
                obj.MAP_NOMBRE_DOCUMENTO = src.MAP_NOMBRE_DOCUMENTO;
                obj.MAP_NOMBRE_DOCUMENTO_ENV = src.MAP_NOMBRE_DOCUMENTO_ENV;
                await cntMsj.addItem(obj);
            }
        }
        ui.appendContentRows("Mensajeria");
    } catch(e) {
        console.error("error:", e.message, e.stack);
    }
}


function recibirMensajeEnChat(objself) {
    _objMensajeriaList = objself;
    if (_agregarMensajeProgramado) return;
    _agregarMensajeProgramado = true;
    var collName = objself.getOwnerCollection().getName();
    if (collName === "ClienteEdicion") {
        ui.executeActionAfterDelay("agregarMensajeAlChatFicha", 2);
    } else {
        ui.executeActionAfterDelay("agregarMensajeAlChat", 1);
    }
}
    

// =============================================
// BUSCAR MENSAJE EN CHAT GENERAL
// =============================================

async function precargarMensajesBusqueda(objself) {
    var idLead = objself.MAP_IDLEAD_SEL;
    if (idLead <= 0) return;
    var coll = appData.getCollection("MensajeriaBusquedaScript");
    coll.unlock();
    coll.setMacro("##MACRO##", "m.IDLEAD=" + idLead);
    coll.clear();
    await coll.loadAll();
    coll.lock();
}

function toggleBuscadorMensajes(objself) {
    _objMensajeriaList = objself;
    if (objself.MAP_BUSCADOR_MENSAJES_VISIBLE == 1) {
        cerrarBuscadorMensajes(objself);
    } else {
        objself.MAP_BUSCADOR_MENSAJES_VISIBLE = 1;
    }
    objself.MAP_RESULTADOS_BUSQUEDA_VISIBLE = 0;
}

function cerrarBuscadorMensajes(objself) {
    objself.MAP_BUSCADOR_MENSAJES_VISIBLE = 0;
    objself.MAP_TEXTO_BUSCAR = "";
    objself.MAP_CONTADOR_BUSQUEDA = "";
    objself.MAP_INDICE_BUSQUEDA_ACTUAL = 0;
    objself._coincidenciasBusqueda = [];
    objself.MAP_RESULTADOS_BUSQUEDA_VISIBLE = 0;
    quitarResaltadosBusqueda();
}

async function buscarMensajes(objself) {
    _objMensajeriaList = objself;
    quitarResaltadosBusqueda();

    if (!objself.MAP_TEXTO_BUSCAR || objself.MAP_TEXTO_BUSCAR.trim() === "") {
        objself.MAP_CONTADOR_BUSQUEDA = "";
        objself._coincidenciasBusqueda = [];
        return;
    }

    var texto = normalizarTexto(objself.MAP_TEXTO_BUSCAR.trim());
    var coll = appData.getCollection("MensajeriaBusquedaScript");

    if (!coll || coll.count() === 0) {
        ui.showToast("Cargando mensajes, espera un momento...");
        await precargarMensajesBusqueda(objself);
        return;
    }

    var coincidencias = [];
    for (var i = 0; i < coll.count(); i++) {
        var obj = coll.getItem(i);
        var textoMsg = normalizarTexto(obj.MAP_TEXTO_BUSQUEDA || "");
        if (textoMsg.indexOf(texto) !== -1) {
            coincidencias.push(obj.ID);
        }
    }

    objself._coincidenciasBusqueda = coincidencias;
    objself._collBusqueda = coll;
    objself._textoBuscado = texto;

    mostrarResultadosBusqueda(objself, coll, coincidencias, texto);

    if (coincidencias.length === 0) {
        objself.MAP_CONTADOR_BUSQUEDA = "0 de 0";
        ui.showToast("No se encontraron mensajes");
        return;
    }

    objself.MAP_INDICE_BUSQUEDA_ACTUAL = coincidencias.length - 1;
    actualizarContadorBusqueda(objself);
    irACoincidencia(objself);
}

function navegarBusqueda(objself, direccion) {
    if (!objself._coincidenciasBusqueda || objself._coincidenciasBusqueda.length === 0) return;

    var total = objself._coincidenciasBusqueda.length;
    var actual = objself.MAP_INDICE_BUSQUEDA_ACTUAL || 0;

    actual = actual + direccion;
    if (actual < 0) actual = total - 1;
    if (actual >= total) actual = 0;

    objself.MAP_INDICE_BUSQUEDA_ACTUAL = actual;
    actualizarContadorBusqueda(objself);
    irACoincidencia(objself);
}

function actualizarContadorBusqueda(objself) {
    var total = objself._coincidenciasBusqueda.length;
    var actual = (objself.MAP_INDICE_BUSQUEDA_ACTUAL || 0) + 1;
    objself.MAP_CONTADOR_BUSQUEDA = actual + " de " + total;
}

function irACoincidencia(objself) {
    var coincidencias = objself._coincidenciasBusqueda;
    var idxActual = objself.MAP_INDICE_BUSQUEDA_ACTUAL;
    var idMensaje = coincidencias[idxActual];

    quitarResaltadosBusqueda();

    var filas = document.querySelectorAll('.xone-contents-row');
    for (var j = 0; j < filas.length; j++) {
        var elemId = filas[j].querySelector('[xone-name="MAP_ID_DOM"]');
        if (elemId && elemId.textContent.trim() == idMensaje) {
            filas[j].scrollIntoView({ behavior: 'smooth', block: 'center' });
            filas[j].style.outline = '4px solid #E65100';
            filas[j].style.outlineOffset = '-4px';
            filas[j]._resaltadoBusqueda = true;
            return;
        }
    }
}

function quitarResaltadosBusqueda() {
    var filas = document.querySelectorAll('.xone-contents-row');
    for (var i = 0; i < filas.length; i++) {
        if (filas[i]._resaltadoBusqueda) {
            filas[i].style.outline = '';
            filas[i].style.outlineOffset = '';
            filas[i]._resaltadoBusqueda = false;
        }
    }
}

function mostrarResultadosBusqueda(objself, collBusqueda, coincidencias, textoBuscado) {
    objself._pendingCoincidencias = coincidencias;
    objself._pendingColl = collBusqueda;
    objself._pendingTexto = textoBuscado;
    objself.MAP_RESULTADOS_BUSQUEDA_VISIBLE = 1;
    ui.executeActionAfterDelay("inyectarResultadosDOM", 0.5);
}

function inyectarResultadosDOM(objself) {
    var coincidencias = objself._pendingCoincidencias || [];
    var collBusqueda = objself._pendingColl;
    var textoBuscado = objself._pendingTexto || "";

    var contenedor = document.querySelector('[xone-name="frmResultadosCuerpo"]');
    ("[inyectar] contenedor:", !!contenedor);
    if (!contenedor) {
        ui.showToast("Error al mostrar resultados");
        return;
    }

    var html = "";
    for (var k = coincidencias.length - 1; k >= 0; k--) {
        var idMsg = coincidencias[k];
        for (var i = 0; i < collBusqueda.count(); i++) {
            var obj = collBusqueda.getItem(i);
            if (obj.ID == idMsg) {
                var texto = obj.MAP_TEXTO_BUSQUEDA || "";
                var idx = texto.toLowerCase().indexOf(textoBuscado.toLowerCase());
                var inicio = Math.max(0, idx - 30);
                var fin = Math.min(texto.length, idx + textoBuscado.length + 30);
                var extracto = (inicio > 0 ? "..." : "") + texto.substring(inicio, fin) + (fin < texto.length ? "..." : "");
                html += '<div onclick="seleccionarResultadoDOM(' + obj.ID + ')" ' +
                    'style="padding:8px 12px;border-bottom:1px solid #E9EDEF;cursor:pointer;">' +
                    '<div style="font-size:11px;color:#909193;">' + (obj.MAP_FECHA_HORA_BUSQUEDA || "") + '</div>' +
                    '<div style="font-size:13px;color:#333;margin-top:2px;">' + extracto + '</div>' +
                    '</div>';
                break;
            }
        }
    }

    contenedor.innerHTML = html;
    ("[inyectar] filas inyectadas:", coincidencias.length);
}

window.seleccionarResultadoDOM = function (idMsg) {
    var objself = _objMensajeriaList;
    ("[seleccionarResultadoDOM] objself:", !!objself, "idMsg:", idMsg);
    if (!objself) {
        ui.showToast("Error: referencia perdida");
        return;
    }
    // Eliminadas las líneas que cerraban el buscador
    objself.getOwnerCollection().setVariables("MensajeObjetivoBusqueda", idMsg);
    ui.executeActionAfterDelay("irAMensajeBusqueda", 0.1);
};

async function irAMensajeBusquedaAction(objself) {
    var idMsg = objself.getOwnerCollection().getVariables("MensajeObjetivoBusqueda");
    if (!idMsg || idMsg <= 0) return;

    if (mensajeEnDom(idMsg)) {
        scrollYResaltarMensaje(idMsg);
        return;
    }

    var collBusqueda = appData.getCollection("MensajeriaBusquedaScript");
    var idInicio = idMsg;
    var idFin = null;

    for (var i = 0; i < collBusqueda.count(); i++) {
        if (collBusqueda.getItem(i).ID == idMsg) {
            // 50 antes
            var idxInicio = Math.max(0, i - 50);
            idInicio = collBusqueda.getItem(idxInicio).ID;
            // 50 después
            var idxFin = Math.min(collBusqueda.count() - 1, i + 50);
            idFin = collBusqueda.getItem(idxFin).ID;
            break;
        }
    }

    var macro = "m.IDLEAD=" + objself.MAP_IDLEAD_SEL + " AND m.ID >= " + idInicio;
    if (idFin) macro += " AND m.ID <= " + idFin;

    var cnt = await objself.getContents("Mensajeria");
    objself._macroModificadoPorBusqueda = true;
    cnt.unlock();
    cnt.setMacro("##MACRO##", macro);
    cnt.clear();
    await cnt.loadAll();
    cnt.lock();
    ui.refresh("Mensajeria");
    ui.executeActionAfterDelay("scrollAMensajeBusqueda", 0.5);
}

function scrollAMensajeBusqueda(objself) {
    var idObjetivo = objself.getOwnerCollection().getVariables("MensajeObjetivoBusqueda");
    if (!idObjetivo || idObjetivo <= 0) return;

    objself._scrollBusquedaIntentos = (objself._scrollBusquedaIntentos || 0) + 1;
    ("[scrollAMensajeBusqueda] intento:", objself._scrollBusquedaIntentos, "buscando ID:", idObjetivo);

    if (objself._scrollBusquedaIntentos > 10) {
        ("[scrollAMensajeBusqueda] máximo reintentos");
        objself._scrollBusquedaIntentos = 0;
        objself.getOwnerCollection().setVariables("MensajeObjetivoBusqueda", null);
        return;
    }

    if (scrollYResaltarMensaje(idObjetivo)) {
        ("[scrollAMensajeBusqueda] encontrado y resaltado");
        objself._scrollBusquedaIntentos = 0;
        objself.getOwnerCollection().setVariables("MensajeObjetivoBusqueda", null);
    } else {
        ("[scrollAMensajeBusqueda] no encontrado, reintentando");
        ui.executeActionAfterDelay("scrollAMensajeBusqueda", 1);
    }
}

function mensajeEnDom(idMsg) {
    var filas = document.querySelectorAll('.xone-contents-row');
    for (var j = 0; j < filas.length; j++) {
        var elemId = filas[j].querySelector('[xone-name="MAP_ID_DOM"]');
        if (elemId && elemId.textContent.trim() == idMsg) return true;
    }
    return false;
}

function scrollYResaltarMensaje(idMsg) {
    quitarResaltadosBusqueda();
    var filas = document.querySelectorAll('.xone-contents-row');
    for (var j = 0; j < filas.length; j++) {
        var elemId = filas[j].querySelector('[xone-name="MAP_ID_DOM"]');
        if (elemId && elemId.textContent.trim() == idMsg) {
            var fila = filas[j];
            fila.scrollIntoView({ behavior: 'instant', block: 'center' });
            fila.style.outline = '4px solid #E65100';
            fila.style.outlineOffset = '-4px';
            fila._resaltadoBusqueda = true;

            // Forzar scroll varias veces para ganarle a start-from-bottom
            setTimeout(function () { fila.scrollIntoView({ behavior: 'instant', block: 'center' }); }, 300);
            setTimeout(function () { fila.scrollIntoView({ behavior: 'instant', block: 'center' }); }, 600);
            setTimeout(function () { fila.scrollIntoView({ behavior: 'instant', block: 'center' }); }, 1000);
            return true;
        }
    }
    return false;
}

function normalizarTexto(texto) {
    return texto
        .toLowerCase()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "");
}

// =============================================
// CHAT FICHA CLIENTE
// =============================================
function buscarGridScrollableFicha(objself) {
    ("[buscarGridFicha] inicio");

    var view = ui.getView(objself);
    if (!view) {
        ("[buscarGridFicha] no view, reintento");
        ui.executeActionAfterDelay("buscarGridDOM", 1);
        return;
    }

    var control = view.getControl("Mensajeria");
    if (!control) {
        ("[buscarGridFicha] no control, reintento");
        ui.executeActionAfterDelay("buscarGridDOM", 1);
        return;
    }

    var gridElement = control.element;
    if (!gridElement) {
        ("[buscarGridFicha] no gridElement, reintento");
        ui.executeActionAfterDelay("buscarGridDOM", 1);
        return;
    }

    var scrollableDiv = gridElement.querySelector('.xone-contents.xone-reverse-column');
    if (!scrollableDiv) {
        ("[buscarGridFicha] no scrollableDiv, reintento");
        ui.executeActionAfterDelay("buscarGridDOM", 1);
        return;
    }

    // Registrar reach-top para paginación inversa
    ui.setContentsOnReachTop("Mensajeria", "cargarMasMensajesFicha");
    ("[buscarGridFicha] reachTop registrado");

    if (scrollableDiv._scrollListenerAdded) {
        ("[buscarGridFicha] listener ya añadido");
        return;
    }
    scrollableDiv._scrollListenerAdded = true;

    var _objself = objself;
    scrollableDiv._scrollHandler = function () {
        // Aquí podríamos actualizar separador flotante si se quisiera en el futuro
        if (scrollableDiv.scrollTop < 50) {
            ("[fichaScroll] cerca del top");
        }
    };

    scrollableDiv.addEventListener('scroll', scrollableDiv._scrollHandler);
    ("[buscarGridFicha] listener añadido");
}

/**
 * Carga más mensajes antiguos al llegar al top (reach-top) en la ficha.
 * Equivalente a cargarMasMensajes de MensajeriaList.
 */
function cargarMasMensajesFicha(objself) {
    var view = ui.getView(objself);
    var control = view ? view.getControl("Mensajeria") : null;
    var el = control && control.element
        ? control.element.querySelector('.xone-contents.xone-reverse-column')
        : null;
    var oldScrollHeight = el ? el.scrollHeight : 0;

    ui.loadContentsOlderRows("Mensajeria");

    if (el) {
        setTimeout(function () {
            var newScrollHeight = el.scrollHeight;
            el.scrollTop = el.scrollTop + (newScrollHeight - oldScrollHeight);
        }, 200);
    }
}

async function scrollChatFicha(objself) {
    if (objself.MAP_BUSCADOR_FICHA_VISIBLE == 1) {
        cerrarBuscadorMensajesFicha(objself);
        await cargarMensajesFicha(objself);
        return;
    }

    var view = ui.getView(objself);
    if (!view) return;
    var control = view.getControl("Mensajeria");
    if (!control) return;

    control.scrollToBottom();

    var el = control.element
        ? control.element.querySelector('.xone-contents.xone-reverse-column')
        : null;
    if (el) {
        setTimeout(function () {
            el.scrollTop = el.scrollHeight;
            el.dispatchEvent(new Event('scroll'));
            ("[scrollFondoFicha] forzado scrollTop:", el.scrollTop);
        }, 300);
    }

    ui.setContentsOnReachTop("Mensajeria", "cargarMasMensajesFicha");
}

// =============================================
// BUSCADOR DE MENSAJES FICHA CLIENTE
// =============================================

async function precargarMensajesBusquedaFicha(objself) {
    // En la ficha el ID del lead es objself.ID directamente
    var idLead = objself.MAP_IDLEAD_SEL > 0 ? objself.MAP_IDLEAD_SEL : objself.ID;
    if (!idLead || idLead <= 0) return;
    var coll = appData.getCollection("MensajeriaBusquedaScript");
    coll.unlock();
    coll.setMacro("##MACRO##", "m.IDLEAD=" + idLead);
    coll.clear();
    await coll.loadAll();
    coll.lock();
    ("[busquedaFicha] precargados:", coll.count(), "mensajes");
}

function toggleBuscadorMensajesFicha(objself) {
    _objClienteEdicionChat = objself;
    if (objself.MAP_BUSCADOR_FICHA_VISIBLE == 1) {
        cerrarBuscadorMensajesFicha(objself);
    } else {
        objself.MAP_BUSCADOR_FICHA_VISIBLE = 1;
    }
    objself.MAP_RESULTADOS_BUSQUEDA_FICHA_VISIBLE = 0;
}

function cerrarBuscadorMensajesFicha(objself) {
    objself.MAP_BUSCADOR_FICHA_VISIBLE = 0;
    objself.MAP_RESULTADOS_BUSQUEDA_FICHA_VISIBLE = 0;
    objself.MAP_TEXTO_BUSCAR_FICHA = "";
    objself.MAP_CONTADOR_BUSQUEDA_FICHA = "";
    objself.MAP_CONTADOR_BUSQUEDA_FICHA_DISPLAY = "";
    objself.MAP_INDICE_BUSQUEDA_ACTUAL = 0;
    objself._coincidenciasBusquedaFicha = [];
    quitarResaltadosBusqueda();
}

async function buscarMensajesFicha(objself) {
    _objClienteEdicionChat = objself;
    quitarResaltadosBusqueda();

    ("[buscarFicha] texto:", objself.MAP_TEXTO_BUSCAR_FICHA);

    var coll = appData.getCollection("MensajeriaBusquedaScript");
    ("[buscarFicha] coll count:", coll ? coll.count() : "null");

    if (!coll || coll.count() === 0) {
        ("[buscarFicha] coll vacía, precargando...");
        await precargarMensajesBusquedaFicha(objself);

        // Log después de precargar
        ("[buscarFicha] tras precargar count:", coll.count());
        return;
    }
    if (!objself.MAP_TEXTO_BUSCAR_FICHA || objself.MAP_TEXTO_BUSCAR_FICHA.trim() === "") {
        objself.MAP_CONTADOR_BUSQUEDA_FICHA = "";
        objself._coincidenciasBusquedaFicha = [];
        return;
    }

    var texto = normalizarTexto(objself.MAP_TEXTO_BUSCAR_FICHA.trim());
    var coll = appData.getCollection("MensajeriaBusquedaScript");

    if (!coll || coll.count() === 0) {
        ui.showToast("Cargando mensajes, espera un momento...");
        await precargarMensajesBusquedaFicha(objself);
        return;
    }

    var coincidencias = [];
    for (var i = 0; i < coll.count(); i++) {
        var obj = coll.getItem(i);
        var textoMsg = normalizarTexto(obj.MAP_TEXTO_BUSQUEDA || "");
        if (textoMsg.indexOf(texto) !== -1) {
            coincidencias.push(obj.ID);
        }
    }

    objself._coincidenciasBusquedaFicha = coincidencias;
    objself._collBusquedaFicha = coll;
    objself._textoBuscadoFicha = texto;

    // Mismo patrón que mostrarResultadosBusqueda del CRM
    mostrarResultadosBusquedaFicha(objself, coll, coincidencias, texto);

    if (coincidencias.length === 0) {
        objself.MAP_CONTADOR_BUSQUEDA_FICHA = "0 de 0";
        ui.showToast("No se encontraron mensajes");
        return;
    }

    objself.MAP_INDICE_BUSQUEDA_ACTUAL = coincidencias.length - 1;
    actualizarContadorBusquedaFicha(objself);
    await irACoincidenciaFicha(objself);
}

async function navegarBusquedaFicha(objself, direccion) {
    if (!objself._coincidenciasBusquedaFicha || objself._coincidenciasBusquedaFicha.length === 0) return;

    var total = objself._coincidenciasBusquedaFicha.length;
    var actual = objself.MAP_INDICE_BUSQUEDA_ACTUAL || 0;

    actual = actual + direccion;
    if (actual < 0) actual = total - 1;
    if (actual >= total) actual = 0;

    objself.MAP_INDICE_BUSQUEDA_ACTUAL = actual;
    actualizarContadorBusquedaFicha(objself);
    await irACoincidenciaFicha(objself);
}

function actualizarContadorBusquedaFicha(objself) {
    var total = objself._coincidenciasBusquedaFicha.length;
    var actual = (objself.MAP_INDICE_BUSQUEDA_ACTUAL || 0) + 1;
    var texto = actual + " de " + total;
    objself.MAP_CONTADOR_BUSQUEDA_FICHA = texto;
    objself.MAP_CONTADOR_BUSQUEDA_FICHA_DISPLAY = texto;
}

async function irACoincidenciaFicha(objself) {
    var coincidencias = objself._coincidenciasBusquedaFicha;
    var idxActual = objself.MAP_INDICE_BUSQUEDA_ACTUAL;
    var idMensaje = coincidencias[idxActual];

    quitarResaltadosBusqueda();

    var filas = document.querySelectorAll('.xone-contents-row');
    for (var j = 0; j < filas.length; j++) {
        var elemId = filas[j].querySelector('[xone-name="MAP_ID_DOM"]');
        if (elemId && elemId.textContent.trim() == idMensaje) {
            filas[j].scrollIntoView({ behavior: 'smooth', block: 'center' });
            filas[j].style.outline = '4px solid #E65100';
            filas[j].style.outlineOffset = '-4px';
            filas[j]._resaltadoBusqueda = true;
            return;
        }
    }
    // No está en DOM, cargar el rango
    await _cargarRangoBusquedaFicha(objself, idMensaje);
}

function mostrarResultadosBusquedaFicha(objself, collBusqueda, coincidencias, textoBuscado) {
    objself._pendingCoincidenciasFicha = coincidencias;
    objself._pendingCollFicha = collBusqueda;
    objself._pendingTextoFicha = textoBuscado;
    objself.MAP_RESULTADOS_BUSQUEDA_FICHA_VISIBLE = 1;
    // Más tiempo para que XOne renderice el flotante antes de buscar el DOM
    ui.executeActionAfterDelay("inyectarResultadosFichaDOM", 1);
}


function inyectarResultadosFichaDOM(objself) {
    ("[inyectarFicha] ejecutado");

    var coincidencias = objself._pendingCoincidenciasFicha || [];
    var collBusqueda = objself._pendingCollFicha;
    var textoBuscado = objself._pendingTextoFicha || "";

    if (!collBusqueda || coincidencias.length === 0) {
        ("[inyectarFicha] sin datos");
        return;
    }

    // Buscar el contenedor por el prop TL que está dentro del frame
    var contenedor = document.querySelector('[xone-name="frmResultadosFichaCuerpo"]');
    ("[inyectarFicha] por prop:", !!contenedor);

    if (!contenedor) {
        objself._inyectarFichaIntentos = (objself._inyectarFichaIntentos || 0) + 1;
        if (objself._inyectarFichaIntentos < 8) {
            ui.executeActionAfterDelay("inyectarResultadosFichaDOM", 0.5);
        } else {
            objself._inyectarFichaIntentos = 0;
            ("[inyectarFicha] no encontrado tras 8 intentos");
        }
        return;
    }
    objself._inyectarFichaIntentos = 0;

    var html = "";
    for (var k = coincidencias.length - 1; k >= 0; k--) {
        var idMsg = coincidencias[k];
        for (var i = 0; i < collBusqueda.count(); i++) {
            var obj = collBusqueda.getItem(i);
            if (obj.ID == idMsg) {
                var texto = obj.MAP_TEXTO_BUSQUEDA || "";
                var idx = texto.toLowerCase().indexOf(textoBuscado.toLowerCase());
                var inicio = Math.max(0, idx - 30);
                var fin = Math.min(texto.length, idx + textoBuscado.length + 30);
                var extracto = (inicio > 0 ? "..." : "")
                    + texto.substring(inicio, fin)
                    + (fin < texto.length ? "..." : "");

                html += '<div onclick="seleccionarResultadoFichaDOM(' + obj.ID + ')"'
                    + ' style="padding:8px 12px;border-bottom:1px solid #E9EDEF;cursor:pointer;">'
                    + '<div style="font-size:11px;color:#909193;">'
                    + (obj.MAP_FECHA_HORA_BUSQUEDA || "") + '</div>'
                    + '<div style="font-size:13px;color:#333;margin-top:2px;">'
                    + extracto + '</div>'
                    + '</div>';
                break;
            }
        }
    }

    contenedor.innerHTML = html;
    ("[inyectarFicha] inyectado en prop, filas:", coincidencias.length);
}

window.seleccionarResultadoFichaDOM = function (idMsg) {
    var objself = _objClienteEdicionChat;
    ("[seleccionarResultadoFichaDOM] objself:", !!objself, "idMsg:", idMsg);
    if (!objself) {
        ui.showToast("Error: referencia perdida");
        return;
    }
    objself.getOwnerCollection().setVariables("MensajeObjetivoBusquedaFicha", idMsg);
    ui.executeActionAfterDelay("irAMensajeBusquedaFicha", 0.1);
};

async function irAMensajeBusquedaFichaAction(objself) {
    var idMsg = objself.getOwnerCollection().getVariables("MensajeObjetivoBusquedaFicha");
    if (!idMsg || idMsg <= 0) return;

    if (mensajeEnDom(idMsg)) {
        scrollYResaltarMensaje(idMsg);
        return;
    }

    var collBusqueda = appData.getCollection("MensajeriaBusquedaScript");
    var idInicio = idMsg;
    var idFin = null;

    for (var i = 0; i < collBusqueda.count(); i++) {
        if (collBusqueda.getItem(i).ID == idMsg) {
            var idxInicio = Math.max(0, i - 50);
            idInicio = collBusqueda.getItem(idxInicio).ID;
            var idxFin = Math.min(collBusqueda.count() - 1, i + 50);
            idFin = collBusqueda.getItem(idxFin).ID;
            break;
        }
    }

    // En la ficha el idLead es objself.ID
    var idLead = objself.MAP_IDLEAD_SEL > 0 ? objself.MAP_IDLEAD_SEL : objself.ID;
    var macro = "m.IDLEAD=" + idLead + " AND m.ID >= " + idInicio;
    if (idFin) macro += " AND m.ID <= " + idFin;

    var cnt = await objself.getContents("Mensajeria");
    cnt.unlock();
    cnt.setMacro("##MACRO##", macro);
    cnt.clear();
    await cnt.loadAll();
    cnt.lock();
    ui.refresh("Mensajeria");
    ui.executeActionAfterDelay("scrollAMensajeBusquedaFicha", 0.5);
}

function scrollAMensajeBusquedaFicha(objself) {
    var idObjetivo = objself.getOwnerCollection().getVariables("MensajeObjetivoBusquedaFicha");
    if (!idObjetivo || idObjetivo <= 0) return;

    objself._scrollBusquedaIntentosFicha = (objself._scrollBusquedaIntentosFicha || 0) + 1;
    ("[scrollBusquedaFicha] intento:", objself._scrollBusquedaIntentosFicha, "buscando ID:", idObjetivo);

    if (objself._scrollBusquedaIntentosFicha > 10) {
        ("[scrollBusquedaFicha] máximo reintentos");
        objself._scrollBusquedaIntentosFicha = 0;
        objself.getOwnerCollection().setVariables("MensajeObjetivoBusquedaFicha", null);
        return;
    }

    if (scrollYResaltarMensaje(idObjetivo)) {
        ("[scrollBusquedaFicha] encontrado y resaltado");
        objself._scrollBusquedaIntentosFicha = 0;
        objself.getOwnerCollection().setVariables("MensajeObjetivoBusquedaFicha", null);
    } else {
        ("[scrollBusquedaFicha] no encontrado, reintentando");
        ui.executeActionAfterDelay("scrollAMensajeBusquedaFicha", 1);
    }
}

async function _cargarRangoBusquedaFicha(objself, idMensaje) {
    var collBusqueda = appData.getCollection("MensajeriaBusquedaScript");
    var idInicio = idMensaje;
    var idFin = null;

    for (var i = 0; i < collBusqueda.count(); i++) {
        if (collBusqueda.getItem(i).ID == idMensaje) {
            var idxIni = Math.max(0, i - 50);
            idInicio = collBusqueda.getItem(idxIni).ID;
            var idxFin = Math.min(collBusqueda.count() - 1, i + 50);
            idFin = collBusqueda.getItem(idxFin).ID;
            break;
        }
    }

    var idLead = objself.MAP_IDLEAD_SEL > 0 ? objself.MAP_IDLEAD_SEL : objself.ID;
    var macro = "m.IDLEAD=" + idLead + " AND m.ID >= " + idInicio;
    if (idFin) macro += " AND m.ID <= " + idFin;

    var cnt = await objself.getContents("Mensajeria");
    cnt.unlock();
    cnt.setMacro("##MACRO##", macro);
    cnt.clear();
    await cnt.loadAll();
    cnt.lock();
    ui.refresh("Mensajeria");

    objself.getOwnerCollection().setVariables("MensajeObjetivoBusquedaFicha", idMensaje);
    ui.executeActionAfterDelay("scrollAMensajeBusquedaFicha", 0.6);
}



// =============================================
// Control campana actualizaciones
// =============================================

async function navegarANotificacion(objNotif) {
    if (!objNotif || !objNotif.ID || objNotif.ID <= 0) return;

    var idLeadDestino = objNotif.MAP_IDLEAD || objNotif.ID;
    if (!idLeadDestino || idLeadDestino <= 0) return;

    if (window._navegandoNotif) return;
    window._navegandoNotif = true;
    setTimeout(function () { window._navegandoNotif = false; }, 1500);

    var objLayout = user.getVariables("layout");
    if (!objLayout) return;

    objLayout.MAP_VER_NOTIFICACION = 0;

    objLayout.setVariables("ChatNotificacionID", null);
    objLayout.setVariables("ChatNotificacionCorreo", null);
    objLayout.setVariables("ChatNotificacionNombre", null);

    objLayout.setVariables("ChatNotificacionID", idLeadDestino);
    objLayout.setVariables("ChatNotificacionCorreo", objNotif.MAP_CORREO || "");
    objLayout.setVariables("ChatNotificacionNombre", objNotif.MAP_NOMBRE || "");

    try {
        var cntNotif = await objLayout.getContents("MensajeriaChatListadoNotificacion");
        if (cntNotif) {
            cntNotif.unlock();
            cntNotif.clear();
            cntNotif.lock();
        }
    } catch (e) { }

    var collMensajeria = appData.getCollection("MensajeriaList");
    var objNuevo = await collMensajeria.createObject();
    appData.pushValueAndExit(objNuevo);
}

async function cargarDesplegableNotificaciones(objLayout) {
    if (!objLayout) return;

    var cnt = await objLayout.getContents("MensajeriaChatListadoNotificacion");
    if (!cnt) {
        objLayout.MAP_NOTIFICACION = 0;
        objLayout.MAP_VER_NOTIFICACION = 0;
        objLayout.setFieldPropertyValue("MAP_BTNOTIFICACION", "img", "btNotificacionNo.png");
        return;
    }

    try {
        cnt.unlock();
        cnt.clear();
        cnt.lock();
    } catch (e) { }

    // await filtrarContentMacroObject(cnt, "c.IDESTADO=10");
    await filtrarContentMacroObject(cnt, getFilter(objLayout, "MensajeriaChatListadoNotificacion"));
    
    if (cnt.count() > 0) {
        objLayout.MAP_NOTIFICACION = 1;
        objLayout.setFieldPropertyValue("MAP_BTNOTIFICACION", "img", "btNotificacionSi.png");
    } else {
        objLayout.MAP_NOTIFICACION = 0;
        objLayout.MAP_VER_NOTIFICACION = 0;
        objLayout.setFieldPropertyValue("MAP_BTNOTIFICACION", "img", "btNotificacionNo.png");
    }
}

async function marcarChatComoLeido(objself, idLead, actualizarCampana) {
    if (!idLead || idLead <= 0) return;

    actualizarCampana = actualizarCampana !== false;
    var objMenu = user.getVariables("layout");

    var collNotif = appData.getCollection("MensajeriaScript");
    
    await filtrarCollMacroObject(collNotif,
    "IDLEAD=" + idLead + " AND ENVIADO_ALIVIA=0 AND ORIGIN='humano' AND ifnull(NOTIFICADO,0)=0 AND (SESSIONID IS NULL OR SESSIONID='')");
    
    var pendientes = collNotif.count();
    var habiaAvisoVisual = false;

    for (var i = 0; i < pendientes; i++) {
        collNotif.getItem(i).NOTIFICADO = 1;
        await collNotif.getItem(i).save();
    }

    try {
        var cntListado = await objself.getContents("MensajeriaChatListado");
        if (cntListado) {
            for (var j = 0; j < cntListado.count(); j++) {
                var objL = cntListado.getItem(j);
                if (objL.MAP_ID == idLead || objL.ID == idLead) {
                    if (objL.MAP_ICONO_NOTIFICACION !== "" || objL.MAP_NUM_NOTIFICACIONES !== "") {
                        habiaAvisoVisual = true;
                        objL.MAP_ICONO_NOTIFICACION = "";
                        objL.MAP_NUM_NOTIFICACIONES = "";
                        ui.refreshContentRow("MensajeriaChatListado", j);
                    }
                    break;
                }
            }
        }
    } catch (e) { }

    if (objMenu) {
        objMenu.MAP_VER_NOTIFICACION = 0;
        if (actualizarCampana && (pendientes > 0 || habiaAvisoVisual)) {
            await actualizarEstadoCampanaLigero(objMenu);
        }
    }
}

// function actualizarEstadoCampanaLigero(objMenu) {
//     if (!objMenu) return;

//     var collPendientes = appData.getCollection("MensajeriaScript");
//     filtrarCollMacroObject(collPendientes, "ENVIADO_ALIVIA=0 AND ORIGIN='humano' AND ifnull(NOTIFICADO,0)=0 AND (SESSIONID IS NULL OR SESSIONID='')");

//     if (collPendientes.count() > 0) {
//         objMenu.MAP_NOTIFICACION = 1;
//         objMenu.setFieldPropertyValue("MAP_BTNOTIFICACION", "img", "btNotificacionSi.png");
//     } else {
//         objMenu.MAP_NOTIFICACION = 0;
//         objMenu.MAP_VER_NOTIFICACION = 0;
//         objMenu.setFieldPropertyValue("MAP_BTNOTIFICACION", "img", "btNotificacionNo.png");
//     }
// }

async function actualizarEstadoCampanaLigero(objMenu) {
    if (!objMenu) return;

    var filtro = "ENVIADO_ALIVIA=0 AND ORIGIN='humano' AND ifnull(NOTIFICADO,0)=0 AND (SESSIONID IS NULL OR SESSIONID='')";
    
    // Solo el ESC ve las notificaciones de sus clientes asignados
    if (user.USERTYPE == 6) {
        filtro += " AND IDLEAD IN (SELECT ID FROM gen_cliente WHERE IDESC=" + user.ID + ")";
    }

    var collPendientes = appData.getCollection("MensajeriaScript");
    await filtrarCollMacroObject(collPendientes, filtro);

    if (collPendientes.count() > 0) {
        objMenu.MAP_NOTIFICACION = 1;
        objMenu.setFieldPropertyValue("MAP_BTNOTIFICACION", "img", "btNotificacionSi.png");
    } else {
        objMenu.MAP_NOTIFICACION = 0;
        objMenu.MAP_VER_NOTIFICACION = 0;
        objMenu.setFieldPropertyValue("MAP_BTNOTIFICACION", "img", "btNotificacionNo.png");
    }
}

async function debeNotificarUsuario(idLeadDestino) {
    if (user.USERTYPE != 6) return true; // otros roles ven todo
    
    var collCliente = appData.getCollection("ClienteScript");
    await filtrarCollMacroObject(collCliente, "c.ID=" + idLeadDestino + " AND c.IDESC=" + user.ID);
    return collCliente.count() > 0;
}

// para adjuntar un archivo al mensaje que enviemos
async function adjuntarArchivo(objself, campo, campo2, campo3) {

    var jsParams = {
        targetProperty: "MAP_MENSAJE_MULTIMEDIA_BASE64",
        fileTypes: "png,jpg,mp4"
    };

    const file = await ui.pickFile(jsParams);

    objself[campo] = file.name;
    objself[campo2] = file.type;
    objself[campo3] = file.size;

    objself.getOwnerCollection().setVariables("File", file);
}

function borrarArchivoAdjunto(objself) {
    if (objself.getOwnerCollection().getVariables("File") !== null) {
        objself.MAP_MENSAJE_MULTIMEDIA = "";
        objself.MAP_MENSAJE_MULTIMEDIA_BASE64 = "";
        objself.MAP_MENSAJE_MULTIMEDIA_TIPO = "";
        objself.MAP_MENSAJE_MULTIMEDIA_TAMANIO = 0;
        objself.getOwnerCollection().setVariables("File", null);
    }
}

// para cargar en bytes el fichero multimedia en enviarMensajeMultimedia()
function cargarMultimediaBytes(fileBase64) {

    // Función para cargar imagen en bytes para mandarla en un mensaje
    var base64Data = fileBase64.split(',')[1]; // Elimina el prefijo "data:..."
    const binaryString = atob(base64Data);
    const len = binaryString.length;

    const bytes = new Array(len);
    for (let i = 0; i < len; i++) {
        bytes[i] = binaryString.charCodeAt(i);
    }
    return bytes;
}

// limpia el input instantaneamente visualmente y guarda lo escrito en memoria
function limpiarCajaMensajeRapido(objself) {
    let textoMensaje = objself.MAP_MENSAJE;
    if (textoMensaje) textoMensaje = textoMensaje.trim();

    // Guardamos en la coleccion por si falla o lo necesita el webhook ok
    objself.getOwnerCollection().setVariables("UltimoMensajeEnviado", textoMensaje);

    // Vaciamos e informamos a la pantalla
    objself.MAP_MENSAJE = "";
    ui.refreshValue("MAP_MENSAJE");

    return textoMensaje;
}



// **********************************
// *** envío mensajes de whatsapp ***
// **********************************

// enviar mensaje ya sea multimedia o texto
function enviarMensajeWhatsapp(objself) {
    if (objself.getOwnerCollection().getVariables("File") !== null) {

        var multimediaBase64 = objself.MAP_MENSAJE_MULTIMEDIA_BASE64;
        var tipo = objself.MAP_MENSAJE_MULTIMEDIA_TIPO;

        // si es imagen o vídeo
        enviarMensajeMultimedia(objself, multimediaBase64, tipo);

    } else {
        // mensaje de texto
        enviarMensajeTexto(objself);
    }
}


function enviarMensajeTexto(objself) {
    if (isNullOrEmpty(objself.MAP_MENSAJE) || objself.MAP_MENSAJE === "") {
        return;
    }

    // En ClienteEdicion usar CORREO directamente, en MensajeriaList usar MAP_CORREO
    var emailDestino = objself.CORREO || objself.MAP_CORREO;
    ("[enviarMensaje] email:", emailDestino);

    let textoMensaje = limpiarCajaMensajeRapido(objself);
    objself.MAP_ENVIANDO_MENSAJE = 1;
    let data = {
        Email: emailDestino,
        Text: {
            body: textoMensaje,
            preview_url: true
        }
    };
    try {
        callApiPost(objself, "message", "text", data, user.MAP_TOKEN, OnMensajeOK, OnMensajeFail);
    } catch (e) {
        ui.showToast(e);
        ui.showToast("Ha ocurrido un error. Por favor, compruebe su conexión a internet e inténtelo nuevamente.enviarMensajeTexto");
        objself.MAP_ENVIANDO_MENSAJE = 0;
    }
}

// Mensajes multimedia
function enviarMensajeMultimedia(objself, fileBase64, tipo) {
    var multimediaBytes, tipoURL;

    multimediaBytes = cargarMultimediaBytes(fileBase64);

    // definimos el tipo para la url de la llamada
    if (tipo.includes("image")) {
        tipoURL = "image";
    } else if (tipo.includes("video")) {
        tipoURL = "video";
    }

    // si la imagen tiene más de 5Mb, no dejamos
    if (multimediaBytes.byteLength > 5000000 && tipo == "image") {
        ui.showToast("La imagen no puede pesar más de 5MB");
        return;

        // si el vídeo tiene más de 16Mb, no dejamos
    } else if (multimediaBytes.byteLength > 16000000 && tipo == "video") {
        ui.showToast("El vídeo no puede pesar más de 5MB");
        return;

    } else {
        let textoMensaje = limpiarCajaMensajeRapido(objself);

        objself.MAP_ENVIANDO_MENSAJE = 1;
        let data = {
            Email: objself.MAP_CORREO,
            Caption: textoMensaje,
            Media: {
                fileName: "holaaa",
                type: tipo,
                data: multimediaBytes
            }
        };

        try {
            callApiPost(objself, "message", tipoURL, data, user.MAP_TOKEN, OnMensajeOK, OnMensajeFail);
        } catch (e) {
            ui.showToast(e);
            ui.showToast("Ha ocurrido un error. Por favor, compruebe su conexión a internet e inténtelo nuevamente.");
            objself.MAP_ENVIANDO_MENSAJE = 0;
        }
    }
}


async function OnMensajeOK(objself, data) {
    try {
        let textoMensaje = objself.getOwnerCollection().getVariables("UltimoMensajeEnviado") || objself.MAP_MENSAJE;
        objself.MAP_MENSAJE = "";
        objself.MAP_ENVIANDO_MENSAJE = 0;
        objself.getOwnerCollection().setVariables("File", null);
        objself.MAP_MENSAJE_MULTIMEDIA = "";
        objself.MAP_MENSAJE_MULTIMEDIA_BASE64 = "";
        objself.MAP_MENSAJE_MULTIMEDIA_TIPO = "";
        objself.MAP_MENSAJE_MULTIMEDIA_TAMANIO = 0;

        // Actualizamos el chat derecho
        _agregarMensajeProgramado = false;
        _objMensajeriaList = objself;
        recibirMensajeEnChat(objself);

        // Actualizamos el listado izquierdo — solo en MensajeriaList
        var collName = objself.getOwnerCollection().getName();
        if (collName === "MensajeriaList") {
            let textoPreview = textoMensaje.length > 50
                ? textoMensaje.substring(0, 50) + '...'
                : textoMensaje;
            let horaStr = convertirHora(Math.floor(Date.now() / 1000));
            await actualizarListadoConMensaje(objself, objself.MAP_IDLEAD_SEL, textoPreview, horaStr, "tickGris.png");
        }
    } catch (ex) {
        ("[OnMensajeOK] error:", ex.message);
        ui.showToast("Ha ocurrido un error. Por favor, compruebe su conexión a internet e inténtelo nuevamente.");
        objself.MAP_ENVIANDO_MENSAJE = 0;
    }
}

// fallo en el envío del mensaje
function OnMensajeFail(objself, data) {
    try {
        // if(data !== null) {
        ui.showToast("No se ha podido enviar el mensaje. ");
        // Restauramos el mensaje si falló
        let textoRecuperar = objself.getOwnerCollection().getVariables("UltimoMensajeEnviado");
        if (textoRecuperar) {
            objself.MAP_MENSAJE = textoRecuperar;
            ui.refreshValue("MAP_MENSAJE");
        }
        objself.MAP_ENVIANDO_MENSAJE = 0;
        // }
    } catch (e) {
        ui.showToast("Ha ocurrido un error. Por favor, compruebe su conexión a internet e inténtelo nuevamente.OnMensajeFail");
        objself.MAP_ENVIANDO_MENSAJE = 0;
    }
}



// ***************************
// *** descarga multimedia ***
// ***************************


// recorrer todos los mensajes y mandar descargar contenido multimedia
async function descargarMultimediaChat(objself) {
    // recorremos los registros y descargamos las imágenes
    var filter = "";
    var cntMensaje = await objself.getContents("Mensajeria");


    switch (objself.getOwnerCollection().getName()) {
        case "LeadEdicion":
            // para la ficha particular de cada lead/cliente
            filter = "m.IDLEAD=" + objself.ID;
            break;
        case "ClienteEdicion":
            filter = "m.IDLEAD=" + objself.ID;
            break;
        case "MensajeriaList":
            // para el chat general
            filter = "m.IDLEAD=" + objself.MAP_IDLEAD_SEL;
            break;
    }
    // await filtrarContentMacroObject(cntMensaje,filter);

    var tipo = {
        image: {
            enviado: "MAP_MENSAJE_MULTIMEDIA_ENV",
            recibido: "MAP_MENSAJE_MULTIMEDIA"
        },
        video: {
            enviado: "MAP_MENSAJE_MULTIMEDIA_VIDEO_ENV",
            recibido: "MAP_MENSAJE_MULTIMEDIA_VIDEO"
        },
        audio: {
            enviado: "MAP_MENSAJE_MULTIMEDIA_AUDIO_ENV",
            recibido: "MAP_MENSAJE_MULTIMEDIA_AUDIO"
        },
        document: {
            enviado: "MAP_DOCUMENTO_ENV",
            recibido: "MAP_DOCUMENTO"
        },
    };

    for (var i = 0; i < cntMensaje.count(); i++) {
        var objMensaje = cntMensaje.getItem(i);

        // Buscamos los mensajes no leídos al entrar al chat y los marcamos como notificados
        if (objMensaje.NOTIFICADO === 0) {
            objMensaje.NOTIFICADO = 1;
            await objMensaje.save();
        }

        // accede a tipo.image o tipo.video..todo lo multimedia
        var tipoInfo = tipo[objMensaje.TIPO];

        if (tipoInfo) {
            var indiceMensaje = i;

            descargarArchivoMultimedia(objself, objMensaje, indiceMensaje,
                function (objself, dataBase64, objMensaje, indiceMensaje) {

                    // si la llamada a la api es Ok
                    const blob = base64ToBlob(dataBase64.Data, dataBase64.MimeType);
                    const blobUrl = URL.createObjectURL(blob);

                    // asignamos la url al prop adecuado
                    var campo = objMensaje.ENVIADO_ALIVIA == 1 ? tipo[objMensaje.TIPO].enviado : tipo[objMensaje.TIPO].recibido;
                    objMensaje[campo] = blobUrl;

                    ui.refreshContentRow('Mensajeria', indiceMensaje);
                },
                function (objself, errorCode, errorMsg) {
                    ui.showToast("Error tratando de obtener los archivos multimedia");
                }
            );
        }
    }
}

// conversión para mostrar el archivo multimedia
function base64ToBlob(base64, mimeType) {
    const byteCharacters = atob(base64);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += 512) {
        const slice = byteCharacters.slice(offset, offset + 512);

        const byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
        }

        const byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
    }

    return new Blob(byteArrays, { type: mimeType });
}


// llamada api para descargar los archivos multimedia de whatsapp
function descargarArchivoMultimedia(objself, objMensaje, indiceMensaje, callBackSuccess, callBackError) {

    let data = {
        Email: objself.MAP_CORREO,
        IdMessage: objMensaje.ID
    };

    try {
        callApiPost(objself, "download", "", data, user.MAP_TOKEN,
            function (objself, response) {
                callBackSuccess(objself, response, objMensaje, indiceMensaje);
            },
            function (objself, errorCode, errorMsg) {
                callBackError(objself, errorCode, errorMsg);
            });
    } catch (e) {
        ui.showToast(e);
        ui.showToast("Ha ocurrido un error. Por favor, compruebe su conexión a internet e inténtelo nuevamente.");
        objself.MAP_ENVIANDO_MENSAJE = 0;
    }
}

// abrir archivo multimedia según su tipo
function abrirMultimedia(objself) {
    if (self.TIPO !== 'text') {

        // según el tipo de archivo, si es enviado o recibido, cogemos un prop u otro para montar la url
        var urlMap = {
            image: self.ENVIADO_ALIVIA == 1 ? self.MAP_MENSAJE_MULTIMEDIA_ENV : self.MAP_MENSAJE_MULTIMEDIA,
            video: self.ENVIADO_ALIVIA == 1 ? self.MAP_MENSAJE_MULTIMEDIA_VIDEO_ENV : self.MAP_MENSAJE_MULTIMEDIA_VIDEO,
            document: self.ENVIADO_ALIVIA == 1 ? self.MAP_DOCUMENTO_ENV : self.MAP_DOCUMENTO
        };

        ui.openUrl(urlMap[self.TIPO]);
    }
}

// Funciones de los movimientos del cliente


async function comprobarRectificativa(iddeuda,idlead){
    // para ver si podemos volver de etapa de pago financiera o solicitar de nuevo la CE si se ha rectificado previamente
    var collMovRec = appData.getCollection("MovimientosScript");
    
    // Buscamos la comisión de éxito más reciente que se haya cobrado
    await filtrarCollMacroObject(collMovRec,"m.IDLEAD="+idlead+" AND m.IDTIPO_MOVIMIENTO=3 AND m.IDESTADO IN(5,7) AND m.IDDEUDA="+iddeuda+" ORDER BY m.FECHA_SOLICITUD DESC");
    
    if(collMovRec.count() > 0) {
        let mov = collMovRec.getItem(0);
        
        // buscamos si existe un movimiento rectificatvo asociado y devuelto (confirmado)
        await filtrarCollMacroObject(collMovRec,"m.IDLEAD="+idlead+" AND m.IDTIPO_MOVIMIENTO=9 AND m.IDESTADO=7 AND m.IDFACTURA_RECTIFICADA ='" +mov.IDENTIFICADOR+"'");
        if(collMovRec.count() > 0){
            return 1;
        }else{
            return 0;
        }
    } else{
        return 0;
    }
}

async function fraccionarCobro(objself,idmovimiento) {
    // MovimientosList. Para fraccionar CE
    
    // en caso de descuento y refinanciación sólo
    if(objself.MAP_FRACCION_COMISION <= 0) {
        ui.showToast("Indique el número de pagos");
        return;
    }
    
    let fecha = ObtenerFechaHoraActual();
    
    // Buscamos el movimiento actual para fraccionarlo tantas veces como se haya indicado
    var collMov = appData.getCollection("MovimientosScript");
    await filtrarCollMacroObject(collMov,"m.ID="+idmovimiento);
    
    if(collMov.count() === 0){
        ui.showToast("No se ha podido fraccionar el movimiento indicado");
        return;
    }
    
    // modificamos el movimiento actual fraccionando el pago
    let objMovCE = collMov.getItem(0);

    
    // creamos tantos movimientos adicionales como fracciones se hayan indicado - el existente
    for (var i = 1; i < objself.MAP_FRACCION_COMISION; i++) {
        let objMov = await collMov.createObject();
        
        objMov.IDDEUDA = objMovCE.IDDEUDA;
        objMov.IDLEAD = objMovCE.IDLEAD;
        objMov.IDTIPO_MOVIMIENTO = 3;
        objMov.FECHA_SOLICITUD =  sumarMeses(fecha, i);
        objMov.CE_DEUDA_LIQUIDADA = 0;

        objMov.IDESTADO = 5;
        objMov.BASE_IMPONIBLE = round(objMovCE.BASE_IMPONIBLE / objself.MAP_FRACCION_COMISION,2);
        objMov.IVA = round(objMovCE.IVA / objself.MAP_FRACCION_COMISION,2);
        objMov.IMPORTE = objMovCE.IMPORTE / objself.MAP_FRACCION_COMISION;
        
        await objMov.save();
    }
    
    
    objMovCE.FECHA_SOLICITUD = fecha;
    objMovCE.FECHA_DONE = "";
    objMovCE.BASE_IMPONIBLE = round(objMovCE.BASE_IMPONIBLE / objself.MAP_FRACCION_COMISION,2);
    objMovCE.IVA = round(objMovCE.IVA / objself.MAP_FRACCION_COMISION,2);
    objMovCE.IMPORTE = objMovCE.IMPORTE / objself.MAP_FRACCION_COMISION;
    
    await objMovCE.save();
    
    await Promise.all([
        actualizarDatosPaginadoLeads(objself,"Movimientos","MovimientosContador","MAP_PAG_INI","MAP_PAG_LEN","MAP_TOTAL_REGISTROS","MAP_T1"),
        actualizarDatosPaginadoLeads(objself,"MovimientosComision","MovimientosComisionContador","MAP_PAG_INI_FAC","MAP_PAG_LEN_FAC","MAP_TOTAL_REGISTROS_FAC","MAP_T4"),
    ]);
    
    await objself.executeNode('fraccionarCobroComision');  
}

async function solicitarCobro(objself,iddeuda,producto,mes){
    // ClienteEdicion. Para generar el movimiento de CE de la deuda en la etapa 'cobro comisión'
    
    // en caso de descuento y refinanciación
    if(producto != 3 && objself.MAP_FRACCION_COMISION <= 0) {
        ui.showToast("Indique el número de pagos");
        return;
    }
    
    let fecha=ObtenerFechaHoraActual();
    let collDeuda = appData.getCollection("DeudaClienteScript");
    await filtrarCollMacroObject(collDeuda,"d.ID="+iddeuda+" AND ifnull(d.BAJA,0)=0");
    
    if(collDeuda.count()>0){
        let objDeuda = collDeuda.getItem(0);
        
        // Comprobamos si ya ha generado el cobro y está pendiente
        var collMov1 = appData.getCollection("MovimientosScript");

        // en caso de ser un fraccionamiento, buscamos el movimiento correspondiente al mes seleccionado
        if(producto==3){
            await filtrarCollMacroObject(collMov1,"m.IDDEUDA="+objself.MAP_IDDEUDA+" and m.IDLEAD="+objself.ID+" and m.MES="+mes+" and m.IDTIPO_MOVIMIENTO=3 and ifnull(m.CE_DEUDA_LIQUIDADA,0)=0 AND m.IDESTADO IN(5,6,7,10) AND m.IDACTIVIDAD IS NULL");
            
            if(collMov1.count()>0){
                ui.showToast("Ya existe un cobro pendiente asociado a la deuda. Revise el apartado de movimientos");
                return;
            }
        }else{
            // buscamos si se ha realizado una rectificación previa para permitir solicitar otra vez la CE
            var comisionRectificada = await comprobarRectificativa(iddeuda,objself.ID);
            
            if(comisionRectificada === 0){
                // si no hemos encontrado ninguna rectificativa asociada, miramos si ya hay un movimiento generado
                await filtrarCollMacroObject(collMov1,"m.IDDEUDA="+objself.MAP_IDDEUDA+" and m.IDLEAD="+objself.ID+" and m.IDTIPO_MOVIMIENTO=3 and ifnull(m.CE_DEUDA_LIQUIDADA,0)=0 AND m.IDESTADO IN(5,6,7,10) AND m.IDACTIVIDAD IS NULL");
                if(collMov1.count() > 0){
                    ui.showToast("Ya existe un cobro pendiente asociado a la deuda. Revise el apartado de movimientos");
                    return;
                }
            }
            
        }
        
        let pregunta= await ui.msgBox("¿Está seguro que desea solicitar el cobro?","Cobro comisión",1);
        
        if(pregunta==1){
            // generamos el movimiento para la comisión de éxito
            let collMov = appData.getCollection("Movimientos");
            
            if(producto == 1 || producto == 2) {
                // creamos tantos movimientos como fracciones se hayan indicado
                for (var i = 0; i < objself.MAP_FRACCION_COMISION; i++) {
                    let objMov = await collMov.createObject();
                    
                    objMov.IDDEUDA = iddeuda;
                    objMov.IDLEAD = objself.ID;
                    objMov.IDTIPO_MOVIMIENTO = 3;
                    objMov.FECHA_SOLICITUD = sumarMeses(fecha, i);
                    objMov.CE_DEUDA_LIQUIDADA = 0;
        
                    objMov.IDESTADO = 5;
                    objMov.BASE_IMPONIBLE = round((objDeuda.COMISION_EXITO/1.21) / objself.MAP_FRACCION_COMISION,2);
                    objMov.IVA = round((objDeuda.COMISION_EXITO - (objDeuda.COMISION_EXITO/1.21)) / objself.MAP_FRACCION_COMISION,2);
                    objMov.IMPORTE = objDeuda.COMISION_EXITO / objself.MAP_FRACCION_COMISION;
                    
                    await objMov.save();
                }
            }else if(producto == 3){
                // guardamos el mes y el cobro mensual en el caso de deuda con producto fraccionamiento
                let objMov = await collMov.createObject();
                
                objMov.IDDEUDA = iddeuda;
                objMov.IDLEAD = objself.ID;
                objMov.IDTIPO_MOVIMIENTO = 3;
                objMov.FECHA_SOLICITUD = fecha;
                objMov.CE_DEUDA_LIQUIDADA = 0;
    
                objMov.IDESTADO = 5;
                objMov.MES = mes;
                objMov.BASE_IMPONIBLE = round(objDeuda.CE_MENSUAL/1.21,2);
                objMov.IVA = round(objDeuda.CE_MENSUAL - (objDeuda.CE_MENSUAL/1.21),2);
                objMov.IMPORTE = objDeuda.CE_MENSUAL;
                await objMov.save();
            }
            
            // Generamos y guardamos el identificador del movimiento (comisión de éxito)
            // await generarIdentificadorMovimiento(3,objMov.ID);
            
            await Promise.all([
                actualizarDatosContent(objself,"DeudaClientePrograma"),
                actualizarDatosContent(objself,"MovimientosCliente"),
            ]);
            
            // actualizamos el plan de pagos si es una deuda con producto fraccionamiento
            if(producto == 1 || producto == 2) {
                await objself.executeNode('fraccionarCobroComision');  
            }else if(producto==3){
                // await actualizarDatosContent(objself,"PlanDePagos");
                var cnt = await objself.getContents("PlanDePagos");
                await filtrarContentMacroObject(cnt,"p.IDDEUDA="+iddeuda+" and p.BAJA=0");
            }
            
            ui.showToast("Movimiento/s de cobro de comisión creado/s. Por favor, revise el apartado de movimientos");
        }else{
            return;
        }
    }
}

async function solicitarPago(objself,iddeuda,producto,idestadodeuda,mes){
    // ClienteEdicion. Para generar el movimiento de pago a la financiera de la deuda en la etapa 'pago financiera'
    // en refinanciación
    if(producto == 2){
        if(safeToFloat(objself.MAP_IMPORTE_REF) <= 0){
            ui.showToast("Debe indicar el importe para solicitar el pago");
            return;
        }
    }
    if(isNullOrEmpty(objself.MAP_BENEFICIARIO_PAGO)){
        ui.showToast("Debe indicar el beneficiario para solicitar el pago");
        return;
    }
    if(isNullOrEmpty(objself.MAP_CONCEPTO_PAGO)){
        ui.showToast("Debe indicar el concepto para solicitar el pago");
        return;
    }
    if(isNullOrEmpty(objself.MAP_IBAN_ENTIDAD_PAGO)){
        ui.showToast("Debe indicar el IBAN para solicitar el pago");
        return;
    }
    
    // Ver condiciones en las que se puede solicitar
    let fecha=ObtenerFechaHoraActual();
    let collDeuda = appData.getCollection("DeudaClienteScript");
    await filtrarCollMacroObject(collDeuda,"d.ID="+iddeuda+" AND ifnull(d.BAJA,0)=0");
    
    if(collDeuda.count() > 0){
        let objDeuda = collDeuda.getItem(0);
        
        // Comprobamos si ya ha generado el cobro y está pendiente
        var collMov1 = appData.getCollection("MovimientosScript");
  
        // en caso de ser un fraccionamiento, buscamos el movimiento correspondiente al mes seleccionado
        if(producto == 3){
            await filtrarCollMacroObject(collMov1,"m.IDDEUDA="+objself.MAP_IDDEUDA+" and m.IDLEAD="+objself.ID+" and m.MES="+mes+" and m.IDTIPO_MOVIMIENTO in(6,7,8) AND m.IDESTADO IN(3,4)");
        }else{
            await filtrarCollMacroObject(collMov1,"m.IDDEUDA="+objself.MAP_IDDEUDA+" and m.IDLEAD="+objself.ID+" and m.IDTIPO_MOVIMIENTO in(6,7,8) AND m.IDESTADO IN(3,4)");
        }
        
        if(collMov1.count() > 0){
            ui.showToast("Ya existe un pago pendiente asociado a la deuda. Revise el apartado de movimientos");
            return;
        }
        
        let pregunta= await ui.msgBox("¿Está seguro que desea solicitar el pago?","Pago financiera",1);
        
        if(pregunta == 1){
            // generamos el movimiento para la comisión de éxito
            let collMov = appData.getCollection("Movimientos");
            let objMov = await collMov.createObject();
            
            objMov.IDDEUDA = iddeuda;
            objMov.IDLEAD = objself.ID;
            objMov.FECHA_SOLICITUD = fecha;
            objMov.IBAN = objself.MAP_IBAN_ENTIDAD_PAGO;
            objMov.CONCEPTO = objself.MAP_CONCEPTO_PAGO;
            objMov.BENEFICIARIO = objself.MAP_BENEFICIARIO_PAGO;
            objMov.IDESTADO=3;
            
            if(producto == 1){
                // si es un descuento
                objMov.IDTIPO_MOVIMIENTO = 6;
                objMov.IMPORTE = objDeuda.IMPORTE_LIQUIDAR;
            }
            else if(producto == 2){
                // si es una refinanciación
                objMov.IDTIPO_MOVIMIENTO = 8;
                objMov.IMPORTE = objself.MAP_IMPORTE_REF;
            }
            // !!!
            else if(producto == 3){
                // si es un fraccionado, buscamos el importe en el plan de pagos
                let collPlanPago = appData.getCollection("PlanDePagosScript");
                await filtrarCollMacroObject(collPlanPago,"p.IDLEAD="+objself.ID+" AND p.IDDEUDA="+objself.MAP_IDDEUDA+" AND p.MES="+mes);
                
                if(collPlanPago.count() > 0){
                    let objPlanPago = collPlanPago.getItem(0);
                    
                    objMov.IDTIPO_MOVIMIENTO = 7;
                    objMov.IMPORTE = objPlanPago.PAB_MENSUAL;
                    objMov.MES = mes;
                }else{
                    ui.showToast("No se ha encontrado el importe para el mes "+mes);
                    return;
                }
                
            }
            await objMov.save();
            
            // Generamos y guardamos el identificador del movimiento
            await generarIdentificadorMovimiento(objMov.IDTIPO_MOVIMIENTO,objMov.ID);
            
            await Promise.all([
                actualizarDatosContent(objself,"DeudaClientePrograma"),
                actualizarDatosContent(objself,"MovimientosCliente"),
            ]);
            // actualizamos el plan de pagos si es una deuda con producto fraccionamiento
            if(producto==3){
                var cnt = await objself.getContents("PlanDePagos");
                await filtrarContentMacroObject(cnt,"p.IDDEUDA="+iddeuda+" and p.BAJA=0");
                // await actualizarDatosContent(objself,"PlanDePagos");
            }
            ui.showToast("Movimiento de pago a financiera creado. Por favor, revise el apartado de movimientos");
            
            limpiarCampos(self,"pagoFinanciera");
            objself.MAP_VER_PAGO_FINANCIERA=0;
            objself.MAP_MES=0;
        }else{
            return;
        }
        // generamos la actualización para mostrarlo en la zona de usuario
        await generarActualizacion(objself,iddeuda,idestadodeuda,producto,mes);
    }
}

async function generarIdentificadorMovimiento(tipoMovimiento,idmovimiento, devolverIdentificador = false){
    var identificador,numero,Contador,coll;
    var guardado=0;
    var fecha = new Date();
	var yy = safeToString(fecha.getFullYear()).substring(2,4);

    // obtenemos el movimiento que acabamos de guardar
    var collMov = appData.getCollection("MovimientosScript");
    await filtrarCollMacroObject(collMov,"m.ID="+idmovimiento);
    
    
    if(collMov.count()>0){
        let objMov = collMov.getItem(0);
        
    	do{
            try{
                // Obtenemos el número de identificador buscando el último existente y le sumamos 1 para generar uno nuevo
            	
            	// comisión mensual
                if(tipoMovimiento==2){
                    coll = appData.getCollection("MovimientoContadorComisionMensual");
                    await coll.loadAll();
                    if(coll.getItem(0)!==undefined && coll.getItem(0)!==null){
                        if(safeToInt(coll.getItem(0).NUMERO_COMISION_MENSUAL)==0){
                            Contador=1;
                        }else{
                            Contador=coll.getItem(0).NUMERO_COMISION_MENSUAL+1;
                        }
                    }
                }
                //  comisión de éxito
                else if(tipoMovimiento==3){
                    coll = appData.getCollection("MovimientoContadorComisionExito");
                    await coll.loadAll();
                    if(coll.getItem(0)!==undefined && coll.getItem(0)!==null){
                        if(safeToInt(coll.getItem(0).NUMERO_COMISION_EXITO)==0){
                            Contador=1;
                        }else{
                            Contador=coll.getItem(0).NUMERO_COMISION_EXITO+1;
                        }
                    }
                }
            	// devolución
                else if(tipoMovimiento==5){
                    coll = appData.getCollection("MovimientoContadorDevolucion");
                    await coll.loadAll();
                    if(coll.getItem(0)!==undefined && coll.getItem(0)!==null){
                        if(safeToInt(coll.getItem(0).NUMERO_DEVOLUCION)==0){
                            Contador=1;
                        }else{
                            Contador=coll.getItem(0).NUMERO_DEVOLUCION+1;
                        }
                    }
                }
            	// Pago financiera
                else if(tipoMovimiento==6 || tipoMovimiento==7 || tipoMovimiento==8){
                    coll = appData.getCollection("MovimientoContadorFinanciera");
                    await coll.loadAll();
                    if(coll.getItem(0)!==undefined && coll.getItem(0)!==null){
                        if(safeToInt(coll.getItem(0).NUMERO_FINANCIERA)==0){
                            Contador=1;
                        }else{
                            Contador=coll.getItem(0).NUMERO_FINANCIERA+1;
                        }
                    }
                }
            	// comisión rectificativa
                else if(tipoMovimiento==9){
                    coll = appData.getCollection("MovimientoContadorRectificativa");
                    await coll.loadAll();
                    if(coll.getItem(0)!==undefined && coll.getItem(0)!==null){
                        if(safeToInt(coll.getItem(0).NUMERO_RECTIFICACION)==0){
                            Contador=1;
                        }else{
                            Contador=coll.getItem(0).NUMERO_RECTIFICACION+1;
                        }
                    }
                }
                // Devolución intereses acreedores
                else if(tipoMovimiento==10){
                    coll = appData.getCollection("MovimientoContadorDevolucionInteresAcreedor");
                    await coll.loadAll();
                    if(coll.getItem(0)!==undefined && coll.getItem(0)!==null){
                        if(safeToInt(coll.getItem(0).NUMERO_DEVOLUCION_INT_ACREEDOR)==0){
                            Contador=1;
                        }else{
                            Contador=coll.getItem(0).NUMERO_DEVOLUCION_INT_ACREEDOR+1;
                        }
                    }
                }
                // Devolución intereses clientes
                else if(tipoMovimiento==11){
                    coll = appData.getCollection("MovimientoContadorDevolucionInteresCliente");
                    await coll.loadAll();
                    if(coll.getItem(0)!==undefined && coll.getItem(0)!==null){
                        if(safeToInt(coll.getItem(0).NUMERO_DEVOLUCION_INT_CLIENTE)==0){
                            Contador=1;
                        }else{
                            Contador=coll.getItem(0).NUMERO_DEVOLUCION_INT_CLIENTE+1;
                        }
                    }
                }
                // Costas
                else if(tipoMovimiento == 12){
                    coll = appData.getCollection("MovimientoContadorCostas");
                    await coll.loadAll();
                    if(coll.getItem(0)!==undefined && coll.getItem(0)!==null){
                        if(safeToInt(coll.getItem(0).NUMERO_COSTAS)==0){
                            Contador=1;
                        }else{
                            Contador=coll.getItem(0).NUMERO_COSTAS+1;
                        }
                    }
                }
                // Compensación acuerdo no judicial
                else if(tipoMovimiento == 13){
                    coll = appData.getCollection("MovimientoContadorCompensacionAcuerdoAcreedores");
                    await coll.loadAll();
                    if(coll.getItem(0)!==undefined && coll.getItem(0)!==null){
                        if(safeToInt(coll.getItem(0).NUMERO_COMPENSACION_ACUERDO_ACREEDORES)==0){
                            Contador=1;
                        }else{
                            Contador=coll.getItem(0).NUMERO_COMPENSACION_ACUERDO_ACREEDORES+1;
                        }
                    }
                }
                // CE compensación acuerdo
                else if(tipoMovimiento == 14){
                    coll = appData.getCollection("MovimientoContadorComisionExitoCompensacionAcuerdoAcreedores");
                    await coll.loadAll();
                    if(coll.getItem(0)!==undefined && coll.getItem(0)!==null){
                        if(safeToInt(coll.getItem(0).NUMERO_COMISION_EXITO_COMPENSACION_ACUERDO_ACREEDORES)==0){
                            Contador=1;
                        }else{
                            Contador=coll.getItem(0).NUMERO_COMISION_EXITO_COMPENSACION_ACUERDO_ACREEDORES+1;
                        }
                    }
                }
                        
                if(safeToInt(Contador)>0 && safeToInt(Contador)<=9){
                    // identificador entre el 1 y el 9
                    numero = '0000'+Contador;
                }else if(safeToInt(Contador)>=10 && safeToInt(Contador)<=99){
                    // identificador entre el 10 y el 99
                    numero = '000'+Contador;
                }else if(safeToInt(Contador)>=100 && safeToInt(Contador)<=999){
                    // identificador entre el 100 y el 999
                    numero = '00'+Contador;
                }else if(safeToInt(Contador)>=1000 && safeToInt(Contador)<=9999){
                    // identificador entre el 1000 y el 9999
                    numero = '0'+Contador;
                }else{
                    // identificador por encima del 10000
                    numero = Contador;
                }
                coll.clear();
                
                // completamos aquí los distintos tipos de identificadores según el tipo de movimiento
                // Comisión mensual
                if(tipoMovimiento==2){
                    identificador="CM"+yy+numero;
                    objMov.NUMERO_COMISION_MENSUAL = Contador;
                }
                // Comisión de éxito
                else if(tipoMovimiento==3){
                    identificador="CE"+yy+numero;
                    objMov.NUMERO_COMISION_EXITO = Contador;
                }
                // Devolución
                else if(tipoMovimiento==5){
                    identificador="DEV"+yy+numero;
                    objMov.NUMERO_DEVOLUCION = Contador;
                }
                // Pago liquidación
                else if(tipoMovimiento==6 || tipoMovimiento==7 || tipoMovimiento==8){
                    identificador="PAG"+yy+numero;
                    objMov.NUMERO_FINANCIERA = Contador;
                }
                // Comisión rectificativa
                else if(tipoMovimiento==9){
                    identificador="RC"+yy+numero;
                    objMov.NUMERO_RECTIFICACION = Contador;
                }
                // Devolución intereses acreedores
                else if(tipoMovimiento == 10){
                    identificador = "DIA"+yy+numero;
                    objMov.NUMERO_DEVOLUCION_INT_ACREEDOR = Contador;
                }
                // Devolución intereses clientes
                else if(tipoMovimiento == 11){
                    identificador = "DIC"+yy+numero;
                    objMov.NUMERO_DEVOLUCION_INT_CLIENTE = Contador;
                }
                // Costas
                else if(tipoMovimiento == 12){
                    identificador = "CTL"+yy+numero;
                    objMov.NUMERO_COSTAS = Contador;
                }
                // Compensación acuerdo no judicial acreedores
                else if(tipoMovimiento == 13){
                    identificador = "CANJ"+yy+numero;
                    objMov.NUMERO_COMPENSACION_ACUERDO_ACREEDORES = Contador;
                }
                // CE compensación acuerdo acreedores
                else if(tipoMovimiento == 14){
                    identificador = "CECA"+yy+numero;
                    objMov.NUMERO_COMISION_EXITO_COMPENSACION_ACUERDO_ACREEDORES = Contador;
                }
                
                // Guardamos el número de identificador y el número (campos únicos)
                objMov.IDENTIFICADOR = identificador;
                await objMov.save();
                guardado=1;
                
                if(devolverIdentificador) {
                    return identificador;
                }
                
            }catch(e){
                // si existe un nº de identificador duplicado, da error y seguimos iterando
                objMov.IDENTIFICADOR="";
                identificador="";
                guardado=0;
            }
        }while(guardado === 0);
    }
}

async function generarActualizacionConfirmarMovimiento(cliente,iddeuda){
    // Cuando confirmamos un pago a la financiera desde MovimientosList, generamos la actualización correspondiente en la deuda
    // Actualizaciones que se generan para visualizarse en la zona de usuario de manera automática
    let fecha = ObtenerFechaHoraActual();
    let cntAct = appData.getCollection("ClienteActualizaciones");
    let objAct = await cntAct.createObject();

    objAct.IDDEUDA = iddeuda;
    objAct.IDLEAD = cliente.ID;
    objAct.IDUSUARIO = user.ID;
    objAct.FECHA = fecha;
    objAct.IDCONCEPTO = 12;
    objAct.OBSERVACIONES_ZONA_USUARIO = "Pagos realizados a la financiera";
    
    await objAct.save();
    
    // enviamos mensaje al cliente al generar la actualización
    // EnviarMensajeAivo(self,"actualizacion_deuda_v1",cliente.MOVIL);
}

async function comprobarUltimaComision(objself){
    // comprobamos el identificador de la última comisión de éxito generado
    // let collMov = appData.getCollection("MovimientoContadorComisionExito");
    // await collMov.loadAll();
    let collMov = appData.getCollection("MovimientosScript");
    await filtrarCollMacroObject(collMov,"m.IDTIPO_MOVIMIENTO=3 AND m.NUMERO_COMISION_EXITO IS NOT NULL AND m.NUMERO_COMISION_EXITO != ''  ORDER BY m.NUMERO_COMISION_EXITO DESC");
    
    if(collMov.count() > 0){
        let item = collMov.getItem(0);
        objself.MAP_ULT_CE = item.IDENTIFICADOR;
    }
}

async function comprobarProximaComision(objself){
    var fecha = new Date();
	var yy = safeToString(fecha.getFullYear()).substring(2,4);
	let numero = "";
    
    // comprobamos el identificador de la última comisión de éxito generado
    let collMov = appData.getCollection("MovimientoContadorComisionExito");
    await collMov.loadAll();
    
    if(collMov.count() > 0){
        let item = collMov.getItem(0);
        // siguiente nº comisión
        let Contador = item.NUMERO_COMISION_EXITO + 1;
        
        if(safeToInt(Contador)>0 && safeToInt(Contador)<=9){
        // identificador entre el 1 y el 9
        numero = '0000'+Contador;
    }else if(safeToInt(Contador)>=10 && safeToInt(Contador)<=99){
        // identificador entre el 10 y el 99
        numero = '000'+Contador;
    }else if(safeToInt(Contador)>=100 && safeToInt(Contador)<=999){
        // identificador entre el 100 y el 999
        numero = '00'+Contador;
    }else if(safeToInt(Contador)>=1000 && safeToInt(Contador)<=9999){
        // identificador entre el 1000 y el 9999
        numero = '0'+Contador;
    }else{
        // identificador por encima del 10000
        numero = Contador;
    }
        
        objself.MAP_PROX_CE = "CE"+yy+numero;
    }
}

async function calcularTotalComision(objself){
    // Sumamos el importe de las comisiones en pantalla
    let cntMov = await objself.getContents("MovimientosComision");
    let total = 0;
    for(var i = 0; i < cntMov.count(); i++) {
        let objComision = cntMov.getItem(i);
        
        if(objComision) {
            total += safeToFloat(objComision.IMPORTE);
        }
    }
    
    objself.MAP_TOTAL_COMISIONES = total.toFixed(2) + " €";
}


async function solicitarCobroLiquidada(objself,iddeuda){
    // ClienteEdicion. Para generar el movimiento de CE de la deuda una vez liquidada
    let fecha=ObtenerFechaHoraActual();
    let collDeuda = appData.getCollection("DeudaClienteScript");
    await filtrarCollMacroObject(collDeuda,"d.ID="+iddeuda+" AND ifnull(d.BAJA,0)=0");
    
    if(collDeuda.count()>0){
        let objDeuda = collDeuda.getItem(0);
        
        // Comprobamos si ya ha generado el cobro y está pendiente
        var collMov = appData.getCollection("MovimientosScript");
        await filtrarCollMacroObject(collMov,"m.IDDEUDA="+objself.MAP_IDDEUDA+" and m.IDLEAD="+objself.ID+" and m.IDTIPO_MOVIMIENTO=3 AND m.IDESTADO IN(5,6,7) AND ifnull(m.CE_DEUDA_LIQUIDADA,0)=1");

        if(collMov.count()>0){
            ui.showToast("Ya existe un cobro pendiente asociado a la deuda liquidada. Revise el apartado de movimientos");
            return;
        }
        
        let pregunta= await ui.msgBox("¿Está seguro que desea solicitar el cobro?","Cobro comisión deuda liquidada",1);
        if(pregunta==1){
            // generamos el movimiento para la comisión de éxito
            let collMov = appData.getCollection("Movimientos");
            let objMov = await collMov.createObject();
            objMov.IDDEUDA=iddeuda;
            objMov.IDLEAD=objself.ID;
            objMov.IDTIPO_MOVIMIENTO=3;
            objMov.FECHA_SOLICITUD= fecha;

            objMov.IDESTADO=5;
            
            objMov.BASE_IMPONIBLE = round(objDeuda.COMISION_EXITO_LIQUIDADA/1.21,2);
            objMov.IVA = round(objDeuda.COMISION_EXITO_LIQUIDADA - (objDeuda.COMISION_EXITO_LIQUIDADA/1.21),2);
            objMov.IMPORTE=objDeuda.COMISION_EXITO_LIQUIDADA;
            
            // Marcamos este campo para diferenciar del resto de CE de la deuda y poder filtrarla como una CE aparte
            objMov.CE_DEUDA_LIQUIDADA=1;

            await objMov.save();
            
            // Generamos y guardamos el identificador del movimiento (comisión de éxito)
            // await generarIdentificadorMovimiento(3,objMov.ID);
            
            await Promise.all([
                actualizarDatosContent(objself,"DeudaClientePrograma"),
                actualizarDatosContent(objself,"MovimientosCliente"),
            ]);
            
            // bloqueamos el cálculo de CE
            self.MAP_MOV_CE_CREADO=1;
            self.MAP_IMG_PROGRESO11="deudaAmarillo.png";
            ui.showToast("Movimiento de cobro de comisión creado. Por favor, revise el apartado de movimientos");
        }else{
            return;
        }
    }
}

async function generarFactura(objself) {
    
    let collMov = appData.getCollection("MovimientosScript");
    let collCliente = appData.getCollection("ClienteScript");
    
    let fecha = ObtenerFechaHoraActual();
    // let anyoFecha = new Date();
    // var yy = safeToString(anyoFecha.getFullYear()).substring(2,4);
    
    // validaciones
    if(objself.MAP_ID_TIPO_FACTURA == ""){
        ui.showToast("Seleccione el tipo de factura");
        return;
    }
    if(objself.MAP_ID_CALIFICACION_OPERACION_FACTURA == ""){
        ui.showToast("Seleccione la calificación de operación");
        return;
    }
    if(objself.MAP_ID_OPERACION_EXENTA_FACTURA == "" && objself.MAP_ID_CLAVE_REGIMEN_FACTURA == ""){
        ui.showToast("Seleccione la operación exenta o clave régimen");
        return;
    }
    if(objself.MAP_ID_IMPUESTO_FACTURA == ""){
        ui.showToast("Seleccione el impuesto");
        return;
    }
    
    
    // recorremos los movimientos seleccionados para generar la factura
    // Los recorremos del más antiguo al más reciente
    let cntFac = await objself.getContents("MovimientosFacturacion");
    
    for(var i = cntFac.count() - 1; i >= 0; i--) {
        
        // Obtenemos el movimiento que vamos a facturar
        let objMov = cntFac.getItem(i);
        
        if(objMov && safeToInt(objMov.FACTURADO) == 0 && objMov.MAP_SELECCIONAR == 1) {
            
            // en caso de rectificativa, comprobamos que el movimiento original esté facturado
            if(objMov.IDTIPO_MOVIMIENTO === 9) {
                await filtrarCollMacroObject(collMov,"m.IDENTIFICADOR='" + objMov.IDFACTURA_RECTIFICADA + "'");
                
                if(collMov.count() === 0) {
                    ui.showToast("No se encuentra el movimiento original asociado a la rectificativa " + objMov.IDENTIFICADOR);
                    return;
                } else {
                    let objFacturado = collMov.getItem(0);
                    if(safeToInt(objFacturado.FACTURADO) == 0) {
                        ui.showToast("Debe facturar primero la comisión original asociada a " + objMov.IDENTIFICADOR);
                        return;
                    }
                }
            }
            
                
            // obtenemos el cliente asociado al movimiento
            await filtrarCollMacroObject(collCliente,"c.ID = " + objMov.IDLEAD);
            
            if(collCliente.count() === 0) {
                ui.showToast("Cliente no encontrado para la factura");
                return;
            }
            let objCliente = collCliente.getItem(0);
            
            
            
            // generamos el registro de la factura
            let collFactura = appData.getCollection("FacturasScript");
            let objFactura = await collFactura.createObject();
            
            
            // obtenemos idSerie y la serie según el identificador del movimiento. Pasamos el objeto
            let objSerie = await obtenerSerieFactura(objMov);
            let idSerie = objSerie.ID;
            let serie = objSerie.SERIE;
            if (idSerie === 0) return;
            
            // obtenemos el total de registros de la serie correspondiente (CI, CM o CE)
            // await filtrarCollMacroObject(collFactura, "IDSERIE = " + idSerie);
            // let cantidadRegistrosSerie = collFactura.count();
            
            // obtememos la numeración de la serie en concreto
            // let numeroSerie = obtenerNumeroSerie(cantidadRegistrosSerie);
        
            
            objFactura.IDEMPRESA = 1;
            objFactura.IDSERIE = idSerie;
            objFactura.NUMERO = objMov.IDENTIFICADOR.slice(2);
            objFactura.IDCLIENTE = objMov.IDLEAD;
            objFactura.FECHA = fecha;
            objFactura.NOMCLIENTE = objCliente.NOMBRE + " " + objCliente.APELLIDOS;
            objFactura.DIRCLIENTE = objCliente.CALLE + " " + objCliente.NUMCALLE + ", " + objCliente.NUMPISO;
            objFactura.CPCLIENTE = objCliente.CP;
            objFactura.POBLACION = objCliente.LOCALIDAD;
            objFactura.PROVINCIA = objCliente.PROVINCIA;
            objFactura.PAIS = objCliente.NACIONALIDAD;
            objFactura.TELEFONO = objCliente.MOVIL;
            objFactura.DNI = objCliente.DNI;
            // objFactura.NUMCOMPLETO = serie + "-" + numeroSerie + "/" + yy;
            objFactura.NUMCOMPLETO = objMov.IDENTIFICADOR;
            objFactura.BASE = objMov.BASE_IMPONIBLE;
            objFactura.IVA = objMov.IVA;
            objFactura.TOTAL = objMov.IMPORTE;
            objFactura.VERIFACTU = 1;
            objFactura.VERIFACTU_IMPUESTO = objself.MAP_ID_IMPUESTO_FACTURA;
            objFactura.VERIFACTU_CLAVEREGIMEN = objself.MAP_ID_CLAVE_REGIMEN_FACTURA;
            objFactura.VERIFACTU_CALIFICACION = objself.MAP_ID_CALIFICACION_OPERACION_FACTURA;
            objFactura.VERIFACTU_OPERACIONEXENTA = objself.MAP_ID_OPERACION_EXENTA_FACTURA;
            objFactura.VERIFACTU_TIPOFACTURA = objself.MAP_ID_TIPO_FACTURA;
            
            // si es una rectificativa, guardamos el id de la factura del movimiento original
            if(objMov.IDTIPO_MOVIMIENTO === 9) {
                objFactura.IDDOCORIGEN = objFacturado.ID;
            }
            
            await objFactura.save();
            
            // generamos el detalle de la factura
            await generarDetalleFactura(objself, objFactura, objSerie);
            
            // marcamos el movimiento
            objMov.FACTURADO = 1;
            objMov.IDFACTURA = objFactura.ID;
            objMov.MAP_SELECCIONAR = 0;
            await objMov.save();
            
            // refrescamos la línea seleccionada
            objMov.MAP_INVISIBLE_FACTURAR = 1;
            ui.refreshContentRow('MovimientosComision', i);
        }
        
    }
    
    await objself.executeNode('facturarMovimiento');
    // await actualizarDatosPaginadoLeads(objself,"MovimientosComision","MovimientosComisionContador","MAP_PAG_INI_FAC","MAP_PAG_LEN_FAC","MAP_TOTAL_REGISTROS_FAC","MAP_T4");
    
    ui.showToast("Factura/s generada/s");
}

async function obtenerSerieFactura(objMovimiento) {
    
    // función para obtener la serie CI, CM, CE o CR
    let collSerie = appData.getCollection("FacturaSerieScript");
    
    await filtrarCollMacroObject(collSerie, "'" + objMovimiento.IDENTIFICADOR + "' LIKE CONCAT(SERIE, '%')");
    
    if(collSerie.count() > 0) {
        let objSerie = collSerie.getItem(0);
        return objSerie;
    } else {
        return 0;
    }
}

function obtenerNumeroSerie(cantidadRegistros) {
    
    let contador, numero;
    
    // asignamos el contador actual y añadimos 1 para el nuevo
    contador = cantidadRegistros === 0 ? 1 : cantidadRegistros + 1;
    
    if(safeToInt(contador) > 0 && safeToInt(contador) <= 9){
        // identificador entre el 1 y el 9
        numero = '00000'+contador;
    }else if(safeToInt(contador) >= 10 && safeToInt(contador) <= 99){
        // identificador entre el 10 y el 99
        numero = '0000'+contador;
    }else if(safeToInt(contador) >= 100 && safeToInt(contador) <= 999){
        // identificador entre el 100 y el 999
        numero = '000'+contador;
    }else if(safeToInt(contador) >= 1000 && safeToInt(contador) <= 9999){
        // identificador entre el 1000 y el 9999
        numero = '00'+contador;
    }else if(safeToInt(contador) >= 10000 && safeToInt(contador) <= 99999){
        // identificador entre el 10000 y el 99999
        numero = '0'+contador;
    }else{
        // identificador por encima del 100000
        numero = contador;
    }
    
    return numero;
}

async function generarDetalleFactura(objself, objFactura, objSerie) {
    
    // Creamos el detalle de la factura
    let collDetFactura = appData.getCollection("FacturasDetalleScript");
    let objDetFactura = await collDetFactura.createObject();
    
    objDetFactura.IDDOCUMENTO = objFactura.ID;
    objDetFactura.IDEMPRESA = objFactura.IDEMPRESA;
    objDetFactura.DESCRIPCION = objSerie.DESCRIPCION;
    objDetFactura.IMPORTE = objFactura.TOTAL;
    objDetFactura.PORIVA = objFactura.IVA;
    objDetFactura.BASE = objFactura.BASE;
    objDetFactura.TOTAL = objFactura.TOTAL;
    
    await objDetFactura.save();
}

var dominioUrl; //para saber si estamos en dev o prod
var actionTarget=["LoginHEX","ExcelDatosSQL","CreateUser"];
var actionTargetCalculator=["quota"];
var actionTargetPDF=["GenerateFile","accept_addendum","signature_request_docs"];
var actionTargetStripe=["subscription","payment_by_trasnfer","payment"];
var actionTargetWhastsapp=["message","download"];
var actionTargetCore=["zadarma"];

// todo hacer que este valor lo saque de base de datos
// variable para indicar si estamos en desarrollo (1) o no
var DESARROLLO=1;

// variables globales asociadas al agente chatbot
var apiKey, dominioUrlAgente, flowID, hostUrl, bgImage, dominioUrlResumen, flowIDResumen = "";

// para establecer la conexión de HubConnection de signalR
var connection;


async function comprobarEntorno(){
    var obj;
    
    obj = await appData.getCollection("Empresas").findObject("CODIGO=99"); //99 es en desarrollo
	if (!isNothing(obj)) {
	    //ESTO SI ENTRA AQUI ES QUE TIENE LA CLAVE EN LA BASE DE dominioUrl
	    //SI PONEMOS EN LA LINEA DE ARRIBA CODIGO=99, LO ENCUENTRA Y ASI PROBAMOS EN NUESTRO ENTORNO Y YA DECIDO CON DESARROLLO=1 Ó 0.
		
        // DESARROLLO = 1;
        appData.getCurrentEnterprise().setVariables("DESARROLLO",1);
        // si estamos en desarrollo CODIGO=99 y usamos credenciales de dev DESARROLLO=1
        if (DESARROLLO == 1) {
            // para el widget del chatbot
            apiKey = "sk-nap-vzz5R6X8EhlMvp9b2gA0LKuxtsEucmz/TYnPrS156zY="; 
            flowID = "47b2bfbd-84c9-4f67-8f9f-08d4ad57307c";
            hostUrl = "https://dev01.ai.nappai.es"; 
            bgImage = "https://dev.aliviafinance.com/icons/logo_Alivia.png"; 
            dominioUrlAgente = "https://dev01.app.nappai.es"; 
            
            // para el resumen socioeconómico
            dominioUrlResumen = "https://dev01.ai.nappai.es/api/v1/run/"; 
            flowIDResumen = "091c0e86-5bcb-48a2-a740-df54371f811f";
            
        } else if (DESARROLLO === 0) {
            // para el widget del chatbot
            apiKey = "sk-nap-r6R/DDhdSoEwPDyjLqHJc7Ms3xztG3BrNXHPU5TBmug="; 
            flowID = "166b7823-b798-4c40-9409-b6d33a392709"; 
            hostUrl = "https://api.xonefactory.ai"; 
            bgImage = "https://crm.aliviafinance.com/icons/logo_Alivia.png"; 
            dominioUrlAgente = "https://xonefactory.ai"; 
            
            // para el resumen socioeconómico
            dominioUrlResumen = "https://api.xonefactory.ai/api/v1/run/"; 
            flowIDResumen = "a5b6a68c-8aff-447d-8207-72c3b310b367";
        }     
	} else {
	    DESARROLLO = 0;
	    appData.getCurrentEnterprise().setVariables("DESARROLLO",0);
	    
	    // para el widget del chatbot
        apiKey = "sk-nap-r6R/DDhdSoEwPDyjLqHJc7Ms3xztG3BrNXHPU5TBmug="; 
        flowID = "166b7823-b798-4c40-9409-b6d33a392709"; 
        hostUrl = "https://api.xonefactory.ai"; 
        bgImage = "https://crm.aliviafinance.com/icons/logo_Alivia.png"; 
        dominioUrlAgente = "https://xonefactory.ai"; 
        
        // para el resumen socioeconómico
        dominioUrlResumen = "https://api.xonefactory.ai/api/v1/run/"; 
        flowIDResumen = "a5b6a68c-8aff-447d-8207-72c3b310b367";
	}   
	
	// Chatbot nappai (canal web): expone la config de ENTORNO como macros globales
    // que el runtime resuelve en los `web-widget-attr-*` del <prop MAP_CHAT> de
    // frmChatBot (EntradaApp). Sustituye a los setAttribute del antiguo
    // DevolverIframeAgente/loadTargetDiv (DOM directo, vetado en el sandbox web).
    // La api-key NO se hornea en el bundle: se resuelve aquí en runtime (viene de
    // la config de entorno, idealmente de una macro de sesión/edge en el futuro).
    appData.setGlobalMacro("##CHAT_BUNDLE_URL##", dominioUrlAgente + "/js/bundle.min.js");
    appData.setGlobalMacro("##CHAT_HOST_URL##", hostUrl);
    appData.setGlobalMacro("##CHAT_API_KEY##", apiKey);
    appData.setGlobalMacro("##CHAT_FLOW_ID##", flowID);
    appData.setGlobalMacro("##CHAT_BG_IMAGE##", bgImage);
}


// ************** Comentar desde aquí


async function filtrarCollMacroObject(coll,filter){
 // pasamos ya el objeto por parámetro
 coll.unlock();
 coll.setMacro("##MACRO##", filter);
 coll.clear();
 await coll.loadAll();
 coll.lock();
}

async function filtrarContentMacroObject(content,filter){
 // pasamos ya el objeto por parámetro
 content.unlock();
 content.setMacro("##MACRO##", filter);
 content.clear();
 await content.loadAll();
 content.lock();
}

async function filtrarContentFilterObject(objself, contentsName,filtroContent) {
    let cnt = await objself.getContents(contentsName);
    
    cnt.unlock();
    cnt.setFilter(filtroContent);
    cnt.clear();
    await cnt.loadAll();
    cnt.lock();
    ui.refresh(contentsName);
}

async function obtenerPrimerObjetoColl(coll,filtro) {
    let collBuscar = appData.getCollection(coll);
    await filtrarCollMacroObject(collBuscar,filtro);
    if(collBuscar.count() > 0) {
        return collBuscar.getItem(0);
    }
    return null;
}

async function actualizarDatosContent(objself, contentsName, refrescarPadre, segundaMacro) {
    objself.MAP_BANDERA = 1;
    var filter = '', filter2 = '';
    var usersContent = await objself.getContents(contentsName);
    usersContent.unlock();
    filter = getFilter(objself, contentsName);
    usersContent.setMacro("##MACRO##", filter);

    // para deudas del procesoLSO, una segunda macro
    if (contentsName === 'ProcesoLSODeudaCliente') {
        usersContent.setMacro("##IDCLIENTE_TITULAR##", objself.MAP_IDLEAD_TITULAR);
        usersContent.setMacro("##IDCLIENTE_PAREJA##", objself.MAP_IDLEAD_PAREJA);
    }
    if (segundaMacro) {
        filter2 = getFilter2(objself, contentsName);
        usersContent.setMacro("##MACRO2##", filter2);
    }
    usersContent.clear();
    let promise = await usersContent.loadAll();
    usersContent.lock();
    if (refrescarPadre) {
        ui.getView(objself).refresh(contentsName);
    } else {
        ui.refresh(contentsName);
    }
    objself.MAP_BANDERA = 0;
    return promise;
}

async function actualizarDatosPaginadoLeads(objself,contentsName,collContador,pag_ini,pag_len,totalRegistros,Proptitulo, refrescarPadre) {
    objself.MAP_BANDERA=1;
    var filter = '', filter2 = '';
    var filterContador = '';
    var page= {
        "start": objself[pag_ini],
        "length": objself[pag_len]
    };

    let usersContent = await objself.getContents(contentsName);
    usersContent.unlock();
    filter = getFilter(objself,contentsName);
	usersContent.setMacro("##MACRO##", filter);
	
	// para casos con dos macros en la sql como DeudaCliente
    // if(segundaMacro == 1){
    //     filter2 = getFilter2(objself,contentsName);
    // 	usersContent.setMacro("##MACRO2##", filter2);
    // }

    usersContent.clear();
    await usersContent.loadAll(page);
    usersContent.lock();
    

    var ctr=appData.getCollection(collContador);
    filterContador = getFilter(objself,collContador);
    ctr.setMacro("##MACRO##", filterContador);
    await ctr.loadAll();
    objself[totalRegistros]=ctr.getItem(0).MAP_CONTADOR;
    
    let valorde=0; 
    let valorhasta=objself[pag_len];
    if (valorhasta>objself[totalRegistros]) valorhasta=objself[totalRegistros];
    objself.setFieldPropertyValue(Proptitulo,"title","Mostrando registros: De " + valorde + " a " + valorhasta + "/" + objself[totalRegistros]);
    
    if(refrescarPadre) {
        // si necesitamos refrescar el content en otra pantalla, obtenemos la vista. Ejemplo: Al volver de leadEdicion a LeadList
        ui.getView(objself).refresh(contentsName);
    } else {
        ui.refresh(contentsName);
    }
    
    // Limpiamos HTML de los mensajes del bot en el listado de chats tras la carga inicial
    if (contentsName === "MensajeriaChatListado") {
        var cntLimpiar = await objself.getContents("MensajeriaChatListado");
        if (cntLimpiar) {
            for (var i = 0; i < cntLimpiar.count(); i++) {
                var objLimpiar = cntLimpiar.getItem(i);
                if (objLimpiar.MAP_ULT_MENSAJE && objLimpiar.MAP_ULT_MENSAJE.indexOf('<') !== -1) {
                    objLimpiar.MAP_ULT_MENSAJE = limpiarHTML(objLimpiar.MAP_ULT_MENSAJE);
                    ui.refreshContentRow("MensajeriaChatListado", i);
                }
            }
        }
    }
    objself.MAP_BANDERA = 0;
    
}

async function paginado(objself,tipo,contentsName,pag_ini,pag_len,totalRegistros,Proptitulo) {

    var valorde,valorhasta;
    valorde=0;
    if (tipo=='ANT') {
        if (objself[pag_ini]===0) {
            ui.showToast("No hay mas registros");
        } else {
            objself[pag_ini]=objself[pag_ini] - objself[pag_len];
            if (objself[pag_ini]<0) {
                objself[pag_ini]=0;  
            } 
            await loaddata(objself,contentsName,1,objself[pag_ini],objself[pag_len]);
        }
    } else {
        // Si el total de registros obtenidos es menos que el numero maximo,
        //ya no hay mas registros. ver siempre el total registros que da la 
        //consulta
        if (await objself.getContents(contentsName).getCount() < objself[pag_len]) {
            ui.showToast("No hay más registros");
        } else {
            objself[pag_ini]=objself[pag_ini] + objself[pag_len];
            if (objself[pag_ini]>objself[totalRegistros]) {
                objself[pag_ini]=objself[totalRegistros];  
            }
            await loaddata(objself,contentsName,1,objself[pag_ini],objself[pag_len]);
        }
    }

    valorhasta=objself[pag_ini] + objself[pag_len];
    if (valorhasta>objself[totalRegistros]) {
        valorde=valorhasta - objself[pag_len];
        valorhasta=objself[totalRegistros];  
    } else {
        valorde=valorhasta - objself[pag_len];    
    } 
    if (valorde<0) {
        valorde=0;  
    } 
    objself.setFieldPropertyValue(Proptitulo,"title","Mostrando registros: De " + valorde + " a " + valorhasta + "/" + objself[totalRegistros]);
}

//Cargar un content bloqueado
async function loaddata(obj,content,load,ini,fin){

    // if (load===0) {
    // } else {
    //     ui.showToast("Cargando información...");
    // }
    try {
        let ct=await obj.getContents(content);
        ct.unlock();
        ct.clear();
        var page;
        if (!isNothing(ini)) {
            page= {
                "start": ini,
                "length": fin
            };
            await ct.loadAll(page);
        } else {
            await ct.loadAll();
        }
        ct.lock();

        ui.getView(obj).refresh(content);

    } catch(e) {
        ui.showToast("Error de conexión...");
    }
}



// ===== Subida de ficheros al WebCore (api/itf/upload) =====
// Antes las subidas iban al API externo `dev.aliviafinance.com/api/Pdf/UploadFile*`
// (guardaba el fichero + creaba la fila gen_documento + devolvía {data:[{ID}]}).
// Ahora van al backend WebCore del propio SPA (`/api/itf/upload`, mismo origen):
// el endpoint guarda el fichero en el repositorio del tenant Y crea la fila
// Documento (coll=Documento) con las columnas que enviamos, devolviendo
// {data:[{ID, DOCUMENTO, ...}]} — mismo contrato, así `leerRespuesta().ID` sigue
// funcionando. La BD asigna el ID; el ROWID lo generamos aquí (keys=["ROWID"]).

function _fechaSubidaDoc() {
    function p(n){ return (n < 10 ? "0" : "") + n; }
    var d = new Date();
    return d.getFullYear() + "-" + p(d.getMonth() + 1) + "-" + p(d.getDate()) +
        " " + p(d.getHours()) + ":" + p(d.getMinutes()) + ":" + p(d.getSeconds());
}

// Traduce los `parameters` de subida (idtipo, iddeuda, correo_lead, ...) a las
// columnas de la tabla gen_documento. `rowidLead` se pasa aparte porque algunos
// llamadores solo tienen `correo_lead` (el ID_LEAD real va por ROWID_LEAD).
function _docFieldsFromParams(parameters, rowidLead) {
    var p = parameters || {};
    return {
        ROWID: crypto.getNewUuid(),
        FECHA: _fechaSubidaDoc(),
        BAJA: 0,
        DOCUMENTO_VISIBLE: 1,
        DOCUMENTO: p.name || p.fileName || "",
        IDTIPO: p.idtipo || 0,
        ROWID_LEAD: rowidLead || p.rowid_lead || "",
        ROWID_PROCESO_LSO: p.idproceso_lso || "",
        USUARIO_SUBIDA: p.usuario_subida || (typeof user !== "undefined" ? user.LOGIN : ""),
        IDDEUDA: p.iddeuda || 0,
        IDDEUDACLIENTE: p.iddeudacliente || 0,
        IDACTIVIDADCLIENTE: p.idactividadcliente || 0,
        ID_CLIENTE_DATOS_SANCIONES_HACIENDA: p.idsancioneshacienda || 0,
        ID_CLIENTE_DATOS_VENTA_DONACION_BIEN: p.idventadonacionbien || 0,
        ID_CLIENTE_DATOS_HERENCIA: p.idherencia || 0,
        ID_CLIENTE_DATOS_OTROS_ACTIVOS: p.idotrosactivos || 0,
        ID_CLIENTE_DATOS_INMUEBLES: p.idinmuebles || 0,
        ID_CLIENTE_DATOS_VEHICULOS: p.idvehiculos || 0,
        ID_CLIENTE_DATOS_FAMILIARES_CARGO: p.idfamiliares || 0,
        ID_CLIENTE_DATOS_POSEE_ALGUNA_SOCIEDAD: p.idposeesociedad || 0
    };
}

// POST multipart a /api/itf/upload: `file` + `coll=Documento` + `filefield=DOCUMENTO`
// (el server pone DOCUMENTO = nombre del fichero guardado) + el resto de columnas.
// Devuelve una Promesa que resuelve con {data:[{ID, DOCUMENTO, ...}]}.
async function subirFicheroWebcore(file, docFields) {
    await ui.sleep(0);
    return new Promise(function(resolve, reject) {
        var formData = new FormData();
        formData.append("file", file);
        formData.append("name", docFields.DOCUMENTO || file.name);
        formData.append("coll", "Documento");
        formData.append("filefield", "DOCUMENTO");
        Object.keys(docFields).forEach(function(k){
            if (k === "DOCUMENTO") return; // lo fija el server vía filefield
            var v = docFields[k];
            formData.append(k, v == null ? "" : String(v));
        });

        var xhr = new XMLHttpRequest();
        xhr.open("POST", "/api/itf/upload");
        // El WebCore en Standalone admite anónimo; mandamos el token por si el
        // entorno exige 'itfref' (como DoAction).
        if (typeof user !== "undefined" && user.MAP_TOKEN) {
            xhr.setRequestHeader("Authorization", "Bearer " + user.MAP_TOKEN);
        }
        xhr.onload = function() {
            if (xhr.status >= 200 && xhr.status < 300) {
                try {
                    var data = JSON.parse(xhr.responseText);
                    if (data.hasError) {
                        reject(new Error(data.err || data.message || "Error en la respuesta del servidor"));
                    } else {
                        resolve(data);
                    }
                } catch (e) {
                    reject(new Error("Error al parsear la respuesta"));
                }
            } else {
                reject(new Error("Error HTTP: " + xhr.status));
            }
        };
        xhr.onerror = function() { reject(new Error("Error de red")); };
        xhr.send(formData);
    });
}

// Función para subir los documentos de cliente. Usamos una promesa y ui.sleep para que la detecte como asíncrona
async function sendOnlineFilesApiNEW(objself, apiName, file, parameters) {
    // `parameters.rowid_lead` viene ya resuelto del llamador; si faltara, caemos
    // al ROWID del objeto en edición (lead/cliente comparten ROWID).
    var rowidLead = (parameters && parameters.rowid_lead) ||
        (objself && (objself.MAP_ROWID || objself.ROWID)) || "";
    var fields = _docFieldsFromParams(parameters, rowidLead);
    return await subirFicheroWebcore(file, fields);
}


// subirArchivo genérico de cliente. Recibe un objeto con los parámetros directamente
async function subirArchivo(objself, opciones = {}) {
    
    const file = objself.getOwnerCollection().getVariables("File");
    if (!file) {
        await ui.msgBox("Debe adjuntar un archivo antes de subirlo", "Falta documento", 0);
        return null;
    }

    // volcamos los parámetros que hayamos recibido
    const parameters = {
        correo_lead: opciones.correo_lead,
        // ROWID_LEAD real: lo pasa el llamador (p.ej. adjuntarArchivoDatosCliente);
        // si no, el ROWID del objeto en edición (lead/cliente comparten ROWID).
        rowid_lead: opciones.rowid_lead || (objself && (objself.MAP_ROWID || objself.ROWID)) || "",
        idproceso_lso: opciones.idproceso_lso || "",
        idtipo: opciones.tipoDoc,
        usuario_subida: user.LOGIN,
        name: opciones.fileName || file.name,
        iddeuda: opciones.iddeuda || 0,
        iddeudacliente: opciones.iddeudacliente || 0,
        idactividadcliente: opciones.idactividadcliente || 0,
        idsancioneshacienda: opciones.idsancioneshacienda || 0,
        idventadonacionbien: opciones.idventadonacionbien || 0,
        idherencia: opciones.idherencia || 0,
        idotrosactivos: opciones.idotrosactivos || 0,
        idinmuebles: opciones.idinmuebles || 0,
        idvehiculos: opciones.idvehiculos || 0,
        idfamiliares: opciones.idfamiliares || 0,
        idposeesociedad: opciones.idposeesociedad || 0,
    };

    // Callbacks por defecto si no se pasan en las Opciones
    const okcallback = opciones.onSuccess || function() {
        ui.showToast("Documento subido correctamente");
        limpiarDatosTrasSubida(objself);
        actualizarDatosContent(objself, "Documentopersonal");
    };
    const errorCallback = opciones.onError || function() {
        objself.MAP_ANEXO = "";
    };


    // sendOnlineFilesApi sólo subirá el documento. El callback se llama desde aquí
    try {
        const response = await sendOnlineFilesApiNEW(
            objself,
            "/api/Pdf/UploadFile?user=" + user.LOGIN,
            file,
            parameters
        );
        return okcallback(response);
    } catch (error) {
        errorCallback(error);
    }
}


// Función para subir los documentos. Usamos una promesa y ui.sleep para que la detecte como asíncrona
async function UploadFileLSO(objself, apiName, file, parameters) {
    // Subida de documentos de proceso LSO: la fila se enlaza por ROWID_PROCESO_LSO
    // (parameters.idproceso_lso), no por ROWID_LEAD.
    var fields = _docFieldsFromParams(parameters, "");
    return await subirFicheroWebcore(file, fields);
}


// subirArchivo genérico para LSO. Recibe un objeto con los parámetros directamente
async function subirArchivoLSO(objself, opciones = {}) {
    
    const file = objself.getOwnerCollection().getVariables("File");
    if (!file) {
        await ui.msgBox("Debe adjuntar un archivo antes de subirlo", "Falta documento", 0);
        return null;
    }

    // volcamos los parámetros que hayamos recibido
    const parameters = {
        idproceso_lso: opciones.idproceso_lso,
        idtipo: opciones.tipoDoc,
        usuario_subida: user.LOGIN,
        name: opciones.fileName || file.name,
    };

    // Callbacks por defecto si no se pasan en las Opciones
    const okcallback = opciones.onSuccess || function() {
        ui.showToast("Documento subido correctamente");
        limpiarDatosTrasSubida(objself);
        actualizarDatosContent(objself, "Documentopersonal");
    };
    const errorCallback = opciones.onError || function() {
        objself.MAP_ANEXO = "";
    };


    // UploadFileLSO sólo subirá el documento. El callback se llama desde aquí
    try {
        const response = await UploadFileLSO(
            objself,
            "/api/Pdf/UploadFileLso?user=" + user.LOGIN,
            file,
            parameters
        );
        return okcallback(response);
    } catch (error) {
        console.log("Error inesperado al subir archivo:", error);
        errorCallback(error);
    }
}

function DescargarArchivoLSO(objself,fileName,idproceso,callBackSuccess,callBackError) {
    let request = {
		parameters: {
		    connectTimeout: 120000,
		    readTimeout: 120000
		},
        headers : {
            "Authorization": "Bearer " + user.MAP_TOKEN,
            processData: false, 
            contentType: false, 
            // "x-request-rowid-lead": rowid_lead
        }
    };
    
    let fullURL = dominioUrl + "/api/Pdf/DownloadFileLso?idproceso="+idproceso+"&&file="+fileName;
    $http.getFile(fullURL, request, 
        function(response) {
            callBackSuccess(response);
        }, 
        function(errorCode, errorMsg,msgampliado) {
            ui.showToast(errorCode + ": " + errorMsg);
        }
    ); 
}



// ************** Comentar hasta aquí




async function actualizarDatosContentSinRefresco(objself, contentsName, segundaMacro) {
    objself.MAP_BANDERA = 1;
    var filter = '', filter2 = '';
    var promise = null;
    var usersContent = await objself.getContents(contentsName);
    usersContent.unlock();
    try {
        filter = getFilter(objself, contentsName);
        usersContent.setMacro("##MACRO##", filter);

        // Para casos con dos macros en la sql como la documentacion previa de LSO
        if (segundaMacro) {
            filter2 = getFilter2(objself, contentsName);
            usersContent.setMacro("##MACRO2##", filter2);
        }
        usersContent.clear();
        promise = await usersContent.loadAll();
    } finally {
        usersContent.lock();
        objself.MAP_BANDERA = 0;
    }
    return promise;
}


function comprobarConexionWhatsapp() {
    var conn = window._signalRConnection;
    if (conn && conn.state === signalR.HubConnectionState.Connected) {
        return conn.stop()
            .then(function() { 
                window._signalRConnection = null;
            })
            .catch(function(err) {
                window._signalRConnection = null;
            });
    }
    window._signalRConnection = null;
    return Promise.resolve();
}

async function iniciarConexionChat(objself) {
    let dominioUrl = await getApiUrl();
    comprobarConexionWhatsapp().then(function() {
        var conn = new signalR.HubConnectionBuilder()
            .withUrl(dominioUrl + "/api/ChatHub", {
                accessTokenFactory: function() {
                    return user.MAP_TOKEN;
                },
                transport: signalR.HttpTransportType.LongPolling
            })
            .withAutomaticReconnect([0, 2000, 5000, 10000, 30000])
            .build();
        conn.off("ReceiveWebhook");
        conn.on("ReceiveWebhook", function(message) {
            whatsappWebhook(objself, message);
        });
        conn.start()
            .then(function() {
                window._signalRConnection = conn;
            })
            .catch(function(err) {
            });
    });
}

async function getApiUrl() {
	var obj;
	var valor="";
    if (isNothing(dominioUrl)) {
        obj=await appData.getCollection("Empresas").findObject("CODIGO=99");
    	if (!isNothing(obj)) {
    	    //ESTO SI ENTRA AQUI ES QUE TIENE LA CLAVE EN LA BASE DE dominioUrl
    	    //SI PONEMOS EN LA LINEA DE ARRIBA CODIGO=99, LO ENCUENTRA Y ASI PROBAMOS EN NUESTRO ENTORNO Y YA DECIDO CON DESARROLLO=1 Ó 0.
    		
            if (DESARROLLO==1) {
                valor="https://dev.aliviafinance.com"; 
            } else if (DESARROLLO == 0) {
                valor="https://crm.aliviafinance.com"; 
            }     
    	} else {
            valor="https://crm.aliviafinance.com"; 
    	}  
    	dominioUrl=valor;
    } else {
        dominioUrl=dominioUrl;
    }
	return dominioUrl.toString();
}

function formatUrl(action,param) {
    
	var url="/api";
	
	if (actionTarget.indexOf(action)>=0)
	    url="/api/Go";
	else if (actionTargetPDF.indexOf(action)>=0)
	    url="/api/PDF";
	else if (actionTargetCalculator.indexOf(action)>=0)
    	url="/api/Calculator";
	else if (actionTargetStripe.indexOf(action)>=0)
	    url="/api/Stripe";
	else if (actionTargetWhastsapp.indexOf(action)>=0)
	    url="/api/Chat";
	else if (actionTargetCore.indexOf(action)>=0)
	    url="/api/Core";

// 	if (action.includes("core"))
// 	url="/api";
	  
	var ret= url+(isEmptyString(action)?"":"/"+action);
	ret= ret+(isEmptyString(param)?"":"/"+param);
	return ret;
}


function callApiPost(objself,action,param,data,token,callbackExtSuccess,callbackExtError, runOnBackground) {

	let request = {
    	headers : {
    	    "Content-Type" : "application/json",
    	    "Authorization" : "Bearer " + token
    	},
    	parameters: {
    		allowUnsafeCertificates: true,
    		connectTimeout: 90000,
    		readTimeout: 90000
	    },
		data : data
	};
	try {
		if(!runOnBackground)
		    ui.showWaitDialog("...");
		var otpRuta = formatUrl(action,param);
		ui.hideWaitDialog();
		$http.post(otpRuta, request,
		    function (jsResult) {
			    if(!runOnBackground) {
			        ui.hideWaitDialog();
			    }
			    if (isString(jsResult)) {
			        jsResult=JSON.parse(jsResult);
			    }
			    else if (jsResult.hasError || jsResult.errors) {
			        callbackExtError(objself,jsResult.errorCode,jsResult.message);
			    }
		        else if (jsResult.Data){
			        callbackExtSuccess(objself,jsResult);
			    } else {
			        callbackExtSuccess(objself,jsResult.data);
			    }
			},function(sError,stext) {
			    if(!runOnBackground)
			        ui.hideWaitDialog();
			    callbackExtError(objself,sError,stext);
			});
	} catch(e) {
	    if(!runOnBackground)
	        ui.hideWaitDialog();
	    appData.writeConsoleString(e);
	}
}

function callApiGet(objself,action,param,data,token,callbackExtSuccess,callbackExtError, runOnBackground) {
	let request = {
    	headers : {
    	    "Content-Type" : "application/json",
    	    "Authorization" : "Bearer " + token
    	},
    	parameters: {
    		allowUnsafeCertificates: true,
    		connectTimeout: 90000,
    		readTimeout: 90000
	    },
		data : data
	};
	try {
		if(!runOnBackground)
		    ui.showWaitDialog("...");
		var otpRuta = formatUrl(action,param);
		$http.get(otpRuta, request,
		    function (jsResult) {
			    if(!runOnBackground) {
			        ui.hideWaitDialog();
			    }
			    if (isString(jsResult)) {
			        jsResult=JSON.parse(jsResult);
			    }
			 //   if (Array.isArray(jsResult)) {
			 //       jsResult=jsResult;
			 //   }
			    if (jsResult.hasError) {
			        callbackExtError(jsResult.message,jsResult.message);
			    } else if (jsResult.statusCode == 500) {
			        callbackExtError(jsResult.message,jsResult.message);
			    } else {
			        callbackExtSuccess(objself,jsResult.data,jsResult);
			    }
			},function(sError,stext) {
			    if(!runOnBackground)
			        ui.hideWaitDialog();
			    callbackExtError(sError,stext);
			});
	} catch(e) {
	    if(!runOnBackground)
	        ui.hideWaitDialog();
	    appData.writeConsoleString(e);
	}
}



async function descargarExcelOLD(objself){
    callApiPost(objself,"ExcelDatosSQL","",
    {
        name: "ExcelPrueba.xlsx",
        entidad: "ExcelDatos",
        where:[]
    }
    ,user.MAP_TOKEN,
    function(objself,data){
        var link = document.createElement("a");
        link.download = "aa";
        link.href = data;
        link.click();
        ui.msgBox("Llamada correcta ","",0);
    },
    function(objself,data){
        ui.msgBox("Error en la llamada ","",0);
    });
}

function descargarExcel(objself){

    let where =[];
    let request = {
		parameters: {
		    connectTimeout: 120000,
		    readTimeout: 120000
		},
        headers : {
            "Authorization": "Bearer " + user.MAP_TOKEN,
            "Content-Type" : "application/json"
        },
        body : {
            "name": JSON.stringify("ExcelPrueba.xlsx"),
            "entidad": JSON.stringify("ExcelDatos"),
            "where": JSON.stringify(where)
        }
    };
    
    let fullURL = dominioUrl + "/api/Go/ExcelDatosSQL";
    try{
        $http.getFile(fullURL, request, 
            function(response) {
                ui.openUrl(response);
                var link = TableExport(document.createElement("a"));
                // var link = document.createElement("a");
                link.doctype;
                link.download = "qwerty";
                link.href = response;
                link.click();
            }, 
            function(errorCode, errorMsg,msgampliado) {
                ui.showToast(errorCode + ": " + errorMsg);
            }
        );
    }catch(e){
        ui.showToast(e);
        ui.showToast("Ha ocurrido un error. Por favor, compruebe su conexión a internet e inténtelo nuevamente.");
    }
}


// FUNCIONES DE LOGIN
async function login(objself,login,password){
    try{
        var pwdHash = await crypto.md5(password);
        callApiPost(objself,"LoginHEX","",{
            LOGIN: login,
            PWD: pwdHash
        },"",OnLoginOKApp,OnLoginFailApp);
    } catch(e){
        ui.showToast(e);
        ui.showToast("Ha ocurrido un error. Por favor, compruebe su conexión a internet e inténtelo nuevamente.");
    }
}
async function OnLoginOKApp(objself, data){
    try {
        if(data !== null) {
            user.NOMBRE = data.USER.NOMBRE;
            user.MAP_TOKEN = data.USER.TOKEN;
            user.CORREO = data.USER.CORREO;
            user.USERTYPE = data.USER.USERTYPE;
            
            // // si el tipo de usuario es Procurador (tipo=12), lo mandamos a su pantalla de inicio
            if(user.USERTYPE == 12) {
                await goToColl("DeudaClienteAccionesJudicialesList");
            }
        }
    } catch (ex){
        ui.showToast("Ha ocurrido un error. Por favor, compruebe su conexión a internet e inténtelo nuevamente.");
    }
}
function OnLoginFailApp(objself, data){
    try{
        if(data !== null) {
            user.MAP_TOKEN="";
            ui.showToast("No se ha podido iniciar sesión. ");
            // ui.showToast("No se ha podido iniciar sesión. "+ data);
        }
    } catch (e) {
        ui.showToast("Ha ocurrido un error. Por favor, compruebe su conexión a internet e inténtelo nuevamente.");
    }
}



// FUNCIÓN DE CUOTAS
function CalculadoraObtenerCuotas(objself,cantidad){
    try{
        callApiGet(objself,"quota",cantidad,"",user.MAP_TOKEN,ObtenerCuotaOK,ObtenerCuotaFail);
    } catch(e){
        ui.showToast(e);
        ui.showToast("Ha ocurrido un error obteniendo las cuotas. Por favor, compruebe su conexión a internet e inténtelo nuevamente.");
    }
}

function comparar(a, b) {
  return a - b;
}
async function ObtenerCuotaOK(objself, data, jsResult){
    let arrayCuota = jsResult;
    arrayCuota.sort(comparar);
    let cnt = await objself.getContents("CalculadoraCuota");
    cnt.unlock();
    cnt.clear();
    await cnt.loadAll();
    
    // comprobamos el valor de cuota mínima para poder calcular
    let coll = appData.getCollection("ParametrosCalculadora");
    await coll.loadAll();
    let objParam = coll.getItem(0);
    if(objParam){
        for(var i=0;i<arrayCuota.length;i++){
            if(arrayCuota[i]>=objParam.CUOTA_MINIMA){
                let obj = await cnt.createObject();
                obj.MAP_ID=i+1;
                obj.MAP_VALOR=arrayCuota[i];
                await cnt.addItem(obj);
            }
        }
        cnt.lock();
        // ui.getView(objself).refresh("CalculadoraCuota");
        ui.refresh("CalculadoraCuota");
    }else{
        ui.showToast("No se ha podido comprobar el parámetro de cuota mínima");
    }
}
function ObtenerCuotaFail(objself, data, jsResult){
    ui.showToast("Error al tratar de obtener las cuotas para el cálculo");
}


// FUNCIÓN DE CUOTAS ADDENDUM CLIENTE ACTIVIDAD
function CalculadoraObtenerCuotasAddendum(objself,cantidad){
    try{
        callApiGet(objself,"quota",cantidad,"",user.MAP_TOKEN,ObtenerCuotaOK,ObtenerCuotaFail);
    } catch(e){
        ui.showToast(e);
        ui.showToast("Ha ocurrido un error obteniendo las cuotas. Por favor, compruebe su conexión a internet e inténtelo nuevamente.");
    }
}
async function ObtenerCuotaAddendumOK(objself, data, jsResult){
    let arrayCuota = jsResult;
    arrayCuota.sort(comparar);
    let cnt=await objself.getContents("CalculadoraCuota");
    cnt.unlock();
    cnt.clear();
    await cnt.loadAll();
    
    // comprobamos el valor de cuota mínima para poder calcular
    let coll = appData.getCollection("ParametrosCalculadora");
    await coll.loadAll();
    let objParam = coll.getItem(0);
    if(objParam){
        
        let totalCuotas = 0;
        
        for(var i=0;i<arrayCuota.length;i++){
            if(arrayCuota[i]>=objParam.CUOTA_MINIMA){
                let obj = await cnt.createObject();
                obj.MAP_ID=i+1;
                obj.MAP_VALOR=arrayCuota[i];
                await cnt.addItem(obj);
                totalCuotas +=1;
            }
        }
        
        if(totalCuotas === 0) {
            await ui.msgBox("Las cuotas obtenidas son menores al mínimo establecido [" + objParam.CUOTA_MINIMA + " €]","Cuota mínima addendum",0);
        }
        
        cnt.lock();
        ui.refresh("CalculadoraCuota");
    }else{
        ui.showToast("No se ha podido comprobar el parámetro de cuota mínima");
    }
}



// FUNCIÓN DE CALCULADORA
function calculadoraPL(objself,idsimulacion){
    try{
        callApiGet(objself,"Calculator",idsimulacion,"",user.MAP_TOKEN,CalculadoraOK,CalculadoraFail);
    } catch(e){
        ui.showToast(e);
        ui.showToast("Ha ocurrido un error. Por favor, compruebe su conexión a internet e inténtelo nuevamente.");
    }
}
async function CalculadoraOK(objself, data, jsResult){
    let duracion=0;
    var objSim;
    var cntSim=await objself.getContents("Simulaciones");

    // Comprobamos si el ahorro neto es negativo. Si es negativo, volvemos y desmarcamos
    if(jsResult.Negativo==true){
        objself.setFieldPropertyValue("MAP_AHORRO_NEGATIVO","forecolor","#cd2d2d");
        objself.setFieldPropertyValue("MAP_AHORRO_NEGATIVO","text-forecolor","#cd2d2d");
        objself.MAP_AHORRO_NEGATIVO="SÍ";
        
        // guardamos el valor del ahorro negativo
        await filtrarContentMacroObject(cntSim,"ID="+objself.MAP_IDSIMULACION_SEL);
        
        if(cntSim.count()>0){
            objSim=cntSim.getItem(0);
            
            objSim.AHORRO_NEGATIVO="Sí";
            await objSim.save();
        }
        
        // desmarcamos la cuota elegida
        self.MAP_CUOTA_SEL=0;
        let cnt=await self.getContents("CalculadoraCuota");
        for(var i=0;i<cnt.count();i++){
            if(cnt.getItem(i).getFieldPropertyValue("MAP_BOTON","img")=="btCheck.png"){
                cnt.getItem(i).setFieldPropertyValue("MAP_BOTON","img","btSeleccionar.png");
            }
        }

        ui.refresh("CalculadoraCuota");
        ui.showToast("Ahorro neto negativo. Elija otra cuota o revise las deudas");
        // vaciamos algunos valores
        objself.MAP_CALCULO1="";
        objself.MAP_CALCULO2="";
        objself.MAP_CALCULO3="";
        objself.MAP_CALCULO4="";
        objself.MAP_CALCULO5="";
        objself.MAP_CALCULO6="";
        objself.MAP_CALCULO7="";
        objself.MAP_IDSIMULACION_SEL=0;
        ui.refresh("Simulaciones,SimulacionesDeuda");

        return;  
    }
    if(jsResult.Negativo==false){
        objself.setFieldPropertyValue("MAP_AHORRO_NEGATIVO","forecolor","#52cd2d");
        objself.setFieldPropertyValue("MAP_AHORRO_NEGATIVO","text-forecolor","#52cd2d");
        objself.MAP_AHORRO_NEGATIVO="NO";
        
        // guardamos el valor del ahorro negativo y comprobamos el mes de solución
        await filtrarContentMacroObject(cntSim,"ID="+objself.MAP_IDSIMULACION_SEL);
        
        if(cntSim.count()>0){
            objSim=cntSim.getItem(0);
            
            objSim.AHORRO_NEGATIVO="No";
            for(var i=0;i<jsResult.Deudas.length;i++){
                if(jsResult.Deudas[i].IDPRODUCTO_FINANCIERO==1){
                    if(jsResult.Deudas[i].MES_SOLUCION>objSim.DURACION){
                        objSim.DURACION=jsResult.Deudas[i].MES_SOLUCION;
                    }
                }
            }
            await objSim.save();
        }
        
        // Volcamos los datos generales del cálculo
        objself.MAP_CALCULO1=objself.MAP_CUOTA_SEL+" €";
        objself.MAP_CALCULO2=jsResult.Simulacion.TOTAL_PAGAR.toFixed(2)+" €";
        objself.MAP_CALCULO3=jsResult.Simulacion.DESCUENTO_ESTIMADO.toFixed(2)+" %";
        if(objSim.DURACION>1){
            objself.MAP_CALCULO4=objSim.DURACION+" meses";
        }else{
            objself.MAP_CALCULO4=objSim.DURACION+" mes";
        }
        // para asignar la fecha estimada de finalización en función de los meses
        objself.MAP_CALCULO5 = ObtenerFechaModificada(objSim.DURACION,"dmy");
        objself.MAP_CALCULO6=jsResult.Simulacion.DEUDA_TOTAL.toFixed(2)+" €";
        objself.MAP_CALCULO7=jsResult.Simulacion.DEUDA_TOTAL_INTERESES.toFixed(2)+" €";
        
        cntSim.clear();
        await cntSim.loadAll();
        
        // Cargar los contents cuando se realice el cálculo y obtengamos los valores de vuelta
        var cnt2 = await objself.getContents("SimulacionesDeuda");
        
        cnt2.unlock();
        cnt2.clear();
        await cnt2.loadAll();
        cnt2.lock();
        ui.refresh("Simulaciones,SimulacionesDeuda");
    }
}
async function CalculadoraFail(objself, data, jsResult){
    ui.showToast("No ha sido posible calcular el plan");

    // desmarcamos la cuota elegida
    self.MAP_CUOTA_SEL=0;
    let cnt=await self.getContents("CalculadoraCuota");
    for(var i=0;i<cnt.count();i++){
        if(cnt.getItem(i).getFieldPropertyValue("MAP_BOTON","img")=="btCheck.png"){
            cnt.getItem(i).setFieldPropertyValue("MAP_BOTON","img","btSeleccionar.png");
        }
    }
    ui.refresh("CalculadoraCuota");
}





async function sendOnlineFilesApi(objself, apiName, file, parameters,okCallback, errorCallback) {
    // Variante con callbacks (la usa `uploadFiles`). `parameters.rowid_lead` lo
    // fija uploadFiles; si faltara, caemos al ROWID del objeto en edición.
    var rowidLead = parameters.rowid_lead || (objself && (objself.MAP_ROWID || objself.ROWID)) || "";
    var fields = _docFieldsFromParams(parameters, rowidLead);
    await subirFicheroWebcore(file, fields)
        .then(function(data){ if (okCallback) okCallback(data); })
        .catch(function(error){
            if (errorCallback) errorCallback(error);
            else ui.showToast("Error: " + error.message);
        });
}

// !!!

//  FUNCIÓN CON CALLBACKS DE SUBIR ARCHIVOS SERVER
async function uploadFiles(objself,file,fileName,type,correo_lead,userName,login,tipoDoc,rowid_lead,iddeuda,iddeudacliente,idActualizacion,mes,idactividadcliente) {

    // funciones comunes para los callback
    function leerRespuestaLlamada(response) {
        // devolvemos el objeto del documento subido
        let documento = response.data[0];
            
        return documento;
    }
    
    async function limpiarTrasSubida(objself, refrescarPadre) {
        objself.getOwnerCollection().setVariables("File", null);
        ui.showToast("Actualizando listado de documentos...");
        await actualizarDatosPaginadoLeads(objself,"Documento","DocumentoContador","MAP_PAG_INI_DOC","MAP_PAG_LEN_DOC","MAP_TOTAL_REGISTROS_DOC","MAP_T1_DOC", refrescarPadre);
    }

    async function marcarActividadSiAplica() {
        // por tiype que es el idtipo de documentos
        if (type === 19) {
            await cambiarEstadoActividad(objself, idactividadcliente, 1);
        }
    }

    // callback OK según tipoDoc
    var okcallbacks = {

        doc: function () {
            ui.showToast("Documento subido correctamente");
            limpiarCampos(objself, "agregarDocumento");
            objself.MAP_CREAR_DOCUMENTO = 0;
            comprobarCheckContrato(objself);
            limpiarTrasSubida(objself);
            actualizarDatosContent(objself, "DocumentoPersonal");

            if (iddeudacliente > 0) {
                actualizarDatosContent(objself, "DeudaClientePrograma");
            }
        },
        
        // comprobantes de deudas lead
        compr: function () {
            ui.showToast("Comprobante subido correctamente");
            limpiarTrasSubida(objself);

            if (objself.getParent().IDESTADO === 10) {
                asignarIdDocumentoDeudaAddendum(objself.getParent(),file,fileName,rowid_lead,objself.ID);
            }
        },
        
        // comprobantes de deudas lead (mismo que arriba)
        comprEdit: function () {
            okcallbacks.compr();
        },

        // plan de liquidación lead y addendum cliente
        plan: function () {
            ui.showToast("Plan de liquidación subido correctamente");
            limpiarTrasSubida(objself);
            guardarPlanLiquidacion(objself,objself.MAP_IDSIMULACION_SEL,file,fileName,rowid_lead);

            if (objself.IDESTADO === 10) {
                actualizarDatosPaginadoLeads(objself,"ActividadesCliente","ActividadesClienteContador","MAP_PAG_INI_ACT","MAP_PAG_LEN_ACT","MAP_TOTAL_REGISTROS_ACT","MAP_T1_ACT");
                objself.MAP_CREAR_ADDENDUM = 0;
                limpiarCampos(objself, "generarPlanAddendum");
            }
        },

        // anexo actualizaciones deudas cliente programa
        anexo: function () {
            ui.showToast("Anexo subido correctamente");
            limpiarTrasSubida(objself);
            asignarIdDocumentoActualizacionDeuda(objself,idActualizacion,file,fileName,rowid_lead);
        },
        
        // anexo del apartado actividades del cliente
        anexoActividad: function () {
            ui.showToast("Documento de actividad subido correctamente");
            marcarActividadSiAplica();
            limpiarTrasSubida(objself);
            refrescarContent(objself, "ActividadesCliente");
        },

        // documentos del apartado acciones judiciales en actividades del cliente
        devolucionIntereses: function () {
            ui.showToast("Documento de actividad subido correctamente");
            limpiarTrasSubida(objself.getParent());
            refrescarContent(objself.getParent(), "ActividadesCliente");
            refrescarContent(objself.getParent(), "ActividadesClienteHijoDevolucionIntereses");
        },
        // documentos del apartado acciones judiciales en actividades del cliente
        accionesJudiciales: function () {
            ui.showToast("Documento de actividad subido correctamente");
            cambiarEtapaAccionJudicial(objself, type);
            limpiarTrasSubida(objself.getParent());
            refrescarContent(objself.getParent(), "ActividadesCliente");
            refrescarContent(objself.getParent(), "ActividadesClienteHijoAccionJudicial");
        },
        
        // documentos del proceso LSO del cliente
        procesoLSO: function (response) {
            ui.showToast("Documento del proceso subido correctamente");
            
            let documento = response.data[0];
            // limpiarTrasSubida(objself, true);

            // asignamos el nombre y el id en memoria del documento recién subido
            objself["MAP_DOCUMENTO" + safeToString(documento.IDTIPO)] = documento.DOCUMENTO;
            objself["MAP_IDDOCUMENTO" + safeToString(documento.IDTIPO)] = documento.ID;
        },
        
        // documentación previa del proceso LSO del cliente
        procesoLSODocumentacionPrevia: function (response) {
            ui.showToast("Documento del proceso subido correctamente");
            let padre = objself.getParent();
            let abuelo = padre.getParent();
            let documento = response.data[0];
            limpiarTrasSubida(abuelo, true);
            
            // asignamos el nombre y el id en memoria del documento recién subido
            objself.MAP_DOCUMENTO = documento.DOCUMENTO;
            objself.MAP_IDDOCUMENTO = documento.ID;
            // !!!
            objself.MAP_FECHA_SUBIDA = ObtenerFechaActual('dmy');
            objself.MAP_USUARIO_SUBIDA = documento.USUARIO_SUBIDA;
            
            comprobarDocumentacionPrevia(padre);
        },

        // documento aprobación cliente deudas cliente programa
        aprobacion: function (response) {
            ui.showToast("Documento de aprobación de liquidación o reestructura subido correctamente");
            limpiarTrasSubida(objself);
            actualizarDatosContent(objself, "DeudaClientePrograma");
            let documento = leerRespuestaLlamada(response);
            generarActualizacion(objself, iddeudacliente, 5, objself.MAP_IDPRODUCTO, null, function(objActGenerado) {
                // ¡Este código sólo se ejecutará cuando el .save() interno 
                // de generarActualizacion haya terminado!
                // Así podemos acceder al objeto ya que no marca la fución como await
                if (objActGenerado != null) {
                    objActGenerado.IDDOCUMENTO = documento.ID;
                    objActGenerado.save();
                    // asignarIdDocumentoActualizacionDeuda(objself,objActGenerado.ID,file,fileName,rowid_lead);
                }
                
            });
            // !!!
        },

        // documento justificante transferencia deudas cliente programa
        justificante: function (response) {
            ui.showToast("Documento de justificante de transferencia subido correctamente");
            limpiarTrasSubida(objself);
            actualizarDatosContent(objself, "DeudaClientePrograma");
            let documento = leerRespuestaLlamada(response);

            generarActualizacion(objself, iddeudacliente, 9, objself.MAP_IDPRODUCTO, null, function(objActGenerado) {
                // ¡Este código sólo se ejecutará cuando el .save() interno 
                // de generarActualizacion haya terminado!
                // Así podemos acceder al objeto ya que no marca la fución como await
                if (objActGenerado != null) {
                    objActGenerado.IDDOCUMENTO = documento.ID;
                    objActGenerado.save();
                }
                
            });

        },
        // !!!
        // documento justificante transferencia deudas cliente programa subidos desde movimientos
        justificanteTransMov: function (response) {
            ui.showToast("Documento de justificante de transferencia/devolución subido correctamente");
            objself.getOwnerCollection().setVariables("File", null);

            // si no es devolución
            if (objself.IDTIPO_MOVIMIENTO !== 5) {
                let documento = leerRespuestaLlamada(response);
                generarActualizacion(objself, iddeudacliente, 9, objself.MAP_IDPRODUCTO, null, function(objActGenerado) {
                    // ¡Este código sólo se ejecutará cuando el .save() interno 
                    // de generarActualizacion haya terminado!
                    // Así podemos acceder al objeto ya que no marca la fución como await
                    if (objActGenerado != null) {
                        objActGenerado.IDDOCUMENTO = documento.ID;
                        objActGenerado.save();
                    }
                    
                });
                
                
                if (mes > 0) {
                    asignarIdDocumentoPlanPagoDeuda(objself,iddeudacliente,file,fileName,rowid_lead,mes);
                }
            }
        },

        // documento justificante transferencia deudas cliente programa para deudas fraccionadas. Guardamos el id en cada mes del plan de pago
        justificantePlanPago: function () {
            ui.showToast("Documento de justificante de transferencia subido correctamente");
            limpiarTrasSubida(objself);
            actualizarDatosContent(objself, "DeudaClientePrograma");
            generarActualizacion(objself, iddeudacliente, 9, objself.MAP_IDPRODUCTO);

            asignarIdDocumentoPlanPagoDeuda(objself,iddeudacliente,file,fileName,rowid_lead,mes);

            actualizarDatosContent(objself, "PlanDePagos");
        },

        // documento de certificado financiera deudas cliente programa
        certificado: function () {
            ui.showToast("Documento de certificado de financiera subido correctamente");
            limpiarTrasSubida(objself);
            actualizarDatosContent(objself, "DeudaClientePrograma");
            generarActualizacion(objself, iddeudacliente, 10, objself.MAP_IDPRODUCTO);
        },
        
        // documento de acreditar residencia desde general en ClienteEdicion
        acreditaResidencia: function (response) {
            ui.showToast("Documento de acreditación de residencia subido correctamente");
            let documento = response.data[0];
            // guardamos el id del documento subido en la tabla de acreditar residencia
            acreditaResidenciaOk(objself,documento);
            limpiarTrasSubida(objself);
       },
        // documento de venta donación de bienes en ClienteEdicion
        ventaDonacionBien: function (response) {
            ui.showToast("Documento de venta o donación subido correctamente");
            let documento = leerRespuestaLlamada(response);
            // guardamos el id del documento subido en la tabla de acreditar residencia
            limpiarTrasSubida(objself);
            return documento.ID;
        }
    };

    var okcallback = okcallbacks[tipoDoc] || function () {
        ui.showToast("Documento subido correctamente");
        limpiarTrasSubida(objself);
        actualizarDatosContent(objself, "Documentopersonal");
    };
    
    
    var errorCallbacks = {

        anexoActividad: function () {
            objself.MAP_ANEXO = "";
        },
    
        devolucionIntereses: function () {
            objself.MAP_ANEXO = "";
        },
        accionesJudiciales: function () {
            objself.MAP_ANEXO = "";
        },
        

        procesoLSO: function () {
            objself.MAP_ANEXO = "";
        },
        
        procesoLSODocumentacionPrevia: function () {
            objself.MAP_ANEXO = "";
        },
    
        aprobacion: function () {
            objself.MAP_DOCUMENTO_APROBACION = "";
        },
    
        justificante: function () {
            objself.MAP_DOCUMENTO_JUSTIFICANTE = "";
        },
    
        justificanteTransMov: function () {
            objself.MAP_DOCUMENTO_JUSTIFICANTE = "";
        },
    
        justificantePlanPago: function () {
            objself.MAP_DOCUMENTO_JUSTIFICANTE = "";
        },
    
        certificado: function () {
            objself.MAP_DOCUMENTO_CERTIFICADO = "";
        },
        acreditaResidencia: function () {
            objself.MAP_ANEXO = "";
        },
        ventaDonacionBien: function () {
            objself.MAP_VENTA_BIEN_DOCUMENTO = "";
        }
    };

    var errorCallback = errorCallbacks[tipoDoc] || function () {
        objself.MAP_ANEXO = "";
    };


    // parámetros para la llamada
    var parameters = {
        correo_lead: correo_lead,
        rowid_lead: rowid_lead,
        idtipo: type,
        usuario_subida: userName,
        name: fileName || file.name,
        iddeuda: iddeuda,
        iddeudacliente: iddeudacliente,
        idactividadcliente: idactividadcliente
    };

    // subida de ficheros
    await sendOnlineFilesApi(objself,"/api/Pdf/UploadFile?user=" + login,file,parameters,okcallback,errorCallback);
}



// FUNCIÓN CREACIÓN DE USUARIO DEL LEAD PARA LA ZONA WEB AL MANDAR EL PLAN DE LIQUIDACIÓN (al ponerlo visible desde la coll Documento)
// También da de alta en mailchimp y manda correo
async function crearUsuarioLead(objself){
    callApiPost(objself,"CreateUser","",
    {
        login: objself.CORREO,
        correo: objself.CORREO,
        nombre:objself.NOMBRE,
        tag:"Propuesta_Plan",
        parameters:{
            NOMBRELEAD:objself.NOMBRE+" "+objself.APELLIDOS,
            USERZONA:objself.CORREO
        }
    }
    ,user.MAP_TOKEN,
    function(objself,data){
        pasarLeadPropuesta(objself);
        ui.msgBox("Se ha creado un usuario al lead para acceder a su 'Zona de usuario' en la web. Se le han enviado las credenciales a su correo electrónico","Usuario creado web Alivia",0);
    },
    function(objself,data){
        ui.showToast("se ha producido un error intentando crear el usuario para el lead. Compruebe la dirección de correo");
        self.DOCUMENTO_VISIBLE=0;
    });
}

// borrar documentos baja=1
async function borrarDocumento(objself,idDocumento,contentsName, omitirPregunta, tipoDoc){
    let pregunta = 0;
    
    // callback OK según tipoDoc
    var okcallbacks = {


        
        // al borrar desde dentro de DocumentoDatosCliente
        listadoDocumentosGeneral: function () {
            ui.showToast("Documento borrado correctamente");
            
            recargarDocumentoDatosCliente(objself.getParent());
            actualizarDatosPaginadoLeads(objself.getParent(),"Documento","DocumentoContador","MAP_PAG_INI_DOC","MAP_PAG_LEN_DOC","MAP_TOTAL_REGISTROS_DOC","MAP_T1_DOC", true);
        },
        // Comprobantes de deudas al editar una
        comprobanteDeuda: function () {
            ui.showToast("Documento borrado correctamente");
            
            // vaciamos el nombre y el id en memoria del documento borrado
            objself.MAP_DOCUMENTO_COMPROBANTE = "";
            objself.MAP_ID_DOCUMENTO_COMPROBANTE = 0;
            
            // actualizamos el registro vaciando el id del doc
            actualizarAcreditaResidenciaOk(objself);
            actualizarDatosPaginadoLeads(objself.getParent(),"Documento","DocumentoContador","MAP_PAG_INI_DOC","MAP_PAG_LEN_DOC","MAP_TOTAL_REGISTROS_DOC","MAP_T1_DOC", true);
        },
        // documentos del proceso LSO del cliente
        procesoLSO: function () {
            ui.showToast("Documento borrado correctamente");
            
            // Al borrar, buscaremos los props correspondientes y vaciaremos sus valores. (MAP_DOCUMENTO + nº doc), acorde al documento de cada estado
            let docsPorEtapa = {
                1: 42,
                3: 43,
                5: 44,
                6: 45,
                7: 46,
                9: 47,
                10: 48,
                11: 49,
                12: 50,
                13: 51,
                15: 52,
                16: 53
            };

            // vaciamos el nombre y el id en memoria del documento borrado
            objself["MAP_DOCUMENTO" + safeToString(docsPorEtapa[objself.IDESTADO])] = "";
            objself["MAP_IDDOCUMENTO" + safeToString(docsPorEtapa[objself.IDESTADO])] = 0;
            
            actualizarDatosPaginadoLeads(objself,"ProcesoLSODocumento","ProcesoLSODocumentoContador","MAP_PAG_INI_DOC","MAP_PAG_LEN_DOC","MAP_TOTAL_REGISTROS_DOC","MAP_T1_DOC", true);
        },
        
        // documentos previos del proceso LSO del cliente
        procesoLSODocumentacionPrevia: function () {
            ui.showToast("Documento borrado correctamente");
            
            // vaciamos el nombre y el id en memoria del documento borrado
            objself.MAP_DOCUMENTO = "";
            objself.MAP_FECHA_USUARIO_SUBIDA = "";
            objself.MAP_IDDOCUMENTO = 0;
            
            let padre = objself.getParent();
            comprobarDocumentacionPrevia(padre);
        },
        
        partidaNacimiento: function () {
            ui.showToast("Documento borrado correctamente");
            
            // vaciamos el nombre y el id en memoria del documento borrado
            objself.MAP_DOCUMENTO_PARTIDA_NACIMIENTO = "";
            objself.MAP_ID_DOCUMENTO_PARTIDA_NACIMIENTO = 0;
            limpiarDatosTrasSubida(objself);
        },
        certificadoCatastral: function () {
            ui.showToast("Documento borrado correctamente");
            
            // vaciamos el nombre y el id en memoria del documento borrado
            objself.MAP_DOCUMENTO_CERTIFICADO_CATASTRAL = "";
            objself.MAP_ID_DOCUMENTO_CERTIFICADO_CATASTRAL = 0;
            limpiarDatosTrasSubida(objself);
        },
        lsoPrevia: function () {
            ui.showToast("Documento borrado correctamente");
            
            // vaciamos el nombre y el id en memoria del documento borrado
            objself.MAP_DOCUMENTO_LSO_PREVIA = "";
            objself.MAP_ID_DOCUMENTO_LSO_PREVIA = 0;
            limpiarDatosTrasSubida(objself);
        },
        // documentos acredita residencia clienteEdicion en General
        acreditaResidencia: function () {
            ui.showToast("Documento borrado correctamente");
            
            // vaciamos el nombre y el id en memoria del documento borrado
            objself.MAP_DOCUMENTO_ACREDITA_RESIDENCIA = "";
            objself.MAP_ID_DOCUMENTO_ACREDITA_RESIDENCIA = 0;
            
            // actualizamos el registro vaciando el id del doc
            actualizarAcreditaResidenciaOk(objself);
            actualizarDatosPaginadoLeads(objself,"Documento","DocumentoContador","MAP_PAG_INI_DOC","MAP_PAG_LEN_DOC","MAP_TOTAL_REGISTROS_DOC","MAP_T1_DOC", true);
        },
        familiaresCargoLibroFamilia: function () {
            ui.showToast("Documento borrado correctamente");
            
            // vaciamos el nombre y el id en memoria del documento borrado
            objself.MAP_DOCUMENTO_LIBRO_FAMILIA = "";
            objself.MAP_ID_DOCUMENTO_LIBRO_FAMILIA = 0;
            limpiarDatosTrasSubida(objself);
        },
        gastoMensual: function () {
            ui.showToast("Documento borrado correctamente");
            
            // vaciamos el nombre y el id en memoria del documento borrado
            objself.MAP_GASTO_MENSUAL_DOCUMENTO = "";
            objself.MAP_GASTO_MENSUAL_ID_TIPO_DOCUMENTO = 0;
            limpiarDatosTrasSubida(objself.getParent());
        },
        certificadoAntecedentesPenales: function () {
            ui.showToast("Documento borrado correctamente");
            
            // vaciamos el nombre y el id en memoria del documento borrado
            objself.MAP_DOCUMENTO_CERTIFICADO_ANTECEDENTES_PENALES = "";
            objself.MAP_ID_DOCUMENTO_CERTIFICADO_ANTECEDENTES_PENALES = 0;
            limpiarDatosTrasSubida(objself);
        },
        certificadoVidaLaboral: function () {
            ui.showToast("Documento borrado correctamente");
            
            // vaciamos el nombre y el id en memoria del documento borrado
            objself.MAP_DOCUMENTO_CERTIFICADO_VIDA_LABORAL = "";
            objself.MAP_ID_DOCUMENTO_CERTIFICADO_VIDA_LABORAL = 0;
            limpiarDatosTrasSubida(objself);
        },
        autorizacionOposicionMonitorio: function () {
            ui.showToast("Documento borrado correctamente");
            
            // vaciamos el nombre y el id en memoria del documento borrado
            objself.MAP_DOCUMENTO_AUTORIZACION_OPOSICION = "";
            objself.MAP_IDDOCUMENTO_AUTORIZACION_OPOSICION = 0;
        },
        autorizacionIngreso: function () {
            ui.showToast("Documento borrado correctamente");
            
            // vaciamos el nombre y el id en memoria del documento borrado
            objself.MAP_DOCUMENTO = "";
            objself.MAP_ID_DOCUMENTO = 0;
        }
        
    };
    

    var okcallback = okcallbacks[tipoDoc] || function () {
        ui.showToast("Documento borrado correctamente");
        actualizarDatosContent(objself,contentsName);
    };
    
    
    
    // desde u monitorio en actividadesclienteHijo omitimos la pregunta y borramos directamente
    if(!omitirPregunta) {
        pregunta = await ui.msgBox("¿Está seguro que desea borrar el documento seleccionado? Esta acción no será reversible","Borrar documento",1);
    } else {
        pregunta = 1;
    }
    
    if(pregunta == 1){
        
        try {
            var otpRuta = dominioUrl + "/api/Pdf/RemoveFile?documentId=" + idDocumento + "&user=" + user.CORREO;
        
            fetch(otpRuta, {
                method: "DELETE",
                headers: { 
                    Authorization: "Bearer " + user.MAP_TOKEN
                }
            })
            .then(function(response){
                return response.json();
            })
            .then(function(result){
                if (!result.hasError) {
                    okcallback(); // callback ok
                } else {
                    ui.showToast(result.message || "No se ha podido borrar el documento");
                }
            })
            .catch(function(){
                ui.showToast("Error al llamar al servicio");
            });
        
        } catch (ex) {
            ui.showToast("Error al intentar borrar el documento. No se han realizado los cambios");
        }
    }
}


function downloadDocumentAsyncPDF(objself,rowid_lead,fileName,correo,callBackSuccess,callBackError) {
    let request = {
		parameters: {
		    connectTimeout: 120000,
		    readTimeout: 120000
		},
        headers : {
            "Authorization": "Bearer " + user.MAP_TOKEN,
            processData: false, 
            contentType: false, 
            // "x-request-rowid-lead": rowid_lead
        }
    };
    
    let fullURL = dominioUrl + "/api/Pdf/DownloadFile?user="+correo+"&&file="+fileName;
    $http.getFile(fullURL, request, 
        function(response) {
            callBackSuccess(response);
        }, 
        function(errorCode, errorMsg,msgampliado) {
            ui.showToast(errorCode + ": " + errorMsg);
        }
    ); 
}


async function uploadUserFiles(objself,file,fileName,correo_usuario,login,objUsuario){
    
    // para subir fotos de los usuarios Alivia
    let parameters={
        correo_lead:correo_usuario,
        name: fileName,
    };
    
    // llamada para subir los documentos
    await sendOnlineFilesApi(
        objself,
        "/api/Pdf/UploadFile?user="+login+"&&fromuser=true",
        file,
        parameters,
        function(response) {
            objUsuario.FOTO=fileName;
            objUsuario.save();
            objself.getOwnerCollection().setVariables("File",null);
            ui.showToast("imagen subida correctamente");
            actualizarDatosContent(objself,"UsuariosContent");
        },
        function(errorCode, errorMsg,msgampliado) {
        // ui.showToast(errorCode + ": " + errorMsg);
        ui.showToast("Se ha producido un error intentando subir la foto");
        actualizarDatosContent(objself,"UsuariosContent");
    });
}

function DownloadUserFile(objself,fileName,correo,callBackSuccess,callBackError) {
    // para descargar fotos de los usuarios Alivia
    let request = {
		parameters: {
		    connectTimeout: 120000,
		    readTimeout: 120000
		},
        headers : {
            "Authorization": "Bearer " + user.MAP_TOKEN,
            processData: false, 
            contentType: false
        }
    };
    let fullURL = dominioUrl + "/api/Pdf/DownloadFile?user="+correo+"&&file="+fileName+"&&fromuser=true";
    $http.getFile(fullURL, request, 
        function(response) {
            callBackSuccess(response);
        }, 
        function(errorCode, errorMsg,msgampliado) {
            callBackError();
            // ui.showToast(errorCode + ": " + errorMsg);
        }
    ); 
}


// Función generar documentos con las plantillas word
function generarDocumentoPlantilla(objself,parameters,addendum,objEntidad,nombreDocumento){
    /*
        En los checkstexts mandar las tildes codificadas:
        a:\u00e1  e:\u00e9  i:\u00ed  o:\u00f3  u:\u00fa
    */

    let request = {
		parameters: {
		    connectTimeout: 120000,
		    readTimeout: 120000
		},
        headers : {
            "Authorization": "Bearer " + user.MAP_TOKEN,
            "lead": parameters.lead,
            "name": parameters.name,
            "entidad": parameters.entidad,
            "images": JSON.stringify(parameters.images),
            "parameters": JSON.stringify(parameters.where),
            "checks": JSON.stringify(parameters.checks),
            "checkstexts": JSON.stringify(parameters.checkstexts)
        }
    };
    
    let fullURL = dominioUrl + "/api/Pdf/GenerateFile";
    try{
        $http.getFile(fullURL, request, 
            function(response) {
                // ui.openUrl(response);
                var link = document.createElement("a");
                link.download = parameters.name.split('.')[0] + "_" + nombreDocumento + ".docx";
                link.href = response;
                link.click();
                
                if(addendum == 1){
                    // cerramos el flotante del addendum
                    limpiarCampos(objself,"generarContratoAddendum");
                    objself.MAP_GENERAR_CONTRATO_ADDENDUM = 0;
                }
            }, 
            function(errorCode, errorMsg,msgampliado) {
                ui.showToast(errorCode + ": " + errorMsg);
            }
        );
    }catch(e){
        ui.showToast(e);
        ui.showToast("Ha ocurrido un error. Por favor, compruebe su conexión a internet e inténtelo nuevamente.");
    }
}

async function generarAnexoPagoDiferido(objself, iddeuda) {
    
    // comprobamos que hayan generado antes las CE
    let collMov = appData.getCollection("MovimientosScript");
    await filtrarCollMacroObject(collMov,"m.IDLEAD=" + objself.ID + " and m.IDTIPO_MOVIMIENTO=3 and ifnull(m.BAJA,0)=0");
    
    if(collMov.count() == 0) {
        ui.showToast("Debe generar antes los movcimientos de CE");
        return;
    }
    
    var parameters = {
        lead: objself.ROWID,
        name: "AnexoPagoDiferido.docx",
        entidad: "AnexoPagoDiferido",
        images: [],
        where: [iddeuda],
        checks: [],
        checkstexts: []
    };
    
    generarDocumentoPlantilla(objself, parameters, 0, null, 
        objself.MAP_NOMBRE_COMPLETO);
}


// Función mandar correos con Mailchimp
function enviarCorreoMailchimp(objself,correo,tagCorreo){
    let parametrosCorreo;
    // definimos los parámetros necesarios para cada tipo de correo
    if(tagCorreo=="ContratoFirmado"){
        parametrosCorreo={
            nombrepara:"texto"
        };
    }
    let data = {
        email: correo,
        tag: tagCorreo,
        parameters: parametrosCorreo
    };
    
    try{
        callApiPost(objself,"Mailchimp/sendmail","",data,user.MAP_TOKEN,
        function(response) {
            ui.showToast("Correo enviado correctamente");
        }, 
        function(errorCode, errorMsg,msgampliado) {
            ui.showToast(errorCode + ": " + errorMsg);
        });
    } catch(e){
        ui.showToast(e);
        ui.showToast("Ha ocurrido un error. Por favor, compruebe su conexión a internet e inténtelo nuevamente.");
    }
}

// Función chatbot aivo para mandar mensajes
function EnviarMensajeAivo(objself,nombreCampania,telefono,callBackSuccess,callBackError) {
    let parametros=[];
    // definimos los parámetros necesarios para cada tipo de mensaje
    parametros=[parametrosPlantillaAvio(objself,nombreCampania)];
    
    let request = {
		parameters: {
		    connectTimeout: 120000,
		    readTimeout: 120000
		},
        headers : {
            "Authorization": "Bearer " + user.MAP_TOKEN,
            processData: false, 
            contentType: false
        }
    };
    
    let fullURL = dominioUrl + "/api/Aivo/sendmessage?campaignname="+nombreCampania+"&phonenumber="+telefono+"&parameters="+parametros;
    try{
        $http.post(fullURL, request, 
            function(response) {
                // callBackSuccess(response);
            }, 
            function(errorCode, errorMsg,msgampliado) {
                ui.showToast(errorCode + ": " + errorMsg);
            }
        );
    }catch(e){
        ui.showToast(e);
        ui.showToast("Ha ocurrido un error. Por favor, compruebe su conexión a internet e inténtelo nuevamente.");
    }
}

// funcion eleccion tarjeta. LLamada por MediosPagos
async function cambiarMedioPago(objself,callBackSuccess) {
    let idTarjeta = objself.ID;
    let nombreTarjeta = objself.NOMBRE;
    

    let pregunta = await ui.msgBox("¿Desea marcar \"" + nombreTarjeta + "\" como tarjeta principal?", "Confirmar", 1);
    if (pregunta != 1) return;

    let fullURL = dominioUrl + "/api/Stripe/payment_method/main/" + idTarjeta;

    try {
        fetch(fullURL, {
            method: "PUT",
            headers: {
                Authorization: "Bearer " + user.MAP_TOKEN
            }
        })
        .then(
            function(response) {
                if(response.ok) {
                    callBackSuccess.call(this,objself);
                } else {
                    ui.showToast("Error al actualizar la tarjeta principal.");
                }
            },
            function() {
                ui.showToast("Error al actualizar la tarjeta principal.");
            }
        );
    } catch(ex) {
        ui.showToast("Error al intentar actualizar la tarjeta principal. No se han realizado los cambios.");
    }
}

async function cambiarMedioPagoOk(objself) {
    let cnt = await objself.getParent().getContents("mediosPagosContent");
    ui.showToast("Tarjeta principal actualizada correctamente.");
    
    cnt.unlock();
    cnt.clear();
    await cnt.loadAll();
    cnt.lock();
    ui.getView(objself.getParent()).refresh("mediosPagosContent");
}

function parametrosPlantillaAvio(objself,nombreCampania){
    let parametros=[];
    if(nombreCampania=="test_mkt_descuento"){
        parametros=["texto prueba código"];
    }
    return parametros;
}


// FUNCIONES DE PAYLANDS
function crearSuscripcion(objself,callBackSuccess,callBackError,obj){

    try {
        var otpRuta = formatUrl("subscription","");
        fetch(otpRuta, {
            method: "POST",
            headers: { 
                "Content-Type" : "application/json",
    	        "Authorization" : "Bearer " + user.MAP_TOKEN
            },
            body: JSON.stringify({
                nombre: "suscripcion " + objself.NOMBRE + " " + objself.APELLIDOS,
                importe: objself.CUOTA_ALIVIA,
                moneda: "EUR",
                correo: objself.CORREO,
                tipo_pago: "MONTHLY",
                fecha_inicio: objself.MAP_FECHA_NUEVA_SUSCRIPCION
            }),
        })
        .then(
            // ok
            function(response){
                if(response.ok) {
                    callBackSuccess.call(this,objself,obj);
                } else {
                    callBackError.call(this);
                }
            },
            // Error
            function(response){
                callBackError.call(this);
            }
        );
    } catch (ex) {
        ui.showToast("Error al intentar crear la suscripción. No se han realizado los cambios");
    }
}

function borrarSuscripcion(objself,correo,callBackSuccess,callBackError,obj){
    ui.showToast("Borrando suscripción activa del cliente...");
    
    var o = objself;

    try {
        var otpRuta = formatUrl("subscription",correo);
        fetch(otpRuta, {
            method: "DELETE",
            headers: { 
                processData: false, 
                contentType: false, 
                Authorization: "Bearer " + user.MAP_TOKEN
            },
            body: "",
        })
        .then(
            // ok
            function(response){
                if(response.ok) {
                    callBackSuccess.call(this,objself,obj);
                } else {
                    callBackError.call(this);
                }
            },
            // Error
            function(){
                callBackError.call(this);
            }
        );
    } catch (ex) {
        ui.showToast("Error al intentar borrar la suscripción. No se han realizado los cambios");
        // ui.showToast("Error al borrar la suscripción: " + ex);
    }
}

async function borrarSuscripcionOk(objself,objDoc){
    ui.showToast("Suscripción activa del cliente borrada");
    let padre = objself.getParent();
    
    // rechazamos el documento
    objDoc.DOCUMENTO="rechazado_"+objDoc.DOCUMENTO;
    objDoc.ACEPTADO=2;
    objDoc.DOCUMENTO_VISIBLE=0;
    await objDoc.save();
    
    // Devolvemos el lead a la etapa propuesta
    var collEstado= appData.getCollection("Estados");
    await filtrarCollMacroObject(collEstado,"CODIGO");
    
    if(collEstado.count()>0){
        let Estado = collEstado.getItem(0);
        
        padre.IDESTADO=7;
        padre.MAP_ESTADO=Estado.NOMBRE;
        // vaciamos el número de contrato para que genere otro nuevo
        padre.CONTRATO_NUMERO="";
        padre.NUMERO="";
        await padre.save();
    }else{
        ui.showToast("error al volver a la etapa 'propuesta'");
    }
    
    await Promise.all([
        actualizarDatosContent(padre,"Documento"),
        actualizarDatosContent(padre,"PlanesLiquidacion"),
    ]);
}

function borrarSuscripcionError(){
    ui.showToast("se ha producido un error intentando borrar la suscripción activa del lead");
}


async function aportacionExtra(objself){
    
    if(objself.MAP_IMPORTE_EXTRA <= 0 || objself.MAP_IMPORTE_EXTRA == null){
        await ui.msgBox("Debe indicar un importe","Falta importe",0);
        return;
    }
    
    let pregunta = await ui.msgBox("¿Está seguro que desea realizar la aportación de "+objself.MAP_IMPORTE_EXTRA+"€?","Aportación extra",1);
    if(pregunta != 1) return;
    

    try{
        // Llamada a la API para procesar el pago
        callApiPost(objself,"payment","",{
            IMPORTE: objself.MAP_IMPORTE_EXTRA,
            CURRENCY: "EUR",
            EMAIL: objself.MAP_CORREO,
            IDACTIVIDADCLIENTE: objself.ID
        },user.MAP_TOKEN,
         function(objself,data){
            aportacionExtraOk(objself);
            ui.showToast("El pago se ha realizado correctamente");
        },function(objself,data){
            ui.showToast("Error al realizar la aportación extra");
        });
    } catch(e){
        ui.showToast("Ha ocurrido un error. Por favor, compruebe su conexión a internet e inténtelo nuevamente.");
    }
}

async function aportacionExtraOk(objself){
    // Callback tras el pago exitoso. marcar la actividad como finalizada
    objself.ESTADO = 1;
    await objself.save();

    // Actualizar el saldo en pantalla y refrescar contenidos
    objself.getParent().MAP_SALDO = (parseFloat(objself.getParent().SALDO) + parseFloat(objself.MAP_IMPORTE_EXTRA)).toFixed(2) + " €";
    
    await actualizarDatosPaginadoLeads(objself.getParent(),"MovimientosCliente","MovimientosClienteContador","MAP_PAG_INI_MOV","MAP_PAG_LEN_MOV","MAP_TOTAL_REGISTROS_MOV","MAP_T1_MOV");
    await Promise.all([
        actualizarDatosContent(objself,"MovimientosClienteMes"),
        actualizarDatosContent(objself.getParent(), "ActividadesCliente"),
        actualizarDatosContent(objself.getParent(), "ActividadesClienteHijoAportacionExtra"),
    ]);
}

// Función pago cuota. Llamada en ClienteEdicion
async function aportacionCuota(objself) {
    
    let pregunta = await ui.msgBox("¿Está seguro que desea realizar el pago de la cuota de " + objself.CUOTA_ALIVIA + "€?", "Pagar cuota", 1);
    if(pregunta != 1) return;
    
    try {
        callApiPost(objself, "payment", "", {
            IMPORTE: objself.CUOTA_ALIVIA,
            CURRENCY: "EUR",
            EMAIL: objself.MAP_CORREO
        }, user.MAP_TOKEN,
        function(objself, data) {
            aportacionCuotaOk(objself);
        }, function(objself, data) {
            ui.showToast("Error al realizar el pago de la cuota");
        });
    } catch(e) {
        ui.showToast("Ha ocurrido un error. Por favor, compruebe su conexión a internet e inténtelo nuevamente.");
    }
}

async function aportacionCuotaOk(objself) {
    // En caso de ser un lead quien paga, estaremos en LeadEdicion y pasaremos a cliente
    if(objself.getOwnerCollection().getName() == "LeadEdicion") {

        let Estado = await obtenerPrimerObjetoColl("Estados","CODIGO=10");
        if(Estado){
            objself.MAP_ESTADO = Estado.NOMBRE;
            objself.MAP_CODIGO_ETAPA = Estado.CODIGO;
            await ui.msgBox("Pago realizado correctamente. La operación se está procesando y puede tardar unos segundos en reflejarse en el listado de movimientos. Se está realizando el paso a cliente. ","Pago realizado",0);
            await objself.executeNode('editarSucripcion');
        }
    } else {
        // Actualizar el saldo en pantalla para clienteEdicion
        objself.MAP_SALDO = (parseFloat(objself.SALDO) + parseFloat(objself.CUOTA_ALIVIA)).toFixed(2) + " €";
        await ui.msgBox("Pago realizado correctamente. La operación se está procesando y puede tardar unos segundos en reflejarse en el listado de movimientos. Actualiza el listado en unos instantes para comprobarlo. ","Pago realizado",0);
        await actualizarDatosPaginadoLeads(objself, "MovimientosCliente", "MovimientosClienteContador", "MAP_PAG_INI_MOV", "MAP_PAG_LEN_MOV", "MAP_TOTAL_REGISTROS_MOV", "MAP_T1_MOV");
        await actualizarDatosContent(objself, "MovimientosClienteMes");
        await objself.executeNode('editarSucripcion');
    }
}

async function pagarTransferencia(objself,escliente, importe){
    try{
        callApiPost(objself,"payment_by_trasnfer","",{
            IMPORTE: importe,
            CURRENCY: "EUR",
            EMAIL: objself.CORREO
        },user.MAP_TOKEN,
        function(objself,data){
            transferenciaOk(objself,escliente,importe);
            ui.msgBox("El pago se ha realizado correctamente","Pago por transferencia",0);
        },function(objself,data){
            ui.showToast("Error al aceptar el pago por transferencia");
        });
    } catch(e){
        // ui.showToast(e);
        ui.showToast("Ha ocurrido un error. Por favor, compruebe su conexión a internet e inténtelo nuevamente.");
    }
} 

async function pagarTransferenciaProceso(objself,escliente, importe){
    // para pagos realizados desde el proceso LSO
    try{
        callApiPost(objself,"payment_by_trasnfer","",{
            IMPORTE: importe,
            CURRENCY: "EUR",
            EMAIL: objself.MAP_CORREO_TITULAR_CABECERA
        },user.MAP_TOKEN,
        function(objself,data){
            transferenciaOkProceso(objself,escliente,importe);
            ui.msgBox("El pago se ha realizado correctamente","Pago por transferencia",0);
        },function(objself,data){
            ui.showToast("Error al aceptar el pago por transferencia");
        });
    } catch(e){
        // ui.showToast(e);
        ui.showToast("Ha ocurrido un error. Por favor, compruebe su conexión a internet e inténtelo nuevamente.");
    }
} 


async function comprobarPlazoAportaciones(objself, idcliente) {
    // la defino aquí porque si no no me respeta el await en transferenciaok..
    
    // Según si mandamos el titular desde el proceso LSO o desde la ficha del lead/cliente
    let proxFechaPagoCliente = objself.MAP_FECHA_PAGO_TRANSFERENCIA_TITULAR || objself.FECHA_PAGO_TRANSFERENCIA;
    let cuotaAlivia = objself.MAP_CUOTA_ALIVIA_TITULAR || objself.CUOTA_ALIVIA;
    
    // buscamos la última aportación realizada por el cliente
    let collMov = appData.getCollection("MovimientosScript");
    await filtrarCollMacroObject(collMov,"m.IDLEAD = " + idcliente + " AND m.IDTIPO_MOVIMIENTO = 4 AND m.IDESTADO = 1 ORDER BY m.FECHA_DONE DESC");
    
    if(collMov.count() > 0) {
        let objMov = collMov.getItem(0);
        
        
        let ultimaAportacion = objMov.FECHA_DONE;
        let proximaAportacion = proxFechaPagoCliente;
        let fechaActual = ObtenerFechaHoraActual();
        
        // realizamos la comprobaciones
        const hoy = new Date(fechaActual);
        const ultima = ultimaAportacion ? new Date(ultimaAportacion) : null;
        const proxima = new Date(proximaAportacion);
        
        // ¿Ha pagado este mes?
        const haPagadoEsteMes =
            ultima &&
            ultima.getMonth() === hoy.getMonth() &&
            ultima.getFullYear() === hoy.getFullYear() &&
            objMov.IMPORTE >= cuotaAlivia * 0.9;
    
        if (haPagadoEsteMes) {
            return "#58d68d"; // realizado
        }
    
        // No ha pagado → comprobar plazo
        if (proxima > hoy) {
            return "#B0E0E6"; // en plazo
        }
    
        // Fuera de plazo
        return "#ec7063"; // atraso
    }
}
  

async function transferenciaOk(objself,escliente,importe){
    if(escliente == 1){
        // si es cliente, actualizamos el saldo en pantalla y sus movimientos
        objself.MAP_SALDO = (objself.SALDO + importe).toFixed(2) + " €";
        objself.MAP_COLOR_PAGO_BG = await comprobarPlazoAportaciones(objself, objself.ID);
        
        await actualizarDatosPaginadoLeads(objself,"MovimientosCliente","MovimientosClienteContador","MAP_PAG_INI_MOV","MAP_PAG_LEN_MOV","MAP_TOTAL_REGISTROS_MOV","MAP_T1_MOV");
        await actualizarDatosContent(objself,"MovimientosClienteMes");
    }else{
        // si es lead, lo acualizamos como cliente aunque lo hayan guardado ya en BD
        var collEstado= appData.getCollection("Estados");
        await filtrarCollMacroObject(collEstado,"CODIGO=10");
        
        if(collEstado.count()>0){
            let Estado = collEstado.getItem(0);
        
            await guardarHistoricoCambioEstado(objself,9,10);
            objself.MAP_CODIGO_ETAPA=10;
            objself.MAP_ESTADO=Estado.NOMBRE;
        }
        objself.MAP_ESCLIENTE=1;
    }
    
    // cerramos el flotante
    objself.MAP_PAGO_TRANSFERENCIA = 0;
    limpiarCampos(objself,"pagoTransferencia");
}

async function transferenciaOkProceso(objself,escliente,importe){
    if(escliente == 1){
        // si es cliente, actualizamos el saldo en pantalla y sus movimientos
        // objself.MAP_SALDO = (objself.SALDO + importe).toFixed(2) + " €";
        objself.MAP_COLOR_PAGO_BG = await comprobarPlazoAportaciones(objself, objself.MAP_IDLEAD_TITULAR);
        
        await actualizarDatosPaginadoLeads(objself,"MovimientosCliente","MovimientosClienteContador","MAP_PAG_INI_MOV","MAP_PAG_LEN_MOV","MAP_TOTAL_REGISTROS_MOV","MAP_T1_MOV");
        await actualizarDatosContent(objself,"MovimientosClienteMes");
    }
    
    // cerramos el flotante
    objself.MAP_PAGO_TRANSFERENCIA = 0;
    limpiarCampos(objself,"pagoTransferencia");
}



// Función generar documentos con las plantillas word
async function firmarDocumento(objself,idDocumentos){
    
    callApiPost(objself,"signature_request_docs","",
    {
        documentsId: idDocumentos,
        user: objself.CORREO
    },
    user.MAP_TOKEN,
    function(objself,data){
        ui.showToast("Enlaces de firma generados correctamente");
        refrescarContent(objself,"DocumentoFirmaPendiente");
    },
    function(objself,data, msg){
        ui.showToast("Error al generar los enlaces de firma: " + msg);
    });
}

function enviarSms(objself,telefono,plantilla,parametros) {
    let telefonosms = [telefono];
    let parametrossms = [];

    objself.MAP_BANDERA = 1;
    // aquí si parametros viene lleno, crear un case para llenar el array o similar con los parámetros según plantilla
    ui.showToast("Enviando sms...");
    
    callApiPost(objself,"zadarma","sms",
    {
        Phones: telefonosms,
        Message: "",
        Template: plantilla,
        TemplateParameters: parametrossms
    },
    user.MAP_TOKEN,
    function(objself,data){
        objself.MAP_BANDERA = 0;
        ui.showToast("Sms enviado al cliente");
    },
    function(objself,data){
        objself.MAP_BANDERA = 0;
        ui.showToast("Error al enviar sms al cliente");
    });
}

async function generarResumenSocioeconomico (objself, correo) {
    
    ui.showWaitDialog();
    ui.showToast("Intentando generar resumen...");

    let request = {
    	headers : {
    	    "Content-Type" : "application/json",
    	    "x-api-key" : apiKey
    	},
    	parameters: {
    		allowUnsafeCertificates: true,
    		connectTimeout: 90000,
    		readTimeout: 90000
	    },
		data : {
		    "input_value": "message",
            "output_type": "chat",
            "input_type": "chat",
            "tweaks": {
                "input": {
                    "input_value": "Genera el resumen socioeconómico para el cliente " + objself.CORREO
                },
                "userName": {
                    "input_value": user.LOGIN
                },
                "token": {
                    "input_value":
                    "Bearer "+ user.MAP_TOKEN
                }
            }
        }
	};
	
    // 	Montamos la llamada
    try {

		var otpRuta = dominioUrlResumen+ flowIDResumen;

		$http.post(otpRuta, request, function (jsResult) {
	            resumenOk(objself, jsResult);
			},function(sError,stext) {
		        resumenError(objself, sError,stext);
			});
	} catch(e) {
	    ui.showToast("Error al intentar generar el resumen socioeconómico");
	}
	ui.hideWaitDialog();
}

async function resumenOk(objself, resumen) {
    const textoResumen = resumen.outputs[0].outputs[0].results.text.data.text;
    
    if(textoResumen) {
        
        objself.RESUMEN_SOCIOECONOMICO = textoResumen;
        await objself.save();
        ui.showToast("Resumen generado correctamente");
    }else {
        ui.showToast("No se ha podido guardar el resumen en el cliente");
    }
}

function resumenError(objself, error, errorText) {
    ui.showToast("Error al intentar generar el resumen socioeconómico");
}

// función para el ok tras subir documento. (lo pongo fuera porque dentro del callback no me aplica await y falla)
// function acreditaResidenciaOk(objself, documento) {
//     let objResidencia;
//     let collResidencia = appData.getCollection("ClienteDatosAcreditaResidenciaScript");
//     filtrarCollMacroObject(collResidencia,"IDLEAD=" + objself.ID);
//     if(collResidencia.count() > 0) {
//         objResidencia = collResidencia.getItem(0);
//         objResidencia.ID_DOCUMENTO = documento.ID;
//         objResidencia.save();
        
//     } else {
//         objResidencia = collResidencia.createObject();
//         objResidencia.IDLEAD = objself.ID;
//         objResidencia.ID_DOCUMENTO = documento.ID;
//     }
//     objResidencia.save();
    
//     // asignamos el nombre y el id en memoria del documento recién subido
//     objself["MAP_ID_DOCUMENTO_ACREDITA_RESIDENCIA"] = documento.ID;
//     objself["MAP_DOCUMENTO_ACREDITA_RESIDENCIA"] = documento.DOCUMENTO;
// }

// función para el ok tras borrar documento. (lo pongo fuera porque dentro del callback no me aplica await y falla)
async function actualizarAcreditaResidenciaOk(objself) {
    let objResidencia;
    let collResidencia = appData.getCollection("ClienteDatosAcreditaResidenciaScript");
    await filtrarCollMacroObject(collResidencia,"IDLEAD=" + objself.ID);
    if(collResidencia.count() > 0) {
        objResidencia = collResidencia.getItem(0);
        objResidencia.ID_DOCUMENTO = 0;
        await objResidencia.save();
    }
}

var simpleSDK = new RingoverSDK();
const generate = function(){ simpleSDK.generate(); };
const destroy = function(){ simpleSDK.destroy(); };
const show = function(){ simpleSDK.show(); };
const hide = function(){ simpleSDK.hide(); };
const toggle = function(){ simpleSDK.toggle(); };
const reload = function(){ simpleSDK.reload(); };
const logout1 = function(){ simpleSDK.logout(); };
const dial = function(numero,desdenumero){ simpleSDK.dial(numero,desdenumero); };
const whatsapp = function(numero,desdenumero){ simpleSDK.whatsapp(numero,desdenumero); };
const sendSMS = function(numDestino,mensaje,numOrigen){ simpleSDK.sendSMS(numDestino, mensaje, numOrigen || null); };
const openCallLog = function(idllamada){ simpleSDK.openCallLog(idllamada); };
const getPage = function(){ console.log(simpleSDK.getCurrentPage()); };
const changePage = function(){ simpleSDK.changePage(s.selectedOptions[0].value); };
    



// ************** Comentar desde aquí


// function filtrarCollMacroObject(coll,filter){
//     // pasamos ya el objeto por parámetro
//     coll.unlock();
// 	coll.setMacro("##MACRO##", filter);
//     coll.clear();
//     coll.loadAll();
//     coll.lock();
// }

// function filtrarContentMacroObject(content,filter){
//     // pasamos ya el objeto por parámetro
//     content.unlock();
// 	content.setMacro("##MACRO##", filter);
//     content.clear();
//     content.loadAll();
//     content.lock();
// }

// function filtrarContentFilterObject(objself, contentsName,filtroContent) {
//     let cnt = objself.getContents(contentsName);
    
//     cnt.unlock();
//     cnt.setFilter(filtroContent);
//     cnt.clear();
//     cnt.loadAll();
//     cnt.lock();
// }

// function obtenerPrimerObjetoColl(coll,filtro) {
//     let collBuscar = appData.getCollection(coll);
//     filtrarCollMacroObject(collBuscar,filtro);
//     if(collBuscar.count() > 0) {
//         return collBuscar.getItem(0);
//     }
//     return null;
// }


// function actualizarDatosContent(objself, contentsName, refrescarPadre, segundaMacro) {
//     objself.MAP_BANDERA = 1;
//     var filter = '', filter2 = '';
//     var usersContent = objself.getContents(contentsName);
//     usersContent.unlock();
//     filter = getFilter(objself, contentsName);
//     usersContent.setMacro("##MACRO##", filter);

//     // para deudas del procesoLSO, una segunda macro
//     if (contentsName === 'ProcesoLSODeudaCliente') {
//         usersContent.setMacro("##IDCLIENTE_TITULAR##", objself.MAP_IDLEAD_TITULAR);
//         usersContent.setMacro("##IDCLIENTE_PAREJA##", objself.MAP_IDLEAD_PAREJA);
//     }
//     if (segundaMacro) {
//         filter2 = getFilter2(objself, contentsName);
//         usersContent.setMacro("##MACRO2##", filter2);
//     }
//     usersContent.clear();
//     let promise = usersContent.loadAll();
//     usersContent.lock();
//     if (refrescarPadre) {
//         ui.getView(objself).refresh(contentsName);
//     } else {
//         ui.refresh(contentsName);
//     }
//     objself.MAP_BANDERA = 0;
//     return promise;
// }

// function actualizarDatosPaginadoLeads(objself,contentsName,collContador,pag_ini,pag_len,totalRegistros,Proptitulo, refrescarPadre) {
//     objself.MAP_BANDERA=1;
//     var filter = '', filter2 = '';
//     var filterContador = '';
//     var page= {
//         "start": objself[pag_ini],
//         "length": objself[pag_len]
//     };

//     let usersContent = objself.getContents(contentsName);
//     usersContent.unlock();
//     filter = getFilter(objself,contentsName);
// 	usersContent.setMacro("##MACRO##", filter);
	
// 	// para casos con dos macros en la sql como DeudaCliente
//     // if(segundaMacro == 1){
//     //     filter2 = getFilter2(objself,contentsName);
//     // 	usersContent.setMacro("##MACRO2##", filter2);
//     // }

//     usersContent.clear();
//     usersContent.loadAll(false,page);
//     usersContent.lock();
    

//     var ctr=appData.getCollection(collContador);
//     filterContador = getFilter(objself,collContador);
//     ctr.setMacro("##MACRO##", filterContador);
//     ctr.loadAll();
//     objself[totalRegistros]=ctr.getItem(0).MAP_CONTADOR;
    
//     let valorde=0; 
//     let valorhasta=objself[pag_len];
//     if (valorhasta>objself[totalRegistros]) valorhasta=objself[totalRegistros];
//     objself.setFieldPropertyValue(Proptitulo,"title","Mostrando registros: De " + valorde + " a " + valorhasta + "/" + objself[totalRegistros]);
    
//     if(refrescarPadre) {
//         // si necesitamos refrescar el content en otra pantalla, obtenemos la vista. Ejemplo: Al volver de leadEdicion a LeadList
//         ui.getView(objself).refresh(contentsName);
//     } else {
//         ui.refresh(contentsName);
//     }
//     objself.MAP_BANDERA = 0;
    
// }


// function paginado(objself,tipo,contentsName,pag_ini,pag_len,totalRegistros,Proptitulo) {

//     var valorde,valorhasta;
//     valorde=0;
//     if (tipo=='ANT') {
//         if (objself[pag_ini]===0) {
//             ui.showToast("No hay mas registros");
//         } else {
//             objself[pag_ini]=objself[pag_ini] - objself[pag_len];
//             if (objself[pag_ini]<0) {
//                 objself[pag_ini]=0;  
//             } 
//             loaddata(objself,contentsName,1,objself[pag_ini],objself[pag_len]);
//         }
//     } else {
//         // Si el total de registros obtenidos es menos que el numero maximo,
//         //ya no hay mas registros. ver siempre el total registros que da la 
//         //consulta
//         if (objself.getContents(contentsName).getCount() < objself[pag_len]) {
//             ui.showToast("No hay más registros");
//         } else {
//             objself[pag_ini]=objself[pag_ini] + objself[pag_len];
//             if (objself[pag_ini]>objself[totalRegistros]) {
//                 objself[pag_ini]=objself[totalRegistros];  
//             }
//             loaddata(objself,contentsName,1,objself[pag_ini],objself[pag_len]);
//         }
//     }

//     valorhasta=objself[pag_ini] + objself[pag_len];
//     if (valorhasta>objself[totalRegistros]) {
//         valorde=valorhasta - objself[pag_len];
//         valorhasta=objself[totalRegistros];  
//     } else {
//         valorde=valorhasta - objself[pag_len];    
//     } 
//     if (valorde<0) {
//         valorde=0;  
//     } 
//     objself.setFieldPropertyValue(Proptitulo,"title","Mostrando registros: De " + valorde + " a " + valorhasta + "/" + objself[totalRegistros]);
// }

// // Cargar un content bloqueado
// function loaddata(obj,content,load,ini,fin){

//     if (load===0) {
//     } else {
//         ui.showToast("Cargando información...");
//     }
//     try {
//         let ct=obj.getContents(content);
//         ct.unlock();
//         ct.clear();
//         var page;
//         if (!isNothing(ini)) {
//             page= {
//                 "start": ini,
//                 "length": fin
//             };
//             ct.loadAll(false,page);
//         } else {
//             ct.loadAll();
//         }
//         ct.lock();

//         ui.getView(obj).refresh(content);

//     } catch(e) {
//         ui.showToast("Error de conexión...");
//     }
// }



// // Función para subir los documentos. Usamos una promesa y ui.sleep para que la detecte como asíncrona
// function sendOnlineFilesApiNEW(objself, apiName, file, parameters) {
//     ui.sleep(0);
//     // resolve marca ok y reject devuelve error. El callback se ejecuta fuera
//     return new Promise(function(resolve, reject) {
//         const formData = new FormData();
//         formData.append("file", file);
//         formData.append("correo_lead", parameters.correo_lead);
//         formData.append("idtipo", parameters.idtipo);
//         formData.append("usuario", parameters.usuario_subida);
//         formData.append("name", parameters.name);
//         formData.append("iddeuda", parameters.iddeuda);
//         formData.append("iddeudacliente", parameters.iddeudacliente);
//         formData.append("idactividadcliente", parameters.idactividadcliente);
//         formData.append("idsancioneshacienda", parameters.idsancioneshacienda);
//         formData.append("idventadonacionbien", parameters.idventadonacionbien);
//         formData.append("idherencia", parameters.idherencia);
//         formData.append("idotrosactivos", parameters.idotrosactivos);
//         formData.append("idinmuebles", parameters.idinmuebles);
//         formData.append("idvehiculos", parameters.idvehiculos);
//         formData.append("idfamiliares", parameters.idfamiliares);
//         formData.append("idposeesociedad", parameters.idposeesociedad);

//         const xhr = new XMLHttpRequest();
//         xhr.open("POST", dominioUrl + apiName);
//         xhr.setRequestHeader("Authorization", "Bearer " + user.MAP_TOKEN);

//         xhr.onload = function() {
//             if (xhr.status >= 200 && xhr.status < 300) {
//                 try {
//                     const data = JSON.parse(xhr.responseText);
                    
//                     // si hay error
//                     if (data.hasError) {
//                         reject(new Error(data.message || "Error en la respuesta del servidor"));
//                     } else {
//                         resolve(data);
//                     }
//                 } catch (e) {
//                     reject(new Error("Error al parsear la respuesta"));
//                 }
//             } else {
//                 reject(new Error("Error HTTP: " + xhr.status));
//             }
//         };

//         xhr.onerror = function() {
//             reject(new Error("Error de red"));
//         };

//         xhr.send(formData);
//     });
// }


// // subirArchivo genérico. Recibe un objeto con los parámetros directamente
// function subirArchivo(objself, opciones = {}) {
    
//     const file = objself.getOwnerCollection().getVariables("File");
//     if (!file) {
//         ui.msgBox("Debe adjuntar un archivo antes de subirlo", "Falta documento", 0);
//         return null;
//     }

//     // volcamos los parámetros que hayamos recibido
//     const parameters = {
//         correo_lead: opciones.correo_lead,
//         idtipo: opciones.tipoDoc,
//         usuario_subida: user.LOGIN,
//         name: opciones.fileName || file.name,
//         iddeuda: opciones.iddeuda || 0,
//         iddeudacliente: opciones.iddeudacliente || 0,
//         idactividadcliente: opciones.idactividadcliente || 0,
//         idsancioneshacienda: opciones.idsancioneshacienda || 0,
//         idventadonacionbien: opciones.idventadonacionbien || 0,
//         idherencia: opciones.idherencia || 0,
//         idotrosactivos: opciones.idotrosactivos || 0,
//         idinmuebles: opciones.idinmuebles || 0,
//         idvehiculos: opciones.idvehiculos || 0,
//         idfamiliares: opciones.idfamiliares || 0,
//         idposeesociedad: opciones.idposeesociedad || 0,
//     };

//     // Callbacks por defecto si no se pasan en las Opciones
//     const okcallback = opciones.onSuccess || function() {
//         ui.showToast("Documento subido correctamente");
//         limpiarDatosTrasSubida(objself);
//         actualizarDatosContent(objself, "Documentopersonal");
//     };
//     const errorCallback = opciones.onError || function() {
//         objself.MAP_ANEXO = "";
//     };


//     // sendOnlineFilesApi sólo subirá el documento. El callback se llama desde aquí
//     try {
//         const response = sendOnlineFilesApiNEW(
//             objself,
//             "/api/Pdf/UploadFile?user=" + user.LOGIN,
//             file,
//             parameters
//         );
//         return okcallback(response);
//     } catch (error) {
//         errorCallback(error);
//     }
// }


// // Función para subir los documentos. Usamos una promesa y ui.sleep para que la detecte como asíncrona
// function UploadFileLSO(objself, apiName, file, parameters) {
//     ui.sleep(0);
//     // resolve marca ok y reject devuelve error. El callback se ejecuta fuera
//     return new Promise(function(resolve, reject) {
//         const formData = new FormData();
//         formData.append("file", file);
//         formData.append("idproceso_lso", parameters.idproceso_lso);
//         formData.append("idtipo", parameters.idtipo);
//         formData.append("usuario_subida", parameters.usuario_subida);
//         formData.append("name", parameters.name);

//         const xhr = new XMLHttpRequest();
//         xhr.open("POST", dominioUrl + apiName);
//         xhr.setRequestHeader("Authorization", "Bearer " + user.MAP_TOKEN);

//         xhr.onload = function() {
//             if (xhr.status >= 200 && xhr.status < 300) {
//                 try {
//                     const data = JSON.parse(xhr.responseText);
                    
//                     // si hay error
//                     if (data.hasError) {
//                         reject(new Error(data.message || "Error en la respuesta del servidor"));
//                     } else {
//                         // devuelve ok y ejecutamos el callback en la función que llama a ésta
//                         resolve(data);
//                     }
//                 } catch (e) {
//                     reject(new Error("Error al parsear la respuesta"));
//                 }
//             } else {
//                 reject(new Error("Error HTTP: " + xhr.status));
//             }
//         };

//         xhr.onerror = function() {
//             reject(new Error("Error de red"));
//         };

//         xhr.send(formData);
//     });
// }


// // subirArchivo genérico para LSO. Recibe un objeto con los parámetros directamente
// function subirArchivoLSO(objself, opciones = {}) {
    
//     const file = objself.getOwnerCollection().getVariables("File");
//     if (!file) {
//         ui.msgBox("Debe adjuntar un archivo antes de subirlo", "Falta documento", 0);
//         return null;
//     }

//     // volcamos los parámetros que hayamos recibido
//     const parameters = {
//         idproceso_lso: opciones.idproceso_lso,
//         idtipo: opciones.tipoDoc,
//         usuario_subida: user.LOGIN,
//         name: opciones.fileName || file.name,
//     };

//     // Callbacks por defecto si no se pasan en las Opciones
//     const okcallback = opciones.onSuccess || function() {
//         ui.showToast("Documento subido correctamente");
//         limpiarDatosTrasSubida(objself);
//         actualizarDatosContent(objself, "Documentopersonal");
//     };
//     const errorCallback = opciones.onError || function() {
//         objself.MAP_ANEXO = "";
//     };


//     // UploadFileLSO sólo subirá el documento. El callback se llama desde aquí
//     try {
//         const response = UploadFileLSO(
//             objself,
//             "/api/Pdf/UploadFileLso?user=" + user.LOGIN,
//             file,
//             parameters
//         );
//         return okcallback(response);
//     } catch (error) {
//         console.log("Error inesperado al subir archivo:", error);
//         errorCallback(error);
//     }
// }

// function DescargarArchivoLSO(objself,fileName,idproceso,callBackSuccess,callBackError) {
//     let request = {
// 		parameters: {
// 		    connectTimeout: 120000,
// 		    readTimeout: 120000
// 		},
//         headers : {
//             "Authorization": "Bearer " + user.MAP_TOKEN,
//             processData: false, 
//             contentType: false, 
//             // "x-request-rowid-lead": rowid_lead
//         }
//     };
    
//     let fullURL = dominioUrl + "/api/Pdf/DownloadFileLso?idproceso="+idproceso+"&&file="+fileName;
//     $http.getFile(fullURL, request, 
//         function(response) {
//             callBackSuccess(response);
//         }, 
//         function(errorCode, errorMsg,msgampliado) {
//             ui.showToast(errorCode + ": " + errorMsg);
//         }
//     ); 
// }



// *********** Comentar hasta aquí








function ringOVer(metodo){
    switch(metodo) {
        case 'iniciar':
            generate();
            break;
        case 'destruir':
            destroy();
            break;
    }
}

function iniciarRingover(){
    generate();
    hide();
}
function cerrarRingover(){
    destroy();
}

function hideRingover(){
    hide();
    flotanteRingover=0;
}

function toggleRingover(){
    if(simpleSDK.toggle()==false){
        self.MAP_RINGOVER_FLOTANTE=1;
    }else{
        self.MAP_RINGOVER_FLOTANTE=0;
    }
    ui.refresh("MAP_BT_RINGOVER");
}

function llamarLead(numero,desdenumero){
    dial(numero,desdenumero);
}

function abrirWhatsapp(numero,desdenumero){
    whatsapp(numero,desdenumero);
}

function mandarSMS(numDestino,mensaje,numOrigen){
    sendSMS(numDestino,mensaje,numOrigen);
}

function abrirLogLLamada(idllamada){
    openCallLog(idllamada);
}

function VBScriptSupport() {
	this.cstr = function(value) {
		return safeToString(value);
	};
 
	this.now = function() {
		return new Date();
	};
 
	this.len = function(str) {
		return safeToString(str).length;
	};
 
	this.cint = function(value) {
		return parseInt(value);
	};
 
	this.left = function(str, n) {
		if (n <= 0) {
			return new String();
		} else if (n > String(str).length) {
			return safeToString(str);
		} else {
			return safeToString(str).substring(0, n);
		}
	};
 
	this.replace = function(source, search, replacement) {
		source = safeToString(source);
		search = safeToString(search);
		replacement = safeToString(replacement);
		search = escapeRegularExpression(search);
		source.replace(search, replacement);
		return source;
	};
 
	this.day = function(mDate) {
		mDate = safeToDate(mDate);
		return mDate.getDate();
	};
 
	this.month = function(mDate) {
		mDate = safeToDate(mDate);
		return mDate.getMonth();
	};
 
	this.year = function(mDate) {
		mDate = safeToDate(mDate);
		return mDate.getFullYear();
	};
 
	this.right = function(str, n) {
		str = new String(str);
		if (n <= 0 || n > str.length) {
			return str;
		} else {
			var iLen = str.length;
			return str.substring(iLen, iLen - n);
		}
	};
 
	this.mid = function(str, start, len) {
		if (start < 0 || len < 0) {
			return str;
		}
		var iEnd, iLen = new String(str).length;
		if (start + len > iLen) {
			iEnd = iLen;
		} else {
			iEnd = start + len;
		}
		return new String(str).substring(start, iEnd);
	};
 
	this.inStr = function(strSearch, charSearchFor) {
		for (i = 0; i < len(strSearch); i++) {
			if (charSearchFor == mid(strSearch, i, 1)) {
				return i;
			}
		}
		return -1;
	};
 
	this.lcase = function(str) {
		if (isString(str)) {
			return str.toLowerCase();
		}
		return new String(str).toLowerCase();
	};
 
	this.ucase = function(str) {
		if (isString(str)) {
			return str.toUpperCase();
		}
		return new String(str).toUpperCase();
	};
 
	this.abs = function(value) {
		return Math.abs(value);
	};
 
	this.trim = function(str) {
		str = safeToString(str);
		return str.trim();
	};
 
	this.split = function(str, delimiter) {
		return str.split(delimiter);
	};
 
	this.dateDiff = function(sPeriod, mDate1, mDate2) {
		mDate1 = safeToDate(mDate1);
		mDate2 = safeToDate(mDate2);
		nDiff = Math.abs(mDate1.getTime() - mDate2.getTime());
		switch(sPeriod) {
			case "h":
				return nDiff / 3600000;
			case "n":
				return nDiff / 60000;
			default:
				throw new Error("dateDiff(): Unknown date period " + sPeriod);
		}
	};
 
	this.dateAdd = function(sPeriod, nNumber, mDate) {
		mDate = safeToDate(mDate);
		switch(sPeriod) {
			case "yyyy":
				//Year
				mDate.setYear(mDate.getYear() + nNumber);
				return mDate;
			case "q":
				//Quarter
				return mDate;
			case "m":
				//Month
				mDate.setMonth(mDate.getMonth() + nNumber);
				return mDate;
			case "y":
				//Day of year
				return mDate;
			case "d":
				//Day
				mDate.setDate(mDate.getDate() + nNumber);
				return mDate;
			case "w":
				//Weekday
				return mDate;
			case "ww":
				//Week of year
				return mDate;
			case "h":
				//Hour
				mDate.setHours(mDate.getHours() + nNumber);
				return mDate;
			case "n":
				//Minute
				mDate.setMinutes(mDate.getMinutes() + nNumber);
				return mDate;
			case "s":
				//Second
				mDate.setSeconds(mDate.getSeconds() + nNumber);
				return mDate;
			default:
				throw new Error("dateAdd(): Unknown date period " + sPeriod);
		}
	};
}
 
var vbSupport = new VBScriptSupport();
 
function isNothing(obj) {
	if (obj === null) {
		return true;
	}
	if (obj == "undefined") {
		return true;
	}
	if (typeof obj === "undefined") {
		return true;
	}
	return false;
}
 
function isSomething(obj) {
	if (obj === null) {
		return false;
	}
	if (obj == "undefined") {
		return false;
	}
	return true;
}
 
function getClassName(obj) {
	if(isNothing(obj)) {
		return null;
	}
	return obj.constructor.name;
}
 
function isFloatNumber(n) {
	return n === +n && n !== (n | 0);
}
 
function isIntegerNumber(n) {
	return n === +n && n === (n | 0);
}
 
function isNumber(obj) {
	if (isNothing(obj)) {
		return false;
	}
	return !isNaN(parseFloat(obj)) && isFinite(obj);
}
 
function isString(obj) {
	return typeof obj === 'string' || obj instanceof String;
}

 
function isEmptyString(obj) {
	if(!isString(obj)) {
		return false;
	}
	return(!obj || 0 === obj.length);
}
 
function isDate(obj) {
	if (obj instanceof Date) {
		return true;
	}
	return false;
}

function safeToInt(value) {
	if(isNothing(value)) {
		return 0;
	}
	if(!isNumber(value)){
		return 0;
	}
	return Number(value);
}

function safeToFloat(value) {
	if(isNothing(value)) {
		return 0;
	}
	if(!isNumber(value)){
		return 0;
	}
	return parseFloat(value);
}

function safeToString(value) {
	if(isNothing(value)) {
		return new String();
	}
	return new String(value);
}
 
function safeToDate(mDate) {
	if(isDate(mDate)) {
		return mDate;
	}
	return new Date(replaceAll(safeToString(mDate), '-', '/'));
}
 
function escapeRegularExpression(str) {
    return str.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, "\\$1");
}
 
function replaceAll(sSource, sSearch, sReplacement) {
	sSearch = escapeRegularExpression(sSearch);
	return sSource.split(sSearch).join(sReplacement);
}

// ===== exports para MPA Island mode =====
export { filtrarActividadCliente, crearActividadClienteGuardar, crearActividadSolicitudBaja, crearActividadClienteDevolucionIntereses, guardarHistoricoDevolucionIntereses, asignarValoresPlazoIntereses, generarActualizacionDevolucionIntereses, crearActividadClienteCompensacionAcuerdoAcreedores, comprobarEtapaCompensacionAcuerdoAcreedores, solicitarDevolucionCompensacionAcuerdoAcreedores, solicitarCobroCECompensacionAcuerdoAcreedores, crearActividadClienteAccionJudicial, generarActualizacionAccionJudicial, cambiarEtapaAccionJudicial, comprobarEtapaAccionJudicial, accionJudicialHistoricoEstadoApudGuardar, accionJudicialHistoricoEstadoAccionGuardar, accionJudicialGuardar, crearActividadClienteMonitorio, generarIdentificadorActividadDemandaMonitorio, asignarValoresPlazoMonitorio, vincularOposicionMonitorio, agregarDocumentoActividadGuardar, solicitarDevolucion, solicitarComisionMensual, marcarBajaCliente, marcarPausaCliente, marcarReactivacionCliente, obtenerImporteDeudadAddendum, annadirDeudadAddendum, asignarIdDocumentoDeudaAddendum, comprobarDeudaAnnadidaAddendum, confirmarAddendum, eliminarAddendum, generarIdentificadorDevolucionIntereses, solicitarDevolucionIntereses, cambiarEstadoActividad, comprobarEtapaDevolucionIntereses, solicitarCobroCEDevolucionIntereses, hola, sumarDiasNaturales, esDiaLaborable, sumarDiasLaborables, diasLaborablesTranscurridos, ObtenerFechaHoraActual, ObtenerFechaActual, ObtenerFechaMesAnterior, obtenerFechaActualConcatenada, esAnteriorAHoy, sumarMeses, ObtenerFechaModificada, ObtenerHoraActual, fechaFormateada, diferenciaEnDias, diferenciaEnDiasDosFechas, calcularDiferenciaAnnios, esFechaMayor, mismoDia, isNullOrEmpty, onBack, cambiarColorProp, round, obtenerobjeto, obtenerPrimerobjetoCnt, verComprobanteDeuda, omitirCobroComision, guardarActualizacion, generarActualizacion, asignarIdDocumentoActualizacionDeuda, asignarIdDocumentoPlanPagoDeuda, crearPlanDePago, actualizarValoresDeuda, comprobarCambioEtapaDeuda, cambioProductoDeuda, volverEtapaDeuda, comprobarEstadoDeuda, comprobacionExisteDocumento, rechazarContratoManual, agregarDocumentoDeudaGuardar, liquidarDeuda, eliminarDeuda, ResetearDeuda, leerRespuesta, limpiarDatosTrasSubida, guardarSubtipoComprobante, recargarDocumentoDatosCliente, limpiarDatosCliente, limpiarDatosComprobantes, verDocumentoCliente, verDocumentoProcesoLSO, adjuntarArchivoDatosCliente, comprobanteClienteEdicionOk, acreditaResidenciaOk, adjuntarArchivoProcesoLSO, ObjMenuPadre, _objClienteEdicionChat, textoColor, camposMatriz, sendPush, tituloPestanyaNavegador, refrescarContent, refrescarContentMacro, refrescarContentPadre, filtrarCollObject, crearObjetoContent, onEditorAction, bloquearContentsBeforeEdit, goToColl, irColl, irColl2, logoutExpirado, logout, selectedItemPadre, selectedItemHijo, marcarMenuPadre, marcarPadreInicio, cargarChatMensajeria, prepararContextoChatMensajeria, cargarMensajesFicha, prepararMensajeriaUltimoScript, MostrarGrupoDispositivo, MostrarGrupoDispositivoNuevo, annadirOrigenLeadFiltro, getFilter, getFilter2, limpiarFiltro, limpiarCampos, copiarPortapapeles, asignarTextoColor, aplicarColor, comprobarColor, quitarTildes, calcularEdad, guardarMatrizSimple, guardarMatrizIntereses, guardarMatrizAumentada, obtenerPrimerElementoMatriz, filtrarLeadEdicionTipoUsuario, filtrarLeadEdicionTipoLead, crearLeadGuardar, crearRegistroHistorico, textoInformacionActividad, guardarHistoricoCambioEstado, guardarHistoricoCambioEstadoCliente, guardarEstadoClientePausa, guardarEstadoClienteReanudar, guardarHistoricoCambioAsesor, crearActividadGuardar, editarActividadGuardar, actualizarDeudaTotal, guardarDatosClienteGeneral, annadirFamiliar, adjuntarArchivoGastoMensual, annadirGastoMensual, annadirBienInmueble, annadirVehiculo, annadirEmbargoActivo, annadirOtroActivo, annadirSancion, annadirVentaBien, annadirHerencia, activarEdicionDatosCliente, activarEdicionDatosContrato, guardarDatosContrato, actualizarCorreoMailchimp, actualizarDatosUsuario, calcular, cargarDocumento, quitarDocumento, comprobarDocumento, comprobarDocumentoLSO, adjuntarDocumento, borrarDocAdjunto, agregarDocumentoGuardar, verDocumento, crearEquipoGuardar, comprobarExisteUsuarioLead, pasarLeadPropuesta, actualizarDatosZonaUsuario, comprobarCheckContrato, comprobarCheck1, comprobarCheck2, comprobarCheck3, comprobarCheck4, comprobarCheck5, agregarDocumentoGuardarPlan, guardarPlanLiquidacion, asignarIdDocumentoPlan, comprobarDatosDeudasGuardarSimulacion, PrintFrame, asignarPaquetePlanLiquidacion, generarNumeroContrato, GenerarPlantilla, calcularCuotaMensualRef, GenerarModificacionContrato, obtenerImagenDocumento, ircolldeuda, ircollcliente, calcularTotalesMovimientoMes, subirFotoUsuario, comprobarPagarTransferencia, rechazarDocumento, obtenerNombreDocumento, obtenerVersionDocumento, generarEnlaceFirma, comprobarEnvioSms, modificarSuscripcion, crearSuscripcionOk, eliminarSuscripcion, comprobarEtapaProcesoLSO, calcularDiasLaborablesProcesoLSO, guardarHistoricoCambioProcesoLSO, comprobarDocumentacionPrevia, recargarDireccionInmueble, verDocumentacionDatosCliente, generarIdentificadorGenerico, guardarNuevoProcesoLSO, cancelarNuevoProcesoLSO, colorBotonesProcesoLSOAfterEdit, cargarAsesoresClienteProcesoLSO, comprobarDocumentosDeudaCero, cargarDatosGeneralesClienteProcesoLSO, cargarDatosMemoriasClienteProcesoLSO, guardarMemoriasProcesoLSO, activarEdicionDatosClienteProcesoLSO, guardarDatosGeneralesProcesoLSO, cargarDeudasClienteProcesoLSO, cargarDocumentoProcesoLSO, refrescarTodasDocumentacionesPrevias, _objMensajeriaList, _agregarMensajeProgramado, _actualizandoListado, comprobarMensajesNuevos, buscarGridScrollable, scrollAlFondoConReintento, scrollChat, actualizarSeparadorFlotante, cargarMasMensajes, paginadoChat, refescarLineaContentMensaje, actualizarIconoEnContent, actualizarEstadoMensajeWA, comprobarEstadoPosteriorAlSent, convertirHora, limpiarHTML, limpiarHTMLMensajesEnContent, whatsappWebhook, obtenerIdLeadPorMovil, esMensajeDuplicado, procesarMensajeBot, actualizarListadoConMensaje, esWebhookServicioIgnorable, agregarMensajesNuevos, recibirMensajeEnChat, precargarMensajesBusqueda, toggleBuscadorMensajes, cerrarBuscadorMensajes, buscarMensajes, navegarBusqueda, actualizarContadorBusqueda, irACoincidencia, quitarResaltadosBusqueda, mostrarResultadosBusqueda, inyectarResultadosDOM, irAMensajeBusquedaAction, scrollAMensajeBusqueda, mensajeEnDom, scrollYResaltarMensaje, normalizarTexto, buscarGridScrollableFicha, cargarMasMensajesFicha, scrollChatFicha, precargarMensajesBusquedaFicha, toggleBuscadorMensajesFicha, cerrarBuscadorMensajesFicha, buscarMensajesFicha, navegarBusquedaFicha, actualizarContadorBusquedaFicha, irACoincidenciaFicha, mostrarResultadosBusquedaFicha, inyectarResultadosFichaDOM, irAMensajeBusquedaFichaAction, scrollAMensajeBusquedaFicha, _cargarRangoBusquedaFicha, navegarANotificacion, cargarDesplegableNotificaciones, marcarChatComoLeido, actualizarEstadoCampanaLigero, debeNotificarUsuario, adjuntarArchivo, borrarArchivoAdjunto, cargarMultimediaBytes, limpiarCajaMensajeRapido, enviarMensajeWhatsapp, enviarMensajeTexto, enviarMensajeMultimedia, OnMensajeOK, OnMensajeFail, descargarMultimediaChat, base64ToBlob, descargarArchivoMultimedia, abrirMultimedia, comprobarRectificativa, fraccionarCobro, solicitarCobro, solicitarPago, generarIdentificadorMovimiento, generarActualizacionConfirmarMovimiento, comprobarUltimaComision, comprobarProximaComision, calcularTotalComision, solicitarCobroLiquidada, generarFactura, obtenerSerieFactura, obtenerNumeroSerie, generarDetalleFactura, dominioUrl, actionTarget, actionTargetCalculator, actionTargetPDF, actionTargetStripe, actionTargetWhastsapp, actionTargetCore, DESARROLLO, apiKey, dominioUrlAgente, flowID, hostUrl, bgImage, dominioUrlResumen, flowIDResumen, connection, comprobarEntorno, filtrarCollMacroObject, filtrarContentMacroObject, filtrarContentFilterObject, obtenerPrimerObjetoColl, actualizarDatosContent, actualizarDatosPaginadoLeads, paginado, loaddata, _fechaSubidaDoc, _docFieldsFromParams, subirFicheroWebcore, sendOnlineFilesApiNEW, subirArchivo, UploadFileLSO, subirArchivoLSO, DescargarArchivoLSO, actualizarDatosContentSinRefresco, comprobarConexionWhatsapp, iniciarConexionChat, getApiUrl, formatUrl, callApiPost, callApiGet, descargarExcelOLD, descargarExcel, login, OnLoginOKApp, OnLoginFailApp, CalculadoraObtenerCuotas, comparar, ObtenerCuotaOK, ObtenerCuotaFail, CalculadoraObtenerCuotasAddendum, ObtenerCuotaAddendumOK, calculadoraPL, CalculadoraOK, CalculadoraFail, sendOnlineFilesApi, uploadFiles, crearUsuarioLead, borrarDocumento, downloadDocumentAsyncPDF, uploadUserFiles, DownloadUserFile, generarDocumentoPlantilla, generarAnexoPagoDiferido, enviarCorreoMailchimp, EnviarMensajeAivo, cambiarMedioPago, cambiarMedioPagoOk, parametrosPlantillaAvio, crearSuscripcion, borrarSuscripcion, borrarSuscripcionOk, borrarSuscripcionError, aportacionExtra, aportacionExtraOk, aportacionCuota, aportacionCuotaOk, pagarTransferencia, pagarTransferenciaProceso, comprobarPlazoAportaciones, transferenciaOk, transferenciaOkProceso, firmarDocumento, enviarSms, generarResumenSocioeconomico, resumenOk, resumenError, actualizarAcreditaResidenciaOk, simpleSDK, generate, destroy, show, hide, toggle, reload, logout1, dial, whatsapp, sendSMS, openCallLog, getPage, changePage, ringOVer, iniciarRingover, cerrarRingover, hideRingover, toggleRingover, llamarLead, abrirWhatsapp, mandarSMS, abrirLogLLamada, VBScriptSupport, vbSupport, isNothing, isSomething, getClassName, isFloatNumber, isIntegerNumber, isNumber, isString, isEmptyString, isDate, safeToInt, safeToFloat, safeToString, safeToDate, escapeRegularExpression, replaceAll };
